import { GraphQLClient, RequestOptions } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bpchar: { input: any; output: any; }
  case_request_status: { input: any; output: any; }
  case_request_type: { input: any; output: any; }
  date: { input: string; output: string; }
  float8: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: number; output: number; }
  timestamptz: { input: string; output: string; }
  trademark_filing_basis_type: { input: any; output: any; }
  use_in_commerce_request_class_decision_type: { input: any; output: any; }
  use_in_commerce_request_type: { input: any; output: any; }
  uuid: { input: string; output: string; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  entity: Array<Entity>;
  /** An aggregate relationship */
  entity_aggregate: Entity_Aggregate;
  id: Scalars['Int']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "address" */
export type AddressEntityArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


/** columns and relationships of "address" */
export type AddressEntity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};

/** aggregated selection of "address" */
export type Address_Aggregate = {
  __typename?: 'address_aggregate';
  aggregate?: Maybe<Address_Aggregate_Fields>;
  nodes: Array<Address>;
};

/** aggregate fields of "address" */
export type Address_Aggregate_Fields = {
  __typename?: 'address_aggregate_fields';
  avg?: Maybe<Address_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Address_Max_Fields>;
  min?: Maybe<Address_Min_Fields>;
  stddev?: Maybe<Address_Stddev_Fields>;
  stddev_pop?: Maybe<Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Address_Stddev_Samp_Fields>;
  sum?: Maybe<Address_Sum_Fields>;
  var_pop?: Maybe<Address_Var_Pop_Fields>;
  var_samp?: Maybe<Address_Var_Samp_Fields>;
  variance?: Maybe<Address_Variance_Fields>;
};


/** aggregate fields of "address" */
export type Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Address_Avg_Fields = {
  __typename?: 'address_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity?: InputMaybe<Entity_Bool_Exp>;
  entity_aggregate?: InputMaybe<Entity_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  entity?: InputMaybe<Entity_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Address_Max_Fields = {
  __typename?: 'address_max_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Address_Min_Fields = {
  __typename?: 'address_min_fields';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  entity_aggregate?: InputMaybe<Entity_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Address_Stddev_Fields = {
  __typename?: 'address_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Address_Stddev_Pop_Fields = {
  __typename?: 'address_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Address_Stddev_Samp_Fields = {
  __typename?: 'address_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Address_Sum_Fields = {
  __typename?: 'address_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Address_Var_Pop_Fields = {
  __typename?: 'address_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Address_Var_Samp_Fields = {
  __typename?: 'address_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Address_Variance_Fields = {
  __typename?: 'address_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Aggregate_Count = {
  __typename?: 'aggregate_count';
  count: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the logical model for "aggregate_count". All fields are combined with a logical 'AND'. */
export type Aggregate_Count_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Aggregate_Count_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Aggregate_Count_Bool_Exp_Bool_Exp>>;
  count?: InputMaybe<Int_Comparison_Exp>;
};

export enum Aggregate_Count_Enum_Name {
  /** column name */
  Count = 'count'
}

/** Ordering options when selecting data from "aggregate_count". */
export type Aggregate_Count_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** columns and relationships of "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis = {
  __typename?: 'ai_gs_items_analysis';
  analysis: Scalars['String']['output'];
  business_description: Scalars['String']['output'];
  class_items: Scalars['jsonb']['output'];
  class_number: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  jurisdiction: Scalars['String']['output'];
  registration_request_id: Scalars['uuid']['output'];
};


/** columns and relationships of "ai_gs_items_analysis" */
export type Ai_Gs_Items_AnalysisClass_ItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Aggregate = {
  __typename?: 'ai_gs_items_analysis_aggregate';
  aggregate?: Maybe<Ai_Gs_Items_Analysis_Aggregate_Fields>;
  nodes: Array<Ai_Gs_Items_Analysis>;
};

export type Ai_Gs_Items_Analysis_Aggregate_Bool_Exp = {
  count?: InputMaybe<Ai_Gs_Items_Analysis_Aggregate_Bool_Exp_Count>;
};

export type Ai_Gs_Items_Analysis_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Aggregate_Fields = {
  __typename?: 'ai_gs_items_analysis_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Ai_Gs_Items_Analysis_Max_Fields>;
  min?: Maybe<Ai_Gs_Items_Analysis_Min_Fields>;
};


/** aggregate fields of "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ai_Gs_Items_Analysis_Max_Order_By>;
  min?: InputMaybe<Ai_Gs_Items_Analysis_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Ai_Gs_Items_Analysis_Append_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Arr_Rel_Insert_Input = {
  data: Array<Ai_Gs_Items_Analysis_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ai_Gs_Items_Analysis_On_Conflict>;
};

/** Boolean expression to filter rows from the table "ai_gs_items_analysis". All fields are combined with a logical 'AND'. */
export type Ai_Gs_Items_Analysis_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Gs_Items_Analysis_Bool_Exp>>;
  _not?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Gs_Items_Analysis_Bool_Exp>>;
  analysis?: InputMaybe<String_Comparison_Exp>;
  business_description?: InputMaybe<String_Comparison_Exp>;
  class_items?: InputMaybe<Jsonb_Comparison_Exp>;
  class_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "ai_gs_items_analysis" */
export enum Ai_Gs_Items_Analysis_Constraint {
  /** unique or primary key constraint on columns "id" */
  AiGsItemsAnalysisPkey = 'ai_gs_items_analysis_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Ai_Gs_Items_Analysis_Delete_At_Path_Input = {
  class_items?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Ai_Gs_Items_Analysis_Delete_Elem_Input = {
  class_items?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Ai_Gs_Items_Analysis_Delete_Key_Input = {
  class_items?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Insert_Input = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  business_description?: InputMaybe<Scalars['String']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Ai_Gs_Items_Analysis_Max_Fields = {
  __typename?: 'ai_gs_items_analysis_max_fields';
  analysis?: Maybe<Scalars['String']['output']>;
  business_description?: Maybe<Scalars['String']['output']>;
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Max_Order_By = {
  analysis?: InputMaybe<Order_By>;
  business_description?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ai_Gs_Items_Analysis_Min_Fields = {
  __typename?: 'ai_gs_items_analysis_min_fields';
  analysis?: Maybe<Scalars['String']['output']>;
  business_description?: Maybe<Scalars['String']['output']>;
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Min_Order_By = {
  analysis?: InputMaybe<Order_By>;
  business_description?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Mutation_Response = {
  __typename?: 'ai_gs_items_analysis_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Ai_Gs_Items_Analysis>;
};

/** on_conflict condition type for table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_On_Conflict = {
  constraint: Ai_Gs_Items_Analysis_Constraint;
  update_columns?: Array<Ai_Gs_Items_Analysis_Update_Column>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};

/** Ordering options when selecting data from "ai_gs_items_analysis". */
export type Ai_Gs_Items_Analysis_Order_By = {
  analysis?: InputMaybe<Order_By>;
  business_description?: InputMaybe<Order_By>;
  class_items?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ai_gs_items_analysis */
export type Ai_Gs_Items_Analysis_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Ai_Gs_Items_Analysis_Prepend_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ai_gs_items_analysis" */
export enum Ai_Gs_Items_Analysis_Select_Column {
  /** column name */
  Analysis = 'analysis',
  /** column name */
  BusinessDescription = 'business_description',
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  RegistrationRequestId = 'registration_request_id'
}

/** input type for updating data in table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Set_Input = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  business_description?: InputMaybe<Scalars['String']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ai_gs_items_analysis" */
export type Ai_Gs_Items_Analysis_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Gs_Items_Analysis_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Gs_Items_Analysis_Stream_Cursor_Value_Input = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  business_description?: InputMaybe<Scalars['String']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ai_gs_items_analysis" */
export enum Ai_Gs_Items_Analysis_Update_Column {
  /** column name */
  Analysis = 'analysis',
  /** column name */
  BusinessDescription = 'business_description',
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  RegistrationRequestId = 'registration_request_id'
}

export type Ai_Gs_Items_Analysis_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Ai_Gs_Items_Analysis_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Ai_Gs_Items_Analysis_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Ai_Gs_Items_Analysis_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ai_Gs_Items_Analysis_Set_Input>;
  /** filter the rows which have to be updated */
  where: Ai_Gs_Items_Analysis_Bool_Exp;
};

/** Application form data */
export type Application = {
  __typename?: 'application';
  ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  ai_domicile_address_verdict?: Maybe<Scalars['String']['output']>;
  ai_extracted_data: Scalars['jsonb']['output'];
  ai_reasoning: Scalars['jsonb']['output'];
  /** An array relationship */
  application_jurisdictions: Array<Application_Jurisdiction>;
  /** An aggregate relationship */
  application_jurisdictions_aggregate: Application_Jurisdiction_Aggregate;
  client_approval: Scalars['Boolean']['output'];
  /** An array relationship */
  comments: Array<Thread_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Thread_Comment_Aggregate;
  document_types: Scalars['jsonb']['output'];
  document_types_modified: Scalars['Boolean']['output'];
  /** An object relationship */
  domicile_address?: Maybe<Address>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  domicile_address_visible: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mailing_address?: Maybe<Address>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  onboarding_finished: Scalars['Boolean']['output'];
  poa_metadata: Scalars['jsonb']['output'];
  priority_filing_date?: Maybe<Scalars['date']['output']>;
  priority_filing_jurisdiction?: Maybe<Scalars['String']['output']>;
  priority_filing_number?: Maybe<Scalars['String']['output']>;
  priority_filing_visible: Scalars['Boolean']['output'];
  /** An object relationship */
  registration_entity?: Maybe<Entity>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
};


/** Application form data */
export type ApplicationAi_Extracted_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Application form data */
export type ApplicationAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Application form data */
export type ApplicationApplication_JurisdictionsArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


/** Application form data */
export type ApplicationApplication_Jurisdictions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


/** Application form data */
export type ApplicationCommentsArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


/** Application form data */
export type ApplicationComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


/** Application form data */
export type ApplicationDocument_TypesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Application form data */
export type ApplicationPoa_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "application" */
export type Application_Aggregate = {
  __typename?: 'application_aggregate';
  aggregate?: Maybe<Application_Aggregate_Fields>;
  nodes: Array<Application>;
};

export type Application_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Application_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Application_Aggregate_Bool_Exp_Count>;
};

export type Application_Aggregate_Bool_Exp_Bool_And = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "application" */
export type Application_Aggregate_Fields = {
  __typename?: 'application_aggregate_fields';
  avg?: Maybe<Application_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Max_Fields>;
  min?: Maybe<Application_Min_Fields>;
  stddev?: Maybe<Application_Stddev_Fields>;
  stddev_pop?: Maybe<Application_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Application_Stddev_Samp_Fields>;
  sum?: Maybe<Application_Sum_Fields>;
  var_pop?: Maybe<Application_Var_Pop_Fields>;
  var_samp?: Maybe<Application_Var_Samp_Fields>;
  variance?: Maybe<Application_Variance_Fields>;
};


/** aggregate fields of "application" */
export type Application_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "application" */
export type Application_Aggregate_Order_By = {
  avg?: InputMaybe<Application_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Max_Order_By>;
  min?: InputMaybe<Application_Min_Order_By>;
  stddev?: InputMaybe<Application_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Application_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Application_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Application_Sum_Order_By>;
  var_pop?: InputMaybe<Application_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Application_Var_Samp_Order_By>;
  variance?: InputMaybe<Application_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Application_Append_Input = {
  ai_extracted_data?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  document_types?: InputMaybe<Scalars['jsonb']['input']>;
  poa_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "application" */
export type Application_Arr_Rel_Insert_Input = {
  data: Array<Application_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** aggregate avg on columns */
export type Application_Avg_Fields = {
  __typename?: 'application_avg_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "application" */
export type Application_Avg_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "application". All fields are combined with a logical 'AND'. */
export type Application_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Bool_Exp>>;
  _not?: InputMaybe<Application_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Bool_Exp>>;
  ai_analysis_task_id?: InputMaybe<String_Comparison_Exp>;
  ai_domicile_address_verdict?: InputMaybe<String_Comparison_Exp>;
  ai_extracted_data?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  application_jurisdictions?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  application_jurisdictions_aggregate?: InputMaybe<Application_Jurisdiction_Aggregate_Bool_Exp>;
  client_approval?: InputMaybe<Boolean_Comparison_Exp>;
  comments?: InputMaybe<Thread_Comment_Bool_Exp>;
  comments_aggregate?: InputMaybe<Thread_Comment_Aggregate_Bool_Exp>;
  document_types?: InputMaybe<Jsonb_Comparison_Exp>;
  document_types_modified?: InputMaybe<Boolean_Comparison_Exp>;
  domicile_address?: InputMaybe<Address_Bool_Exp>;
  domicile_address_id?: InputMaybe<Int_Comparison_Exp>;
  domicile_address_visible?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mailing_address?: InputMaybe<Address_Bool_Exp>;
  mailing_address_id?: InputMaybe<Int_Comparison_Exp>;
  onboarding_finished?: InputMaybe<Boolean_Comparison_Exp>;
  poa_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  priority_filing_date?: InputMaybe<Date_Comparison_Exp>;
  priority_filing_jurisdiction?: InputMaybe<String_Comparison_Exp>;
  priority_filing_number?: InputMaybe<String_Comparison_Exp>;
  priority_filing_visible?: InputMaybe<Boolean_Comparison_Exp>;
  registration_entity?: InputMaybe<Entity_Bool_Exp>;
  registration_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "application" */
export enum Application_Constraint {
  /** unique or primary key constraint on columns "id" */
  ApplicationPkey = 'application_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Application_Delete_At_Path_Input = {
  ai_extracted_data?: InputMaybe<Array<Scalars['String']['input']>>;
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
  document_types?: InputMaybe<Array<Scalars['String']['input']>>;
  poa_metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Application_Delete_Elem_Input = {
  ai_extracted_data?: InputMaybe<Scalars['Int']['input']>;
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
  document_types?: InputMaybe<Scalars['Int']['input']>;
  poa_metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Application_Delete_Key_Input = {
  ai_extracted_data?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
  document_types?: InputMaybe<Scalars['String']['input']>;
  poa_metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "application" */
export type Application_Inc_Input = {
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "application" */
export type Application_Insert_Input = {
  ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  ai_domicile_address_verdict?: InputMaybe<Scalars['String']['input']>;
  ai_extracted_data?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  application_jurisdictions?: InputMaybe<Application_Jurisdiction_Arr_Rel_Insert_Input>;
  client_approval?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Thread_Comment_Arr_Rel_Insert_Input>;
  document_types?: InputMaybe<Scalars['jsonb']['input']>;
  document_types_modified?: InputMaybe<Scalars['Boolean']['input']>;
  domicile_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  domicile_address_visible?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mailing_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  poa_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  priority_filing_date?: InputMaybe<Scalars['date']['input']>;
  priority_filing_jurisdiction?: InputMaybe<Scalars['String']['input']>;
  priority_filing_number?: InputMaybe<Scalars['String']['input']>;
  priority_filing_visible?: InputMaybe<Scalars['Boolean']['input']>;
  registration_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "application_jurisdiction" */
export type Application_Jurisdiction = {
  __typename?: 'application_jurisdiction';
  additional_info?: Maybe<Scalars['jsonb']['output']>;
  ai_additional_info: Scalars['jsonb']['output'];
  ai_color_claim?: Maybe<Scalars['String']['output']>;
  ai_logo_type?: Maybe<Scalars['String']['output']>;
  ai_reasoning: Scalars['jsonb']['output'];
  ai_text_in_trademark?: Maybe<Scalars['String']['output']>;
  ai_uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
  application_id: Scalars['uuid']['output'];
  color_claim?: Maybe<Scalars['String']['output']>;
  color_claim_enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  document_folder?: Maybe<Document_Folder>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  goods_and_services?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  jurisdiction: Scalars['String']['output'];
  logo_type?: Maybe<Scalars['String']['output']>;
  text_in_trademark?: Maybe<Scalars['String']['output']>;
  uspto_filing_basis?: Maybe<Scalars['jsonb']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
  uspto_specimen_to_class?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionAdditional_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionAi_Additional_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionGoods_And_ServicesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionUspto_Filing_BasisArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "application_jurisdiction" */
export type Application_JurisdictionUspto_Specimen_To_ClassArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "application_jurisdiction" */
export type Application_Jurisdiction_Aggregate = {
  __typename?: 'application_jurisdiction_aggregate';
  aggregate?: Maybe<Application_Jurisdiction_Aggregate_Fields>;
  nodes: Array<Application_Jurisdiction>;
};

export type Application_Jurisdiction_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Application_Jurisdiction_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Application_Jurisdiction_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Application_Jurisdiction_Aggregate_Bool_Exp_Count>;
};

export type Application_Jurisdiction_Aggregate_Bool_Exp_Bool_And = {
  arguments: Application_Jurisdiction_Select_Column_Application_Jurisdiction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Jurisdiction_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Application_Jurisdiction_Select_Column_Application_Jurisdiction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Application_Jurisdiction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "application_jurisdiction" */
export type Application_Jurisdiction_Aggregate_Fields = {
  __typename?: 'application_jurisdiction_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Application_Jurisdiction_Max_Fields>;
  min?: Maybe<Application_Jurisdiction_Min_Fields>;
};


/** aggregate fields of "application_jurisdiction" */
export type Application_Jurisdiction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "application_jurisdiction" */
export type Application_Jurisdiction_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Application_Jurisdiction_Max_Order_By>;
  min?: InputMaybe<Application_Jurisdiction_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Application_Jurisdiction_Append_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "application_jurisdiction" */
export type Application_Jurisdiction_Arr_Rel_Insert_Input = {
  data: Array<Application_Jurisdiction_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_Jurisdiction_On_Conflict>;
};

/** Boolean expression to filter rows from the table "application_jurisdiction". All fields are combined with a logical 'AND'. */
export type Application_Jurisdiction_Bool_Exp = {
  _and?: InputMaybe<Array<Application_Jurisdiction_Bool_Exp>>;
  _not?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  _or?: InputMaybe<Array<Application_Jurisdiction_Bool_Exp>>;
  additional_info?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_additional_info?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_color_claim?: InputMaybe<String_Comparison_Exp>;
  ai_logo_type?: InputMaybe<String_Comparison_Exp>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_text_in_trademark?: InputMaybe<String_Comparison_Exp>;
  ai_uspto_logo_subcategory?: InputMaybe<String_Comparison_Exp>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  color_claim?: InputMaybe<String_Comparison_Exp>;
  color_claim_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  document_folder?: InputMaybe<Document_Folder_Bool_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_and_services?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  logo_type?: InputMaybe<String_Comparison_Exp>;
  text_in_trademark?: InputMaybe<String_Comparison_Exp>;
  uspto_filing_basis?: InputMaybe<Jsonb_Comparison_Exp>;
  uspto_logo_subcategory?: InputMaybe<String_Comparison_Exp>;
  uspto_specimen_to_class?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "application_jurisdiction" */
export enum Application_Jurisdiction_Constraint {
  /** unique or primary key constraint on columns "application_id", "jurisdiction" */
  ApplicationJurisdictionApplicationIdJurisdictionKey = 'application_jurisdiction_application_id_jurisdiction_key',
  /** unique or primary key constraint on columns "id" */
  ApplicationJurisdictionPkey = 'application_jurisdiction_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Application_Jurisdiction_Delete_At_Path_Input = {
  additional_info?: InputMaybe<Array<Scalars['String']['input']>>;
  ai_additional_info?: InputMaybe<Array<Scalars['String']['input']>>;
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
  goods_and_services?: InputMaybe<Array<Scalars['String']['input']>>;
  uspto_filing_basis?: InputMaybe<Array<Scalars['String']['input']>>;
  uspto_specimen_to_class?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Application_Jurisdiction_Delete_Elem_Input = {
  additional_info?: InputMaybe<Scalars['Int']['input']>;
  ai_additional_info?: InputMaybe<Scalars['Int']['input']>;
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
  goods_and_services?: InputMaybe<Scalars['Int']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['Int']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Application_Jurisdiction_Delete_Key_Input = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  ai_additional_info?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
  goods_and_services?: InputMaybe<Scalars['String']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['String']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "application_jurisdiction" */
export type Application_Jurisdiction_Insert_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_color_claim?: InputMaybe<Scalars['String']['input']>;
  ai_logo_type?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  ai_uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  color_claim_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  document_folder?: InputMaybe<Document_Folder_Obj_Rel_Insert_Input>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Application_Jurisdiction_Max_Fields = {
  __typename?: 'application_jurisdiction_max_fields';
  ai_color_claim?: Maybe<Scalars['String']['output']>;
  ai_logo_type?: Maybe<Scalars['String']['output']>;
  ai_text_in_trademark?: Maybe<Scalars['String']['output']>;
  ai_uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  color_claim?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  logo_type?: Maybe<Scalars['String']['output']>;
  text_in_trademark?: Maybe<Scalars['String']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "application_jurisdiction" */
export type Application_Jurisdiction_Max_Order_By = {
  ai_color_claim?: InputMaybe<Order_By>;
  ai_logo_type?: InputMaybe<Order_By>;
  ai_text_in_trademark?: InputMaybe<Order_By>;
  ai_uspto_logo_subcategory?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  text_in_trademark?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Jurisdiction_Min_Fields = {
  __typename?: 'application_jurisdiction_min_fields';
  ai_color_claim?: Maybe<Scalars['String']['output']>;
  ai_logo_type?: Maybe<Scalars['String']['output']>;
  ai_text_in_trademark?: Maybe<Scalars['String']['output']>;
  ai_uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  color_claim?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  logo_type?: Maybe<Scalars['String']['output']>;
  text_in_trademark?: Maybe<Scalars['String']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "application_jurisdiction" */
export type Application_Jurisdiction_Min_Order_By = {
  ai_color_claim?: InputMaybe<Order_By>;
  ai_logo_type?: InputMaybe<Order_By>;
  ai_text_in_trademark?: InputMaybe<Order_By>;
  ai_uspto_logo_subcategory?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  text_in_trademark?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "application_jurisdiction" */
export type Application_Jurisdiction_Mutation_Response = {
  __typename?: 'application_jurisdiction_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application_Jurisdiction>;
};

/** on_conflict condition type for table "application_jurisdiction" */
export type Application_Jurisdiction_On_Conflict = {
  constraint: Application_Jurisdiction_Constraint;
  update_columns?: Array<Application_Jurisdiction_Update_Column>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};

/** Ordering options when selecting data from "application_jurisdiction". */
export type Application_Jurisdiction_Order_By = {
  additional_info?: InputMaybe<Order_By>;
  ai_additional_info?: InputMaybe<Order_By>;
  ai_color_claim?: InputMaybe<Order_By>;
  ai_logo_type?: InputMaybe<Order_By>;
  ai_reasoning?: InputMaybe<Order_By>;
  ai_text_in_trademark?: InputMaybe<Order_By>;
  ai_uspto_logo_subcategory?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  color_claim_enabled?: InputMaybe<Order_By>;
  document_folder?: InputMaybe<Document_Folder_Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  goods_and_services?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  text_in_trademark?: InputMaybe<Order_By>;
  uspto_filing_basis?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
  uspto_specimen_to_class?: InputMaybe<Order_By>;
};

/** primary key columns input for table: application_jurisdiction */
export type Application_Jurisdiction_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Application_Jurisdiction_Prepend_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "application_jurisdiction" */
export enum Application_Jurisdiction_Select_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  AiAdditionalInfo = 'ai_additional_info',
  /** column name */
  AiColorClaim = 'ai_color_claim',
  /** column name */
  AiLogoType = 'ai_logo_type',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiTextInTrademark = 'ai_text_in_trademark',
  /** column name */
  AiUsptoLogoSubcategory = 'ai_uspto_logo_subcategory',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  ColorClaim = 'color_claim',
  /** column name */
  ColorClaimEnabled = 'color_claim_enabled',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  GoodsAndServices = 'goods_and_services',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LogoType = 'logo_type',
  /** column name */
  TextInTrademark = 'text_in_trademark',
  /** column name */
  UsptoFilingBasis = 'uspto_filing_basis',
  /** column name */
  UsptoLogoSubcategory = 'uspto_logo_subcategory',
  /** column name */
  UsptoSpecimenToClass = 'uspto_specimen_to_class'
}

/** select "application_jurisdiction_aggregate_bool_exp_bool_and_arguments_columns" columns of table "application_jurisdiction" */
export enum Application_Jurisdiction_Select_Column_Application_Jurisdiction_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ColorClaimEnabled = 'color_claim_enabled'
}

/** select "application_jurisdiction_aggregate_bool_exp_bool_or_arguments_columns" columns of table "application_jurisdiction" */
export enum Application_Jurisdiction_Select_Column_Application_Jurisdiction_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ColorClaimEnabled = 'color_claim_enabled'
}

/** input type for updating data in table "application_jurisdiction" */
export type Application_Jurisdiction_Set_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_color_claim?: InputMaybe<Scalars['String']['input']>;
  ai_logo_type?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  ai_uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  color_claim_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "application_jurisdiction" */
export type Application_Jurisdiction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Jurisdiction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Jurisdiction_Stream_Cursor_Value_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  ai_color_claim?: InputMaybe<Scalars['String']['input']>;
  ai_logo_type?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  ai_uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  color_claim_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  text_in_trademark?: InputMaybe<Scalars['String']['input']>;
  uspto_filing_basis?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
  uspto_specimen_to_class?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "application_jurisdiction" */
export enum Application_Jurisdiction_Update_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  AiAdditionalInfo = 'ai_additional_info',
  /** column name */
  AiColorClaim = 'ai_color_claim',
  /** column name */
  AiLogoType = 'ai_logo_type',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiTextInTrademark = 'ai_text_in_trademark',
  /** column name */
  AiUsptoLogoSubcategory = 'ai_uspto_logo_subcategory',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  ColorClaim = 'color_claim',
  /** column name */
  ColorClaimEnabled = 'color_claim_enabled',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  GoodsAndServices = 'goods_and_services',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LogoType = 'logo_type',
  /** column name */
  TextInTrademark = 'text_in_trademark',
  /** column name */
  UsptoFilingBasis = 'uspto_filing_basis',
  /** column name */
  UsptoLogoSubcategory = 'uspto_logo_subcategory',
  /** column name */
  UsptoSpecimenToClass = 'uspto_specimen_to_class'
}

export type Application_Jurisdiction_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Application_Jurisdiction_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Application_Jurisdiction_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Application_Jurisdiction_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Application_Jurisdiction_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Application_Jurisdiction_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Jurisdiction_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Jurisdiction_Bool_Exp;
};

/** aggregate max on columns */
export type Application_Max_Fields = {
  __typename?: 'application_max_fields';
  ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  ai_domicile_address_verdict?: Maybe<Scalars['String']['output']>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  priority_filing_date?: Maybe<Scalars['date']['output']>;
  priority_filing_jurisdiction?: Maybe<Scalars['String']['output']>;
  priority_filing_number?: Maybe<Scalars['String']['output']>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "application" */
export type Application_Max_Order_By = {
  ai_analysis_task_id?: InputMaybe<Order_By>;
  ai_domicile_address_verdict?: InputMaybe<Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  priority_filing_date?: InputMaybe<Order_By>;
  priority_filing_jurisdiction?: InputMaybe<Order_By>;
  priority_filing_number?: InputMaybe<Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Application_Min_Fields = {
  __typename?: 'application_min_fields';
  ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  ai_domicile_address_verdict?: Maybe<Scalars['String']['output']>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  priority_filing_date?: Maybe<Scalars['date']['output']>;
  priority_filing_jurisdiction?: Maybe<Scalars['String']['output']>;
  priority_filing_number?: Maybe<Scalars['String']['output']>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "application" */
export type Application_Min_Order_By = {
  ai_analysis_task_id?: InputMaybe<Order_By>;
  ai_domicile_address_verdict?: InputMaybe<Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  priority_filing_date?: InputMaybe<Order_By>;
  priority_filing_jurisdiction?: InputMaybe<Order_By>;
  priority_filing_number?: InputMaybe<Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "application" */
export type Application_Mutation_Response = {
  __typename?: 'application_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Application>;
};

/** input type for inserting object relation for remote table "application" */
export type Application_Obj_Rel_Insert_Input = {
  data: Application_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Application_On_Conflict>;
};

/** on_conflict condition type for table "application" */
export type Application_On_Conflict = {
  constraint: Application_Constraint;
  update_columns?: Array<Application_Update_Column>;
  where?: InputMaybe<Application_Bool_Exp>;
};

/** Ordering options when selecting data from "application". */
export type Application_Order_By = {
  ai_analysis_task_id?: InputMaybe<Order_By>;
  ai_domicile_address_verdict?: InputMaybe<Order_By>;
  ai_extracted_data?: InputMaybe<Order_By>;
  ai_reasoning?: InputMaybe<Order_By>;
  application_jurisdictions_aggregate?: InputMaybe<Application_Jurisdiction_Aggregate_Order_By>;
  client_approval?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Thread_Comment_Aggregate_Order_By>;
  document_types?: InputMaybe<Order_By>;
  document_types_modified?: InputMaybe<Order_By>;
  domicile_address?: InputMaybe<Address_Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  domicile_address_visible?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailing_address?: InputMaybe<Address_Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  onboarding_finished?: InputMaybe<Order_By>;
  poa_metadata?: InputMaybe<Order_By>;
  priority_filing_date?: InputMaybe<Order_By>;
  priority_filing_jurisdiction?: InputMaybe<Order_By>;
  priority_filing_number?: InputMaybe<Order_By>;
  priority_filing_visible?: InputMaybe<Order_By>;
  registration_entity?: InputMaybe<Entity_Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
};

/** primary key columns input for table: application */
export type Application_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Application_Prepend_Input = {
  ai_extracted_data?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  document_types?: InputMaybe<Scalars['jsonb']['input']>;
  poa_metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "application" */
export enum Application_Select_Column {
  /** column name */
  AiAnalysisTaskId = 'ai_analysis_task_id',
  /** column name */
  AiDomicileAddressVerdict = 'ai_domicile_address_verdict',
  /** column name */
  AiExtractedData = 'ai_extracted_data',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientApproval = 'client_approval',
  /** column name */
  DocumentTypes = 'document_types',
  /** column name */
  DocumentTypesModified = 'document_types_modified',
  /** column name */
  DomicileAddressId = 'domicile_address_id',
  /** column name */
  DomicileAddressVisible = 'domicile_address_visible',
  /** column name */
  Id = 'id',
  /** column name */
  MailingAddressId = 'mailing_address_id',
  /** column name */
  OnboardingFinished = 'onboarding_finished',
  /** column name */
  PoaMetadata = 'poa_metadata',
  /** column name */
  PriorityFilingDate = 'priority_filing_date',
  /** column name */
  PriorityFilingJurisdiction = 'priority_filing_jurisdiction',
  /** column name */
  PriorityFilingNumber = 'priority_filing_number',
  /** column name */
  PriorityFilingVisible = 'priority_filing_visible',
  /** column name */
  RegistrationEntityId = 'registration_entity_id'
}

/** select "application_aggregate_bool_exp_bool_and_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ClientApproval = 'client_approval',
  /** column name */
  DocumentTypesModified = 'document_types_modified',
  /** column name */
  DomicileAddressVisible = 'domicile_address_visible',
  /** column name */
  OnboardingFinished = 'onboarding_finished',
  /** column name */
  PriorityFilingVisible = 'priority_filing_visible'
}

/** select "application_aggregate_bool_exp_bool_or_arguments_columns" columns of table "application" */
export enum Application_Select_Column_Application_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ClientApproval = 'client_approval',
  /** column name */
  DocumentTypesModified = 'document_types_modified',
  /** column name */
  DomicileAddressVisible = 'domicile_address_visible',
  /** column name */
  OnboardingFinished = 'onboarding_finished',
  /** column name */
  PriorityFilingVisible = 'priority_filing_visible'
}

/** input type for updating data in table "application" */
export type Application_Set_Input = {
  ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  ai_domicile_address_verdict?: InputMaybe<Scalars['String']['input']>;
  ai_extracted_data?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_approval?: InputMaybe<Scalars['Boolean']['input']>;
  document_types?: InputMaybe<Scalars['jsonb']['input']>;
  document_types_modified?: InputMaybe<Scalars['Boolean']['input']>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  domicile_address_visible?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  poa_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  priority_filing_date?: InputMaybe<Scalars['date']['input']>;
  priority_filing_jurisdiction?: InputMaybe<Scalars['String']['input']>;
  priority_filing_number?: InputMaybe<Scalars['String']['input']>;
  priority_filing_visible?: InputMaybe<Scalars['Boolean']['input']>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Application_Stddev_Fields = {
  __typename?: 'application_stddev_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "application" */
export type Application_Stddev_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Application_Stddev_Pop_Fields = {
  __typename?: 'application_stddev_pop_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "application" */
export type Application_Stddev_Pop_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Application_Stddev_Samp_Fields = {
  __typename?: 'application_stddev_samp_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "application" */
export type Application_Stddev_Samp_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "application" */
export type Application_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Application_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Application_Stream_Cursor_Value_Input = {
  ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  ai_domicile_address_verdict?: InputMaybe<Scalars['String']['input']>;
  ai_extracted_data?: InputMaybe<Scalars['jsonb']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_approval?: InputMaybe<Scalars['Boolean']['input']>;
  document_types?: InputMaybe<Scalars['jsonb']['input']>;
  document_types_modified?: InputMaybe<Scalars['Boolean']['input']>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  domicile_address_visible?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  poa_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  priority_filing_date?: InputMaybe<Scalars['date']['input']>;
  priority_filing_jurisdiction?: InputMaybe<Scalars['String']['input']>;
  priority_filing_number?: InputMaybe<Scalars['String']['input']>;
  priority_filing_visible?: InputMaybe<Scalars['Boolean']['input']>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Application_Sum_Fields = {
  __typename?: 'application_sum_fields';
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "application" */
export type Application_Sum_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** update columns of table "application" */
export enum Application_Update_Column {
  /** column name */
  AiAnalysisTaskId = 'ai_analysis_task_id',
  /** column name */
  AiDomicileAddressVerdict = 'ai_domicile_address_verdict',
  /** column name */
  AiExtractedData = 'ai_extracted_data',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientApproval = 'client_approval',
  /** column name */
  DocumentTypes = 'document_types',
  /** column name */
  DocumentTypesModified = 'document_types_modified',
  /** column name */
  DomicileAddressId = 'domicile_address_id',
  /** column name */
  DomicileAddressVisible = 'domicile_address_visible',
  /** column name */
  Id = 'id',
  /** column name */
  MailingAddressId = 'mailing_address_id',
  /** column name */
  OnboardingFinished = 'onboarding_finished',
  /** column name */
  PoaMetadata = 'poa_metadata',
  /** column name */
  PriorityFilingDate = 'priority_filing_date',
  /** column name */
  PriorityFilingJurisdiction = 'priority_filing_jurisdiction',
  /** column name */
  PriorityFilingNumber = 'priority_filing_number',
  /** column name */
  PriorityFilingVisible = 'priority_filing_visible',
  /** column name */
  RegistrationEntityId = 'registration_entity_id'
}

export type Application_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Application_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Application_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Application_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Application_Set_Input>;
  /** filter the rows which have to be updated */
  where: Application_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Application_Var_Pop_Fields = {
  __typename?: 'application_var_pop_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "application" */
export type Application_Var_Pop_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Application_Var_Samp_Fields = {
  __typename?: 'application_var_samp_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "application" */
export type Application_Var_Samp_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Application_Variance_Fields = {
  __typename?: 'application_variance_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "application" */
export type Application_Variance_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "audit_log" */
export type Audit_Log = {
  __typename?: 'audit_log';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  new_values?: Maybe<Scalars['jsonb']['output']>;
  old_values?: Maybe<Scalars['jsonb']['output']>;
  operation: Scalars['String']['output'];
  record_id_int?: Maybe<Scalars['Int']['output']>;
  record_id_uuid?: Maybe<Scalars['uuid']['output']>;
  table_name: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "audit_log" */
export type Audit_LogNew_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "audit_log" */
export type Audit_LogOld_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "audit_log" */
export type Audit_Log_Aggregate = {
  __typename?: 'audit_log_aggregate';
  aggregate?: Maybe<Audit_Log_Aggregate_Fields>;
  nodes: Array<Audit_Log>;
};

/** aggregate fields of "audit_log" */
export type Audit_Log_Aggregate_Fields = {
  __typename?: 'audit_log_aggregate_fields';
  avg?: Maybe<Audit_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Audit_Log_Max_Fields>;
  min?: Maybe<Audit_Log_Min_Fields>;
  stddev?: Maybe<Audit_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Audit_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Audit_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Audit_Log_Sum_Fields>;
  var_pop?: Maybe<Audit_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Audit_Log_Var_Samp_Fields>;
  variance?: Maybe<Audit_Log_Variance_Fields>;
};


/** aggregate fields of "audit_log" */
export type Audit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Audit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Audit_Log_Append_Input = {
  new_values?: InputMaybe<Scalars['jsonb']['input']>;
  old_values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Audit_Log_Avg_Fields = {
  __typename?: 'audit_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "audit_log". All fields are combined with a logical 'AND'. */
export type Audit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Audit_Log_Bool_Exp>>;
  _not?: InputMaybe<Audit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Audit_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  new_values?: InputMaybe<Jsonb_Comparison_Exp>;
  old_values?: InputMaybe<Jsonb_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  record_id_int?: InputMaybe<Int_Comparison_Exp>;
  record_id_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Audit_Log_Delete_At_Path_Input = {
  new_values?: InputMaybe<Array<Scalars['String']['input']>>;
  old_values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Audit_Log_Delete_Elem_Input = {
  new_values?: InputMaybe<Scalars['Int']['input']>;
  old_values?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Audit_Log_Delete_Key_Input = {
  new_values?: InputMaybe<Scalars['String']['input']>;
  old_values?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "audit_log" */
export type Audit_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  record_id_int?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "audit_log" */
export type Audit_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_values?: InputMaybe<Scalars['jsonb']['input']>;
  old_values?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  record_id_int?: InputMaybe<Scalars['Int']['input']>;
  record_id_uuid?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Audit_Log_Max_Fields = {
  __typename?: 'audit_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  record_id_int?: Maybe<Scalars['Int']['output']>;
  record_id_uuid?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Audit_Log_Min_Fields = {
  __typename?: 'audit_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  record_id_int?: Maybe<Scalars['Int']['output']>;
  record_id_uuid?: Maybe<Scalars['uuid']['output']>;
  table_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "audit_log" */
export type Audit_Log_Mutation_Response = {
  __typename?: 'audit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Audit_Log>;
};

/** Ordering options when selecting data from "audit_log". */
export type Audit_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_values?: InputMaybe<Order_By>;
  old_values?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  record_id_int?: InputMaybe<Order_By>;
  record_id_uuid?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Audit_Log_Prepend_Input = {
  new_values?: InputMaybe<Scalars['jsonb']['input']>;
  old_values?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "audit_log" */
export enum Audit_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewValues = 'new_values',
  /** column name */
  OldValues = 'old_values',
  /** column name */
  Operation = 'operation',
  /** column name */
  RecordIdInt = 'record_id_int',
  /** column name */
  RecordIdUuid = 'record_id_uuid',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "audit_log" */
export type Audit_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_values?: InputMaybe<Scalars['jsonb']['input']>;
  old_values?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  record_id_int?: InputMaybe<Scalars['Int']['input']>;
  record_id_uuid?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Audit_Log_Stddev_Fields = {
  __typename?: 'audit_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Audit_Log_Stddev_Pop_Fields = {
  __typename?: 'audit_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Audit_Log_Stddev_Samp_Fields = {
  __typename?: 'audit_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "audit_log" */
export type Audit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Audit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Audit_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  new_values?: InputMaybe<Scalars['jsonb']['input']>;
  old_values?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  record_id_int?: InputMaybe<Scalars['Int']['input']>;
  record_id_uuid?: InputMaybe<Scalars['uuid']['input']>;
  table_name?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Audit_Log_Sum_Fields = {
  __typename?: 'audit_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  record_id_int?: Maybe<Scalars['Int']['output']>;
};

export type Audit_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Audit_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Audit_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Audit_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Audit_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Audit_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Audit_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Audit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Audit_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Audit_Log_Var_Pop_Fields = {
  __typename?: 'audit_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Audit_Log_Var_Samp_Fields = {
  __typename?: 'audit_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Audit_Log_Variance_Fields = {
  __typename?: 'audit_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  record_id_int?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "brand" */
export type Brand = {
  __typename?: 'brand';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  ai_reasoning?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  brand_snapshots: Array<Brand_Snapshot>;
  /** An aggregate relationship */
  brand_snapshots_aggregate: Brand_Snapshot_Aggregate;
  /** An array relationship */
  brand_subscriptions: Array<Brand_Subscription>;
  /** An aggregate relationship */
  brand_subscriptions_aggregate: Brand_Subscription_Aggregate;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted: Scalars['Boolean']['output'];
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  tasks: Array<Brand_Monitoring_Task>;
  /** An aggregate relationship */
  tasks_aggregate: Brand_Monitoring_Task_Aggregate;
  /** An array relationship */
  trademarks: Array<Trademark>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademark_Aggregate;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user?: Maybe<User>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
  /** An array relationship */
  websites: Array<Website>;
  /** An aggregate relationship */
  websites_aggregate: Website_Aggregate;
};


/** columns and relationships of "brand" */
export type BrandAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "brand" */
export type BrandBrand_SnapshotsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandBrand_Snapshots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandBrand_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandBrand_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTasksArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandWebsitesArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};


/** columns and relationships of "brand" */
export type BrandWebsites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};

/** aggregated selection of "brand" */
export type Brand_Aggregate = {
  __typename?: 'brand_aggregate';
  aggregate?: Maybe<Brand_Aggregate_Fields>;
  nodes: Array<Brand>;
};

export type Brand_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Brand_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Brand_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Brand_Aggregate_Bool_Exp_Count>;
};

export type Brand_Aggregate_Bool_Exp_Bool_And = {
  arguments: Brand_Select_Column_Brand_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Brand_Select_Column_Brand_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand" */
export type Brand_Aggregate_Fields = {
  __typename?: 'brand_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Max_Fields>;
  min?: Maybe<Brand_Min_Fields>;
};


/** aggregate fields of "brand" */
export type Brand_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand" */
export type Brand_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Max_Order_By>;
  min?: InputMaybe<Brand_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Brand_Append_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "brand" */
export type Brand_Arr_Rel_Insert_Input = {
  data: Array<Brand_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};

/** Boolean expression to filter rows from the table "brand". All fields are combined with a logical 'AND'. */
export type Brand_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Bool_Exp>>;
  _not?: InputMaybe<Brand_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Bool_Exp>>;
  ai_business_description?: InputMaybe<String_Comparison_Exp>;
  ai_date_of_first_use?: InputMaybe<Date_Comparison_Exp>;
  ai_high_level_usage?: InputMaybe<String_Comparison_Exp>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  brand_snapshots?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  brand_snapshots_aggregate?: InputMaybe<Brand_Snapshot_Aggregate_Bool_Exp>;
  brand_subscriptions?: InputMaybe<Brand_Subscription_Bool_Exp>;
  brand_subscriptions_aggregate?: InputMaybe<Brand_Subscription_Aggregate_Bool_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  client_business_description?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  date_of_first_use?: InputMaybe<Date_Comparison_Exp>;
  date_of_first_use_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  high_level_usage?: InputMaybe<String_Comparison_Exp>;
  high_level_usage_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tasks?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
  tasks_aggregate?: InputMaybe<Brand_Monitoring_Task_Aggregate_Bool_Exp>;
  trademarks?: InputMaybe<Trademark_Bool_Exp>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Bool_Exp>;
  trama_business_description?: InputMaybe<String_Comparison_Exp>;
  trama_business_description_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  websites?: InputMaybe<Website_Bool_Exp>;
  websites_aggregate?: InputMaybe<Website_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "brand" */
export enum Brand_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandPkey = 'brand_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Brand_Delete_At_Path_Input = {
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Brand_Delete_Elem_Input = {
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Brand_Delete_Key_Input = {
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "brand" */
export type Brand_Insert_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  brand_snapshots?: InputMaybe<Brand_Snapshot_Arr_Rel_Insert_Input>;
  brand_subscriptions?: InputMaybe<Brand_Subscription_Arr_Rel_Insert_Input>;
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tasks?: InputMaybe<Brand_Monitoring_Task_Arr_Rel_Insert_Input>;
  trademarks?: InputMaybe<Trademark_Arr_Rel_Insert_Input>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Website_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Brand_Max_Fields = {
  __typename?: 'brand_max_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand" */
export type Brand_Max_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Min_Fields = {
  __typename?: 'brand_min_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand" */
export type Brand_Min_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "brand_monitoring_task" */
export type Brand_Monitoring_Task = {
  __typename?: 'brand_monitoring_task';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  brand: Brand;
  brand_id: Scalars['uuid']['output'];
  /** An object relationship */
  brand_subscription?: Maybe<Brand_Subscription>;
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_tier: Scalars['String']['output'];
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  deadline: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  processed_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Brand_Monitoring_Task_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Brand_Monitoring_Task_Tracking_Aggregate;
};


/** columns and relationships of "brand_monitoring_task" */
export type Brand_Monitoring_TaskCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "brand_monitoring_task" */
export type Brand_Monitoring_TaskCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "brand_monitoring_task" */
export type Brand_Monitoring_TaskTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


/** columns and relationships of "brand_monitoring_task" */
export type Brand_Monitoring_TaskTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};

/** aggregated selection of "brand_monitoring_task" */
export type Brand_Monitoring_Task_Aggregate = {
  __typename?: 'brand_monitoring_task_aggregate';
  aggregate?: Maybe<Brand_Monitoring_Task_Aggregate_Fields>;
  nodes: Array<Brand_Monitoring_Task>;
};

export type Brand_Monitoring_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Brand_Monitoring_Task_Aggregate_Bool_Exp_Count>;
};

export type Brand_Monitoring_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_monitoring_task" */
export type Brand_Monitoring_Task_Aggregate_Fields = {
  __typename?: 'brand_monitoring_task_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Monitoring_Task_Max_Fields>;
  min?: Maybe<Brand_Monitoring_Task_Min_Fields>;
};


/** aggregate fields of "brand_monitoring_task" */
export type Brand_Monitoring_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Monitoring_Task_Max_Order_By>;
  min?: InputMaybe<Brand_Monitoring_Task_Min_Order_By>;
};

/** input type for inserting array relation for remote table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Arr_Rel_Insert_Input = {
  data: Array<Brand_Monitoring_Task_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Monitoring_Task_On_Conflict>;
};

/** Boolean expression to filter rows from the table "brand_monitoring_task". All fields are combined with a logical 'AND'. */
export type Brand_Monitoring_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Monitoring_Task_Bool_Exp>>;
  _not?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Monitoring_Task_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_subscription?: InputMaybe<Brand_Subscription_Bool_Exp>;
  brand_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_subscription_tier?: InputMaybe<String_Comparison_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deadline?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  processed_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "brand_monitoring_task" */
export enum Brand_Monitoring_Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandMonitoringTaskPkey = 'brand_monitoring_task_pkey'
}

/** input type for inserting data into table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription?: InputMaybe<Brand_Subscription_Obj_Rel_Insert_Input>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_tier?: InputMaybe<Scalars['String']['input']>;
  cases?: InputMaybe<Case_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  processed_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Brand_Monitoring_Task_Tracking_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Brand_Monitoring_Task_Max_Fields = {
  __typename?: 'brand_monitoring_task_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_tier?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  processed_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Max_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  brand_subscription_tier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  processed_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Monitoring_Task_Min_Fields = {
  __typename?: 'brand_monitoring_task_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_tier?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  processed_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Min_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  brand_subscription_tier?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  processed_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Mutation_Response = {
  __typename?: 'brand_monitoring_task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Monitoring_Task>;
};

/** input type for inserting object relation for remote table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Obj_Rel_Insert_Input = {
  data: Brand_Monitoring_Task_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Monitoring_Task_On_Conflict>;
};

/** on_conflict condition type for table "brand_monitoring_task" */
export type Brand_Monitoring_Task_On_Conflict = {
  constraint: Brand_Monitoring_Task_Constraint;
  update_columns?: Array<Brand_Monitoring_Task_Update_Column>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_monitoring_task". */
export type Brand_Monitoring_Task_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_subscription?: InputMaybe<Brand_Subscription_Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  brand_subscription_tier?: InputMaybe<Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  processed_timestamp?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Brand_Monitoring_Task_Tracking_Aggregate_Order_By>;
};

/** primary key columns input for table: brand_monitoring_task */
export type Brand_Monitoring_Task_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "brand_monitoring_task" */
export enum Brand_Monitoring_Task_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  BrandSubscriptionTier = 'brand_subscription_tier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  ProcessedTimestamp = 'processed_timestamp',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_tier?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  processed_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "brand_monitoring_task" */
export type Brand_Monitoring_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Monitoring_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Monitoring_Task_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_tier?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  processed_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking = {
  __typename?: 'brand_monitoring_task_tracking';
  brand_monitoring_task_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Brand_Monitoring_Task_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Aggregate = {
  __typename?: 'brand_monitoring_task_tracking_aggregate';
  aggregate?: Maybe<Brand_Monitoring_Task_Tracking_Aggregate_Fields>;
  nodes: Array<Brand_Monitoring_Task_Tracking>;
};

export type Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Brand_Monitoring_Task_Tracking_Select_Column_Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Brand_Monitoring_Task_Tracking_Select_Column_Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Aggregate_Fields = {
  __typename?: 'brand_monitoring_task_tracking_aggregate_fields';
  avg?: Maybe<Brand_Monitoring_Task_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Monitoring_Task_Tracking_Max_Fields>;
  min?: Maybe<Brand_Monitoring_Task_Tracking_Min_Fields>;
  stddev?: Maybe<Brand_Monitoring_Task_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Brand_Monitoring_Task_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Brand_Monitoring_Task_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Brand_Monitoring_Task_Tracking_Sum_Fields>;
  var_pop?: Maybe<Brand_Monitoring_Task_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Brand_Monitoring_Task_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Brand_Monitoring_Task_Tracking_Variance_Fields>;
};


/** aggregate fields of "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Brand_Monitoring_Task_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Monitoring_Task_Tracking_Max_Order_By>;
  min?: InputMaybe<Brand_Monitoring_Task_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Brand_Monitoring_Task_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Brand_Monitoring_Task_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Brand_Monitoring_Task_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Brand_Monitoring_Task_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Brand_Monitoring_Task_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Brand_Monitoring_Task_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Brand_Monitoring_Task_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Brand_Monitoring_Task_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Brand_Monitoring_Task_Tracking_Avg_Fields = {
  __typename?: 'brand_monitoring_task_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "brand_monitoring_task_tracking". All fields are combined with a logical 'AND'. */
export type Brand_Monitoring_Task_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Bool_Exp>>;
  brand_monitoring_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_monitoring_task_tracking" */
export enum Brand_Monitoring_Task_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandMonitoringTaskTrackingPkey = 'brand_monitoring_task_tracking_pkey'
}

/** input type for incrementing numeric columns in table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Insert_Input = {
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Brand_Monitoring_Task_Tracking_Max_Fields = {
  __typename?: 'brand_monitoring_task_tracking_max_fields';
  brand_monitoring_task_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Max_Order_By = {
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Monitoring_Task_Tracking_Min_Fields = {
  __typename?: 'brand_monitoring_task_tracking_min_fields';
  brand_monitoring_task_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Min_Order_By = {
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Mutation_Response = {
  __typename?: 'brand_monitoring_task_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Monitoring_Task_Tracking>;
};

/** on_conflict condition type for table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_On_Conflict = {
  constraint: Brand_Monitoring_Task_Tracking_Constraint;
  update_columns?: Array<Brand_Monitoring_Task_Tracking_Update_Column>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_monitoring_task_tracking". */
export type Brand_Monitoring_Task_Tracking_Order_By = {
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_monitoring_task_tracking */
export type Brand_Monitoring_Task_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "brand_monitoring_task_tracking" */
export enum Brand_Monitoring_Task_Tracking_Select_Column {
  /** column name */
  BrandMonitoringTaskId = 'brand_monitoring_task_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "brand_monitoring_task_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "brand_monitoring_task_tracking" */
export enum Brand_Monitoring_Task_Tracking_Select_Column_Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "brand_monitoring_task_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "brand_monitoring_task_tracking" */
export enum Brand_Monitoring_Task_Tracking_Select_Column_Brand_Monitoring_Task_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Set_Input = {
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status = {
  __typename?: 'brand_monitoring_task_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Aggregate = {
  __typename?: 'brand_monitoring_task_tracking_status_aggregate';
  aggregate?: Maybe<Brand_Monitoring_Task_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Brand_Monitoring_Task_Tracking_Status>;
};

/** aggregate fields of "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Aggregate_Fields = {
  __typename?: 'brand_monitoring_task_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Monitoring_Task_Tracking_Status_Max_Fields>;
  min?: Maybe<Brand_Monitoring_Task_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "brand_monitoring_task_tracking_status". All fields are combined with a logical 'AND'. */
export type Brand_Monitoring_Task_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_monitoring_task_tracking_status" */
export enum Brand_Monitoring_Task_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  BrandMonitoringTaskTrackingStatusPkey = 'brand_monitoring_task_tracking_status_pkey'
}

/** input type for inserting data into table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Brand_Monitoring_Task_Tracking_Status_Max_Fields = {
  __typename?: 'brand_monitoring_task_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Brand_Monitoring_Task_Tracking_Status_Min_Fields = {
  __typename?: 'brand_monitoring_task_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Mutation_Response = {
  __typename?: 'brand_monitoring_task_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Monitoring_Task_Tracking_Status>;
};

/** input type for inserting object relation for remote table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Brand_Monitoring_Task_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_On_Conflict = {
  constraint: Brand_Monitoring_Task_Tracking_Status_Constraint;
  update_columns?: Array<Brand_Monitoring_Task_Tracking_Status_Update_Column>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_monitoring_task_tracking_status". */
export type Brand_Monitoring_Task_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_monitoring_task_tracking_status */
export type Brand_Monitoring_Task_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "brand_monitoring_task_tracking_status" */
export enum Brand_Monitoring_Task_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "brand_monitoring_task_tracking_status" */
export type Brand_Monitoring_Task_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Monitoring_Task_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Monitoring_Task_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "brand_monitoring_task_tracking_status" */
export enum Brand_Monitoring_Task_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Brand_Monitoring_Task_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Monitoring_Task_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Brand_Monitoring_Task_Tracking_Stddev_Fields = {
  __typename?: 'brand_monitoring_task_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Brand_Monitoring_Task_Tracking_Stddev_Pop_Fields = {
  __typename?: 'brand_monitoring_task_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Brand_Monitoring_Task_Tracking_Stddev_Samp_Fields = {
  __typename?: 'brand_monitoring_task_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Monitoring_Task_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Monitoring_Task_Tracking_Stream_Cursor_Value_Input = {
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Brand_Monitoring_Task_Tracking_Sum_Fields = {
  __typename?: 'brand_monitoring_task_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "brand_monitoring_task_tracking" */
export enum Brand_Monitoring_Task_Tracking_Update_Column {
  /** column name */
  BrandMonitoringTaskId = 'brand_monitoring_task_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Brand_Monitoring_Task_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Brand_Monitoring_Task_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Monitoring_Task_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Brand_Monitoring_Task_Tracking_Var_Pop_Fields = {
  __typename?: 'brand_monitoring_task_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Brand_Monitoring_Task_Tracking_Var_Samp_Fields = {
  __typename?: 'brand_monitoring_task_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Brand_Monitoring_Task_Tracking_Variance_Fields = {
  __typename?: 'brand_monitoring_task_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "brand_monitoring_task_tracking" */
export type Brand_Monitoring_Task_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "brand_monitoring_task" */
export enum Brand_Monitoring_Task_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  BrandSubscriptionTier = 'brand_subscription_tier',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  ProcessedTimestamp = 'processed_timestamp',
  /** column name */
  Status = 'status'
}

export type Brand_Monitoring_Task_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Monitoring_Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Monitoring_Task_Bool_Exp;
};

/** response of any mutation on the table "brand" */
export type Brand_Mutation_Response = {
  __typename?: 'brand_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand>;
};

/** input type for inserting object relation for remote table "brand" */
export type Brand_Obj_Rel_Insert_Input = {
  data: Brand_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};

/** on_conflict condition type for table "brand" */
export type Brand_On_Conflict = {
  constraint: Brand_Constraint;
  update_columns?: Array<Brand_Update_Column>;
  where?: InputMaybe<Brand_Bool_Exp>;
};

/** Ordering options when selecting data from "brand". */
export type Brand_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  ai_reasoning?: InputMaybe<Order_By>;
  brand_snapshots_aggregate?: InputMaybe<Brand_Snapshot_Aggregate_Order_By>;
  brand_subscriptions_aggregate?: InputMaybe<Brand_Subscription_Aggregate_Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tasks_aggregate?: InputMaybe<Brand_Monitoring_Task_Aggregate_Order_By>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  websites_aggregate?: InputMaybe<Website_Aggregate_Order_By>;
};

/** primary key columns input for table: brand */
export type Brand_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Brand_Prepend_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "brand" */
export enum Brand_Select_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiDateOfFirstUse = 'ai_date_of_first_use',
  /** column name */
  AiHighLevelUsage = 'ai_high_level_usage',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DateOfFirstUse = 'date_of_first_use',
  /** column name */
  DateOfFirstUseUpdatedAt = 'date_of_first_use_updated_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HighLevelUsage = 'high_level_usage',
  /** column name */
  HighLevelUsageUpdatedAt = 'high_level_usage_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  TramaBusinessDescriptionUpdatedAt = 'trama_business_description_updated_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** select "brand_aggregate_bool_exp_bool_and_arguments_columns" columns of table "brand" */
export enum Brand_Select_Column_Brand_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "brand_aggregate_bool_exp_bool_or_arguments_columns" columns of table "brand" */
export enum Brand_Select_Column_Brand_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "brand" */
export type Brand_Set_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_snapshot" */
export type Brand_Snapshot = {
  __typename?: 'brand_snapshot';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  ai_reasoning: Scalars['jsonb']['output'];
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at: Scalars['timestamptz']['output'];
  deleted: Scalars['Boolean']['output'];
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  original_brand?: Maybe<Brand>;
  original_brand_id?: Maybe<Scalars['uuid']['output']>;
  snapshotted_at: Scalars['timestamptz']['output'];
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at: Scalars['timestamptz']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
  /** An array relationship */
  verification_results: Array<Verification_Result>;
  /** An aggregate relationship */
  verification_results_aggregate: Verification_Result_Aggregate;
  websites: Scalars['jsonb']['output'];
};


/** columns and relationships of "brand_snapshot" */
export type Brand_SnapshotAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "brand_snapshot" */
export type Brand_SnapshotVerification_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


/** columns and relationships of "brand_snapshot" */
export type Brand_SnapshotVerification_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


/** columns and relationships of "brand_snapshot" */
export type Brand_SnapshotWebsitesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "brand_snapshot" */
export type Brand_Snapshot_Aggregate = {
  __typename?: 'brand_snapshot_aggregate';
  aggregate?: Maybe<Brand_Snapshot_Aggregate_Fields>;
  nodes: Array<Brand_Snapshot>;
};

export type Brand_Snapshot_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Brand_Snapshot_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Brand_Snapshot_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Brand_Snapshot_Aggregate_Bool_Exp_Count>;
};

export type Brand_Snapshot_Aggregate_Bool_Exp_Bool_And = {
  arguments: Brand_Snapshot_Select_Column_Brand_Snapshot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Snapshot_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Brand_Snapshot_Select_Column_Brand_Snapshot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Snapshot_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_snapshot" */
export type Brand_Snapshot_Aggregate_Fields = {
  __typename?: 'brand_snapshot_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Snapshot_Max_Fields>;
  min?: Maybe<Brand_Snapshot_Min_Fields>;
};


/** aggregate fields of "brand_snapshot" */
export type Brand_Snapshot_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_snapshot" */
export type Brand_Snapshot_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Snapshot_Max_Order_By>;
  min?: InputMaybe<Brand_Snapshot_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Brand_Snapshot_Append_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "brand_snapshot" */
export type Brand_Snapshot_Arr_Rel_Insert_Input = {
  data: Array<Brand_Snapshot_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Snapshot_On_Conflict>;
};

/** Boolean expression to filter rows from the table "brand_snapshot". All fields are combined with a logical 'AND'. */
export type Brand_Snapshot_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Snapshot_Bool_Exp>>;
  _not?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Snapshot_Bool_Exp>>;
  ai_business_description?: InputMaybe<String_Comparison_Exp>;
  ai_date_of_first_use?: InputMaybe<Date_Comparison_Exp>;
  ai_high_level_usage?: InputMaybe<String_Comparison_Exp>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  client_business_description?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  date_of_first_use?: InputMaybe<Date_Comparison_Exp>;
  date_of_first_use_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  high_level_usage?: InputMaybe<String_Comparison_Exp>;
  high_level_usage_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  original_brand?: InputMaybe<Brand_Bool_Exp>;
  original_brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  snapshotted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  trama_business_description?: InputMaybe<String_Comparison_Exp>;
  trama_business_description_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verification_results?: InputMaybe<Verification_Result_Bool_Exp>;
  verification_results_aggregate?: InputMaybe<Verification_Result_Aggregate_Bool_Exp>;
  websites?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_snapshot" */
export enum Brand_Snapshot_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandSnapshotPkey = 'brand_snapshot_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Brand_Snapshot_Delete_At_Path_Input = {
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
  websites?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Brand_Snapshot_Delete_Elem_Input = {
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
  websites?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Brand_Snapshot_Delete_Key_Input = {
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
  websites?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "brand_snapshot" */
export type Brand_Snapshot_Insert_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  original_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  snapshotted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_results?: InputMaybe<Verification_Result_Arr_Rel_Insert_Input>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Brand_Snapshot_Max_Fields = {
  __typename?: 'brand_snapshot_max_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_brand_id?: Maybe<Scalars['uuid']['output']>;
  snapshotted_at?: Maybe<Scalars['timestamptz']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_snapshot" */
export type Brand_Snapshot_Max_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original_brand_id?: InputMaybe<Order_By>;
  snapshotted_at?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Snapshot_Min_Fields = {
  __typename?: 'brand_snapshot_min_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_date_of_first_use?: Maybe<Scalars['date']['output']>;
  ai_high_level_usage?: Maybe<Scalars['String']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  date_of_first_use?: Maybe<Scalars['date']['output']>;
  date_of_first_use_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  high_level_usage?: Maybe<Scalars['String']['output']>;
  high_level_usage_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  original_brand_id?: Maybe<Scalars['uuid']['output']>;
  snapshotted_at?: Maybe<Scalars['timestamptz']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  trama_business_description_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_snapshot" */
export type Brand_Snapshot_Min_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original_brand_id?: InputMaybe<Order_By>;
  snapshotted_at?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_snapshot" */
export type Brand_Snapshot_Mutation_Response = {
  __typename?: 'brand_snapshot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Snapshot>;
};

/** input type for inserting object relation for remote table "brand_snapshot" */
export type Brand_Snapshot_Obj_Rel_Insert_Input = {
  data: Brand_Snapshot_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Snapshot_On_Conflict>;
};

/** on_conflict condition type for table "brand_snapshot" */
export type Brand_Snapshot_On_Conflict = {
  constraint: Brand_Snapshot_Constraint;
  update_columns?: Array<Brand_Snapshot_Update_Column>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_snapshot". */
export type Brand_Snapshot_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_date_of_first_use?: InputMaybe<Order_By>;
  ai_high_level_usage?: InputMaybe<Order_By>;
  ai_reasoning?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  date_of_first_use?: InputMaybe<Order_By>;
  date_of_first_use_updated_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  high_level_usage?: InputMaybe<Order_By>;
  high_level_usage_updated_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  original_brand?: InputMaybe<Brand_Order_By>;
  original_brand_id?: InputMaybe<Order_By>;
  snapshotted_at?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  trama_business_description_updated_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_results_aggregate?: InputMaybe<Verification_Result_Aggregate_Order_By>;
  websites?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_snapshot */
export type Brand_Snapshot_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Brand_Snapshot_Prepend_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "brand_snapshot" */
export enum Brand_Snapshot_Select_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiDateOfFirstUse = 'ai_date_of_first_use',
  /** column name */
  AiHighLevelUsage = 'ai_high_level_usage',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DateOfFirstUse = 'date_of_first_use',
  /** column name */
  DateOfFirstUseUpdatedAt = 'date_of_first_use_updated_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HighLevelUsage = 'high_level_usage',
  /** column name */
  HighLevelUsageUpdatedAt = 'high_level_usage_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalBrandId = 'original_brand_id',
  /** column name */
  SnapshottedAt = 'snapshotted_at',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  TramaBusinessDescriptionUpdatedAt = 'trama_business_description_updated_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites'
}

/** select "brand_snapshot_aggregate_bool_exp_bool_and_arguments_columns" columns of table "brand_snapshot" */
export enum Brand_Snapshot_Select_Column_Brand_Snapshot_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "brand_snapshot_aggregate_bool_exp_bool_or_arguments_columns" columns of table "brand_snapshot" */
export enum Brand_Snapshot_Select_Column_Brand_Snapshot_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "brand_snapshot" */
export type Brand_Snapshot_Set_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  snapshotted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "brand_snapshot" */
export type Brand_Snapshot_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Snapshot_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Snapshot_Stream_Cursor_Value_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  original_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  snapshotted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "brand_snapshot" */
export enum Brand_Snapshot_Update_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiDateOfFirstUse = 'ai_date_of_first_use',
  /** column name */
  AiHighLevelUsage = 'ai_high_level_usage',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DateOfFirstUse = 'date_of_first_use',
  /** column name */
  DateOfFirstUseUpdatedAt = 'date_of_first_use_updated_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HighLevelUsage = 'high_level_usage',
  /** column name */
  HighLevelUsageUpdatedAt = 'high_level_usage_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OriginalBrandId = 'original_brand_id',
  /** column name */
  SnapshottedAt = 'snapshotted_at',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  TramaBusinessDescriptionUpdatedAt = 'trama_business_description_updated_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites'
}

export type Brand_Snapshot_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Brand_Snapshot_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Brand_Snapshot_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Brand_Snapshot_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Brand_Snapshot_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Brand_Snapshot_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Snapshot_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Snapshot_Bool_Exp;
};

/** Streaming cursor of the table "brand" */
export type Brand_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Stream_Cursor_Value_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  ai_high_level_usage?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_first_use?: InputMaybe<Scalars['date']['input']>;
  date_of_first_use_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  high_level_usage?: InputMaybe<Scalars['String']['input']>;
  high_level_usage_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  trama_business_description_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_subscription" */
export type Brand_Subscription = {
  __typename?: 'brand_subscription';
  analytics_data?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  billing_entity?: Maybe<Entity>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  brand: Brand;
  brand_id: Scalars['uuid']['output'];
  /** An array relationship */
  brand_monitoring_tasks: Array<Brand_Monitoring_Task>;
  /** An aggregate relationship */
  brand_monitoring_tasks_aggregate: Brand_Monitoring_Task_Aggregate;
  /** An array relationship */
  brand_subscription_payments: Array<Brand_Subscription_Payment>;
  /** An aggregate relationship */
  brand_subscription_payments_aggregate: Brand_Subscription_Payment_Aggregate;
  /** An object relationship */
  case_solution?: Maybe<Case_Solution>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  currency: Scalars['String']['output'];
  /** An object relationship */
  discount_coupon?: Maybe<Discount_Coupon>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  is_proactive: Scalars['Boolean']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  note_hub_id: Scalars['uuid']['output'];
  payment_frequency: Scalars['String']['output'];
  /** An array relationship */
  platforms: Array<Brand_Subscription_Platform>;
  /** An aggregate relationship */
  platforms_aggregate: Brand_Subscription_Platform_Aggregate;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  start_date: Scalars['date']['output'];
  status: Scalars['String']['output'];
  tier: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Brand_Subscription_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Brand_Subscription_Tracking_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user_payment_method?: Maybe<User_Payment_Method>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionAnalytics_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionBrand_Monitoring_TasksArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionBrand_Monitoring_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionBrand_Subscription_PaymentsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionBrand_Subscription_Payments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionPlatformsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionPlatforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


/** columns and relationships of "brand_subscription" */
export type Brand_SubscriptionTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};

/** aggregated selection of "brand_subscription" */
export type Brand_Subscription_Aggregate = {
  __typename?: 'brand_subscription_aggregate';
  aggregate?: Maybe<Brand_Subscription_Aggregate_Fields>;
  nodes: Array<Brand_Subscription>;
};

export type Brand_Subscription_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Brand_Subscription_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Brand_Subscription_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Brand_Subscription_Aggregate_Bool_Exp_Count>;
};

export type Brand_Subscription_Aggregate_Bool_Exp_Bool_And = {
  arguments: Brand_Subscription_Select_Column_Brand_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Subscription_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Brand_Subscription_Select_Column_Brand_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_subscription" */
export type Brand_Subscription_Aggregate_Fields = {
  __typename?: 'brand_subscription_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Subscription_Max_Fields>;
  min?: Maybe<Brand_Subscription_Min_Fields>;
};


/** aggregate fields of "brand_subscription" */
export type Brand_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_subscription" */
export type Brand_Subscription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Subscription_Max_Order_By>;
  min?: InputMaybe<Brand_Subscription_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Brand_Subscription_Append_Input = {
  analytics_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "brand_subscription" */
export type Brand_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Brand_Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "brand_subscription". All fields are combined with a logical 'AND'. */
export type Brand_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Brand_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Subscription_Bool_Exp>>;
  analytics_data?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_entity?: InputMaybe<Entity_Bool_Exp>;
  billing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_monitoring_tasks?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
  brand_monitoring_tasks_aggregate?: InputMaybe<Brand_Monitoring_Task_Aggregate_Bool_Exp>;
  brand_subscription_payments?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
  brand_subscription_payments_aggregate?: InputMaybe<Brand_Subscription_Payment_Aggregate_Bool_Exp>;
  case_solution?: InputMaybe<Case_Solution_Bool_Exp>;
  case_solution_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  discount_coupon?: InputMaybe<Discount_Coupon_Bool_Exp>;
  discount_coupon_id?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_proactive?: InputMaybe<Boolean_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_frequency?: InputMaybe<String_Comparison_Exp>;
  platforms?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
  platforms_aggregate?: InputMaybe<Brand_Subscription_Platform_Aggregate_Bool_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tier?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Brand_Subscription_Tracking_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_payment_method?: InputMaybe<User_Payment_Method_Bool_Exp>;
  user_payment_method_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_subscription" */
export enum Brand_Subscription_Constraint {
  /** unique or primary key constraint on columns "note_hub_id" */
  BrandSubscriptionNoteHubIdKey = 'brand_subscription_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  BrandSubscriptionPkey = 'brand_subscription_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Brand_Subscription_Delete_At_Path_Input = {
  analytics_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Brand_Subscription_Delete_Elem_Input = {
  analytics_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Brand_Subscription_Delete_Key_Input = {
  analytics_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "brand_subscription" */
export type Brand_Subscription_Insert_Input = {
  analytics_data?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_monitoring_tasks?: InputMaybe<Brand_Monitoring_Task_Arr_Rel_Insert_Input>;
  brand_subscription_payments?: InputMaybe<Brand_Subscription_Payment_Arr_Rel_Insert_Input>;
  case_solution?: InputMaybe<Case_Solution_Obj_Rel_Insert_Input>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon?: InputMaybe<Discount_Coupon_Obj_Rel_Insert_Input>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_proactive?: InputMaybe<Scalars['Boolean']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_frequency?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Brand_Subscription_Platform_Arr_Rel_Insert_Input>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Brand_Subscription_Tracking_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_payment_method?: InputMaybe<User_Payment_Method_Obj_Rel_Insert_Input>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Brand_Subscription_Max_Fields = {
  __typename?: 'brand_subscription_max_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  payment_frequency?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_subscription" */
export type Brand_Subscription_Max_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  payment_frequency?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Subscription_Min_Fields = {
  __typename?: 'brand_subscription_min_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  payment_frequency?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_subscription" */
export type Brand_Subscription_Min_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  payment_frequency?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_subscription" */
export type Brand_Subscription_Mutation_Response = {
  __typename?: 'brand_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Subscription>;
};

/** input type for inserting object relation for remote table "brand_subscription" */
export type Brand_Subscription_Obj_Rel_Insert_Input = {
  data: Brand_Subscription_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_On_Conflict>;
};

/** on_conflict condition type for table "brand_subscription" */
export type Brand_Subscription_On_Conflict = {
  constraint: Brand_Subscription_Constraint;
  update_columns?: Array<Brand_Subscription_Update_Column>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_subscription". */
export type Brand_Subscription_Order_By = {
  analytics_data?: InputMaybe<Order_By>;
  billing_entity?: InputMaybe<Entity_Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_monitoring_tasks_aggregate?: InputMaybe<Brand_Monitoring_Task_Aggregate_Order_By>;
  brand_subscription_payments_aggregate?: InputMaybe<Brand_Subscription_Payment_Aggregate_Order_By>;
  case_solution?: InputMaybe<Case_Solution_Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon?: InputMaybe<Discount_Coupon_Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_proactive?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  payment_frequency?: InputMaybe<Order_By>;
  platforms_aggregate?: InputMaybe<Brand_Subscription_Platform_Aggregate_Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Brand_Subscription_Tracking_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_payment_method?: InputMaybe<User_Payment_Method_Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "brand_subscription_payment" */
export type Brand_Subscription_Payment = {
  __typename?: 'brand_subscription_payment';
  /** An object relationship */
  billing_entity: Entity;
  billing_entity_id: Scalars['uuid']['output'];
  /** An object relationship */
  brand_subscription: Brand_Subscription;
  brand_subscription_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  decline_reason?: Maybe<Scalars['String']['output']>;
  document_folder_id: Scalars['uuid']['output'];
  end_date: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  last_attempt_date?: Maybe<Scalars['date']['output']>;
  number_of_attempts: Scalars['Int']['output'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  start_date: Scalars['date']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user_payment_method?: Maybe<User_Payment_Method>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "brand_subscription_payment" */
export type Brand_Subscription_Payment_Aggregate = {
  __typename?: 'brand_subscription_payment_aggregate';
  aggregate?: Maybe<Brand_Subscription_Payment_Aggregate_Fields>;
  nodes: Array<Brand_Subscription_Payment>;
};

export type Brand_Subscription_Payment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Brand_Subscription_Payment_Aggregate_Bool_Exp_Count>;
};

export type Brand_Subscription_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_subscription_payment" */
export type Brand_Subscription_Payment_Aggregate_Fields = {
  __typename?: 'brand_subscription_payment_aggregate_fields';
  avg?: Maybe<Brand_Subscription_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Subscription_Payment_Max_Fields>;
  min?: Maybe<Brand_Subscription_Payment_Min_Fields>;
  stddev?: Maybe<Brand_Subscription_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Brand_Subscription_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Brand_Subscription_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Brand_Subscription_Payment_Sum_Fields>;
  var_pop?: Maybe<Brand_Subscription_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Brand_Subscription_Payment_Var_Samp_Fields>;
  variance?: Maybe<Brand_Subscription_Payment_Variance_Fields>;
};


/** aggregate fields of "brand_subscription_payment" */
export type Brand_Subscription_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Aggregate_Order_By = {
  avg?: InputMaybe<Brand_Subscription_Payment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Subscription_Payment_Max_Order_By>;
  min?: InputMaybe<Brand_Subscription_Payment_Min_Order_By>;
  stddev?: InputMaybe<Brand_Subscription_Payment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Brand_Subscription_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Brand_Subscription_Payment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Brand_Subscription_Payment_Sum_Order_By>;
  var_pop?: InputMaybe<Brand_Subscription_Payment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Brand_Subscription_Payment_Var_Samp_Order_By>;
  variance?: InputMaybe<Brand_Subscription_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Arr_Rel_Insert_Input = {
  data: Array<Brand_Subscription_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_Payment_On_Conflict>;
};

/** aggregate avg on columns */
export type Brand_Subscription_Payment_Avg_Fields = {
  __typename?: 'brand_subscription_payment_avg_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Avg_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "brand_subscription_payment". All fields are combined with a logical 'AND'. */
export type Brand_Subscription_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Subscription_Payment_Bool_Exp>>;
  _not?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Subscription_Payment_Bool_Exp>>;
  billing_entity?: InputMaybe<Entity_Bool_Exp>;
  billing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_subscription?: InputMaybe<Brand_Subscription_Bool_Exp>;
  brand_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  decline_reason?: InputMaybe<String_Comparison_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_attempt_date?: InputMaybe<Date_Comparison_Exp>;
  number_of_attempts?: InputMaybe<Int_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_payment_method?: InputMaybe<User_Payment_Method_Bool_Exp>;
  user_payment_method_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_subscription_payment" */
export enum Brand_Subscription_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandSubscriptionPaymentPkey = 'brand_subscription_payment_pkey'
}

/** input type for incrementing numeric columns in table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Inc_Input = {
  number_of_attempts?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Insert_Input = {
  billing_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription?: InputMaybe<Brand_Subscription_Obj_Rel_Insert_Input>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  decline_reason?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_attempt_date?: InputMaybe<Scalars['date']['input']>;
  number_of_attempts?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_payment_method?: InputMaybe<User_Payment_Method_Obj_Rel_Insert_Input>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Brand_Subscription_Payment_Max_Fields = {
  __typename?: 'brand_subscription_payment_max_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  decline_reason?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_attempt_date?: Maybe<Scalars['date']['output']>;
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Max_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  decline_reason?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempt_date?: InputMaybe<Order_By>;
  number_of_attempts?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Subscription_Payment_Min_Fields = {
  __typename?: 'brand_subscription_payment_min_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  decline_reason?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_attempt_date?: Maybe<Scalars['date']['output']>;
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_payment_method_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Min_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  decline_reason?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempt_date?: InputMaybe<Order_By>;
  number_of_attempts?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Mutation_Response = {
  __typename?: 'brand_subscription_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Subscription_Payment>;
};

/** input type for inserting object relation for remote table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Obj_Rel_Insert_Input = {
  data: Brand_Subscription_Payment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_Payment_On_Conflict>;
};

/** on_conflict condition type for table "brand_subscription_payment" */
export type Brand_Subscription_Payment_On_Conflict = {
  constraint: Brand_Subscription_Payment_Constraint;
  update_columns?: Array<Brand_Subscription_Payment_Update_Column>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_subscription_payment". */
export type Brand_Subscription_Payment_Order_By = {
  billing_entity?: InputMaybe<Entity_Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_subscription?: InputMaybe<Brand_Subscription_Order_By>;
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  decline_reason?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_attempt_date?: InputMaybe<Order_By>;
  number_of_attempts?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_payment_method?: InputMaybe<User_Payment_Method_Order_By>;
  user_payment_method_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_subscription_payment */
export type Brand_Subscription_Payment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "brand_subscription_payment" */
export enum Brand_Subscription_Payment_Select_Column {
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclineReason = 'decline_reason',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastAttemptDate = 'last_attempt_date',
  /** column name */
  NumberOfAttempts = 'number_of_attempts',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserPaymentMethodId = 'user_payment_method_id'
}

/** input type for updating data in table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Set_Input = {
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  decline_reason?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_attempt_date?: InputMaybe<Scalars['date']['input']>;
  number_of_attempts?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Brand_Subscription_Payment_Stddev_Fields = {
  __typename?: 'brand_subscription_payment_stddev_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Stddev_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Brand_Subscription_Payment_Stddev_Pop_Fields = {
  __typename?: 'brand_subscription_payment_stddev_pop_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Stddev_Pop_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Brand_Subscription_Payment_Stddev_Samp_Fields = {
  __typename?: 'brand_subscription_payment_stddev_samp_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Stddev_Samp_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Subscription_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Subscription_Payment_Stream_Cursor_Value_Input = {
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  decline_reason?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_attempt_date?: InputMaybe<Scalars['date']['input']>;
  number_of_attempts?: InputMaybe<Scalars['Int']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Brand_Subscription_Payment_Sum_Fields = {
  __typename?: 'brand_subscription_payment_sum_fields';
  number_of_attempts?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Sum_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** update columns of table "brand_subscription_payment" */
export enum Brand_Subscription_Payment_Update_Column {
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclineReason = 'decline_reason',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastAttemptDate = 'last_attempt_date',
  /** column name */
  NumberOfAttempts = 'number_of_attempts',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserPaymentMethodId = 'user_payment_method_id'
}

export type Brand_Subscription_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Brand_Subscription_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Subscription_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Subscription_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Brand_Subscription_Payment_Var_Pop_Fields = {
  __typename?: 'brand_subscription_payment_var_pop_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Var_Pop_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Brand_Subscription_Payment_Var_Samp_Fields = {
  __typename?: 'brand_subscription_payment_var_samp_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Var_Samp_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Brand_Subscription_Payment_Variance_Fields = {
  __typename?: 'brand_subscription_payment_variance_fields';
  number_of_attempts?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "brand_subscription_payment" */
export type Brand_Subscription_Payment_Variance_Order_By = {
  number_of_attempts?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_subscription */
export type Brand_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "brand_subscription_platform" */
export type Brand_Subscription_Platform = {
  __typename?: 'brand_subscription_platform';
  brand_subscription_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  end_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  name: Scalars['String']['output'];
  start_date: Scalars['date']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "brand_subscription_platform" */
export type Brand_Subscription_PlatformMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "brand_subscription_platform" */
export type Brand_Subscription_Platform_Aggregate = {
  __typename?: 'brand_subscription_platform_aggregate';
  aggregate?: Maybe<Brand_Subscription_Platform_Aggregate_Fields>;
  nodes: Array<Brand_Subscription_Platform>;
};

export type Brand_Subscription_Platform_Aggregate_Bool_Exp = {
  count?: InputMaybe<Brand_Subscription_Platform_Aggregate_Bool_Exp_Count>;
};

export type Brand_Subscription_Platform_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_subscription_platform" */
export type Brand_Subscription_Platform_Aggregate_Fields = {
  __typename?: 'brand_subscription_platform_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Subscription_Platform_Max_Fields>;
  min?: Maybe<Brand_Subscription_Platform_Min_Fields>;
};


/** aggregate fields of "brand_subscription_platform" */
export type Brand_Subscription_Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Subscription_Platform_Max_Order_By>;
  min?: InputMaybe<Brand_Subscription_Platform_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Brand_Subscription_Platform_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Arr_Rel_Insert_Input = {
  data: Array<Brand_Subscription_Platform_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_Platform_On_Conflict>;
};

/** Boolean expression to filter rows from the table "brand_subscription_platform". All fields are combined with a logical 'AND'. */
export type Brand_Subscription_Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Subscription_Platform_Bool_Exp>>;
  _not?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Subscription_Platform_Bool_Exp>>;
  brand_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_subscription_platform" */
export enum Brand_Subscription_Platform_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandSubscriptionPlatformPkey = 'brand_subscription_platform_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Brand_Subscription_Platform_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Brand_Subscription_Platform_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Brand_Subscription_Platform_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Insert_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Brand_Subscription_Platform_Max_Fields = {
  __typename?: 'brand_subscription_platform_max_fields';
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Max_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Subscription_Platform_Min_Fields = {
  __typename?: 'brand_subscription_platform_min_fields';
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Min_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Mutation_Response = {
  __typename?: 'brand_subscription_platform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Subscription_Platform>;
};

/** on_conflict condition type for table "brand_subscription_platform" */
export type Brand_Subscription_Platform_On_Conflict = {
  constraint: Brand_Subscription_Platform_Constraint;
  update_columns?: Array<Brand_Subscription_Platform_Update_Column>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_subscription_platform". */
export type Brand_Subscription_Platform_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_subscription_platform */
export type Brand_Subscription_Platform_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Brand_Subscription_Platform_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "brand_subscription_platform" */
export enum Brand_Subscription_Platform_Select_Column {
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Set_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "brand_subscription_platform" */
export type Brand_Subscription_Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Subscription_Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Subscription_Platform_Stream_Cursor_Value_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "brand_subscription_platform" */
export enum Brand_Subscription_Platform_Update_Column {
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Brand_Subscription_Platform_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Brand_Subscription_Platform_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Brand_Subscription_Platform_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Brand_Subscription_Platform_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Brand_Subscription_Platform_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Brand_Subscription_Platform_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Subscription_Platform_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Subscription_Platform_Bool_Exp;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Brand_Subscription_Prepend_Input = {
  analytics_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "brand_subscription" */
export enum Brand_Subscription_Select_Column {
  /** column name */
  AnalyticsData = 'analytics_data',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CaseSolutionId = 'case_solution_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsProactive = 'is_proactive',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  PaymentFrequency = 'payment_frequency',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserPaymentMethodId = 'user_payment_method_id'
}

/** select "brand_subscription_aggregate_bool_exp_bool_and_arguments_columns" columns of table "brand_subscription" */
export enum Brand_Subscription_Select_Column_Brand_Subscription_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsProactive = 'is_proactive'
}

/** select "brand_subscription_aggregate_bool_exp_bool_or_arguments_columns" columns of table "brand_subscription" */
export enum Brand_Subscription_Select_Column_Brand_Subscription_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsProactive = 'is_proactive'
}

/** input type for updating data in table "brand_subscription" */
export type Brand_Subscription_Set_Input = {
  analytics_data?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_proactive?: InputMaybe<Scalars['Boolean']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_frequency?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "brand_subscription" */
export type Brand_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Subscription_Stream_Cursor_Value_Input = {
  analytics_data?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_proactive?: InputMaybe<Scalars['Boolean']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_frequency?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_payment_method_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_subscription_tracking" */
export type Brand_Subscription_Tracking = {
  __typename?: 'brand_subscription_tracking';
  brand_subscription_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Brand_Subscription_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Aggregate = {
  __typename?: 'brand_subscription_tracking_aggregate';
  aggregate?: Maybe<Brand_Subscription_Tracking_Aggregate_Fields>;
  nodes: Array<Brand_Subscription_Tracking>;
};

export type Brand_Subscription_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Brand_Subscription_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Brand_Subscription_Tracking_Select_Column_Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Brand_Subscription_Tracking_Select_Column_Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Brand_Subscription_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Aggregate_Fields = {
  __typename?: 'brand_subscription_tracking_aggregate_fields';
  avg?: Maybe<Brand_Subscription_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Subscription_Tracking_Max_Fields>;
  min?: Maybe<Brand_Subscription_Tracking_Min_Fields>;
  stddev?: Maybe<Brand_Subscription_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Brand_Subscription_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Brand_Subscription_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Brand_Subscription_Tracking_Sum_Fields>;
  var_pop?: Maybe<Brand_Subscription_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Brand_Subscription_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Brand_Subscription_Tracking_Variance_Fields>;
};


/** aggregate fields of "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Brand_Subscription_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Brand_Subscription_Tracking_Max_Order_By>;
  min?: InputMaybe<Brand_Subscription_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Brand_Subscription_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Brand_Subscription_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Brand_Subscription_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Brand_Subscription_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Brand_Subscription_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Brand_Subscription_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Brand_Subscription_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Brand_Subscription_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Brand_Subscription_Tracking_Avg_Fields = {
  __typename?: 'brand_subscription_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "brand_subscription_tracking". All fields are combined with a logical 'AND'. */
export type Brand_Subscription_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Subscription_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Subscription_Tracking_Bool_Exp>>;
  brand_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_subscription_tracking" */
export enum Brand_Subscription_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  BrandSubscriptionTrackingPkey = 'brand_subscription_tracking_pkey'
}

/** input type for incrementing numeric columns in table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Insert_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Brand_Subscription_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Brand_Subscription_Tracking_Max_Fields = {
  __typename?: 'brand_subscription_tracking_max_fields';
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Max_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Brand_Subscription_Tracking_Min_Fields = {
  __typename?: 'brand_subscription_tracking_min_fields';
  brand_subscription_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Min_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Mutation_Response = {
  __typename?: 'brand_subscription_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Subscription_Tracking>;
};

/** on_conflict condition type for table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_On_Conflict = {
  constraint: Brand_Subscription_Tracking_Constraint;
  update_columns?: Array<Brand_Subscription_Tracking_Update_Column>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_subscription_tracking". */
export type Brand_Subscription_Tracking_Order_By = {
  brand_subscription_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Brand_Subscription_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_subscription_tracking */
export type Brand_Subscription_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "brand_subscription_tracking" */
export enum Brand_Subscription_Tracking_Select_Column {
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "brand_subscription_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "brand_subscription_tracking" */
export enum Brand_Subscription_Tracking_Select_Column_Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "brand_subscription_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "brand_subscription_tracking" */
export enum Brand_Subscription_Tracking_Select_Column_Brand_Subscription_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Set_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status = {
  __typename?: 'brand_subscription_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Aggregate = {
  __typename?: 'brand_subscription_tracking_status_aggregate';
  aggregate?: Maybe<Brand_Subscription_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Brand_Subscription_Tracking_Status>;
};

/** aggregate fields of "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Aggregate_Fields = {
  __typename?: 'brand_subscription_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Brand_Subscription_Tracking_Status_Max_Fields>;
  min?: Maybe<Brand_Subscription_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "brand_subscription_tracking_status". All fields are combined with a logical 'AND'. */
export type Brand_Subscription_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "brand_subscription_tracking_status" */
export enum Brand_Subscription_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  BrandSubscriptionTrackingStatusPkey = 'brand_subscription_tracking_status_pkey'
}

/** input type for inserting data into table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Brand_Subscription_Tracking_Status_Max_Fields = {
  __typename?: 'brand_subscription_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Brand_Subscription_Tracking_Status_Min_Fields = {
  __typename?: 'brand_subscription_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Mutation_Response = {
  __typename?: 'brand_subscription_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Brand_Subscription_Tracking_Status>;
};

/** input type for inserting object relation for remote table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Brand_Subscription_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_On_Conflict = {
  constraint: Brand_Subscription_Tracking_Status_Constraint;
  update_columns?: Array<Brand_Subscription_Tracking_Status_Update_Column>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "brand_subscription_tracking_status". */
export type Brand_Subscription_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: brand_subscription_tracking_status */
export type Brand_Subscription_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "brand_subscription_tracking_status" */
export enum Brand_Subscription_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "brand_subscription_tracking_status" */
export type Brand_Subscription_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Subscription_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Subscription_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "brand_subscription_tracking_status" */
export enum Brand_Subscription_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Brand_Subscription_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Subscription_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Subscription_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Brand_Subscription_Tracking_Stddev_Fields = {
  __typename?: 'brand_subscription_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Brand_Subscription_Tracking_Stddev_Pop_Fields = {
  __typename?: 'brand_subscription_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Brand_Subscription_Tracking_Stddev_Samp_Fields = {
  __typename?: 'brand_subscription_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Brand_Subscription_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Brand_Subscription_Tracking_Stream_Cursor_Value_Input = {
  brand_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Brand_Subscription_Tracking_Sum_Fields = {
  __typename?: 'brand_subscription_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "brand_subscription_tracking" */
export enum Brand_Subscription_Tracking_Update_Column {
  /** column name */
  BrandSubscriptionId = 'brand_subscription_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Brand_Subscription_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Brand_Subscription_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Subscription_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Subscription_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Brand_Subscription_Tracking_Var_Pop_Fields = {
  __typename?: 'brand_subscription_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Brand_Subscription_Tracking_Var_Samp_Fields = {
  __typename?: 'brand_subscription_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Brand_Subscription_Tracking_Variance_Fields = {
  __typename?: 'brand_subscription_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "brand_subscription_tracking" */
export type Brand_Subscription_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "brand_subscription" */
export enum Brand_Subscription_Update_Column {
  /** column name */
  AnalyticsData = 'analytics_data',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CaseSolutionId = 'case_solution_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsProactive = 'is_proactive',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  PaymentFrequency = 'payment_frequency',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tier = 'tier',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserPaymentMethodId = 'user_payment_method_id'
}

export type Brand_Subscription_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Brand_Subscription_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Brand_Subscription_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Brand_Subscription_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Brand_Subscription_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Brand_Subscription_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Subscription_Bool_Exp;
};

/** update columns of table "brand" */
export enum Brand_Update_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiDateOfFirstUse = 'ai_date_of_first_use',
  /** column name */
  AiHighLevelUsage = 'ai_high_level_usage',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DateOfFirstUse = 'date_of_first_use',
  /** column name */
  DateOfFirstUseUpdatedAt = 'date_of_first_use_updated_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  HighLevelUsage = 'high_level_usage',
  /** column name */
  HighLevelUsageUpdatedAt = 'high_level_usage_updated_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  TramaBusinessDescriptionUpdatedAt = 'trama_business_description_updated_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Brand_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Brand_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Brand_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Brand_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Brand_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Brand_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Brand_Set_Input>;
  /** filter the rows which have to be updated */
  where: Brand_Bool_Exp;
};

/** columns and relationships of "case" */
export type Case = {
  __typename?: 'case';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  brand: Brand;
  brand_id: Scalars['uuid']['output'];
  /** An object relationship */
  brand_monitoring_task?: Maybe<Brand_Monitoring_Task>;
  brand_monitoring_task_id?: Maybe<Scalars['uuid']['output']>;
  case_counterparty_id: Scalars['uuid']['output'];
  /** An object relationship */
  counterparty: Case_Counterparty;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  infringements: Array<Case_Infringement>;
  /** An aggregate relationship */
  infringements_aggregate: Case_Infringement_Aggregate;
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  lawyers_note?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  solutions: Array<Case_Solution>;
  /** An aggregate relationship */
  solutions_aggregate: Case_Solution_Aggregate;
  status: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Case_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Case_Tracking_Aggregate;
  /** An object relationship */
  trademark?: Maybe<Trademark>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "case" */
export type CaseDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseInfringementsArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseInfringements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseSolutionsArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseSolutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


/** columns and relationships of "case" */
export type CaseTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};

/** aggregated selection of "case" */
export type Case_Aggregate = {
  __typename?: 'case_aggregate';
  aggregate?: Maybe<Case_Aggregate_Fields>;
  nodes: Array<Case>;
};

export type Case_Aggregate_Bool_Exp = {
  count?: InputMaybe<Case_Aggregate_Bool_Exp_Count>;
};

export type Case_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case" */
export type Case_Aggregate_Fields = {
  __typename?: 'case_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Max_Fields>;
  min?: Maybe<Case_Min_Fields>;
};


/** aggregate fields of "case" */
export type Case_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case" */
export type Case_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Max_Order_By>;
  min?: InputMaybe<Case_Min_Order_By>;
};

/** input type for inserting array relation for remote table "case" */
export type Case_Arr_Rel_Insert_Input = {
  data: Array<Case_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** Boolean expression to filter rows from the table "case". All fields are combined with a logical 'AND'. */
export type Case_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Bool_Exp>>;
  _not?: InputMaybe<Case_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_monitoring_task?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
  brand_monitoring_task_id?: InputMaybe<Uuid_Comparison_Exp>;
  case_counterparty_id?: InputMaybe<Uuid_Comparison_Exp>;
  counterparty?: InputMaybe<Case_Counterparty_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  infringements?: InputMaybe<Case_Infringement_Bool_Exp>;
  infringements_aggregate?: InputMaybe<Case_Infringement_Aggregate_Bool_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  lawyers_note?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  outcome_note?: InputMaybe<String_Comparison_Exp>;
  relevance?: InputMaybe<String_Comparison_Exp>;
  solutions?: InputMaybe<Case_Solution_Bool_Exp>;
  solutions_aggregate?: InputMaybe<Case_Solution_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Case_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Case_Tracking_Aggregate_Bool_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case" */
export enum Case_Constraint {
  /** unique or primary key constraint on columns "note_hub_id" */
  CaseNoteHubIdKey = 'case_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  CasePkey = 'case_pkey'
}

/** columns and relationships of "case_counterparty" */
export type Case_Counterparty = {
  __typename?: 'case_counterparty';
  aliases: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  entity_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  jurisdiction?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  primary_name: Scalars['String']['output'];
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  websites: Scalars['jsonb']['output'];
  whitelisted: Scalars['Boolean']['output'];
};


/** columns and relationships of "case_counterparty" */
export type Case_CounterpartyAliasesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "case_counterparty" */
export type Case_CounterpartyWebsitesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "case_counterparty" */
export type Case_Counterparty_Aggregate = {
  __typename?: 'case_counterparty_aggregate';
  aggregate?: Maybe<Case_Counterparty_Aggregate_Fields>;
  nodes: Array<Case_Counterparty>;
};

/** aggregate fields of "case_counterparty" */
export type Case_Counterparty_Aggregate_Fields = {
  __typename?: 'case_counterparty_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Counterparty_Max_Fields>;
  min?: Maybe<Case_Counterparty_Min_Fields>;
};


/** aggregate fields of "case_counterparty" */
export type Case_Counterparty_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Counterparty_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Case_Counterparty_Append_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "case_counterparty". All fields are combined with a logical 'AND'. */
export type Case_Counterparty_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Counterparty_Bool_Exp>>;
  _not?: InputMaybe<Case_Counterparty_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Counterparty_Bool_Exp>>;
  aliases?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  primary_name?: InputMaybe<String_Comparison_Exp>;
  representative_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  websites?: InputMaybe<Jsonb_Comparison_Exp>;
  whitelisted?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_counterparty" */
export enum Case_Counterparty_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseCounterpartyPkey = 'case_counterparty_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Case_Counterparty_Delete_At_Path_Input = {
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  websites?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Case_Counterparty_Delete_Elem_Input = {
  aliases?: InputMaybe<Scalars['Int']['input']>;
  websites?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Case_Counterparty_Delete_Key_Input = {
  aliases?: InputMaybe<Scalars['String']['input']>;
  websites?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "case_counterparty" */
export type Case_Counterparty_Insert_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primary_name?: InputMaybe<Scalars['String']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
  whitelisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Case_Counterparty_Max_Fields = {
  __typename?: 'case_counterparty_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  primary_name?: Maybe<Scalars['String']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Case_Counterparty_Min_Fields = {
  __typename?: 'case_counterparty_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  entity_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  primary_name?: Maybe<Scalars['String']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "case_counterparty" */
export type Case_Counterparty_Mutation_Response = {
  __typename?: 'case_counterparty_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Counterparty>;
};

/** input type for inserting object relation for remote table "case_counterparty" */
export type Case_Counterparty_Obj_Rel_Insert_Input = {
  data: Case_Counterparty_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Counterparty_On_Conflict>;
};

/** on_conflict condition type for table "case_counterparty" */
export type Case_Counterparty_On_Conflict = {
  constraint: Case_Counterparty_Constraint;
  update_columns?: Array<Case_Counterparty_Update_Column>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};

/** Ordering options when selecting data from "case_counterparty". */
export type Case_Counterparty_Order_By = {
  aliases?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  entity_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  primary_name?: InputMaybe<Order_By>;
  representative_entity_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  websites?: InputMaybe<Order_By>;
  whitelisted?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_counterparty */
export type Case_Counterparty_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Case_Counterparty_Prepend_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "case_counterparty" */
export enum Case_Counterparty_Select_Column {
  /** column name */
  Aliases = 'aliases',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Note = 'note',
  /** column name */
  PrimaryName = 'primary_name',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites',
  /** column name */
  Whitelisted = 'whitelisted'
}

/** input type for updating data in table "case_counterparty" */
export type Case_Counterparty_Set_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primary_name?: InputMaybe<Scalars['String']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
  whitelisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "case_counterparty" */
export type Case_Counterparty_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Counterparty_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Counterparty_Stream_Cursor_Value_Input = {
  aliases?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  entity_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  primary_name?: InputMaybe<Scalars['String']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
  whitelisted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "case_counterparty" */
export enum Case_Counterparty_Update_Column {
  /** column name */
  Aliases = 'aliases',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  EntityId = 'entity_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Note = 'note',
  /** column name */
  PrimaryName = 'primary_name',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Websites = 'websites',
  /** column name */
  Whitelisted = 'whitelisted'
}

export type Case_Counterparty_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Case_Counterparty_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Case_Counterparty_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Case_Counterparty_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Case_Counterparty_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Case_Counterparty_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Counterparty_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Counterparty_Bool_Exp;
};

/** columns and relationships of "case_infringement" */
export type Case_Infringement = {
  __typename?: 'case_infringement';
  /** An object relationship */
  case: Case;
  case_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  /** An array relationship */
  evidences: Array<Case_Infringement_Evidence>;
  /** An aggregate relationship */
  evidences_aggregate: Case_Infringement_Evidence_Aggregate;
  id: Scalars['uuid']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "case_infringement" */
export type Case_InfringementEvidencesArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


/** columns and relationships of "case_infringement" */
export type Case_InfringementEvidences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};

/** aggregated selection of "case_infringement" */
export type Case_Infringement_Aggregate = {
  __typename?: 'case_infringement_aggregate';
  aggregate?: Maybe<Case_Infringement_Aggregate_Fields>;
  nodes: Array<Case_Infringement>;
};

export type Case_Infringement_Aggregate_Bool_Exp = {
  count?: InputMaybe<Case_Infringement_Aggregate_Bool_Exp_Count>;
};

export type Case_Infringement_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Infringement_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case_infringement" */
export type Case_Infringement_Aggregate_Fields = {
  __typename?: 'case_infringement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Infringement_Max_Fields>;
  min?: Maybe<Case_Infringement_Min_Fields>;
};


/** aggregate fields of "case_infringement" */
export type Case_Infringement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case_infringement" */
export type Case_Infringement_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Infringement_Max_Order_By>;
  min?: InputMaybe<Case_Infringement_Min_Order_By>;
};

/** input type for inserting array relation for remote table "case_infringement" */
export type Case_Infringement_Arr_Rel_Insert_Input = {
  data: Array<Case_Infringement_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Infringement_On_Conflict>;
};

/** Boolean expression to filter rows from the table "case_infringement". All fields are combined with a logical 'AND'. */
export type Case_Infringement_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Infringement_Bool_Exp>>;
  _not?: InputMaybe<Case_Infringement_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Infringement_Bool_Exp>>;
  case?: InputMaybe<Case_Bool_Exp>;
  case_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  evidences?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
  evidences_aggregate?: InputMaybe<Case_Infringement_Evidence_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_infringement" */
export enum Case_Infringement_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseInfringementPkey = 'case_infringement_pkey'
}

/** columns and relationships of "case_infringement_evidence" */
export type Case_Infringement_Evidence = {
  __typename?: 'case_infringement_evidence';
  case_infringement_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  description?: Maybe<Scalars['String']['output']>;
  document_folder_id: Scalars['uuid']['output'];
  evidence_date: Scalars['date']['output'];
  /** An object relationship */
  external_trademark?: Maybe<External_Trademark>;
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "case_infringement_evidence" */
export type Case_Infringement_Evidence_Aggregate = {
  __typename?: 'case_infringement_evidence_aggregate';
  aggregate?: Maybe<Case_Infringement_Evidence_Aggregate_Fields>;
  nodes: Array<Case_Infringement_Evidence>;
};

export type Case_Infringement_Evidence_Aggregate_Bool_Exp = {
  count?: InputMaybe<Case_Infringement_Evidence_Aggregate_Bool_Exp_Count>;
};

export type Case_Infringement_Evidence_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case_infringement_evidence" */
export type Case_Infringement_Evidence_Aggregate_Fields = {
  __typename?: 'case_infringement_evidence_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Infringement_Evidence_Max_Fields>;
  min?: Maybe<Case_Infringement_Evidence_Min_Fields>;
};


/** aggregate fields of "case_infringement_evidence" */
export type Case_Infringement_Evidence_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Infringement_Evidence_Max_Order_By>;
  min?: InputMaybe<Case_Infringement_Evidence_Min_Order_By>;
};

/** input type for inserting array relation for remote table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Arr_Rel_Insert_Input = {
  data: Array<Case_Infringement_Evidence_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Infringement_Evidence_On_Conflict>;
};

/** Boolean expression to filter rows from the table "case_infringement_evidence". All fields are combined with a logical 'AND'. */
export type Case_Infringement_Evidence_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Infringement_Evidence_Bool_Exp>>;
  _not?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Infringement_Evidence_Bool_Exp>>;
  case_infringement_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  evidence_date?: InputMaybe<Date_Comparison_Exp>;
  external_trademark?: InputMaybe<External_Trademark_Bool_Exp>;
  external_trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_infringement_evidence" */
export enum Case_Infringement_Evidence_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseInfringementEvidencePkey = 'case_infringement_evidence_pkey'
}

/** input type for inserting data into table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Insert_Input = {
  case_infringement_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence_date?: InputMaybe<Scalars['date']['input']>;
  external_trademark?: InputMaybe<External_Trademark_Obj_Rel_Insert_Input>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Case_Infringement_Evidence_Max_Fields = {
  __typename?: 'case_infringement_evidence_max_fields';
  case_infringement_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  evidence_date?: Maybe<Scalars['date']['output']>;
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Max_Order_By = {
  case_infringement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  evidence_date?: InputMaybe<Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Infringement_Evidence_Min_Fields = {
  __typename?: 'case_infringement_evidence_min_fields';
  case_infringement_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  evidence_date?: Maybe<Scalars['date']['output']>;
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Min_Order_By = {
  case_infringement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  evidence_date?: InputMaybe<Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Mutation_Response = {
  __typename?: 'case_infringement_evidence_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Infringement_Evidence>;
};

/** on_conflict condition type for table "case_infringement_evidence" */
export type Case_Infringement_Evidence_On_Conflict = {
  constraint: Case_Infringement_Evidence_Constraint;
  update_columns?: Array<Case_Infringement_Evidence_Update_Column>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};

/** Ordering options when selecting data from "case_infringement_evidence". */
export type Case_Infringement_Evidence_Order_By = {
  case_infringement_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  evidence_date?: InputMaybe<Order_By>;
  external_trademark?: InputMaybe<External_Trademark_Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_infringement_evidence */
export type Case_Infringement_Evidence_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "case_infringement_evidence" */
export enum Case_Infringement_Evidence_Select_Column {
  /** column name */
  CaseInfringementId = 'case_infringement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  EvidenceDate = 'evidence_date',
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Set_Input = {
  case_infringement_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence_date?: InputMaybe<Scalars['date']['input']>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "case_infringement_evidence" */
export type Case_Infringement_Evidence_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Infringement_Evidence_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Infringement_Evidence_Stream_Cursor_Value_Input = {
  case_infringement_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  evidence_date?: InputMaybe<Scalars['date']['input']>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "case_infringement_evidence" */
export enum Case_Infringement_Evidence_Update_Column {
  /** column name */
  CaseInfringementId = 'case_infringement_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  EvidenceDate = 'evidence_date',
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Website = 'website'
}

export type Case_Infringement_Evidence_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Infringement_Evidence_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Infringement_Evidence_Bool_Exp;
};

/** input type for inserting data into table "case_infringement" */
export type Case_Infringement_Insert_Input = {
  case?: InputMaybe<Case_Obj_Rel_Insert_Input>;
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  evidences?: InputMaybe<Case_Infringement_Evidence_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Infringement_Max_Fields = {
  __typename?: 'case_infringement_max_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "case_infringement" */
export type Case_Infringement_Max_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Infringement_Min_Fields = {
  __typename?: 'case_infringement_min_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "case_infringement" */
export type Case_Infringement_Min_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case_infringement" */
export type Case_Infringement_Mutation_Response = {
  __typename?: 'case_infringement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Infringement>;
};

/** on_conflict condition type for table "case_infringement" */
export type Case_Infringement_On_Conflict = {
  constraint: Case_Infringement_Constraint;
  update_columns?: Array<Case_Infringement_Update_Column>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};

/** Ordering options when selecting data from "case_infringement". */
export type Case_Infringement_Order_By = {
  case?: InputMaybe<Case_Order_By>;
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  evidences_aggregate?: InputMaybe<Case_Infringement_Evidence_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_infringement */
export type Case_Infringement_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "case_infringement" */
export enum Case_Infringement_Select_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "case_infringement" */
export type Case_Infringement_Set_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "case_infringement" */
export type Case_Infringement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Infringement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Infringement_Stream_Cursor_Value_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "case_infringement" */
export enum Case_Infringement_Update_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Case_Infringement_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Infringement_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Infringement_Bool_Exp;
};

/** input type for inserting data into table "case" */
export type Case_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_monitoring_task?: InputMaybe<Brand_Monitoring_Task_Obj_Rel_Insert_Input>;
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  case_counterparty_id?: InputMaybe<Scalars['uuid']['input']>;
  counterparty?: InputMaybe<Case_Counterparty_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  infringements?: InputMaybe<Case_Infringement_Arr_Rel_Insert_Input>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyers_note?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  solutions?: InputMaybe<Case_Solution_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Case_Tracking_Arr_Rel_Insert_Input>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Max_Fields = {
  __typename?: 'case_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_monitoring_task_id?: Maybe<Scalars['uuid']['output']>;
  case_counterparty_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  lawyers_note?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "case" */
export type Case_Max_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  case_counterparty_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  lawyers_note?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Min_Fields = {
  __typename?: 'case_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_monitoring_task_id?: Maybe<Scalars['uuid']['output']>;
  case_counterparty_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  lawyers_note?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "case" */
export type Case_Min_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  case_counterparty_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  lawyers_note?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case" */
export type Case_Mutation_Response = {
  __typename?: 'case_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case>;
};

/** input type for inserting object relation for remote table "case" */
export type Case_Obj_Rel_Insert_Input = {
  data: Case_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_On_Conflict>;
};

/** on_conflict condition type for table "case" */
export type Case_On_Conflict = {
  constraint: Case_Constraint;
  update_columns?: Array<Case_Update_Column>;
  where?: InputMaybe<Case_Bool_Exp>;
};

/** Ordering options when selecting data from "case". */
export type Case_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_monitoring_task?: InputMaybe<Brand_Monitoring_Task_Order_By>;
  brand_monitoring_task_id?: InputMaybe<Order_By>;
  case_counterparty_id?: InputMaybe<Order_By>;
  counterparty?: InputMaybe<Case_Counterparty_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  infringements_aggregate?: InputMaybe<Case_Infringement_Aggregate_Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  lawyers_note?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  solutions_aggregate?: InputMaybe<Case_Solution_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Case_Tracking_Aggregate_Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case */
export type Case_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "case_request" */
export type Case_Request = {
  __typename?: 'case_request';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_website?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  case?: Maybe<Case>;
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['uuid']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  links: Scalars['jsonb']['output'];
  message?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  status: Scalars['case_request_status']['output'];
  /** An array relationship */
  tracking_actions: Array<Case_Request_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Case_Request_Tracking_Aggregate;
  type: Scalars['case_request_type']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user: User;
  updated_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "case_request" */
export type Case_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "case_request" */
export type Case_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "case_request" */
export type Case_RequestLinksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "case_request" */
export type Case_RequestTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "case_request" */
export type Case_RequestTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};

/** aggregated selection of "case_request" */
export type Case_Request_Aggregate = {
  __typename?: 'case_request_aggregate';
  aggregate?: Maybe<Case_Request_Aggregate_Fields>;
  nodes: Array<Case_Request>;
};

/** aggregate fields of "case_request" */
export type Case_Request_Aggregate_Fields = {
  __typename?: 'case_request_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Request_Max_Fields>;
  min?: Maybe<Case_Request_Min_Fields>;
};


/** aggregate fields of "case_request" */
export type Case_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Case_Request_Append_Input = {
  links?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "case_request". All fields are combined with a logical 'AND'. */
export type Case_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Request_Bool_Exp>>;
  _not?: InputMaybe<Case_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Request_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_website?: InputMaybe<String_Comparison_Exp>;
  case?: InputMaybe<Case_Bool_Exp>;
  case_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dismiss_reason?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  links?: InputMaybe<Jsonb_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Case_Request_Status_Comparison_Exp>;
  tracking_actions?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Case_Request_Tracking_Aggregate_Bool_Exp>;
  type?: InputMaybe<Case_Request_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_request" */
export enum Case_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseRequestPkey = 'case_request_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Case_Request_Delete_At_Path_Input = {
  links?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Case_Request_Delete_Elem_Input = {
  links?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Case_Request_Delete_Key_Input = {
  links?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "case_request" */
export type Case_Request_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_website?: InputMaybe<Scalars['String']['input']>;
  case?: InputMaybe<Case_Obj_Rel_Insert_Input>;
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dismiss_reason?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['case_request_status']['input']>;
  tracking_actions?: InputMaybe<Case_Request_Tracking_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['case_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Request_Max_Fields = {
  __typename?: 'case_request_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_website?: Maybe<Scalars['String']['output']>;
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['case_request_status']['output']>;
  type?: Maybe<Scalars['case_request_type']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Case_Request_Min_Fields = {
  __typename?: 'case_request_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_website?: Maybe<Scalars['String']['output']>;
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['case_request_status']['output']>;
  type?: Maybe<Scalars['case_request_type']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "case_request" */
export type Case_Request_Mutation_Response = {
  __typename?: 'case_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Request>;
};

/** on_conflict condition type for table "case_request" */
export type Case_Request_On_Conflict = {
  constraint: Case_Request_Constraint;
  update_columns?: Array<Case_Request_Update_Column>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "case_request". */
export type Case_Request_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_website?: InputMaybe<Order_By>;
  case?: InputMaybe<Case_Order_By>;
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dismiss_reason?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  links?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Case_Request_Tracking_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_request */
export type Case_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Case_Request_Prepend_Input = {
  links?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "case_request" */
export enum Case_Request_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandWebsite = 'brand_website',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DismissReason = 'dismiss_reason',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  Links = 'links',
  /** column name */
  Message = 'message',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "case_request" */
export type Case_Request_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_website?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dismiss_reason?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['case_request_status']['input']>;
  type?: InputMaybe<Scalars['case_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "case_request_status". All fields are combined with logical 'AND'. */
export type Case_Request_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['case_request_status']['input']>;
  _gt?: InputMaybe<Scalars['case_request_status']['input']>;
  _gte?: InputMaybe<Scalars['case_request_status']['input']>;
  _in?: InputMaybe<Array<Scalars['case_request_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['case_request_status']['input']>;
  _lte?: InputMaybe<Scalars['case_request_status']['input']>;
  _neq?: InputMaybe<Scalars['case_request_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['case_request_status']['input']>>;
};

/** Streaming cursor of the table "case_request" */
export type Case_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Request_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_website?: InputMaybe<Scalars['String']['input']>;
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dismiss_reason?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  links?: InputMaybe<Scalars['jsonb']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['case_request_status']['input']>;
  type?: InputMaybe<Scalars['case_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "case_request_tracking" */
export type Case_Request_Tracking = {
  __typename?: 'case_request_tracking';
  case_request_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['case_request_status']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Case_Request_Tracking_Status;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "case_request_tracking" */
export type Case_Request_Tracking_Aggregate = {
  __typename?: 'case_request_tracking_aggregate';
  aggregate?: Maybe<Case_Request_Tracking_Aggregate_Fields>;
  nodes: Array<Case_Request_Tracking>;
};

export type Case_Request_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Case_Request_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Case_Request_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Case_Request_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Case_Request_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Case_Request_Tracking_Select_Column_Case_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Request_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Case_Request_Tracking_Select_Column_Case_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Request_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case_request_tracking" */
export type Case_Request_Tracking_Aggregate_Fields = {
  __typename?: 'case_request_tracking_aggregate_fields';
  avg?: Maybe<Case_Request_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Request_Tracking_Max_Fields>;
  min?: Maybe<Case_Request_Tracking_Min_Fields>;
  stddev?: Maybe<Case_Request_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Case_Request_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Case_Request_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Case_Request_Tracking_Sum_Fields>;
  var_pop?: Maybe<Case_Request_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Case_Request_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Case_Request_Tracking_Variance_Fields>;
};


/** aggregate fields of "case_request_tracking" */
export type Case_Request_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case_request_tracking" */
export type Case_Request_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Case_Request_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Request_Tracking_Max_Order_By>;
  min?: InputMaybe<Case_Request_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Case_Request_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Case_Request_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Case_Request_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Case_Request_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Case_Request_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Case_Request_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Case_Request_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "case_request_tracking" */
export type Case_Request_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Case_Request_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Request_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Case_Request_Tracking_Avg_Fields = {
  __typename?: 'case_request_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "case_request_tracking". All fields are combined with a logical 'AND'. */
export type Case_Request_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Request_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Request_Tracking_Bool_Exp>>;
  case_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<Case_Request_Status_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_request_tracking" */
export enum Case_Request_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseRequestTrackingPkey = 'case_request_tracking_pkey'
}

/** input type for incrementing numeric columns in table "case_request_tracking" */
export type Case_Request_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "case_request_tracking" */
export type Case_Request_Tracking_Insert_Input = {
  case_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Case_Request_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Request_Tracking_Max_Fields = {
  __typename?: 'case_request_tracking_max_fields';
  case_request_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['case_request_status']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Max_Order_By = {
  case_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Request_Tracking_Min_Fields = {
  __typename?: 'case_request_tracking_min_fields';
  case_request_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['case_request_status']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Min_Order_By = {
  case_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case_request_tracking" */
export type Case_Request_Tracking_Mutation_Response = {
  __typename?: 'case_request_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Request_Tracking>;
};

/** on_conflict condition type for table "case_request_tracking" */
export type Case_Request_Tracking_On_Conflict = {
  constraint: Case_Request_Tracking_Constraint;
  update_columns?: Array<Case_Request_Tracking_Update_Column>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "case_request_tracking". */
export type Case_Request_Tracking_Order_By = {
  case_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Case_Request_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_request_tracking */
export type Case_Request_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "case_request_tracking" */
export enum Case_Request_Tracking_Select_Column {
  /** column name */
  CaseRequestId = 'case_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "case_request_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "case_request_tracking" */
export enum Case_Request_Tracking_Select_Column_Case_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "case_request_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "case_request_tracking" */
export enum Case_Request_Tracking_Select_Column_Case_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "case_request_tracking" */
export type Case_Request_Tracking_Set_Input = {
  case_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "case_request_tracking_status" */
export type Case_Request_Tracking_Status = {
  __typename?: 'case_request_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['case_request_status']['output'];
};

/** aggregated selection of "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Aggregate = {
  __typename?: 'case_request_tracking_status_aggregate';
  aggregate?: Maybe<Case_Request_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Case_Request_Tracking_Status>;
};

/** aggregate fields of "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Aggregate_Fields = {
  __typename?: 'case_request_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Request_Tracking_Status_Max_Fields>;
  min?: Maybe<Case_Request_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Request_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "case_request_tracking_status". All fields are combined with a logical 'AND'. */
export type Case_Request_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Request_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Request_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<Case_Request_Status_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_request_tracking_status" */
export enum Case_Request_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  CaseRequestTrackingStatusPkey = 'case_request_tracking_status_pkey'
}

/** input type for inserting data into table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
};

/** aggregate max on columns */
export type Case_Request_Tracking_Status_Max_Fields = {
  __typename?: 'case_request_tracking_status_max_fields';
  name?: Maybe<Scalars['case_request_status']['output']>;
};

/** aggregate min on columns */
export type Case_Request_Tracking_Status_Min_Fields = {
  __typename?: 'case_request_tracking_status_min_fields';
  name?: Maybe<Scalars['case_request_status']['output']>;
};

/** response of any mutation on the table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Mutation_Response = {
  __typename?: 'case_request_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Request_Tracking_Status>;
};

/** input type for inserting object relation for remote table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Case_Request_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Request_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_On_Conflict = {
  constraint: Case_Request_Tracking_Status_Constraint;
  update_columns?: Array<Case_Request_Tracking_Status_Update_Column>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "case_request_tracking_status". */
export type Case_Request_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_request_tracking_status */
export type Case_Request_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['case_request_status']['input'];
};

/** select columns of table "case_request_tracking_status" */
export enum Case_Request_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
};

/** Streaming cursor of the table "case_request_tracking_status" */
export type Case_Request_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Request_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Request_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
};

/** update columns of table "case_request_tracking_status" */
export enum Case_Request_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Case_Request_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Request_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Request_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Case_Request_Tracking_Stddev_Fields = {
  __typename?: 'case_request_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Case_Request_Tracking_Stddev_Pop_Fields = {
  __typename?: 'case_request_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Case_Request_Tracking_Stddev_Samp_Fields = {
  __typename?: 'case_request_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "case_request_tracking" */
export type Case_Request_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Request_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Request_Tracking_Stream_Cursor_Value_Input = {
  case_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['case_request_status']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Case_Request_Tracking_Sum_Fields = {
  __typename?: 'case_request_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "case_request_tracking" */
export enum Case_Request_Tracking_Update_Column {
  /** column name */
  CaseRequestId = 'case_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Case_Request_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Case_Request_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Request_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Request_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Case_Request_Tracking_Var_Pop_Fields = {
  __typename?: 'case_request_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Case_Request_Tracking_Var_Samp_Fields = {
  __typename?: 'case_request_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Case_Request_Tracking_Variance_Fields = {
  __typename?: 'case_request_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "case_request_tracking" */
export type Case_Request_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "case_request_type". All fields are combined with logical 'AND'. */
export type Case_Request_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['case_request_type']['input']>;
  _gt?: InputMaybe<Scalars['case_request_type']['input']>;
  _gte?: InputMaybe<Scalars['case_request_type']['input']>;
  _in?: InputMaybe<Array<Scalars['case_request_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['case_request_type']['input']>;
  _lte?: InputMaybe<Scalars['case_request_type']['input']>;
  _neq?: InputMaybe<Scalars['case_request_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['case_request_type']['input']>>;
};

/** update columns of table "case_request" */
export enum Case_Request_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandWebsite = 'brand_website',
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DismissReason = 'dismiss_reason',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  Links = 'links',
  /** column name */
  Message = 'message',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Case_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Case_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Case_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Case_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Case_Request_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Case_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Request_Bool_Exp;
};

/** select columns of table "case" */
export enum Case_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandMonitoringTaskId = 'brand_monitoring_task_id',
  /** column name */
  CaseCounterpartyId = 'case_counterparty_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LawyersNote = 'lawyers_note',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeNote = 'outcome_note',
  /** column name */
  Relevance = 'relevance',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "case" */
export type Case_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  case_counterparty_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyers_note?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "case_solution" */
export type Case_Solution = {
  __typename?: 'case_solution';
  /** An object relationship */
  case: Case;
  case_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  items: Scalars['jsonb']['output'];
  offer_subscription: Scalars['Boolean']['output'];
  offer_watchlist: Scalars['Boolean']['output'];
  /** An object relationship */
  order?: Maybe<Service_Request>;
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  services: Array<Service>;
  /** An aggregate relationship */
  services_aggregate: Service_Aggregate;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "case_solution" */
export type Case_SolutionItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "case_solution" */
export type Case_SolutionServicesArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


/** columns and relationships of "case_solution" */
export type Case_SolutionServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};

/** aggregated selection of "case_solution" */
export type Case_Solution_Aggregate = {
  __typename?: 'case_solution_aggregate';
  aggregate?: Maybe<Case_Solution_Aggregate_Fields>;
  nodes: Array<Case_Solution>;
};

export type Case_Solution_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Case_Solution_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Case_Solution_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Case_Solution_Aggregate_Bool_Exp_Count>;
};

export type Case_Solution_Aggregate_Bool_Exp_Bool_And = {
  arguments: Case_Solution_Select_Column_Case_Solution_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Solution_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Solution_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Case_Solution_Select_Column_Case_Solution_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Solution_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Solution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Solution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Solution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case_solution" */
export type Case_Solution_Aggregate_Fields = {
  __typename?: 'case_solution_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Solution_Max_Fields>;
  min?: Maybe<Case_Solution_Min_Fields>;
};


/** aggregate fields of "case_solution" */
export type Case_Solution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Solution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case_solution" */
export type Case_Solution_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Solution_Max_Order_By>;
  min?: InputMaybe<Case_Solution_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Case_Solution_Append_Input = {
  items?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "case_solution" */
export type Case_Solution_Arr_Rel_Insert_Input = {
  data: Array<Case_Solution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Solution_On_Conflict>;
};

/** Boolean expression to filter rows from the table "case_solution". All fields are combined with a logical 'AND'. */
export type Case_Solution_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Solution_Bool_Exp>>;
  _not?: InputMaybe<Case_Solution_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Solution_Bool_Exp>>;
  case?: InputMaybe<Case_Bool_Exp>;
  case_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  items?: InputMaybe<Jsonb_Comparison_Exp>;
  offer_subscription?: InputMaybe<Boolean_Comparison_Exp>;
  offer_watchlist?: InputMaybe<Boolean_Comparison_Exp>;
  order?: InputMaybe<Service_Request_Bool_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  services?: InputMaybe<Service_Bool_Exp>;
  services_aggregate?: InputMaybe<Service_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_solution" */
export enum Case_Solution_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseSolutionPkey = 'case_solution_pkey',
  /** unique or primary key constraint on columns "quote_hub_id" */
  CaseSolutionQuoteHubIdKey = 'case_solution_quote_hub_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Case_Solution_Delete_At_Path_Input = {
  items?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Case_Solution_Delete_Elem_Input = {
  items?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Case_Solution_Delete_Key_Input = {
  items?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "case_solution" */
export type Case_Solution_Insert_Input = {
  case?: InputMaybe<Case_Obj_Rel_Insert_Input>;
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  offer_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  offer_watchlist?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Service_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Solution_Max_Fields = {
  __typename?: 'case_solution_max_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "case_solution" */
export type Case_Solution_Max_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Solution_Min_Fields = {
  __typename?: 'case_solution_min_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "case_solution" */
export type Case_Solution_Min_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case_solution" */
export type Case_Solution_Mutation_Response = {
  __typename?: 'case_solution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Solution>;
};

/** input type for inserting object relation for remote table "case_solution" */
export type Case_Solution_Obj_Rel_Insert_Input = {
  data: Case_Solution_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Solution_On_Conflict>;
};

/** on_conflict condition type for table "case_solution" */
export type Case_Solution_On_Conflict = {
  constraint: Case_Solution_Constraint;
  update_columns?: Array<Case_Solution_Update_Column>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};

/** Ordering options when selecting data from "case_solution". */
export type Case_Solution_Order_By = {
  case?: InputMaybe<Case_Order_By>;
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  items?: InputMaybe<Order_By>;
  offer_subscription?: InputMaybe<Order_By>;
  offer_watchlist?: InputMaybe<Order_By>;
  order?: InputMaybe<Service_Request_Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  services_aggregate?: InputMaybe<Service_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_solution */
export type Case_Solution_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Case_Solution_Prepend_Input = {
  items?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "case_solution" */
export enum Case_Solution_Select_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Items = 'items',
  /** column name */
  OfferSubscription = 'offer_subscription',
  /** column name */
  OfferWatchlist = 'offer_watchlist',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** select "case_solution_aggregate_bool_exp_bool_and_arguments_columns" columns of table "case_solution" */
export enum Case_Solution_Select_Column_Case_Solution_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  OfferSubscription = 'offer_subscription',
  /** column name */
  OfferWatchlist = 'offer_watchlist'
}

/** select "case_solution_aggregate_bool_exp_bool_or_arguments_columns" columns of table "case_solution" */
export enum Case_Solution_Select_Column_Case_Solution_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  OfferSubscription = 'offer_subscription',
  /** column name */
  OfferWatchlist = 'offer_watchlist'
}

/** input type for updating data in table "case_solution" */
export type Case_Solution_Set_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  offer_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  offer_watchlist?: InputMaybe<Scalars['Boolean']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "case_solution" */
export type Case_Solution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Solution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Solution_Stream_Cursor_Value_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  offer_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  offer_watchlist?: InputMaybe<Scalars['Boolean']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "case_solution" */
export enum Case_Solution_Update_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Items = 'items',
  /** column name */
  OfferSubscription = 'offer_subscription',
  /** column name */
  OfferWatchlist = 'offer_watchlist',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Case_Solution_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Case_Solution_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Case_Solution_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Case_Solution_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Case_Solution_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Case_Solution_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Solution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Solution_Bool_Exp;
};

/** Streaming cursor of the table "case" */
export type Case_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_monitoring_task_id?: InputMaybe<Scalars['uuid']['input']>;
  case_counterparty_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyers_note?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "case_tracking" */
export type Case_Tracking = {
  __typename?: 'case_tracking';
  case_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Case_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "case_tracking" */
export type Case_Tracking_Aggregate = {
  __typename?: 'case_tracking_aggregate';
  aggregate?: Maybe<Case_Tracking_Aggregate_Fields>;
  nodes: Array<Case_Tracking>;
};

export type Case_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Case_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Case_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Case_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Case_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Case_Tracking_Select_Column_Case_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Case_Tracking_Select_Column_Case_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Case_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case_tracking" */
export type Case_Tracking_Aggregate_Fields = {
  __typename?: 'case_tracking_aggregate_fields';
  avg?: Maybe<Case_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Tracking_Max_Fields>;
  min?: Maybe<Case_Tracking_Min_Fields>;
  stddev?: Maybe<Case_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Case_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Case_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Case_Tracking_Sum_Fields>;
  var_pop?: Maybe<Case_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Case_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Case_Tracking_Variance_Fields>;
};


/** aggregate fields of "case_tracking" */
export type Case_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "case_tracking" */
export type Case_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Case_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Tracking_Max_Order_By>;
  min?: InputMaybe<Case_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Case_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Case_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Case_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Case_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Case_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Case_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Case_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "case_tracking" */
export type Case_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Case_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Case_Tracking_Avg_Fields = {
  __typename?: 'case_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "case_tracking" */
export type Case_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "case_tracking". All fields are combined with a logical 'AND'. */
export type Case_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Case_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Tracking_Bool_Exp>>;
  case_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_tracking" */
export enum Case_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  CaseTrackingPkey = 'case_tracking_pkey'
}

/** input type for incrementing numeric columns in table "case_tracking" */
export type Case_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "case_tracking" */
export type Case_Tracking_Insert_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Case_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Case_Tracking_Max_Fields = {
  __typename?: 'case_tracking_max_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "case_tracking" */
export type Case_Tracking_Max_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Tracking_Min_Fields = {
  __typename?: 'case_tracking_min_fields';
  case_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "case_tracking" */
export type Case_Tracking_Min_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "case_tracking" */
export type Case_Tracking_Mutation_Response = {
  __typename?: 'case_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Tracking>;
};

/** on_conflict condition type for table "case_tracking" */
export type Case_Tracking_On_Conflict = {
  constraint: Case_Tracking_Constraint;
  update_columns?: Array<Case_Tracking_Update_Column>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "case_tracking". */
export type Case_Tracking_Order_By = {
  case_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Case_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_tracking */
export type Case_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "case_tracking" */
export enum Case_Tracking_Select_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "case_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "case_tracking" */
export enum Case_Tracking_Select_Column_Case_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "case_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "case_tracking" */
export enum Case_Tracking_Select_Column_Case_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "case_tracking" */
export type Case_Tracking_Set_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "case_tracking_status" */
export type Case_Tracking_Status = {
  __typename?: 'case_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "case_tracking_status" */
export type Case_Tracking_Status_Aggregate = {
  __typename?: 'case_tracking_status_aggregate';
  aggregate?: Maybe<Case_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Case_Tracking_Status>;
};

/** aggregate fields of "case_tracking_status" */
export type Case_Tracking_Status_Aggregate_Fields = {
  __typename?: 'case_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Case_Tracking_Status_Max_Fields>;
  min?: Maybe<Case_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "case_tracking_status" */
export type Case_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "case_tracking_status". All fields are combined with a logical 'AND'. */
export type Case_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "case_tracking_status" */
export enum Case_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  CaseTrackingStatusPkey = 'case_tracking_status_pkey'
}

/** input type for inserting data into table "case_tracking_status" */
export type Case_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Case_Tracking_Status_Max_Fields = {
  __typename?: 'case_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Case_Tracking_Status_Min_Fields = {
  __typename?: 'case_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "case_tracking_status" */
export type Case_Tracking_Status_Mutation_Response = {
  __typename?: 'case_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Case_Tracking_Status>;
};

/** input type for inserting object relation for remote table "case_tracking_status" */
export type Case_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Case_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Case_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "case_tracking_status" */
export type Case_Tracking_Status_On_Conflict = {
  constraint: Case_Tracking_Status_Constraint;
  update_columns?: Array<Case_Tracking_Status_Update_Column>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "case_tracking_status". */
export type Case_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: case_tracking_status */
export type Case_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "case_tracking_status" */
export enum Case_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "case_tracking_status" */
export type Case_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "case_tracking_status" */
export type Case_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "case_tracking_status" */
export enum Case_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Case_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Case_Tracking_Stddev_Fields = {
  __typename?: 'case_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "case_tracking" */
export type Case_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Case_Tracking_Stddev_Pop_Fields = {
  __typename?: 'case_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "case_tracking" */
export type Case_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Case_Tracking_Stddev_Samp_Fields = {
  __typename?: 'case_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "case_tracking" */
export type Case_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "case_tracking" */
export type Case_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Tracking_Stream_Cursor_Value_Input = {
  case_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Case_Tracking_Sum_Fields = {
  __typename?: 'case_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "case_tracking" */
export type Case_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "case_tracking" */
export enum Case_Tracking_Update_Column {
  /** column name */
  CaseId = 'case_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Case_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Case_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Case_Tracking_Var_Pop_Fields = {
  __typename?: 'case_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "case_tracking" */
export type Case_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Case_Tracking_Var_Samp_Fields = {
  __typename?: 'case_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "case_tracking" */
export type Case_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Case_Tracking_Variance_Fields = {
  __typename?: 'case_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "case_tracking" */
export type Case_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "case" */
export enum Case_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandMonitoringTaskId = 'brand_monitoring_task_id',
  /** column name */
  CaseCounterpartyId = 'case_counterparty_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LawyersNote = 'lawyers_note',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeNote = 'outcome_note',
  /** column name */
  Relevance = 'relevance',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Case_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Case_Set_Input>;
  /** filter the rows which have to be updated */
  where: Case_Bool_Exp;
};

/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type Consultation = {
  __typename?: 'consultation';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  calendly_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  event_timestamp: Scalars['timestamptz']['output'];
  fathom_recording_url?: Maybe<Scalars['String']['output']>;
  fathom_summary?: Maybe<Scalars['String']['output']>;
  fathom_transcript?: Maybe<Scalars['jsonb']['output']>;
  google_meet_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  location?: Maybe<Scalars['jsonb']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  outcome?: Maybe<Scalars['String']['output']>;
  questions_and_answers: Scalars['jsonb']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationFathom_TranscriptArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationLocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** Consultation we did with our clients done by phone, reserved usually by calendly */
export type ConsultationQuestions_And_AnswersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "consultation" */
export type Consultation_Aggregate = {
  __typename?: 'consultation_aggregate';
  aggregate?: Maybe<Consultation_Aggregate_Fields>;
  nodes: Array<Consultation>;
};

/** aggregate fields of "consultation" */
export type Consultation_Aggregate_Fields = {
  __typename?: 'consultation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Consultation_Max_Fields>;
  min?: Maybe<Consultation_Min_Fields>;
};


/** aggregate fields of "consultation" */
export type Consultation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consultation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Consultation_Append_Input = {
  fathom_transcript?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  questions_and_answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "consultation". All fields are combined with a logical 'AND'. */
export type Consultation_Bool_Exp = {
  _and?: InputMaybe<Array<Consultation_Bool_Exp>>;
  _not?: InputMaybe<Consultation_Bool_Exp>;
  _or?: InputMaybe<Array<Consultation_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  calendly_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  event_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  fathom_recording_url?: InputMaybe<String_Comparison_Exp>;
  fathom_summary?: InputMaybe<String_Comparison_Exp>;
  fathom_transcript?: InputMaybe<Jsonb_Comparison_Exp>;
  google_meet_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  questions_and_answers?: InputMaybe<Jsonb_Comparison_Exp>;
  resolution?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "consultation" */
export enum Consultation_Constraint {
  /** unique or primary key constraint on columns "calendly_id" */
  ConsultationCalendlyIdKey = 'consultation_calendly_id_key',
  /** unique or primary key constraint on columns "note_hub_id" */
  ConsultationNoteHubIdKey = 'consultation_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  ConsultationPkey = 'consultation_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Consultation_Delete_At_Path_Input = {
  fathom_transcript?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  questions_and_answers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Consultation_Delete_Elem_Input = {
  fathom_transcript?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['Int']['input']>;
  questions_and_answers?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Consultation_Delete_Key_Input = {
  fathom_transcript?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  questions_and_answers?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "consultation" */
export type Consultation_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  calendly_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  event_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  fathom_recording_url?: InputMaybe<Scalars['String']['input']>;
  fathom_summary?: InputMaybe<Scalars['String']['input']>;
  fathom_transcript?: InputMaybe<Scalars['jsonb']['input']>;
  google_meet_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  questions_and_answers?: InputMaybe<Scalars['jsonb']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Consultation_Max_Fields = {
  __typename?: 'consultation_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  calendly_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  event_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  fathom_recording_url?: Maybe<Scalars['String']['output']>;
  fathom_summary?: Maybe<Scalars['String']['output']>;
  google_meet_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Consultation_Min_Fields = {
  __typename?: 'consultation_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  calendly_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  event_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  fathom_recording_url?: Maybe<Scalars['String']['output']>;
  fathom_summary?: Maybe<Scalars['String']['output']>;
  google_meet_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "consultation" */
export type Consultation_Mutation_Response = {
  __typename?: 'consultation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Consultation>;
};

/** on_conflict condition type for table "consultation" */
export type Consultation_On_Conflict = {
  constraint: Consultation_Constraint;
  update_columns?: Array<Consultation_Update_Column>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};

/** Ordering options when selecting data from "consultation". */
export type Consultation_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  calendly_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  event_timestamp?: InputMaybe<Order_By>;
  fathom_recording_url?: InputMaybe<Order_By>;
  fathom_summary?: InputMaybe<Order_By>;
  fathom_transcript?: InputMaybe<Order_By>;
  google_meet_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  outcome?: InputMaybe<Order_By>;
  questions_and_answers?: InputMaybe<Order_By>;
  resolution?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consultation */
export type Consultation_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Consultation_Prepend_Input = {
  fathom_transcript?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  questions_and_answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "consultation" */
export enum Consultation_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  CalendlyId = 'calendly_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  EventTimestamp = 'event_timestamp',
  /** column name */
  FathomRecordingUrl = 'fathom_recording_url',
  /** column name */
  FathomSummary = 'fathom_summary',
  /** column name */
  FathomTranscript = 'fathom_transcript',
  /** column name */
  GoogleMeetId = 'google_meet_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  QuestionsAndAnswers = 'questions_and_answers',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "consultation" */
export type Consultation_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  calendly_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  event_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  fathom_recording_url?: InputMaybe<Scalars['String']['input']>;
  fathom_summary?: InputMaybe<Scalars['String']['input']>;
  fathom_transcript?: InputMaybe<Scalars['jsonb']['input']>;
  google_meet_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  questions_and_answers?: InputMaybe<Scalars['jsonb']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "consultation" */
export type Consultation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consultation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consultation_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  calendly_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  event_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  fathom_recording_url?: InputMaybe<Scalars['String']['input']>;
  fathom_summary?: InputMaybe<Scalars['String']['input']>;
  fathom_transcript?: InputMaybe<Scalars['jsonb']['input']>;
  google_meet_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  questions_and_answers?: InputMaybe<Scalars['jsonb']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "consultation" */
export enum Consultation_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  CalendlyId = 'calendly_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  EventTimestamp = 'event_timestamp',
  /** column name */
  FathomRecordingUrl = 'fathom_recording_url',
  /** column name */
  FathomSummary = 'fathom_summary',
  /** column name */
  FathomTranscript = 'fathom_transcript',
  /** column name */
  GoogleMeetId = 'google_meet_id',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  QuestionsAndAnswers = 'questions_and_answers',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Consultation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Consultation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consultation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consultation_Bool_Exp;
};

/** columns and relationships of "contentful" */
export type Contentful = {
  __typename?: 'contentful';
  author_id?: Maybe<Scalars['String']['output']>;
  content_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  date?: Maybe<Scalars['timestamptz']['output']>;
  deleted: Scalars['Boolean']['output'];
  fields: Scalars['jsonb']['output'];
  id: Scalars['bpchar']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "contentful" */
export type ContentfulFieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "contentful" */
export type Contentful_Aggregate = {
  __typename?: 'contentful_aggregate';
  aggregate?: Maybe<Contentful_Aggregate_Fields>;
  nodes: Array<Contentful>;
};

/** aggregate fields of "contentful" */
export type Contentful_Aggregate_Fields = {
  __typename?: 'contentful_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Contentful_Max_Fields>;
  min?: Maybe<Contentful_Min_Fields>;
};


/** aggregate fields of "contentful" */
export type Contentful_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contentful_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contentful_Append_Input = {
  fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "contentful". All fields are combined with a logical 'AND'. */
export type Contentful_Bool_Exp = {
  _and?: InputMaybe<Array<Contentful_Bool_Exp>>;
  _not?: InputMaybe<Contentful_Bool_Exp>;
  _or?: InputMaybe<Array<Contentful_Bool_Exp>>;
  author_id?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  fields?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Bpchar_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "contentful" */
export enum Contentful_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContentfulPkey = 'contentful_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contentful_Delete_At_Path_Input = {
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contentful_Delete_Elem_Input = {
  fields?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contentful_Delete_Key_Input = {
  fields?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "contentful" */
export type Contentful_Insert_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Contentful_Max_Fields = {
  __typename?: 'contentful_max_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Contentful_Min_Fields = {
  __typename?: 'contentful_min_fields';
  author_id?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bpchar']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "contentful" */
export type Contentful_Mutation_Response = {
  __typename?: 'contentful_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Contentful>;
};

/** on_conflict condition type for table "contentful" */
export type Contentful_On_Conflict = {
  constraint: Contentful_Constraint;
  update_columns?: Array<Contentful_Update_Column>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};

/** Ordering options when selecting data from "contentful". */
export type Contentful_Order_By = {
  author_id?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  fields?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contentful */
export type Contentful_Pk_Columns_Input = {
  id: Scalars['bpchar']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contentful_Prepend_Input = {
  fields?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "contentful" */
export enum Contentful_Select_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "contentful" */
export type Contentful_Set_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "contentful" */
export type Contentful_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contentful_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contentful_Stream_Cursor_Value_Input = {
  author_id?: InputMaybe<Scalars['String']['input']>;
  content_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bpchar']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "contentful" */
export enum Contentful_Update_Column {
  /** column name */
  AuthorId = 'author_id',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Contentful_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Contentful_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Contentful_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Contentful_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Contentful_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Contentful_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contentful_Set_Input>;
  /** filter the rows which have to be updated */
  where: Contentful_Bool_Exp;
};

/** columns and relationships of "credit_note" */
export type Credit_Note = {
  __typename?: 'credit_note';
  billing_entity: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_context: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  refund_request?: Maybe<Refund_Request>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  variable_symbol: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


/** columns and relationships of "credit_note" */
export type Credit_NoteDocument_ContextArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "credit_note" */
export type Credit_Note_Aggregate = {
  __typename?: 'credit_note_aggregate';
  aggregate?: Maybe<Credit_Note_Aggregate_Fields>;
  nodes: Array<Credit_Note>;
};

export type Credit_Note_Aggregate_Bool_Exp = {
  count?: InputMaybe<Credit_Note_Aggregate_Bool_Exp_Count>;
};

export type Credit_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Credit_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Credit_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "credit_note" */
export type Credit_Note_Aggregate_Fields = {
  __typename?: 'credit_note_aggregate_fields';
  avg?: Maybe<Credit_Note_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Credit_Note_Max_Fields>;
  min?: Maybe<Credit_Note_Min_Fields>;
  stddev?: Maybe<Credit_Note_Stddev_Fields>;
  stddev_pop?: Maybe<Credit_Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Credit_Note_Stddev_Samp_Fields>;
  sum?: Maybe<Credit_Note_Sum_Fields>;
  var_pop?: Maybe<Credit_Note_Var_Pop_Fields>;
  var_samp?: Maybe<Credit_Note_Var_Samp_Fields>;
  variance?: Maybe<Credit_Note_Variance_Fields>;
};


/** aggregate fields of "credit_note" */
export type Credit_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Credit_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "credit_note" */
export type Credit_Note_Aggregate_Order_By = {
  avg?: InputMaybe<Credit_Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Credit_Note_Max_Order_By>;
  min?: InputMaybe<Credit_Note_Min_Order_By>;
  stddev?: InputMaybe<Credit_Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Credit_Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Credit_Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Credit_Note_Sum_Order_By>;
  var_pop?: InputMaybe<Credit_Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Credit_Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Credit_Note_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Append_Input = {
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "credit_note" */
export type Credit_Note_Arr_Rel_Insert_Input = {
  data: Array<Credit_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Credit_Note_Avg_Fields = {
  __typename?: 'credit_note_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "credit_note" */
export type Credit_Note_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "credit_note". All fields are combined with a logical 'AND'. */
export type Credit_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Credit_Note_Bool_Exp>>;
  _not?: InputMaybe<Credit_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Credit_Note_Bool_Exp>>;
  billing_entity?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_context?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_reference?: InputMaybe<String_Comparison_Exp>;
  refund_request?: InputMaybe<Refund_Request_Bool_Exp>;
  refund_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  variable_symbol?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "credit_note" */
export enum Credit_Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  CreditNotePkey = 'credit_note_pkey',
  /** unique or primary key constraint on columns "variable_symbol" */
  CreditNoteVariableSymbolKey = 'credit_note_variable_symbol_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Credit_Note_Delete_At_Path_Input = {
  document_context?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Credit_Note_Delete_Elem_Input = {
  document_context?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Credit_Note_Delete_Key_Input = {
  document_context?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "credit_note" */
export type Credit_Note_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "credit_note" */
export type Credit_Note_Insert_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoice_reference?: InputMaybe<Scalars['String']['input']>;
  refund_request?: InputMaybe<Refund_Request_Obj_Rel_Insert_Input>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Credit_Note_Max_Fields = {
  __typename?: 'credit_note_max_fields';
  billing_entity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "credit_note" */
export type Credit_Note_Max_Order_By = {
  billing_entity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_reference?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  variable_symbol?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Credit_Note_Min_Fields = {
  __typename?: 'credit_note_min_fields';
  billing_entity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice_reference?: Maybe<Scalars['String']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "credit_note" */
export type Credit_Note_Min_Order_By = {
  billing_entity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_reference?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  variable_symbol?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "credit_note" */
export type Credit_Note_Mutation_Response = {
  __typename?: 'credit_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Credit_Note>;
};

/** input type for inserting object relation for remote table "credit_note" */
export type Credit_Note_Obj_Rel_Insert_Input = {
  data: Credit_Note_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};

/** on_conflict condition type for table "credit_note" */
export type Credit_Note_On_Conflict = {
  constraint: Credit_Note_Constraint;
  update_columns?: Array<Credit_Note_Update_Column>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "credit_note". */
export type Credit_Note_Order_By = {
  billing_entity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_context?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_reference?: InputMaybe<Order_By>;
  refund_request?: InputMaybe<Refund_Request_Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  variable_symbol?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: credit_note */
export type Credit_Note_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Credit_Note_Prepend_Input = {
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "credit_note" */
export enum Credit_Note_Select_Column {
  /** column name */
  BillingEntity = 'billing_entity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentContext = 'document_context',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceReference = 'invoice_reference',
  /** column name */
  RefundRequestId = 'refund_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  VariableSymbol = 'variable_symbol',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "credit_note" */
export type Credit_Note_Set_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice_reference?: InputMaybe<Scalars['String']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Credit_Note_Stddev_Fields = {
  __typename?: 'credit_note_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "credit_note" */
export type Credit_Note_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Credit_Note_Stddev_Pop_Fields = {
  __typename?: 'credit_note_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "credit_note" */
export type Credit_Note_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Credit_Note_Stddev_Samp_Fields = {
  __typename?: 'credit_note_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "credit_note" */
export type Credit_Note_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "credit_note" */
export type Credit_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Credit_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Credit_Note_Stream_Cursor_Value_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice_reference?: InputMaybe<Scalars['String']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Credit_Note_Sum_Fields = {
  __typename?: 'credit_note_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "credit_note" */
export type Credit_Note_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "credit_note" */
export enum Credit_Note_Update_Column {
  /** column name */
  BillingEntity = 'billing_entity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentContext = 'document_context',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceReference = 'invoice_reference',
  /** column name */
  RefundRequestId = 'refund_request_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  VariableSymbol = 'variable_symbol',
  /** column name */
  Year = 'year'
}

export type Credit_Note_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Credit_Note_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Credit_Note_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Credit_Note_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Credit_Note_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Credit_Note_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Credit_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Credit_Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Credit_Note_Var_Pop_Fields = {
  __typename?: 'credit_note_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "credit_note" */
export type Credit_Note_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Credit_Note_Var_Samp_Fields = {
  __typename?: 'credit_note_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "credit_note" */
export type Credit_Note_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Credit_Note_Variance_Fields = {
  __typename?: 'credit_note_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "credit_note" */
export type Credit_Note_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type Delete_Address_By_Pk_Audited_Args = {
  aid?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "discount_coupon" */
export type Discount_Coupon = {
  __typename?: 'discount_coupon';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  discount_type: Scalars['String']['output'];
  fees_discount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  lawyer_fees_discount: Scalars['Int']['output'];
  monitoring_upsell: Scalars['Boolean']['output'];
  recurring: Scalars['Boolean']['output'];
  scope: Scalars['jsonb']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user?: Maybe<User>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "discount_coupon" */
export type Discount_CouponScopeArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "discount_coupon" */
export type Discount_Coupon_Aggregate = {
  __typename?: 'discount_coupon_aggregate';
  aggregate?: Maybe<Discount_Coupon_Aggregate_Fields>;
  nodes: Array<Discount_Coupon>;
};

/** aggregate fields of "discount_coupon" */
export type Discount_Coupon_Aggregate_Fields = {
  __typename?: 'discount_coupon_aggregate_fields';
  avg?: Maybe<Discount_Coupon_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Discount_Coupon_Max_Fields>;
  min?: Maybe<Discount_Coupon_Min_Fields>;
  stddev?: Maybe<Discount_Coupon_Stddev_Fields>;
  stddev_pop?: Maybe<Discount_Coupon_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Discount_Coupon_Stddev_Samp_Fields>;
  sum?: Maybe<Discount_Coupon_Sum_Fields>;
  var_pop?: Maybe<Discount_Coupon_Var_Pop_Fields>;
  var_samp?: Maybe<Discount_Coupon_Var_Samp_Fields>;
  variance?: Maybe<Discount_Coupon_Variance_Fields>;
};


/** aggregate fields of "discount_coupon" */
export type Discount_Coupon_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Discount_Coupon_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Discount_Coupon_Append_Input = {
  scope?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Discount_Coupon_Avg_Fields = {
  __typename?: 'discount_coupon_avg_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "discount_coupon". All fields are combined with a logical 'AND'. */
export type Discount_Coupon_Bool_Exp = {
  _and?: InputMaybe<Array<Discount_Coupon_Bool_Exp>>;
  _not?: InputMaybe<Discount_Coupon_Bool_Exp>;
  _or?: InputMaybe<Array<Discount_Coupon_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  discount_type?: InputMaybe<String_Comparison_Exp>;
  fees_discount?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lawyer_fees_discount?: InputMaybe<Int_Comparison_Exp>;
  monitoring_upsell?: InputMaybe<Boolean_Comparison_Exp>;
  recurring?: InputMaybe<Boolean_Comparison_Exp>;
  scope?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "discount_coupon" */
export enum Discount_Coupon_Constraint {
  /** unique or primary key constraint on columns "id" */
  DiscountCouponPkey = 'discount_coupon_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Discount_Coupon_Delete_At_Path_Input = {
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Discount_Coupon_Delete_Elem_Input = {
  scope?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Discount_Coupon_Delete_Key_Input = {
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "discount_coupon" */
export type Discount_Coupon_Inc_Input = {
  fees_discount?: InputMaybe<Scalars['Int']['input']>;
  lawyer_fees_discount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "discount_coupon" */
export type Discount_Coupon_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  fees_discount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lawyer_fees_discount?: InputMaybe<Scalars['Int']['input']>;
  monitoring_upsell?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Discount_Coupon_Max_Fields = {
  __typename?: 'discount_coupon_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  fees_discount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Discount_Coupon_Min_Fields = {
  __typename?: 'discount_coupon_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  discount_type?: Maybe<Scalars['String']['output']>;
  fees_discount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "discount_coupon" */
export type Discount_Coupon_Mutation_Response = {
  __typename?: 'discount_coupon_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Discount_Coupon>;
};

/** input type for inserting object relation for remote table "discount_coupon" */
export type Discount_Coupon_Obj_Rel_Insert_Input = {
  data: Discount_Coupon_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Discount_Coupon_On_Conflict>;
};

/** on_conflict condition type for table "discount_coupon" */
export type Discount_Coupon_On_Conflict = {
  constraint: Discount_Coupon_Constraint;
  update_columns?: Array<Discount_Coupon_Update_Column>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};

/** Ordering options when selecting data from "discount_coupon". */
export type Discount_Coupon_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  discount_type?: InputMaybe<Order_By>;
  fees_discount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lawyer_fees_discount?: InputMaybe<Order_By>;
  monitoring_upsell?: InputMaybe<Order_By>;
  recurring?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: discount_coupon */
export type Discount_Coupon_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Discount_Coupon_Prepend_Input = {
  scope?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "discount_coupon" */
export enum Discount_Coupon_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  FeesDiscount = 'fees_discount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LawyerFeesDiscount = 'lawyer_fees_discount',
  /** column name */
  MonitoringUpsell = 'monitoring_upsell',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "discount_coupon" */
export type Discount_Coupon_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  fees_discount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lawyer_fees_discount?: InputMaybe<Scalars['Int']['input']>;
  monitoring_upsell?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Discount_Coupon_Stddev_Fields = {
  __typename?: 'discount_coupon_stddev_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Discount_Coupon_Stddev_Pop_Fields = {
  __typename?: 'discount_coupon_stddev_pop_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Discount_Coupon_Stddev_Samp_Fields = {
  __typename?: 'discount_coupon_stddev_samp_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "discount_coupon" */
export type Discount_Coupon_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discount_Coupon_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discount_Coupon_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  discount_type?: InputMaybe<Scalars['String']['input']>;
  fees_discount?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  lawyer_fees_discount?: InputMaybe<Scalars['Int']['input']>;
  monitoring_upsell?: InputMaybe<Scalars['Boolean']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Discount_Coupon_Sum_Fields = {
  __typename?: 'discount_coupon_sum_fields';
  fees_discount?: Maybe<Scalars['Int']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "discount_coupon" */
export enum Discount_Coupon_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DiscountType = 'discount_type',
  /** column name */
  FeesDiscount = 'fees_discount',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LawyerFeesDiscount = 'lawyer_fees_discount',
  /** column name */
  MonitoringUpsell = 'monitoring_upsell',
  /** column name */
  Recurring = 'recurring',
  /** column name */
  Scope = 'scope',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Discount_Coupon_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Discount_Coupon_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Discount_Coupon_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Discount_Coupon_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Discount_Coupon_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Discount_Coupon_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Discount_Coupon_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Discount_Coupon_Set_Input>;
  /** filter the rows which have to be updated */
  where: Discount_Coupon_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Discount_Coupon_Var_Pop_Fields = {
  __typename?: 'discount_coupon_var_pop_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Discount_Coupon_Var_Samp_Fields = {
  __typename?: 'discount_coupon_var_samp_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Discount_Coupon_Variance_Fields = {
  __typename?: 'discount_coupon_variance_fields';
  fees_discount?: Maybe<Scalars['Float']['output']>;
  lawyer_fees_discount?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "docketed_message" */
export type Docketed_Message = {
  __typename?: 'docketed_message';
  asana_task_gid?: Maybe<Scalars['String']['output']>;
  asana_task_link?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  docketer: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jurisdiction?: Maybe<Scalars['String']['output']>;
  message_id: Scalars['String']['output'];
  message_link?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  received_at: Scalars['timestamptz']['output'];
  retried_at?: Maybe<Scalars['timestamptz']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sender_email: Scalars['String']['output'];
  sender_name?: Maybe<Scalars['String']['output']>;
  source_email: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "docketed_message" */
export type Docketed_MessageDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "docketed_message" */
export type Docketed_Message_Aggregate = {
  __typename?: 'docketed_message_aggregate';
  aggregate?: Maybe<Docketed_Message_Aggregate_Fields>;
  nodes: Array<Docketed_Message>;
};

/** aggregate fields of "docketed_message" */
export type Docketed_Message_Aggregate_Fields = {
  __typename?: 'docketed_message_aggregate_fields';
  avg?: Maybe<Docketed_Message_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Docketed_Message_Max_Fields>;
  min?: Maybe<Docketed_Message_Min_Fields>;
  stddev?: Maybe<Docketed_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Docketed_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Docketed_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Docketed_Message_Sum_Fields>;
  var_pop?: Maybe<Docketed_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Docketed_Message_Var_Samp_Fields>;
  variance?: Maybe<Docketed_Message_Variance_Fields>;
};


/** aggregate fields of "docketed_message" */
export type Docketed_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Docketed_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Docketed_Message_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Docketed_Message_Avg_Fields = {
  __typename?: 'docketed_message_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "docketed_message". All fields are combined with a logical 'AND'. */
export type Docketed_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Docketed_Message_Bool_Exp>>;
  _not?: InputMaybe<Docketed_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Docketed_Message_Bool_Exp>>;
  asana_task_gid?: InputMaybe<String_Comparison_Exp>;
  asana_task_link?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  docketer?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  message_link?: InputMaybe<String_Comparison_Exp>;
  office_action_id?: InputMaybe<Uuid_Comparison_Exp>;
  received_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  retried_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  sender_email?: InputMaybe<String_Comparison_Exp>;
  sender_name?: InputMaybe<String_Comparison_Exp>;
  source_email?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "docketed_message" */
export enum Docketed_Message_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocketedMessagePkey = 'docketed_message_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Docketed_Message_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Docketed_Message_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Docketed_Message_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "docketed_message" */
export type Docketed_Message_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "docketed_message" */
export type Docketed_Message_Insert_Input = {
  asana_task_gid?: InputMaybe<Scalars['String']['input']>;
  asana_task_link?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  docketer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  message_link?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retried_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sender_email?: InputMaybe<Scalars['String']['input']>;
  sender_name?: InputMaybe<Scalars['String']['input']>;
  source_email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Docketed_Message_Max_Fields = {
  __typename?: 'docketed_message_max_fields';
  asana_task_gid?: Maybe<Scalars['String']['output']>;
  asana_task_link?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  docketer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  message_link?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  retried_at?: Maybe<Scalars['timestamptz']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sender_email?: Maybe<Scalars['String']['output']>;
  sender_name?: Maybe<Scalars['String']['output']>;
  source_email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Docketed_Message_Min_Fields = {
  __typename?: 'docketed_message_min_fields';
  asana_task_gid?: Maybe<Scalars['String']['output']>;
  asana_task_link?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  docketer?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  message_link?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  received_at?: Maybe<Scalars['timestamptz']['output']>;
  retried_at?: Maybe<Scalars['timestamptz']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  sender_email?: Maybe<Scalars['String']['output']>;
  sender_name?: Maybe<Scalars['String']['output']>;
  source_email?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "docketed_message" */
export type Docketed_Message_Mutation_Response = {
  __typename?: 'docketed_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Docketed_Message>;
};

/** on_conflict condition type for table "docketed_message" */
export type Docketed_Message_On_Conflict = {
  constraint: Docketed_Message_Constraint;
  update_columns?: Array<Docketed_Message_Update_Column>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};

/** Ordering options when selecting data from "docketed_message". */
export type Docketed_Message_Order_By = {
  asana_task_gid?: InputMaybe<Order_By>;
  asana_task_link?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  docketer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  message_link?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  received_at?: InputMaybe<Order_By>;
  retried_at?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  sender_email?: InputMaybe<Order_By>;
  sender_name?: InputMaybe<Order_By>;
  source_email?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: docketed_message */
export type Docketed_Message_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Docketed_Message_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "docketed_message" */
export enum Docketed_Message_Select_Column {
  /** column name */
  AsanaTaskGid = 'asana_task_gid',
  /** column name */
  AsanaTaskLink = 'asana_task_link',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Docketer = 'docketer',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MessageLink = 'message_link',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RetriedAt = 'retried_at',
  /** column name */
  Sender = 'sender',
  /** column name */
  SenderEmail = 'sender_email',
  /** column name */
  SenderName = 'sender_name',
  /** column name */
  SourceEmail = 'source_email',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "docketed_message" */
export type Docketed_Message_Set_Input = {
  asana_task_gid?: InputMaybe<Scalars['String']['input']>;
  asana_task_link?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  docketer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  message_link?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retried_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sender_email?: InputMaybe<Scalars['String']['input']>;
  sender_name?: InputMaybe<Scalars['String']['input']>;
  source_email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Docketed_Message_Stddev_Fields = {
  __typename?: 'docketed_message_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Docketed_Message_Stddev_Pop_Fields = {
  __typename?: 'docketed_message_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Docketed_Message_Stddev_Samp_Fields = {
  __typename?: 'docketed_message_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "docketed_message" */
export type Docketed_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Docketed_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Docketed_Message_Stream_Cursor_Value_Input = {
  asana_task_gid?: InputMaybe<Scalars['String']['input']>;
  asana_task_link?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  docketer?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  message_link?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  received_at?: InputMaybe<Scalars['timestamptz']['input']>;
  retried_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  sender_email?: InputMaybe<Scalars['String']['input']>;
  sender_name?: InputMaybe<Scalars['String']['input']>;
  source_email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Docketed_Message_Sum_Fields = {
  __typename?: 'docketed_message_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "docketed_message" */
export enum Docketed_Message_Update_Column {
  /** column name */
  AsanaTaskGid = 'asana_task_gid',
  /** column name */
  AsanaTaskLink = 'asana_task_link',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Docketer = 'docketer',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  MessageLink = 'message_link',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  ReceivedAt = 'received_at',
  /** column name */
  RetriedAt = 'retried_at',
  /** column name */
  Sender = 'sender',
  /** column name */
  SenderEmail = 'sender_email',
  /** column name */
  SenderName = 'sender_name',
  /** column name */
  SourceEmail = 'source_email',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Docketed_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Docketed_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Docketed_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Docketed_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Docketed_Message_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Docketed_Message_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Docketed_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Docketed_Message_Set_Input>;
  /** filter the rows which have to be updated */
  where: Docketed_Message_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Docketed_Message_Var_Pop_Fields = {
  __typename?: 'docketed_message_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Docketed_Message_Var_Samp_Fields = {
  __typename?: 'docketed_message_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Docketed_Message_Variance_Fields = {
  __typename?: 'docketed_message_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "document" */
export type Document = {
  __typename?: 'document';
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  document_folder?: Maybe<Document_Folder>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  document_hub?: Maybe<Document_Hub>;
  document_hub_id: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  parent_document_id?: Maybe<Scalars['Int']['output']>;
  path: Scalars['String']['output'];
  /** An object relationship */
  poa?: Maybe<Poa>;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  revision: Scalars['Int']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  trademark?: Maybe<Trademark>;
  type: Scalars['String']['output'];
  /** An object relationship */
  use_in_commerce_request?: Maybe<Use_In_Commerce_Request>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  __typename?: 'document_aggregate';
  aggregate?: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

export type Document_Aggregate_Bool_Exp = {
  count?: InputMaybe<Document_Aggregate_Bool_Exp_Count>;
};

export type Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  __typename?: 'document_aggregate_fields';
  avg?: Maybe<Document_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Max_Fields>;
  min?: Maybe<Document_Min_Fields>;
  stddev?: Maybe<Document_Stddev_Fields>;
  stddev_pop?: Maybe<Document_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Document_Stddev_Samp_Fields>;
  sum?: Maybe<Document_Sum_Fields>;
  var_pop?: Maybe<Document_Var_Pop_Fields>;
  var_samp?: Maybe<Document_Var_Samp_Fields>;
  variance?: Maybe<Document_Variance_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "document" */
export type Document_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Max_Order_By>;
  min?: InputMaybe<Document_Min_Order_By>;
  stddev?: InputMaybe<Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "document" */
export type Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** aggregate avg on columns */
export type Document_Avg_Fields = {
  __typename?: 'document_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "document" */
export type Document_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_folder?: InputMaybe<Document_Folder_Bool_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_hub?: InputMaybe<Document_Hub_Bool_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  parent_document_id?: InputMaybe<Int_Comparison_Exp>;
  path?: InputMaybe<String_Comparison_Exp>;
  poa?: InputMaybe<Poa_Bool_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  revision?: InputMaybe<Int_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentPkey = 'document_pkey'
}

/** columns and relationships of "document_folder" */
export type Document_Folder = {
  __typename?: 'document_folder';
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "document_folder" */
export type Document_Folder_Aggregate = {
  __typename?: 'document_folder_aggregate';
  aggregate?: Maybe<Document_Folder_Aggregate_Fields>;
  nodes: Array<Document_Folder>;
};

/** aggregate fields of "document_folder" */
export type Document_Folder_Aggregate_Fields = {
  __typename?: 'document_folder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Folder_Max_Fields>;
  min?: Maybe<Document_Folder_Min_Fields>;
};


/** aggregate fields of "document_folder" */
export type Document_Folder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Folder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "document_folder". All fields are combined with a logical 'AND'. */
export type Document_Folder_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Folder_Bool_Exp>>;
  _not?: InputMaybe<Document_Folder_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Folder_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_folder" */
export enum Document_Folder_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentFolderPkey = 'document_folder_pkey'
}

/** input type for inserting data into table "document_folder" */
export type Document_Folder_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Document_Folder_Max_Fields = {
  __typename?: 'document_folder_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Document_Folder_Min_Fields = {
  __typename?: 'document_folder_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "document_folder" */
export type Document_Folder_Mutation_Response = {
  __typename?: 'document_folder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Folder>;
};

/** input type for inserting object relation for remote table "document_folder" */
export type Document_Folder_Obj_Rel_Insert_Input = {
  data: Document_Folder_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Folder_On_Conflict>;
};

/** on_conflict condition type for table "document_folder" */
export type Document_Folder_On_Conflict = {
  constraint: Document_Folder_Constraint;
  update_columns?: Array<Document_Folder_Update_Column>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};

/** Ordering options when selecting data from "document_folder". */
export type Document_Folder_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_folder */
export type Document_Folder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "document_folder" */
export enum Document_Folder_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "document_folder" */
export type Document_Folder_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "document_folder" */
export type Document_Folder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Folder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Folder_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "document_folder" */
export enum Document_Folder_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Document_Folder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Folder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Folder_Bool_Exp;
};

/** columns and relationships of "document_hub" */
export type Document_Hub = {
  __typename?: 'document_hub';
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['uuid']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "document_hub" */
export type Document_HubDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "document_hub" */
export type Document_HubDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** aggregated selection of "document_hub" */
export type Document_Hub_Aggregate = {
  __typename?: 'document_hub_aggregate';
  aggregate?: Maybe<Document_Hub_Aggregate_Fields>;
  nodes: Array<Document_Hub>;
};

/** aggregate fields of "document_hub" */
export type Document_Hub_Aggregate_Fields = {
  __typename?: 'document_hub_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Document_Hub_Max_Fields>;
  min?: Maybe<Document_Hub_Min_Fields>;
};


/** aggregate fields of "document_hub" */
export type Document_Hub_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Hub_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "document_hub". All fields are combined with a logical 'AND'. */
export type Document_Hub_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Hub_Bool_Exp>>;
  _not?: InputMaybe<Document_Hub_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Hub_Bool_Exp>>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "document_hub" */
export enum Document_Hub_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentHubPkey = 'document_hub_pkey'
}

/** input type for inserting data into table "document_hub" */
export type Document_Hub_Insert_Input = {
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Document_Hub_Max_Fields = {
  __typename?: 'document_hub_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Document_Hub_Min_Fields = {
  __typename?: 'document_hub_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "document_hub" */
export type Document_Hub_Mutation_Response = {
  __typename?: 'document_hub_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Hub>;
};

/** input type for inserting object relation for remote table "document_hub" */
export type Document_Hub_Obj_Rel_Insert_Input = {
  data: Document_Hub_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Hub_On_Conflict>;
};

/** on_conflict condition type for table "document_hub" */
export type Document_Hub_On_Conflict = {
  constraint: Document_Hub_Constraint;
  update_columns?: Array<Document_Hub_Update_Column>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};

/** Ordering options when selecting data from "document_hub". */
export type Document_Hub_Order_By = {
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: document_hub */
export type Document_Hub_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "document_hub" */
export enum Document_Hub_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "document_hub" */
export type Document_Hub_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "document_hub" */
export type Document_Hub_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Hub_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Hub_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "document_hub" */
export enum Document_Hub_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type Document_Hub_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Hub_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Hub_Bool_Exp;
};

/** input type for incrementing numeric columns in table "document" */
export type Document_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_document_id?: InputMaybe<Scalars['Int']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_folder?: InputMaybe<Document_Folder_Obj_Rel_Insert_Input>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub?: InputMaybe<Document_Hub_Obj_Rel_Insert_Input>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_document_id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  poa?: InputMaybe<Poa_Obj_Rel_Insert_Input>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  __typename?: 'document_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_document_id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "document" */
export type Document_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  __typename?: 'document_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_document_id?: Maybe<Scalars['Int']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "document" */
export type Document_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  __typename?: 'document_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_folder?: InputMaybe<Document_Folder_Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  document_hub?: InputMaybe<Document_Hub_Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  path?: InputMaybe<Order_By>;
  poa?: InputMaybe<Poa_Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  type?: InputMaybe<Order_By>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Order_By>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParentDocumentId = 'parent_document_id',
  /** column name */
  Path = 'path',
  /** column name */
  Revision = 'revision',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_document_id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Document_Stddev_Fields = {
  __typename?: 'document_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "document" */
export type Document_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Document_Stddev_Pop_Fields = {
  __typename?: 'document_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "document" */
export type Document_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Document_Stddev_Samp_Fields = {
  __typename?: 'document_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "document" */
export type Document_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  parent_document_id?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Document_Sum_Fields = {
  __typename?: 'document_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  parent_document_id?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "document" */
export type Document_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  ParentDocumentId = 'parent_document_id',
  /** column name */
  Path = 'path',
  /** column name */
  Revision = 'revision',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type'
}

export type Document_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  /** filter the rows which have to be updated */
  where: Document_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Document_Var_Pop_Fields = {
  __typename?: 'document_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "document" */
export type Document_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Document_Var_Samp_Fields = {
  __typename?: 'document_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "document" */
export type Document_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Document_Variance_Fields = {
  __typename?: 'document_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  parent_document_id?: Maybe<Scalars['Float']['output']>;
  revision?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "document" */
export type Document_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  parent_document_id?: InputMaybe<Order_By>;
  revision?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
};

/** columns and relationships of "entity" */
export type Entity = {
  __typename?: 'entity';
  /** An object relationship */
  address?: Maybe<Address>;
  address_id?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  application_entity: Array<Application>;
  /** An aggregate relationship */
  application_entity_aggregate: Application_Aggregate;
  /** An array relationship */
  billing_entity_request: Array<Registration_Request>;
  /** An aggregate relationship */
  billing_entity_request_aggregate: Registration_Request_Aggregate;
  birthdate?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  brand_subscription?: Maybe<Brand_Subscription>;
  business_name?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  country_of_incorporation?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  identity_card_id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  official_first_name?: Maybe<Scalars['String']['output']>;
  official_function?: Maybe<Scalars['String']['output']>;
  official_last_name?: Maybe<Scalars['String']['output']>;
  personal_id_number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
  state_of_incorporation?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  trademark_owner_entity: Array<Trademark>;
  /** An aggregate relationship */
  trademark_owner_entity_aggregate: Trademark_Aggregate;
  /** An array relationship */
  trademark_representative_entity: Array<Trademark>;
  /** An aggregate relationship */
  trademark_representative_entity_aggregate: Trademark_Aggregate;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  user_profile_billing_entity: Array<User_Profile>;
  /** An aggregate relationship */
  user_profile_billing_entity_aggregate: User_Profile_Aggregate;
  /** An array relationship */
  user_profile_registration_entity: Array<User_Profile>;
  /** An aggregate relationship */
  user_profile_registration_entity_aggregate: User_Profile_Aggregate;
  vat?: Maybe<Scalars['String']['output']>;
  vat_payer?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "entity" */
export type EntityApplication_EntityArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityApplication_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityBilling_Entity_RequestArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityBilling_Entity_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityTrademark_Owner_EntityArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityTrademark_Owner_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityTrademark_Representative_EntityArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityTrademark_Representative_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityUser_Profile_Billing_EntityArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityUser_Profile_Billing_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityUser_Profile_Registration_EntityArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


/** columns and relationships of "entity" */
export type EntityUser_Profile_Registration_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};

/** aggregated selection of "entity" */
export type Entity_Aggregate = {
  __typename?: 'entity_aggregate';
  aggregate?: Maybe<Entity_Aggregate_Fields>;
  nodes: Array<Entity>;
};

export type Entity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Entity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Entity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Entity_Aggregate_Bool_Exp_Count>;
};

export type Entity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Entity_Select_Column_Entity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Entity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Entity_Select_Column_Entity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Entity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Entity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "entity" */
export type Entity_Aggregate_Fields = {
  __typename?: 'entity_aggregate_fields';
  avg?: Maybe<Entity_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Entity_Max_Fields>;
  min?: Maybe<Entity_Min_Fields>;
  stddev?: Maybe<Entity_Stddev_Fields>;
  stddev_pop?: Maybe<Entity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Entity_Stddev_Samp_Fields>;
  sum?: Maybe<Entity_Sum_Fields>;
  var_pop?: Maybe<Entity_Var_Pop_Fields>;
  var_samp?: Maybe<Entity_Var_Samp_Fields>;
  variance?: Maybe<Entity_Variance_Fields>;
};


/** aggregate fields of "entity" */
export type Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "entity" */
export type Entity_Aggregate_Order_By = {
  avg?: InputMaybe<Entity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Entity_Max_Order_By>;
  min?: InputMaybe<Entity_Min_Order_By>;
  stddev?: InputMaybe<Entity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Entity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Entity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Entity_Sum_Order_By>;
  var_pop?: InputMaybe<Entity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Entity_Var_Samp_Order_By>;
  variance?: InputMaybe<Entity_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "entity" */
export type Entity_Arr_Rel_Insert_Input = {
  data: Array<Entity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};

/** aggregate avg on columns */
export type Entity_Avg_Fields = {
  __typename?: 'entity_avg_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "entity" */
export type Entity_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "entity". All fields are combined with a logical 'AND'. */
export type Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Entity_Bool_Exp>>;
  _not?: InputMaybe<Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Entity_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  application_entity?: InputMaybe<Application_Bool_Exp>;
  application_entity_aggregate?: InputMaybe<Application_Aggregate_Bool_Exp>;
  billing_entity_request?: InputMaybe<Registration_Request_Bool_Exp>;
  billing_entity_request_aggregate?: InputMaybe<Registration_Request_Aggregate_Bool_Exp>;
  birthdate?: InputMaybe<Date_Comparison_Exp>;
  brand_subscription?: InputMaybe<Brand_Subscription_Bool_Exp>;
  business_name?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<String_Comparison_Exp>;
  company_type?: InputMaybe<String_Comparison_Exp>;
  country_of_incorporation?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity_card_id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  nationality?: InputMaybe<String_Comparison_Exp>;
  official_first_name?: InputMaybe<String_Comparison_Exp>;
  official_function?: InputMaybe<String_Comparison_Exp>;
  official_last_name?: InputMaybe<String_Comparison_Exp>;
  personal_id_number?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
  state_of_incorporation?: InputMaybe<String_Comparison_Exp>;
  trademark_owner_entity?: InputMaybe<Trademark_Bool_Exp>;
  trademark_owner_entity_aggregate?: InputMaybe<Trademark_Aggregate_Bool_Exp>;
  trademark_representative_entity?: InputMaybe<Trademark_Bool_Exp>;
  trademark_representative_entity_aggregate?: InputMaybe<Trademark_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_profile_billing_entity?: InputMaybe<User_Profile_Bool_Exp>;
  user_profile_billing_entity_aggregate?: InputMaybe<User_Profile_Aggregate_Bool_Exp>;
  user_profile_registration_entity?: InputMaybe<User_Profile_Bool_Exp>;
  user_profile_registration_entity_aggregate?: InputMaybe<User_Profile_Aggregate_Bool_Exp>;
  vat?: InputMaybe<String_Comparison_Exp>;
  vat_payer?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "entity" */
export enum Entity_Constraint {
  /** unique or primary key constraint on columns "id" */
  EntityPkey = 'entity_pkey'
}

/** input type for incrementing numeric columns in table "entity" */
export type Entity_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "entity" */
export type Entity_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']['input']>;
  application_entity?: InputMaybe<Application_Arr_Rel_Insert_Input>;
  billing_entity_request?: InputMaybe<Registration_Request_Arr_Rel_Insert_Input>;
  birthdate?: InputMaybe<Scalars['date']['input']>;
  brand_subscription?: InputMaybe<Brand_Subscription_Obj_Rel_Insert_Input>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  company_type?: InputMaybe<Scalars['String']['input']>;
  country_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identity_card_id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  official_first_name?: InputMaybe<Scalars['String']['input']>;
  official_function?: InputMaybe<Scalars['String']['input']>;
  official_last_name?: InputMaybe<Scalars['String']['input']>;
  personal_id_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  state_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  trademark_owner_entity?: InputMaybe<Trademark_Arr_Rel_Insert_Input>;
  trademark_representative_entity?: InputMaybe<Trademark_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_profile_billing_entity?: InputMaybe<User_Profile_Arr_Rel_Insert_Input>;
  user_profile_registration_entity?: InputMaybe<User_Profile_Arr_Rel_Insert_Input>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vat_payer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Entity_Max_Fields = {
  __typename?: 'entity_max_fields';
  address_id?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['date']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  country_of_incorporation?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identity_card_id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  official_first_name?: Maybe<Scalars['String']['output']>;
  official_function?: Maybe<Scalars['String']['output']>;
  official_last_name?: Maybe<Scalars['String']['output']>;
  personal_id_number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state_of_incorporation?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "entity" */
export type Entity_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  business_name?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_type?: InputMaybe<Order_By>;
  country_of_incorporation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_card_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  official_first_name?: InputMaybe<Order_By>;
  official_function?: InputMaybe<Order_By>;
  official_last_name?: InputMaybe<Order_By>;
  personal_id_number?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  state_of_incorporation?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Entity_Min_Fields = {
  __typename?: 'entity_min_fields';
  address_id?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['date']['output']>;
  business_name?: Maybe<Scalars['String']['output']>;
  company_id?: Maybe<Scalars['String']['output']>;
  company_type?: Maybe<Scalars['String']['output']>;
  country_of_incorporation?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identity_card_id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  official_first_name?: Maybe<Scalars['String']['output']>;
  official_function?: Maybe<Scalars['String']['output']>;
  official_last_name?: Maybe<Scalars['String']['output']>;
  personal_id_number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state_of_incorporation?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "entity" */
export type Entity_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  business_name?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_type?: InputMaybe<Order_By>;
  country_of_incorporation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_card_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  official_first_name?: InputMaybe<Order_By>;
  official_function?: InputMaybe<Order_By>;
  official_last_name?: InputMaybe<Order_By>;
  personal_id_number?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  state_of_incorporation?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "entity" */
export type Entity_Mutation_Response = {
  __typename?: 'entity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Entity>;
};

/** input type for inserting object relation for remote table "entity" */
export type Entity_Obj_Rel_Insert_Input = {
  data: Entity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};

/** on_conflict condition type for table "entity" */
export type Entity_On_Conflict = {
  constraint: Entity_Constraint;
  update_columns?: Array<Entity_Update_Column>;
  where?: InputMaybe<Entity_Bool_Exp>;
};

/** Ordering options when selecting data from "entity". */
export type Entity_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  application_entity_aggregate?: InputMaybe<Application_Aggregate_Order_By>;
  billing_entity_request_aggregate?: InputMaybe<Registration_Request_Aggregate_Order_By>;
  birthdate?: InputMaybe<Order_By>;
  brand_subscription?: InputMaybe<Brand_Subscription_Order_By>;
  business_name?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_type?: InputMaybe<Order_By>;
  country_of_incorporation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identity_card_id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  nationality?: InputMaybe<Order_By>;
  official_first_name?: InputMaybe<Order_By>;
  official_function?: InputMaybe<Order_By>;
  official_last_name?: InputMaybe<Order_By>;
  personal_id_number?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Request_Order_By>;
  state_of_incorporation?: InputMaybe<Order_By>;
  trademark_owner_entity_aggregate?: InputMaybe<Trademark_Aggregate_Order_By>;
  trademark_representative_entity_aggregate?: InputMaybe<Trademark_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_profile_billing_entity_aggregate?: InputMaybe<User_Profile_Aggregate_Order_By>;
  user_profile_registration_entity_aggregate?: InputMaybe<User_Profile_Aggregate_Order_By>;
  vat?: InputMaybe<Order_By>;
  vat_payer?: InputMaybe<Order_By>;
};

/** primary key columns input for table: entity */
export type Entity_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "entity" */
export enum Entity_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyType = 'company_type',
  /** column name */
  CountryOfIncorporation = 'country_of_incorporation',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityCardId = 'identity_card_id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  OfficialFirstName = 'official_first_name',
  /** column name */
  OfficialFunction = 'official_function',
  /** column name */
  OfficialLastName = 'official_last_name',
  /** column name */
  PersonalIdNumber = 'personal_id_number',
  /** column name */
  Phone = 'phone',
  /** column name */
  StateOfIncorporation = 'state_of_incorporation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Vat = 'vat',
  /** column name */
  VatPayer = 'vat_payer'
}

/** select "entity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "entity" */
export enum Entity_Select_Column_Entity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  VatPayer = 'vat_payer'
}

/** select "entity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "entity" */
export enum Entity_Select_Column_Entity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  VatPayer = 'vat_payer'
}

/** input type for updating data in table "entity" */
export type Entity_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']['input']>;
  birthdate?: InputMaybe<Scalars['date']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  company_type?: InputMaybe<Scalars['String']['input']>;
  country_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identity_card_id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  official_first_name?: InputMaybe<Scalars['String']['input']>;
  official_function?: InputMaybe<Scalars['String']['input']>;
  official_last_name?: InputMaybe<Scalars['String']['input']>;
  personal_id_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vat_payer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Entity_Stddev_Fields = {
  __typename?: 'entity_stddev_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "entity" */
export type Entity_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Entity_Stddev_Pop_Fields = {
  __typename?: 'entity_stddev_pop_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "entity" */
export type Entity_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Entity_Stddev_Samp_Fields = {
  __typename?: 'entity_stddev_samp_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "entity" */
export type Entity_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "entity" */
export type Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Entity_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']['input']>;
  birthdate?: InputMaybe<Scalars['date']['input']>;
  business_name?: InputMaybe<Scalars['String']['input']>;
  company_id?: InputMaybe<Scalars['String']['input']>;
  company_type?: InputMaybe<Scalars['String']['input']>;
  country_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identity_card_id?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  official_first_name?: InputMaybe<Scalars['String']['input']>;
  official_function?: InputMaybe<Scalars['String']['input']>;
  official_last_name?: InputMaybe<Scalars['String']['input']>;
  personal_id_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state_of_incorporation?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  vat_payer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Entity_Sum_Fields = {
  __typename?: 'entity_sum_fields';
  address_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "entity" */
export type Entity_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** update columns of table "entity" */
export enum Entity_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BusinessName = 'business_name',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyType = 'company_type',
  /** column name */
  CountryOfIncorporation = 'country_of_incorporation',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  IdentityCardId = 'identity_card_id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Nationality = 'nationality',
  /** column name */
  OfficialFirstName = 'official_first_name',
  /** column name */
  OfficialFunction = 'official_function',
  /** column name */
  OfficialLastName = 'official_last_name',
  /** column name */
  PersonalIdNumber = 'personal_id_number',
  /** column name */
  Phone = 'phone',
  /** column name */
  StateOfIncorporation = 'state_of_incorporation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  Vat = 'vat',
  /** column name */
  VatPayer = 'vat_payer'
}

export type Entity_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Entity_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Entity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Entity_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Entity_Var_Pop_Fields = {
  __typename?: 'entity_var_pop_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "entity" */
export type Entity_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Entity_Var_Samp_Fields = {
  __typename?: 'entity_var_samp_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "entity" */
export type Entity_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Entity_Variance_Fields = {
  __typename?: 'entity_variance_fields';
  address_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "entity" */
export type Entity_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "exchange_rate" */
export type Exchange_Rate = {
  __typename?: 'exchange_rate';
  base_currency: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  date: Scalars['date']['output'];
  id: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  target_currency: Scalars['String']['output'];
};

/** aggregated selection of "exchange_rate" */
export type Exchange_Rate_Aggregate = {
  __typename?: 'exchange_rate_aggregate';
  aggregate?: Maybe<Exchange_Rate_Aggregate_Fields>;
  nodes: Array<Exchange_Rate>;
};

/** aggregate fields of "exchange_rate" */
export type Exchange_Rate_Aggregate_Fields = {
  __typename?: 'exchange_rate_aggregate_fields';
  avg?: Maybe<Exchange_Rate_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Exchange_Rate_Max_Fields>;
  min?: Maybe<Exchange_Rate_Min_Fields>;
  stddev?: Maybe<Exchange_Rate_Stddev_Fields>;
  stddev_pop?: Maybe<Exchange_Rate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exchange_Rate_Stddev_Samp_Fields>;
  sum?: Maybe<Exchange_Rate_Sum_Fields>;
  var_pop?: Maybe<Exchange_Rate_Var_Pop_Fields>;
  var_samp?: Maybe<Exchange_Rate_Var_Samp_Fields>;
  variance?: Maybe<Exchange_Rate_Variance_Fields>;
};


/** aggregate fields of "exchange_rate" */
export type Exchange_Rate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exchange_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Exchange_Rate_Avg_Fields = {
  __typename?: 'exchange_rate_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "exchange_rate". All fields are combined with a logical 'AND'. */
export type Exchange_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Exchange_Rate_Bool_Exp>>;
  _not?: InputMaybe<Exchange_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Exchange_Rate_Bool_Exp>>;
  base_currency?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  rate?: InputMaybe<Float_Comparison_Exp>;
  target_currency?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exchange_rate" */
export enum Exchange_Rate_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExchangeRatePkey = 'exchange_rate_pkey'
}

/** input type for incrementing numeric columns in table "exchange_rate" */
export type Exchange_Rate_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "exchange_rate" */
export type Exchange_Rate_Insert_Input = {
  base_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  target_currency?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Exchange_Rate_Max_Fields = {
  __typename?: 'exchange_rate_max_fields';
  base_currency?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  target_currency?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Exchange_Rate_Min_Fields = {
  __typename?: 'exchange_rate_min_fields';
  base_currency?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  target_currency?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "exchange_rate" */
export type Exchange_Rate_Mutation_Response = {
  __typename?: 'exchange_rate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Exchange_Rate>;
};

/** on_conflict condition type for table "exchange_rate" */
export type Exchange_Rate_On_Conflict = {
  constraint: Exchange_Rate_Constraint;
  update_columns?: Array<Exchange_Rate_Update_Column>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};

/** Ordering options when selecting data from "exchange_rate". */
export type Exchange_Rate_Order_By = {
  base_currency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  target_currency?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exchange_rate */
export type Exchange_Rate_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "exchange_rate" */
export enum Exchange_Rate_Select_Column {
  /** column name */
  BaseCurrency = 'base_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Rate = 'rate',
  /** column name */
  TargetCurrency = 'target_currency'
}

/** input type for updating data in table "exchange_rate" */
export type Exchange_Rate_Set_Input = {
  base_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  target_currency?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Exchange_Rate_Stddev_Fields = {
  __typename?: 'exchange_rate_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Exchange_Rate_Stddev_Pop_Fields = {
  __typename?: 'exchange_rate_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Exchange_Rate_Stddev_Samp_Fields = {
  __typename?: 'exchange_rate_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "exchange_rate" */
export type Exchange_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Exchange_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Exchange_Rate_Stream_Cursor_Value_Input = {
  base_currency?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  target_currency?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Exchange_Rate_Sum_Fields = {
  __typename?: 'exchange_rate_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "exchange_rate" */
export enum Exchange_Rate_Update_Column {
  /** column name */
  BaseCurrency = 'base_currency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Rate = 'rate',
  /** column name */
  TargetCurrency = 'target_currency'
}

export type Exchange_Rate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Exchange_Rate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Exchange_Rate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Exchange_Rate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Exchange_Rate_Var_Pop_Fields = {
  __typename?: 'exchange_rate_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Exchange_Rate_Var_Samp_Fields = {
  __typename?: 'exchange_rate_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Exchange_Rate_Variance_Fields = {
  __typename?: 'exchange_rate_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "external_trademark" */
export type External_Trademark = {
  __typename?: 'external_trademark';
  ai_well_known?: Maybe<Scalars['Boolean']['output']>;
  ai_well_known_reasoning?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  filing_date?: Maybe<Scalars['date']['output']>;
  goods_and_services: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
  registration_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  representative_entity?: Maybe<Entity>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  well_known?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "external_trademark" */
export type External_TrademarkDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "external_trademark" */
export type External_TrademarkDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "external_trademark" */
export type External_TrademarkGoods_And_ServicesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_trademark" */
export type External_Trademark_Aggregate = {
  __typename?: 'external_trademark_aggregate';
  aggregate?: Maybe<External_Trademark_Aggregate_Fields>;
  nodes: Array<External_Trademark>;
};

/** aggregate fields of "external_trademark" */
export type External_Trademark_Aggregate_Fields = {
  __typename?: 'external_trademark_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<External_Trademark_Max_Fields>;
  min?: Maybe<External_Trademark_Min_Fields>;
};


/** aggregate fields of "external_trademark" */
export type External_Trademark_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<External_Trademark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type External_Trademark_Append_Input = {
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "external_trademark". All fields are combined with a logical 'AND'. */
export type External_Trademark_Bool_Exp = {
  _and?: InputMaybe<Array<External_Trademark_Bool_Exp>>;
  _not?: InputMaybe<External_Trademark_Bool_Exp>;
  _or?: InputMaybe<Array<External_Trademark_Bool_Exp>>;
  ai_well_known?: InputMaybe<Boolean_Comparison_Exp>;
  ai_well_known_reasoning?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  filing_date?: InputMaybe<Date_Comparison_Exp>;
  goods_and_services?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ipo_link?: InputMaybe<String_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  registration_date?: InputMaybe<Date_Comparison_Exp>;
  representative_entity?: InputMaybe<Entity_Bool_Exp>;
  representative_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
  well_known?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "external_trademark" */
export enum External_Trademark_Constraint {
  /** unique or primary key constraint on columns "jurisdiction", "number" */
  ExternalTrademarkNumberJurisdictionKey = 'external_trademark_number_jurisdiction_key',
  /** unique or primary key constraint on columns "id" */
  ExternalTrademarkPkey = 'external_trademark_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type External_Trademark_Delete_At_Path_Input = {
  goods_and_services?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type External_Trademark_Delete_Elem_Input = {
  goods_and_services?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type External_Trademark_Delete_Key_Input = {
  goods_and_services?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "external_trademark" */
export type External_Trademark_Insert_Input = {
  ai_well_known?: InputMaybe<Scalars['Boolean']['input']>;
  ai_well_known_reasoning?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  representative_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type External_Trademark_Max_Fields = {
  __typename?: 'external_trademark_max_fields';
  ai_well_known_reasoning?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  registration_date?: Maybe<Scalars['date']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type External_Trademark_Min_Fields = {
  __typename?: 'external_trademark_min_fields';
  ai_well_known_reasoning?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  registration_date?: Maybe<Scalars['date']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "external_trademark" */
export type External_Trademark_Mutation_Response = {
  __typename?: 'external_trademark_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<External_Trademark>;
};

/** input type for inserting object relation for remote table "external_trademark" */
export type External_Trademark_Obj_Rel_Insert_Input = {
  data: External_Trademark_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<External_Trademark_On_Conflict>;
};

/** on_conflict condition type for table "external_trademark" */
export type External_Trademark_On_Conflict = {
  constraint: External_Trademark_Constraint;
  update_columns?: Array<External_Trademark_Update_Column>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};

/** Ordering options when selecting data from "external_trademark". */
export type External_Trademark_Order_By = {
  ai_well_known?: InputMaybe<Order_By>;
  ai_well_known_reasoning?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  filing_date?: InputMaybe<Order_By>;
  goods_and_services?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  registration_date?: InputMaybe<Order_By>;
  representative_entity?: InputMaybe<Entity_Order_By>;
  representative_entity_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
  well_known?: InputMaybe<Order_By>;
};

/** primary key columns input for table: external_trademark */
export type External_Trademark_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type External_Trademark_Prepend_Input = {
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "external_trademark" */
export enum External_Trademark_Select_Column {
  /** column name */
  AiWellKnown = 'ai_well_known',
  /** column name */
  AiWellKnownReasoning = 'ai_well_known_reasoning',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  GoodsAndServices = 'goods_and_services',
  /** column name */
  Id = 'id',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website',
  /** column name */
  WellKnown = 'well_known'
}

/** input type for updating data in table "external_trademark" */
export type External_Trademark_Set_Input = {
  ai_well_known?: InputMaybe<Scalars['Boolean']['input']>;
  ai_well_known_reasoning?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "external_trademark" */
export type External_Trademark_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: External_Trademark_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type External_Trademark_Stream_Cursor_Value_Input = {
  ai_well_known?: InputMaybe<Scalars['Boolean']['input']>;
  ai_well_known_reasoning?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  goods_and_services?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "external_trademark" */
export enum External_Trademark_Update_Column {
  /** column name */
  AiWellKnown = 'ai_well_known',
  /** column name */
  AiWellKnownReasoning = 'ai_well_known_reasoning',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  GoodsAndServices = 'goods_and_services',
  /** column name */
  Id = 'id',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  Type = 'type',
  /** column name */
  Website = 'website',
  /** column name */
  WellKnown = 'well_known'
}

export type External_Trademark_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<External_Trademark_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<External_Trademark_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<External_Trademark_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<External_Trademark_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<External_Trademark_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<External_Trademark_Set_Input>;
  /** filter the rows which have to be updated */
  where: External_Trademark_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  billing_entity: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  credit_note?: Maybe<Credit_Note>;
  document_context: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  invoice_id?: Maybe<Scalars['String']['output']>;
  last_failed_payment_alert_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  revolut_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_public_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_transaction_id?: Maybe<Scalars['uuid']['output']>;
  serial_number?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
  stripe_payment_id?: Maybe<Scalars['String']['output']>;
  variable_symbol: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


/** columns and relationships of "invoice" */
export type InvoiceDocument_ContextArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Append_Input = {
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  billing_entity?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_note?: InputMaybe<Credit_Note_Bool_Exp>;
  document_context?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_id?: InputMaybe<String_Comparison_Exp>;
  last_failed_payment_alert_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  payment_type?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  revolut_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  revolut_public_order_id?: InputMaybe<Uuid_Comparison_Exp>;
  revolut_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  serial_number?: InputMaybe<Int_Comparison_Exp>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
  stripe_payment_id?: InputMaybe<String_Comparison_Exp>;
  variable_symbol?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoice" */
export enum Invoice_Constraint {
  /** unique or primary key constraint on columns "billing_entity", "serial_number", "year" */
  InvoiceEntityYearSerialNumberIdx = 'invoice_entity_year_serial_number_idx',
  /** unique or primary key constraint on columns "id" */
  InvoiceIdKey = 'invoice_id_key',
  /** unique or primary key constraint on columns "variable_symbol" */
  InvoicePkey = 'invoice_pkey',
  /** unique or primary key constraint on columns "product_id" */
  InvoiceProductIdKey = 'invoice_product_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoice_Delete_At_Path_Input = {
  document_context?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoice_Delete_Elem_Input = {
  document_context?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoice_Delete_Key_Input = {
  document_context?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "invoice" */
export type Invoice_Inc_Input = {
  serial_number?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "invoice" */
export type Invoice_Insert_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  credit_note?: InputMaybe<Credit_Note_Obj_Rel_Insert_Input>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['String']['input']>;
  last_failed_payment_alert_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  revolut_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_public_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  serial_number?: InputMaybe<Scalars['Int']['input']>;
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  stripe_payment_id?: InputMaybe<Scalars['String']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Invoice_Mark_As_Paid_Args = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  billing_entity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  last_failed_payment_alert_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  revolut_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_public_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_transaction_id?: Maybe<Scalars['uuid']['output']>;
  serial_number?: Maybe<Scalars['Int']['output']>;
  stripe_payment_id?: Maybe<Scalars['String']['output']>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  billing_entity?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  last_failed_payment_alert_at?: Maybe<Scalars['timestamptz']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  payment_type?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  revolut_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_public_order_id?: Maybe<Scalars['uuid']['output']>;
  revolut_transaction_id?: Maybe<Scalars['uuid']['output']>;
  serial_number?: Maybe<Scalars['Int']['output']>;
  stripe_payment_id?: Maybe<Scalars['String']['output']>;
  variable_symbol?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "invoice" */
export type Invoice_Mutation_Response = {
  __typename?: 'invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoice>;
};

/** input type for inserting object relation for remote table "invoice" */
export type Invoice_Obj_Rel_Insert_Input = {
  data: Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};

/** on_conflict condition type for table "invoice" */
export type Invoice_On_Conflict = {
  constraint: Invoice_Constraint;
  update_columns?: Array<Invoice_Update_Column>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  billing_entity?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_note?: InputMaybe<Credit_Note_Order_By>;
  document_context?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  last_failed_payment_alert_at?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  payment_type?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  revolut_order_id?: InputMaybe<Order_By>;
  revolut_public_order_id?: InputMaybe<Order_By>;
  revolut_transaction_id?: InputMaybe<Order_By>;
  serial_number?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Request_Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  variable_symbol?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoice */
export type Invoice_Pk_Columns_Input = {
  variable_symbol: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoice_Prepend_Input = {
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  BillingEntity = 'billing_entity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentContext = 'document_context',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LastFailedPaymentAlertAt = 'last_failed_payment_alert_at',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  RevolutOrderId = 'revolut_order_id',
  /** column name */
  RevolutPublicOrderId = 'revolut_public_order_id',
  /** column name */
  RevolutTransactionId = 'revolut_transaction_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  VariableSymbol = 'variable_symbol',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "invoice" */
export type Invoice_Set_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['String']['input']>;
  last_failed_payment_alert_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_public_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  serial_number?: InputMaybe<Scalars['Int']['input']>;
  stripe_payment_id?: InputMaybe<Scalars['String']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  billing_entity?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_context?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_id?: InputMaybe<Scalars['String']['input']>;
  last_failed_payment_alert_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_type?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_public_order_id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  serial_number?: InputMaybe<Scalars['Int']['input']>;
  stripe_payment_id?: InputMaybe<Scalars['String']['input']>;
  variable_symbol?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  serial_number?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "invoice" */
export enum Invoice_Update_Column {
  /** column name */
  BillingEntity = 'billing_entity',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentContext = 'document_context',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  LastFailedPaymentAlertAt = 'last_failed_payment_alert_at',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PaymentType = 'payment_type',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  RevolutOrderId = 'revolut_order_id',
  /** column name */
  RevolutPublicOrderId = 'revolut_public_order_id',
  /** column name */
  RevolutTransactionId = 'revolut_transaction_id',
  /** column name */
  SerialNumber = 'serial_number',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  VariableSymbol = 'variable_symbol',
  /** column name */
  Year = 'year'
}

export type Invoice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invoice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  serial_number?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "address" */
  delete_address?: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk?: Maybe<Address>;
  /** execute VOLATILE function "delete_address_by_pk_audited" which returns "address" */
  delete_address_by_pk_audited: Array<Address>;
  /** delete data from the table: "ai_gs_items_analysis" */
  delete_ai_gs_items_analysis?: Maybe<Ai_Gs_Items_Analysis_Mutation_Response>;
  /** delete single row from the table: "ai_gs_items_analysis" */
  delete_ai_gs_items_analysis_by_pk?: Maybe<Ai_Gs_Items_Analysis>;
  /** delete data from the table: "application" */
  delete_application?: Maybe<Application_Mutation_Response>;
  /** delete single row from the table: "application" */
  delete_application_by_pk?: Maybe<Application>;
  /** delete data from the table: "application_jurisdiction" */
  delete_application_jurisdiction?: Maybe<Application_Jurisdiction_Mutation_Response>;
  /** delete single row from the table: "application_jurisdiction" */
  delete_application_jurisdiction_by_pk?: Maybe<Application_Jurisdiction>;
  /** delete data from the table: "audit_log" */
  delete_audit_log?: Maybe<Audit_Log_Mutation_Response>;
  /** delete data from the table: "brand" */
  delete_brand?: Maybe<Brand_Mutation_Response>;
  /** delete single row from the table: "brand" */
  delete_brand_by_pk?: Maybe<Brand>;
  /** delete data from the table: "brand_monitoring_task" */
  delete_brand_monitoring_task?: Maybe<Brand_Monitoring_Task_Mutation_Response>;
  /** delete single row from the table: "brand_monitoring_task" */
  delete_brand_monitoring_task_by_pk?: Maybe<Brand_Monitoring_Task>;
  /** delete data from the table: "brand_monitoring_task_tracking" */
  delete_brand_monitoring_task_tracking?: Maybe<Brand_Monitoring_Task_Tracking_Mutation_Response>;
  /** delete single row from the table: "brand_monitoring_task_tracking" */
  delete_brand_monitoring_task_tracking_by_pk?: Maybe<Brand_Monitoring_Task_Tracking>;
  /** delete data from the table: "brand_monitoring_task_tracking_status" */
  delete_brand_monitoring_task_tracking_status?: Maybe<Brand_Monitoring_Task_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "brand_monitoring_task_tracking_status" */
  delete_brand_monitoring_task_tracking_status_by_pk?: Maybe<Brand_Monitoring_Task_Tracking_Status>;
  /** delete data from the table: "brand_snapshot" */
  delete_brand_snapshot?: Maybe<Brand_Snapshot_Mutation_Response>;
  /** delete single row from the table: "brand_snapshot" */
  delete_brand_snapshot_by_pk?: Maybe<Brand_Snapshot>;
  /** delete data from the table: "brand_subscription" */
  delete_brand_subscription?: Maybe<Brand_Subscription_Mutation_Response>;
  /** delete single row from the table: "brand_subscription" */
  delete_brand_subscription_by_pk?: Maybe<Brand_Subscription>;
  /** delete data from the table: "brand_subscription_payment" */
  delete_brand_subscription_payment?: Maybe<Brand_Subscription_Payment_Mutation_Response>;
  /** delete single row from the table: "brand_subscription_payment" */
  delete_brand_subscription_payment_by_pk?: Maybe<Brand_Subscription_Payment>;
  /** delete data from the table: "brand_subscription_platform" */
  delete_brand_subscription_platform?: Maybe<Brand_Subscription_Platform_Mutation_Response>;
  /** delete single row from the table: "brand_subscription_platform" */
  delete_brand_subscription_platform_by_pk?: Maybe<Brand_Subscription_Platform>;
  /** delete data from the table: "brand_subscription_tracking" */
  delete_brand_subscription_tracking?: Maybe<Brand_Subscription_Tracking_Mutation_Response>;
  /** delete single row from the table: "brand_subscription_tracking" */
  delete_brand_subscription_tracking_by_pk?: Maybe<Brand_Subscription_Tracking>;
  /** delete data from the table: "brand_subscription_tracking_status" */
  delete_brand_subscription_tracking_status?: Maybe<Brand_Subscription_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "brand_subscription_tracking_status" */
  delete_brand_subscription_tracking_status_by_pk?: Maybe<Brand_Subscription_Tracking_Status>;
  /** delete data from the table: "case" */
  delete_case?: Maybe<Case_Mutation_Response>;
  /** delete single row from the table: "case" */
  delete_case_by_pk?: Maybe<Case>;
  /** delete data from the table: "case_counterparty" */
  delete_case_counterparty?: Maybe<Case_Counterparty_Mutation_Response>;
  /** delete single row from the table: "case_counterparty" */
  delete_case_counterparty_by_pk?: Maybe<Case_Counterparty>;
  /** delete data from the table: "case_infringement" */
  delete_case_infringement?: Maybe<Case_Infringement_Mutation_Response>;
  /** delete single row from the table: "case_infringement" */
  delete_case_infringement_by_pk?: Maybe<Case_Infringement>;
  /** delete data from the table: "case_infringement_evidence" */
  delete_case_infringement_evidence?: Maybe<Case_Infringement_Evidence_Mutation_Response>;
  /** delete single row from the table: "case_infringement_evidence" */
  delete_case_infringement_evidence_by_pk?: Maybe<Case_Infringement_Evidence>;
  /** delete data from the table: "case_request" */
  delete_case_request?: Maybe<Case_Request_Mutation_Response>;
  /** delete single row from the table: "case_request" */
  delete_case_request_by_pk?: Maybe<Case_Request>;
  /** delete data from the table: "case_request_tracking" */
  delete_case_request_tracking?: Maybe<Case_Request_Tracking_Mutation_Response>;
  /** delete single row from the table: "case_request_tracking" */
  delete_case_request_tracking_by_pk?: Maybe<Case_Request_Tracking>;
  /** delete data from the table: "case_request_tracking_status" */
  delete_case_request_tracking_status?: Maybe<Case_Request_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "case_request_tracking_status" */
  delete_case_request_tracking_status_by_pk?: Maybe<Case_Request_Tracking_Status>;
  /** delete data from the table: "case_solution" */
  delete_case_solution?: Maybe<Case_Solution_Mutation_Response>;
  /** delete single row from the table: "case_solution" */
  delete_case_solution_by_pk?: Maybe<Case_Solution>;
  /** delete data from the table: "case_tracking" */
  delete_case_tracking?: Maybe<Case_Tracking_Mutation_Response>;
  /** delete single row from the table: "case_tracking" */
  delete_case_tracking_by_pk?: Maybe<Case_Tracking>;
  /** delete data from the table: "case_tracking_status" */
  delete_case_tracking_status?: Maybe<Case_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "case_tracking_status" */
  delete_case_tracking_status_by_pk?: Maybe<Case_Tracking_Status>;
  /** delete data from the table: "consultation" */
  delete_consultation?: Maybe<Consultation_Mutation_Response>;
  /** delete single row from the table: "consultation" */
  delete_consultation_by_pk?: Maybe<Consultation>;
  /** delete data from the table: "contentful" */
  delete_contentful?: Maybe<Contentful_Mutation_Response>;
  /** delete single row from the table: "contentful" */
  delete_contentful_by_pk?: Maybe<Contentful>;
  /** delete data from the table: "credit_note" */
  delete_credit_note?: Maybe<Credit_Note_Mutation_Response>;
  /** delete single row from the table: "credit_note" */
  delete_credit_note_by_pk?: Maybe<Credit_Note>;
  /** delete data from the table: "discount_coupon" */
  delete_discount_coupon?: Maybe<Discount_Coupon_Mutation_Response>;
  /** delete single row from the table: "discount_coupon" */
  delete_discount_coupon_by_pk?: Maybe<Discount_Coupon>;
  /** delete data from the table: "docketed_message" */
  delete_docketed_message?: Maybe<Docketed_Message_Mutation_Response>;
  /** delete single row from the table: "docketed_message" */
  delete_docketed_message_by_pk?: Maybe<Docketed_Message>;
  /** delete data from the table: "document" */
  delete_document?: Maybe<Document_Mutation_Response>;
  /** delete single row from the table: "document" */
  delete_document_by_pk?: Maybe<Document>;
  /** delete data from the table: "document_folder" */
  delete_document_folder?: Maybe<Document_Folder_Mutation_Response>;
  /** delete single row from the table: "document_folder" */
  delete_document_folder_by_pk?: Maybe<Document_Folder>;
  /** delete data from the table: "document_hub" */
  delete_document_hub?: Maybe<Document_Hub_Mutation_Response>;
  /** delete single row from the table: "document_hub" */
  delete_document_hub_by_pk?: Maybe<Document_Hub>;
  /** delete data from the table: "entity" */
  delete_entity?: Maybe<Entity_Mutation_Response>;
  /** delete single row from the table: "entity" */
  delete_entity_by_pk?: Maybe<Entity>;
  /** delete data from the table: "exchange_rate" */
  delete_exchange_rate?: Maybe<Exchange_Rate_Mutation_Response>;
  /** delete single row from the table: "exchange_rate" */
  delete_exchange_rate_by_pk?: Maybe<Exchange_Rate>;
  /** delete data from the table: "external_trademark" */
  delete_external_trademark?: Maybe<External_Trademark_Mutation_Response>;
  /** delete single row from the table: "external_trademark" */
  delete_external_trademark_by_pk?: Maybe<External_Trademark>;
  /** delete data from the table: "invoice" */
  delete_invoice?: Maybe<Invoice_Mutation_Response>;
  /** delete single row from the table: "invoice" */
  delete_invoice_by_pk?: Maybe<Invoice>;
  /** delete data from the table: "note" */
  delete_note?: Maybe<Note_Mutation_Response>;
  /** delete single row from the table: "note" */
  delete_note_by_pk?: Maybe<Note>;
  /** delete data from the table: "note_hub" */
  delete_note_hub?: Maybe<Note_Hub_Mutation_Response>;
  /** delete single row from the table: "note_hub" */
  delete_note_hub_by_pk?: Maybe<Note_Hub>;
  /** delete data from the table: "notification" */
  delete_notification?: Maybe<Notification_Mutation_Response>;
  /** delete single row from the table: "notification" */
  delete_notification_by_pk?: Maybe<Notification>;
  /** delete data from the table: "office_action" */
  delete_office_action?: Maybe<Office_Action_Mutation_Response>;
  /** delete single row from the table: "office_action" */
  delete_office_action_by_pk?: Maybe<Office_Action>;
  /** delete data from the table: "office_action_issue" */
  delete_office_action_issue?: Maybe<Office_Action_Issue_Mutation_Response>;
  /** delete single row from the table: "office_action_issue" */
  delete_office_action_issue_by_pk?: Maybe<Office_Action_Issue>;
  /** delete data from the table: "office_action_similar_trademark_map" */
  delete_office_action_similar_trademark_map?: Maybe<Office_Action_Similar_Trademark_Map_Mutation_Response>;
  /** delete single row from the table: "office_action_similar_trademark_map" */
  delete_office_action_similar_trademark_map_by_pk?: Maybe<Office_Action_Similar_Trademark_Map>;
  /** delete data from the table: "office_action_solution" */
  delete_office_action_solution?: Maybe<Office_Action_Solution_Mutation_Response>;
  /** delete single row from the table: "office_action_solution" */
  delete_office_action_solution_by_pk?: Maybe<Office_Action_Solution>;
  /** delete data from the table: "office_action_tracking" */
  delete_office_action_tracking?: Maybe<Office_Action_Tracking_Mutation_Response>;
  /** delete single row from the table: "office_action_tracking" */
  delete_office_action_tracking_by_pk?: Maybe<Office_Action_Tracking>;
  /** delete data from the table: "office_action_tracking_status" */
  delete_office_action_tracking_status?: Maybe<Office_Action_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "office_action_tracking_status" */
  delete_office_action_tracking_status_by_pk?: Maybe<Office_Action_Tracking_Status>;
  /** delete data from the table: "order" */
  delete_order?: Maybe<Order_Mutation_Response>;
  /** delete single row from the table: "order" */
  delete_order_by_pk?: Maybe<Order>;
  /** delete data from the table: "order_hub" */
  delete_order_hub?: Maybe<Order_Hub_Mutation_Response>;
  /** delete single row from the table: "order_hub" */
  delete_order_hub_by_pk?: Maybe<Order_Hub>;
  /** delete data from the table: "order_tracking" */
  delete_order_tracking?: Maybe<Order_Tracking_Mutation_Response>;
  /** delete single row from the table: "order_tracking" */
  delete_order_tracking_by_pk?: Maybe<Order_Tracking>;
  /** delete data from the table: "order_tracking_status" */
  delete_order_tracking_status?: Maybe<Order_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "order_tracking_status" */
  delete_order_tracking_status_by_pk?: Maybe<Order_Tracking_Status>;
  /** delete data from the table: "poa" */
  delete_poa?: Maybe<Poa_Mutation_Response>;
  /** delete single row from the table: "poa" */
  delete_poa_by_pk?: Maybe<Poa>;
  /** delete data from the table: "price" */
  delete_price?: Maybe<Price_Mutation_Response>;
  /** delete single row from the table: "price" */
  delete_price_by_pk?: Maybe<Price>;
  /** delete data from the table: "price_rule" */
  delete_price_rule?: Maybe<Price_Rule_Mutation_Response>;
  /** delete single row from the table: "price_rule" */
  delete_price_rule_by_pk?: Maybe<Price_Rule>;
  /** delete data from the table: "product" */
  delete_product?: Maybe<Product_Mutation_Response>;
  /** delete data from the table: "product_bundle" */
  delete_product_bundle?: Maybe<Product_Bundle_Mutation_Response>;
  /** delete single row from the table: "product_bundle" */
  delete_product_bundle_by_pk?: Maybe<Product_Bundle>;
  /** delete single row from the table: "product" */
  delete_product_by_pk?: Maybe<Product>;
  /** delete data from the table: "product_event" */
  delete_product_event?: Maybe<Product_Event_Mutation_Response>;
  /** delete single row from the table: "product_event" */
  delete_product_event_by_pk?: Maybe<Product_Event>;
  /** delete data from the table: "product_v2" */
  delete_product_v2?: Maybe<Product_V2_Mutation_Response>;
  /** delete single row from the table: "product_v2" */
  delete_product_v2_by_pk?: Maybe<Product_V2>;
  /** delete data from the table: "quote" */
  delete_quote?: Maybe<Quote_Mutation_Response>;
  /** delete single row from the table: "quote" */
  delete_quote_by_pk?: Maybe<Quote>;
  /** delete data from the table: "quote_hub" */
  delete_quote_hub?: Maybe<Quote_Hub_Mutation_Response>;
  /** delete single row from the table: "quote_hub" */
  delete_quote_hub_by_pk?: Maybe<Quote_Hub>;
  /** delete data from the table: "quote_item" */
  delete_quote_item?: Maybe<Quote_Item_Mutation_Response>;
  /** delete single row from the table: "quote_item" */
  delete_quote_item_by_pk?: Maybe<Quote_Item>;
  /** delete data from the table: "refund_request" */
  delete_refund_request?: Maybe<Refund_Request_Mutation_Response>;
  /** delete single row from the table: "refund_request" */
  delete_refund_request_by_pk?: Maybe<Refund_Request>;
  /** delete data from the table: "refund_request_invoice" */
  delete_refund_request_invoice?: Maybe<Refund_Request_Invoice_Mutation_Response>;
  /** delete single row from the table: "refund_request_invoice" */
  delete_refund_request_invoice_by_pk?: Maybe<Refund_Request_Invoice>;
  /** delete data from the table: "refund_request_tracking" */
  delete_refund_request_tracking?: Maybe<Refund_Request_Tracking_Mutation_Response>;
  /** delete single row from the table: "refund_request_tracking" */
  delete_refund_request_tracking_by_pk?: Maybe<Refund_Request_Tracking>;
  /** delete data from the table: "refund_request_tracking_status" */
  delete_refund_request_tracking_status?: Maybe<Refund_Request_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "refund_request_tracking_status" */
  delete_refund_request_tracking_status_by_pk?: Maybe<Refund_Request_Tracking_Status>;
  /** delete data from the table: "registration_request" */
  delete_registration_request?: Maybe<Registration_Request_Mutation_Response>;
  /** delete single row from the table: "registration_request" */
  delete_registration_request_by_pk?: Maybe<Registration_Request>;
  /** delete data from the table: "registration_request_tracking" */
  delete_registration_request_tracking?: Maybe<Registration_Request_Tracking_Mutation_Response>;
  /** delete single row from the table: "registration_request_tracking" */
  delete_registration_request_tracking_by_pk?: Maybe<Registration_Request_Tracking>;
  /** delete data from the table: "registration_request_tracking_status" */
  delete_registration_request_tracking_status?: Maybe<Registration_Request_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "registration_request_tracking_status" */
  delete_registration_request_tracking_status_by_pk?: Maybe<Registration_Request_Tracking_Status>;
  /** delete data from the table: "reminder" */
  delete_reminder?: Maybe<Reminder_Mutation_Response>;
  /** delete single row from the table: "reminder" */
  delete_reminder_by_pk?: Maybe<Reminder>;
  /** delete data from the table: "service" */
  delete_service?: Maybe<Service_Mutation_Response>;
  /** delete single row from the table: "service" */
  delete_service_by_pk?: Maybe<Service>;
  /** delete data from the table: "service_request" */
  delete_service_request?: Maybe<Service_Request_Mutation_Response>;
  /** delete single row from the table: "service_request" */
  delete_service_request_by_pk?: Maybe<Service_Request>;
  /** delete data from the table: "service_request_tracking" */
  delete_service_request_tracking?: Maybe<Service_Request_Tracking_Mutation_Response>;
  /** delete single row from the table: "service_request_tracking" */
  delete_service_request_tracking_by_pk?: Maybe<Service_Request_Tracking>;
  /** delete data from the table: "service_request_tracking_status" */
  delete_service_request_tracking_status?: Maybe<Service_Request_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "service_request_tracking_status" */
  delete_service_request_tracking_status_by_pk?: Maybe<Service_Request_Tracking_Status>;
  /** delete data from the table: "service_tracking" */
  delete_service_tracking?: Maybe<Service_Tracking_Mutation_Response>;
  /** delete single row from the table: "service_tracking" */
  delete_service_tracking_by_pk?: Maybe<Service_Tracking>;
  /** delete data from the table: "service_tracking_status" */
  delete_service_tracking_status?: Maybe<Service_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "service_tracking_status" */
  delete_service_tracking_status_by_pk?: Maybe<Service_Tracking_Status>;
  /** delete data from the table: "similar_trademark" */
  delete_similar_trademark?: Maybe<Similar_Trademark_Mutation_Response>;
  /** delete single row from the table: "similar_trademark" */
  delete_similar_trademark_by_pk?: Maybe<Similar_Trademark>;
  /** delete data from the table: "specimen" */
  delete_specimen?: Maybe<Specimen_Mutation_Response>;
  /** delete single row from the table: "specimen" */
  delete_specimen_by_pk?: Maybe<Specimen>;
  /** delete data from the table: "statistic" */
  delete_statistic?: Maybe<Statistic_Mutation_Response>;
  /** delete single row from the table: "statistic" */
  delete_statistic_by_pk?: Maybe<Statistic>;
  /** delete data from the table: "support_ticket" */
  delete_support_ticket?: Maybe<Support_Ticket_Mutation_Response>;
  /** delete single row from the table: "support_ticket" */
  delete_support_ticket_by_pk?: Maybe<Support_Ticket>;
  /** delete data from the table: "task" */
  delete_task?: Maybe<Task_Mutation_Response>;
  /** delete single row from the table: "task" */
  delete_task_by_pk?: Maybe<Task>;
  /** delete data from the table: "thread_comment" */
  delete_thread_comment?: Maybe<Thread_Comment_Mutation_Response>;
  /** delete single row from the table: "thread_comment" */
  delete_thread_comment_by_pk?: Maybe<Thread_Comment>;
  /** delete data from the table: "trademark" */
  delete_trademark?: Maybe<Trademark_Mutation_Response>;
  /** delete single row from the table: "trademark" */
  delete_trademark_by_pk?: Maybe<Trademark>;
  /** delete data from the table: "trademark_class" */
  delete_trademark_class?: Maybe<Trademark_Class_Mutation_Response>;
  /** delete single row from the table: "trademark_class" */
  delete_trademark_class_by_pk?: Maybe<Trademark_Class>;
  /** delete data from the table: "trademark_ipo_data" */
  delete_trademark_ipo_data?: Maybe<Trademark_Ipo_Data_Mutation_Response>;
  /** delete single row from the table: "trademark_ipo_data" */
  delete_trademark_ipo_data_by_pk?: Maybe<Trademark_Ipo_Data>;
  /** delete data from the table: "trademark_monitoring_result" */
  delete_trademark_monitoring_result?: Maybe<Trademark_Monitoring_Result_Mutation_Response>;
  /** delete single row from the table: "trademark_monitoring_result" */
  delete_trademark_monitoring_result_by_pk?: Maybe<Trademark_Monitoring_Result>;
  /** delete data from the table: "trademark_rate_limit_log" */
  delete_trademark_rate_limit_log?: Maybe<Trademark_Rate_Limit_Log_Mutation_Response>;
  /** delete single row from the table: "trademark_rate_limit_log" */
  delete_trademark_rate_limit_log_by_pk?: Maybe<Trademark_Rate_Limit_Log>;
  /** delete data from the table: "trademark_request" */
  delete_trademark_request?: Maybe<Trademark_Request_Mutation_Response>;
  /** delete single row from the table: "trademark_request" */
  delete_trademark_request_by_pk?: Maybe<Trademark_Request>;
  /** delete data from the table: "trademark_service_requests" */
  delete_trademark_service_requests?: Maybe<Trademark_Service_Requests_Mutation_Response>;
  /** delete single row from the table: "trademark_service_requests" */
  delete_trademark_service_requests_by_pk?: Maybe<Trademark_Service_Requests>;
  /** delete data from the table: "trademark_shared_documents" */
  delete_trademark_shared_documents?: Maybe<Trademark_Shared_Documents_Mutation_Response>;
  /** delete single row from the table: "trademark_shared_documents" */
  delete_trademark_shared_documents_by_pk?: Maybe<Trademark_Shared_Documents>;
  /** delete data from the table: "trademark_tracking" */
  delete_trademark_tracking?: Maybe<Trademark_Tracking_Mutation_Response>;
  /** delete single row from the table: "trademark_tracking" */
  delete_trademark_tracking_by_pk?: Maybe<Trademark_Tracking>;
  /** delete data from the table: "trademark_tracking_status" */
  delete_trademark_tracking_status?: Maybe<Trademark_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "trademark_tracking_status" */
  delete_trademark_tracking_status_by_pk?: Maybe<Trademark_Tracking_Status>;
  /** delete data from the table: "trademark_watch_subscription" */
  delete_trademark_watch_subscription?: Maybe<Trademark_Watch_Subscription_Mutation_Response>;
  /** delete single row from the table: "trademark_watch_subscription" */
  delete_trademark_watch_subscription_by_pk?: Maybe<Trademark_Watch_Subscription>;
  /** delete data from the table: "use_in_commerce_request" */
  delete_use_in_commerce_request?: Maybe<Use_In_Commerce_Request_Mutation_Response>;
  /** delete single row from the table: "use_in_commerce_request" */
  delete_use_in_commerce_request_by_pk?: Maybe<Use_In_Commerce_Request>;
  /** delete data from the table: "use_in_commerce_request_tracking" */
  delete_use_in_commerce_request_tracking?: Maybe<Use_In_Commerce_Request_Tracking_Mutation_Response>;
  /** delete single row from the table: "use_in_commerce_request_tracking" */
  delete_use_in_commerce_request_tracking_by_pk?: Maybe<Use_In_Commerce_Request_Tracking>;
  /** delete data from the table: "use_in_commerce_request_tracking_status" */
  delete_use_in_commerce_request_tracking_status?: Maybe<Use_In_Commerce_Request_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "use_in_commerce_request_tracking_status" */
  delete_use_in_commerce_request_tracking_status_by_pk?: Maybe<Use_In_Commerce_Request_Tracking_Status>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<User_Mutation_Response>;
  /** delete data from the table: "user_auth_log" */
  delete_user_auth_log?: Maybe<User_Auth_Log_Mutation_Response>;
  /** delete single row from the table: "user_auth_log" */
  delete_user_auth_log_by_pk?: Maybe<User_Auth_Log>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<User>;
  /** delete data from the table: "user_history" */
  delete_user_history?: Maybe<User_History_Mutation_Response>;
  /** delete single row from the table: "user_history" */
  delete_user_history_by_pk?: Maybe<User_History>;
  /** delete data from the table: "user_payment_method" */
  delete_user_payment_method?: Maybe<User_Payment_Method_Mutation_Response>;
  /** delete single row from the table: "user_payment_method" */
  delete_user_payment_method_by_pk?: Maybe<User_Payment_Method>;
  /** delete data from the table: "user_profile" */
  delete_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** delete single row from the table: "user_profile" */
  delete_user_profile_by_pk?: Maybe<User_Profile>;
  /** delete data from the table: "user_tracking" */
  delete_user_tracking?: Maybe<User_Tracking_Mutation_Response>;
  /** delete single row from the table: "user_tracking" */
  delete_user_tracking_by_pk?: Maybe<User_Tracking>;
  /** delete data from the table: "user_tracking_status" */
  delete_user_tracking_status?: Maybe<User_Tracking_Status_Mutation_Response>;
  /** delete single row from the table: "user_tracking_status" */
  delete_user_tracking_status_by_pk?: Maybe<User_Tracking_Status>;
  /** delete data from the table: "verification_result" */
  delete_verification_result?: Maybe<Verification_Result_Mutation_Response>;
  /** delete single row from the table: "verification_result" */
  delete_verification_result_by_pk?: Maybe<Verification_Result>;
  /** delete data from the table: "verification_result_similar_trademark_map" */
  delete_verification_result_similar_trademark_map?: Maybe<Verification_Result_Similar_Trademark_Map_Mutation_Response>;
  /** delete single row from the table: "verification_result_similar_trademark_map" */
  delete_verification_result_similar_trademark_map_by_pk?: Maybe<Verification_Result_Similar_Trademark_Map>;
  /** delete data from the table: "website" */
  delete_website?: Maybe<Website_Mutation_Response>;
  /** delete single row from the table: "website" */
  delete_website_by_pk?: Maybe<Website>;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "ai_gs_items_analysis" */
  insert_ai_gs_items_analysis?: Maybe<Ai_Gs_Items_Analysis_Mutation_Response>;
  /** insert a single row into the table: "ai_gs_items_analysis" */
  insert_ai_gs_items_analysis_one?: Maybe<Ai_Gs_Items_Analysis>;
  /** insert data into the table: "application" */
  insert_application?: Maybe<Application_Mutation_Response>;
  /** insert data into the table: "application_jurisdiction" */
  insert_application_jurisdiction?: Maybe<Application_Jurisdiction_Mutation_Response>;
  /** insert a single row into the table: "application_jurisdiction" */
  insert_application_jurisdiction_one?: Maybe<Application_Jurisdiction>;
  /** insert a single row into the table: "application" */
  insert_application_one?: Maybe<Application>;
  /** insert data into the table: "audit_log" */
  insert_audit_log?: Maybe<Audit_Log_Mutation_Response>;
  /** insert a single row into the table: "audit_log" */
  insert_audit_log_one?: Maybe<Audit_Log>;
  /** insert data into the table: "brand" */
  insert_brand?: Maybe<Brand_Mutation_Response>;
  /** insert data into the table: "brand_monitoring_task" */
  insert_brand_monitoring_task?: Maybe<Brand_Monitoring_Task_Mutation_Response>;
  /** insert a single row into the table: "brand_monitoring_task" */
  insert_brand_monitoring_task_one?: Maybe<Brand_Monitoring_Task>;
  /** insert data into the table: "brand_monitoring_task_tracking" */
  insert_brand_monitoring_task_tracking?: Maybe<Brand_Monitoring_Task_Tracking_Mutation_Response>;
  /** insert a single row into the table: "brand_monitoring_task_tracking" */
  insert_brand_monitoring_task_tracking_one?: Maybe<Brand_Monitoring_Task_Tracking>;
  /** insert data into the table: "brand_monitoring_task_tracking_status" */
  insert_brand_monitoring_task_tracking_status?: Maybe<Brand_Monitoring_Task_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "brand_monitoring_task_tracking_status" */
  insert_brand_monitoring_task_tracking_status_one?: Maybe<Brand_Monitoring_Task_Tracking_Status>;
  /** insert a single row into the table: "brand" */
  insert_brand_one?: Maybe<Brand>;
  /** insert data into the table: "brand_snapshot" */
  insert_brand_snapshot?: Maybe<Brand_Snapshot_Mutation_Response>;
  /** insert a single row into the table: "brand_snapshot" */
  insert_brand_snapshot_one?: Maybe<Brand_Snapshot>;
  /** insert data into the table: "brand_subscription" */
  insert_brand_subscription?: Maybe<Brand_Subscription_Mutation_Response>;
  /** insert a single row into the table: "brand_subscription" */
  insert_brand_subscription_one?: Maybe<Brand_Subscription>;
  /** insert data into the table: "brand_subscription_payment" */
  insert_brand_subscription_payment?: Maybe<Brand_Subscription_Payment_Mutation_Response>;
  /** insert a single row into the table: "brand_subscription_payment" */
  insert_brand_subscription_payment_one?: Maybe<Brand_Subscription_Payment>;
  /** insert data into the table: "brand_subscription_platform" */
  insert_brand_subscription_platform?: Maybe<Brand_Subscription_Platform_Mutation_Response>;
  /** insert a single row into the table: "brand_subscription_platform" */
  insert_brand_subscription_platform_one?: Maybe<Brand_Subscription_Platform>;
  /** insert data into the table: "brand_subscription_tracking" */
  insert_brand_subscription_tracking?: Maybe<Brand_Subscription_Tracking_Mutation_Response>;
  /** insert a single row into the table: "brand_subscription_tracking" */
  insert_brand_subscription_tracking_one?: Maybe<Brand_Subscription_Tracking>;
  /** insert data into the table: "brand_subscription_tracking_status" */
  insert_brand_subscription_tracking_status?: Maybe<Brand_Subscription_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "brand_subscription_tracking_status" */
  insert_brand_subscription_tracking_status_one?: Maybe<Brand_Subscription_Tracking_Status>;
  /** insert data into the table: "case" */
  insert_case?: Maybe<Case_Mutation_Response>;
  /** insert data into the table: "case_counterparty" */
  insert_case_counterparty?: Maybe<Case_Counterparty_Mutation_Response>;
  /** insert a single row into the table: "case_counterparty" */
  insert_case_counterparty_one?: Maybe<Case_Counterparty>;
  /** insert data into the table: "case_infringement" */
  insert_case_infringement?: Maybe<Case_Infringement_Mutation_Response>;
  /** insert data into the table: "case_infringement_evidence" */
  insert_case_infringement_evidence?: Maybe<Case_Infringement_Evidence_Mutation_Response>;
  /** insert a single row into the table: "case_infringement_evidence" */
  insert_case_infringement_evidence_one?: Maybe<Case_Infringement_Evidence>;
  /** insert a single row into the table: "case_infringement" */
  insert_case_infringement_one?: Maybe<Case_Infringement>;
  /** insert a single row into the table: "case" */
  insert_case_one?: Maybe<Case>;
  /** insert data into the table: "case_request" */
  insert_case_request?: Maybe<Case_Request_Mutation_Response>;
  /** insert a single row into the table: "case_request" */
  insert_case_request_one?: Maybe<Case_Request>;
  /** insert data into the table: "case_request_tracking" */
  insert_case_request_tracking?: Maybe<Case_Request_Tracking_Mutation_Response>;
  /** insert a single row into the table: "case_request_tracking" */
  insert_case_request_tracking_one?: Maybe<Case_Request_Tracking>;
  /** insert data into the table: "case_request_tracking_status" */
  insert_case_request_tracking_status?: Maybe<Case_Request_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "case_request_tracking_status" */
  insert_case_request_tracking_status_one?: Maybe<Case_Request_Tracking_Status>;
  /** insert data into the table: "case_solution" */
  insert_case_solution?: Maybe<Case_Solution_Mutation_Response>;
  /** insert a single row into the table: "case_solution" */
  insert_case_solution_one?: Maybe<Case_Solution>;
  /** insert data into the table: "case_tracking" */
  insert_case_tracking?: Maybe<Case_Tracking_Mutation_Response>;
  /** insert a single row into the table: "case_tracking" */
  insert_case_tracking_one?: Maybe<Case_Tracking>;
  /** insert data into the table: "case_tracking_status" */
  insert_case_tracking_status?: Maybe<Case_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "case_tracking_status" */
  insert_case_tracking_status_one?: Maybe<Case_Tracking_Status>;
  /** insert data into the table: "consultation" */
  insert_consultation?: Maybe<Consultation_Mutation_Response>;
  /** insert a single row into the table: "consultation" */
  insert_consultation_one?: Maybe<Consultation>;
  /** insert data into the table: "contentful" */
  insert_contentful?: Maybe<Contentful_Mutation_Response>;
  /** insert a single row into the table: "contentful" */
  insert_contentful_one?: Maybe<Contentful>;
  /** insert data into the table: "credit_note" */
  insert_credit_note?: Maybe<Credit_Note_Mutation_Response>;
  /** insert a single row into the table: "credit_note" */
  insert_credit_note_one?: Maybe<Credit_Note>;
  /** insert data into the table: "discount_coupon" */
  insert_discount_coupon?: Maybe<Discount_Coupon_Mutation_Response>;
  /** insert a single row into the table: "discount_coupon" */
  insert_discount_coupon_one?: Maybe<Discount_Coupon>;
  /** insert data into the table: "docketed_message" */
  insert_docketed_message?: Maybe<Docketed_Message_Mutation_Response>;
  /** insert a single row into the table: "docketed_message" */
  insert_docketed_message_one?: Maybe<Docketed_Message>;
  /** insert data into the table: "document" */
  insert_document?: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_folder" */
  insert_document_folder?: Maybe<Document_Folder_Mutation_Response>;
  /** insert a single row into the table: "document_folder" */
  insert_document_folder_one?: Maybe<Document_Folder>;
  /** insert data into the table: "document_hub" */
  insert_document_hub?: Maybe<Document_Hub_Mutation_Response>;
  /** insert a single row into the table: "document_hub" */
  insert_document_hub_one?: Maybe<Document_Hub>;
  /** insert a single row into the table: "document" */
  insert_document_one?: Maybe<Document>;
  /** insert data into the table: "entity" */
  insert_entity?: Maybe<Entity_Mutation_Response>;
  /** insert a single row into the table: "entity" */
  insert_entity_one?: Maybe<Entity>;
  /** insert data into the table: "exchange_rate" */
  insert_exchange_rate?: Maybe<Exchange_Rate_Mutation_Response>;
  /** insert a single row into the table: "exchange_rate" */
  insert_exchange_rate_one?: Maybe<Exchange_Rate>;
  /** insert data into the table: "external_trademark" */
  insert_external_trademark?: Maybe<External_Trademark_Mutation_Response>;
  /** insert a single row into the table: "external_trademark" */
  insert_external_trademark_one?: Maybe<External_Trademark>;
  /** insert data into the table: "invoice" */
  insert_invoice?: Maybe<Invoice_Mutation_Response>;
  /** insert a single row into the table: "invoice" */
  insert_invoice_one?: Maybe<Invoice>;
  /** insert data into the table: "note" */
  insert_note?: Maybe<Note_Mutation_Response>;
  /** insert data into the table: "note_hub" */
  insert_note_hub?: Maybe<Note_Hub_Mutation_Response>;
  /** insert a single row into the table: "note_hub" */
  insert_note_hub_one?: Maybe<Note_Hub>;
  /** insert a single row into the table: "note" */
  insert_note_one?: Maybe<Note>;
  /** insert data into the table: "notification" */
  insert_notification?: Maybe<Notification_Mutation_Response>;
  /** insert a single row into the table: "notification" */
  insert_notification_one?: Maybe<Notification>;
  /** insert data into the table: "office_action" */
  insert_office_action?: Maybe<Office_Action_Mutation_Response>;
  /** insert data into the table: "office_action_issue" */
  insert_office_action_issue?: Maybe<Office_Action_Issue_Mutation_Response>;
  /** insert a single row into the table: "office_action_issue" */
  insert_office_action_issue_one?: Maybe<Office_Action_Issue>;
  /** insert a single row into the table: "office_action" */
  insert_office_action_one?: Maybe<Office_Action>;
  /** insert data into the table: "office_action_similar_trademark_map" */
  insert_office_action_similar_trademark_map?: Maybe<Office_Action_Similar_Trademark_Map_Mutation_Response>;
  /** insert a single row into the table: "office_action_similar_trademark_map" */
  insert_office_action_similar_trademark_map_one?: Maybe<Office_Action_Similar_Trademark_Map>;
  /** insert data into the table: "office_action_solution" */
  insert_office_action_solution?: Maybe<Office_Action_Solution_Mutation_Response>;
  /** insert a single row into the table: "office_action_solution" */
  insert_office_action_solution_one?: Maybe<Office_Action_Solution>;
  /** insert data into the table: "office_action_tracking" */
  insert_office_action_tracking?: Maybe<Office_Action_Tracking_Mutation_Response>;
  /** insert a single row into the table: "office_action_tracking" */
  insert_office_action_tracking_one?: Maybe<Office_Action_Tracking>;
  /** insert data into the table: "office_action_tracking_status" */
  insert_office_action_tracking_status?: Maybe<Office_Action_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "office_action_tracking_status" */
  insert_office_action_tracking_status_one?: Maybe<Office_Action_Tracking_Status>;
  /** insert data into the table: "order" */
  insert_order?: Maybe<Order_Mutation_Response>;
  /** insert data into the table: "order_hub" */
  insert_order_hub?: Maybe<Order_Hub_Mutation_Response>;
  /** insert a single row into the table: "order_hub" */
  insert_order_hub_one?: Maybe<Order_Hub>;
  /** insert a single row into the table: "order" */
  insert_order_one?: Maybe<Order>;
  /** insert data into the table: "order_tracking" */
  insert_order_tracking?: Maybe<Order_Tracking_Mutation_Response>;
  /** insert a single row into the table: "order_tracking" */
  insert_order_tracking_one?: Maybe<Order_Tracking>;
  /** insert data into the table: "order_tracking_status" */
  insert_order_tracking_status?: Maybe<Order_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "order_tracking_status" */
  insert_order_tracking_status_one?: Maybe<Order_Tracking_Status>;
  /** insert data into the table: "poa" */
  insert_poa?: Maybe<Poa_Mutation_Response>;
  /** insert a single row into the table: "poa" */
  insert_poa_one?: Maybe<Poa>;
  /** insert data into the table: "price" */
  insert_price?: Maybe<Price_Mutation_Response>;
  /** insert a single row into the table: "price" */
  insert_price_one?: Maybe<Price>;
  /** insert data into the table: "price_rule" */
  insert_price_rule?: Maybe<Price_Rule_Mutation_Response>;
  /** insert a single row into the table: "price_rule" */
  insert_price_rule_one?: Maybe<Price_Rule>;
  /** insert data into the table: "product" */
  insert_product?: Maybe<Product_Mutation_Response>;
  /** insert data into the table: "product_bundle" */
  insert_product_bundle?: Maybe<Product_Bundle_Mutation_Response>;
  /** insert a single row into the table: "product_bundle" */
  insert_product_bundle_one?: Maybe<Product_Bundle>;
  /** insert data into the table: "product_event" */
  insert_product_event?: Maybe<Product_Event_Mutation_Response>;
  /** insert a single row into the table: "product_event" */
  insert_product_event_one?: Maybe<Product_Event>;
  /** insert a single row into the table: "product" */
  insert_product_one?: Maybe<Product>;
  /** insert data into the table: "product_v2" */
  insert_product_v2?: Maybe<Product_V2_Mutation_Response>;
  /** insert a single row into the table: "product_v2" */
  insert_product_v2_one?: Maybe<Product_V2>;
  /** insert data into the table: "quote" */
  insert_quote?: Maybe<Quote_Mutation_Response>;
  /** insert data into the table: "quote_hub" */
  insert_quote_hub?: Maybe<Quote_Hub_Mutation_Response>;
  /** insert a single row into the table: "quote_hub" */
  insert_quote_hub_one?: Maybe<Quote_Hub>;
  /** insert data into the table: "quote_item" */
  insert_quote_item?: Maybe<Quote_Item_Mutation_Response>;
  /** insert a single row into the table: "quote_item" */
  insert_quote_item_one?: Maybe<Quote_Item>;
  /** insert a single row into the table: "quote" */
  insert_quote_one?: Maybe<Quote>;
  /** insert data into the table: "refund_request" */
  insert_refund_request?: Maybe<Refund_Request_Mutation_Response>;
  /** insert data into the table: "refund_request_invoice" */
  insert_refund_request_invoice?: Maybe<Refund_Request_Invoice_Mutation_Response>;
  /** insert a single row into the table: "refund_request_invoice" */
  insert_refund_request_invoice_one?: Maybe<Refund_Request_Invoice>;
  /** insert a single row into the table: "refund_request" */
  insert_refund_request_one?: Maybe<Refund_Request>;
  /** insert data into the table: "refund_request_tracking" */
  insert_refund_request_tracking?: Maybe<Refund_Request_Tracking_Mutation_Response>;
  /** insert a single row into the table: "refund_request_tracking" */
  insert_refund_request_tracking_one?: Maybe<Refund_Request_Tracking>;
  /** insert data into the table: "refund_request_tracking_status" */
  insert_refund_request_tracking_status?: Maybe<Refund_Request_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "refund_request_tracking_status" */
  insert_refund_request_tracking_status_one?: Maybe<Refund_Request_Tracking_Status>;
  /** insert data into the table: "registration_request" */
  insert_registration_request?: Maybe<Registration_Request_Mutation_Response>;
  /** insert a single row into the table: "registration_request" */
  insert_registration_request_one?: Maybe<Registration_Request>;
  /** insert data into the table: "registration_request_tracking" */
  insert_registration_request_tracking?: Maybe<Registration_Request_Tracking_Mutation_Response>;
  /** insert a single row into the table: "registration_request_tracking" */
  insert_registration_request_tracking_one?: Maybe<Registration_Request_Tracking>;
  /** insert data into the table: "registration_request_tracking_status" */
  insert_registration_request_tracking_status?: Maybe<Registration_Request_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "registration_request_tracking_status" */
  insert_registration_request_tracking_status_one?: Maybe<Registration_Request_Tracking_Status>;
  /** insert data into the table: "reminder" */
  insert_reminder?: Maybe<Reminder_Mutation_Response>;
  /** insert a single row into the table: "reminder" */
  insert_reminder_one?: Maybe<Reminder>;
  /** insert data into the table: "service" */
  insert_service?: Maybe<Service_Mutation_Response>;
  /** insert a single row into the table: "service" */
  insert_service_one?: Maybe<Service>;
  /** insert data into the table: "service_request" */
  insert_service_request?: Maybe<Service_Request_Mutation_Response>;
  /** insert a single row into the table: "service_request" */
  insert_service_request_one?: Maybe<Service_Request>;
  /** insert data into the table: "service_request_tracking" */
  insert_service_request_tracking?: Maybe<Service_Request_Tracking_Mutation_Response>;
  /** insert a single row into the table: "service_request_tracking" */
  insert_service_request_tracking_one?: Maybe<Service_Request_Tracking>;
  /** insert data into the table: "service_request_tracking_status" */
  insert_service_request_tracking_status?: Maybe<Service_Request_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "service_request_tracking_status" */
  insert_service_request_tracking_status_one?: Maybe<Service_Request_Tracking_Status>;
  /** insert data into the table: "service_tracking" */
  insert_service_tracking?: Maybe<Service_Tracking_Mutation_Response>;
  /** insert a single row into the table: "service_tracking" */
  insert_service_tracking_one?: Maybe<Service_Tracking>;
  /** insert data into the table: "service_tracking_status" */
  insert_service_tracking_status?: Maybe<Service_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "service_tracking_status" */
  insert_service_tracking_status_one?: Maybe<Service_Tracking_Status>;
  /** insert data into the table: "similar_trademark" */
  insert_similar_trademark?: Maybe<Similar_Trademark_Mutation_Response>;
  /** insert a single row into the table: "similar_trademark" */
  insert_similar_trademark_one?: Maybe<Similar_Trademark>;
  /** insert data into the table: "specimen" */
  insert_specimen?: Maybe<Specimen_Mutation_Response>;
  /** insert a single row into the table: "specimen" */
  insert_specimen_one?: Maybe<Specimen>;
  /** insert data into the table: "statistic" */
  insert_statistic?: Maybe<Statistic_Mutation_Response>;
  /** insert a single row into the table: "statistic" */
  insert_statistic_one?: Maybe<Statistic>;
  /** insert data into the table: "support_ticket" */
  insert_support_ticket?: Maybe<Support_Ticket_Mutation_Response>;
  /** insert a single row into the table: "support_ticket" */
  insert_support_ticket_one?: Maybe<Support_Ticket>;
  /** insert data into the table: "task" */
  insert_task?: Maybe<Task_Mutation_Response>;
  /** insert a single row into the table: "task" */
  insert_task_one?: Maybe<Task>;
  /** insert data into the table: "thread_comment" */
  insert_thread_comment?: Maybe<Thread_Comment_Mutation_Response>;
  /** insert a single row into the table: "thread_comment" */
  insert_thread_comment_one?: Maybe<Thread_Comment>;
  /** insert data into the table: "trademark" */
  insert_trademark?: Maybe<Trademark_Mutation_Response>;
  /** insert data into the table: "trademark_class" */
  insert_trademark_class?: Maybe<Trademark_Class_Mutation_Response>;
  /** insert a single row into the table: "trademark_class" */
  insert_trademark_class_one?: Maybe<Trademark_Class>;
  /** insert data into the table: "trademark_ipo_data" */
  insert_trademark_ipo_data?: Maybe<Trademark_Ipo_Data_Mutation_Response>;
  /** insert a single row into the table: "trademark_ipo_data" */
  insert_trademark_ipo_data_one?: Maybe<Trademark_Ipo_Data>;
  /** insert data into the table: "trademark_monitoring_result" */
  insert_trademark_monitoring_result?: Maybe<Trademark_Monitoring_Result_Mutation_Response>;
  /** insert a single row into the table: "trademark_monitoring_result" */
  insert_trademark_monitoring_result_one?: Maybe<Trademark_Monitoring_Result>;
  /** insert a single row into the table: "trademark" */
  insert_trademark_one?: Maybe<Trademark>;
  /** insert data into the table: "trademark_rate_limit_log" */
  insert_trademark_rate_limit_log?: Maybe<Trademark_Rate_Limit_Log_Mutation_Response>;
  /** insert a single row into the table: "trademark_rate_limit_log" */
  insert_trademark_rate_limit_log_one?: Maybe<Trademark_Rate_Limit_Log>;
  /** insert data into the table: "trademark_request" */
  insert_trademark_request?: Maybe<Trademark_Request_Mutation_Response>;
  /** insert a single row into the table: "trademark_request" */
  insert_trademark_request_one?: Maybe<Trademark_Request>;
  /** insert data into the table: "trademark_service_requests" */
  insert_trademark_service_requests?: Maybe<Trademark_Service_Requests_Mutation_Response>;
  /** insert a single row into the table: "trademark_service_requests" */
  insert_trademark_service_requests_one?: Maybe<Trademark_Service_Requests>;
  /** insert data into the table: "trademark_shared_documents" */
  insert_trademark_shared_documents?: Maybe<Trademark_Shared_Documents_Mutation_Response>;
  /** insert a single row into the table: "trademark_shared_documents" */
  insert_trademark_shared_documents_one?: Maybe<Trademark_Shared_Documents>;
  /** insert data into the table: "trademark_tracking" */
  insert_trademark_tracking?: Maybe<Trademark_Tracking_Mutation_Response>;
  /** insert a single row into the table: "trademark_tracking" */
  insert_trademark_tracking_one?: Maybe<Trademark_Tracking>;
  /** insert data into the table: "trademark_tracking_status" */
  insert_trademark_tracking_status?: Maybe<Trademark_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "trademark_tracking_status" */
  insert_trademark_tracking_status_one?: Maybe<Trademark_Tracking_Status>;
  /** insert data into the table: "trademark_watch_subscription" */
  insert_trademark_watch_subscription?: Maybe<Trademark_Watch_Subscription_Mutation_Response>;
  /** insert a single row into the table: "trademark_watch_subscription" */
  insert_trademark_watch_subscription_one?: Maybe<Trademark_Watch_Subscription>;
  /** insert data into the table: "use_in_commerce_request" */
  insert_use_in_commerce_request?: Maybe<Use_In_Commerce_Request_Mutation_Response>;
  /** insert a single row into the table: "use_in_commerce_request" */
  insert_use_in_commerce_request_one?: Maybe<Use_In_Commerce_Request>;
  /** insert data into the table: "use_in_commerce_request_tracking" */
  insert_use_in_commerce_request_tracking?: Maybe<Use_In_Commerce_Request_Tracking_Mutation_Response>;
  /** insert a single row into the table: "use_in_commerce_request_tracking" */
  insert_use_in_commerce_request_tracking_one?: Maybe<Use_In_Commerce_Request_Tracking>;
  /** insert data into the table: "use_in_commerce_request_tracking_status" */
  insert_use_in_commerce_request_tracking_status?: Maybe<Use_In_Commerce_Request_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "use_in_commerce_request_tracking_status" */
  insert_use_in_commerce_request_tracking_status_one?: Maybe<Use_In_Commerce_Request_Tracking_Status>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<User_Mutation_Response>;
  /** insert data into the table: "user_auth_log" */
  insert_user_auth_log?: Maybe<User_Auth_Log_Mutation_Response>;
  /** insert a single row into the table: "user_auth_log" */
  insert_user_auth_log_one?: Maybe<User_Auth_Log>;
  /** insert data into the table: "user_history" */
  insert_user_history?: Maybe<User_History_Mutation_Response>;
  /** insert a single row into the table: "user_history" */
  insert_user_history_one?: Maybe<User_History>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<User>;
  /** insert data into the table: "user_payment_method" */
  insert_user_payment_method?: Maybe<User_Payment_Method_Mutation_Response>;
  /** insert a single row into the table: "user_payment_method" */
  insert_user_payment_method_one?: Maybe<User_Payment_Method>;
  /** insert data into the table: "user_profile" */
  insert_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** insert a single row into the table: "user_profile" */
  insert_user_profile_one?: Maybe<User_Profile>;
  /** insert data into the table: "user_tracking" */
  insert_user_tracking?: Maybe<User_Tracking_Mutation_Response>;
  /** insert a single row into the table: "user_tracking" */
  insert_user_tracking_one?: Maybe<User_Tracking>;
  /** insert data into the table: "user_tracking_status" */
  insert_user_tracking_status?: Maybe<User_Tracking_Status_Mutation_Response>;
  /** insert a single row into the table: "user_tracking_status" */
  insert_user_tracking_status_one?: Maybe<User_Tracking_Status>;
  /** insert data into the table: "verification_result" */
  insert_verification_result?: Maybe<Verification_Result_Mutation_Response>;
  /** insert a single row into the table: "verification_result" */
  insert_verification_result_one?: Maybe<Verification_Result>;
  /** insert data into the table: "verification_result_similar_trademark_map" */
  insert_verification_result_similar_trademark_map?: Maybe<Verification_Result_Similar_Trademark_Map_Mutation_Response>;
  /** insert a single row into the table: "verification_result_similar_trademark_map" */
  insert_verification_result_similar_trademark_map_one?: Maybe<Verification_Result_Similar_Trademark_Map>;
  /** insert data into the table: "website" */
  insert_website?: Maybe<Website_Mutation_Response>;
  /** insert a single row into the table: "website" */
  insert_website_one?: Maybe<Website>;
  /** execute VOLATILE function "invoice_mark_as_paid" which returns "invoice" */
  invoice_mark_as_paid: Array<Invoice>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "ai_gs_items_analysis" */
  update_ai_gs_items_analysis?: Maybe<Ai_Gs_Items_Analysis_Mutation_Response>;
  /** update single row of the table: "ai_gs_items_analysis" */
  update_ai_gs_items_analysis_by_pk?: Maybe<Ai_Gs_Items_Analysis>;
  /** update multiples rows of table: "ai_gs_items_analysis" */
  update_ai_gs_items_analysis_many?: Maybe<Array<Maybe<Ai_Gs_Items_Analysis_Mutation_Response>>>;
  /** update data of the table: "application" */
  update_application?: Maybe<Application_Mutation_Response>;
  /** update single row of the table: "application" */
  update_application_by_pk?: Maybe<Application>;
  /** update data of the table: "application_jurisdiction" */
  update_application_jurisdiction?: Maybe<Application_Jurisdiction_Mutation_Response>;
  /** update single row of the table: "application_jurisdiction" */
  update_application_jurisdiction_by_pk?: Maybe<Application_Jurisdiction>;
  /** update multiples rows of table: "application_jurisdiction" */
  update_application_jurisdiction_many?: Maybe<Array<Maybe<Application_Jurisdiction_Mutation_Response>>>;
  /** update multiples rows of table: "application" */
  update_application_many?: Maybe<Array<Maybe<Application_Mutation_Response>>>;
  /** update data of the table: "audit_log" */
  update_audit_log?: Maybe<Audit_Log_Mutation_Response>;
  /** update multiples rows of table: "audit_log" */
  update_audit_log_many?: Maybe<Array<Maybe<Audit_Log_Mutation_Response>>>;
  /** update data of the table: "brand" */
  update_brand?: Maybe<Brand_Mutation_Response>;
  /** update single row of the table: "brand" */
  update_brand_by_pk?: Maybe<Brand>;
  /** update multiples rows of table: "brand" */
  update_brand_many?: Maybe<Array<Maybe<Brand_Mutation_Response>>>;
  /** update data of the table: "brand_monitoring_task" */
  update_brand_monitoring_task?: Maybe<Brand_Monitoring_Task_Mutation_Response>;
  /** update single row of the table: "brand_monitoring_task" */
  update_brand_monitoring_task_by_pk?: Maybe<Brand_Monitoring_Task>;
  /** update multiples rows of table: "brand_monitoring_task" */
  update_brand_monitoring_task_many?: Maybe<Array<Maybe<Brand_Monitoring_Task_Mutation_Response>>>;
  /** update data of the table: "brand_monitoring_task_tracking" */
  update_brand_monitoring_task_tracking?: Maybe<Brand_Monitoring_Task_Tracking_Mutation_Response>;
  /** update single row of the table: "brand_monitoring_task_tracking" */
  update_brand_monitoring_task_tracking_by_pk?: Maybe<Brand_Monitoring_Task_Tracking>;
  /** update multiples rows of table: "brand_monitoring_task_tracking" */
  update_brand_monitoring_task_tracking_many?: Maybe<Array<Maybe<Brand_Monitoring_Task_Tracking_Mutation_Response>>>;
  /** update data of the table: "brand_monitoring_task_tracking_status" */
  update_brand_monitoring_task_tracking_status?: Maybe<Brand_Monitoring_Task_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "brand_monitoring_task_tracking_status" */
  update_brand_monitoring_task_tracking_status_by_pk?: Maybe<Brand_Monitoring_Task_Tracking_Status>;
  /** update multiples rows of table: "brand_monitoring_task_tracking_status" */
  update_brand_monitoring_task_tracking_status_many?: Maybe<Array<Maybe<Brand_Monitoring_Task_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "brand_snapshot" */
  update_brand_snapshot?: Maybe<Brand_Snapshot_Mutation_Response>;
  /** update single row of the table: "brand_snapshot" */
  update_brand_snapshot_by_pk?: Maybe<Brand_Snapshot>;
  /** update multiples rows of table: "brand_snapshot" */
  update_brand_snapshot_many?: Maybe<Array<Maybe<Brand_Snapshot_Mutation_Response>>>;
  /** update data of the table: "brand_subscription" */
  update_brand_subscription?: Maybe<Brand_Subscription_Mutation_Response>;
  /** update single row of the table: "brand_subscription" */
  update_brand_subscription_by_pk?: Maybe<Brand_Subscription>;
  /** update multiples rows of table: "brand_subscription" */
  update_brand_subscription_many?: Maybe<Array<Maybe<Brand_Subscription_Mutation_Response>>>;
  /** update data of the table: "brand_subscription_payment" */
  update_brand_subscription_payment?: Maybe<Brand_Subscription_Payment_Mutation_Response>;
  /** update single row of the table: "brand_subscription_payment" */
  update_brand_subscription_payment_by_pk?: Maybe<Brand_Subscription_Payment>;
  /** update multiples rows of table: "brand_subscription_payment" */
  update_brand_subscription_payment_many?: Maybe<Array<Maybe<Brand_Subscription_Payment_Mutation_Response>>>;
  /** update data of the table: "brand_subscription_platform" */
  update_brand_subscription_platform?: Maybe<Brand_Subscription_Platform_Mutation_Response>;
  /** update single row of the table: "brand_subscription_platform" */
  update_brand_subscription_platform_by_pk?: Maybe<Brand_Subscription_Platform>;
  /** update multiples rows of table: "brand_subscription_platform" */
  update_brand_subscription_platform_many?: Maybe<Array<Maybe<Brand_Subscription_Platform_Mutation_Response>>>;
  /** update data of the table: "brand_subscription_tracking" */
  update_brand_subscription_tracking?: Maybe<Brand_Subscription_Tracking_Mutation_Response>;
  /** update single row of the table: "brand_subscription_tracking" */
  update_brand_subscription_tracking_by_pk?: Maybe<Brand_Subscription_Tracking>;
  /** update multiples rows of table: "brand_subscription_tracking" */
  update_brand_subscription_tracking_many?: Maybe<Array<Maybe<Brand_Subscription_Tracking_Mutation_Response>>>;
  /** update data of the table: "brand_subscription_tracking_status" */
  update_brand_subscription_tracking_status?: Maybe<Brand_Subscription_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "brand_subscription_tracking_status" */
  update_brand_subscription_tracking_status_by_pk?: Maybe<Brand_Subscription_Tracking_Status>;
  /** update multiples rows of table: "brand_subscription_tracking_status" */
  update_brand_subscription_tracking_status_many?: Maybe<Array<Maybe<Brand_Subscription_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "case" */
  update_case?: Maybe<Case_Mutation_Response>;
  /** update single row of the table: "case" */
  update_case_by_pk?: Maybe<Case>;
  /** update data of the table: "case_counterparty" */
  update_case_counterparty?: Maybe<Case_Counterparty_Mutation_Response>;
  /** update single row of the table: "case_counterparty" */
  update_case_counterparty_by_pk?: Maybe<Case_Counterparty>;
  /** update multiples rows of table: "case_counterparty" */
  update_case_counterparty_many?: Maybe<Array<Maybe<Case_Counterparty_Mutation_Response>>>;
  /** update data of the table: "case_infringement" */
  update_case_infringement?: Maybe<Case_Infringement_Mutation_Response>;
  /** update single row of the table: "case_infringement" */
  update_case_infringement_by_pk?: Maybe<Case_Infringement>;
  /** update data of the table: "case_infringement_evidence" */
  update_case_infringement_evidence?: Maybe<Case_Infringement_Evidence_Mutation_Response>;
  /** update single row of the table: "case_infringement_evidence" */
  update_case_infringement_evidence_by_pk?: Maybe<Case_Infringement_Evidence>;
  /** update multiples rows of table: "case_infringement_evidence" */
  update_case_infringement_evidence_many?: Maybe<Array<Maybe<Case_Infringement_Evidence_Mutation_Response>>>;
  /** update multiples rows of table: "case_infringement" */
  update_case_infringement_many?: Maybe<Array<Maybe<Case_Infringement_Mutation_Response>>>;
  /** update multiples rows of table: "case" */
  update_case_many?: Maybe<Array<Maybe<Case_Mutation_Response>>>;
  /** update data of the table: "case_request" */
  update_case_request?: Maybe<Case_Request_Mutation_Response>;
  /** update single row of the table: "case_request" */
  update_case_request_by_pk?: Maybe<Case_Request>;
  /** update multiples rows of table: "case_request" */
  update_case_request_many?: Maybe<Array<Maybe<Case_Request_Mutation_Response>>>;
  /** update data of the table: "case_request_tracking" */
  update_case_request_tracking?: Maybe<Case_Request_Tracking_Mutation_Response>;
  /** update single row of the table: "case_request_tracking" */
  update_case_request_tracking_by_pk?: Maybe<Case_Request_Tracking>;
  /** update multiples rows of table: "case_request_tracking" */
  update_case_request_tracking_many?: Maybe<Array<Maybe<Case_Request_Tracking_Mutation_Response>>>;
  /** update data of the table: "case_request_tracking_status" */
  update_case_request_tracking_status?: Maybe<Case_Request_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "case_request_tracking_status" */
  update_case_request_tracking_status_by_pk?: Maybe<Case_Request_Tracking_Status>;
  /** update multiples rows of table: "case_request_tracking_status" */
  update_case_request_tracking_status_many?: Maybe<Array<Maybe<Case_Request_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "case_solution" */
  update_case_solution?: Maybe<Case_Solution_Mutation_Response>;
  /** update single row of the table: "case_solution" */
  update_case_solution_by_pk?: Maybe<Case_Solution>;
  /** update multiples rows of table: "case_solution" */
  update_case_solution_many?: Maybe<Array<Maybe<Case_Solution_Mutation_Response>>>;
  /** update data of the table: "case_tracking" */
  update_case_tracking?: Maybe<Case_Tracking_Mutation_Response>;
  /** update single row of the table: "case_tracking" */
  update_case_tracking_by_pk?: Maybe<Case_Tracking>;
  /** update multiples rows of table: "case_tracking" */
  update_case_tracking_many?: Maybe<Array<Maybe<Case_Tracking_Mutation_Response>>>;
  /** update data of the table: "case_tracking_status" */
  update_case_tracking_status?: Maybe<Case_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "case_tracking_status" */
  update_case_tracking_status_by_pk?: Maybe<Case_Tracking_Status>;
  /** update multiples rows of table: "case_tracking_status" */
  update_case_tracking_status_many?: Maybe<Array<Maybe<Case_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "consultation" */
  update_consultation?: Maybe<Consultation_Mutation_Response>;
  /** update single row of the table: "consultation" */
  update_consultation_by_pk?: Maybe<Consultation>;
  /** update multiples rows of table: "consultation" */
  update_consultation_many?: Maybe<Array<Maybe<Consultation_Mutation_Response>>>;
  /** update data of the table: "contentful" */
  update_contentful?: Maybe<Contentful_Mutation_Response>;
  /** update single row of the table: "contentful" */
  update_contentful_by_pk?: Maybe<Contentful>;
  /** update multiples rows of table: "contentful" */
  update_contentful_many?: Maybe<Array<Maybe<Contentful_Mutation_Response>>>;
  /** update data of the table: "credit_note" */
  update_credit_note?: Maybe<Credit_Note_Mutation_Response>;
  /** update single row of the table: "credit_note" */
  update_credit_note_by_pk?: Maybe<Credit_Note>;
  /** update multiples rows of table: "credit_note" */
  update_credit_note_many?: Maybe<Array<Maybe<Credit_Note_Mutation_Response>>>;
  /** update data of the table: "discount_coupon" */
  update_discount_coupon?: Maybe<Discount_Coupon_Mutation_Response>;
  /** update single row of the table: "discount_coupon" */
  update_discount_coupon_by_pk?: Maybe<Discount_Coupon>;
  /** update multiples rows of table: "discount_coupon" */
  update_discount_coupon_many?: Maybe<Array<Maybe<Discount_Coupon_Mutation_Response>>>;
  /** update data of the table: "docketed_message" */
  update_docketed_message?: Maybe<Docketed_Message_Mutation_Response>;
  /** update single row of the table: "docketed_message" */
  update_docketed_message_by_pk?: Maybe<Docketed_Message>;
  /** update multiples rows of table: "docketed_message" */
  update_docketed_message_many?: Maybe<Array<Maybe<Docketed_Message_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document?: Maybe<Document_Mutation_Response>;
  /** update single row of the table: "document" */
  update_document_by_pk?: Maybe<Document>;
  /** update data of the table: "document_folder" */
  update_document_folder?: Maybe<Document_Folder_Mutation_Response>;
  /** update single row of the table: "document_folder" */
  update_document_folder_by_pk?: Maybe<Document_Folder>;
  /** update multiples rows of table: "document_folder" */
  update_document_folder_many?: Maybe<Array<Maybe<Document_Folder_Mutation_Response>>>;
  /** update data of the table: "document_hub" */
  update_document_hub?: Maybe<Document_Hub_Mutation_Response>;
  /** update single row of the table: "document_hub" */
  update_document_hub_by_pk?: Maybe<Document_Hub>;
  /** update multiples rows of table: "document_hub" */
  update_document_hub_many?: Maybe<Array<Maybe<Document_Hub_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many?: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "entity" */
  update_entity?: Maybe<Entity_Mutation_Response>;
  /** update single row of the table: "entity" */
  update_entity_by_pk?: Maybe<Entity>;
  /** update multiples rows of table: "entity" */
  update_entity_many?: Maybe<Array<Maybe<Entity_Mutation_Response>>>;
  /** update data of the table: "exchange_rate" */
  update_exchange_rate?: Maybe<Exchange_Rate_Mutation_Response>;
  /** update single row of the table: "exchange_rate" */
  update_exchange_rate_by_pk?: Maybe<Exchange_Rate>;
  /** update multiples rows of table: "exchange_rate" */
  update_exchange_rate_many?: Maybe<Array<Maybe<Exchange_Rate_Mutation_Response>>>;
  /** update data of the table: "external_trademark" */
  update_external_trademark?: Maybe<External_Trademark_Mutation_Response>;
  /** update single row of the table: "external_trademark" */
  update_external_trademark_by_pk?: Maybe<External_Trademark>;
  /** update multiples rows of table: "external_trademark" */
  update_external_trademark_many?: Maybe<Array<Maybe<External_Trademark_Mutation_Response>>>;
  /** update data of the table: "invoice" */
  update_invoice?: Maybe<Invoice_Mutation_Response>;
  /** update single row of the table: "invoice" */
  update_invoice_by_pk?: Maybe<Invoice>;
  /** update multiples rows of table: "invoice" */
  update_invoice_many?: Maybe<Array<Maybe<Invoice_Mutation_Response>>>;
  /** update data of the table: "note" */
  update_note?: Maybe<Note_Mutation_Response>;
  /** update single row of the table: "note" */
  update_note_by_pk?: Maybe<Note>;
  /** update data of the table: "note_hub" */
  update_note_hub?: Maybe<Note_Hub_Mutation_Response>;
  /** update single row of the table: "note_hub" */
  update_note_hub_by_pk?: Maybe<Note_Hub>;
  /** update multiples rows of table: "note_hub" */
  update_note_hub_many?: Maybe<Array<Maybe<Note_Hub_Mutation_Response>>>;
  /** update multiples rows of table: "note" */
  update_note_many?: Maybe<Array<Maybe<Note_Mutation_Response>>>;
  /** update data of the table: "notification" */
  update_notification?: Maybe<Notification_Mutation_Response>;
  /** update single row of the table: "notification" */
  update_notification_by_pk?: Maybe<Notification>;
  /** update multiples rows of table: "notification" */
  update_notification_many?: Maybe<Array<Maybe<Notification_Mutation_Response>>>;
  /** update data of the table: "office_action" */
  update_office_action?: Maybe<Office_Action_Mutation_Response>;
  /** update single row of the table: "office_action" */
  update_office_action_by_pk?: Maybe<Office_Action>;
  /** update data of the table: "office_action_issue" */
  update_office_action_issue?: Maybe<Office_Action_Issue_Mutation_Response>;
  /** update single row of the table: "office_action_issue" */
  update_office_action_issue_by_pk?: Maybe<Office_Action_Issue>;
  /** update multiples rows of table: "office_action_issue" */
  update_office_action_issue_many?: Maybe<Array<Maybe<Office_Action_Issue_Mutation_Response>>>;
  /** update multiples rows of table: "office_action" */
  update_office_action_many?: Maybe<Array<Maybe<Office_Action_Mutation_Response>>>;
  /** update data of the table: "office_action_similar_trademark_map" */
  update_office_action_similar_trademark_map?: Maybe<Office_Action_Similar_Trademark_Map_Mutation_Response>;
  /** update single row of the table: "office_action_similar_trademark_map" */
  update_office_action_similar_trademark_map_by_pk?: Maybe<Office_Action_Similar_Trademark_Map>;
  /** update multiples rows of table: "office_action_similar_trademark_map" */
  update_office_action_similar_trademark_map_many?: Maybe<Array<Maybe<Office_Action_Similar_Trademark_Map_Mutation_Response>>>;
  /** update data of the table: "office_action_solution" */
  update_office_action_solution?: Maybe<Office_Action_Solution_Mutation_Response>;
  /** update single row of the table: "office_action_solution" */
  update_office_action_solution_by_pk?: Maybe<Office_Action_Solution>;
  /** update multiples rows of table: "office_action_solution" */
  update_office_action_solution_many?: Maybe<Array<Maybe<Office_Action_Solution_Mutation_Response>>>;
  /** update data of the table: "office_action_tracking" */
  update_office_action_tracking?: Maybe<Office_Action_Tracking_Mutation_Response>;
  /** update single row of the table: "office_action_tracking" */
  update_office_action_tracking_by_pk?: Maybe<Office_Action_Tracking>;
  /** update multiples rows of table: "office_action_tracking" */
  update_office_action_tracking_many?: Maybe<Array<Maybe<Office_Action_Tracking_Mutation_Response>>>;
  /** update data of the table: "office_action_tracking_status" */
  update_office_action_tracking_status?: Maybe<Office_Action_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "office_action_tracking_status" */
  update_office_action_tracking_status_by_pk?: Maybe<Office_Action_Tracking_Status>;
  /** update multiples rows of table: "office_action_tracking_status" */
  update_office_action_tracking_status_many?: Maybe<Array<Maybe<Office_Action_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update data of the table: "order_hub" */
  update_order_hub?: Maybe<Order_Hub_Mutation_Response>;
  /** update single row of the table: "order_hub" */
  update_order_hub_by_pk?: Maybe<Order_Hub>;
  /** update multiples rows of table: "order_hub" */
  update_order_hub_many?: Maybe<Array<Maybe<Order_Hub_Mutation_Response>>>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "order_tracking" */
  update_order_tracking?: Maybe<Order_Tracking_Mutation_Response>;
  /** update single row of the table: "order_tracking" */
  update_order_tracking_by_pk?: Maybe<Order_Tracking>;
  /** update multiples rows of table: "order_tracking" */
  update_order_tracking_many?: Maybe<Array<Maybe<Order_Tracking_Mutation_Response>>>;
  /** update data of the table: "order_tracking_status" */
  update_order_tracking_status?: Maybe<Order_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "order_tracking_status" */
  update_order_tracking_status_by_pk?: Maybe<Order_Tracking_Status>;
  /** update multiples rows of table: "order_tracking_status" */
  update_order_tracking_status_many?: Maybe<Array<Maybe<Order_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "poa" */
  update_poa?: Maybe<Poa_Mutation_Response>;
  /** update single row of the table: "poa" */
  update_poa_by_pk?: Maybe<Poa>;
  /** update multiples rows of table: "poa" */
  update_poa_many?: Maybe<Array<Maybe<Poa_Mutation_Response>>>;
  /** update data of the table: "price" */
  update_price?: Maybe<Price_Mutation_Response>;
  /** update single row of the table: "price" */
  update_price_by_pk?: Maybe<Price>;
  /** update multiples rows of table: "price" */
  update_price_many?: Maybe<Array<Maybe<Price_Mutation_Response>>>;
  /** update data of the table: "price_rule" */
  update_price_rule?: Maybe<Price_Rule_Mutation_Response>;
  /** update single row of the table: "price_rule" */
  update_price_rule_by_pk?: Maybe<Price_Rule>;
  /** update multiples rows of table: "price_rule" */
  update_price_rule_many?: Maybe<Array<Maybe<Price_Rule_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update data of the table: "product_bundle" */
  update_product_bundle?: Maybe<Product_Bundle_Mutation_Response>;
  /** update single row of the table: "product_bundle" */
  update_product_bundle_by_pk?: Maybe<Product_Bundle>;
  /** update multiples rows of table: "product_bundle" */
  update_product_bundle_many?: Maybe<Array<Maybe<Product_Bundle_Mutation_Response>>>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update data of the table: "product_event" */
  update_product_event?: Maybe<Product_Event_Mutation_Response>;
  /** update single row of the table: "product_event" */
  update_product_event_by_pk?: Maybe<Product_Event>;
  /** update multiples rows of table: "product_event" */
  update_product_event_many?: Maybe<Array<Maybe<Product_Event_Mutation_Response>>>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
  /** update data of the table: "product_v2" */
  update_product_v2?: Maybe<Product_V2_Mutation_Response>;
  /** update single row of the table: "product_v2" */
  update_product_v2_by_pk?: Maybe<Product_V2>;
  /** update multiples rows of table: "product_v2" */
  update_product_v2_many?: Maybe<Array<Maybe<Product_V2_Mutation_Response>>>;
  /** update data of the table: "quote" */
  update_quote?: Maybe<Quote_Mutation_Response>;
  /** update single row of the table: "quote" */
  update_quote_by_pk?: Maybe<Quote>;
  /** update data of the table: "quote_hub" */
  update_quote_hub?: Maybe<Quote_Hub_Mutation_Response>;
  /** update single row of the table: "quote_hub" */
  update_quote_hub_by_pk?: Maybe<Quote_Hub>;
  /** update multiples rows of table: "quote_hub" */
  update_quote_hub_many?: Maybe<Array<Maybe<Quote_Hub_Mutation_Response>>>;
  /** update data of the table: "quote_item" */
  update_quote_item?: Maybe<Quote_Item_Mutation_Response>;
  /** update single row of the table: "quote_item" */
  update_quote_item_by_pk?: Maybe<Quote_Item>;
  /** update multiples rows of table: "quote_item" */
  update_quote_item_many?: Maybe<Array<Maybe<Quote_Item_Mutation_Response>>>;
  /** update multiples rows of table: "quote" */
  update_quote_many?: Maybe<Array<Maybe<Quote_Mutation_Response>>>;
  /** update data of the table: "refund_request" */
  update_refund_request?: Maybe<Refund_Request_Mutation_Response>;
  /** update single row of the table: "refund_request" */
  update_refund_request_by_pk?: Maybe<Refund_Request>;
  /** update data of the table: "refund_request_invoice" */
  update_refund_request_invoice?: Maybe<Refund_Request_Invoice_Mutation_Response>;
  /** update single row of the table: "refund_request_invoice" */
  update_refund_request_invoice_by_pk?: Maybe<Refund_Request_Invoice>;
  /** update multiples rows of table: "refund_request_invoice" */
  update_refund_request_invoice_many?: Maybe<Array<Maybe<Refund_Request_Invoice_Mutation_Response>>>;
  /** update multiples rows of table: "refund_request" */
  update_refund_request_many?: Maybe<Array<Maybe<Refund_Request_Mutation_Response>>>;
  /** update data of the table: "refund_request_tracking" */
  update_refund_request_tracking?: Maybe<Refund_Request_Tracking_Mutation_Response>;
  /** update single row of the table: "refund_request_tracking" */
  update_refund_request_tracking_by_pk?: Maybe<Refund_Request_Tracking>;
  /** update multiples rows of table: "refund_request_tracking" */
  update_refund_request_tracking_many?: Maybe<Array<Maybe<Refund_Request_Tracking_Mutation_Response>>>;
  /** update data of the table: "refund_request_tracking_status" */
  update_refund_request_tracking_status?: Maybe<Refund_Request_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "refund_request_tracking_status" */
  update_refund_request_tracking_status_by_pk?: Maybe<Refund_Request_Tracking_Status>;
  /** update multiples rows of table: "refund_request_tracking_status" */
  update_refund_request_tracking_status_many?: Maybe<Array<Maybe<Refund_Request_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "registration_request" */
  update_registration_request?: Maybe<Registration_Request_Mutation_Response>;
  /** update single row of the table: "registration_request" */
  update_registration_request_by_pk?: Maybe<Registration_Request>;
  /** update multiples rows of table: "registration_request" */
  update_registration_request_many?: Maybe<Array<Maybe<Registration_Request_Mutation_Response>>>;
  /** update data of the table: "registration_request_tracking" */
  update_registration_request_tracking?: Maybe<Registration_Request_Tracking_Mutation_Response>;
  /** update single row of the table: "registration_request_tracking" */
  update_registration_request_tracking_by_pk?: Maybe<Registration_Request_Tracking>;
  /** update multiples rows of table: "registration_request_tracking" */
  update_registration_request_tracking_many?: Maybe<Array<Maybe<Registration_Request_Tracking_Mutation_Response>>>;
  /** update data of the table: "registration_request_tracking_status" */
  update_registration_request_tracking_status?: Maybe<Registration_Request_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "registration_request_tracking_status" */
  update_registration_request_tracking_status_by_pk?: Maybe<Registration_Request_Tracking_Status>;
  /** update multiples rows of table: "registration_request_tracking_status" */
  update_registration_request_tracking_status_many?: Maybe<Array<Maybe<Registration_Request_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "reminder" */
  update_reminder?: Maybe<Reminder_Mutation_Response>;
  /** update single row of the table: "reminder" */
  update_reminder_by_pk?: Maybe<Reminder>;
  /** update multiples rows of table: "reminder" */
  update_reminder_many?: Maybe<Array<Maybe<Reminder_Mutation_Response>>>;
  /** update data of the table: "service" */
  update_service?: Maybe<Service_Mutation_Response>;
  /** update single row of the table: "service" */
  update_service_by_pk?: Maybe<Service>;
  /** update multiples rows of table: "service" */
  update_service_many?: Maybe<Array<Maybe<Service_Mutation_Response>>>;
  /** update data of the table: "service_request" */
  update_service_request?: Maybe<Service_Request_Mutation_Response>;
  /** update single row of the table: "service_request" */
  update_service_request_by_pk?: Maybe<Service_Request>;
  /** update multiples rows of table: "service_request" */
  update_service_request_many?: Maybe<Array<Maybe<Service_Request_Mutation_Response>>>;
  /** update data of the table: "service_request_tracking" */
  update_service_request_tracking?: Maybe<Service_Request_Tracking_Mutation_Response>;
  /** update single row of the table: "service_request_tracking" */
  update_service_request_tracking_by_pk?: Maybe<Service_Request_Tracking>;
  /** update multiples rows of table: "service_request_tracking" */
  update_service_request_tracking_many?: Maybe<Array<Maybe<Service_Request_Tracking_Mutation_Response>>>;
  /** update data of the table: "service_request_tracking_status" */
  update_service_request_tracking_status?: Maybe<Service_Request_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "service_request_tracking_status" */
  update_service_request_tracking_status_by_pk?: Maybe<Service_Request_Tracking_Status>;
  /** update multiples rows of table: "service_request_tracking_status" */
  update_service_request_tracking_status_many?: Maybe<Array<Maybe<Service_Request_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "service_tracking" */
  update_service_tracking?: Maybe<Service_Tracking_Mutation_Response>;
  /** update single row of the table: "service_tracking" */
  update_service_tracking_by_pk?: Maybe<Service_Tracking>;
  /** update multiples rows of table: "service_tracking" */
  update_service_tracking_many?: Maybe<Array<Maybe<Service_Tracking_Mutation_Response>>>;
  /** update data of the table: "service_tracking_status" */
  update_service_tracking_status?: Maybe<Service_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "service_tracking_status" */
  update_service_tracking_status_by_pk?: Maybe<Service_Tracking_Status>;
  /** update multiples rows of table: "service_tracking_status" */
  update_service_tracking_status_many?: Maybe<Array<Maybe<Service_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "similar_trademark" */
  update_similar_trademark?: Maybe<Similar_Trademark_Mutation_Response>;
  /** update single row of the table: "similar_trademark" */
  update_similar_trademark_by_pk?: Maybe<Similar_Trademark>;
  /** update multiples rows of table: "similar_trademark" */
  update_similar_trademark_many?: Maybe<Array<Maybe<Similar_Trademark_Mutation_Response>>>;
  /** update data of the table: "specimen" */
  update_specimen?: Maybe<Specimen_Mutation_Response>;
  /** update single row of the table: "specimen" */
  update_specimen_by_pk?: Maybe<Specimen>;
  /** update multiples rows of table: "specimen" */
  update_specimen_many?: Maybe<Array<Maybe<Specimen_Mutation_Response>>>;
  /** update data of the table: "statistic" */
  update_statistic?: Maybe<Statistic_Mutation_Response>;
  /** update single row of the table: "statistic" */
  update_statistic_by_pk?: Maybe<Statistic>;
  /** update multiples rows of table: "statistic" */
  update_statistic_many?: Maybe<Array<Maybe<Statistic_Mutation_Response>>>;
  /** update data of the table: "support_ticket" */
  update_support_ticket?: Maybe<Support_Ticket_Mutation_Response>;
  /** update single row of the table: "support_ticket" */
  update_support_ticket_by_pk?: Maybe<Support_Ticket>;
  /** update multiples rows of table: "support_ticket" */
  update_support_ticket_many?: Maybe<Array<Maybe<Support_Ticket_Mutation_Response>>>;
  /** update data of the table: "task" */
  update_task?: Maybe<Task_Mutation_Response>;
  /** update single row of the table: "task" */
  update_task_by_pk?: Maybe<Task>;
  /** update multiples rows of table: "task" */
  update_task_many?: Maybe<Array<Maybe<Task_Mutation_Response>>>;
  /** update data of the table: "thread_comment" */
  update_thread_comment?: Maybe<Thread_Comment_Mutation_Response>;
  /** update single row of the table: "thread_comment" */
  update_thread_comment_by_pk?: Maybe<Thread_Comment>;
  /** update multiples rows of table: "thread_comment" */
  update_thread_comment_many?: Maybe<Array<Maybe<Thread_Comment_Mutation_Response>>>;
  /** update data of the table: "trademark" */
  update_trademark?: Maybe<Trademark_Mutation_Response>;
  /** update single row of the table: "trademark" */
  update_trademark_by_pk?: Maybe<Trademark>;
  /** update data of the table: "trademark_class" */
  update_trademark_class?: Maybe<Trademark_Class_Mutation_Response>;
  /** update single row of the table: "trademark_class" */
  update_trademark_class_by_pk?: Maybe<Trademark_Class>;
  /** update multiples rows of table: "trademark_class" */
  update_trademark_class_many?: Maybe<Array<Maybe<Trademark_Class_Mutation_Response>>>;
  /** update data of the table: "trademark_ipo_data" */
  update_trademark_ipo_data?: Maybe<Trademark_Ipo_Data_Mutation_Response>;
  /** update single row of the table: "trademark_ipo_data" */
  update_trademark_ipo_data_by_pk?: Maybe<Trademark_Ipo_Data>;
  /** update multiples rows of table: "trademark_ipo_data" */
  update_trademark_ipo_data_many?: Maybe<Array<Maybe<Trademark_Ipo_Data_Mutation_Response>>>;
  /** update multiples rows of table: "trademark" */
  update_trademark_many?: Maybe<Array<Maybe<Trademark_Mutation_Response>>>;
  /** update data of the table: "trademark_monitoring_result" */
  update_trademark_monitoring_result?: Maybe<Trademark_Monitoring_Result_Mutation_Response>;
  /** update single row of the table: "trademark_monitoring_result" */
  update_trademark_monitoring_result_by_pk?: Maybe<Trademark_Monitoring_Result>;
  /** update multiples rows of table: "trademark_monitoring_result" */
  update_trademark_monitoring_result_many?: Maybe<Array<Maybe<Trademark_Monitoring_Result_Mutation_Response>>>;
  /** update data of the table: "trademark_rate_limit_log" */
  update_trademark_rate_limit_log?: Maybe<Trademark_Rate_Limit_Log_Mutation_Response>;
  /** update single row of the table: "trademark_rate_limit_log" */
  update_trademark_rate_limit_log_by_pk?: Maybe<Trademark_Rate_Limit_Log>;
  /** update multiples rows of table: "trademark_rate_limit_log" */
  update_trademark_rate_limit_log_many?: Maybe<Array<Maybe<Trademark_Rate_Limit_Log_Mutation_Response>>>;
  /** update data of the table: "trademark_request" */
  update_trademark_request?: Maybe<Trademark_Request_Mutation_Response>;
  /** update single row of the table: "trademark_request" */
  update_trademark_request_by_pk?: Maybe<Trademark_Request>;
  /** update multiples rows of table: "trademark_request" */
  update_trademark_request_many?: Maybe<Array<Maybe<Trademark_Request_Mutation_Response>>>;
  /** update data of the table: "trademark_service_requests" */
  update_trademark_service_requests?: Maybe<Trademark_Service_Requests_Mutation_Response>;
  /** update single row of the table: "trademark_service_requests" */
  update_trademark_service_requests_by_pk?: Maybe<Trademark_Service_Requests>;
  /** update multiples rows of table: "trademark_service_requests" */
  update_trademark_service_requests_many?: Maybe<Array<Maybe<Trademark_Service_Requests_Mutation_Response>>>;
  /** update data of the table: "trademark_shared_documents" */
  update_trademark_shared_documents?: Maybe<Trademark_Shared_Documents_Mutation_Response>;
  /** update single row of the table: "trademark_shared_documents" */
  update_trademark_shared_documents_by_pk?: Maybe<Trademark_Shared_Documents>;
  /** update multiples rows of table: "trademark_shared_documents" */
  update_trademark_shared_documents_many?: Maybe<Array<Maybe<Trademark_Shared_Documents_Mutation_Response>>>;
  /** update data of the table: "trademark_tracking" */
  update_trademark_tracking?: Maybe<Trademark_Tracking_Mutation_Response>;
  /** update single row of the table: "trademark_tracking" */
  update_trademark_tracking_by_pk?: Maybe<Trademark_Tracking>;
  /** update multiples rows of table: "trademark_tracking" */
  update_trademark_tracking_many?: Maybe<Array<Maybe<Trademark_Tracking_Mutation_Response>>>;
  /** update data of the table: "trademark_tracking_status" */
  update_trademark_tracking_status?: Maybe<Trademark_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "trademark_tracking_status" */
  update_trademark_tracking_status_by_pk?: Maybe<Trademark_Tracking_Status>;
  /** update multiples rows of table: "trademark_tracking_status" */
  update_trademark_tracking_status_many?: Maybe<Array<Maybe<Trademark_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "trademark_watch_subscription" */
  update_trademark_watch_subscription?: Maybe<Trademark_Watch_Subscription_Mutation_Response>;
  /** update single row of the table: "trademark_watch_subscription" */
  update_trademark_watch_subscription_by_pk?: Maybe<Trademark_Watch_Subscription>;
  /** update multiples rows of table: "trademark_watch_subscription" */
  update_trademark_watch_subscription_many?: Maybe<Array<Maybe<Trademark_Watch_Subscription_Mutation_Response>>>;
  /** update data of the table: "use_in_commerce_request" */
  update_use_in_commerce_request?: Maybe<Use_In_Commerce_Request_Mutation_Response>;
  /** update single row of the table: "use_in_commerce_request" */
  update_use_in_commerce_request_by_pk?: Maybe<Use_In_Commerce_Request>;
  /** update multiples rows of table: "use_in_commerce_request" */
  update_use_in_commerce_request_many?: Maybe<Array<Maybe<Use_In_Commerce_Request_Mutation_Response>>>;
  /** update data of the table: "use_in_commerce_request_tracking" */
  update_use_in_commerce_request_tracking?: Maybe<Use_In_Commerce_Request_Tracking_Mutation_Response>;
  /** update single row of the table: "use_in_commerce_request_tracking" */
  update_use_in_commerce_request_tracking_by_pk?: Maybe<Use_In_Commerce_Request_Tracking>;
  /** update multiples rows of table: "use_in_commerce_request_tracking" */
  update_use_in_commerce_request_tracking_many?: Maybe<Array<Maybe<Use_In_Commerce_Request_Tracking_Mutation_Response>>>;
  /** update data of the table: "use_in_commerce_request_tracking_status" */
  update_use_in_commerce_request_tracking_status?: Maybe<Use_In_Commerce_Request_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "use_in_commerce_request_tracking_status" */
  update_use_in_commerce_request_tracking_status_by_pk?: Maybe<Use_In_Commerce_Request_Tracking_Status>;
  /** update multiples rows of table: "use_in_commerce_request_tracking_status" */
  update_use_in_commerce_request_tracking_status_many?: Maybe<Array<Maybe<Use_In_Commerce_Request_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update data of the table: "user_auth_log" */
  update_user_auth_log?: Maybe<User_Auth_Log_Mutation_Response>;
  /** update single row of the table: "user_auth_log" */
  update_user_auth_log_by_pk?: Maybe<User_Auth_Log>;
  /** update multiples rows of table: "user_auth_log" */
  update_user_auth_log_many?: Maybe<Array<Maybe<User_Auth_Log_Mutation_Response>>>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update data of the table: "user_history" */
  update_user_history?: Maybe<User_History_Mutation_Response>;
  /** update single row of the table: "user_history" */
  update_user_history_by_pk?: Maybe<User_History>;
  /** update multiples rows of table: "user_history" */
  update_user_history_many?: Maybe<Array<Maybe<User_History_Mutation_Response>>>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_payment_method" */
  update_user_payment_method?: Maybe<User_Payment_Method_Mutation_Response>;
  /** update single row of the table: "user_payment_method" */
  update_user_payment_method_by_pk?: Maybe<User_Payment_Method>;
  /** update multiples rows of table: "user_payment_method" */
  update_user_payment_method_many?: Maybe<Array<Maybe<User_Payment_Method_Mutation_Response>>>;
  /** update data of the table: "user_profile" */
  update_user_profile?: Maybe<User_Profile_Mutation_Response>;
  /** update single row of the table: "user_profile" */
  update_user_profile_by_pk?: Maybe<User_Profile>;
  /** update multiples rows of table: "user_profile" */
  update_user_profile_many?: Maybe<Array<Maybe<User_Profile_Mutation_Response>>>;
  /** update data of the table: "user_tracking" */
  update_user_tracking?: Maybe<User_Tracking_Mutation_Response>;
  /** update single row of the table: "user_tracking" */
  update_user_tracking_by_pk?: Maybe<User_Tracking>;
  /** update multiples rows of table: "user_tracking" */
  update_user_tracking_many?: Maybe<Array<Maybe<User_Tracking_Mutation_Response>>>;
  /** update data of the table: "user_tracking_status" */
  update_user_tracking_status?: Maybe<User_Tracking_Status_Mutation_Response>;
  /** update single row of the table: "user_tracking_status" */
  update_user_tracking_status_by_pk?: Maybe<User_Tracking_Status>;
  /** update multiples rows of table: "user_tracking_status" */
  update_user_tracking_status_many?: Maybe<Array<Maybe<User_Tracking_Status_Mutation_Response>>>;
  /** update data of the table: "verification_result" */
  update_verification_result?: Maybe<Verification_Result_Mutation_Response>;
  /** update single row of the table: "verification_result" */
  update_verification_result_by_pk?: Maybe<Verification_Result>;
  /** update multiples rows of table: "verification_result" */
  update_verification_result_many?: Maybe<Array<Maybe<Verification_Result_Mutation_Response>>>;
  /** update data of the table: "verification_result_similar_trademark_map" */
  update_verification_result_similar_trademark_map?: Maybe<Verification_Result_Similar_Trademark_Map_Mutation_Response>;
  /** update single row of the table: "verification_result_similar_trademark_map" */
  update_verification_result_similar_trademark_map_by_pk?: Maybe<Verification_Result_Similar_Trademark_Map>;
  /** update multiples rows of table: "verification_result_similar_trademark_map" */
  update_verification_result_similar_trademark_map_many?: Maybe<Array<Maybe<Verification_Result_Similar_Trademark_Map_Mutation_Response>>>;
  /** update data of the table: "website" */
  update_website?: Maybe<Website_Mutation_Response>;
  /** update single row of the table: "website" */
  update_website_by_pk?: Maybe<Website>;
  /** update multiples rows of table: "website" */
  update_website_many?: Maybe<Array<Maybe<Website_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Address_By_Pk_AuditedArgs = {
  args: Delete_Address_By_Pk_Audited_Args;
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Gs_Items_AnalysisArgs = {
  where: Ai_Gs_Items_Analysis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ai_Gs_Items_Analysis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ApplicationArgs = {
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Application_JurisdictionArgs = {
  where: Application_Jurisdiction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Application_Jurisdiction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Audit_LogArgs = {
  where: Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BrandArgs = {
  where: Brand_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_TaskArgs = {
  where: Brand_Monitoring_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_Task_TrackingArgs = {
  where: Brand_Monitoring_Task_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_Task_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_Task_Tracking_StatusArgs = {
  where: Brand_Monitoring_Task_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Monitoring_Task_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_SnapshotArgs = {
  where: Brand_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_SubscriptionArgs = {
  where: Brand_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_PaymentArgs = {
  where: Brand_Subscription_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_PlatformArgs = {
  where: Brand_Subscription_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_Platform_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_TrackingArgs = {
  where: Brand_Subscription_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_Tracking_StatusArgs = {
  where: Brand_Subscription_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Brand_Subscription_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CaseArgs = {
  where: Case_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_CounterpartyArgs = {
  where: Case_Counterparty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Counterparty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_InfringementArgs = {
  where: Case_Infringement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Infringement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_Infringement_EvidenceArgs = {
  where: Case_Infringement_Evidence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Infringement_Evidence_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_RequestArgs = {
  where: Case_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_Request_TrackingArgs = {
  where: Case_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_Request_Tracking_StatusArgs = {
  where: Case_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['case_request_status']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_SolutionArgs = {
  where: Case_Solution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_TrackingArgs = {
  where: Case_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Case_Tracking_StatusArgs = {
  where: Case_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Case_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ConsultationArgs = {
  where: Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Consultation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ContentfulArgs = {
  where: Contentful_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contentful_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Credit_NoteArgs = {
  where: Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Credit_Note_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Discount_CouponArgs = {
  where: Discount_Coupon_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Discount_Coupon_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Docketed_MessageArgs = {
  where: Docketed_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Docketed_Message_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_FolderArgs = {
  where: Document_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Document_HubArgs = {
  where: Document_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EntityArgs = {
  where: Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Entity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Exchange_RateArgs = {
  where: Exchange_Rate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exchange_Rate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_External_TrademarkArgs = {
  where: External_Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_External_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvoiceArgs = {
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoice_By_PkArgs = {
  variable_symbol: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NoteArgs = {
  where: Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Note_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Note_HubArgs = {
  where: Note_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Note_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationArgs = {
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_ActionArgs = {
  where: Office_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_IssueArgs = {
  where: Office_Action_Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Similar_Trademark_MapArgs = {
  where: Office_Action_Similar_Trademark_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_SolutionArgs = {
  where: Office_Action_Solution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_TrackingArgs = {
  where: Office_Action_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Tracking_StatusArgs = {
  where: Office_Action_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Office_Action_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrderArgs = {
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_HubArgs = {
  where: Order_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_TrackingArgs = {
  where: Order_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Order_Tracking_StatusArgs = {
  where: Order_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PoaArgs = {
  where: Poa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Poa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PriceArgs = {
  where: Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Price_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Price_RuleArgs = {
  where: Price_Rule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Price_Rule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ProductArgs = {
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_BundleArgs = {
  where: Product_Bundle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Bundle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_EventArgs = {
  where: Product_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Product_V2Args = {
  where: Product_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Product_V2_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuoteArgs = {
  where: Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_HubArgs = {
  where: Quote_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Quote_ItemArgs = {
  where: Quote_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Quote_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_RequestArgs = {
  where: Refund_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_InvoiceArgs = {
  where: Refund_Request_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_Invoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_TrackingArgs = {
  where: Refund_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_Tracking_StatusArgs = {
  where: Refund_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Refund_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Registration_RequestArgs = {
  where: Registration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registration_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Registration_Request_TrackingArgs = {
  where: Registration_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registration_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Registration_Request_Tracking_StatusArgs = {
  where: Registration_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Registration_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReminderArgs = {
  where: Reminder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reminder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceArgs = {
  where: Service_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_RequestArgs = {
  where: Service_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_TrackingArgs = {
  where: Service_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Tracking_StatusArgs = {
  where: Service_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_TrackingArgs = {
  where: Service_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Service_Tracking_StatusArgs = {
  where: Service_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Service_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Similar_TrademarkArgs = {
  where: Similar_Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Similar_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpecimenArgs = {
  where: Specimen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Specimen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_StatisticArgs = {
  where: Statistic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Statistic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Support_TicketArgs = {
  where: Support_Ticket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Support_Ticket_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaskArgs = {
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Task_By_PkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_CommentArgs = {
  where: Thread_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Thread_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TrademarkArgs = {
  where: Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_ClassArgs = {
  where: Trademark_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Class_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Ipo_DataArgs = {
  where: Trademark_Ipo_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Ipo_Data_By_PkArgs = {
  jurisdiction: Scalars['String']['input'];
  number: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Monitoring_ResultArgs = {
  where: Trademark_Monitoring_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Monitoring_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Rate_Limit_LogArgs = {
  where: Trademark_Rate_Limit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Rate_Limit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_RequestArgs = {
  where: Trademark_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Service_RequestsArgs = {
  where: Trademark_Service_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Service_Requests_By_PkArgs = {
  service_request_id: Scalars['uuid']['input'];
  trademark_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Shared_DocumentsArgs = {
  where: Trademark_Shared_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Shared_Documents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_TrackingArgs = {
  where: Trademark_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Tracking_StatusArgs = {
  where: Trademark_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Watch_SubscriptionArgs = {
  where: Trademark_Watch_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trademark_Watch_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_RequestArgs = {
  where: Use_In_Commerce_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_Request_TrackingArgs = {
  where: Use_In_Commerce_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_Request_Tracking_StatusArgs = {
  where: Use_In_Commerce_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Use_In_Commerce_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_LogArgs = {
  where: User_Auth_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_HistoryArgs = {
  where: User_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Payment_MethodArgs = {
  where: User_Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Payment_Method_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ProfileArgs = {
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Profile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_TrackingArgs = {
  where: User_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Tracking_StatusArgs = {
  where: User_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Verification_ResultArgs = {
  where: Verification_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Verification_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Verification_Result_Similar_Trademark_MapArgs = {
  where: Verification_Result_Similar_Trademark_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Verification_Result_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WebsiteArgs = {
  where: Website_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Website_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Gs_Items_AnalysisArgs = {
  objects: Array<Ai_Gs_Items_Analysis_Insert_Input>;
  on_conflict?: InputMaybe<Ai_Gs_Items_Analysis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ai_Gs_Items_Analysis_OneArgs = {
  object: Ai_Gs_Items_Analysis_Insert_Input;
  on_conflict?: InputMaybe<Ai_Gs_Items_Analysis_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ApplicationArgs = {
  objects: Array<Application_Insert_Input>;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_JurisdictionArgs = {
  objects: Array<Application_Jurisdiction_Insert_Input>;
  on_conflict?: InputMaybe<Application_Jurisdiction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_Jurisdiction_OneArgs = {
  object: Application_Jurisdiction_Insert_Input;
  on_conflict?: InputMaybe<Application_Jurisdiction_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Application_OneArgs = {
  object: Application_Insert_Input;
  on_conflict?: InputMaybe<Application_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_LogArgs = {
  objects: Array<Audit_Log_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Audit_Log_OneArgs = {
  object: Audit_Log_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_BrandArgs = {
  objects: Array<Brand_Insert_Input>;
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_TaskArgs = {
  objects: Array<Brand_Monitoring_Task_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_Task_OneArgs = {
  object: Brand_Monitoring_Task_Insert_Input;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_Task_TrackingArgs = {
  objects: Array<Brand_Monitoring_Task_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_Task_Tracking_OneArgs = {
  object: Brand_Monitoring_Task_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_Task_Tracking_StatusArgs = {
  objects: Array<Brand_Monitoring_Task_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Monitoring_Task_Tracking_Status_OneArgs = {
  object: Brand_Monitoring_Task_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_OneArgs = {
  object: Brand_Insert_Input;
  on_conflict?: InputMaybe<Brand_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_SnapshotArgs = {
  objects: Array<Brand_Snapshot_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Snapshot_OneArgs = {
  object: Brand_Snapshot_Insert_Input;
  on_conflict?: InputMaybe<Brand_Snapshot_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_SubscriptionArgs = {
  objects: Array<Brand_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_OneArgs = {
  object: Brand_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Brand_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_PaymentArgs = {
  objects: Array<Brand_Subscription_Payment_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Subscription_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_Payment_OneArgs = {
  object: Brand_Subscription_Payment_Insert_Input;
  on_conflict?: InputMaybe<Brand_Subscription_Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_PlatformArgs = {
  objects: Array<Brand_Subscription_Platform_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Subscription_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_Platform_OneArgs = {
  object: Brand_Subscription_Platform_Insert_Input;
  on_conflict?: InputMaybe<Brand_Subscription_Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_TrackingArgs = {
  objects: Array<Brand_Subscription_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_Tracking_OneArgs = {
  object: Brand_Subscription_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_Tracking_StatusArgs = {
  objects: Array<Brand_Subscription_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Brand_Subscription_Tracking_Status_OneArgs = {
  object: Brand_Subscription_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Brand_Subscription_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CaseArgs = {
  objects: Array<Case_Insert_Input>;
  on_conflict?: InputMaybe<Case_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_CounterpartyArgs = {
  objects: Array<Case_Counterparty_Insert_Input>;
  on_conflict?: InputMaybe<Case_Counterparty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Counterparty_OneArgs = {
  object: Case_Counterparty_Insert_Input;
  on_conflict?: InputMaybe<Case_Counterparty_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_InfringementArgs = {
  objects: Array<Case_Infringement_Insert_Input>;
  on_conflict?: InputMaybe<Case_Infringement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Infringement_EvidenceArgs = {
  objects: Array<Case_Infringement_Evidence_Insert_Input>;
  on_conflict?: InputMaybe<Case_Infringement_Evidence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Infringement_Evidence_OneArgs = {
  object: Case_Infringement_Evidence_Insert_Input;
  on_conflict?: InputMaybe<Case_Infringement_Evidence_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Infringement_OneArgs = {
  object: Case_Infringement_Insert_Input;
  on_conflict?: InputMaybe<Case_Infringement_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_OneArgs = {
  object: Case_Insert_Input;
  on_conflict?: InputMaybe<Case_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_RequestArgs = {
  objects: Array<Case_Request_Insert_Input>;
  on_conflict?: InputMaybe<Case_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Request_OneArgs = {
  object: Case_Request_Insert_Input;
  on_conflict?: InputMaybe<Case_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Request_TrackingArgs = {
  objects: Array<Case_Request_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Case_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Request_Tracking_OneArgs = {
  object: Case_Request_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Case_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Request_Tracking_StatusArgs = {
  objects: Array<Case_Request_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Case_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Request_Tracking_Status_OneArgs = {
  object: Case_Request_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Case_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_SolutionArgs = {
  objects: Array<Case_Solution_Insert_Input>;
  on_conflict?: InputMaybe<Case_Solution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Solution_OneArgs = {
  object: Case_Solution_Insert_Input;
  on_conflict?: InputMaybe<Case_Solution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_TrackingArgs = {
  objects: Array<Case_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Case_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Tracking_OneArgs = {
  object: Case_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Case_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Tracking_StatusArgs = {
  objects: Array<Case_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Case_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Case_Tracking_Status_OneArgs = {
  object: Case_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Case_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ConsultationArgs = {
  objects: Array<Consultation_Insert_Input>;
  on_conflict?: InputMaybe<Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Consultation_OneArgs = {
  object: Consultation_Insert_Input;
  on_conflict?: InputMaybe<Consultation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContentfulArgs = {
  objects: Array<Contentful_Insert_Input>;
  on_conflict?: InputMaybe<Contentful_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contentful_OneArgs = {
  object: Contentful_Insert_Input;
  on_conflict?: InputMaybe<Contentful_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_NoteArgs = {
  objects: Array<Credit_Note_Insert_Input>;
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Credit_Note_OneArgs = {
  object: Credit_Note_Insert_Input;
  on_conflict?: InputMaybe<Credit_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_CouponArgs = {
  objects: Array<Discount_Coupon_Insert_Input>;
  on_conflict?: InputMaybe<Discount_Coupon_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Discount_Coupon_OneArgs = {
  object: Discount_Coupon_Insert_Input;
  on_conflict?: InputMaybe<Discount_Coupon_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Docketed_MessageArgs = {
  objects: Array<Docketed_Message_Insert_Input>;
  on_conflict?: InputMaybe<Docketed_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Docketed_Message_OneArgs = {
  object: Docketed_Message_Insert_Input;
  on_conflict?: InputMaybe<Docketed_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_FolderArgs = {
  objects: Array<Document_Folder_Insert_Input>;
  on_conflict?: InputMaybe<Document_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Folder_OneArgs = {
  object: Document_Folder_Insert_Input;
  on_conflict?: InputMaybe<Document_Folder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_HubArgs = {
  objects: Array<Document_Hub_Insert_Input>;
  on_conflict?: InputMaybe<Document_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Hub_OneArgs = {
  object: Document_Hub_Insert_Input;
  on_conflict?: InputMaybe<Document_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EntityArgs = {
  objects: Array<Entity_Insert_Input>;
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Entity_OneArgs = {
  object: Entity_Insert_Input;
  on_conflict?: InputMaybe<Entity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_RateArgs = {
  objects: Array<Exchange_Rate_Insert_Input>;
  on_conflict?: InputMaybe<Exchange_Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exchange_Rate_OneArgs = {
  object: Exchange_Rate_Insert_Input;
  on_conflict?: InputMaybe<Exchange_Rate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_TrademarkArgs = {
  objects: Array<External_Trademark_Insert_Input>;
  on_conflict?: InputMaybe<External_Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_External_Trademark_OneArgs = {
  object: External_Trademark_Insert_Input;
  on_conflict?: InputMaybe<External_Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoiceArgs = {
  objects: Array<Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoice_OneArgs = {
  object: Invoice_Insert_Input;
  on_conflict?: InputMaybe<Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NoteArgs = {
  objects: Array<Note_Insert_Input>;
  on_conflict?: InputMaybe<Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Note_HubArgs = {
  objects: Array<Note_Hub_Insert_Input>;
  on_conflict?: InputMaybe<Note_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Note_Hub_OneArgs = {
  object: Note_Hub_Insert_Input;
  on_conflict?: InputMaybe<Note_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Note_OneArgs = {
  object: Note_Insert_Input;
  on_conflict?: InputMaybe<Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationArgs = {
  objects: Array<Notification_Insert_Input>;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_OneArgs = {
  object: Notification_Insert_Input;
  on_conflict?: InputMaybe<Notification_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_ActionArgs = {
  objects: Array<Office_Action_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_IssueArgs = {
  objects: Array<Office_Action_Issue_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Issue_OneArgs = {
  object: Office_Action_Issue_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_Issue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_OneArgs = {
  object: Office_Action_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Similar_Trademark_MapArgs = {
  objects: Array<Office_Action_Similar_Trademark_Map_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_Similar_Trademark_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Similar_Trademark_Map_OneArgs = {
  object: Office_Action_Similar_Trademark_Map_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_Similar_Trademark_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_SolutionArgs = {
  objects: Array<Office_Action_Solution_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_Solution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Solution_OneArgs = {
  object: Office_Action_Solution_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_Solution_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_TrackingArgs = {
  objects: Array<Office_Action_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Tracking_OneArgs = {
  object: Office_Action_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Tracking_StatusArgs = {
  objects: Array<Office_Action_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Office_Action_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Office_Action_Tracking_Status_OneArgs = {
  object: Office_Action_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Office_Action_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_HubArgs = {
  objects: Array<Order_Hub_Insert_Input>;
  on_conflict?: InputMaybe<Order_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Hub_OneArgs = {
  object: Order_Hub_Insert_Input;
  on_conflict?: InputMaybe<Order_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_TrackingArgs = {
  objects: Array<Order_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Order_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Tracking_OneArgs = {
  object: Order_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Order_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Tracking_StatusArgs = {
  objects: Array<Order_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Order_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Tracking_Status_OneArgs = {
  object: Order_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Order_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PoaArgs = {
  objects: Array<Poa_Insert_Input>;
  on_conflict?: InputMaybe<Poa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Poa_OneArgs = {
  object: Poa_Insert_Input;
  on_conflict?: InputMaybe<Poa_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PriceArgs = {
  objects: Array<Price_Insert_Input>;
  on_conflict?: InputMaybe<Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Price_OneArgs = {
  object: Price_Insert_Input;
  on_conflict?: InputMaybe<Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Price_RuleArgs = {
  objects: Array<Price_Rule_Insert_Input>;
  on_conflict?: InputMaybe<Price_Rule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Price_Rule_OneArgs = {
  object: Price_Rule_Insert_Input;
  on_conflict?: InputMaybe<Price_Rule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProductArgs = {
  objects: Array<Product_Insert_Input>;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_BundleArgs = {
  objects: Array<Product_Bundle_Insert_Input>;
  on_conflict?: InputMaybe<Product_Bundle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Bundle_OneArgs = {
  object: Product_Bundle_Insert_Input;
  on_conflict?: InputMaybe<Product_Bundle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_EventArgs = {
  objects: Array<Product_Event_Insert_Input>;
  on_conflict?: InputMaybe<Product_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_Event_OneArgs = {
  object: Product_Event_Insert_Input;
  on_conflict?: InputMaybe<Product_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_OneArgs = {
  object: Product_Insert_Input;
  on_conflict?: InputMaybe<Product_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_V2Args = {
  objects: Array<Product_V2_Insert_Input>;
  on_conflict?: InputMaybe<Product_V2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Product_V2_OneArgs = {
  object: Product_V2_Insert_Input;
  on_conflict?: InputMaybe<Product_V2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_QuoteArgs = {
  objects: Array<Quote_Insert_Input>;
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_HubArgs = {
  objects: Array<Quote_Hub_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Hub_OneArgs = {
  object: Quote_Hub_Insert_Input;
  on_conflict?: InputMaybe<Quote_Hub_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_ItemArgs = {
  objects: Array<Quote_Item_Insert_Input>;
  on_conflict?: InputMaybe<Quote_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_Item_OneArgs = {
  object: Quote_Item_Insert_Input;
  on_conflict?: InputMaybe<Quote_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Quote_OneArgs = {
  object: Quote_Insert_Input;
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_RequestArgs = {
  objects: Array<Refund_Request_Insert_Input>;
  on_conflict?: InputMaybe<Refund_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_InvoiceArgs = {
  objects: Array<Refund_Request_Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Refund_Request_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_Invoice_OneArgs = {
  object: Refund_Request_Invoice_Insert_Input;
  on_conflict?: InputMaybe<Refund_Request_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_OneArgs = {
  object: Refund_Request_Insert_Input;
  on_conflict?: InputMaybe<Refund_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_TrackingArgs = {
  objects: Array<Refund_Request_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Refund_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_Tracking_OneArgs = {
  object: Refund_Request_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Refund_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_Tracking_StatusArgs = {
  objects: Array<Refund_Request_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Refund_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Refund_Request_Tracking_Status_OneArgs = {
  object: Refund_Request_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Refund_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_RequestArgs = {
  objects: Array<Registration_Request_Insert_Input>;
  on_conflict?: InputMaybe<Registration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Request_OneArgs = {
  object: Registration_Request_Insert_Input;
  on_conflict?: InputMaybe<Registration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Request_TrackingArgs = {
  objects: Array<Registration_Request_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Registration_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Request_Tracking_OneArgs = {
  object: Registration_Request_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Registration_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Request_Tracking_StatusArgs = {
  objects: Array<Registration_Request_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Registration_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Registration_Request_Tracking_Status_OneArgs = {
  object: Registration_Request_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Registration_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReminderArgs = {
  objects: Array<Reminder_Insert_Input>;
  on_conflict?: InputMaybe<Reminder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reminder_OneArgs = {
  object: Reminder_Insert_Input;
  on_conflict?: InputMaybe<Reminder_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceArgs = {
  objects: Array<Service_Insert_Input>;
  on_conflict?: InputMaybe<Service_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_OneArgs = {
  object: Service_Insert_Input;
  on_conflict?: InputMaybe<Service_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_RequestArgs = {
  objects: Array<Service_Request_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_OneArgs = {
  object: Service_Request_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_TrackingArgs = {
  objects: Array<Service_Request_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Tracking_OneArgs = {
  object: Service_Request_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Tracking_StatusArgs = {
  objects: Array<Service_Request_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Service_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Request_Tracking_Status_OneArgs = {
  object: Service_Request_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Service_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_TrackingArgs = {
  objects: Array<Service_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Service_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Tracking_OneArgs = {
  object: Service_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Service_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Tracking_StatusArgs = {
  objects: Array<Service_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Service_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Tracking_Status_OneArgs = {
  object: Service_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Service_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Similar_TrademarkArgs = {
  objects: Array<Similar_Trademark_Insert_Input>;
  on_conflict?: InputMaybe<Similar_Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Similar_Trademark_OneArgs = {
  object: Similar_Trademark_Insert_Input;
  on_conflict?: InputMaybe<Similar_Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SpecimenArgs = {
  objects: Array<Specimen_Insert_Input>;
  on_conflict?: InputMaybe<Specimen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Specimen_OneArgs = {
  object: Specimen_Insert_Input;
  on_conflict?: InputMaybe<Specimen_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_StatisticArgs = {
  objects: Array<Statistic_Insert_Input>;
  on_conflict?: InputMaybe<Statistic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Statistic_OneArgs = {
  object: Statistic_Insert_Input;
  on_conflict?: InputMaybe<Statistic_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_TicketArgs = {
  objects: Array<Support_Ticket_Insert_Input>;
  on_conflict?: InputMaybe<Support_Ticket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Support_Ticket_OneArgs = {
  object: Support_Ticket_Insert_Input;
  on_conflict?: InputMaybe<Support_Ticket_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TaskArgs = {
  objects: Array<Task_Insert_Input>;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Task_OneArgs = {
  object: Task_Insert_Input;
  on_conflict?: InputMaybe<Task_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_CommentArgs = {
  objects: Array<Thread_Comment_Insert_Input>;
  on_conflict?: InputMaybe<Thread_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_Comment_OneArgs = {
  object: Thread_Comment_Insert_Input;
  on_conflict?: InputMaybe<Thread_Comment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrademarkArgs = {
  objects: Array<Trademark_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_ClassArgs = {
  objects: Array<Trademark_Class_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Class_OneArgs = {
  object: Trademark_Class_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Class_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Ipo_DataArgs = {
  objects: Array<Trademark_Ipo_Data_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Ipo_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Ipo_Data_OneArgs = {
  object: Trademark_Ipo_Data_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Ipo_Data_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Monitoring_ResultArgs = {
  objects: Array<Trademark_Monitoring_Result_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Monitoring_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Monitoring_Result_OneArgs = {
  object: Trademark_Monitoring_Result_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Monitoring_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_OneArgs = {
  object: Trademark_Insert_Input;
  on_conflict?: InputMaybe<Trademark_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Rate_Limit_LogArgs = {
  objects: Array<Trademark_Rate_Limit_Log_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Rate_Limit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Rate_Limit_Log_OneArgs = {
  object: Trademark_Rate_Limit_Log_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Rate_Limit_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_RequestArgs = {
  objects: Array<Trademark_Request_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Request_OneArgs = {
  object: Trademark_Request_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Service_RequestsArgs = {
  objects: Array<Trademark_Service_Requests_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Service_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Service_Requests_OneArgs = {
  object: Trademark_Service_Requests_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Service_Requests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Shared_DocumentsArgs = {
  objects: Array<Trademark_Shared_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Shared_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Shared_Documents_OneArgs = {
  object: Trademark_Shared_Documents_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Shared_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_TrackingArgs = {
  objects: Array<Trademark_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Tracking_OneArgs = {
  object: Trademark_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Tracking_StatusArgs = {
  objects: Array<Trademark_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Tracking_Status_OneArgs = {
  object: Trademark_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Watch_SubscriptionArgs = {
  objects: Array<Trademark_Watch_Subscription_Insert_Input>;
  on_conflict?: InputMaybe<Trademark_Watch_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trademark_Watch_Subscription_OneArgs = {
  object: Trademark_Watch_Subscription_Insert_Input;
  on_conflict?: InputMaybe<Trademark_Watch_Subscription_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_RequestArgs = {
  objects: Array<Use_In_Commerce_Request_Insert_Input>;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_Request_OneArgs = {
  object: Use_In_Commerce_Request_Insert_Input;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_Request_TrackingArgs = {
  objects: Array<Use_In_Commerce_Request_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_Request_Tracking_OneArgs = {
  object: Use_In_Commerce_Request_Tracking_Insert_Input;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_Request_Tracking_StatusArgs = {
  objects: Array<Use_In_Commerce_Request_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Use_In_Commerce_Request_Tracking_Status_OneArgs = {
  object: Use_In_Commerce_Request_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserArgs = {
  objects: Array<User_Insert_Input>;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_LogArgs = {
  objects: Array<User_Auth_Log_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Log_OneArgs = {
  object: User_Auth_Log_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_HistoryArgs = {
  objects: Array<User_History_Insert_Input>;
  on_conflict?: InputMaybe<User_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_History_OneArgs = {
  object: User_History_Insert_Input;
  on_conflict?: InputMaybe<User_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_OneArgs = {
  object: User_Insert_Input;
  on_conflict?: InputMaybe<User_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Payment_MethodArgs = {
  objects: Array<User_Payment_Method_Insert_Input>;
  on_conflict?: InputMaybe<User_Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Payment_Method_OneArgs = {
  object: User_Payment_Method_Insert_Input;
  on_conflict?: InputMaybe<User_Payment_Method_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ProfileArgs = {
  objects: Array<User_Profile_Insert_Input>;
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Profile_OneArgs = {
  object: User_Profile_Insert_Input;
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_TrackingArgs = {
  objects: Array<User_Tracking_Insert_Input>;
  on_conflict?: InputMaybe<User_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tracking_OneArgs = {
  object: User_Tracking_Insert_Input;
  on_conflict?: InputMaybe<User_Tracking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tracking_StatusArgs = {
  objects: Array<User_Tracking_Status_Insert_Input>;
  on_conflict?: InputMaybe<User_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Tracking_Status_OneArgs = {
  object: User_Tracking_Status_Insert_Input;
  on_conflict?: InputMaybe<User_Tracking_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Verification_ResultArgs = {
  objects: Array<Verification_Result_Insert_Input>;
  on_conflict?: InputMaybe<Verification_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Verification_Result_OneArgs = {
  object: Verification_Result_Insert_Input;
  on_conflict?: InputMaybe<Verification_Result_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Verification_Result_Similar_Trademark_MapArgs = {
  objects: Array<Verification_Result_Similar_Trademark_Map_Insert_Input>;
  on_conflict?: InputMaybe<Verification_Result_Similar_Trademark_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Verification_Result_Similar_Trademark_Map_OneArgs = {
  object: Verification_Result_Similar_Trademark_Map_Insert_Input;
  on_conflict?: InputMaybe<Verification_Result_Similar_Trademark_Map_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WebsiteArgs = {
  objects: Array<Website_Insert_Input>;
  on_conflict?: InputMaybe<Website_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Website_OneArgs = {
  object: Website_Insert_Input;
  on_conflict?: InputMaybe<Website_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInvoice_Mark_As_PaidArgs = {
  args: Invoice_Mark_As_Paid_Args;
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _inc?: InputMaybe<Address_Inc_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Gs_Items_AnalysisArgs = {
  _append?: InputMaybe<Ai_Gs_Items_Analysis_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Gs_Items_Analysis_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Gs_Items_Analysis_Prepend_Input>;
  _set?: InputMaybe<Ai_Gs_Items_Analysis_Set_Input>;
  where: Ai_Gs_Items_Analysis_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Gs_Items_Analysis_By_PkArgs = {
  _append?: InputMaybe<Ai_Gs_Items_Analysis_Append_Input>;
  _delete_at_path?: InputMaybe<Ai_Gs_Items_Analysis_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Ai_Gs_Items_Analysis_Delete_Key_Input>;
  _prepend?: InputMaybe<Ai_Gs_Items_Analysis_Prepend_Input>;
  _set?: InputMaybe<Ai_Gs_Items_Analysis_Set_Input>;
  pk_columns: Ai_Gs_Items_Analysis_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ai_Gs_Items_Analysis_ManyArgs = {
  updates: Array<Ai_Gs_Items_Analysis_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ApplicationArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  where: Application_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_By_PkArgs = {
  _append?: InputMaybe<Application_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Delete_Key_Input>;
  _inc?: InputMaybe<Application_Inc_Input>;
  _prepend?: InputMaybe<Application_Prepend_Input>;
  _set?: InputMaybe<Application_Set_Input>;
  pk_columns: Application_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_JurisdictionArgs = {
  _append?: InputMaybe<Application_Jurisdiction_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Jurisdiction_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Jurisdiction_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Jurisdiction_Delete_Key_Input>;
  _prepend?: InputMaybe<Application_Jurisdiction_Prepend_Input>;
  _set?: InputMaybe<Application_Jurisdiction_Set_Input>;
  where: Application_Jurisdiction_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Jurisdiction_By_PkArgs = {
  _append?: InputMaybe<Application_Jurisdiction_Append_Input>;
  _delete_at_path?: InputMaybe<Application_Jurisdiction_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Application_Jurisdiction_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Application_Jurisdiction_Delete_Key_Input>;
  _prepend?: InputMaybe<Application_Jurisdiction_Prepend_Input>;
  _set?: InputMaybe<Application_Jurisdiction_Set_Input>;
  pk_columns: Application_Jurisdiction_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Application_Jurisdiction_ManyArgs = {
  updates: Array<Application_Jurisdiction_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Application_ManyArgs = {
  updates: Array<Application_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_LogArgs = {
  _append?: InputMaybe<Audit_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Audit_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Audit_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Audit_Log_Delete_Key_Input>;
  _inc?: InputMaybe<Audit_Log_Inc_Input>;
  _prepend?: InputMaybe<Audit_Log_Prepend_Input>;
  _set?: InputMaybe<Audit_Log_Set_Input>;
  where: Audit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Audit_Log_ManyArgs = {
  updates: Array<Audit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BrandArgs = {
  _append?: InputMaybe<Brand_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Prepend_Input>;
  _set?: InputMaybe<Brand_Set_Input>;
  where: Brand_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_By_PkArgs = {
  _append?: InputMaybe<Brand_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Prepend_Input>;
  _set?: InputMaybe<Brand_Set_Input>;
  pk_columns: Brand_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_ManyArgs = {
  updates: Array<Brand_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_TaskArgs = {
  _set?: InputMaybe<Brand_Monitoring_Task_Set_Input>;
  where: Brand_Monitoring_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_By_PkArgs = {
  _set?: InputMaybe<Brand_Monitoring_Task_Set_Input>;
  pk_columns: Brand_Monitoring_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_ManyArgs = {
  updates: Array<Brand_Monitoring_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_TrackingArgs = {
  _inc?: InputMaybe<Brand_Monitoring_Task_Tracking_Inc_Input>;
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Set_Input>;
  where: Brand_Monitoring_Task_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Brand_Monitoring_Task_Tracking_Inc_Input>;
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Set_Input>;
  pk_columns: Brand_Monitoring_Task_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_Tracking_ManyArgs = {
  updates: Array<Brand_Monitoring_Task_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_Tracking_StatusArgs = {
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Set_Input>;
  where: Brand_Monitoring_Task_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Set_Input>;
  pk_columns: Brand_Monitoring_Task_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Monitoring_Task_Tracking_Status_ManyArgs = {
  updates: Array<Brand_Monitoring_Task_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_SnapshotArgs = {
  _append?: InputMaybe<Brand_Snapshot_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Snapshot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Snapshot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Snapshot_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Snapshot_Prepend_Input>;
  _set?: InputMaybe<Brand_Snapshot_Set_Input>;
  where: Brand_Snapshot_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Snapshot_By_PkArgs = {
  _append?: InputMaybe<Brand_Snapshot_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Snapshot_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Snapshot_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Snapshot_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Snapshot_Prepend_Input>;
  _set?: InputMaybe<Brand_Snapshot_Set_Input>;
  pk_columns: Brand_Snapshot_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Snapshot_ManyArgs = {
  updates: Array<Brand_Snapshot_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_SubscriptionArgs = {
  _append?: InputMaybe<Brand_Subscription_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Subscription_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Subscription_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Subscription_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Subscription_Prepend_Input>;
  _set?: InputMaybe<Brand_Subscription_Set_Input>;
  where: Brand_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_By_PkArgs = {
  _append?: InputMaybe<Brand_Subscription_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Subscription_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Subscription_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Subscription_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Subscription_Prepend_Input>;
  _set?: InputMaybe<Brand_Subscription_Set_Input>;
  pk_columns: Brand_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_ManyArgs = {
  updates: Array<Brand_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_PaymentArgs = {
  _inc?: InputMaybe<Brand_Subscription_Payment_Inc_Input>;
  _set?: InputMaybe<Brand_Subscription_Payment_Set_Input>;
  where: Brand_Subscription_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Payment_By_PkArgs = {
  _inc?: InputMaybe<Brand_Subscription_Payment_Inc_Input>;
  _set?: InputMaybe<Brand_Subscription_Payment_Set_Input>;
  pk_columns: Brand_Subscription_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Payment_ManyArgs = {
  updates: Array<Brand_Subscription_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_PlatformArgs = {
  _append?: InputMaybe<Brand_Subscription_Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Subscription_Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Subscription_Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Subscription_Platform_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Subscription_Platform_Prepend_Input>;
  _set?: InputMaybe<Brand_Subscription_Platform_Set_Input>;
  where: Brand_Subscription_Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Platform_By_PkArgs = {
  _append?: InputMaybe<Brand_Subscription_Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Brand_Subscription_Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Brand_Subscription_Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Brand_Subscription_Platform_Delete_Key_Input>;
  _prepend?: InputMaybe<Brand_Subscription_Platform_Prepend_Input>;
  _set?: InputMaybe<Brand_Subscription_Platform_Set_Input>;
  pk_columns: Brand_Subscription_Platform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Platform_ManyArgs = {
  updates: Array<Brand_Subscription_Platform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_TrackingArgs = {
  _inc?: InputMaybe<Brand_Subscription_Tracking_Inc_Input>;
  _set?: InputMaybe<Brand_Subscription_Tracking_Set_Input>;
  where: Brand_Subscription_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Brand_Subscription_Tracking_Inc_Input>;
  _set?: InputMaybe<Brand_Subscription_Tracking_Set_Input>;
  pk_columns: Brand_Subscription_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Tracking_ManyArgs = {
  updates: Array<Brand_Subscription_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Tracking_StatusArgs = {
  _set?: InputMaybe<Brand_Subscription_Tracking_Status_Set_Input>;
  where: Brand_Subscription_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Brand_Subscription_Tracking_Status_Set_Input>;
  pk_columns: Brand_Subscription_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Brand_Subscription_Tracking_Status_ManyArgs = {
  updates: Array<Brand_Subscription_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CaseArgs = {
  _set?: InputMaybe<Case_Set_Input>;
  where: Case_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_By_PkArgs = {
  _set?: InputMaybe<Case_Set_Input>;
  pk_columns: Case_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_CounterpartyArgs = {
  _append?: InputMaybe<Case_Counterparty_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Counterparty_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Counterparty_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Counterparty_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Counterparty_Prepend_Input>;
  _set?: InputMaybe<Case_Counterparty_Set_Input>;
  where: Case_Counterparty_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Counterparty_By_PkArgs = {
  _append?: InputMaybe<Case_Counterparty_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Counterparty_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Counterparty_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Counterparty_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Counterparty_Prepend_Input>;
  _set?: InputMaybe<Case_Counterparty_Set_Input>;
  pk_columns: Case_Counterparty_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Counterparty_ManyArgs = {
  updates: Array<Case_Counterparty_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_InfringementArgs = {
  _set?: InputMaybe<Case_Infringement_Set_Input>;
  where: Case_Infringement_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Infringement_By_PkArgs = {
  _set?: InputMaybe<Case_Infringement_Set_Input>;
  pk_columns: Case_Infringement_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Infringement_EvidenceArgs = {
  _set?: InputMaybe<Case_Infringement_Evidence_Set_Input>;
  where: Case_Infringement_Evidence_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Infringement_Evidence_By_PkArgs = {
  _set?: InputMaybe<Case_Infringement_Evidence_Set_Input>;
  pk_columns: Case_Infringement_Evidence_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Infringement_Evidence_ManyArgs = {
  updates: Array<Case_Infringement_Evidence_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Infringement_ManyArgs = {
  updates: Array<Case_Infringement_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_ManyArgs = {
  updates: Array<Case_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_RequestArgs = {
  _append?: InputMaybe<Case_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Request_Prepend_Input>;
  _set?: InputMaybe<Case_Request_Set_Input>;
  where: Case_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_By_PkArgs = {
  _append?: InputMaybe<Case_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Request_Prepend_Input>;
  _set?: InputMaybe<Case_Request_Set_Input>;
  pk_columns: Case_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_ManyArgs = {
  updates: Array<Case_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_TrackingArgs = {
  _inc?: InputMaybe<Case_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Case_Request_Tracking_Set_Input>;
  where: Case_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Case_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Case_Request_Tracking_Set_Input>;
  pk_columns: Case_Request_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_Tracking_ManyArgs = {
  updates: Array<Case_Request_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_Tracking_StatusArgs = {
  _set?: InputMaybe<Case_Request_Tracking_Status_Set_Input>;
  where: Case_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Case_Request_Tracking_Status_Set_Input>;
  pk_columns: Case_Request_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Request_Tracking_Status_ManyArgs = {
  updates: Array<Case_Request_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_SolutionArgs = {
  _append?: InputMaybe<Case_Solution_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Solution_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Solution_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Solution_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Solution_Prepend_Input>;
  _set?: InputMaybe<Case_Solution_Set_Input>;
  where: Case_Solution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Solution_By_PkArgs = {
  _append?: InputMaybe<Case_Solution_Append_Input>;
  _delete_at_path?: InputMaybe<Case_Solution_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Case_Solution_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Case_Solution_Delete_Key_Input>;
  _prepend?: InputMaybe<Case_Solution_Prepend_Input>;
  _set?: InputMaybe<Case_Solution_Set_Input>;
  pk_columns: Case_Solution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Solution_ManyArgs = {
  updates: Array<Case_Solution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_TrackingArgs = {
  _inc?: InputMaybe<Case_Tracking_Inc_Input>;
  _set?: InputMaybe<Case_Tracking_Set_Input>;
  where: Case_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Case_Tracking_Inc_Input>;
  _set?: InputMaybe<Case_Tracking_Set_Input>;
  pk_columns: Case_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Tracking_ManyArgs = {
  updates: Array<Case_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Tracking_StatusArgs = {
  _set?: InputMaybe<Case_Tracking_Status_Set_Input>;
  where: Case_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Case_Tracking_Status_Set_Input>;
  pk_columns: Case_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Case_Tracking_Status_ManyArgs = {
  updates: Array<Case_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ConsultationArgs = {
  _append?: InputMaybe<Consultation_Append_Input>;
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  _set?: InputMaybe<Consultation_Set_Input>;
  where: Consultation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_By_PkArgs = {
  _append?: InputMaybe<Consultation_Append_Input>;
  _delete_at_path?: InputMaybe<Consultation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Consultation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Consultation_Delete_Key_Input>;
  _prepend?: InputMaybe<Consultation_Prepend_Input>;
  _set?: InputMaybe<Consultation_Set_Input>;
  pk_columns: Consultation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Consultation_ManyArgs = {
  updates: Array<Consultation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContentfulArgs = {
  _append?: InputMaybe<Contentful_Append_Input>;
  _delete_at_path?: InputMaybe<Contentful_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contentful_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contentful_Delete_Key_Input>;
  _prepend?: InputMaybe<Contentful_Prepend_Input>;
  _set?: InputMaybe<Contentful_Set_Input>;
  where: Contentful_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contentful_By_PkArgs = {
  _append?: InputMaybe<Contentful_Append_Input>;
  _delete_at_path?: InputMaybe<Contentful_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contentful_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contentful_Delete_Key_Input>;
  _prepend?: InputMaybe<Contentful_Prepend_Input>;
  _set?: InputMaybe<Contentful_Set_Input>;
  pk_columns: Contentful_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contentful_ManyArgs = {
  updates: Array<Contentful_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_NoteArgs = {
  _append?: InputMaybe<Credit_Note_Append_Input>;
  _delete_at_path?: InputMaybe<Credit_Note_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Credit_Note_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Credit_Note_Delete_Key_Input>;
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  _prepend?: InputMaybe<Credit_Note_Prepend_Input>;
  _set?: InputMaybe<Credit_Note_Set_Input>;
  where: Credit_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_By_PkArgs = {
  _append?: InputMaybe<Credit_Note_Append_Input>;
  _delete_at_path?: InputMaybe<Credit_Note_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Credit_Note_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Credit_Note_Delete_Key_Input>;
  _inc?: InputMaybe<Credit_Note_Inc_Input>;
  _prepend?: InputMaybe<Credit_Note_Prepend_Input>;
  _set?: InputMaybe<Credit_Note_Set_Input>;
  pk_columns: Credit_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Credit_Note_ManyArgs = {
  updates: Array<Credit_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_CouponArgs = {
  _append?: InputMaybe<Discount_Coupon_Append_Input>;
  _delete_at_path?: InputMaybe<Discount_Coupon_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Discount_Coupon_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Discount_Coupon_Delete_Key_Input>;
  _inc?: InputMaybe<Discount_Coupon_Inc_Input>;
  _prepend?: InputMaybe<Discount_Coupon_Prepend_Input>;
  _set?: InputMaybe<Discount_Coupon_Set_Input>;
  where: Discount_Coupon_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Coupon_By_PkArgs = {
  _append?: InputMaybe<Discount_Coupon_Append_Input>;
  _delete_at_path?: InputMaybe<Discount_Coupon_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Discount_Coupon_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Discount_Coupon_Delete_Key_Input>;
  _inc?: InputMaybe<Discount_Coupon_Inc_Input>;
  _prepend?: InputMaybe<Discount_Coupon_Prepend_Input>;
  _set?: InputMaybe<Discount_Coupon_Set_Input>;
  pk_columns: Discount_Coupon_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Discount_Coupon_ManyArgs = {
  updates: Array<Discount_Coupon_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Docketed_MessageArgs = {
  _append?: InputMaybe<Docketed_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Docketed_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Docketed_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Docketed_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Docketed_Message_Inc_Input>;
  _prepend?: InputMaybe<Docketed_Message_Prepend_Input>;
  _set?: InputMaybe<Docketed_Message_Set_Input>;
  where: Docketed_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Docketed_Message_By_PkArgs = {
  _append?: InputMaybe<Docketed_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Docketed_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Docketed_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Docketed_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Docketed_Message_Inc_Input>;
  _prepend?: InputMaybe<Docketed_Message_Prepend_Input>;
  _set?: InputMaybe<Docketed_Message_Set_Input>;
  pk_columns: Docketed_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Docketed_Message_ManyArgs = {
  updates: Array<Docketed_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _inc?: InputMaybe<Document_Inc_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_FolderArgs = {
  _set?: InputMaybe<Document_Folder_Set_Input>;
  where: Document_Folder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Folder_By_PkArgs = {
  _set?: InputMaybe<Document_Folder_Set_Input>;
  pk_columns: Document_Folder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Folder_ManyArgs = {
  updates: Array<Document_Folder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_HubArgs = {
  _set?: InputMaybe<Document_Hub_Set_Input>;
  where: Document_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Hub_By_PkArgs = {
  _set?: InputMaybe<Document_Hub_Set_Input>;
  pk_columns: Document_Hub_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Hub_ManyArgs = {
  updates: Array<Document_Hub_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EntityArgs = {
  _inc?: InputMaybe<Entity_Inc_Input>;
  _set?: InputMaybe<Entity_Set_Input>;
  where: Entity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_By_PkArgs = {
  _inc?: InputMaybe<Entity_Inc_Input>;
  _set?: InputMaybe<Entity_Set_Input>;
  pk_columns: Entity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Entity_ManyArgs = {
  updates: Array<Entity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_RateArgs = {
  _inc?: InputMaybe<Exchange_Rate_Inc_Input>;
  _set?: InputMaybe<Exchange_Rate_Set_Input>;
  where: Exchange_Rate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Rate_By_PkArgs = {
  _inc?: InputMaybe<Exchange_Rate_Inc_Input>;
  _set?: InputMaybe<Exchange_Rate_Set_Input>;
  pk_columns: Exchange_Rate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exchange_Rate_ManyArgs = {
  updates: Array<Exchange_Rate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_External_TrademarkArgs = {
  _append?: InputMaybe<External_Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<External_Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Trademark_Delete_Key_Input>;
  _prepend?: InputMaybe<External_Trademark_Prepend_Input>;
  _set?: InputMaybe<External_Trademark_Set_Input>;
  where: External_Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_External_Trademark_By_PkArgs = {
  _append?: InputMaybe<External_Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<External_Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<External_Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<External_Trademark_Delete_Key_Input>;
  _prepend?: InputMaybe<External_Trademark_Prepend_Input>;
  _set?: InputMaybe<External_Trademark_Set_Input>;
  pk_columns: External_Trademark_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_External_Trademark_ManyArgs = {
  updates: Array<External_Trademark_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoiceArgs = {
  _append?: InputMaybe<Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  where: Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_By_PkArgs = {
  _append?: InputMaybe<Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Invoice_Inc_Input>;
  _prepend?: InputMaybe<Invoice_Prepend_Input>;
  _set?: InputMaybe<Invoice_Set_Input>;
  pk_columns: Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoice_ManyArgs = {
  updates: Array<Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NoteArgs = {
  _inc?: InputMaybe<Note_Inc_Input>;
  _set?: InputMaybe<Note_Set_Input>;
  where: Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Note_By_PkArgs = {
  _inc?: InputMaybe<Note_Inc_Input>;
  _set?: InputMaybe<Note_Set_Input>;
  pk_columns: Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Note_HubArgs = {
  _set?: InputMaybe<Note_Hub_Set_Input>;
  where: Note_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Note_Hub_By_PkArgs = {
  _set?: InputMaybe<Note_Hub_Set_Input>;
  pk_columns: Note_Hub_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Note_Hub_ManyArgs = {
  updates: Array<Note_Hub_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Note_ManyArgs = {
  updates: Array<Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationArgs = {
  _append?: InputMaybe<Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Prepend_Input>;
  _set?: InputMaybe<Notification_Set_Input>;
  where: Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_By_PkArgs = {
  _append?: InputMaybe<Notification_Append_Input>;
  _delete_at_path?: InputMaybe<Notification_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Notification_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Notification_Delete_Key_Input>;
  _prepend?: InputMaybe<Notification_Prepend_Input>;
  _set?: InputMaybe<Notification_Set_Input>;
  pk_columns: Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_ManyArgs = {
  updates: Array<Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_ActionArgs = {
  _append?: InputMaybe<Office_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Office_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Office_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Office_Action_Delete_Key_Input>;
  _inc?: InputMaybe<Office_Action_Inc_Input>;
  _prepend?: InputMaybe<Office_Action_Prepend_Input>;
  _set?: InputMaybe<Office_Action_Set_Input>;
  where: Office_Action_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_By_PkArgs = {
  _append?: InputMaybe<Office_Action_Append_Input>;
  _delete_at_path?: InputMaybe<Office_Action_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Office_Action_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Office_Action_Delete_Key_Input>;
  _inc?: InputMaybe<Office_Action_Inc_Input>;
  _prepend?: InputMaybe<Office_Action_Prepend_Input>;
  _set?: InputMaybe<Office_Action_Set_Input>;
  pk_columns: Office_Action_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_IssueArgs = {
  _set?: InputMaybe<Office_Action_Issue_Set_Input>;
  where: Office_Action_Issue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Issue_By_PkArgs = {
  _set?: InputMaybe<Office_Action_Issue_Set_Input>;
  pk_columns: Office_Action_Issue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Issue_ManyArgs = {
  updates: Array<Office_Action_Issue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_ManyArgs = {
  updates: Array<Office_Action_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Similar_Trademark_MapArgs = {
  _inc?: InputMaybe<Office_Action_Similar_Trademark_Map_Inc_Input>;
  _set?: InputMaybe<Office_Action_Similar_Trademark_Map_Set_Input>;
  where: Office_Action_Similar_Trademark_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Similar_Trademark_Map_By_PkArgs = {
  _inc?: InputMaybe<Office_Action_Similar_Trademark_Map_Inc_Input>;
  _set?: InputMaybe<Office_Action_Similar_Trademark_Map_Set_Input>;
  pk_columns: Office_Action_Similar_Trademark_Map_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Similar_Trademark_Map_ManyArgs = {
  updates: Array<Office_Action_Similar_Trademark_Map_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_SolutionArgs = {
  _inc?: InputMaybe<Office_Action_Solution_Inc_Input>;
  _set?: InputMaybe<Office_Action_Solution_Set_Input>;
  where: Office_Action_Solution_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Solution_By_PkArgs = {
  _inc?: InputMaybe<Office_Action_Solution_Inc_Input>;
  _set?: InputMaybe<Office_Action_Solution_Set_Input>;
  pk_columns: Office_Action_Solution_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Solution_ManyArgs = {
  updates: Array<Office_Action_Solution_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_TrackingArgs = {
  _inc?: InputMaybe<Office_Action_Tracking_Inc_Input>;
  _set?: InputMaybe<Office_Action_Tracking_Set_Input>;
  where: Office_Action_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Office_Action_Tracking_Inc_Input>;
  _set?: InputMaybe<Office_Action_Tracking_Set_Input>;
  pk_columns: Office_Action_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Tracking_ManyArgs = {
  updates: Array<Office_Action_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Tracking_StatusArgs = {
  _set?: InputMaybe<Office_Action_Tracking_Status_Set_Input>;
  where: Office_Action_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Office_Action_Tracking_Status_Set_Input>;
  pk_columns: Office_Action_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Office_Action_Tracking_Status_ManyArgs = {
  updates: Array<Office_Action_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_HubArgs = {
  _set?: InputMaybe<Order_Hub_Set_Input>;
  where: Order_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Hub_By_PkArgs = {
  _set?: InputMaybe<Order_Hub_Set_Input>;
  pk_columns: Order_Hub_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Hub_ManyArgs = {
  updates: Array<Order_Hub_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_TrackingArgs = {
  _set?: InputMaybe<Order_Tracking_Set_Input>;
  where: Order_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Tracking_By_PkArgs = {
  _set?: InputMaybe<Order_Tracking_Set_Input>;
  pk_columns: Order_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Tracking_ManyArgs = {
  updates: Array<Order_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Tracking_StatusArgs = {
  _set?: InputMaybe<Order_Tracking_Status_Set_Input>;
  where: Order_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Order_Tracking_Status_Set_Input>;
  pk_columns: Order_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Tracking_Status_ManyArgs = {
  updates: Array<Order_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PoaArgs = {
  _append?: InputMaybe<Poa_Append_Input>;
  _delete_at_path?: InputMaybe<Poa_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Poa_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Poa_Delete_Key_Input>;
  _inc?: InputMaybe<Poa_Inc_Input>;
  _prepend?: InputMaybe<Poa_Prepend_Input>;
  _set?: InputMaybe<Poa_Set_Input>;
  where: Poa_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Poa_By_PkArgs = {
  _append?: InputMaybe<Poa_Append_Input>;
  _delete_at_path?: InputMaybe<Poa_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Poa_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Poa_Delete_Key_Input>;
  _inc?: InputMaybe<Poa_Inc_Input>;
  _prepend?: InputMaybe<Poa_Prepend_Input>;
  _set?: InputMaybe<Poa_Set_Input>;
  pk_columns: Poa_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Poa_ManyArgs = {
  updates: Array<Poa_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PriceArgs = {
  _inc?: InputMaybe<Price_Inc_Input>;
  _set?: InputMaybe<Price_Set_Input>;
  where: Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Price_By_PkArgs = {
  _inc?: InputMaybe<Price_Inc_Input>;
  _set?: InputMaybe<Price_Set_Input>;
  pk_columns: Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Price_ManyArgs = {
  updates: Array<Price_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Price_RuleArgs = {
  _append?: InputMaybe<Price_Rule_Append_Input>;
  _delete_at_path?: InputMaybe<Price_Rule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Price_Rule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Price_Rule_Delete_Key_Input>;
  _prepend?: InputMaybe<Price_Rule_Prepend_Input>;
  _set?: InputMaybe<Price_Rule_Set_Input>;
  where: Price_Rule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Price_Rule_By_PkArgs = {
  _append?: InputMaybe<Price_Rule_Append_Input>;
  _delete_at_path?: InputMaybe<Price_Rule_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Price_Rule_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Price_Rule_Delete_Key_Input>;
  _prepend?: InputMaybe<Price_Rule_Prepend_Input>;
  _set?: InputMaybe<Price_Rule_Set_Input>;
  pk_columns: Price_Rule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Price_Rule_ManyArgs = {
  updates: Array<Price_Rule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_BundleArgs = {
  _set?: InputMaybe<Product_Bundle_Set_Input>;
  where: Product_Bundle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Bundle_By_PkArgs = {
  _set?: InputMaybe<Product_Bundle_Set_Input>;
  pk_columns: Product_Bundle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Bundle_ManyArgs = {
  updates: Array<Product_Bundle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_EventArgs = {
  _append?: InputMaybe<Product_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Product_Event_Prepend_Input>;
  _set?: InputMaybe<Product_Event_Set_Input>;
  where: Product_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Event_By_PkArgs = {
  _append?: InputMaybe<Product_Event_Append_Input>;
  _delete_at_path?: InputMaybe<Product_Event_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_Event_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_Event_Delete_Key_Input>;
  _prepend?: InputMaybe<Product_Event_Prepend_Input>;
  _set?: InputMaybe<Product_Event_Set_Input>;
  pk_columns: Product_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_Event_ManyArgs = {
  updates: Array<Product_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Product_V2Args = {
  _append?: InputMaybe<Product_V2_Append_Input>;
  _delete_at_path?: InputMaybe<Product_V2_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_V2_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_V2_Delete_Key_Input>;
  _inc?: InputMaybe<Product_V2_Inc_Input>;
  _prepend?: InputMaybe<Product_V2_Prepend_Input>;
  _set?: InputMaybe<Product_V2_Set_Input>;
  where: Product_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_V2_By_PkArgs = {
  _append?: InputMaybe<Product_V2_Append_Input>;
  _delete_at_path?: InputMaybe<Product_V2_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Product_V2_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Product_V2_Delete_Key_Input>;
  _inc?: InputMaybe<Product_V2_Inc_Input>;
  _prepend?: InputMaybe<Product_V2_Prepend_Input>;
  _set?: InputMaybe<Product_V2_Set_Input>;
  pk_columns: Product_V2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_V2_ManyArgs = {
  updates: Array<Product_V2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_QuoteArgs = {
  _append?: InputMaybe<Quote_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  _set?: InputMaybe<Quote_Set_Input>;
  where: Quote_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_By_PkArgs = {
  _append?: InputMaybe<Quote_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  _set?: InputMaybe<Quote_Set_Input>;
  pk_columns: Quote_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_HubArgs = {
  _set?: InputMaybe<Quote_Hub_Set_Input>;
  where: Quote_Hub_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Hub_By_PkArgs = {
  _set?: InputMaybe<Quote_Hub_Set_Input>;
  pk_columns: Quote_Hub_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Hub_ManyArgs = {
  updates: Array<Quote_Hub_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_ItemArgs = {
  _append?: InputMaybe<Quote_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Quote_Item_Inc_Input>;
  _prepend?: InputMaybe<Quote_Item_Prepend_Input>;
  _set?: InputMaybe<Quote_Item_Set_Input>;
  where: Quote_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Item_By_PkArgs = {
  _append?: InputMaybe<Quote_Item_Append_Input>;
  _delete_at_path?: InputMaybe<Quote_Item_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Quote_Item_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Quote_Item_Delete_Key_Input>;
  _inc?: InputMaybe<Quote_Item_Inc_Input>;
  _prepend?: InputMaybe<Quote_Item_Prepend_Input>;
  _set?: InputMaybe<Quote_Item_Set_Input>;
  pk_columns: Quote_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_Item_ManyArgs = {
  updates: Array<Quote_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Quote_ManyArgs = {
  updates: Array<Quote_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_RequestArgs = {
  _inc?: InputMaybe<Refund_Request_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Set_Input>;
  where: Refund_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_By_PkArgs = {
  _inc?: InputMaybe<Refund_Request_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Set_Input>;
  pk_columns: Refund_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_InvoiceArgs = {
  _inc?: InputMaybe<Refund_Request_Invoice_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Invoice_Set_Input>;
  where: Refund_Request_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Invoice_By_PkArgs = {
  _inc?: InputMaybe<Refund_Request_Invoice_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Invoice_Set_Input>;
  pk_columns: Refund_Request_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Invoice_ManyArgs = {
  updates: Array<Refund_Request_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_ManyArgs = {
  updates: Array<Refund_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_TrackingArgs = {
  _inc?: InputMaybe<Refund_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Tracking_Set_Input>;
  where: Refund_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Refund_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Refund_Request_Tracking_Set_Input>;
  pk_columns: Refund_Request_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Tracking_ManyArgs = {
  updates: Array<Refund_Request_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Tracking_StatusArgs = {
  _set?: InputMaybe<Refund_Request_Tracking_Status_Set_Input>;
  where: Refund_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Refund_Request_Tracking_Status_Set_Input>;
  pk_columns: Refund_Request_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Refund_Request_Tracking_Status_ManyArgs = {
  updates: Array<Refund_Request_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_RequestArgs = {
  _append?: InputMaybe<Registration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Registration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Registration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Registration_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Registration_Request_Prepend_Input>;
  _set?: InputMaybe<Registration_Request_Set_Input>;
  where: Registration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_By_PkArgs = {
  _append?: InputMaybe<Registration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Registration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Registration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Registration_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Registration_Request_Prepend_Input>;
  _set?: InputMaybe<Registration_Request_Set_Input>;
  pk_columns: Registration_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_ManyArgs = {
  updates: Array<Registration_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_TrackingArgs = {
  _inc?: InputMaybe<Registration_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Registration_Request_Tracking_Set_Input>;
  where: Registration_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Registration_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Registration_Request_Tracking_Set_Input>;
  pk_columns: Registration_Request_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_Tracking_ManyArgs = {
  updates: Array<Registration_Request_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_Tracking_StatusArgs = {
  _set?: InputMaybe<Registration_Request_Tracking_Status_Set_Input>;
  where: Registration_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Registration_Request_Tracking_Status_Set_Input>;
  pk_columns: Registration_Request_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Registration_Request_Tracking_Status_ManyArgs = {
  updates: Array<Registration_Request_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReminderArgs = {
  _set?: InputMaybe<Reminder_Set_Input>;
  where: Reminder_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reminder_By_PkArgs = {
  _set?: InputMaybe<Reminder_Set_Input>;
  pk_columns: Reminder_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reminder_ManyArgs = {
  updates: Array<Reminder_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceArgs = {
  _append?: InputMaybe<Service_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Delete_Key_Input>;
  _prepend?: InputMaybe<Service_Prepend_Input>;
  _set?: InputMaybe<Service_Set_Input>;
  where: Service_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_By_PkArgs = {
  _append?: InputMaybe<Service_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Delete_Key_Input>;
  _prepend?: InputMaybe<Service_Prepend_Input>;
  _set?: InputMaybe<Service_Set_Input>;
  pk_columns: Service_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_ManyArgs = {
  updates: Array<Service_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_RequestArgs = {
  _append?: InputMaybe<Service_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Request_Inc_Input>;
  _prepend?: InputMaybe<Service_Request_Prepend_Input>;
  _set?: InputMaybe<Service_Request_Set_Input>;
  where: Service_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_By_PkArgs = {
  _append?: InputMaybe<Service_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Request_Inc_Input>;
  _prepend?: InputMaybe<Service_Request_Prepend_Input>;
  _set?: InputMaybe<Service_Request_Set_Input>;
  pk_columns: Service_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_ManyArgs = {
  updates: Array<Service_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_TrackingArgs = {
  _set?: InputMaybe<Service_Request_Tracking_Set_Input>;
  where: Service_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Tracking_By_PkArgs = {
  _set?: InputMaybe<Service_Request_Tracking_Set_Input>;
  pk_columns: Service_Request_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Tracking_ManyArgs = {
  updates: Array<Service_Request_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Tracking_StatusArgs = {
  _set?: InputMaybe<Service_Request_Tracking_Status_Set_Input>;
  where: Service_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Service_Request_Tracking_Status_Set_Input>;
  pk_columns: Service_Request_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Request_Tracking_Status_ManyArgs = {
  updates: Array<Service_Request_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_TrackingArgs = {
  _inc?: InputMaybe<Service_Tracking_Inc_Input>;
  _set?: InputMaybe<Service_Tracking_Set_Input>;
  where: Service_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Service_Tracking_Inc_Input>;
  _set?: InputMaybe<Service_Tracking_Set_Input>;
  pk_columns: Service_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tracking_ManyArgs = {
  updates: Array<Service_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tracking_StatusArgs = {
  _set?: InputMaybe<Service_Tracking_Status_Set_Input>;
  where: Service_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Service_Tracking_Status_Set_Input>;
  pk_columns: Service_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tracking_Status_ManyArgs = {
  updates: Array<Service_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Similar_TrademarkArgs = {
  _append?: InputMaybe<Similar_Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<Similar_Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Similar_Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Similar_Trademark_Delete_Key_Input>;
  _prepend?: InputMaybe<Similar_Trademark_Prepend_Input>;
  _set?: InputMaybe<Similar_Trademark_Set_Input>;
  where: Similar_Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Similar_Trademark_By_PkArgs = {
  _append?: InputMaybe<Similar_Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<Similar_Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Similar_Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Similar_Trademark_Delete_Key_Input>;
  _prepend?: InputMaybe<Similar_Trademark_Prepend_Input>;
  _set?: InputMaybe<Similar_Trademark_Set_Input>;
  pk_columns: Similar_Trademark_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Similar_Trademark_ManyArgs = {
  updates: Array<Similar_Trademark_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SpecimenArgs = {
  _append?: InputMaybe<Specimen_Append_Input>;
  _delete_at_path?: InputMaybe<Specimen_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Specimen_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Specimen_Delete_Key_Input>;
  _inc?: InputMaybe<Specimen_Inc_Input>;
  _prepend?: InputMaybe<Specimen_Prepend_Input>;
  _set?: InputMaybe<Specimen_Set_Input>;
  where: Specimen_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Specimen_By_PkArgs = {
  _append?: InputMaybe<Specimen_Append_Input>;
  _delete_at_path?: InputMaybe<Specimen_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Specimen_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Specimen_Delete_Key_Input>;
  _inc?: InputMaybe<Specimen_Inc_Input>;
  _prepend?: InputMaybe<Specimen_Prepend_Input>;
  _set?: InputMaybe<Specimen_Set_Input>;
  pk_columns: Specimen_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Specimen_ManyArgs = {
  updates: Array<Specimen_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StatisticArgs = {
  _inc?: InputMaybe<Statistic_Inc_Input>;
  _set?: InputMaybe<Statistic_Set_Input>;
  where: Statistic_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Statistic_By_PkArgs = {
  _inc?: InputMaybe<Statistic_Inc_Input>;
  _set?: InputMaybe<Statistic_Set_Input>;
  pk_columns: Statistic_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Statistic_ManyArgs = {
  updates: Array<Statistic_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Support_TicketArgs = {
  _inc?: InputMaybe<Support_Ticket_Inc_Input>;
  _set?: InputMaybe<Support_Ticket_Set_Input>;
  where: Support_Ticket_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Ticket_By_PkArgs = {
  _inc?: InputMaybe<Support_Ticket_Inc_Input>;
  _set?: InputMaybe<Support_Ticket_Set_Input>;
  pk_columns: Support_Ticket_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Support_Ticket_ManyArgs = {
  updates: Array<Support_Ticket_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TaskArgs = {
  _append?: InputMaybe<Task_Append_Input>;
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  _inc?: InputMaybe<Task_Inc_Input>;
  _prepend?: InputMaybe<Task_Prepend_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  where: Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Task_By_PkArgs = {
  _append?: InputMaybe<Task_Append_Input>;
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  _inc?: InputMaybe<Task_Inc_Input>;
  _prepend?: InputMaybe<Task_Prepend_Input>;
  _set?: InputMaybe<Task_Set_Input>;
  pk_columns: Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ManyArgs = {
  updates: Array<Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_CommentArgs = {
  _inc?: InputMaybe<Thread_Comment_Inc_Input>;
  _set?: InputMaybe<Thread_Comment_Set_Input>;
  where: Thread_Comment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Comment_By_PkArgs = {
  _inc?: InputMaybe<Thread_Comment_Inc_Input>;
  _set?: InputMaybe<Thread_Comment_Set_Input>;
  pk_columns: Thread_Comment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_Comment_ManyArgs = {
  updates: Array<Thread_Comment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TrademarkArgs = {
  _append?: InputMaybe<Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Delete_Key_Input>;
  _inc?: InputMaybe<Trademark_Inc_Input>;
  _prepend?: InputMaybe<Trademark_Prepend_Input>;
  _set?: InputMaybe<Trademark_Set_Input>;
  where: Trademark_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_By_PkArgs = {
  _append?: InputMaybe<Trademark_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Delete_Key_Input>;
  _inc?: InputMaybe<Trademark_Inc_Input>;
  _prepend?: InputMaybe<Trademark_Prepend_Input>;
  _set?: InputMaybe<Trademark_Set_Input>;
  pk_columns: Trademark_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_ClassArgs = {
  _append?: InputMaybe<Trademark_Class_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Class_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Class_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Class_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Class_Prepend_Input>;
  _set?: InputMaybe<Trademark_Class_Set_Input>;
  where: Trademark_Class_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Class_By_PkArgs = {
  _append?: InputMaybe<Trademark_Class_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Class_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Class_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Class_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Class_Prepend_Input>;
  _set?: InputMaybe<Trademark_Class_Set_Input>;
  pk_columns: Trademark_Class_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Class_ManyArgs = {
  updates: Array<Trademark_Class_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Ipo_DataArgs = {
  _append?: InputMaybe<Trademark_Ipo_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Ipo_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Ipo_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Ipo_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Ipo_Data_Prepend_Input>;
  _set?: InputMaybe<Trademark_Ipo_Data_Set_Input>;
  where: Trademark_Ipo_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Ipo_Data_By_PkArgs = {
  _append?: InputMaybe<Trademark_Ipo_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Ipo_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Ipo_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Ipo_Data_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Ipo_Data_Prepend_Input>;
  _set?: InputMaybe<Trademark_Ipo_Data_Set_Input>;
  pk_columns: Trademark_Ipo_Data_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Ipo_Data_ManyArgs = {
  updates: Array<Trademark_Ipo_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_ManyArgs = {
  updates: Array<Trademark_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Monitoring_ResultArgs = {
  _append?: InputMaybe<Trademark_Monitoring_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Monitoring_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Monitoring_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Monitoring_Result_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Monitoring_Result_Prepend_Input>;
  _set?: InputMaybe<Trademark_Monitoring_Result_Set_Input>;
  where: Trademark_Monitoring_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Monitoring_Result_By_PkArgs = {
  _append?: InputMaybe<Trademark_Monitoring_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Monitoring_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Monitoring_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Monitoring_Result_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Monitoring_Result_Prepend_Input>;
  _set?: InputMaybe<Trademark_Monitoring_Result_Set_Input>;
  pk_columns: Trademark_Monitoring_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Monitoring_Result_ManyArgs = {
  updates: Array<Trademark_Monitoring_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Rate_Limit_LogArgs = {
  _inc?: InputMaybe<Trademark_Rate_Limit_Log_Inc_Input>;
  _set?: InputMaybe<Trademark_Rate_Limit_Log_Set_Input>;
  where: Trademark_Rate_Limit_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Rate_Limit_Log_By_PkArgs = {
  _inc?: InputMaybe<Trademark_Rate_Limit_Log_Inc_Input>;
  _set?: InputMaybe<Trademark_Rate_Limit_Log_Set_Input>;
  pk_columns: Trademark_Rate_Limit_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Rate_Limit_Log_ManyArgs = {
  updates: Array<Trademark_Rate_Limit_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_RequestArgs = {
  _append?: InputMaybe<Trademark_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Request_Prepend_Input>;
  _set?: InputMaybe<Trademark_Request_Set_Input>;
  where: Trademark_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Request_By_PkArgs = {
  _append?: InputMaybe<Trademark_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Trademark_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trademark_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trademark_Request_Delete_Key_Input>;
  _prepend?: InputMaybe<Trademark_Request_Prepend_Input>;
  _set?: InputMaybe<Trademark_Request_Set_Input>;
  pk_columns: Trademark_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Request_ManyArgs = {
  updates: Array<Trademark_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Service_RequestsArgs = {
  _set?: InputMaybe<Trademark_Service_Requests_Set_Input>;
  where: Trademark_Service_Requests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Service_Requests_By_PkArgs = {
  _set?: InputMaybe<Trademark_Service_Requests_Set_Input>;
  pk_columns: Trademark_Service_Requests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Service_Requests_ManyArgs = {
  updates: Array<Trademark_Service_Requests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Shared_DocumentsArgs = {
  _inc?: InputMaybe<Trademark_Shared_Documents_Inc_Input>;
  _set?: InputMaybe<Trademark_Shared_Documents_Set_Input>;
  where: Trademark_Shared_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Shared_Documents_By_PkArgs = {
  _inc?: InputMaybe<Trademark_Shared_Documents_Inc_Input>;
  _set?: InputMaybe<Trademark_Shared_Documents_Set_Input>;
  pk_columns: Trademark_Shared_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Shared_Documents_ManyArgs = {
  updates: Array<Trademark_Shared_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_TrackingArgs = {
  _inc?: InputMaybe<Trademark_Tracking_Inc_Input>;
  _set?: InputMaybe<Trademark_Tracking_Set_Input>;
  where: Trademark_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Trademark_Tracking_Inc_Input>;
  _set?: InputMaybe<Trademark_Tracking_Set_Input>;
  pk_columns: Trademark_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Tracking_ManyArgs = {
  updates: Array<Trademark_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Tracking_StatusArgs = {
  _set?: InputMaybe<Trademark_Tracking_Status_Set_Input>;
  where: Trademark_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Trademark_Tracking_Status_Set_Input>;
  pk_columns: Trademark_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Tracking_Status_ManyArgs = {
  updates: Array<Trademark_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Watch_SubscriptionArgs = {
  _set?: InputMaybe<Trademark_Watch_Subscription_Set_Input>;
  where: Trademark_Watch_Subscription_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Watch_Subscription_By_PkArgs = {
  _set?: InputMaybe<Trademark_Watch_Subscription_Set_Input>;
  pk_columns: Trademark_Watch_Subscription_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trademark_Watch_Subscription_ManyArgs = {
  updates: Array<Trademark_Watch_Subscription_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_RequestArgs = {
  _inc?: InputMaybe<Use_In_Commerce_Request_Inc_Input>;
  _set?: InputMaybe<Use_In_Commerce_Request_Set_Input>;
  where: Use_In_Commerce_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_By_PkArgs = {
  _inc?: InputMaybe<Use_In_Commerce_Request_Inc_Input>;
  _set?: InputMaybe<Use_In_Commerce_Request_Set_Input>;
  pk_columns: Use_In_Commerce_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_ManyArgs = {
  updates: Array<Use_In_Commerce_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_TrackingArgs = {
  _inc?: InputMaybe<Use_In_Commerce_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Set_Input>;
  where: Use_In_Commerce_Request_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_Tracking_By_PkArgs = {
  _inc?: InputMaybe<Use_In_Commerce_Request_Tracking_Inc_Input>;
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Set_Input>;
  pk_columns: Use_In_Commerce_Request_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_Tracking_ManyArgs = {
  updates: Array<Use_In_Commerce_Request_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_Tracking_StatusArgs = {
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Set_Input>;
  where: Use_In_Commerce_Request_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Set_Input>;
  pk_columns: Use_In_Commerce_Request_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Use_In_Commerce_Request_Tracking_Status_ManyArgs = {
  updates: Array<Use_In_Commerce_Request_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_LogArgs = {
  _append?: InputMaybe<User_Auth_Log_Append_Input>;
  _delete_at_path?: InputMaybe<User_Auth_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Auth_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Auth_Log_Delete_Key_Input>;
  _inc?: InputMaybe<User_Auth_Log_Inc_Input>;
  _prepend?: InputMaybe<User_Auth_Log_Prepend_Input>;
  _set?: InputMaybe<User_Auth_Log_Set_Input>;
  where: User_Auth_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Log_By_PkArgs = {
  _append?: InputMaybe<User_Auth_Log_Append_Input>;
  _delete_at_path?: InputMaybe<User_Auth_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Auth_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Auth_Log_Delete_Key_Input>;
  _inc?: InputMaybe<User_Auth_Log_Inc_Input>;
  _prepend?: InputMaybe<User_Auth_Log_Prepend_Input>;
  _set?: InputMaybe<User_Auth_Log_Set_Input>;
  pk_columns: User_Auth_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Log_ManyArgs = {
  updates: Array<User_Auth_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _append?: InputMaybe<User_Append_Input>;
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Prepend_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_HistoryArgs = {
  _set?: InputMaybe<User_History_Set_Input>;
  where: User_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_History_By_PkArgs = {
  _set?: InputMaybe<User_History_Set_Input>;
  pk_columns: User_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_History_ManyArgs = {
  updates: Array<User_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Payment_MethodArgs = {
  _set?: InputMaybe<User_Payment_Method_Set_Input>;
  where: User_Payment_Method_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Payment_Method_By_PkArgs = {
  _set?: InputMaybe<User_Payment_Method_Set_Input>;
  pk_columns: User_Payment_Method_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Payment_Method_ManyArgs = {
  updates: Array<User_Payment_Method_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ProfileArgs = {
  _inc?: InputMaybe<User_Profile_Inc_Input>;
  _set?: InputMaybe<User_Profile_Set_Input>;
  where: User_Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_By_PkArgs = {
  _inc?: InputMaybe<User_Profile_Inc_Input>;
  _set?: InputMaybe<User_Profile_Set_Input>;
  pk_columns: User_Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Profile_ManyArgs = {
  updates: Array<User_Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_TrackingArgs = {
  _inc?: InputMaybe<User_Tracking_Inc_Input>;
  _set?: InputMaybe<User_Tracking_Set_Input>;
  where: User_Tracking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tracking_By_PkArgs = {
  _inc?: InputMaybe<User_Tracking_Inc_Input>;
  _set?: InputMaybe<User_Tracking_Set_Input>;
  pk_columns: User_Tracking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tracking_ManyArgs = {
  updates: Array<User_Tracking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tracking_StatusArgs = {
  _set?: InputMaybe<User_Tracking_Status_Set_Input>;
  where: User_Tracking_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tracking_Status_By_PkArgs = {
  _set?: InputMaybe<User_Tracking_Status_Set_Input>;
  pk_columns: User_Tracking_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Tracking_Status_ManyArgs = {
  updates: Array<User_Tracking_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_ResultArgs = {
  _append?: InputMaybe<Verification_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Verification_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Verification_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Verification_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Verification_Result_Inc_Input>;
  _prepend?: InputMaybe<Verification_Result_Prepend_Input>;
  _set?: InputMaybe<Verification_Result_Set_Input>;
  where: Verification_Result_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_Result_By_PkArgs = {
  _append?: InputMaybe<Verification_Result_Append_Input>;
  _delete_at_path?: InputMaybe<Verification_Result_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Verification_Result_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Verification_Result_Delete_Key_Input>;
  _inc?: InputMaybe<Verification_Result_Inc_Input>;
  _prepend?: InputMaybe<Verification_Result_Prepend_Input>;
  _set?: InputMaybe<Verification_Result_Set_Input>;
  pk_columns: Verification_Result_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_Result_ManyArgs = {
  updates: Array<Verification_Result_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_Result_Similar_Trademark_MapArgs = {
  _append?: InputMaybe<Verification_Result_Similar_Trademark_Map_Append_Input>;
  _delete_at_path?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Key_Input>;
  _prepend?: InputMaybe<Verification_Result_Similar_Trademark_Map_Prepend_Input>;
  _set?: InputMaybe<Verification_Result_Similar_Trademark_Map_Set_Input>;
  where: Verification_Result_Similar_Trademark_Map_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_Result_Similar_Trademark_Map_By_PkArgs = {
  _append?: InputMaybe<Verification_Result_Similar_Trademark_Map_Append_Input>;
  _delete_at_path?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Key_Input>;
  _prepend?: InputMaybe<Verification_Result_Similar_Trademark_Map_Prepend_Input>;
  _set?: InputMaybe<Verification_Result_Similar_Trademark_Map_Set_Input>;
  pk_columns: Verification_Result_Similar_Trademark_Map_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Verification_Result_Similar_Trademark_Map_ManyArgs = {
  updates: Array<Verification_Result_Similar_Trademark_Map_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WebsiteArgs = {
  _set?: InputMaybe<Website_Set_Input>;
  where: Website_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Website_By_PkArgs = {
  _set?: InputMaybe<Website_Set_Input>;
  pk_columns: Website_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Website_ManyArgs = {
  updates: Array<Website_Updates>;
};

/** columns and relationships of "note" */
export type Note = {
  __typename?: 'note';
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  document?: Maybe<Document>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_enabled: Scalars['Boolean']['output'];
  note_hub_id: Scalars['uuid']['output'];
  text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
};

/** aggregated selection of "note" */
export type Note_Aggregate = {
  __typename?: 'note_aggregate';
  aggregate?: Maybe<Note_Aggregate_Fields>;
  nodes: Array<Note>;
};

export type Note_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Note_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Note_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Note_Aggregate_Bool_Exp_Count>;
};

export type Note_Aggregate_Bool_Exp_Bool_And = {
  arguments: Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Note_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "note" */
export type Note_Aggregate_Fields = {
  __typename?: 'note_aggregate_fields';
  avg?: Maybe<Note_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Note_Max_Fields>;
  min?: Maybe<Note_Min_Fields>;
  stddev?: Maybe<Note_Stddev_Fields>;
  stddev_pop?: Maybe<Note_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Note_Stddev_Samp_Fields>;
  sum?: Maybe<Note_Sum_Fields>;
  var_pop?: Maybe<Note_Var_Pop_Fields>;
  var_samp?: Maybe<Note_Var_Samp_Fields>;
  variance?: Maybe<Note_Variance_Fields>;
};


/** aggregate fields of "note" */
export type Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "note" */
export type Note_Aggregate_Order_By = {
  avg?: InputMaybe<Note_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Note_Max_Order_By>;
  min?: InputMaybe<Note_Min_Order_By>;
  stddev?: InputMaybe<Note_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Note_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Note_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Note_Sum_Order_By>;
  var_pop?: InputMaybe<Note_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Note_Var_Samp_Order_By>;
  variance?: InputMaybe<Note_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "note" */
export type Note_Arr_Rel_Insert_Input = {
  data: Array<Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Note_On_Conflict>;
};

/** aggregate avg on columns */
export type Note_Avg_Fields = {
  __typename?: 'note_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "note" */
export type Note_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "note". All fields are combined with a logical 'AND'. */
export type Note_Bool_Exp = {
  _and?: InputMaybe<Array<Note_Bool_Exp>>;
  _not?: InputMaybe<Note_Bool_Exp>;
  _or?: InputMaybe<Array<Note_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "note" */
export enum Note_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotesPkey = 'notes_pkey'
}

/** columns and relationships of "note_hub" */
export type Note_Hub = {
  __typename?: 'note_hub';
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "note_hub" */
export type Note_Hub_Aggregate = {
  __typename?: 'note_hub_aggregate';
  aggregate?: Maybe<Note_Hub_Aggregate_Fields>;
  nodes: Array<Note_Hub>;
};

/** aggregate fields of "note_hub" */
export type Note_Hub_Aggregate_Fields = {
  __typename?: 'note_hub_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Note_Hub_Max_Fields>;
  min?: Maybe<Note_Hub_Min_Fields>;
};


/** aggregate fields of "note_hub" */
export type Note_Hub_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Note_Hub_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "note_hub". All fields are combined with a logical 'AND'. */
export type Note_Hub_Bool_Exp = {
  _and?: InputMaybe<Array<Note_Hub_Bool_Exp>>;
  _not?: InputMaybe<Note_Hub_Bool_Exp>;
  _or?: InputMaybe<Array<Note_Hub_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "note_hub" */
export enum Note_Hub_Constraint {
  /** unique or primary key constraint on columns "id" */
  NoteHubPkey = 'note_hub_pkey'
}

/** input type for inserting data into table "note_hub" */
export type Note_Hub_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Note_Hub_Max_Fields = {
  __typename?: 'note_hub_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Note_Hub_Min_Fields = {
  __typename?: 'note_hub_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "note_hub" */
export type Note_Hub_Mutation_Response = {
  __typename?: 'note_hub_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Note_Hub>;
};

/** on_conflict condition type for table "note_hub" */
export type Note_Hub_On_Conflict = {
  constraint: Note_Hub_Constraint;
  update_columns?: Array<Note_Hub_Update_Column>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};

/** Ordering options when selecting data from "note_hub". */
export type Note_Hub_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: note_hub */
export type Note_Hub_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "note_hub" */
export enum Note_Hub_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "note_hub" */
export type Note_Hub_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "note_hub" */
export type Note_Hub_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Note_Hub_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Note_Hub_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "note_hub" */
export enum Note_Hub_Update_Column {
  /** column name */
  Id = 'id'
}

export type Note_Hub_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Note_Hub_Set_Input>;
  /** filter the rows which have to be updated */
  where: Note_Hub_Bool_Exp;
};

/** input type for incrementing numeric columns in table "note" */
export type Note_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "note" */
export type Note_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Note_Max_Fields = {
  __typename?: 'note_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "note" */
export type Note_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Note_Min_Fields = {
  __typename?: 'note_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "note" */
export type Note_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "note" */
export type Note_Mutation_Response = {
  __typename?: 'note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Note>;
};

/** on_conflict condition type for table "note" */
export type Note_On_Conflict = {
  constraint: Note_Constraint;
  update_columns?: Array<Note_Update_Column>;
  where?: InputMaybe<Note_Bool_Exp>;
};

/** Ordering options when selecting data from "note". */
export type Note_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_enabled?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** primary key columns input for table: note */
export type Note_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "note" */
export enum Note_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'is_enabled',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Text = 'text'
}

/** select "note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "note" */
export enum Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsEnabled = 'is_enabled'
}

/** select "note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "note" */
export enum Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsEnabled = 'is_enabled'
}

/** input type for updating data in table "note" */
export type Note_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Note_Stddev_Fields = {
  __typename?: 'note_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "note" */
export type Note_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Note_Stddev_Pop_Fields = {
  __typename?: 'note_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "note" */
export type Note_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Note_Stddev_Samp_Fields = {
  __typename?: 'note_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "note" */
export type Note_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "note" */
export type Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Note_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Note_Sum_Fields = {
  __typename?: 'note_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "note" */
export type Note_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "note" */
export enum Note_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsEnabled = 'is_enabled',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Text = 'text'
}

export type Note_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Note_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Note_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Note_Var_Pop_Fields = {
  __typename?: 'note_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "note" */
export type Note_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Note_Var_Samp_Fields = {
  __typename?: 'note_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "note" */
export type Note_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Note_Variance_Fields = {
  __typename?: 'note_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "note" */
export type Note_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification" */
export type Notification = {
  __typename?: 'notification';
  created_at: Scalars['timestamptz']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  from_user: User;
  from_user_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  message: Scalars['String']['output'];
  metadata: Scalars['jsonb']['output'];
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "notification" */
export type NotificationMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "notification" */
export type Notification_Aggregate = {
  __typename?: 'notification_aggregate';
  aggregate?: Maybe<Notification_Aggregate_Fields>;
  nodes: Array<Notification>;
};

/** aggregate fields of "notification" */
export type Notification_Aggregate_Fields = {
  __typename?: 'notification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Notification_Max_Fields>;
  min?: Maybe<Notification_Min_Fields>;
};


/** aggregate fields of "notification" */
export type Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Notification_Append_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "notification". All fields are combined with a logical 'AND'. */
export type Notification_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Bool_Exp>>;
  _not?: InputMaybe<Notification_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  from_user?: InputMaybe<User_Bool_Exp>;
  from_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  to_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification" */
export enum Notification_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationPkey = 'notification_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Notification_Delete_At_Path_Input = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Notification_Delete_Elem_Input = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Notification_Delete_Key_Input = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "notification" */
export type Notification_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Notification_Max_Fields = {
  __typename?: 'notification_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Notification_Min_Fields = {
  __typename?: 'notification_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  seen_at?: Maybe<Scalars['timestamptz']['output']>;
  to_user_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "notification" */
export type Notification_Mutation_Response = {
  __typename?: 'notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification>;
};

/** on_conflict condition type for table "notification" */
export type Notification_On_Conflict = {
  constraint: Notification_Constraint;
  update_columns?: Array<Notification_Update_Column>;
  where?: InputMaybe<Notification_Bool_Exp>;
};

/** Ordering options when selecting data from "notification". */
export type Notification_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  from_user?: InputMaybe<User_Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  seen_at?: InputMaybe<Order_By>;
  to_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification */
export type Notification_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Notification_Prepend_Input = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "notification" */
export enum Notification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notification" */
export type Notification_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "notification" */
export type Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  to_user_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notification" */
export enum Notification_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  SeenAt = 'seen_at',
  /** column name */
  ToUserId = 'to_user_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Notification_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Notification_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Notification_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Notification_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Notification_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Notification_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "office_action" */
export type Office_Action = {
  __typename?: 'office_action';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  ai_issue_summary?: Maybe<Scalars['String']['output']>;
  ai_similar_marks?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  assignee_history?: Maybe<Scalars['jsonb']['output']>;
  client_delight?: Maybe<Scalars['String']['output']>;
  client_input?: Maybe<Scalars['String']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  consent_denied_roa_service_request_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  due_date?: Maybe<Scalars['date']['output']>;
  external_communication: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_final: Scalars['Boolean']['output'];
  issue_date?: Maybe<Scalars['date']['output']>;
  issue_summary?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  issues: Array<Office_Action_Issue>;
  /** An aggregate relationship */
  issues_aggregate: Office_Action_Issue_Aggregate;
  issues_version: Scalars['Int']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  missive_link?: Maybe<Scalars['String']['output']>;
  nature_of_issues?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  /** An array relationship */
  office_action_similar_trademark_map: Array<Office_Action_Similar_Trademark_Map>;
  /** An aggregate relationship */
  office_action_similar_trademark_map_aggregate: Office_Action_Similar_Trademark_Map_Aggregate;
  order_currency?: Maybe<Scalars['String']['output']>;
  order_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  orders: Array<Service_Request>;
  /** An aggregate relationship */
  orders_aggregate: Service_Request_Aggregate;
  outcome?: Maybe<Scalars['String']['output']>;
  partner_description?: Maybe<Scalars['String']['output']>;
  recommendation_note?: Maybe<Scalars['String']['output']>;
  reminders_enabled: Scalars['Boolean']['output'];
  risk_highlighted?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  solutions: Array<Office_Action_Solution>;
  /** An aggregate relationship */
  solutions_aggregate: Office_Action_Solution_Aggregate;
  status: Scalars['String']['output'];
  suggested_issues?: Maybe<Scalars['jsonb']['output']>;
  supplemental_register_suggested?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  tracking_actions: Array<Office_Action_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Office_Action_Tracking_Aggregate;
  /** An object relationship */
  trademark: Trademark;
  trademark_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "office_action" */
export type Office_ActionAi_Similar_MarksArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "office_action" */
export type Office_ActionAssignee_HistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "office_action" */
export type Office_ActionDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionIssuesArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionIssues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionOffice_Action_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionOffice_Action_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionOrdersArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionSolutionsArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionSolutions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionSuggested_IssuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "office_action" */
export type Office_ActionTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "office_action" */
export type Office_ActionTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


/** columns and relationships of "office_action" */
export type Office_ActionTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};

/** aggregated selection of "office_action" */
export type Office_Action_Aggregate = {
  __typename?: 'office_action_aggregate';
  aggregate?: Maybe<Office_Action_Aggregate_Fields>;
  nodes: Array<Office_Action>;
};

export type Office_Action_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Office_Action_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Office_Action_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Office_Action_Aggregate_Bool_Exp_Count>;
};

export type Office_Action_Aggregate_Bool_Exp_Bool_And = {
  arguments: Office_Action_Select_Column_Office_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Office_Action_Select_Column_Office_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Office_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "office_action" */
export type Office_Action_Aggregate_Fields = {
  __typename?: 'office_action_aggregate_fields';
  avg?: Maybe<Office_Action_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Max_Fields>;
  min?: Maybe<Office_Action_Min_Fields>;
  stddev?: Maybe<Office_Action_Stddev_Fields>;
  stddev_pop?: Maybe<Office_Action_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Office_Action_Stddev_Samp_Fields>;
  sum?: Maybe<Office_Action_Sum_Fields>;
  var_pop?: Maybe<Office_Action_Var_Pop_Fields>;
  var_samp?: Maybe<Office_Action_Var_Samp_Fields>;
  variance?: Maybe<Office_Action_Variance_Fields>;
};


/** aggregate fields of "office_action" */
export type Office_Action_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "office_action" */
export type Office_Action_Aggregate_Order_By = {
  avg?: InputMaybe<Office_Action_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Office_Action_Max_Order_By>;
  min?: InputMaybe<Office_Action_Min_Order_By>;
  stddev?: InputMaybe<Office_Action_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Office_Action_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Office_Action_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Office_Action_Sum_Order_By>;
  var_pop?: InputMaybe<Office_Action_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Office_Action_Var_Samp_Order_By>;
  variance?: InputMaybe<Office_Action_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Office_Action_Append_Input = {
  ai_similar_marks?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  suggested_issues?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "office_action" */
export type Office_Action_Arr_Rel_Insert_Input = {
  data: Array<Office_Action_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_On_Conflict>;
};

/** aggregate avg on columns */
export type Office_Action_Avg_Fields = {
  __typename?: 'office_action_avg_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "office_action" */
export type Office_Action_Avg_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "office_action". All fields are combined with a logical 'AND'. */
export type Office_Action_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Bool_Exp>>;
  additional_info_note?: InputMaybe<String_Comparison_Exp>;
  ai_issue_summary?: InputMaybe<String_Comparison_Exp>;
  ai_similar_marks?: InputMaybe<Jsonb_Comparison_Exp>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assignee_history?: InputMaybe<Jsonb_Comparison_Exp>;
  client_delight?: InputMaybe<String_Comparison_Exp>;
  client_input?: InputMaybe<String_Comparison_Exp>;
  client_note?: InputMaybe<String_Comparison_Exp>;
  consent_denied_roa_service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  external_communication?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_final?: InputMaybe<Boolean_Comparison_Exp>;
  issue_date?: InputMaybe<Date_Comparison_Exp>;
  issue_summary?: InputMaybe<String_Comparison_Exp>;
  issues?: InputMaybe<Office_Action_Issue_Bool_Exp>;
  issues_aggregate?: InputMaybe<Office_Action_Issue_Aggregate_Bool_Exp>;
  issues_version?: InputMaybe<Int_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  missive_link?: InputMaybe<String_Comparison_Exp>;
  nature_of_issues?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  office_action_similar_trademark_map?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
  office_action_similar_trademark_map_aggregate?: InputMaybe<Office_Action_Similar_Trademark_Map_Aggregate_Bool_Exp>;
  order_currency?: InputMaybe<String_Comparison_Exp>;
  order_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  orders?: InputMaybe<Service_Request_Bool_Exp>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Bool_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  partner_description?: InputMaybe<String_Comparison_Exp>;
  recommendation_note?: InputMaybe<String_Comparison_Exp>;
  reminders_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  risk_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  solutions?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  solutions_aggregate?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  suggested_issues?: InputMaybe<Jsonb_Comparison_Exp>;
  supplemental_register_suggested?: InputMaybe<Boolean_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  tracking_actions?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Office_Action_Tracking_Aggregate_Bool_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action" */
export enum Office_Action_Constraint {
  /** unique or primary key constraint on columns "note_hub_id" */
  OfficeActionNoteHubIdKey = 'office_action_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  OfficeActionPkey = 'office_action_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Office_Action_Delete_At_Path_Input = {
  ai_similar_marks?: InputMaybe<Array<Scalars['String']['input']>>;
  assignee_history?: InputMaybe<Array<Scalars['String']['input']>>;
  suggested_issues?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Office_Action_Delete_Elem_Input = {
  ai_similar_marks?: InputMaybe<Scalars['Int']['input']>;
  assignee_history?: InputMaybe<Scalars['Int']['input']>;
  suggested_issues?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Office_Action_Delete_Key_Input = {
  ai_similar_marks?: InputMaybe<Scalars['String']['input']>;
  assignee_history?: InputMaybe<Scalars['String']['input']>;
  suggested_issues?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "office_action" */
export type Office_Action_Inc_Input = {
  issues_version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "office_action" */
export type Office_Action_Insert_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  ai_issue_summary?: InputMaybe<Scalars['String']['input']>;
  ai_similar_marks?: InputMaybe<Scalars['jsonb']['input']>;
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  client_delight?: InputMaybe<Scalars['String']['input']>;
  client_input?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  consent_denied_roa_service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  due_date?: InputMaybe<Scalars['date']['input']>;
  external_communication?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_final?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['date']['input']>;
  issue_summary?: InputMaybe<Scalars['String']['input']>;
  issues?: InputMaybe<Office_Action_Issue_Arr_Rel_Insert_Input>;
  issues_version?: InputMaybe<Scalars['Int']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  nature_of_issues?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  office_action_similar_trademark_map?: InputMaybe<Office_Action_Similar_Trademark_Map_Arr_Rel_Insert_Input>;
  order_currency?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  orders?: InputMaybe<Service_Request_Arr_Rel_Insert_Input>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  partner_description?: InputMaybe<Scalars['String']['input']>;
  recommendation_note?: InputMaybe<Scalars['String']['input']>;
  reminders_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  risk_highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  solutions?: InputMaybe<Office_Action_Solution_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_issues?: InputMaybe<Scalars['jsonb']['input']>;
  supplemental_register_suggested?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  tracking_actions?: InputMaybe<Office_Action_Tracking_Arr_Rel_Insert_Input>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "office_action_issue" */
export type Office_Action_Issue = {
  __typename?: 'office_action_issue';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  /** An object relationship */
  document_folder?: Maybe<Document_Folder>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  office_action: Office_Action;
  office_action_id: Scalars['uuid']['output'];
};

/** aggregated selection of "office_action_issue" */
export type Office_Action_Issue_Aggregate = {
  __typename?: 'office_action_issue_aggregate';
  aggregate?: Maybe<Office_Action_Issue_Aggregate_Fields>;
  nodes: Array<Office_Action_Issue>;
};

export type Office_Action_Issue_Aggregate_Bool_Exp = {
  count?: InputMaybe<Office_Action_Issue_Aggregate_Bool_Exp_Count>;
};

export type Office_Action_Issue_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Issue_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "office_action_issue" */
export type Office_Action_Issue_Aggregate_Fields = {
  __typename?: 'office_action_issue_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Issue_Max_Fields>;
  min?: Maybe<Office_Action_Issue_Min_Fields>;
};


/** aggregate fields of "office_action_issue" */
export type Office_Action_Issue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "office_action_issue" */
export type Office_Action_Issue_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Office_Action_Issue_Max_Order_By>;
  min?: InputMaybe<Office_Action_Issue_Min_Order_By>;
};

/** input type for inserting array relation for remote table "office_action_issue" */
export type Office_Action_Issue_Arr_Rel_Insert_Input = {
  data: Array<Office_Action_Issue_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Issue_On_Conflict>;
};

/** Boolean expression to filter rows from the table "office_action_issue". All fields are combined with a logical 'AND'. */
export type Office_Action_Issue_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Issue_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Issue_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Issue_Bool_Exp>>;
  additional_info_note?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  document_folder?: InputMaybe<Document_Folder_Bool_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_action?: InputMaybe<Office_Action_Bool_Exp>;
  office_action_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action_issue" */
export enum Office_Action_Issue_Constraint {
  /** unique or primary key constraint on columns "id" */
  OfficeActionIssuePkey = 'office_action_issue_pkey'
}

/** input type for inserting data into table "office_action_issue" */
export type Office_Action_Issue_Insert_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  document_folder?: InputMaybe<Document_Folder_Obj_Rel_Insert_Input>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action?: InputMaybe<Office_Action_Obj_Rel_Insert_Input>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Office_Action_Issue_Max_Fields = {
  __typename?: 'office_action_issue_max_fields';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "office_action_issue" */
export type Office_Action_Issue_Max_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Office_Action_Issue_Min_Fields = {
  __typename?: 'office_action_issue_min_fields';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "office_action_issue" */
export type Office_Action_Issue_Min_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "office_action_issue" */
export type Office_Action_Issue_Mutation_Response = {
  __typename?: 'office_action_issue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action_Issue>;
};

/** on_conflict condition type for table "office_action_issue" */
export type Office_Action_Issue_On_Conflict = {
  constraint: Office_Action_Issue_Constraint;
  update_columns?: Array<Office_Action_Issue_Update_Column>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action_issue". */
export type Office_Action_Issue_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  document_folder?: InputMaybe<Document_Folder_Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action?: InputMaybe<Office_Action_Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action_issue */
export type Office_Action_Issue_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "office_action_issue" */
export enum Office_Action_Issue_Select_Column {
  /** column name */
  AdditionalInfoNote = 'additional_info_note',
  /** column name */
  Category = 'category',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeActionId = 'office_action_id'
}

/** input type for updating data in table "office_action_issue" */
export type Office_Action_Issue_Set_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "office_action_issue" */
export type Office_Action_Issue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Issue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Issue_Stream_Cursor_Value_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "office_action_issue" */
export enum Office_Action_Issue_Update_Column {
  /** column name */
  AdditionalInfoNote = 'additional_info_note',
  /** column name */
  Category = 'category',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeActionId = 'office_action_id'
}

export type Office_Action_Issue_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Issue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Issue_Bool_Exp;
};

/** aggregate max on columns */
export type Office_Action_Max_Fields = {
  __typename?: 'office_action_max_fields';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  ai_issue_summary?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  client_delight?: Maybe<Scalars['String']['output']>;
  client_input?: Maybe<Scalars['String']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  consent_denied_roa_service_request_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  due_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_date?: Maybe<Scalars['date']['output']>;
  issue_summary?: Maybe<Scalars['String']['output']>;
  issues_version?: Maybe<Scalars['Int']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link?: Maybe<Scalars['String']['output']>;
  nature_of_issues?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_currency?: Maybe<Scalars['String']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  partner_description?: Maybe<Scalars['String']['output']>;
  recommendation_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "office_action" */
export type Office_Action_Max_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  ai_issue_summary?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  client_delight?: InputMaybe<Order_By>;
  client_input?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  consent_denied_roa_service_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  issue_summary?: InputMaybe<Order_By>;
  issues_version?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link?: InputMaybe<Order_By>;
  nature_of_issues?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_currency?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  partner_description?: InputMaybe<Order_By>;
  recommendation_note?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Office_Action_Min_Fields = {
  __typename?: 'office_action_min_fields';
  additional_info_note?: Maybe<Scalars['String']['output']>;
  ai_issue_summary?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  client_delight?: Maybe<Scalars['String']['output']>;
  client_input?: Maybe<Scalars['String']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  consent_denied_roa_service_request_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  due_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_date?: Maybe<Scalars['date']['output']>;
  issue_summary?: Maybe<Scalars['String']['output']>;
  issues_version?: Maybe<Scalars['Int']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link?: Maybe<Scalars['String']['output']>;
  nature_of_issues?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_currency?: Maybe<Scalars['String']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  partner_description?: Maybe<Scalars['String']['output']>;
  recommendation_note?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "office_action" */
export type Office_Action_Min_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  ai_issue_summary?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  client_delight?: InputMaybe<Order_By>;
  client_input?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  consent_denied_roa_service_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  issue_summary?: InputMaybe<Order_By>;
  issues_version?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link?: InputMaybe<Order_By>;
  nature_of_issues?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_currency?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  partner_description?: InputMaybe<Order_By>;
  recommendation_note?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "office_action" */
export type Office_Action_Mutation_Response = {
  __typename?: 'office_action_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action>;
};

/** input type for inserting object relation for remote table "office_action" */
export type Office_Action_Obj_Rel_Insert_Input = {
  data: Office_Action_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_On_Conflict>;
};

/** on_conflict condition type for table "office_action" */
export type Office_Action_On_Conflict = {
  constraint: Office_Action_Constraint;
  update_columns?: Array<Office_Action_Update_Column>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action". */
export type Office_Action_Order_By = {
  additional_info_note?: InputMaybe<Order_By>;
  ai_issue_summary?: InputMaybe<Order_By>;
  ai_similar_marks?: InputMaybe<Order_By>;
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  assignee_history?: InputMaybe<Order_By>;
  client_delight?: InputMaybe<Order_By>;
  client_input?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  consent_denied_roa_service_request_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  due_date?: InputMaybe<Order_By>;
  external_communication?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_final?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  issue_summary?: InputMaybe<Order_By>;
  issues_aggregate?: InputMaybe<Office_Action_Issue_Aggregate_Order_By>;
  issues_version?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link?: InputMaybe<Order_By>;
  nature_of_issues?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  office_action_similar_trademark_map_aggregate?: InputMaybe<Office_Action_Similar_Trademark_Map_Aggregate_Order_By>;
  order_currency?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Order_By>;
  outcome?: InputMaybe<Order_By>;
  partner_description?: InputMaybe<Order_By>;
  recommendation_note?: InputMaybe<Order_By>;
  reminders_enabled?: InputMaybe<Order_By>;
  risk_highlighted?: InputMaybe<Order_By>;
  solutions_aggregate?: InputMaybe<Office_Action_Solution_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  suggested_issues?: InputMaybe<Order_By>;
  supplemental_register_suggested?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Office_Action_Tracking_Aggregate_Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action */
export type Office_Action_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Office_Action_Prepend_Input = {
  ai_similar_marks?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  suggested_issues?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "office_action" */
export enum Office_Action_Select_Column {
  /** column name */
  AdditionalInfoNote = 'additional_info_note',
  /** column name */
  AiIssueSummary = 'ai_issue_summary',
  /** column name */
  AiSimilarMarks = 'ai_similar_marks',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  ClientDelight = 'client_delight',
  /** column name */
  ClientInput = 'client_input',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  ConsentDeniedRoaServiceRequestId = 'consent_denied_roa_service_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalCommunication = 'external_communication',
  /** column name */
  Id = 'id',
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  IssueSummary = 'issue_summary',
  /** column name */
  IssuesVersion = 'issues_version',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  MissiveLink = 'missive_link',
  /** column name */
  NatureOfIssues = 'nature_of_issues',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderCurrency = 'order_currency',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  PartnerDescription = 'partner_description',
  /** column name */
  RecommendationNote = 'recommendation_note',
  /** column name */
  RemindersEnabled = 'reminders_enabled',
  /** column name */
  RiskHighlighted = 'risk_highlighted',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedIssues = 'suggested_issues',
  /** column name */
  SupplementalRegisterSuggested = 'supplemental_register_suggested',
  /** column name */
  Tags = 'tags',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** select "office_action_aggregate_bool_exp_bool_and_arguments_columns" columns of table "office_action" */
export enum Office_Action_Select_Column_Office_Action_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ExternalCommunication = 'external_communication',
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  RemindersEnabled = 'reminders_enabled',
  /** column name */
  RiskHighlighted = 'risk_highlighted',
  /** column name */
  SupplementalRegisterSuggested = 'supplemental_register_suggested'
}

/** select "office_action_aggregate_bool_exp_bool_or_arguments_columns" columns of table "office_action" */
export enum Office_Action_Select_Column_Office_Action_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ExternalCommunication = 'external_communication',
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  RemindersEnabled = 'reminders_enabled',
  /** column name */
  RiskHighlighted = 'risk_highlighted',
  /** column name */
  SupplementalRegisterSuggested = 'supplemental_register_suggested'
}

/** input type for updating data in table "office_action" */
export type Office_Action_Set_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  ai_issue_summary?: InputMaybe<Scalars['String']['input']>;
  ai_similar_marks?: InputMaybe<Scalars['jsonb']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  client_delight?: InputMaybe<Scalars['String']['input']>;
  client_input?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  consent_denied_roa_service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  due_date?: InputMaybe<Scalars['date']['input']>;
  external_communication?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_final?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['date']['input']>;
  issue_summary?: InputMaybe<Scalars['String']['input']>;
  issues_version?: InputMaybe<Scalars['Int']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  nature_of_issues?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_currency?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  partner_description?: InputMaybe<Scalars['String']['input']>;
  recommendation_note?: InputMaybe<Scalars['String']['input']>;
  reminders_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  risk_highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_issues?: InputMaybe<Scalars['jsonb']['input']>;
  supplemental_register_suggested?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map = {
  __typename?: 'office_action_similar_trademark_map';
  /** An object relationship */
  external_trademark: External_Trademark;
  external_trademark_id: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  office_action: Office_Action;
  office_action_id: Scalars['uuid']['output'];
};

/** aggregated selection of "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Aggregate = {
  __typename?: 'office_action_similar_trademark_map_aggregate';
  aggregate?: Maybe<Office_Action_Similar_Trademark_Map_Aggregate_Fields>;
  nodes: Array<Office_Action_Similar_Trademark_Map>;
};

export type Office_Action_Similar_Trademark_Map_Aggregate_Bool_Exp = {
  count?: InputMaybe<Office_Action_Similar_Trademark_Map_Aggregate_Bool_Exp_Count>;
};

export type Office_Action_Similar_Trademark_Map_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Aggregate_Fields = {
  __typename?: 'office_action_similar_trademark_map_aggregate_fields';
  avg?: Maybe<Office_Action_Similar_Trademark_Map_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Similar_Trademark_Map_Max_Fields>;
  min?: Maybe<Office_Action_Similar_Trademark_Map_Min_Fields>;
  stddev?: Maybe<Office_Action_Similar_Trademark_Map_Stddev_Fields>;
  stddev_pop?: Maybe<Office_Action_Similar_Trademark_Map_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Office_Action_Similar_Trademark_Map_Stddev_Samp_Fields>;
  sum?: Maybe<Office_Action_Similar_Trademark_Map_Sum_Fields>;
  var_pop?: Maybe<Office_Action_Similar_Trademark_Map_Var_Pop_Fields>;
  var_samp?: Maybe<Office_Action_Similar_Trademark_Map_Var_Samp_Fields>;
  variance?: Maybe<Office_Action_Similar_Trademark_Map_Variance_Fields>;
};


/** aggregate fields of "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Aggregate_Order_By = {
  avg?: InputMaybe<Office_Action_Similar_Trademark_Map_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Office_Action_Similar_Trademark_Map_Max_Order_By>;
  min?: InputMaybe<Office_Action_Similar_Trademark_Map_Min_Order_By>;
  stddev?: InputMaybe<Office_Action_Similar_Trademark_Map_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Office_Action_Similar_Trademark_Map_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Office_Action_Similar_Trademark_Map_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Office_Action_Similar_Trademark_Map_Sum_Order_By>;
  var_pop?: InputMaybe<Office_Action_Similar_Trademark_Map_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Office_Action_Similar_Trademark_Map_Var_Samp_Order_By>;
  variance?: InputMaybe<Office_Action_Similar_Trademark_Map_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Arr_Rel_Insert_Input = {
  data: Array<Office_Action_Similar_Trademark_Map_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Similar_Trademark_Map_On_Conflict>;
};

/** aggregate avg on columns */
export type Office_Action_Similar_Trademark_Map_Avg_Fields = {
  __typename?: 'office_action_similar_trademark_map_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "office_action_similar_trademark_map". All fields are combined with a logical 'AND'. */
export type Office_Action_Similar_Trademark_Map_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Bool_Exp>>;
  external_trademark?: InputMaybe<External_Trademark_Bool_Exp>;
  external_trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  office_action?: InputMaybe<Office_Action_Bool_Exp>;
  office_action_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action_similar_trademark_map" */
export enum Office_Action_Similar_Trademark_Map_Constraint {
  /** unique or primary key constraint on columns "id" */
  OfficeActionSimilarTrademarkMapPkey = 'office_action_similar_trademark_map_pkey',
  /** unique or primary key constraint on columns "office_action_id", "external_trademark_id" */
  UniqueOfficeActionSimilarTrademarkMapIdx = 'unique_office_action_similar_trademark_map_idx'
}

/** input type for incrementing numeric columns in table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Insert_Input = {
  external_trademark?: InputMaybe<External_Trademark_Obj_Rel_Insert_Input>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  office_action?: InputMaybe<Office_Action_Obj_Rel_Insert_Input>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Office_Action_Similar_Trademark_Map_Max_Fields = {
  __typename?: 'office_action_similar_trademark_map_max_fields';
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Max_Order_By = {
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Office_Action_Similar_Trademark_Map_Min_Fields = {
  __typename?: 'office_action_similar_trademark_map_min_fields';
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Min_Order_By = {
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Mutation_Response = {
  __typename?: 'office_action_similar_trademark_map_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action_Similar_Trademark_Map>;
};

/** on_conflict condition type for table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_On_Conflict = {
  constraint: Office_Action_Similar_Trademark_Map_Constraint;
  update_columns?: Array<Office_Action_Similar_Trademark_Map_Update_Column>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action_similar_trademark_map". */
export type Office_Action_Similar_Trademark_Map_Order_By = {
  external_trademark?: InputMaybe<External_Trademark_Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_action?: InputMaybe<Office_Action_Order_By>;
  office_action_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action_similar_trademark_map */
export type Office_Action_Similar_Trademark_Map_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "office_action_similar_trademark_map" */
export enum Office_Action_Similar_Trademark_Map_Select_Column {
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  OfficeActionId = 'office_action_id'
}

/** input type for updating data in table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Set_Input = {
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Office_Action_Similar_Trademark_Map_Stddev_Fields = {
  __typename?: 'office_action_similar_trademark_map_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Office_Action_Similar_Trademark_Map_Stddev_Pop_Fields = {
  __typename?: 'office_action_similar_trademark_map_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Office_Action_Similar_Trademark_Map_Stddev_Samp_Fields = {
  __typename?: 'office_action_similar_trademark_map_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Similar_Trademark_Map_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Similar_Trademark_Map_Stream_Cursor_Value_Input = {
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Office_Action_Similar_Trademark_Map_Sum_Fields = {
  __typename?: 'office_action_similar_trademark_map_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "office_action_similar_trademark_map" */
export enum Office_Action_Similar_Trademark_Map_Update_Column {
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  OfficeActionId = 'office_action_id'
}

export type Office_Action_Similar_Trademark_Map_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Office_Action_Similar_Trademark_Map_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Similar_Trademark_Map_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Similar_Trademark_Map_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Office_Action_Similar_Trademark_Map_Var_Pop_Fields = {
  __typename?: 'office_action_similar_trademark_map_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Office_Action_Similar_Trademark_Map_Var_Samp_Fields = {
  __typename?: 'office_action_similar_trademark_map_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Office_Action_Similar_Trademark_Map_Variance_Fields = {
  __typename?: 'office_action_similar_trademark_map_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "office_action_similar_trademark_map" */
export type Office_Action_Similar_Trademark_Map_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "office_action_solution" */
export type Office_Action_Solution = {
  __typename?: 'office_action_solution';
  chance_of_success?: Maybe<Scalars['Int']['output']>;
  government_fee?: Maybe<Scalars['float8']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  /** An object relationship */
  office_action: Office_Action;
  office_action_id: Scalars['uuid']['output'];
  /** An object relationship */
  order?: Maybe<Service_Request>;
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  recommended: Scalars['Boolean']['output'];
  selected: Scalars['Boolean']['output'];
  service_fee?: Maybe<Scalars['float8']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  solution: Scalars['String']['output'];
};

/** aggregated selection of "office_action_solution" */
export type Office_Action_Solution_Aggregate = {
  __typename?: 'office_action_solution_aggregate';
  aggregate?: Maybe<Office_Action_Solution_Aggregate_Fields>;
  nodes: Array<Office_Action_Solution>;
};

export type Office_Action_Solution_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Office_Action_Solution_Aggregate_Bool_Exp_Var_Samp>;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Avg = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Bool_And = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Corr = {
  arguments: Office_Action_Solution_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Max = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Min = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Sum = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Office_Action_Solution_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "office_action_solution" */
export type Office_Action_Solution_Aggregate_Fields = {
  __typename?: 'office_action_solution_aggregate_fields';
  avg?: Maybe<Office_Action_Solution_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Solution_Max_Fields>;
  min?: Maybe<Office_Action_Solution_Min_Fields>;
  stddev?: Maybe<Office_Action_Solution_Stddev_Fields>;
  stddev_pop?: Maybe<Office_Action_Solution_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Office_Action_Solution_Stddev_Samp_Fields>;
  sum?: Maybe<Office_Action_Solution_Sum_Fields>;
  var_pop?: Maybe<Office_Action_Solution_Var_Pop_Fields>;
  var_samp?: Maybe<Office_Action_Solution_Var_Samp_Fields>;
  variance?: Maybe<Office_Action_Solution_Variance_Fields>;
};


/** aggregate fields of "office_action_solution" */
export type Office_Action_Solution_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "office_action_solution" */
export type Office_Action_Solution_Aggregate_Order_By = {
  avg?: InputMaybe<Office_Action_Solution_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Office_Action_Solution_Max_Order_By>;
  min?: InputMaybe<Office_Action_Solution_Min_Order_By>;
  stddev?: InputMaybe<Office_Action_Solution_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Office_Action_Solution_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Office_Action_Solution_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Office_Action_Solution_Sum_Order_By>;
  var_pop?: InputMaybe<Office_Action_Solution_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Office_Action_Solution_Var_Samp_Order_By>;
  variance?: InputMaybe<Office_Action_Solution_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "office_action_solution" */
export type Office_Action_Solution_Arr_Rel_Insert_Input = {
  data: Array<Office_Action_Solution_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Solution_On_Conflict>;
};

/** aggregate avg on columns */
export type Office_Action_Solution_Avg_Fields = {
  __typename?: 'office_action_solution_avg_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "office_action_solution" */
export type Office_Action_Solution_Avg_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "office_action_solution". All fields are combined with a logical 'AND'. */
export type Office_Action_Solution_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Solution_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Solution_Bool_Exp>>;
  chance_of_success?: InputMaybe<Int_Comparison_Exp>;
  government_fee?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Int_Comparison_Exp>;
  office_action?: InputMaybe<Office_Action_Bool_Exp>;
  office_action_id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Service_Request_Bool_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  recommended?: InputMaybe<Boolean_Comparison_Exp>;
  selected?: InputMaybe<Boolean_Comparison_Exp>;
  service_fee?: InputMaybe<Float8_Comparison_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  solution?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action_solution" */
export enum Office_Action_Solution_Constraint {
  /** unique or primary key constraint on columns "id" */
  OfficeActionSolutionPkey = 'office_action_solution_pkey',
  /** unique or primary key constraint on columns "quote_hub_id" */
  OfficeActionSolutionQuoteHubIdKey = 'office_action_solution_quote_hub_id_key'
}

/** input type for incrementing numeric columns in table "office_action_solution" */
export type Office_Action_Solution_Inc_Input = {
  chance_of_success?: InputMaybe<Scalars['Int']['input']>;
  government_fee?: InputMaybe<Scalars['float8']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  service_fee?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "office_action_solution" */
export type Office_Action_Solution_Insert_Input = {
  chance_of_success?: InputMaybe<Scalars['Int']['input']>;
  government_fee?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  office_action?: InputMaybe<Office_Action_Obj_Rel_Insert_Input>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  service_fee?: InputMaybe<Scalars['float8']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Office_Action_Solution_Max_Fields = {
  __typename?: 'office_action_solution_max_fields';
  chance_of_success?: Maybe<Scalars['Int']['output']>;
  government_fee?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  service_fee?: Maybe<Scalars['float8']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "office_action_solution" */
export type Office_Action_Solution_Max_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Office_Action_Solution_Min_Fields = {
  __typename?: 'office_action_solution_min_fields';
  chance_of_success?: Maybe<Scalars['Int']['output']>;
  government_fee?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  service_fee?: Maybe<Scalars['float8']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  solution?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "office_action_solution" */
export type Office_Action_Solution_Min_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "office_action_solution" */
export type Office_Action_Solution_Mutation_Response = {
  __typename?: 'office_action_solution_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action_Solution>;
};

/** input type for inserting object relation for remote table "office_action_solution" */
export type Office_Action_Solution_Obj_Rel_Insert_Input = {
  data: Office_Action_Solution_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Solution_On_Conflict>;
};

/** on_conflict condition type for table "office_action_solution" */
export type Office_Action_Solution_On_Conflict = {
  constraint: Office_Action_Solution_Constraint;
  update_columns?: Array<Office_Action_Solution_Update_Column>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action_solution". */
export type Office_Action_Solution_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  office_action?: InputMaybe<Office_Action_Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Service_Request_Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  recommended?: InputMaybe<Order_By>;
  selected?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  solution?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action_solution */
export type Office_Action_Solution_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column {
  /** column name */
  ChanceOfSuccess = 'chance_of_success',
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  Recommended = 'recommended',
  /** column name */
  Selected = 'selected',
  /** column name */
  ServiceFee = 'service_fee',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Solution = 'solution'
}

/** select "office_action_solution_aggregate_bool_exp_avg_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_bool_and_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Recommended = 'recommended',
  /** column name */
  Selected = 'selected'
}

/** select "office_action_solution_aggregate_bool_exp_bool_or_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Recommended = 'recommended',
  /** column name */
  Selected = 'selected'
}

/** select "office_action_solution_aggregate_bool_exp_corr_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_max_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_min_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_sum_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** select "office_action_solution_aggregate_bool_exp_var_samp_arguments_columns" columns of table "office_action_solution" */
export enum Office_Action_Solution_Select_Column_Office_Action_Solution_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  ServiceFee = 'service_fee'
}

/** input type for updating data in table "office_action_solution" */
export type Office_Action_Solution_Set_Input = {
  chance_of_success?: InputMaybe<Scalars['Int']['input']>;
  government_fee?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  service_fee?: InputMaybe<Scalars['float8']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Office_Action_Solution_Stddev_Fields = {
  __typename?: 'office_action_solution_stddev_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "office_action_solution" */
export type Office_Action_Solution_Stddev_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Office_Action_Solution_Stddev_Pop_Fields = {
  __typename?: 'office_action_solution_stddev_pop_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "office_action_solution" */
export type Office_Action_Solution_Stddev_Pop_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Office_Action_Solution_Stddev_Samp_Fields = {
  __typename?: 'office_action_solution_stddev_samp_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "office_action_solution" */
export type Office_Action_Solution_Stddev_Samp_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "office_action_solution" */
export type Office_Action_Solution_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Solution_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Solution_Stream_Cursor_Value_Input = {
  chance_of_success?: InputMaybe<Scalars['Int']['input']>;
  government_fee?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  service_fee?: InputMaybe<Scalars['float8']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  solution?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Office_Action_Solution_Sum_Fields = {
  __typename?: 'office_action_solution_sum_fields';
  chance_of_success?: Maybe<Scalars['Int']['output']>;
  government_fee?: Maybe<Scalars['float8']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  service_fee?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "office_action_solution" */
export type Office_Action_Solution_Sum_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** update columns of table "office_action_solution" */
export enum Office_Action_Solution_Update_Column {
  /** column name */
  ChanceOfSuccess = 'chance_of_success',
  /** column name */
  GovernmentFee = 'government_fee',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  Recommended = 'recommended',
  /** column name */
  Selected = 'selected',
  /** column name */
  ServiceFee = 'service_fee',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Solution = 'solution'
}

export type Office_Action_Solution_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Office_Action_Solution_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Solution_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Solution_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Office_Action_Solution_Var_Pop_Fields = {
  __typename?: 'office_action_solution_var_pop_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "office_action_solution" */
export type Office_Action_Solution_Var_Pop_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Office_Action_Solution_Var_Samp_Fields = {
  __typename?: 'office_action_solution_var_samp_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "office_action_solution" */
export type Office_Action_Solution_Var_Samp_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Office_Action_Solution_Variance_Fields = {
  __typename?: 'office_action_solution_variance_fields';
  chance_of_success?: Maybe<Scalars['Float']['output']>;
  government_fee?: Maybe<Scalars['Float']['output']>;
  index?: Maybe<Scalars['Float']['output']>;
  service_fee?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "office_action_solution" */
export type Office_Action_Solution_Variance_Order_By = {
  chance_of_success?: InputMaybe<Order_By>;
  government_fee?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  service_fee?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Office_Action_Stddev_Fields = {
  __typename?: 'office_action_stddev_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "office_action" */
export type Office_Action_Stddev_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Office_Action_Stddev_Pop_Fields = {
  __typename?: 'office_action_stddev_pop_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "office_action" */
export type Office_Action_Stddev_Pop_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Office_Action_Stddev_Samp_Fields = {
  __typename?: 'office_action_stddev_samp_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "office_action" */
export type Office_Action_Stddev_Samp_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "office_action" */
export type Office_Action_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Stream_Cursor_Value_Input = {
  additional_info_note?: InputMaybe<Scalars['String']['input']>;
  ai_issue_summary?: InputMaybe<Scalars['String']['input']>;
  ai_similar_marks?: InputMaybe<Scalars['jsonb']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  client_delight?: InputMaybe<Scalars['String']['input']>;
  client_input?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  consent_denied_roa_service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  due_date?: InputMaybe<Scalars['date']['input']>;
  external_communication?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_final?: InputMaybe<Scalars['Boolean']['input']>;
  issue_date?: InputMaybe<Scalars['date']['input']>;
  issue_summary?: InputMaybe<Scalars['String']['input']>;
  issues_version?: InputMaybe<Scalars['Int']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  nature_of_issues?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_currency?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  partner_description?: InputMaybe<Scalars['String']['input']>;
  recommendation_note?: InputMaybe<Scalars['String']['input']>;
  reminders_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  risk_highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggested_issues?: InputMaybe<Scalars['jsonb']['input']>;
  supplemental_register_suggested?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Office_Action_Sum_Fields = {
  __typename?: 'office_action_sum_fields';
  issues_version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "office_action" */
export type Office_Action_Sum_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** columns and relationships of "office_action_tracking" */
export type Office_Action_Tracking = {
  __typename?: 'office_action_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  office_action: Office_Action;
  office_action_id: Scalars['uuid']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: Office_Action_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "office_action_tracking" */
export type Office_Action_Tracking_Aggregate = {
  __typename?: 'office_action_tracking_aggregate';
  aggregate?: Maybe<Office_Action_Tracking_Aggregate_Fields>;
  nodes: Array<Office_Action_Tracking>;
};

export type Office_Action_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Office_Action_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Office_Action_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Office_Action_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Office_Action_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Office_Action_Tracking_Select_Column_Office_Action_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Office_Action_Tracking_Select_Column_Office_Action_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Office_Action_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "office_action_tracking" */
export type Office_Action_Tracking_Aggregate_Fields = {
  __typename?: 'office_action_tracking_aggregate_fields';
  avg?: Maybe<Office_Action_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Tracking_Max_Fields>;
  min?: Maybe<Office_Action_Tracking_Min_Fields>;
  stddev?: Maybe<Office_Action_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Office_Action_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Office_Action_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Office_Action_Tracking_Sum_Fields>;
  var_pop?: Maybe<Office_Action_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Office_Action_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Office_Action_Tracking_Variance_Fields>;
};


/** aggregate fields of "office_action_tracking" */
export type Office_Action_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "office_action_tracking" */
export type Office_Action_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Office_Action_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Office_Action_Tracking_Max_Order_By>;
  min?: InputMaybe<Office_Action_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Office_Action_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Office_Action_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Office_Action_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Office_Action_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Office_Action_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Office_Action_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Office_Action_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "office_action_tracking" */
export type Office_Action_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Office_Action_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Office_Action_Tracking_Avg_Fields = {
  __typename?: 'office_action_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "office_action_tracking". All fields are combined with a logical 'AND'. */
export type Office_Action_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_action?: InputMaybe<Office_Action_Bool_Exp>;
  office_action_id?: InputMaybe<Uuid_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action_tracking" */
export enum Office_Action_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  OfficeActionTrackingPkey = 'office_action_tracking_pkey'
}

/** input type for incrementing numeric columns in table "office_action_tracking" */
export type Office_Action_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "office_action_tracking" */
export type Office_Action_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action?: InputMaybe<Office_Action_Obj_Rel_Insert_Input>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Office_Action_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Office_Action_Tracking_Max_Fields = {
  __typename?: 'office_action_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Office_Action_Tracking_Min_Fields = {
  __typename?: 'office_action_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  office_action_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "office_action_tracking" */
export type Office_Action_Tracking_Mutation_Response = {
  __typename?: 'office_action_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action_Tracking>;
};

/** on_conflict condition type for table "office_action_tracking" */
export type Office_Action_Tracking_On_Conflict = {
  constraint: Office_Action_Tracking_Constraint;
  update_columns?: Array<Office_Action_Tracking_Update_Column>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action_tracking". */
export type Office_Action_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_action?: InputMaybe<Office_Action_Order_By>;
  office_action_id?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Office_Action_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action_tracking */
export type Office_Action_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "office_action_tracking" */
export enum Office_Action_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "office_action_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "office_action_tracking" */
export enum Office_Action_Tracking_Select_Column_Office_Action_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "office_action_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "office_action_tracking" */
export enum Office_Action_Tracking_Select_Column_Office_Action_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "office_action_tracking" */
export type Office_Action_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "office_action_tracking_status" */
export type Office_Action_Tracking_Status = {
  __typename?: 'office_action_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Aggregate = {
  __typename?: 'office_action_tracking_status_aggregate';
  aggregate?: Maybe<Office_Action_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Office_Action_Tracking_Status>;
};

/** aggregate fields of "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Aggregate_Fields = {
  __typename?: 'office_action_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Office_Action_Tracking_Status_Max_Fields>;
  min?: Maybe<Office_Action_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Office_Action_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "office_action_tracking_status". All fields are combined with a logical 'AND'. */
export type Office_Action_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Office_Action_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Office_Action_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "office_action_tracking_status" */
export enum Office_Action_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  OfficeActionTrackingStatusPkey = 'office_action_tracking_status_pkey'
}

/** input type for inserting data into table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Office_Action_Tracking_Status_Max_Fields = {
  __typename?: 'office_action_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Office_Action_Tracking_Status_Min_Fields = {
  __typename?: 'office_action_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Mutation_Response = {
  __typename?: 'office_action_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Office_Action_Tracking_Status>;
};

/** input type for inserting object relation for remote table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Office_Action_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Office_Action_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_On_Conflict = {
  constraint: Office_Action_Tracking_Status_Constraint;
  update_columns?: Array<Office_Action_Tracking_Status_Update_Column>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "office_action_tracking_status". */
export type Office_Action_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: office_action_tracking_status */
export type Office_Action_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "office_action_tracking_status" */
export enum Office_Action_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "office_action_tracking_status" */
export type Office_Action_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "office_action_tracking_status" */
export enum Office_Action_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Office_Action_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Office_Action_Tracking_Stddev_Fields = {
  __typename?: 'office_action_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Office_Action_Tracking_Stddev_Pop_Fields = {
  __typename?: 'office_action_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Office_Action_Tracking_Stddev_Samp_Fields = {
  __typename?: 'office_action_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "office_action_tracking" */
export type Office_Action_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Office_Action_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Office_Action_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  office_action_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Office_Action_Tracking_Sum_Fields = {
  __typename?: 'office_action_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "office_action_tracking" */
export enum Office_Action_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeActionId = 'office_action_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Office_Action_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Office_Action_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Office_Action_Tracking_Var_Pop_Fields = {
  __typename?: 'office_action_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Office_Action_Tracking_Var_Samp_Fields = {
  __typename?: 'office_action_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Office_Action_Tracking_Variance_Fields = {
  __typename?: 'office_action_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "office_action_tracking" */
export type Office_Action_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "office_action" */
export enum Office_Action_Update_Column {
  /** column name */
  AdditionalInfoNote = 'additional_info_note',
  /** column name */
  AiIssueSummary = 'ai_issue_summary',
  /** column name */
  AiSimilarMarks = 'ai_similar_marks',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  ClientDelight = 'client_delight',
  /** column name */
  ClientInput = 'client_input',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  ConsentDeniedRoaServiceRequestId = 'consent_denied_roa_service_request_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ExternalCommunication = 'external_communication',
  /** column name */
  Id = 'id',
  /** column name */
  IsFinal = 'is_final',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  IssueSummary = 'issue_summary',
  /** column name */
  IssuesVersion = 'issues_version',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  MissiveLink = 'missive_link',
  /** column name */
  NatureOfIssues = 'nature_of_issues',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderCurrency = 'order_currency',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  PartnerDescription = 'partner_description',
  /** column name */
  RecommendationNote = 'recommendation_note',
  /** column name */
  RemindersEnabled = 'reminders_enabled',
  /** column name */
  RiskHighlighted = 'risk_highlighted',
  /** column name */
  Status = 'status',
  /** column name */
  SuggestedIssues = 'suggested_issues',
  /** column name */
  SupplementalRegisterSuggested = 'supplemental_register_suggested',
  /** column name */
  Tags = 'tags',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Office_Action_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Office_Action_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Office_Action_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Office_Action_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Office_Action_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Office_Action_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Office_Action_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Office_Action_Set_Input>;
  /** filter the rows which have to be updated */
  where: Office_Action_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Office_Action_Var_Pop_Fields = {
  __typename?: 'office_action_var_pop_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "office_action" */
export type Office_Action_Var_Pop_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Office_Action_Var_Samp_Fields = {
  __typename?: 'office_action_var_samp_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "office_action" */
export type Office_Action_Var_Samp_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Office_Action_Variance_Fields = {
  __typename?: 'office_action_variance_fields';
  issues_version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "office_action" */
export type Office_Action_Variance_Order_By = {
  issues_version?: InputMaybe<Order_By>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  /** An object relationship */
  quote: Quote;
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  quote_id: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Order_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Order_Tracking_Aggregate;
  /** An object relationship */
  tracking_status: Order_Tracking_Status;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user?: Maybe<User>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "order" */
export type OrderTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
};

/** input type for inserting array relation for remote table "order" */
export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  quote_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Order_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Order_Tracking_Aggregate_Bool_Exp>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey',
  /** unique or primary key constraint on columns "quote_id" */
  OrderQuoteIdKey = 'order_quote_id_key'
}

/** Connecting legal services entities with order information */
export type Order_Hub = {
  __typename?: 'order_hub';
  id: Scalars['uuid']['output'];
};

/** aggregated selection of "order_hub" */
export type Order_Hub_Aggregate = {
  __typename?: 'order_hub_aggregate';
  aggregate?: Maybe<Order_Hub_Aggregate_Fields>;
  nodes: Array<Order_Hub>;
};

/** aggregate fields of "order_hub" */
export type Order_Hub_Aggregate_Fields = {
  __typename?: 'order_hub_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Hub_Max_Fields>;
  min?: Maybe<Order_Hub_Min_Fields>;
};


/** aggregate fields of "order_hub" */
export type Order_Hub_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Hub_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "order_hub". All fields are combined with a logical 'AND'. */
export type Order_Hub_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Hub_Bool_Exp>>;
  _not?: InputMaybe<Order_Hub_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Hub_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_hub" */
export enum Order_Hub_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderHubPkey = 'order_hub_pkey'
}

/** input type for inserting data into table "order_hub" */
export type Order_Hub_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Order_Hub_Max_Fields = {
  __typename?: 'order_hub_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Order_Hub_Min_Fields = {
  __typename?: 'order_hub_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "order_hub" */
export type Order_Hub_Mutation_Response = {
  __typename?: 'order_hub_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Hub>;
};

/** on_conflict condition type for table "order_hub" */
export type Order_Hub_On_Conflict = {
  constraint: Order_Hub_Constraint;
  update_columns?: Array<Order_Hub_Update_Column>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};

/** Ordering options when selecting data from "order_hub". */
export type Order_Hub_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_hub */
export type Order_Hub_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_hub" */
export enum Order_Hub_Select_Column {
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "order_hub" */
export type Order_Hub_Set_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "order_hub" */
export type Order_Hub_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Hub_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Hub_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "order_hub" */
export enum Order_Hub_Update_Column {
  /** column name */
  Id = 'id'
}

export type Order_Hub_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Hub_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Hub_Bool_Exp;
};

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Order_Tracking_Arr_Rel_Insert_Input>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Order_Tracking_Aggregate_Order_By>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_tracking" */
export type Order_Tracking = {
  __typename?: 'order_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  order: Order;
  order_id: Scalars['uuid']['output'];
  /** An object relationship */
  tracking_status: Order_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "order_tracking" */
export type Order_Tracking_Aggregate = {
  __typename?: 'order_tracking_aggregate';
  aggregate?: Maybe<Order_Tracking_Aggregate_Fields>;
  nodes: Array<Order_Tracking>;
};

export type Order_Tracking_Aggregate_Bool_Exp = {
  count?: InputMaybe<Order_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Order_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Order_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_tracking" */
export type Order_Tracking_Aggregate_Fields = {
  __typename?: 'order_tracking_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Tracking_Max_Fields>;
  min?: Maybe<Order_Tracking_Min_Fields>;
};


/** aggregate fields of "order_tracking" */
export type Order_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "order_tracking" */
export type Order_Tracking_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Tracking_Max_Order_By>;
  min?: InputMaybe<Order_Tracking_Min_Order_By>;
};

/** input type for inserting array relation for remote table "order_tracking" */
export type Order_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Order_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Tracking_On_Conflict>;
};

/** Boolean expression to filter rows from the table "order_tracking". All fields are combined with a logical 'AND'. */
export type Order_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Order_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_tracking" */
export enum Order_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderTrackingPkey = 'order_tracking_pkey'
}

/** input type for inserting data into table "order_tracking" */
export type Order_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Order_Tracking_Max_Fields = {
  __typename?: 'order_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "order_tracking" */
export type Order_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Tracking_Min_Fields = {
  __typename?: 'order_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "order_tracking" */
export type Order_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_tracking" */
export type Order_Tracking_Mutation_Response = {
  __typename?: 'order_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Tracking>;
};

/** on_conflict condition type for table "order_tracking" */
export type Order_Tracking_On_Conflict = {
  constraint: Order_Tracking_Constraint;
  update_columns?: Array<Order_Tracking_Update_Column>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "order_tracking". */
export type Order_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_id?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Order_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_tracking */
export type Order_Tracking_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "order_tracking" */
export enum Order_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "order_tracking" */
export type Order_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "order_tracking_status" */
export type Order_Tracking_Status = {
  __typename?: 'order_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "order_tracking_status" */
export type Order_Tracking_Status_Aggregate = {
  __typename?: 'order_tracking_status_aggregate';
  aggregate?: Maybe<Order_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Order_Tracking_Status>;
};

/** aggregate fields of "order_tracking_status" */
export type Order_Tracking_Status_Aggregate_Fields = {
  __typename?: 'order_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Order_Tracking_Status_Max_Fields>;
  min?: Maybe<Order_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "order_tracking_status" */
export type Order_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "order_tracking_status". All fields are combined with a logical 'AND'. */
export type Order_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_tracking_status" */
export enum Order_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  OrderTrackingStatusPkey = 'order_tracking_status_pkey'
}

/** input type for inserting data into table "order_tracking_status" */
export type Order_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Order_Tracking_Status_Max_Fields = {
  __typename?: 'order_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Order_Tracking_Status_Min_Fields = {
  __typename?: 'order_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "order_tracking_status" */
export type Order_Tracking_Status_Mutation_Response = {
  __typename?: 'order_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Tracking_Status>;
};

/** input type for inserting object relation for remote table "order_tracking_status" */
export type Order_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Order_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "order_tracking_status" */
export type Order_Tracking_Status_On_Conflict = {
  constraint: Order_Tracking_Status_Constraint;
  update_columns?: Array<Order_Tracking_Status_Update_Column>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "order_tracking_status". */
export type Order_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_tracking_status */
export type Order_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "order_tracking_status" */
export enum Order_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "order_tracking_status" */
export type Order_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "order_tracking_status" */
export type Order_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "order_tracking_status" */
export enum Order_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Order_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Tracking_Status_Bool_Exp;
};

/** Streaming cursor of the table "order_tracking" */
export type Order_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "order_tracking" */
export enum Order_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  UserId = 'user_id'
}

export type Order_Tracking_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Tracking_Bool_Exp;
};

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Order_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

export type Paid_Orders_Summary_Last_30_Days = {
  __typename?: 'paid_orders_summary_last_30_days';
  assigned_admin?: Maybe<Scalars['jsonb']['output']>;
  date: Scalars['timestamptz']['output'];
  discount: Scalars['float8']['output'];
  email: Scalars['String']['output'];
  government_fees: Scalars['float8']['output'];
  id: Scalars['uuid']['output'];
  registration_request_type?: Maybe<Scalars['String']['output']>;
  registration_request_value?: Maybe<Scalars['String']['output']>;
  service_fees: Scalars['float8']['output'];
  service_name?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  total_vat_base: Scalars['float8']['output'];
  user_id: Scalars['uuid']['output'];
};


export type Paid_Orders_Summary_Last_30_DaysAssigned_AdminArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "paid_orders_summary_last_30_days". All fields are combined with a logical 'AND'. */
export type Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp>>;
  assigned_admin?: InputMaybe<Jsonb_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  discount?: InputMaybe<Float8_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  government_fees?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_request_type?: InputMaybe<String_Comparison_Exp>;
  registration_request_value?: InputMaybe<String_Comparison_Exp>;
  service_fees?: InputMaybe<Float8_Comparison_Exp>;
  service_name?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  total_vat_base?: InputMaybe<Float8_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

export enum Paid_Orders_Summary_Last_30_Days_Enum_Name {
  /** column name */
  AssignedAdmin = 'assigned_admin',
  /** column name */
  Date = 'date',
  /** column name */
  Discount = 'discount',
  /** column name */
  Email = 'email',
  /** column name */
  GovernmentFees = 'government_fees',
  /** column name */
  Id = 'id',
  /** column name */
  RegistrationRequestType = 'registration_request_type',
  /** column name */
  RegistrationRequestValue = 'registration_request_value',
  /** column name */
  ServiceFees = 'service_fees',
  /** column name */
  ServiceName = 'service_name',
  /** column name */
  Source = 'source',
  /** column name */
  TotalVatBase = 'total_vat_base',
  /** column name */
  UserId = 'user_id'
}

/** Ordering options when selecting data from "paid_orders_summary_last_30_days". */
export type Paid_Orders_Summary_Last_30_Days_Order_By = {
  assigned_admin?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  government_fees?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  registration_request_type?: InputMaybe<Order_By>;
  registration_request_value?: InputMaybe<Order_By>;
  service_fees?: InputMaybe<Order_By>;
  service_name?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  total_vat_base?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "poa" */
export type Poa = {
  __typename?: 'poa';
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int']['output'];
  expiration_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  jurisdictions?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  owner_entity: Entity;
  owner_entity_id: Scalars['uuid']['output'];
  status: Scalars['String']['output'];
  template_id: Scalars['String']['output'];
  /** An array relationship */
  trademark_shared_documents: Array<Trademark_Shared_Documents>;
  /** An aggregate relationship */
  trademark_shared_documents_aggregate: Trademark_Shared_Documents_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "poa" */
export type PoaJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "poa" */
export type PoaTrademark_Shared_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


/** columns and relationships of "poa" */
export type PoaTrademark_Shared_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};

/** aggregated selection of "poa" */
export type Poa_Aggregate = {
  __typename?: 'poa_aggregate';
  aggregate?: Maybe<Poa_Aggregate_Fields>;
  nodes: Array<Poa>;
};

/** aggregate fields of "poa" */
export type Poa_Aggregate_Fields = {
  __typename?: 'poa_aggregate_fields';
  avg?: Maybe<Poa_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Poa_Max_Fields>;
  min?: Maybe<Poa_Min_Fields>;
  stddev?: Maybe<Poa_Stddev_Fields>;
  stddev_pop?: Maybe<Poa_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Poa_Stddev_Samp_Fields>;
  sum?: Maybe<Poa_Sum_Fields>;
  var_pop?: Maybe<Poa_Var_Pop_Fields>;
  var_samp?: Maybe<Poa_Var_Samp_Fields>;
  variance?: Maybe<Poa_Variance_Fields>;
};


/** aggregate fields of "poa" */
export type Poa_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Poa_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Poa_Append_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Poa_Avg_Fields = {
  __typename?: 'poa_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "poa". All fields are combined with a logical 'AND'. */
export type Poa_Bool_Exp = {
  _and?: InputMaybe<Array<Poa_Bool_Exp>>;
  _not?: InputMaybe<Poa_Bool_Exp>;
  _or?: InputMaybe<Array<Poa_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  owner_entity?: InputMaybe<Entity_Bool_Exp>;
  owner_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  template_id?: InputMaybe<String_Comparison_Exp>;
  trademark_shared_documents?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
  trademark_shared_documents_aggregate?: InputMaybe<Trademark_Shared_Documents_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "poa" */
export enum Poa_Constraint {
  /** unique or primary key constraint on columns "id" */
  PoaPkey = 'poa_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Poa_Delete_At_Path_Input = {
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Poa_Delete_Elem_Input = {
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Poa_Delete_Key_Input = {
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "poa" */
export type Poa_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "poa" */
export type Poa_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  owner_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
  trademark_shared_documents?: InputMaybe<Trademark_Shared_Documents_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Poa_Max_Fields = {
  __typename?: 'poa_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  owner_entity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Poa_Min_Fields = {
  __typename?: 'poa_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  owner_entity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "poa" */
export type Poa_Mutation_Response = {
  __typename?: 'poa_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Poa>;
};

/** input type for inserting object relation for remote table "poa" */
export type Poa_Obj_Rel_Insert_Input = {
  data: Poa_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Poa_On_Conflict>;
};

/** on_conflict condition type for table "poa" */
export type Poa_On_Conflict = {
  constraint: Poa_Constraint;
  update_columns?: Array<Poa_Update_Column>;
  where?: InputMaybe<Poa_Bool_Exp>;
};

/** Ordering options when selecting data from "poa". */
export type Poa_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  owner_entity?: InputMaybe<Entity_Order_By>;
  owner_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  trademark_shared_documents_aggregate?: InputMaybe<Trademark_Shared_Documents_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: poa */
export type Poa_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Poa_Prepend_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "poa" */
export enum Poa_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  OwnerEntityId = 'owner_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "poa" */
export type Poa_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Poa_Stddev_Fields = {
  __typename?: 'poa_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Poa_Stddev_Pop_Fields = {
  __typename?: 'poa_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Poa_Stddev_Samp_Fields = {
  __typename?: 'poa_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "poa" */
export type Poa_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Poa_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Poa_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Poa_Sum_Fields = {
  __typename?: 'poa_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "poa" */
export enum Poa_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  OwnerEntityId = 'owner_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Poa_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Poa_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Poa_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Poa_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Poa_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Poa_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Poa_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Poa_Set_Input>;
  /** filter the rows which have to be updated */
  where: Poa_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Poa_Var_Pop_Fields = {
  __typename?: 'poa_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Poa_Var_Samp_Fields = {
  __typename?: 'poa_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Poa_Variance_Fields = {
  __typename?: 'poa_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "price" */
export type Price = {
  __typename?: 'price';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  partner_cost_eur?: Maybe<Scalars['float8']['output']>;
  price_aud: Scalars['float8']['output'];
  price_cad: Scalars['float8']['output'];
  price_chf: Scalars['float8']['output'];
  price_czk: Scalars['float8']['output'];
  price_eur: Scalars['float8']['output'];
  price_gbp: Scalars['float8']['output'];
  price_mxn: Scalars['float8']['output'];
  price_nzd: Scalars['float8']['output'];
  /** An object relationship */
  price_rule: Price_Rule;
  price_rule_id: Scalars['uuid']['output'];
  price_usd: Scalars['float8']['output'];
  price_zar: Scalars['float8']['output'];
};

/** aggregated selection of "price" */
export type Price_Aggregate = {
  __typename?: 'price_aggregate';
  aggregate?: Maybe<Price_Aggregate_Fields>;
  nodes: Array<Price>;
};

export type Price_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Price_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Price_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Price_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Price_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Price_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Price_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Price_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Price_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Price_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Price_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Price_Aggregate_Bool_Exp_Var_Samp>;
};

export type Price_Aggregate_Bool_Exp_Avg = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Bool_And = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Corr = {
  arguments: Price_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Price_Select_Column_Price_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Price_Select_Column_Price_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Price_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Price_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Price_Select_Column_Price_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Price_Select_Column_Price_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Price_Aggregate_Bool_Exp_Max = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Min = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Sum = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Price_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Price_Select_Column_Price_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "price" */
export type Price_Aggregate_Fields = {
  __typename?: 'price_aggregate_fields';
  avg?: Maybe<Price_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Price_Max_Fields>;
  min?: Maybe<Price_Min_Fields>;
  stddev?: Maybe<Price_Stddev_Fields>;
  stddev_pop?: Maybe<Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Price_Stddev_Samp_Fields>;
  sum?: Maybe<Price_Sum_Fields>;
  var_pop?: Maybe<Price_Var_Pop_Fields>;
  var_samp?: Maybe<Price_Var_Samp_Fields>;
  variance?: Maybe<Price_Variance_Fields>;
};


/** aggregate fields of "price" */
export type Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price" */
export type Price_Aggregate_Order_By = {
  avg?: InputMaybe<Price_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Price_Max_Order_By>;
  min?: InputMaybe<Price_Min_Order_By>;
  stddev?: InputMaybe<Price_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Price_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Price_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Price_Sum_Order_By>;
  var_pop?: InputMaybe<Price_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Price_Var_Samp_Order_By>;
  variance?: InputMaybe<Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "price" */
export type Price_Arr_Rel_Insert_Input = {
  data: Array<Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Price_On_Conflict>;
};

/** aggregate avg on columns */
export type Price_Avg_Fields = {
  __typename?: 'price_avg_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price" */
export type Price_Avg_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price". All fields are combined with a logical 'AND'. */
export type Price_Bool_Exp = {
  _and?: InputMaybe<Array<Price_Bool_Exp>>;
  _not?: InputMaybe<Price_Bool_Exp>;
  _or?: InputMaybe<Array<Price_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_cost_eur?: InputMaybe<Float8_Comparison_Exp>;
  price_aud?: InputMaybe<Float8_Comparison_Exp>;
  price_cad?: InputMaybe<Float8_Comparison_Exp>;
  price_chf?: InputMaybe<Float8_Comparison_Exp>;
  price_czk?: InputMaybe<Float8_Comparison_Exp>;
  price_eur?: InputMaybe<Float8_Comparison_Exp>;
  price_gbp?: InputMaybe<Float8_Comparison_Exp>;
  price_mxn?: InputMaybe<Float8_Comparison_Exp>;
  price_nzd?: InputMaybe<Float8_Comparison_Exp>;
  price_rule?: InputMaybe<Price_Rule_Bool_Exp>;
  price_rule_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_usd?: InputMaybe<Float8_Comparison_Exp>;
  price_zar?: InputMaybe<Float8_Comparison_Exp>;
};

/** unique or primary key constraints on table "price" */
export enum Price_Constraint {
  /** unique or primary key constraint on columns "price_rule_id" */
  PriceOneActivePerRule = 'price_one_active_per_rule',
  /** unique or primary key constraint on columns "id" */
  PricePkey = 'price_pkey'
}

/** input type for incrementing numeric columns in table "price" */
export type Price_Inc_Input = {
  partner_cost_eur?: InputMaybe<Scalars['float8']['input']>;
  price_aud?: InputMaybe<Scalars['float8']['input']>;
  price_cad?: InputMaybe<Scalars['float8']['input']>;
  price_chf?: InputMaybe<Scalars['float8']['input']>;
  price_czk?: InputMaybe<Scalars['float8']['input']>;
  price_eur?: InputMaybe<Scalars['float8']['input']>;
  price_gbp?: InputMaybe<Scalars['float8']['input']>;
  price_mxn?: InputMaybe<Scalars['float8']['input']>;
  price_nzd?: InputMaybe<Scalars['float8']['input']>;
  price_usd?: InputMaybe<Scalars['float8']['input']>;
  price_zar?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "price" */
export type Price_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  partner_cost_eur?: InputMaybe<Scalars['float8']['input']>;
  price_aud?: InputMaybe<Scalars['float8']['input']>;
  price_cad?: InputMaybe<Scalars['float8']['input']>;
  price_chf?: InputMaybe<Scalars['float8']['input']>;
  price_czk?: InputMaybe<Scalars['float8']['input']>;
  price_eur?: InputMaybe<Scalars['float8']['input']>;
  price_gbp?: InputMaybe<Scalars['float8']['input']>;
  price_mxn?: InputMaybe<Scalars['float8']['input']>;
  price_nzd?: InputMaybe<Scalars['float8']['input']>;
  price_rule?: InputMaybe<Price_Rule_Obj_Rel_Insert_Input>;
  price_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  price_usd?: InputMaybe<Scalars['float8']['input']>;
  price_zar?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate max on columns */
export type Price_Max_Fields = {
  __typename?: 'price_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  partner_cost_eur?: Maybe<Scalars['float8']['output']>;
  price_aud?: Maybe<Scalars['float8']['output']>;
  price_cad?: Maybe<Scalars['float8']['output']>;
  price_chf?: Maybe<Scalars['float8']['output']>;
  price_czk?: Maybe<Scalars['float8']['output']>;
  price_eur?: Maybe<Scalars['float8']['output']>;
  price_gbp?: Maybe<Scalars['float8']['output']>;
  price_mxn?: Maybe<Scalars['float8']['output']>;
  price_nzd?: Maybe<Scalars['float8']['output']>;
  price_rule_id?: Maybe<Scalars['uuid']['output']>;
  price_usd?: Maybe<Scalars['float8']['output']>;
  price_zar?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "price" */
export type Price_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_rule_id?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Price_Min_Fields = {
  __typename?: 'price_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  partner_cost_eur?: Maybe<Scalars['float8']['output']>;
  price_aud?: Maybe<Scalars['float8']['output']>;
  price_cad?: Maybe<Scalars['float8']['output']>;
  price_chf?: Maybe<Scalars['float8']['output']>;
  price_czk?: Maybe<Scalars['float8']['output']>;
  price_eur?: Maybe<Scalars['float8']['output']>;
  price_gbp?: Maybe<Scalars['float8']['output']>;
  price_mxn?: Maybe<Scalars['float8']['output']>;
  price_nzd?: Maybe<Scalars['float8']['output']>;
  price_rule_id?: Maybe<Scalars['uuid']['output']>;
  price_usd?: Maybe<Scalars['float8']['output']>;
  price_zar?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "price" */
export type Price_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_rule_id?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "price" */
export type Price_Mutation_Response = {
  __typename?: 'price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Price>;
};

/** on_conflict condition type for table "price" */
export type Price_On_Conflict = {
  constraint: Price_Constraint;
  update_columns?: Array<Price_Update_Column>;
  where?: InputMaybe<Price_Bool_Exp>;
};

/** Ordering options when selecting data from "price". */
export type Price_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_rule?: InputMaybe<Price_Rule_Order_By>;
  price_rule_id?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** primary key columns input for table: price */
export type Price_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "price_rule" */
export type Price_Rule = {
  __typename?: 'price_rule';
  config: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted: Scalars['Boolean']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  prices: Array<Price>;
  /** An aggregate relationship */
  prices_aggregate: Price_Aggregate;
  /** An object relationship */
  product_v2: Product_V2;
  product_v2_id: Scalars['uuid']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "price_rule" */
export type Price_RuleConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_rule" */
export type Price_RulePricesArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


/** columns and relationships of "price_rule" */
export type Price_RulePrices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};

/** aggregated selection of "price_rule" */
export type Price_Rule_Aggregate = {
  __typename?: 'price_rule_aggregate';
  aggregate?: Maybe<Price_Rule_Aggregate_Fields>;
  nodes: Array<Price_Rule>;
};

export type Price_Rule_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Price_Rule_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Price_Rule_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Price_Rule_Aggregate_Bool_Exp_Count>;
};

export type Price_Rule_Aggregate_Bool_Exp_Bool_And = {
  arguments: Price_Rule_Select_Column_Price_Rule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Rule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Rule_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Price_Rule_Select_Column_Price_Rule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Rule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Rule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Price_Rule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Price_Rule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "price_rule" */
export type Price_Rule_Aggregate_Fields = {
  __typename?: 'price_rule_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Price_Rule_Max_Fields>;
  min?: Maybe<Price_Rule_Min_Fields>;
};


/** aggregate fields of "price_rule" */
export type Price_Rule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Price_Rule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_rule" */
export type Price_Rule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Price_Rule_Max_Order_By>;
  min?: InputMaybe<Price_Rule_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Price_Rule_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "price_rule" */
export type Price_Rule_Arr_Rel_Insert_Input = {
  data: Array<Price_Rule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Price_Rule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "price_rule". All fields are combined with a logical 'AND'. */
export type Price_Rule_Bool_Exp = {
  _and?: InputMaybe<Array<Price_Rule_Bool_Exp>>;
  _not?: InputMaybe<Price_Rule_Bool_Exp>;
  _or?: InputMaybe<Array<Price_Rule_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  prices?: InputMaybe<Price_Bool_Exp>;
  prices_aggregate?: InputMaybe<Price_Aggregate_Bool_Exp>;
  product_v2?: InputMaybe<Product_V2_Bool_Exp>;
  product_v2_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "price_rule" */
export enum Price_Rule_Constraint {
  /** unique or primary key constraint on columns "id" */
  PriceRulePkey = 'price_rule_pkey',
  /** unique or primary key constraint on columns "product_v2_id", "name" */
  PriceRuleProductNameUnique = 'price_rule_product_name_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Price_Rule_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Price_Rule_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Price_Rule_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "price_rule" */
export type Price_Rule_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prices?: InputMaybe<Price_Arr_Rel_Insert_Input>;
  product_v2?: InputMaybe<Product_V2_Obj_Rel_Insert_Input>;
  product_v2_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Price_Rule_Max_Fields = {
  __typename?: 'price_rule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_v2_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "price_rule" */
export type Price_Rule_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_v2_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Price_Rule_Min_Fields = {
  __typename?: 'price_rule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_v2_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "price_rule" */
export type Price_Rule_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_v2_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "price_rule" */
export type Price_Rule_Mutation_Response = {
  __typename?: 'price_rule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Price_Rule>;
};

/** input type for inserting object relation for remote table "price_rule" */
export type Price_Rule_Obj_Rel_Insert_Input = {
  data: Price_Rule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Price_Rule_On_Conflict>;
};

/** on_conflict condition type for table "price_rule" */
export type Price_Rule_On_Conflict = {
  constraint: Price_Rule_Constraint;
  update_columns?: Array<Price_Rule_Update_Column>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};

/** Ordering options when selecting data from "price_rule". */
export type Price_Rule_Order_By = {
  config?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prices_aggregate?: InputMaybe<Price_Aggregate_Order_By>;
  product_v2?: InputMaybe<Product_V2_Order_By>;
  product_v2_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: price_rule */
export type Price_Rule_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Price_Rule_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "price_rule" */
export enum Price_Rule_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductV2Id = 'product_v2_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "price_rule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "price_rule" */
export enum Price_Rule_Select_Column_Price_Rule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** select "price_rule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "price_rule" */
export enum Price_Rule_Select_Column_Price_Rule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted'
}

/** input type for updating data in table "price_rule" */
export type Price_Rule_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_v2_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "price_rule" */
export type Price_Rule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Price_Rule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Price_Rule_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_v2_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "price_rule" */
export enum Price_Rule_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductV2Id = 'product_v2_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Price_Rule_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Price_Rule_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Price_Rule_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Price_Rule_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Price_Rule_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Price_Rule_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Price_Rule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Price_Rule_Bool_Exp;
};

/** select columns of table "price" */
export enum Price_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceRuleId = 'price_rule_id',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_avg_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_bool_and_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "price_aggregate_bool_exp_bool_or_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "price_aggregate_bool_exp_corr_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_max_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_min_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_sum_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** select "price_aggregate_bool_exp_var_samp_arguments_columns" columns of table "price" */
export enum Price_Select_Column_Price_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

/** input type for updating data in table "price" */
export type Price_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  partner_cost_eur?: InputMaybe<Scalars['float8']['input']>;
  price_aud?: InputMaybe<Scalars['float8']['input']>;
  price_cad?: InputMaybe<Scalars['float8']['input']>;
  price_chf?: InputMaybe<Scalars['float8']['input']>;
  price_czk?: InputMaybe<Scalars['float8']['input']>;
  price_eur?: InputMaybe<Scalars['float8']['input']>;
  price_gbp?: InputMaybe<Scalars['float8']['input']>;
  price_mxn?: InputMaybe<Scalars['float8']['input']>;
  price_nzd?: InputMaybe<Scalars['float8']['input']>;
  price_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  price_usd?: InputMaybe<Scalars['float8']['input']>;
  price_zar?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate stddev on columns */
export type Price_Stddev_Fields = {
  __typename?: 'price_stddev_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price" */
export type Price_Stddev_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Price_Stddev_Pop_Fields = {
  __typename?: 'price_stddev_pop_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price" */
export type Price_Stddev_Pop_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Price_Stddev_Samp_Fields = {
  __typename?: 'price_stddev_samp_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price" */
export type Price_Stddev_Samp_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "price" */
export type Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Price_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  partner_cost_eur?: InputMaybe<Scalars['float8']['input']>;
  price_aud?: InputMaybe<Scalars['float8']['input']>;
  price_cad?: InputMaybe<Scalars['float8']['input']>;
  price_chf?: InputMaybe<Scalars['float8']['input']>;
  price_czk?: InputMaybe<Scalars['float8']['input']>;
  price_eur?: InputMaybe<Scalars['float8']['input']>;
  price_gbp?: InputMaybe<Scalars['float8']['input']>;
  price_mxn?: InputMaybe<Scalars['float8']['input']>;
  price_nzd?: InputMaybe<Scalars['float8']['input']>;
  price_rule_id?: InputMaybe<Scalars['uuid']['input']>;
  price_usd?: InputMaybe<Scalars['float8']['input']>;
  price_zar?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Price_Sum_Fields = {
  __typename?: 'price_sum_fields';
  partner_cost_eur?: Maybe<Scalars['float8']['output']>;
  price_aud?: Maybe<Scalars['float8']['output']>;
  price_cad?: Maybe<Scalars['float8']['output']>;
  price_chf?: Maybe<Scalars['float8']['output']>;
  price_czk?: Maybe<Scalars['float8']['output']>;
  price_eur?: Maybe<Scalars['float8']['output']>;
  price_gbp?: Maybe<Scalars['float8']['output']>;
  price_mxn?: Maybe<Scalars['float8']['output']>;
  price_nzd?: Maybe<Scalars['float8']['output']>;
  price_usd?: Maybe<Scalars['float8']['output']>;
  price_zar?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "price" */
export type Price_Sum_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** update columns of table "price" */
export enum Price_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PartnerCostEur = 'partner_cost_eur',
  /** column name */
  PriceAud = 'price_aud',
  /** column name */
  PriceCad = 'price_cad',
  /** column name */
  PriceChf = 'price_chf',
  /** column name */
  PriceCzk = 'price_czk',
  /** column name */
  PriceEur = 'price_eur',
  /** column name */
  PriceGbp = 'price_gbp',
  /** column name */
  PriceMxn = 'price_mxn',
  /** column name */
  PriceNzd = 'price_nzd',
  /** column name */
  PriceRuleId = 'price_rule_id',
  /** column name */
  PriceUsd = 'price_usd',
  /** column name */
  PriceZar = 'price_zar'
}

export type Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Price_Set_Input>;
  /** filter the rows which have to be updated */
  where: Price_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Price_Var_Pop_Fields = {
  __typename?: 'price_var_pop_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price" */
export type Price_Var_Pop_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Price_Var_Samp_Fields = {
  __typename?: 'price_var_samp_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price" */
export type Price_Var_Samp_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Price_Variance_Fields = {
  __typename?: 'price_variance_fields';
  partner_cost_eur?: Maybe<Scalars['Float']['output']>;
  price_aud?: Maybe<Scalars['Float']['output']>;
  price_cad?: Maybe<Scalars['Float']['output']>;
  price_chf?: Maybe<Scalars['Float']['output']>;
  price_czk?: Maybe<Scalars['Float']['output']>;
  price_eur?: Maybe<Scalars['Float']['output']>;
  price_gbp?: Maybe<Scalars['Float']['output']>;
  price_mxn?: Maybe<Scalars['Float']['output']>;
  price_nzd?: Maybe<Scalars['Float']['output']>;
  price_usd?: Maybe<Scalars['Float']['output']>;
  price_zar?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price" */
export type Price_Variance_Order_By = {
  partner_cost_eur?: InputMaybe<Order_By>;
  price_aud?: InputMaybe<Order_By>;
  price_cad?: InputMaybe<Order_By>;
  price_chf?: InputMaybe<Order_By>;
  price_czk?: InputMaybe<Order_By>;
  price_eur?: InputMaybe<Order_By>;
  price_gbp?: InputMaybe<Order_By>;
  price_mxn?: InputMaybe<Order_By>;
  price_nzd?: InputMaybe<Order_By>;
  price_usd?: InputMaybe<Order_By>;
  price_zar?: InputMaybe<Order_By>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  affiliate?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  brand_subscription_payment?: Maybe<Brand_Subscription_Payment>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
};

/** aggregated selection of "product" */
export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  affiliate?: InputMaybe<String_Comparison_Exp>;
  brand_subscription_payment?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
};

/** columns and relationships of "product_bundle" */
export type Product_Bundle = {
  __typename?: 'product_bundle';
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  products: Array<Product_V2>;
  /** An aggregate relationship */
  products_aggregate: Product_V2_Aggregate;
};


/** columns and relationships of "product_bundle" */
export type Product_BundleProductsArgs = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


/** columns and relationships of "product_bundle" */
export type Product_BundleProducts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};

/** aggregated selection of "product_bundle" */
export type Product_Bundle_Aggregate = {
  __typename?: 'product_bundle_aggregate';
  aggregate?: Maybe<Product_Bundle_Aggregate_Fields>;
  nodes: Array<Product_Bundle>;
};

/** aggregate fields of "product_bundle" */
export type Product_Bundle_Aggregate_Fields = {
  __typename?: 'product_bundle_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Bundle_Max_Fields>;
  min?: Maybe<Product_Bundle_Min_Fields>;
};


/** aggregate fields of "product_bundle" */
export type Product_Bundle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Bundle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "product_bundle". All fields are combined with a logical 'AND'. */
export type Product_Bundle_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bundle_Bool_Exp>>;
  _not?: InputMaybe<Product_Bundle_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bundle_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Product_V2_Bool_Exp>;
  products_aggregate?: InputMaybe<Product_V2_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "product_bundle" */
export enum Product_Bundle_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductBundlePkey = 'product_bundle_pkey'
}

/** input type for inserting data into table "product_bundle" */
export type Product_Bundle_Insert_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Product_V2_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Bundle_Max_Fields = {
  __typename?: 'product_bundle_max_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Product_Bundle_Min_Fields = {
  __typename?: 'product_bundle_min_fields';
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "product_bundle" */
export type Product_Bundle_Mutation_Response = {
  __typename?: 'product_bundle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Bundle>;
};

/** input type for inserting object relation for remote table "product_bundle" */
export type Product_Bundle_Obj_Rel_Insert_Input = {
  data: Product_Bundle_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Bundle_On_Conflict>;
};

/** on_conflict condition type for table "product_bundle" */
export type Product_Bundle_On_Conflict = {
  constraint: Product_Bundle_Constraint;
  update_columns?: Array<Product_Bundle_Update_Column>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};

/** Ordering options when selecting data from "product_bundle". */
export type Product_Bundle_Order_By = {
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  products_aggregate?: InputMaybe<Product_V2_Aggregate_Order_By>;
};

/** primary key columns input for table: product_bundle */
export type Product_Bundle_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product_bundle" */
export enum Product_Bundle_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "product_bundle" */
export type Product_Bundle_Set_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "product_bundle" */
export type Product_Bundle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Bundle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Bundle_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "product_bundle" */
export enum Product_Bundle_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name'
}

export type Product_Bundle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Bundle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bundle_Bool_Exp;
};

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** columns and relationships of "product_event" */
export type Product_Event = {
  __typename?: 'product_event';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  product_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "product_event" */
export type Product_EventDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "product_event" */
export type Product_Event_Aggregate = {
  __typename?: 'product_event_aggregate';
  aggregate?: Maybe<Product_Event_Aggregate_Fields>;
  nodes: Array<Product_Event>;
};

export type Product_Event_Aggregate_Bool_Exp = {
  count?: InputMaybe<Product_Event_Aggregate_Bool_Exp_Count>;
};

export type Product_Event_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_Event_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_event" */
export type Product_Event_Aggregate_Fields = {
  __typename?: 'product_event_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Product_Event_Max_Fields>;
  min?: Maybe<Product_Event_Min_Fields>;
};


/** aggregate fields of "product_event" */
export type Product_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_event" */
export type Product_Event_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_Event_Max_Order_By>;
  min?: InputMaybe<Product_Event_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Product_Event_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "product_event" */
export type Product_Event_Arr_Rel_Insert_Input = {
  data: Array<Product_Event_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_Event_On_Conflict>;
};

/** Boolean expression to filter rows from the table "product_event". All fields are combined with a logical 'AND'. */
export type Product_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Event_Bool_Exp>>;
  _not?: InputMaybe<Product_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Event_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_event" */
export enum Product_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductEventPkey = 'product_event_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Product_Event_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Product_Event_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Product_Event_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "product_event" */
export type Product_Event_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Product_Event_Max_Fields = {
  __typename?: 'product_event_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "product_event" */
export type Product_Event_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_Event_Min_Fields = {
  __typename?: 'product_event_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "product_event" */
export type Product_Event_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_event" */
export type Product_Event_Mutation_Response = {
  __typename?: 'product_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_Event>;
};

/** on_conflict condition type for table "product_event" */
export type Product_Event_On_Conflict = {
  constraint: Product_Event_Constraint;
  update_columns?: Array<Product_Event_Update_Column>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "product_event". */
export type Product_Event_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_event */
export type Product_Event_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Product_Event_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "product_event" */
export enum Product_Event_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product_event" */
export type Product_Event_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "product_event" */
export type Product_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Event_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "product_event" */
export enum Product_Event_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_Event_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Product_Event_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Product_Event_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Product_Event_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Product_Event_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Product_Event_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Event_Bool_Exp;
};

/** input type for inserting data into table "product" */
export type Product_Insert_Input = {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  brand_subscription_payment?: InputMaybe<Brand_Subscription_Payment_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  affiliate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  affiliate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** input type for inserting object relation for remote table "product" */
export type Product_Obj_Rel_Insert_Input = {
  data: Product_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_On_Conflict>;
};

/** on_conflict condition type for table "product" */
export type Product_On_Conflict = {
  constraint: Product_Constraint;
  update_columns?: Array<Product_Update_Column>;
  where?: InputMaybe<Product_Bool_Exp>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  affiliate?: InputMaybe<Order_By>;
  brand_subscription_payment?: InputMaybe<Brand_Subscription_Payment_Order_By>;
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  service_request?: InputMaybe<Service_Request_Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  Affiliate = 'affiliate',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  affiliate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  Affiliate = 'affiliate',
  /** column name */
  Id = 'id'
}

export type Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** columns and relationships of "product_v2" */
export type Product_V2 = {
  __typename?: 'product_v2';
  bundle_sort_order?: Maybe<Scalars['Int']['output']>;
  category: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  deleted: Scalars['Boolean']['output'];
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  invoice_translation_key?: Maybe<Scalars['String']['output']>;
  is_gov_fee: Scalars['Boolean']['output'];
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parameters: Scalars['jsonb']['output'];
  /** An array relationship */
  price_rules: Array<Price_Rule>;
  /** An aggregate relationship */
  price_rules_aggregate: Price_Rule_Aggregate;
  /** An object relationship */
  product_bundle?: Maybe<Product_Bundle>;
  product_bundle_id?: Maybe<Scalars['uuid']['output']>;
  sku: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "product_v2" */
export type Product_V2ParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "product_v2" */
export type Product_V2Price_RulesArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


/** columns and relationships of "product_v2" */
export type Product_V2Price_Rules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};

/** aggregated selection of "product_v2" */
export type Product_V2_Aggregate = {
  __typename?: 'product_v2_aggregate';
  aggregate?: Maybe<Product_V2_Aggregate_Fields>;
  nodes: Array<Product_V2>;
};

export type Product_V2_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Product_V2_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Product_V2_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Product_V2_Aggregate_Bool_Exp_Count>;
};

export type Product_V2_Aggregate_Bool_Exp_Bool_And = {
  arguments: Product_V2_Select_Column_Product_V2_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_V2_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_V2_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Product_V2_Select_Column_Product_V2_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_V2_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Product_V2_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Product_V2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Product_V2_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "product_v2" */
export type Product_V2_Aggregate_Fields = {
  __typename?: 'product_v2_aggregate_fields';
  avg?: Maybe<Product_V2_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Product_V2_Max_Fields>;
  min?: Maybe<Product_V2_Min_Fields>;
  stddev?: Maybe<Product_V2_Stddev_Fields>;
  stddev_pop?: Maybe<Product_V2_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_V2_Stddev_Samp_Fields>;
  sum?: Maybe<Product_V2_Sum_Fields>;
  var_pop?: Maybe<Product_V2_Var_Pop_Fields>;
  var_samp?: Maybe<Product_V2_Var_Samp_Fields>;
  variance?: Maybe<Product_V2_Variance_Fields>;
};


/** aggregate fields of "product_v2" */
export type Product_V2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_V2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_v2" */
export type Product_V2_Aggregate_Order_By = {
  avg?: InputMaybe<Product_V2_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Product_V2_Max_Order_By>;
  min?: InputMaybe<Product_V2_Min_Order_By>;
  stddev?: InputMaybe<Product_V2_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Product_V2_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Product_V2_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Product_V2_Sum_Order_By>;
  var_pop?: InputMaybe<Product_V2_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Product_V2_Var_Samp_Order_By>;
  variance?: InputMaybe<Product_V2_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Product_V2_Append_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "product_v2" */
export type Product_V2_Arr_Rel_Insert_Input = {
  data: Array<Product_V2_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_V2_On_Conflict>;
};

/** aggregate avg on columns */
export type Product_V2_Avg_Fields = {
  __typename?: 'product_v2_avg_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "product_v2" */
export type Product_V2_Avg_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "product_v2". All fields are combined with a logical 'AND'. */
export type Product_V2_Bool_Exp = {
  _and?: InputMaybe<Array<Product_V2_Bool_Exp>>;
  _not?: InputMaybe<Product_V2_Bool_Exp>;
  _or?: InputMaybe<Array<Product_V2_Bool_Exp>>;
  bundle_sort_order?: InputMaybe<Int_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_translation_key?: InputMaybe<String_Comparison_Exp>;
  is_gov_fee?: InputMaybe<Boolean_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  price_rules?: InputMaybe<Price_Rule_Bool_Exp>;
  price_rules_aggregate?: InputMaybe<Price_Rule_Aggregate_Bool_Exp>;
  product_bundle?: InputMaybe<Product_Bundle_Bool_Exp>;
  product_bundle_id?: InputMaybe<Uuid_Comparison_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "product_v2" */
export enum Product_V2_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductV2Pkey = 'product_v2_pkey',
  /** unique or primary key constraint on columns "sku" */
  ProductV2SkuUnique = 'product_v2_sku_unique'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Product_V2_Delete_At_Path_Input = {
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Product_V2_Delete_Elem_Input = {
  parameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Product_V2_Delete_Key_Input = {
  parameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "product_v2" */
export type Product_V2_Inc_Input = {
  bundle_sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "product_v2" */
export type Product_V2_Insert_Input = {
  bundle_sort_order?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_translation_key?: InputMaybe<Scalars['String']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  price_rules?: InputMaybe<Price_Rule_Arr_Rel_Insert_Input>;
  product_bundle?: InputMaybe<Product_Bundle_Obj_Rel_Insert_Input>;
  product_bundle_id?: InputMaybe<Scalars['uuid']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Product_V2_Max_Fields = {
  __typename?: 'product_v2_max_fields';
  bundle_sort_order?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_translation_key?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_bundle_id?: Maybe<Scalars['uuid']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "product_v2" */
export type Product_V2_Max_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_translation_key?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_bundle_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Product_V2_Min_Fields = {
  __typename?: 'product_v2_min_fields';
  bundle_sort_order?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_translation_key?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_bundle_id?: Maybe<Scalars['uuid']['output']>;
  sku?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "product_v2" */
export type Product_V2_Min_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_translation_key?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_bundle_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "product_v2" */
export type Product_V2_Mutation_Response = {
  __typename?: 'product_v2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Product_V2>;
};

/** input type for inserting object relation for remote table "product_v2" */
export type Product_V2_Obj_Rel_Insert_Input = {
  data: Product_V2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Product_V2_On_Conflict>;
};

/** on_conflict condition type for table "product_v2" */
export type Product_V2_On_Conflict = {
  constraint: Product_V2_Constraint;
  update_columns?: Array<Product_V2_Update_Column>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};

/** Ordering options when selecting data from "product_v2". */
export type Product_V2_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_translation_key?: InputMaybe<Order_By>;
  is_gov_fee?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  price_rules_aggregate?: InputMaybe<Price_Rule_Aggregate_Order_By>;
  product_bundle?: InputMaybe<Product_Bundle_Order_By>;
  product_bundle_id?: InputMaybe<Order_By>;
  sku?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product_v2 */
export type Product_V2_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Product_V2_Prepend_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "product_v2" */
export enum Product_V2_Select_Column {
  /** column name */
  BundleSortOrder = 'bundle_sort_order',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTranslationKey = 'invoice_translation_key',
  /** column name */
  IsGovFee = 'is_gov_fee',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ProductBundleId = 'product_bundle_id',
  /** column name */
  Sku = 'sku',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "product_v2_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product_v2" */
export enum Product_V2_Select_Column_Product_V2_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsGovFee = 'is_gov_fee'
}

/** select "product_v2_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product_v2" */
export enum Product_V2_Select_Column_Product_V2_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deleted = 'deleted',
  /** column name */
  IsGovFee = 'is_gov_fee'
}

/** input type for updating data in table "product_v2" */
export type Product_V2_Set_Input = {
  bundle_sort_order?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_translation_key?: InputMaybe<Scalars['String']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  product_bundle_id?: InputMaybe<Scalars['uuid']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Product_V2_Stddev_Fields = {
  __typename?: 'product_v2_stddev_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "product_v2" */
export type Product_V2_Stddev_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Product_V2_Stddev_Pop_Fields = {
  __typename?: 'product_v2_stddev_pop_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "product_v2" */
export type Product_V2_Stddev_Pop_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Product_V2_Stddev_Samp_Fields = {
  __typename?: 'product_v2_stddev_samp_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "product_v2" */
export type Product_V2_Stddev_Samp_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "product_v2" */
export type Product_V2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_V2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_V2_Stream_Cursor_Value_Input = {
  bundle_sort_order?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_translation_key?: InputMaybe<Scalars['String']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  product_bundle_id?: InputMaybe<Scalars['uuid']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Product_V2_Sum_Fields = {
  __typename?: 'product_v2_sum_fields';
  bundle_sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "product_v2" */
export type Product_V2_Sum_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "product_v2" */
export enum Product_V2_Update_Column {
  /** column name */
  BundleSortOrder = 'bundle_sort_order',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceTranslationKey = 'invoice_translation_key',
  /** column name */
  IsGovFee = 'is_gov_fee',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ProductBundleId = 'product_bundle_id',
  /** column name */
  Sku = 'sku',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Product_V2_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Product_V2_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Product_V2_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Product_V2_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Product_V2_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Product_V2_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Product_V2_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_V2_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_V2_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_V2_Var_Pop_Fields = {
  __typename?: 'product_v2_var_pop_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "product_v2" */
export type Product_V2_Var_Pop_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Product_V2_Var_Samp_Fields = {
  __typename?: 'product_v2_var_samp_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "product_v2" */
export type Product_V2_Var_Samp_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Product_V2_Variance_Fields = {
  __typename?: 'product_v2_variance_fields';
  bundle_sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "product_v2" */
export type Product_V2_Variance_Order_By = {
  bundle_sort_order?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** An array relationship */
  ai_gs_items_analysis: Array<Ai_Gs_Items_Analysis>;
  /** An aggregate relationship */
  ai_gs_items_analysis_aggregate: Ai_Gs_Items_Analysis_Aggregate;
  /** fetch data from the table: "ai_gs_items_analysis" using primary key columns */
  ai_gs_items_analysis_by_pk?: Maybe<Ai_Gs_Items_Analysis>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** fetch data from the table: "application_jurisdiction" */
  application_jurisdiction: Array<Application_Jurisdiction>;
  /** fetch aggregated fields from the table: "application_jurisdiction" */
  application_jurisdiction_aggregate: Application_Jurisdiction_Aggregate;
  /** fetch data from the table: "application_jurisdiction" using primary key columns */
  application_jurisdiction_by_pk?: Maybe<Application_Jurisdiction>;
  /** fetch data from the table: "audit_log" */
  audit_log: Array<Audit_Log>;
  /** fetch aggregated fields from the table: "audit_log" */
  audit_log_aggregate: Audit_Log_Aggregate;
  /** fetch data from the table: "brand" */
  brand: Array<Brand>;
  /** fetch aggregated fields from the table: "brand" */
  brand_aggregate: Brand_Aggregate;
  /** fetch data from the table: "brand" using primary key columns */
  brand_by_pk?: Maybe<Brand>;
  /** fetch data from the table: "brand_monitoring_task" */
  brand_monitoring_task: Array<Brand_Monitoring_Task>;
  /** fetch aggregated fields from the table: "brand_monitoring_task" */
  brand_monitoring_task_aggregate: Brand_Monitoring_Task_Aggregate;
  /** fetch data from the table: "brand_monitoring_task" using primary key columns */
  brand_monitoring_task_by_pk?: Maybe<Brand_Monitoring_Task>;
  /** fetch data from the table: "brand_monitoring_task_tracking" */
  brand_monitoring_task_tracking: Array<Brand_Monitoring_Task_Tracking>;
  /** fetch aggregated fields from the table: "brand_monitoring_task_tracking" */
  brand_monitoring_task_tracking_aggregate: Brand_Monitoring_Task_Tracking_Aggregate;
  /** fetch data from the table: "brand_monitoring_task_tracking" using primary key columns */
  brand_monitoring_task_tracking_by_pk?: Maybe<Brand_Monitoring_Task_Tracking>;
  /** fetch data from the table: "brand_monitoring_task_tracking_status" */
  brand_monitoring_task_tracking_status: Array<Brand_Monitoring_Task_Tracking_Status>;
  /** fetch aggregated fields from the table: "brand_monitoring_task_tracking_status" */
  brand_monitoring_task_tracking_status_aggregate: Brand_Monitoring_Task_Tracking_Status_Aggregate;
  /** fetch data from the table: "brand_monitoring_task_tracking_status" using primary key columns */
  brand_monitoring_task_tracking_status_by_pk?: Maybe<Brand_Monitoring_Task_Tracking_Status>;
  /** fetch data from the table: "brand_snapshot" */
  brand_snapshot: Array<Brand_Snapshot>;
  /** fetch aggregated fields from the table: "brand_snapshot" */
  brand_snapshot_aggregate: Brand_Snapshot_Aggregate;
  /** fetch data from the table: "brand_snapshot" using primary key columns */
  brand_snapshot_by_pk?: Maybe<Brand_Snapshot>;
  /** fetch data from the table: "brand_subscription" */
  brand_subscription: Array<Brand_Subscription>;
  /** fetch aggregated fields from the table: "brand_subscription" */
  brand_subscription_aggregate: Brand_Subscription_Aggregate;
  /** fetch data from the table: "brand_subscription" using primary key columns */
  brand_subscription_by_pk?: Maybe<Brand_Subscription>;
  /** fetch data from the table: "brand_subscription_payment" */
  brand_subscription_payment: Array<Brand_Subscription_Payment>;
  /** fetch aggregated fields from the table: "brand_subscription_payment" */
  brand_subscription_payment_aggregate: Brand_Subscription_Payment_Aggregate;
  /** fetch data from the table: "brand_subscription_payment" using primary key columns */
  brand_subscription_payment_by_pk?: Maybe<Brand_Subscription_Payment>;
  /** fetch data from the table: "brand_subscription_platform" */
  brand_subscription_platform: Array<Brand_Subscription_Platform>;
  /** fetch aggregated fields from the table: "brand_subscription_platform" */
  brand_subscription_platform_aggregate: Brand_Subscription_Platform_Aggregate;
  /** fetch data from the table: "brand_subscription_platform" using primary key columns */
  brand_subscription_platform_by_pk?: Maybe<Brand_Subscription_Platform>;
  /** fetch data from the table: "brand_subscription_tracking" */
  brand_subscription_tracking: Array<Brand_Subscription_Tracking>;
  /** fetch aggregated fields from the table: "brand_subscription_tracking" */
  brand_subscription_tracking_aggregate: Brand_Subscription_Tracking_Aggregate;
  /** fetch data from the table: "brand_subscription_tracking" using primary key columns */
  brand_subscription_tracking_by_pk?: Maybe<Brand_Subscription_Tracking>;
  /** fetch data from the table: "brand_subscription_tracking_status" */
  brand_subscription_tracking_status: Array<Brand_Subscription_Tracking_Status>;
  /** fetch aggregated fields from the table: "brand_subscription_tracking_status" */
  brand_subscription_tracking_status_aggregate: Brand_Subscription_Tracking_Status_Aggregate;
  /** fetch data from the table: "brand_subscription_tracking_status" using primary key columns */
  brand_subscription_tracking_status_by_pk?: Maybe<Brand_Subscription_Tracking_Status>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table: "case_counterparty" */
  case_counterparty: Array<Case_Counterparty>;
  /** fetch aggregated fields from the table: "case_counterparty" */
  case_counterparty_aggregate: Case_Counterparty_Aggregate;
  /** fetch data from the table: "case_counterparty" using primary key columns */
  case_counterparty_by_pk?: Maybe<Case_Counterparty>;
  /** fetch data from the table: "case_infringement" */
  case_infringement: Array<Case_Infringement>;
  /** fetch aggregated fields from the table: "case_infringement" */
  case_infringement_aggregate: Case_Infringement_Aggregate;
  /** fetch data from the table: "case_infringement" using primary key columns */
  case_infringement_by_pk?: Maybe<Case_Infringement>;
  /** fetch data from the table: "case_infringement_evidence" */
  case_infringement_evidence: Array<Case_Infringement_Evidence>;
  /** fetch aggregated fields from the table: "case_infringement_evidence" */
  case_infringement_evidence_aggregate: Case_Infringement_Evidence_Aggregate;
  /** fetch data from the table: "case_infringement_evidence" using primary key columns */
  case_infringement_evidence_by_pk?: Maybe<Case_Infringement_Evidence>;
  /** fetch data from the table: "case_request" */
  case_request: Array<Case_Request>;
  /** fetch aggregated fields from the table: "case_request" */
  case_request_aggregate: Case_Request_Aggregate;
  /** fetch data from the table: "case_request" using primary key columns */
  case_request_by_pk?: Maybe<Case_Request>;
  /** fetch data from the table: "case_request_tracking" */
  case_request_tracking: Array<Case_Request_Tracking>;
  /** fetch aggregated fields from the table: "case_request_tracking" */
  case_request_tracking_aggregate: Case_Request_Tracking_Aggregate;
  /** fetch data from the table: "case_request_tracking" using primary key columns */
  case_request_tracking_by_pk?: Maybe<Case_Request_Tracking>;
  /** fetch data from the table: "case_request_tracking_status" */
  case_request_tracking_status: Array<Case_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "case_request_tracking_status" */
  case_request_tracking_status_aggregate: Case_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "case_request_tracking_status" using primary key columns */
  case_request_tracking_status_by_pk?: Maybe<Case_Request_Tracking_Status>;
  /** fetch data from the table: "case_solution" */
  case_solution: Array<Case_Solution>;
  /** fetch aggregated fields from the table: "case_solution" */
  case_solution_aggregate: Case_Solution_Aggregate;
  /** fetch data from the table: "case_solution" using primary key columns */
  case_solution_by_pk?: Maybe<Case_Solution>;
  /** fetch data from the table: "case_tracking" */
  case_tracking: Array<Case_Tracking>;
  /** fetch aggregated fields from the table: "case_tracking" */
  case_tracking_aggregate: Case_Tracking_Aggregate;
  /** fetch data from the table: "case_tracking" using primary key columns */
  case_tracking_by_pk?: Maybe<Case_Tracking>;
  /** fetch data from the table: "case_tracking_status" */
  case_tracking_status: Array<Case_Tracking_Status>;
  /** fetch aggregated fields from the table: "case_tracking_status" */
  case_tracking_status_aggregate: Case_Tracking_Status_Aggregate;
  /** fetch data from the table: "case_tracking_status" using primary key columns */
  case_tracking_status_by_pk?: Maybe<Case_Tracking_Status>;
  /** fetch data from the table: "consultation" */
  consultation: Array<Consultation>;
  /** fetch aggregated fields from the table: "consultation" */
  consultation_aggregate: Consultation_Aggregate;
  /** fetch data from the table: "consultation" using primary key columns */
  consultation_by_pk?: Maybe<Consultation>;
  /** fetch data from the table: "contentful" */
  contentful: Array<Contentful>;
  /** fetch aggregated fields from the table: "contentful" */
  contentful_aggregate: Contentful_Aggregate;
  /** fetch data from the table: "contentful" using primary key columns */
  contentful_by_pk?: Maybe<Contentful>;
  /** fetch data from the table: "credit_note" */
  credit_note: Array<Credit_Note>;
  /** fetch aggregated fields from the table: "credit_note" */
  credit_note_aggregate: Credit_Note_Aggregate;
  /** fetch data from the table: "credit_note" using primary key columns */
  credit_note_by_pk?: Maybe<Credit_Note>;
  /** fetch data from the table: "discount_coupon" */
  discount_coupon: Array<Discount_Coupon>;
  /** fetch aggregated fields from the table: "discount_coupon" */
  discount_coupon_aggregate: Discount_Coupon_Aggregate;
  /** fetch data from the table: "discount_coupon" using primary key columns */
  discount_coupon_by_pk?: Maybe<Discount_Coupon>;
  /** fetch data from the table: "docketed_message" */
  docketed_message: Array<Docketed_Message>;
  /** fetch aggregated fields from the table: "docketed_message" */
  docketed_message_aggregate: Docketed_Message_Aggregate;
  /** fetch data from the table: "docketed_message" using primary key columns */
  docketed_message_by_pk?: Maybe<Docketed_Message>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_folder" */
  document_folder: Array<Document_Folder>;
  /** fetch aggregated fields from the table: "document_folder" */
  document_folder_aggregate: Document_Folder_Aggregate;
  /** fetch data from the table: "document_folder" using primary key columns */
  document_folder_by_pk?: Maybe<Document_Folder>;
  /** fetch data from the table: "document_hub" */
  document_hub: Array<Document_Hub>;
  /** fetch aggregated fields from the table: "document_hub" */
  document_hub_aggregate: Document_Hub_Aggregate;
  /** fetch data from the table: "document_hub" using primary key columns */
  document_hub_by_pk?: Maybe<Document_Hub>;
  /** An array relationship */
  entity: Array<Entity>;
  /** An aggregate relationship */
  entity_aggregate: Entity_Aggregate;
  /** fetch data from the table: "entity" using primary key columns */
  entity_by_pk?: Maybe<Entity>;
  /** fetch data from the table: "exchange_rate" */
  exchange_rate: Array<Exchange_Rate>;
  /** fetch aggregated fields from the table: "exchange_rate" */
  exchange_rate_aggregate: Exchange_Rate_Aggregate;
  /** fetch data from the table: "exchange_rate" using primary key columns */
  exchange_rate_by_pk?: Maybe<Exchange_Rate>;
  /** fetch data from the table: "external_trademark" */
  external_trademark: Array<External_Trademark>;
  /** fetch aggregated fields from the table: "external_trademark" */
  external_trademark_aggregate: External_Trademark_Aggregate;
  /** fetch data from the table: "external_trademark" using primary key columns */
  external_trademark_by_pk?: Maybe<External_Trademark>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "note" */
  note: Array<Note>;
  /** fetch aggregated fields from the table: "note" */
  note_aggregate: Note_Aggregate;
  /** fetch data from the table: "note" using primary key columns */
  note_by_pk?: Maybe<Note>;
  /** fetch data from the table: "note_hub" */
  note_hub: Array<Note_Hub>;
  /** fetch aggregated fields from the table: "note_hub" */
  note_hub_aggregate: Note_Hub_Aggregate;
  /** fetch data from the table: "note_hub" using primary key columns */
  note_hub_by_pk?: Maybe<Note_Hub>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table: "office_action" */
  office_action: Array<Office_Action>;
  /** fetch aggregated fields from the table: "office_action" */
  office_action_aggregate: Office_Action_Aggregate;
  /** fetch data from the table: "office_action" using primary key columns */
  office_action_by_pk?: Maybe<Office_Action>;
  /** fetch data from the table: "office_action_issue" */
  office_action_issue: Array<Office_Action_Issue>;
  /** fetch aggregated fields from the table: "office_action_issue" */
  office_action_issue_aggregate: Office_Action_Issue_Aggregate;
  /** fetch data from the table: "office_action_issue" using primary key columns */
  office_action_issue_by_pk?: Maybe<Office_Action_Issue>;
  /** An array relationship */
  office_action_similar_trademark_map: Array<Office_Action_Similar_Trademark_Map>;
  /** An aggregate relationship */
  office_action_similar_trademark_map_aggregate: Office_Action_Similar_Trademark_Map_Aggregate;
  /** fetch data from the table: "office_action_similar_trademark_map" using primary key columns */
  office_action_similar_trademark_map_by_pk?: Maybe<Office_Action_Similar_Trademark_Map>;
  /** fetch data from the table: "office_action_solution" */
  office_action_solution: Array<Office_Action_Solution>;
  /** fetch aggregated fields from the table: "office_action_solution" */
  office_action_solution_aggregate: Office_Action_Solution_Aggregate;
  /** fetch data from the table: "office_action_solution" using primary key columns */
  office_action_solution_by_pk?: Maybe<Office_Action_Solution>;
  /** fetch data from the table: "office_action_tracking" */
  office_action_tracking: Array<Office_Action_Tracking>;
  /** fetch aggregated fields from the table: "office_action_tracking" */
  office_action_tracking_aggregate: Office_Action_Tracking_Aggregate;
  /** fetch data from the table: "office_action_tracking" using primary key columns */
  office_action_tracking_by_pk?: Maybe<Office_Action_Tracking>;
  /** fetch data from the table: "office_action_tracking_status" */
  office_action_tracking_status: Array<Office_Action_Tracking_Status>;
  /** fetch aggregated fields from the table: "office_action_tracking_status" */
  office_action_tracking_status_aggregate: Office_Action_Tracking_Status_Aggregate;
  /** fetch data from the table: "office_action_tracking_status" using primary key columns */
  office_action_tracking_status_by_pk?: Maybe<Office_Action_Tracking_Status>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_hub" */
  order_hub: Array<Order_Hub>;
  /** fetch aggregated fields from the table: "order_hub" */
  order_hub_aggregate: Order_Hub_Aggregate;
  /** fetch data from the table: "order_hub" using primary key columns */
  order_hub_by_pk?: Maybe<Order_Hub>;
  /** fetch data from the table: "order_tracking" */
  order_tracking: Array<Order_Tracking>;
  /** fetch aggregated fields from the table: "order_tracking" */
  order_tracking_aggregate: Order_Tracking_Aggregate;
  /** fetch data from the table: "order_tracking" using primary key columns */
  order_tracking_by_pk?: Maybe<Order_Tracking>;
  /** fetch data from the table: "order_tracking_status" */
  order_tracking_status: Array<Order_Tracking_Status>;
  /** fetch aggregated fields from the table: "order_tracking_status" */
  order_tracking_status_aggregate: Order_Tracking_Status_Aggregate;
  /** fetch data from the table: "order_tracking_status" using primary key columns */
  order_tracking_status_by_pk?: Maybe<Order_Tracking_Status>;
  paid_orders_summary_last_30_days: Array<Paid_Orders_Summary_Last_30_Days>;
  paid_orders_summary_last_30_days_count: Array<Aggregate_Count>;
  /** fetch data from the table: "poa" */
  poa: Array<Poa>;
  /** fetch aggregated fields from the table: "poa" */
  poa_aggregate: Poa_Aggregate;
  /** fetch data from the table: "poa" using primary key columns */
  poa_by_pk?: Maybe<Poa>;
  /** fetch data from the table: "price" */
  price: Array<Price>;
  /** fetch aggregated fields from the table: "price" */
  price_aggregate: Price_Aggregate;
  /** fetch data from the table: "price" using primary key columns */
  price_by_pk?: Maybe<Price>;
  /** fetch data from the table: "price_rule" */
  price_rule: Array<Price_Rule>;
  /** fetch aggregated fields from the table: "price_rule" */
  price_rule_aggregate: Price_Rule_Aggregate;
  /** fetch data from the table: "price_rule" using primary key columns */
  price_rule_by_pk?: Maybe<Price_Rule>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_bundle" */
  product_bundle: Array<Product_Bundle>;
  /** fetch aggregated fields from the table: "product_bundle" */
  product_bundle_aggregate: Product_Bundle_Aggregate;
  /** fetch data from the table: "product_bundle" using primary key columns */
  product_bundle_by_pk?: Maybe<Product_Bundle>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_event" */
  product_event: Array<Product_Event>;
  /** fetch aggregated fields from the table: "product_event" */
  product_event_aggregate: Product_Event_Aggregate;
  /** fetch data from the table: "product_event" using primary key columns */
  product_event_by_pk?: Maybe<Product_Event>;
  /** fetch data from the table: "product_v2" */
  product_v2: Array<Product_V2>;
  /** fetch aggregated fields from the table: "product_v2" */
  product_v2_aggregate: Product_V2_Aggregate;
  /** fetch data from the table: "product_v2" using primary key columns */
  product_v2_by_pk?: Maybe<Product_V2>;
  /** fetch data from the table: "quote" */
  quote: Array<Quote>;
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate;
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>;
  /** fetch data from the table: "quote_hub" */
  quote_hub: Array<Quote_Hub>;
  /** fetch aggregated fields from the table: "quote_hub" */
  quote_hub_aggregate: Quote_Hub_Aggregate;
  /** fetch data from the table: "quote_hub" using primary key columns */
  quote_hub_by_pk?: Maybe<Quote_Hub>;
  /** fetch data from the table: "quote_item" */
  quote_item: Array<Quote_Item>;
  /** fetch aggregated fields from the table: "quote_item" */
  quote_item_aggregate: Quote_Item_Aggregate;
  /** fetch data from the table: "quote_item" using primary key columns */
  quote_item_by_pk?: Maybe<Quote_Item>;
  recent_applications_sent_to_client: Array<Recent_Applications_Sent_To_Client>;
  /** fetch data from the table: "refund_request" */
  refund_request: Array<Refund_Request>;
  /** fetch aggregated fields from the table: "refund_request" */
  refund_request_aggregate: Refund_Request_Aggregate;
  /** fetch data from the table: "refund_request" using primary key columns */
  refund_request_by_pk?: Maybe<Refund_Request>;
  /** fetch data from the table: "refund_request_invoice" */
  refund_request_invoice: Array<Refund_Request_Invoice>;
  /** fetch aggregated fields from the table: "refund_request_invoice" */
  refund_request_invoice_aggregate: Refund_Request_Invoice_Aggregate;
  /** fetch data from the table: "refund_request_invoice" using primary key columns */
  refund_request_invoice_by_pk?: Maybe<Refund_Request_Invoice>;
  /** fetch data from the table: "refund_request_tracking" */
  refund_request_tracking: Array<Refund_Request_Tracking>;
  /** fetch aggregated fields from the table: "refund_request_tracking" */
  refund_request_tracking_aggregate: Refund_Request_Tracking_Aggregate;
  /** fetch data from the table: "refund_request_tracking" using primary key columns */
  refund_request_tracking_by_pk?: Maybe<Refund_Request_Tracking>;
  /** fetch data from the table: "refund_request_tracking_status" */
  refund_request_tracking_status: Array<Refund_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "refund_request_tracking_status" */
  refund_request_tracking_status_aggregate: Refund_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "refund_request_tracking_status" using primary key columns */
  refund_request_tracking_status_by_pk?: Maybe<Refund_Request_Tracking_Status>;
  /** fetch data from the table: "registration_request" */
  registration_request: Array<Registration_Request>;
  /** fetch aggregated fields from the table: "registration_request" */
  registration_request_aggregate: Registration_Request_Aggregate;
  /** fetch data from the table: "registration_request" using primary key columns */
  registration_request_by_pk?: Maybe<Registration_Request>;
  registration_request_recently_dismissed: Array<Registration_Request_Recently_Dismissed>;
  registration_request_recently_dismissed_count: Array<Aggregate_Count>;
  /** fetch data from the table: "registration_request_tracking" */
  registration_request_tracking: Array<Registration_Request_Tracking>;
  /** fetch aggregated fields from the table: "registration_request_tracking" */
  registration_request_tracking_aggregate: Registration_Request_Tracking_Aggregate;
  /** fetch data from the table: "registration_request_tracking" using primary key columns */
  registration_request_tracking_by_pk?: Maybe<Registration_Request_Tracking>;
  /** fetch data from the table: "registration_request_tracking_status" */
  registration_request_tracking_status: Array<Registration_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "registration_request_tracking_status" */
  registration_request_tracking_status_aggregate: Registration_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "registration_request_tracking_status" using primary key columns */
  registration_request_tracking_status_by_pk?: Maybe<Registration_Request_Tracking_Status>;
  /** fetch data from the table: "reminder" */
  reminder: Array<Reminder>;
  /** fetch aggregated fields from the table: "reminder" */
  reminder_aggregate: Reminder_Aggregate;
  /** fetch data from the table: "reminder" using primary key columns */
  reminder_by_pk?: Maybe<Reminder>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch aggregated fields from the table: "service" */
  service_aggregate: Service_Aggregate;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk?: Maybe<Service>;
  /** fetch data from the table: "service_request" */
  service_request: Array<Service_Request>;
  /** fetch aggregated fields from the table: "service_request" */
  service_request_aggregate: Service_Request_Aggregate;
  /** fetch data from the table: "service_request" using primary key columns */
  service_request_by_pk?: Maybe<Service_Request>;
  /** fetch data from the table: "service_request_tracking" */
  service_request_tracking: Array<Service_Request_Tracking>;
  /** fetch aggregated fields from the table: "service_request_tracking" */
  service_request_tracking_aggregate: Service_Request_Tracking_Aggregate;
  /** fetch data from the table: "service_request_tracking" using primary key columns */
  service_request_tracking_by_pk?: Maybe<Service_Request_Tracking>;
  /** fetch data from the table: "service_request_tracking_status" */
  service_request_tracking_status: Array<Service_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "service_request_tracking_status" */
  service_request_tracking_status_aggregate: Service_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "service_request_tracking_status" using primary key columns */
  service_request_tracking_status_by_pk?: Maybe<Service_Request_Tracking_Status>;
  /** fetch data from the table: "service_tracking" */
  service_tracking: Array<Service_Tracking>;
  /** fetch aggregated fields from the table: "service_tracking" */
  service_tracking_aggregate: Service_Tracking_Aggregate;
  /** fetch data from the table: "service_tracking" using primary key columns */
  service_tracking_by_pk?: Maybe<Service_Tracking>;
  /** fetch data from the table: "service_tracking_status" */
  service_tracking_status: Array<Service_Tracking_Status>;
  /** fetch aggregated fields from the table: "service_tracking_status" */
  service_tracking_status_aggregate: Service_Tracking_Status_Aggregate;
  /** fetch data from the table: "service_tracking_status" using primary key columns */
  service_tracking_status_by_pk?: Maybe<Service_Tracking_Status>;
  /** fetch data from the table: "similar_trademark" */
  similar_trademark: Array<Similar_Trademark>;
  /** fetch aggregated fields from the table: "similar_trademark" */
  similar_trademark_aggregate: Similar_Trademark_Aggregate;
  /** fetch data from the table: "similar_trademark" using primary key columns */
  similar_trademark_by_pk?: Maybe<Similar_Trademark>;
  /** fetch data from the table: "specimen" */
  specimen: Array<Specimen>;
  /** fetch aggregated fields from the table: "specimen" */
  specimen_aggregate: Specimen_Aggregate;
  /** fetch data from the table: "specimen" using primary key columns */
  specimen_by_pk?: Maybe<Specimen>;
  /** fetch data from the table: "statistic" */
  statistic: Array<Statistic>;
  /** fetch aggregated fields from the table: "statistic" */
  statistic_aggregate: Statistic_Aggregate;
  /** fetch data from the table: "statistic" using primary key columns */
  statistic_by_pk?: Maybe<Statistic>;
  /** fetch data from the table: "support_ticket" */
  support_ticket: Array<Support_Ticket>;
  /** fetch aggregated fields from the table: "support_ticket" */
  support_ticket_aggregate: Support_Ticket_Aggregate;
  /** fetch data from the table: "support_ticket" using primary key columns */
  support_ticket_by_pk?: Maybe<Support_Ticket>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** fetch data from the table: "thread_comment" */
  thread_comment: Array<Thread_Comment>;
  /** fetch aggregated fields from the table: "thread_comment" */
  thread_comment_aggregate: Thread_Comment_Aggregate;
  /** fetch data from the table: "thread_comment" using primary key columns */
  thread_comment_by_pk?: Maybe<Thread_Comment>;
  /** fetch data from the table: "trademark" */
  trademark: Array<Trademark>;
  /** fetch aggregated fields from the table: "trademark" */
  trademark_aggregate: Trademark_Aggregate;
  trademark_audit_log: Array<Trademark_Audit_Log>;
  trademark_audit_log_count: Array<Aggregate_Count>;
  /** fetch data from the table: "trademark" using primary key columns */
  trademark_by_pk?: Maybe<Trademark>;
  /** fetch data from the table: "trademark_class" */
  trademark_class: Array<Trademark_Class>;
  /** fetch aggregated fields from the table: "trademark_class" */
  trademark_class_aggregate: Trademark_Class_Aggregate;
  /** fetch data from the table: "trademark_class" using primary key columns */
  trademark_class_by_pk?: Maybe<Trademark_Class>;
  /** fetch data from the table: "trademark_ipo_data" */
  trademark_ipo_data: Array<Trademark_Ipo_Data>;
  /** fetch aggregated fields from the table: "trademark_ipo_data" */
  trademark_ipo_data_aggregate: Trademark_Ipo_Data_Aggregate;
  /** fetch data from the table: "trademark_ipo_data" using primary key columns */
  trademark_ipo_data_by_pk?: Maybe<Trademark_Ipo_Data>;
  /** An array relationship */
  trademark_monitoring_result: Array<Trademark_Monitoring_Result>;
  /** An aggregate relationship */
  trademark_monitoring_result_aggregate: Trademark_Monitoring_Result_Aggregate;
  /** fetch data from the table: "trademark_monitoring_result" using primary key columns */
  trademark_monitoring_result_by_pk?: Maybe<Trademark_Monitoring_Result>;
  trademark_portfolio_search: Array<Trademark_Portfolio_Search_Result>;
  trademark_portfolio_search_count: Array<Aggregate_Count>;
  /** fetch data from the table: "trademark_rate_limit_log" */
  trademark_rate_limit_log: Array<Trademark_Rate_Limit_Log>;
  /** fetch aggregated fields from the table: "trademark_rate_limit_log" */
  trademark_rate_limit_log_aggregate: Trademark_Rate_Limit_Log_Aggregate;
  /** fetch data from the table: "trademark_rate_limit_log" using primary key columns */
  trademark_rate_limit_log_by_pk?: Maybe<Trademark_Rate_Limit_Log>;
  /** fetch data from the table: "trademark_request" */
  trademark_request: Array<Trademark_Request>;
  /** fetch aggregated fields from the table: "trademark_request" */
  trademark_request_aggregate: Trademark_Request_Aggregate;
  /** fetch data from the table: "trademark_request" using primary key columns */
  trademark_request_by_pk?: Maybe<Trademark_Request>;
  trademark_search: Array<Trademark_Search_Result>;
  /** An array relationship */
  trademark_service_requests: Array<Trademark_Service_Requests>;
  /** An aggregate relationship */
  trademark_service_requests_aggregate: Trademark_Service_Requests_Aggregate;
  /** fetch data from the table: "trademark_service_requests" using primary key columns */
  trademark_service_requests_by_pk?: Maybe<Trademark_Service_Requests>;
  /** An array relationship */
  trademark_shared_documents: Array<Trademark_Shared_Documents>;
  /** An aggregate relationship */
  trademark_shared_documents_aggregate: Trademark_Shared_Documents_Aggregate;
  /** fetch data from the table: "trademark_shared_documents" using primary key columns */
  trademark_shared_documents_by_pk?: Maybe<Trademark_Shared_Documents>;
  /** fetch data from the table: "trademark_tracking" */
  trademark_tracking: Array<Trademark_Tracking>;
  /** fetch aggregated fields from the table: "trademark_tracking" */
  trademark_tracking_aggregate: Trademark_Tracking_Aggregate;
  /** fetch data from the table: "trademark_tracking" using primary key columns */
  trademark_tracking_by_pk?: Maybe<Trademark_Tracking>;
  /** fetch data from the table: "trademark_tracking_status" */
  trademark_tracking_status: Array<Trademark_Tracking_Status>;
  /** fetch aggregated fields from the table: "trademark_tracking_status" */
  trademark_tracking_status_aggregate: Trademark_Tracking_Status_Aggregate;
  /** fetch data from the table: "trademark_tracking_status" using primary key columns */
  trademark_tracking_status_by_pk?: Maybe<Trademark_Tracking_Status>;
  /** An array relationship */
  trademark_watch_subscription: Array<Trademark_Watch_Subscription>;
  /** An aggregate relationship */
  trademark_watch_subscription_aggregate: Trademark_Watch_Subscription_Aggregate;
  /** fetch data from the table: "trademark_watch_subscription" using primary key columns */
  trademark_watch_subscription_by_pk?: Maybe<Trademark_Watch_Subscription>;
  /** fetch data from the table: "use_in_commerce_request" */
  use_in_commerce_request: Array<Use_In_Commerce_Request>;
  /** fetch aggregated fields from the table: "use_in_commerce_request" */
  use_in_commerce_request_aggregate: Use_In_Commerce_Request_Aggregate;
  /** fetch data from the table: "use_in_commerce_request" using primary key columns */
  use_in_commerce_request_by_pk?: Maybe<Use_In_Commerce_Request>;
  /** fetch data from the table: "use_in_commerce_request_tracking" */
  use_in_commerce_request_tracking: Array<Use_In_Commerce_Request_Tracking>;
  /** fetch aggregated fields from the table: "use_in_commerce_request_tracking" */
  use_in_commerce_request_tracking_aggregate: Use_In_Commerce_Request_Tracking_Aggregate;
  /** fetch data from the table: "use_in_commerce_request_tracking" using primary key columns */
  use_in_commerce_request_tracking_by_pk?: Maybe<Use_In_Commerce_Request_Tracking>;
  /** fetch data from the table: "use_in_commerce_request_tracking_status" */
  use_in_commerce_request_tracking_status: Array<Use_In_Commerce_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "use_in_commerce_request_tracking_status" */
  use_in_commerce_request_tracking_status_aggregate: Use_In_Commerce_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "use_in_commerce_request_tracking_status" using primary key columns */
  use_in_commerce_request_tracking_status_by_pk?: Maybe<Use_In_Commerce_Request_Tracking_Status>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_auth_log" */
  user_auth_log: Array<User_Auth_Log>;
  /** fetch aggregated fields from the table: "user_auth_log" */
  user_auth_log_aggregate: User_Auth_Log_Aggregate;
  /** fetch data from the table: "user_auth_log" using primary key columns */
  user_auth_log_by_pk?: Maybe<User_Auth_Log>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_history" */
  user_history: Array<User_History>;
  /** fetch aggregated fields from the table: "user_history" */
  user_history_aggregate: User_History_Aggregate;
  /** fetch data from the table: "user_history" using primary key columns */
  user_history_by_pk?: Maybe<User_History>;
  /** fetch data from the table: "user_payment_method" */
  user_payment_method: Array<User_Payment_Method>;
  /** fetch aggregated fields from the table: "user_payment_method" */
  user_payment_method_aggregate: User_Payment_Method_Aggregate;
  /** fetch data from the table: "user_payment_method" using primary key columns */
  user_payment_method_by_pk?: Maybe<User_Payment_Method>;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table: "user_tracking" */
  user_tracking: Array<User_Tracking>;
  /** fetch aggregated fields from the table: "user_tracking" */
  user_tracking_aggregate: User_Tracking_Aggregate;
  /** fetch data from the table: "user_tracking" using primary key columns */
  user_tracking_by_pk?: Maybe<User_Tracking>;
  /** fetch data from the table: "user_tracking_status" */
  user_tracking_status: Array<User_Tracking_Status>;
  /** fetch aggregated fields from the table: "user_tracking_status" */
  user_tracking_status_aggregate: User_Tracking_Status_Aggregate;
  /** fetch data from the table: "user_tracking_status" using primary key columns */
  user_tracking_status_by_pk?: Maybe<User_Tracking_Status>;
  user_unseen_verification_count: Array<Aggregate_Count>;
  /** fetch data from the table: "verification_result" */
  verification_result: Array<Verification_Result>;
  /** fetch aggregated fields from the table: "verification_result" */
  verification_result_aggregate: Verification_Result_Aggregate;
  /** fetch data from the table: "verification_result" using primary key columns */
  verification_result_by_pk?: Maybe<Verification_Result>;
  /** An array relationship */
  verification_result_similar_trademark_map: Array<Verification_Result_Similar_Trademark_Map>;
  /** An aggregate relationship */
  verification_result_similar_trademark_map_aggregate: Verification_Result_Similar_Trademark_Map_Aggregate;
  /** fetch data from the table: "verification_result_similar_trademark_map" using primary key columns */
  verification_result_similar_trademark_map_by_pk?: Maybe<Verification_Result_Similar_Trademark_Map>;
  verification_search: Array<Verification_Search_Result>;
  /** fetch data from the table: "website" */
  website: Array<Website>;
  /** fetch aggregated fields from the table: "website" */
  website_aggregate: Website_Aggregate;
  /** fetch data from the table: "website" using primary key columns */
  website_by_pk?: Maybe<Website>;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootAi_Gs_Items_AnalysisArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


export type Query_RootAi_Gs_Items_Analysis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


export type Query_RootAi_Gs_Items_Analysis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Query_RootApplication_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApplication_JurisdictionArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


export type Query_RootApplication_Jurisdiction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


export type Query_RootApplication_Jurisdiction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAudit_LogArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Order_By>>;
  where?: InputMaybe<Audit_Log_Bool_Exp>;
};


export type Query_RootAudit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Order_By>>;
  where?: InputMaybe<Audit_Log_Bool_Exp>;
};


export type Query_RootBrandArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Query_RootBrand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Query_RootBrand_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_Monitoring_TaskArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_Monitoring_Task_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootBrand_Monitoring_Task_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};


export type Query_RootBrand_Monitoring_Task_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootBrand_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


export type Query_RootBrand_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


export type Query_RootBrand_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


export type Query_RootBrand_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


export type Query_RootBrand_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_Subscription_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_Subscription_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Platform_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBrand_Subscription_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootBrand_Subscription_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};


export type Query_RootBrand_Subscription_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Query_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Query_RootCase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_CounterpartyArgs = {
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By>>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};


export type Query_RootCase_Counterparty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By>>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};


export type Query_RootCase_Counterparty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_InfringementArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


export type Query_RootCase_Infringement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


export type Query_RootCase_Infringement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_Infringement_EvidenceArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


export type Query_RootCase_Infringement_Evidence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


export type Query_RootCase_Infringement_Evidence_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_RequestArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Order_By>>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};


export type Query_RootCase_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Order_By>>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};


export type Query_RootCase_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


export type Query_RootCase_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


export type Query_RootCase_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCase_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootCase_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootCase_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['case_request_status']['input'];
};


export type Query_RootCase_SolutionArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


export type Query_RootCase_Solution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


export type Query_RootCase_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCase_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


export type Query_RootCase_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


export type Query_RootCase_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCase_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};


export type Query_RootCase_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};


export type Query_RootCase_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootConsultationArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootConsultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Query_RootConsultation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootContentfulArgs = {
  distinct_on?: InputMaybe<Array<Contentful_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contentful_Order_By>>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};


export type Query_RootContentful_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contentful_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contentful_Order_By>>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};


export type Query_RootContentful_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Query_RootCredit_NoteArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Query_RootCredit_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Query_RootCredit_Note_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDiscount_CouponArgs = {
  distinct_on?: InputMaybe<Array<Discount_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Coupon_Order_By>>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};


export type Query_RootDiscount_Coupon_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Coupon_Order_By>>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};


export type Query_RootDiscount_Coupon_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootDocketed_MessageArgs = {
  distinct_on?: InputMaybe<Array<Docketed_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Docketed_Message_Order_By>>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};


export type Query_RootDocketed_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Docketed_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Docketed_Message_Order_By>>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};


export type Query_RootDocketed_Message_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootDocument_FolderArgs = {
  distinct_on?: InputMaybe<Array<Document_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Folder_Order_By>>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};


export type Query_RootDocument_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Folder_Order_By>>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};


export type Query_RootDocument_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocument_HubArgs = {
  distinct_on?: InputMaybe<Array<Document_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Hub_Order_By>>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};


export type Query_RootDocument_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Hub_Order_By>>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};


export type Query_RootDocument_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Query_RootEntity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Query_RootEntity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootExchange_RateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rate_Order_By>>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};


export type Query_RootExchange_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rate_Order_By>>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};


export type Query_RootExchange_Rate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExternal_TrademarkArgs = {
  distinct_on?: InputMaybe<Array<External_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Trademark_Order_By>>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};


export type Query_RootExternal_Trademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Trademark_Order_By>>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};


export type Query_RootExternal_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  variable_symbol: Scalars['String']['input'];
};


export type Query_RootNoteArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


export type Query_RootNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


export type Query_RootNote_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNote_HubArgs = {
  distinct_on?: InputMaybe<Array<Note_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Hub_Order_By>>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};


export type Query_RootNote_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Hub_Order_By>>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};


export type Query_RootNote_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Query_RootNotification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffice_ActionArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


export type Query_RootOffice_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


export type Query_RootOffice_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffice_Action_IssueArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


export type Query_RootOffice_Action_Issue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


export type Query_RootOffice_Action_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffice_Action_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


export type Query_RootOffice_Action_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


export type Query_RootOffice_Action_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOffice_Action_SolutionArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


export type Query_RootOffice_Action_Solution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


export type Query_RootOffice_Action_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffice_Action_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


export type Query_RootOffice_Action_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


export type Query_RootOffice_Action_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOffice_Action_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Status_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};


export type Query_RootOffice_Action_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Status_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};


export type Query_RootOffice_Action_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_HubArgs = {
  distinct_on?: InputMaybe<Array<Order_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Hub_Order_By>>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};


export type Query_RootOrder_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Hub_Order_By>>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};


export type Query_RootOrder_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


export type Query_RootOrder_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


export type Query_RootOrder_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrder_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Status_Order_By>>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};


export type Query_RootOrder_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Status_Order_By>>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};


export type Query_RootOrder_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootPaid_Orders_Summary_Last_30_DaysArgs = {
  distinct_on?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Order_By>>;
  where?: InputMaybe<Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp>;
};


export type Query_RootPaid_Orders_Summary_Last_30_Days_CountArgs = {
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootPoaArgs = {
  distinct_on?: InputMaybe<Array<Poa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poa_Order_By>>;
  where?: InputMaybe<Poa_Bool_Exp>;
};


export type Query_RootPoa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poa_Order_By>>;
  where?: InputMaybe<Poa_Bool_Exp>;
};


export type Query_RootPoa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPriceArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


export type Query_RootPrice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


export type Query_RootPrice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPrice_RuleArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


export type Query_RootPrice_Rule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


export type Query_RootPrice_Rule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_BundleArgs = {
  distinct_on?: InputMaybe<Array<Product_Bundle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Bundle_Order_By>>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};


export type Query_RootProduct_Bundle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Bundle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Bundle_Order_By>>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};


export type Query_RootProduct_Bundle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_EventArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


export type Query_RootProduct_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


export type Query_RootProduct_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProduct_V2Args = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


export type Query_RootProduct_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


export type Query_RootProduct_V2_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootQuote_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuote_HubArgs = {
  distinct_on?: InputMaybe<Array<Quote_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Hub_Order_By>>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};


export type Query_RootQuote_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Hub_Order_By>>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};


export type Query_RootQuote_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuote_ItemArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


export type Query_RootQuote_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


export type Query_RootQuote_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecent_Applications_Sent_To_ClientArgs = {
  args: Recent_Applications_Sent_To_Client_Arguments;
  distinct_on?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Order_By>>;
  where?: InputMaybe<Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp>;
};


export type Query_RootRefund_RequestArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Order_By>>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};


export type Query_RootRefund_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Order_By>>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};


export type Query_RootRefund_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRefund_Request_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


export type Query_RootRefund_Request_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


export type Query_RootRefund_Request_Invoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRefund_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


export type Query_RootRefund_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


export type Query_RootRefund_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRefund_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootRefund_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootRefund_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootRegistration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


export type Query_RootRegistration_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


export type Query_RootRegistration_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRegistration_Request_Recently_DismissedArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Order_By>>;
  where?: InputMaybe<Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp>;
};


export type Query_RootRegistration_Request_Recently_Dismissed_CountArgs = {
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootRegistration_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


export type Query_RootRegistration_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


export type Query_RootRegistration_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootRegistration_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootRegistration_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootRegistration_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootReminderArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reminder_Order_By>>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};


export type Query_RootReminder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reminder_Order_By>>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};


export type Query_RootReminder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Query_RootService_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Query_RootService_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootService_RequestArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


export type Query_RootService_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


export type Query_RootService_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootService_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


export type Query_RootService_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


export type Query_RootService_Request_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootService_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootService_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootService_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootService_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


export type Query_RootService_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


export type Query_RootService_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootService_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};


export type Query_RootService_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};


export type Query_RootService_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootSimilar_TrademarkArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


export type Query_RootSimilar_Trademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


export type Query_RootSimilar_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSpecimenArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


export type Query_RootSpecimen_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


export type Query_RootSpecimen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootStatisticArgs = {
  distinct_on?: InputMaybe<Array<Statistic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statistic_Order_By>>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};


export type Query_RootStatistic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Statistic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statistic_Order_By>>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};


export type Query_RootStatistic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootSupport_TicketArgs = {
  distinct_on?: InputMaybe<Array<Support_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Ticket_Order_By>>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};


export type Query_RootSupport_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Ticket_Order_By>>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};


export type Query_RootSupport_Ticket_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Query_RootTask_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootThread_CommentArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


export type Query_RootThread_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


export type Query_RootThread_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademarkArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


export type Query_RootTrademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


export type Query_RootTrademark_Audit_LogArgs = {
  args: Trademark_Audit_Log_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Audit_Log_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Audit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Audit_Log_Bool_Exp_Bool_Exp>;
};


export type Query_RootTrademark_Audit_Log_CountArgs = {
  args: Trademark_Audit_Log_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootTrademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_ClassArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


export type Query_RootTrademark_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


export type Query_RootTrademark_Class_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_Ipo_DataArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Ipo_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Ipo_Data_Order_By>>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};


export type Query_RootTrademark_Ipo_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Ipo_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Ipo_Data_Order_By>>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};


export type Query_RootTrademark_Ipo_Data_By_PkArgs = {
  jurisdiction: Scalars['String']['input'];
  number: Scalars['String']['input'];
};


export type Query_RootTrademark_Monitoring_ResultArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


export type Query_RootTrademark_Monitoring_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


export type Query_RootTrademark_Monitoring_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_Portfolio_SearchArgs = {
  args: Trademark_Portfolio_Search_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Order_By>>;
  where?: InputMaybe<Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Query_RootTrademark_Portfolio_Search_CountArgs = {
  args: Trademark_Portfolio_Search_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootTrademark_Rate_Limit_LogArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Rate_Limit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Rate_Limit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};


export type Query_RootTrademark_Rate_Limit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Rate_Limit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Rate_Limit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};


export type Query_RootTrademark_Rate_Limit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_RequestArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By>>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};


export type Query_RootTrademark_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By>>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};


export type Query_RootTrademark_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_SearchArgs = {
  args: Trademark_Search_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Search_Result_Order_By>>;
  where?: InputMaybe<Trademark_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Query_RootTrademark_Service_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


export type Query_RootTrademark_Service_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


export type Query_RootTrademark_Service_Requests_By_PkArgs = {
  service_request_id: Scalars['uuid']['input'];
  trademark_id: Scalars['uuid']['input'];
};


export type Query_RootTrademark_Shared_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


export type Query_RootTrademark_Shared_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


export type Query_RootTrademark_Shared_Documents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTrademark_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


export type Query_RootTrademark_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


export type Query_RootTrademark_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootTrademark_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Status_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};


export type Query_RootTrademark_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Status_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};


export type Query_RootTrademark_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootTrademark_Watch_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


export type Query_RootTrademark_Watch_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


export type Query_RootTrademark_Watch_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUse_In_Commerce_RequestArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUse_In_Commerce_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUse_In_Commerce_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};


export type Query_RootUse_In_Commerce_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_Auth_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Auth_Log_Order_By>>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};


export type Query_RootUser_Auth_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Auth_Log_Order_By>>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};


export type Query_RootUser_Auth_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_HistoryArgs = {
  distinct_on?: InputMaybe<Array<User_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_History_Order_By>>;
  where?: InputMaybe<User_History_Bool_Exp>;
};


export type Query_RootUser_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_History_Order_By>>;
  where?: InputMaybe<User_History_Bool_Exp>;
};


export type Query_RootUser_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By>>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};


export type Query_RootUser_Payment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By>>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};


export type Query_RootUser_Payment_Method_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_ProfileArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Query_RootUser_Profile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_TrackingArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


export type Query_RootUser_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


export type Query_RootUser_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Status_Order_By>>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};


export type Query_RootUser_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Status_Order_By>>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};


export type Query_RootUser_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootUser_Unseen_Verification_CountArgs = {
  args: User_Unseen_Verification_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Query_RootVerification_ResultArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


export type Query_RootVerification_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


export type Query_RootVerification_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVerification_Result_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


export type Query_RootVerification_Result_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


export type Query_RootVerification_Result_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVerification_SearchArgs = {
  args: Verification_Search_Arguments;
  distinct_on?: InputMaybe<Array<Verification_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Search_Result_Order_By>>;
  where?: InputMaybe<Verification_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Query_RootWebsiteArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};


export type Query_RootWebsite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};


export type Query_RootWebsite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "quote" */
export type Quote = {
  __typename?: 'quote';
  active: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency: Scalars['String']['output'];
  group_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  order?: Maybe<Order>;
  parameters?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  quote_items: Array<Quote_Item>;
  /** An aggregate relationship */
  quote_items_aggregate: Quote_Item_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user?: Maybe<User>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "quote" */
export type QuoteParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};

/** aggregated selection of "quote" */
export type Quote_Aggregate = {
  __typename?: 'quote_aggregate';
  aggregate?: Maybe<Quote_Aggregate_Fields>;
  nodes: Array<Quote>;
};

export type Quote_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quote_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quote_Aggregate_Bool_Exp_Count>;
};

export type Quote_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quote" */
export type Quote_Aggregate_Fields = {
  __typename?: 'quote_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Max_Fields>;
  min?: Maybe<Quote_Min_Fields>;
};


/** aggregate fields of "quote" */
export type Quote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quote" */
export type Quote_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Max_Order_By>;
  min?: InputMaybe<Quote_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quote_Append_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "quote" */
export type Quote_Arr_Rel_Insert_Input = {
  data: Array<Quote_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};

/** Boolean expression to filter rows from the table "quote". All fields are combined with a logical 'AND'. */
export type Quote_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Bool_Exp>>;
  _not?: InputMaybe<Quote_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  quote_items?: InputMaybe<Quote_Item_Bool_Exp>;
  quote_items_aggregate?: InputMaybe<Quote_Item_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote" */
export enum Quote_Constraint {
  /** unique or primary key constraint on columns "group_id" */
  QuoteActiveGroupUnique = 'quote_active_group_unique',
  /** unique or primary key constraint on columns "id" */
  QuotePkey = 'quote_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quote_Delete_At_Path_Input = {
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quote_Delete_Elem_Input = {
  parameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quote_Delete_Key_Input = {
  parameters?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "quote_hub" */
export type Quote_Hub = {
  __typename?: 'quote_hub';
  /** An object relationship */
  case_solution?: Maybe<Case_Solution>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  office_action_solution?: Maybe<Office_Action_Solution>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  /** An array relationship */
  quotes: Array<Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Quote_Aggregate;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
  type: Scalars['String']['output'];
  /** An object relationship */
  use_in_commerce_request?: Maybe<Use_In_Commerce_Request>;
};


/** columns and relationships of "quote_hub" */
export type Quote_HubOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "quote_hub" */
export type Quote_HubOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "quote_hub" */
export type Quote_HubQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "quote_hub" */
export type Quote_HubQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** aggregated selection of "quote_hub" */
export type Quote_Hub_Aggregate = {
  __typename?: 'quote_hub_aggregate';
  aggregate?: Maybe<Quote_Hub_Aggregate_Fields>;
  nodes: Array<Quote_Hub>;
};

/** aggregate fields of "quote_hub" */
export type Quote_Hub_Aggregate_Fields = {
  __typename?: 'quote_hub_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Hub_Max_Fields>;
  min?: Maybe<Quote_Hub_Min_Fields>;
};


/** aggregate fields of "quote_hub" */
export type Quote_Hub_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Hub_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "quote_hub". All fields are combined with a logical 'AND'. */
export type Quote_Hub_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Hub_Bool_Exp>>;
  _not?: InputMaybe<Quote_Hub_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Hub_Bool_Exp>>;
  case_solution?: InputMaybe<Case_Solution_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  office_action_solution?: InputMaybe<Office_Action_Solution_Bool_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  quotes?: InputMaybe<Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Bool_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "quote_hub" */
export enum Quote_Hub_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuoteHubPkey = 'quote_hub_pkey'
}

/** input type for inserting data into table "quote_hub" */
export type Quote_Hub_Insert_Input = {
  case_solution?: InputMaybe<Case_Solution_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  office_action_solution?: InputMaybe<Office_Action_Solution_Obj_Rel_Insert_Input>;
  orders?: InputMaybe<Order_Arr_Rel_Insert_Input>;
  quotes?: InputMaybe<Quote_Arr_Rel_Insert_Input>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Quote_Hub_Max_Fields = {
  __typename?: 'quote_hub_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Quote_Hub_Min_Fields = {
  __typename?: 'quote_hub_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "quote_hub" */
export type Quote_Hub_Mutation_Response = {
  __typename?: 'quote_hub_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Hub>;
};

/** input type for inserting object relation for remote table "quote_hub" */
export type Quote_Hub_Obj_Rel_Insert_Input = {
  data: Quote_Hub_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Hub_On_Conflict>;
};

/** on_conflict condition type for table "quote_hub" */
export type Quote_Hub_On_Conflict = {
  constraint: Quote_Hub_Constraint;
  update_columns?: Array<Quote_Hub_Update_Column>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_hub". */
export type Quote_Hub_Order_By = {
  case_solution?: InputMaybe<Case_Solution_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  office_action_solution?: InputMaybe<Office_Action_Solution_Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  service_request?: InputMaybe<Service_Request_Order_By>;
  type?: InputMaybe<Order_By>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Order_By>;
};

/** primary key columns input for table: quote_hub */
export type Quote_Hub_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "quote_hub" */
export enum Quote_Hub_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "quote_hub" */
export type Quote_Hub_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "quote_hub" */
export type Quote_Hub_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Hub_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Hub_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "quote_hub" */
export enum Quote_Hub_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Type = 'type'
}

export type Quote_Hub_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Hub_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Hub_Bool_Exp;
};

/** input type for inserting data into table "quote" */
export type Quote_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_items?: InputMaybe<Quote_Item_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "quote_item" */
export type Quote_Item = {
  __typename?: 'quote_item';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_gov_fee: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['jsonb']['output']>;
  price: Scalars['numeric']['output'];
  /** An object relationship */
  product?: Maybe<Product_V2>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  quantity: Scalars['Int']['output'];
  /** An object relationship */
  quote: Quote;
  quote_id: Scalars['uuid']['output'];
  sort_order: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "quote_item" */
export type Quote_ItemParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "quote_item" */
export type Quote_Item_Aggregate = {
  __typename?: 'quote_item_aggregate';
  aggregate?: Maybe<Quote_Item_Aggregate_Fields>;
  nodes: Array<Quote_Item>;
};

export type Quote_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quote_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quote_Item_Aggregate_Bool_Exp_Count>;
};

export type Quote_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Item_Select_Column_Quote_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Item_Select_Column_Quote_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Quote_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quote_item" */
export type Quote_Item_Aggregate_Fields = {
  __typename?: 'quote_item_aggregate_fields';
  avg?: Maybe<Quote_Item_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Quote_Item_Max_Fields>;
  min?: Maybe<Quote_Item_Min_Fields>;
  stddev?: Maybe<Quote_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Item_Sum_Fields>;
  var_pop?: Maybe<Quote_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Item_Var_Samp_Fields>;
  variance?: Maybe<Quote_Item_Variance_Fields>;
};


/** aggregate fields of "quote_item" */
export type Quote_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "quote_item" */
export type Quote_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Item_Max_Order_By>;
  min?: InputMaybe<Quote_Item_Min_Order_By>;
  stddev?: InputMaybe<Quote_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Item_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Quote_Item_Append_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "quote_item" */
export type Quote_Item_Arr_Rel_Insert_Input = {
  data: Array<Quote_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_Item_On_Conflict>;
};

/** aggregate avg on columns */
export type Quote_Item_Avg_Fields = {
  __typename?: 'quote_item_avg_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "quote_item" */
export type Quote_Item_Avg_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote_item". All fields are combined with a logical 'AND'. */
export type Quote_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Item_Bool_Exp>>;
  _not?: InputMaybe<Quote_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Item_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_gov_fee?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<Product_V2_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quote_id?: InputMaybe<Uuid_Comparison_Exp>;
  sort_order?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "quote_item" */
export enum Quote_Item_Constraint {
  /** unique or primary key constraint on columns "id" */
  QuoteItemPkey = 'quote_item_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Quote_Item_Delete_At_Path_Input = {
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Quote_Item_Delete_Elem_Input = {
  parameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Quote_Item_Delete_Key_Input = {
  parameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "quote_item" */
export type Quote_Item_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "quote_item" */
export type Quote_Item_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product?: InputMaybe<Product_V2_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote?: InputMaybe<Quote_Obj_Rel_Insert_Input>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Quote_Item_Max_Fields = {
  __typename?: 'quote_item_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "quote_item" */
export type Quote_Item_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Item_Min_Fields = {
  __typename?: 'quote_item_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['numeric']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quote_id?: Maybe<Scalars['uuid']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "quote_item" */
export type Quote_Item_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quote_item" */
export type Quote_Item_Mutation_Response = {
  __typename?: 'quote_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote_Item>;
};

/** on_conflict condition type for table "quote_item" */
export type Quote_Item_On_Conflict = {
  constraint: Quote_Item_Constraint;
  update_columns?: Array<Quote_Item_Update_Column>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};

/** Ordering options when selecting data from "quote_item". */
export type Quote_Item_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_gov_fee?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_V2_Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quote_id?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote_item */
export type Quote_Item_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quote_Item_Prepend_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quote_item" */
export enum Quote_Item_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsGovFee = 'is_gov_fee',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "quote_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote_item" */
export enum Quote_Item_Select_Column_Quote_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsGovFee = 'is_gov_fee'
}

/** select "quote_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote_item" */
export enum Quote_Item_Select_Column_Quote_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsGovFee = 'is_gov_fee'
}

/** input type for updating data in table "quote_item" */
export type Quote_Item_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Quote_Item_Stddev_Fields = {
  __typename?: 'quote_item_stddev_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "quote_item" */
export type Quote_Item_Stddev_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Item_Stddev_Pop_Fields = {
  __typename?: 'quote_item_stddev_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "quote_item" */
export type Quote_Item_Stddev_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Item_Stddev_Samp_Fields = {
  __typename?: 'quote_item_stddev_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "quote_item" */
export type Quote_Item_Stddev_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote_item" */
export type Quote_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Item_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_gov_fee?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  price?: InputMaybe<Scalars['numeric']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quote_id?: InputMaybe<Scalars['uuid']['input']>;
  sort_order?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Quote_Item_Sum_Fields = {
  __typename?: 'quote_item_sum_fields';
  price?: Maybe<Scalars['numeric']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "quote_item" */
export type Quote_Item_Sum_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** update columns of table "quote_item" */
export enum Quote_Item_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsGovFee = 'is_gov_fee',
  /** column name */
  Name = 'name',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  Price = 'price',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuoteId = 'quote_id',
  /** column name */
  SortOrder = 'sort_order',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Quote_Item_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quote_Item_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quote_Item_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quote_Item_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quote_Item_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Quote_Item_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quote_Item_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Item_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Item_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Quote_Item_Var_Pop_Fields = {
  __typename?: 'quote_item_var_pop_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "quote_item" */
export type Quote_Item_Var_Pop_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Item_Var_Samp_Fields = {
  __typename?: 'quote_item_var_samp_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "quote_item" */
export type Quote_Item_Var_Samp_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Item_Variance_Fields = {
  __typename?: 'quote_item_variance_fields';
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  sort_order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "quote_item" */
export type Quote_Item_Variance_Order_By = {
  price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sort_order?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Quote_Max_Fields = {
  __typename?: 'quote_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "quote" */
export type Quote_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Min_Fields = {
  __typename?: 'quote_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "quote" */
export type Quote_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "quote" */
export type Quote_Mutation_Response = {
  __typename?: 'quote_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Quote>;
};

/** input type for inserting object relation for remote table "quote" */
export type Quote_Obj_Rel_Insert_Input = {
  data: Quote_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Quote_On_Conflict>;
};

/** on_conflict condition type for table "quote" */
export type Quote_On_Conflict = {
  constraint: Quote_Constraint;
  update_columns?: Array<Quote_Update_Column>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** Ordering options when selecting data from "quote". */
export type Quote_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  parameters?: InputMaybe<Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_items_aggregate?: InputMaybe<Quote_Item_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: quote */
export type Quote_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Quote_Prepend_Input = {
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "quote" */
export enum Quote_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** select "quote_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** select "quote_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Active = 'active'
}

/** input type for updating data in table "quote" */
export type Quote_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "quote" */
export type Quote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "quote" */
export enum Quote_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Quote_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Quote_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Quote_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Quote_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Quote_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Quote_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Quote_Set_Input>;
  /** filter the rows which have to be updated */
  where: Quote_Bool_Exp;
};

export type Recent_Applications_Sent_To_Client = {
  __typename?: 'recent_applications_sent_to_client';
  domicile_address?: Maybe<Scalars['jsonb']['output']>;
  domicile_address_visible: Scalars['Boolean']['output'];
  first_sent_to_client_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  priority_filing_date?: Maybe<Scalars['date']['output']>;
  priority_filing_jurisdiction?: Maybe<Scalars['String']['output']>;
  priority_filing_number?: Maybe<Scalars['String']['output']>;
  priority_filing_visible?: Maybe<Scalars['Boolean']['output']>;
  registration_entity?: Maybe<Scalars['jsonb']['output']>;
  registration_request?: Maybe<Scalars['jsonb']['output']>;
};


export type Recent_Applications_Sent_To_ClientDomicile_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Recent_Applications_Sent_To_ClientRegistration_EntityArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Recent_Applications_Sent_To_ClientRegistration_RequestArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** recent_applications_sent_to_clientNative Query Arguments */
export type Recent_Applications_Sent_To_Client_Arguments = {
  registration_request_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** Boolean expression to filter rows from the logical model for "recent_applications_sent_to_client". All fields are combined with a logical 'AND'. */
export type Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp>>;
  domicile_address?: InputMaybe<Jsonb_Comparison_Exp>;
  domicile_address_visible?: InputMaybe<Boolean_Comparison_Exp>;
  first_sent_to_client_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  priority_filing_date?: InputMaybe<Date_Comparison_Exp>;
  priority_filing_jurisdiction?: InputMaybe<String_Comparison_Exp>;
  priority_filing_number?: InputMaybe<String_Comparison_Exp>;
  priority_filing_visible?: InputMaybe<Boolean_Comparison_Exp>;
  registration_entity?: InputMaybe<Jsonb_Comparison_Exp>;
  registration_request?: InputMaybe<Jsonb_Comparison_Exp>;
};

export enum Recent_Applications_Sent_To_Client_Enum_Name {
  /** column name */
  DomicileAddress = 'domicile_address',
  /** column name */
  DomicileAddressVisible = 'domicile_address_visible',
  /** column name */
  FirstSentToClientAt = 'first_sent_to_client_at',
  /** column name */
  Id = 'id',
  /** column name */
  PriorityFilingDate = 'priority_filing_date',
  /** column name */
  PriorityFilingJurisdiction = 'priority_filing_jurisdiction',
  /** column name */
  PriorityFilingNumber = 'priority_filing_number',
  /** column name */
  PriorityFilingVisible = 'priority_filing_visible',
  /** column name */
  RegistrationEntity = 'registration_entity',
  /** column name */
  RegistrationRequest = 'registration_request'
}

/** Ordering options when selecting data from "recent_applications_sent_to_client". */
export type Recent_Applications_Sent_To_Client_Order_By = {
  domicile_address?: InputMaybe<Order_By>;
  domicile_address_visible?: InputMaybe<Order_By>;
  first_sent_to_client_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priority_filing_date?: InputMaybe<Order_By>;
  priority_filing_jurisdiction?: InputMaybe<Order_By>;
  priority_filing_number?: InputMaybe<Order_By>;
  priority_filing_visible?: InputMaybe<Order_By>;
  registration_entity?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Order_By>;
};

/** columns and relationships of "refund_request" */
export type Refund_Request = {
  __typename?: 'refund_request';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user: User;
  created_by_user_id: Scalars['uuid']['output'];
  /** An array relationship */
  credit_notes: Array<Credit_Note>;
  /** An aggregate relationship */
  credit_notes_aggregate: Credit_Note_Aggregate;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  e2e_refund: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  issue: Scalars['String']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  missive_link?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  our_fault: Scalars['Boolean']['output'];
  proposed_solution: Scalars['String']['output'];
  reason_for_refund?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refund_request_invoices: Array<Refund_Request_Invoice>;
  /** An aggregate relationship */
  refund_request_invoices_aggregate: Refund_Request_Invoice_Aggregate;
  refunded_government_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_partner_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_service_fee?: Maybe<Scalars['numeric']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Refund_Request_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Refund_Request_Tracking_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user: User;
  updated_by_user_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "refund_request" */
export type Refund_RequestCredit_NotesArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestCredit_Notes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestRefund_Request_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestRefund_Request_Invoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "refund_request" */
export type Refund_RequestTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};

/** aggregated selection of "refund_request" */
export type Refund_Request_Aggregate = {
  __typename?: 'refund_request_aggregate';
  aggregate?: Maybe<Refund_Request_Aggregate_Fields>;
  nodes: Array<Refund_Request>;
};

/** aggregate fields of "refund_request" */
export type Refund_Request_Aggregate_Fields = {
  __typename?: 'refund_request_aggregate_fields';
  avg?: Maybe<Refund_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Refund_Request_Max_Fields>;
  min?: Maybe<Refund_Request_Min_Fields>;
  stddev?: Maybe<Refund_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Refund_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refund_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Refund_Request_Sum_Fields>;
  var_pop?: Maybe<Refund_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Refund_Request_Var_Samp_Fields>;
  variance?: Maybe<Refund_Request_Variance_Fields>;
};


/** aggregate fields of "refund_request" */
export type Refund_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refund_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Refund_Request_Avg_Fields = {
  __typename?: 'refund_request_avg_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "refund_request". All fields are combined with a logical 'AND'. */
export type Refund_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Refund_Request_Bool_Exp>>;
  _not?: InputMaybe<Refund_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Refund_Request_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  credit_notes?: InputMaybe<Credit_Note_Bool_Exp>;
  credit_notes_aggregate?: InputMaybe<Credit_Note_Aggregate_Bool_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  e2e_refund?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  issue?: InputMaybe<String_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  missive_link?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  our_fault?: InputMaybe<Boolean_Comparison_Exp>;
  proposed_solution?: InputMaybe<String_Comparison_Exp>;
  reason_for_refund?: InputMaybe<String_Comparison_Exp>;
  refund_request_invoices?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
  refund_request_invoices_aggregate?: InputMaybe<Refund_Request_Invoice_Aggregate_Bool_Exp>;
  refunded_government_fee?: InputMaybe<Numeric_Comparison_Exp>;
  refunded_partner_fee?: InputMaybe<Numeric_Comparison_Exp>;
  refunded_service_fee?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Refund_Request_Tracking_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_request" */
export enum Refund_Request_Constraint {
  /** unique or primary key constraint on columns "note_hub_id" */
  RefundRequestNoteHubIdKey = 'refund_request_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  RefundRequestPkey = 'refund_request_pkey'
}

/** input type for incrementing numeric columns in table "refund_request" */
export type Refund_Request_Inc_Input = {
  refunded_government_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_partner_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_service_fee?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "refund_request" */
export type Refund_Request_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  credit_notes?: InputMaybe<Credit_Note_Arr_Rel_Insert_Input>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  e2e_refund?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  our_fault?: InputMaybe<Scalars['Boolean']['input']>;
  proposed_solution?: InputMaybe<Scalars['String']['input']>;
  reason_for_refund?: InputMaybe<Scalars['String']['input']>;
  refund_request_invoices?: InputMaybe<Refund_Request_Invoice_Arr_Rel_Insert_Input>;
  refunded_government_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_partner_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_service_fee?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Refund_Request_Tracking_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "refund_request_invoice" */
export type Refund_Request_Invoice = {
  __typename?: 'refund_request_invoice';
  id: Scalars['Int']['output'];
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_id: Scalars['uuid']['output'];
  /** An object relationship */
  refund_request?: Maybe<Refund_Request>;
  refund_request_id: Scalars['uuid']['output'];
};

/** aggregated selection of "refund_request_invoice" */
export type Refund_Request_Invoice_Aggregate = {
  __typename?: 'refund_request_invoice_aggregate';
  aggregate?: Maybe<Refund_Request_Invoice_Aggregate_Fields>;
  nodes: Array<Refund_Request_Invoice>;
};

export type Refund_Request_Invoice_Aggregate_Bool_Exp = {
  count?: InputMaybe<Refund_Request_Invoice_Aggregate_Bool_Exp_Count>;
};

export type Refund_Request_Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "refund_request_invoice" */
export type Refund_Request_Invoice_Aggregate_Fields = {
  __typename?: 'refund_request_invoice_aggregate_fields';
  avg?: Maybe<Refund_Request_Invoice_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Refund_Request_Invoice_Max_Fields>;
  min?: Maybe<Refund_Request_Invoice_Min_Fields>;
  stddev?: Maybe<Refund_Request_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Refund_Request_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refund_Request_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Refund_Request_Invoice_Sum_Fields>;
  var_pop?: Maybe<Refund_Request_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Refund_Request_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Refund_Request_Invoice_Variance_Fields>;
};


/** aggregate fields of "refund_request_invoice" */
export type Refund_Request_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "refund_request_invoice" */
export type Refund_Request_Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Refund_Request_Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refund_Request_Invoice_Max_Order_By>;
  min?: InputMaybe<Refund_Request_Invoice_Min_Order_By>;
  stddev?: InputMaybe<Refund_Request_Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Refund_Request_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Refund_Request_Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Refund_Request_Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Refund_Request_Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Refund_Request_Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Refund_Request_Invoice_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "refund_request_invoice" */
export type Refund_Request_Invoice_Arr_Rel_Insert_Input = {
  data: Array<Refund_Request_Invoice_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refund_Request_Invoice_On_Conflict>;
};

/** aggregate avg on columns */
export type Refund_Request_Invoice_Avg_Fields = {
  __typename?: 'refund_request_invoice_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "refund_request_invoice". All fields are combined with a logical 'AND'. */
export type Refund_Request_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Refund_Request_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Refund_Request_Invoice_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_id?: InputMaybe<Uuid_Comparison_Exp>;
  refund_request?: InputMaybe<Refund_Request_Bool_Exp>;
  refund_request_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_request_invoice" */
export enum Refund_Request_Invoice_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefundRequestInvoicePkey = 'refund_request_invoice_pkey',
  /** unique or primary key constraint on columns "invoice_id", "refund_request_id" */
  RefundRequestInvoiceRefundRequestIdInvoiceIdKey = 'refund_request_invoice_refund_request_id_invoice_id_key'
}

/** input type for incrementing numeric columns in table "refund_request_invoice" */
export type Refund_Request_Invoice_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "refund_request_invoice" */
export type Refund_Request_Invoice_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  refund_request?: InputMaybe<Refund_Request_Obj_Rel_Insert_Input>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Refund_Request_Invoice_Max_Fields = {
  __typename?: 'refund_request_invoice_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refund_Request_Invoice_Min_Fields = {
  __typename?: 'refund_request_invoice_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
  invoice_id?: Maybe<Scalars['uuid']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refund_request_invoice" */
export type Refund_Request_Invoice_Mutation_Response = {
  __typename?: 'refund_request_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refund_Request_Invoice>;
};

/** on_conflict condition type for table "refund_request_invoice" */
export type Refund_Request_Invoice_On_Conflict = {
  constraint: Refund_Request_Invoice_Constraint;
  update_columns?: Array<Refund_Request_Invoice_Update_Column>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "refund_request_invoice". */
export type Refund_Request_Invoice_Order_By = {
  id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  refund_request?: InputMaybe<Refund_Request_Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refund_request_invoice */
export type Refund_Request_Invoice_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "refund_request_invoice" */
export enum Refund_Request_Invoice_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  RefundRequestId = 'refund_request_id'
}

/** input type for updating data in table "refund_request_invoice" */
export type Refund_Request_Invoice_Set_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Refund_Request_Invoice_Stddev_Fields = {
  __typename?: 'refund_request_invoice_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Refund_Request_Invoice_Stddev_Pop_Fields = {
  __typename?: 'refund_request_invoice_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Refund_Request_Invoice_Stddev_Samp_Fields = {
  __typename?: 'refund_request_invoice_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "refund_request_invoice" */
export type Refund_Request_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refund_Request_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refund_Request_Invoice_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  invoice_id?: InputMaybe<Scalars['uuid']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Refund_Request_Invoice_Sum_Fields = {
  __typename?: 'refund_request_invoice_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "refund_request_invoice" */
export enum Refund_Request_Invoice_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  RefundRequestId = 'refund_request_id'
}

export type Refund_Request_Invoice_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refund_Request_Invoice_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refund_Request_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refund_Request_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Refund_Request_Invoice_Var_Pop_Fields = {
  __typename?: 'refund_request_invoice_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Refund_Request_Invoice_Var_Samp_Fields = {
  __typename?: 'refund_request_invoice_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Refund_Request_Invoice_Variance_Fields = {
  __typename?: 'refund_request_invoice_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "refund_request_invoice" */
export type Refund_Request_Invoice_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Refund_Request_Max_Fields = {
  __typename?: 'refund_request_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  proposed_solution?: Maybe<Scalars['String']['output']>;
  reason_for_refund?: Maybe<Scalars['String']['output']>;
  refunded_government_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_partner_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_service_fee?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Refund_Request_Min_Fields = {
  __typename?: 'refund_request_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  proposed_solution?: Maybe<Scalars['String']['output']>;
  reason_for_refund?: Maybe<Scalars['String']['output']>;
  refunded_government_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_partner_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_service_fee?: Maybe<Scalars['numeric']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "refund_request" */
export type Refund_Request_Mutation_Response = {
  __typename?: 'refund_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refund_Request>;
};

/** input type for inserting object relation for remote table "refund_request" */
export type Refund_Request_Obj_Rel_Insert_Input = {
  data: Refund_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Refund_Request_On_Conflict>;
};

/** on_conflict condition type for table "refund_request" */
export type Refund_Request_On_Conflict = {
  constraint: Refund_Request_Constraint;
  update_columns?: Array<Refund_Request_Update_Column>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "refund_request". */
export type Refund_Request_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  credit_notes_aggregate?: InputMaybe<Credit_Note_Aggregate_Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  e2e_refund?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  missive_link?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  our_fault?: InputMaybe<Order_By>;
  proposed_solution?: InputMaybe<Order_By>;
  reason_for_refund?: InputMaybe<Order_By>;
  refund_request_invoices_aggregate?: InputMaybe<Refund_Request_Invoice_Aggregate_Order_By>;
  refunded_government_fee?: InputMaybe<Order_By>;
  refunded_partner_fee?: InputMaybe<Order_By>;
  refunded_service_fee?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Refund_Request_Tracking_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refund_request */
export type Refund_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "refund_request" */
export enum Refund_Request_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  E2eRefund = 'e2e_refund',
  /** column name */
  Id = 'id',
  /** column name */
  Issue = 'issue',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  MissiveLink = 'missive_link',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OurFault = 'our_fault',
  /** column name */
  ProposedSolution = 'proposed_solution',
  /** column name */
  ReasonForRefund = 'reason_for_refund',
  /** column name */
  RefundedGovernmentFee = 'refunded_government_fee',
  /** column name */
  RefundedPartnerFee = 'refunded_partner_fee',
  /** column name */
  RefundedServiceFee = 'refunded_service_fee',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "refund_request" */
export type Refund_Request_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  e2e_refund?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  our_fault?: InputMaybe<Scalars['Boolean']['input']>;
  proposed_solution?: InputMaybe<Scalars['String']['input']>;
  reason_for_refund?: InputMaybe<Scalars['String']['input']>;
  refunded_government_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_partner_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_service_fee?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Refund_Request_Stddev_Fields = {
  __typename?: 'refund_request_stddev_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Refund_Request_Stddev_Pop_Fields = {
  __typename?: 'refund_request_stddev_pop_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Refund_Request_Stddev_Samp_Fields = {
  __typename?: 'refund_request_stddev_samp_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "refund_request" */
export type Refund_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refund_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refund_Request_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  e2e_refund?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  our_fault?: InputMaybe<Scalars['Boolean']['input']>;
  proposed_solution?: InputMaybe<Scalars['String']['input']>;
  reason_for_refund?: InputMaybe<Scalars['String']['input']>;
  refunded_government_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_partner_fee?: InputMaybe<Scalars['numeric']['input']>;
  refunded_service_fee?: InputMaybe<Scalars['numeric']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Refund_Request_Sum_Fields = {
  __typename?: 'refund_request_sum_fields';
  refunded_government_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_partner_fee?: Maybe<Scalars['numeric']['output']>;
  refunded_service_fee?: Maybe<Scalars['numeric']['output']>;
};

/** columns and relationships of "refund_request_tracking" */
export type Refund_Request_Tracking = {
  __typename?: 'refund_request_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  refund_request_id: Scalars['uuid']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Refund_Request_Tracking_Status;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "refund_request_tracking" */
export type Refund_Request_Tracking_Aggregate = {
  __typename?: 'refund_request_tracking_aggregate';
  aggregate?: Maybe<Refund_Request_Tracking_Aggregate_Fields>;
  nodes: Array<Refund_Request_Tracking>;
};

export type Refund_Request_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Refund_Request_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Refund_Request_Tracking_Select_Column_Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Refund_Request_Tracking_Select_Column_Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Refund_Request_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "refund_request_tracking" */
export type Refund_Request_Tracking_Aggregate_Fields = {
  __typename?: 'refund_request_tracking_aggregate_fields';
  avg?: Maybe<Refund_Request_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Refund_Request_Tracking_Max_Fields>;
  min?: Maybe<Refund_Request_Tracking_Min_Fields>;
  stddev?: Maybe<Refund_Request_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Refund_Request_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Refund_Request_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Refund_Request_Tracking_Sum_Fields>;
  var_pop?: Maybe<Refund_Request_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Refund_Request_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Refund_Request_Tracking_Variance_Fields>;
};


/** aggregate fields of "refund_request_tracking" */
export type Refund_Request_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "refund_request_tracking" */
export type Refund_Request_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Refund_Request_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Refund_Request_Tracking_Max_Order_By>;
  min?: InputMaybe<Refund_Request_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Refund_Request_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Refund_Request_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Refund_Request_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Refund_Request_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Refund_Request_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Refund_Request_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Refund_Request_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "refund_request_tracking" */
export type Refund_Request_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Refund_Request_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Refund_Request_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Refund_Request_Tracking_Avg_Fields = {
  __typename?: 'refund_request_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "refund_request_tracking". All fields are combined with a logical 'AND'. */
export type Refund_Request_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Refund_Request_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Refund_Request_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  refund_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_request_tracking" */
export enum Refund_Request_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  RefundRequestTrackingPkey = 'refund_request_tracking_pkey'
}

/** input type for incrementing numeric columns in table "refund_request_tracking" */
export type Refund_Request_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "refund_request_tracking" */
export type Refund_Request_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Refund_Request_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Refund_Request_Tracking_Max_Fields = {
  __typename?: 'refund_request_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Refund_Request_Tracking_Min_Fields = {
  __typename?: 'refund_request_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  refund_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "refund_request_tracking" */
export type Refund_Request_Tracking_Mutation_Response = {
  __typename?: 'refund_request_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refund_Request_Tracking>;
};

/** on_conflict condition type for table "refund_request_tracking" */
export type Refund_Request_Tracking_On_Conflict = {
  constraint: Refund_Request_Tracking_Constraint;
  update_columns?: Array<Refund_Request_Tracking_Update_Column>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "refund_request_tracking". */
export type Refund_Request_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  refund_request_id?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Refund_Request_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refund_request_tracking */
export type Refund_Request_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "refund_request_tracking" */
export enum Refund_Request_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RefundRequestId = 'refund_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "refund_request_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "refund_request_tracking" */
export enum Refund_Request_Tracking_Select_Column_Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "refund_request_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "refund_request_tracking" */
export enum Refund_Request_Tracking_Select_Column_Refund_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "refund_request_tracking" */
export type Refund_Request_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status = {
  __typename?: 'refund_request_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Aggregate = {
  __typename?: 'refund_request_tracking_status_aggregate';
  aggregate?: Maybe<Refund_Request_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Refund_Request_Tracking_Status>;
};

/** aggregate fields of "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Aggregate_Fields = {
  __typename?: 'refund_request_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Refund_Request_Tracking_Status_Max_Fields>;
  min?: Maybe<Refund_Request_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Refund_Request_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "refund_request_tracking_status". All fields are combined with a logical 'AND'. */
export type Refund_Request_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Refund_Request_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Refund_Request_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "refund_request_tracking_status" */
export enum Refund_Request_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  RefundRequestTrackingStatusPkey = 'refund_request_tracking_status_pkey'
}

/** input type for inserting data into table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Refund_Request_Tracking_Status_Max_Fields = {
  __typename?: 'refund_request_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Refund_Request_Tracking_Status_Min_Fields = {
  __typename?: 'refund_request_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Mutation_Response = {
  __typename?: 'refund_request_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Refund_Request_Tracking_Status>;
};

/** input type for inserting object relation for remote table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Refund_Request_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Refund_Request_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_On_Conflict = {
  constraint: Refund_Request_Tracking_Status_Constraint;
  update_columns?: Array<Refund_Request_Tracking_Status_Update_Column>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "refund_request_tracking_status". */
export type Refund_Request_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: refund_request_tracking_status */
export type Refund_Request_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "refund_request_tracking_status" */
export enum Refund_Request_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "refund_request_tracking_status" */
export type Refund_Request_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refund_Request_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refund_Request_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "refund_request_tracking_status" */
export enum Refund_Request_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Refund_Request_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refund_Request_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refund_Request_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Refund_Request_Tracking_Stddev_Fields = {
  __typename?: 'refund_request_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Refund_Request_Tracking_Stddev_Pop_Fields = {
  __typename?: 'refund_request_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Refund_Request_Tracking_Stddev_Samp_Fields = {
  __typename?: 'refund_request_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "refund_request_tracking" */
export type Refund_Request_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Refund_Request_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Refund_Request_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refund_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Refund_Request_Tracking_Sum_Fields = {
  __typename?: 'refund_request_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "refund_request_tracking" */
export enum Refund_Request_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RefundRequestId = 'refund_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Refund_Request_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refund_Request_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refund_Request_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refund_Request_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Refund_Request_Tracking_Var_Pop_Fields = {
  __typename?: 'refund_request_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Refund_Request_Tracking_Var_Samp_Fields = {
  __typename?: 'refund_request_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Refund_Request_Tracking_Variance_Fields = {
  __typename?: 'refund_request_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "refund_request_tracking" */
export type Refund_Request_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "refund_request" */
export enum Refund_Request_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  E2eRefund = 'e2e_refund',
  /** column name */
  Id = 'id',
  /** column name */
  Issue = 'issue',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  MissiveLink = 'missive_link',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OurFault = 'our_fault',
  /** column name */
  ProposedSolution = 'proposed_solution',
  /** column name */
  ReasonForRefund = 'reason_for_refund',
  /** column name */
  RefundedGovernmentFee = 'refunded_government_fee',
  /** column name */
  RefundedPartnerFee = 'refunded_partner_fee',
  /** column name */
  RefundedServiceFee = 'refunded_service_fee',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Refund_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Refund_Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Refund_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Refund_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Refund_Request_Var_Pop_Fields = {
  __typename?: 'refund_request_var_pop_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Refund_Request_Var_Samp_Fields = {
  __typename?: 'refund_request_var_samp_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Refund_Request_Variance_Fields = {
  __typename?: 'refund_request_variance_fields';
  refunded_government_fee?: Maybe<Scalars['Float']['output']>;
  refunded_partner_fee?: Maybe<Scalars['Float']['output']>;
  refunded_service_fee?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "registration_request" */
export type Registration_Request = {
  __typename?: 'registration_request';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_classes: Scalars['jsonb']['output'];
  /** An array relationship */
  ai_gs_items_analysis: Array<Ai_Gs_Items_Analysis>;
  /** An aggregate relationship */
  ai_gs_items_analysis_aggregate: Ai_Gs_Items_Analysis_Aggregate;
  ai_pipeline_task_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  application?: Maybe<Application>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  assignee_history: Scalars['jsonb']['output'];
  /** An object relationship */
  billing_entity?: Maybe<Entity>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_protection: Scalars['Boolean']['output'];
  client_business_description: Scalars['String']['output'];
  client_note?: Maybe<Scalars['String']['output']>;
  client_websites?: Maybe<Scalars['jsonb']['output']>;
  contact_email: Scalars['String']['output'];
  contact_first_name: Scalars['String']['output'];
  contact_last_name: Scalars['String']['output'];
  contact_phone: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  /** An object relationship */
  discount_coupon?: Maybe<Discount_Coupon>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  e2e_protection: Scalars['Boolean']['output'];
  euipo_grant_requested: Scalars['Boolean']['output'];
  gdrive_folder_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  initial_ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_issued_in_US?: Maybe<Scalars['Boolean']['output']>;
  is_amazon_seller: Scalars['Boolean']['output'];
  jurisdictions: Scalars['jsonb']['output'];
  language: Scalars['String']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  lawyer_services_help_required?: Maybe<Scalars['Boolean']['output']>;
  mark_alias?: Maybe<Scalars['String']['output']>;
  marketing_emails_force_disabled: Scalars['Boolean']['output'];
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  ordered_items?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  origin_trademark?: Maybe<Trademark>;
  origin_trademark_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  product: Product;
  /** An array relationship */
  product_events: Array<Product_Event>;
  /** An aggregate relationship */
  product_events_aggregate: Product_Event_Aggregate;
  product_id: Scalars['uuid']['output'];
  public_id: Scalars['String']['output'];
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  region: Scalars['String']['output'];
  report_violation_url?: Maybe<Scalars['String']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  send_drafting_reminders: Scalars['Boolean']['output'];
  service_type: Scalars['String']['output'];
  services: Scalars['jsonb']['output'];
  special_treatment: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  status_group: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Registration_Request_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Registration_Request_Tracking_Aggregate;
  /** An array relationship */
  trademarks: Array<Trademark>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademark_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  use_in_commerce?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
  verification_result?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  verification_results: Array<Verification_Result>;
  /** An aggregate relationship */
  verification_results_aggregate: Verification_Result_Aggregate;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestAi_ClassesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestAi_Gs_Items_AnalysisArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestAi_Gs_Items_Analysis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestAssignee_HistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestClient_WebsitesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestOrdered_ItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestProduct_EventsArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestProduct_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestServicesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestVerification_ResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestVerification_ResultsArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


/** columns and relationships of "registration_request" */
export type Registration_RequestVerification_Results_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};

/** aggregated selection of "registration_request" */
export type Registration_Request_Aggregate = {
  __typename?: 'registration_request_aggregate';
  aggregate?: Maybe<Registration_Request_Aggregate_Fields>;
  nodes: Array<Registration_Request>;
};

export type Registration_Request_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Registration_Request_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Registration_Request_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Registration_Request_Aggregate_Bool_Exp_Count>;
};

export type Registration_Request_Aggregate_Bool_Exp_Bool_And = {
  arguments: Registration_Request_Select_Column_Registration_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Registration_Request_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Registration_Request_Select_Column_Registration_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Registration_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Registration_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "registration_request" */
export type Registration_Request_Aggregate_Fields = {
  __typename?: 'registration_request_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Registration_Request_Max_Fields>;
  min?: Maybe<Registration_Request_Min_Fields>;
};


/** aggregate fields of "registration_request" */
export type Registration_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registration_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "registration_request" */
export type Registration_Request_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Registration_Request_Max_Order_By>;
  min?: InputMaybe<Registration_Request_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Registration_Request_Append_Input = {
  ai_classes?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  client_websites?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  ordered_items?: InputMaybe<Scalars['jsonb']['input']>;
  services?: InputMaybe<Scalars['jsonb']['input']>;
  verification_result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "registration_request" */
export type Registration_Request_Arr_Rel_Insert_Input = {
  data: Array<Registration_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Registration_Request_On_Conflict>;
};

/** Boolean expression to filter rows from the table "registration_request". All fields are combined with a logical 'AND'. */
export type Registration_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Request_Bool_Exp>>;
  _not?: InputMaybe<Registration_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Registration_Request_Bool_Exp>>;
  ai_business_description?: InputMaybe<String_Comparison_Exp>;
  ai_classes?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_gs_items_analysis?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
  ai_gs_items_analysis_aggregate?: InputMaybe<Ai_Gs_Items_Analysis_Aggregate_Bool_Exp>;
  ai_pipeline_task_id?: InputMaybe<String_Comparison_Exp>;
  application?: InputMaybe<Application_Bool_Exp>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assignee_history?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_entity?: InputMaybe<Entity_Bool_Exp>;
  billing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_protection?: InputMaybe<Boolean_Comparison_Exp>;
  client_business_description?: InputMaybe<String_Comparison_Exp>;
  client_note?: InputMaybe<String_Comparison_Exp>;
  client_websites?: InputMaybe<Jsonb_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_first_name?: InputMaybe<String_Comparison_Exp>;
  contact_last_name?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  discount_coupon?: InputMaybe<Discount_Coupon_Bool_Exp>;
  discount_coupon_id?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  e2e_protection?: InputMaybe<Boolean_Comparison_Exp>;
  euipo_grant_requested?: InputMaybe<Boolean_Comparison_Exp>;
  gdrive_folder_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  initial_ai_analysis_task_id?: InputMaybe<String_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_issued_in_US?: InputMaybe<Boolean_Comparison_Exp>;
  is_amazon_seller?: InputMaybe<Boolean_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  lawyer_services_help_required?: InputMaybe<Boolean_Comparison_Exp>;
  mark_alias?: InputMaybe<String_Comparison_Exp>;
  marketing_emails_force_disabled?: InputMaybe<Boolean_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  ordered_items?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_trademark?: InputMaybe<Trademark_Bool_Exp>;
  origin_trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_events?: InputMaybe<Product_Event_Bool_Exp>;
  product_events_aggregate?: InputMaybe<Product_Event_Aggregate_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  public_id?: InputMaybe<String_Comparison_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  report_violation_url?: InputMaybe<String_Comparison_Exp>;
  search?: InputMaybe<String_Comparison_Exp>;
  send_drafting_reminders?: InputMaybe<Boolean_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  services?: InputMaybe<Jsonb_Comparison_Exp>;
  special_treatment?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_group?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Registration_Request_Tracking_Aggregate_Bool_Exp>;
  trademarks?: InputMaybe<Trademark_Bool_Exp>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_in_commerce?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  verification_result?: InputMaybe<Jsonb_Comparison_Exp>;
  verification_results?: InputMaybe<Verification_Result_Bool_Exp>;
  verification_results_aggregate?: InputMaybe<Verification_Result_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "registration_request" */
export enum Registration_Request_Constraint {
  /** unique or primary key constraint on columns "application_id" */
  RegistrationRequestApplicationIdUnique = 'registration_request_application_id_unique',
  /** unique or primary key constraint on columns "document_hub_id" */
  RegistrationRequestDocumentHubIdKey = 'registration_request_document_hub_id_key',
  /** unique or primary key constraint on columns "note_hub_id" */
  RegistrationRequestNoteHubIdKey = 'registration_request_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  RegistrationRequestPkey = 'registration_request_pkey',
  /** unique or primary key constraint on columns "product_id" */
  RegistrationRequestProductIdKey = 'registration_request_product_id_key',
  /** unique or primary key constraint on columns "public_id" */
  RegistrationRequestPublicIdKey = 'registration_request_public_id_key',
  /** unique or primary key constraint on columns "quote_hub_id" */
  RegistrationRequestQuoteHubIdKey = 'registration_request_quote_hub_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Registration_Request_Delete_At_Path_Input = {
  ai_classes?: InputMaybe<Array<Scalars['String']['input']>>;
  assignee_history?: InputMaybe<Array<Scalars['String']['input']>>;
  client_websites?: InputMaybe<Array<Scalars['String']['input']>>;
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
  ordered_items?: InputMaybe<Array<Scalars['String']['input']>>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  verification_result?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Registration_Request_Delete_Elem_Input = {
  ai_classes?: InputMaybe<Scalars['Int']['input']>;
  assignee_history?: InputMaybe<Scalars['Int']['input']>;
  client_websites?: InputMaybe<Scalars['Int']['input']>;
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
  ordered_items?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Scalars['Int']['input']>;
  verification_result?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Registration_Request_Delete_Key_Input = {
  ai_classes?: InputMaybe<Scalars['String']['input']>;
  assignee_history?: InputMaybe<Scalars['String']['input']>;
  client_websites?: InputMaybe<Scalars['String']['input']>;
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
  ordered_items?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "registration_request" */
export type Registration_Request_Insert_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_classes?: InputMaybe<Scalars['jsonb']['input']>;
  ai_gs_items_analysis?: InputMaybe<Ai_Gs_Items_Analysis_Arr_Rel_Insert_Input>;
  ai_pipeline_task_id?: InputMaybe<Scalars['String']['input']>;
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_protection?: InputMaybe<Scalars['Boolean']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  client_websites?: InputMaybe<Scalars['jsonb']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon?: InputMaybe<Discount_Coupon_Obj_Rel_Insert_Input>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  e2e_protection?: InputMaybe<Scalars['Boolean']['input']>;
  euipo_grant_requested?: InputMaybe<Scalars['Boolean']['input']>;
  gdrive_folder_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoice_issued_in_US?: InputMaybe<Scalars['Boolean']['input']>;
  is_amazon_seller?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyer_services_help_required?: InputMaybe<Scalars['Boolean']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_force_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  ordered_items?: InputMaybe<Scalars['jsonb']['input']>;
  origin_trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  origin_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_events?: InputMaybe<Product_Event_Arr_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_violation_url?: InputMaybe<Scalars['String']['input']>;
  send_drafting_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  service_type?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['jsonb']['input']>;
  special_treatment?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Registration_Request_Tracking_Arr_Rel_Insert_Input>;
  trademarks?: InputMaybe<Trademark_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Scalars['jsonb']['input']>;
  verification_results?: InputMaybe<Verification_Result_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Registration_Request_Max_Fields = {
  __typename?: 'registration_request_max_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_pipeline_task_id?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  gdrive_folder_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initial_ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  mark_alias?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  origin_trademark_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  report_violation_url?: Maybe<Scalars['String']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  service_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_group?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "registration_request" */
export type Registration_Request_Max_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_pipeline_task_id?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  gdrive_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_ai_analysis_task_id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  mark_alias?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  origin_trademark_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_violation_url?: InputMaybe<Order_By>;
  search?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Registration_Request_Min_Fields = {
  __typename?: 'registration_request_min_fields';
  ai_business_description?: Maybe<Scalars['String']['output']>;
  ai_pipeline_task_id?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  client_business_description?: Maybe<Scalars['String']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_first_name?: Maybe<Scalars['String']['output']>;
  contact_last_name?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  gdrive_folder_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  initial_ai_analysis_task_id?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  mark_alias?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  origin_trademark_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  report_violation_url?: Maybe<Scalars['String']['output']>;
  search?: Maybe<Scalars['String']['output']>;
  service_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_group?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "registration_request" */
export type Registration_Request_Min_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_pipeline_task_id?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  gdrive_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_ai_analysis_task_id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  mark_alias?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  origin_trademark_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_violation_url?: InputMaybe<Order_By>;
  search?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "registration_request" */
export type Registration_Request_Mutation_Response = {
  __typename?: 'registration_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Registration_Request>;
};

/** input type for inserting object relation for remote table "registration_request" */
export type Registration_Request_Obj_Rel_Insert_Input = {
  data: Registration_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Registration_Request_On_Conflict>;
};

/** on_conflict condition type for table "registration_request" */
export type Registration_Request_On_Conflict = {
  constraint: Registration_Request_Constraint;
  update_columns?: Array<Registration_Request_Update_Column>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "registration_request". */
export type Registration_Request_Order_By = {
  ai_business_description?: InputMaybe<Order_By>;
  ai_classes?: InputMaybe<Order_By>;
  ai_gs_items_analysis_aggregate?: InputMaybe<Ai_Gs_Items_Analysis_Aggregate_Order_By>;
  ai_pipeline_task_id?: InputMaybe<Order_By>;
  application?: InputMaybe<Application_Order_By>;
  application_id?: InputMaybe<Order_By>;
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  assignee_history?: InputMaybe<Order_By>;
  billing_entity?: InputMaybe<Entity_Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_protection?: InputMaybe<Order_By>;
  client_business_description?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  client_websites?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_coupon?: InputMaybe<Discount_Coupon_Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  e2e_protection?: InputMaybe<Order_By>;
  euipo_grant_requested?: InputMaybe<Order_By>;
  gdrive_folder_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  initial_ai_analysis_task_id?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_issued_in_US?: InputMaybe<Order_By>;
  is_amazon_seller?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  lawyer_services_help_required?: InputMaybe<Order_By>;
  mark_alias?: InputMaybe<Order_By>;
  marketing_emails_force_disabled?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  ordered_items?: InputMaybe<Order_By>;
  origin_trademark?: InputMaybe<Trademark_Order_By>;
  origin_trademark_id?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_events_aggregate?: InputMaybe<Product_Event_Aggregate_Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  report_violation_url?: InputMaybe<Order_By>;
  search?: InputMaybe<Order_By>;
  send_drafting_reminders?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  special_treatment?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Registration_Request_Tracking_Aggregate_Order_By>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_in_commerce?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  verification_result?: InputMaybe<Order_By>;
  verification_results_aggregate?: InputMaybe<Verification_Result_Aggregate_Order_By>;
};

/** primary key columns input for table: registration_request */
export type Registration_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Registration_Request_Prepend_Input = {
  ai_classes?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  client_websites?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  ordered_items?: InputMaybe<Scalars['jsonb']['input']>;
  services?: InputMaybe<Scalars['jsonb']['input']>;
  verification_result?: InputMaybe<Scalars['jsonb']['input']>;
};

export type Registration_Request_Recently_Dismissed = {
  __typename?: 'registration_request_recently_dismissed';
  assigned_admin?: Maybe<Scalars['jsonb']['output']>;
  contact_first_name: Scalars['String']['output'];
  contact_last_name: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  jurisdictions: Scalars['jsonb']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  notes: Scalars['json']['output'];
  type: Scalars['String']['output'];
  user?: Maybe<Scalars['json']['output']>;
  value: Scalars['String']['output'];
  verification_result: Scalars['jsonb']['output'];
};


export type Registration_Request_Recently_DismissedAssigned_AdminArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Registration_Request_Recently_DismissedJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Registration_Request_Recently_DismissedNotesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Registration_Request_Recently_DismissedUserArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Registration_Request_Recently_DismissedVerification_ResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the logical model for "registration_request_recently_dismissed". All fields are combined with a logical 'AND'. */
export type Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp>>;
  assigned_admin?: InputMaybe<Jsonb_Comparison_Exp>;
  contact_first_name?: InputMaybe<String_Comparison_Exp>;
  contact_last_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  notes?: InputMaybe<Json_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Json_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  verification_result?: InputMaybe<Jsonb_Comparison_Exp>;
};

export enum Registration_Request_Recently_Dismissed_Enum_Name {
  /** column name */
  AssignedAdmin = 'assigned_admin',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  Notes = 'notes',
  /** column name */
  Type = 'type',
  /** column name */
  User = 'user',
  /** column name */
  Value = 'value',
  /** column name */
  VerificationResult = 'verification_result'
}

/** Ordering options when selecting data from "registration_request_recently_dismissed". */
export type Registration_Request_Recently_Dismissed_Order_By = {
  assigned_admin?: InputMaybe<Order_By>;
  contact_first_name?: InputMaybe<Order_By>;
  contact_last_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  verification_result?: InputMaybe<Order_By>;
};

/** select columns of table "registration_request" */
export enum Registration_Request_Select_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiClasses = 'ai_classes',
  /** column name */
  AiPipelineTaskId = 'ai_pipeline_task_id',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandProtection = 'brand_protection',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  ClientWebsites = 'client_websites',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  E2eProtection = 'e2e_protection',
  /** column name */
  EuipoGrantRequested = 'euipo_grant_requested',
  /** column name */
  GdriveFolderId = 'gdrive_folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  InitialAiAnalysisTaskId = 'initial_ai_analysis_task_id',
  /** column name */
  InvoiceIssuedInUs = 'invoice_issued_in_US',
  /** column name */
  IsAmazonSeller = 'is_amazon_seller',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Language = 'language',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LawyerServicesHelpRequired = 'lawyer_services_help_required',
  /** column name */
  MarkAlias = 'mark_alias',
  /** column name */
  MarketingEmailsForceDisabled = 'marketing_emails_force_disabled',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderedItems = 'ordered_items',
  /** column name */
  OriginTrademarkId = 'origin_trademark_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PublicId = 'public_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  Region = 'region',
  /** column name */
  ReportViolationUrl = 'report_violation_url',
  /** column name */
  Search = 'search',
  /** column name */
  SendDraftingReminders = 'send_drafting_reminders',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Services = 'services',
  /** column name */
  SpecialTreatment = 'special_treatment',
  /** column name */
  Status = 'status',
  /** column name */
  StatusGroup = 'status_group',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCommerce = 'use_in_commerce',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value',
  /** column name */
  VerificationResult = 'verification_result'
}

/** select "registration_request_aggregate_bool_exp_bool_and_arguments_columns" columns of table "registration_request" */
export enum Registration_Request_Select_Column_Registration_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BrandProtection = 'brand_protection',
  /** column name */
  E2eProtection = 'e2e_protection',
  /** column name */
  EuipoGrantRequested = 'euipo_grant_requested',
  /** column name */
  InvoiceIssuedInUs = 'invoice_issued_in_US',
  /** column name */
  IsAmazonSeller = 'is_amazon_seller',
  /** column name */
  LawyerServicesHelpRequired = 'lawyer_services_help_required',
  /** column name */
  MarketingEmailsForceDisabled = 'marketing_emails_force_disabled',
  /** column name */
  SendDraftingReminders = 'send_drafting_reminders',
  /** column name */
  SpecialTreatment = 'special_treatment',
  /** column name */
  UseInCommerce = 'use_in_commerce'
}

/** select "registration_request_aggregate_bool_exp_bool_or_arguments_columns" columns of table "registration_request" */
export enum Registration_Request_Select_Column_Registration_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BrandProtection = 'brand_protection',
  /** column name */
  E2eProtection = 'e2e_protection',
  /** column name */
  EuipoGrantRequested = 'euipo_grant_requested',
  /** column name */
  InvoiceIssuedInUs = 'invoice_issued_in_US',
  /** column name */
  IsAmazonSeller = 'is_amazon_seller',
  /** column name */
  LawyerServicesHelpRequired = 'lawyer_services_help_required',
  /** column name */
  MarketingEmailsForceDisabled = 'marketing_emails_force_disabled',
  /** column name */
  SendDraftingReminders = 'send_drafting_reminders',
  /** column name */
  SpecialTreatment = 'special_treatment',
  /** column name */
  UseInCommerce = 'use_in_commerce'
}

/** input type for updating data in table "registration_request" */
export type Registration_Request_Set_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_classes?: InputMaybe<Scalars['jsonb']['input']>;
  ai_pipeline_task_id?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_protection?: InputMaybe<Scalars['Boolean']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  client_websites?: InputMaybe<Scalars['jsonb']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  e2e_protection?: InputMaybe<Scalars['Boolean']['input']>;
  euipo_grant_requested?: InputMaybe<Scalars['Boolean']['input']>;
  gdrive_folder_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  invoice_issued_in_US?: InputMaybe<Scalars['Boolean']['input']>;
  is_amazon_seller?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyer_services_help_required?: InputMaybe<Scalars['Boolean']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_force_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  ordered_items?: InputMaybe<Scalars['jsonb']['input']>;
  origin_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_violation_url?: InputMaybe<Scalars['String']['input']>;
  send_drafting_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  service_type?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['jsonb']['input']>;
  special_treatment?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "registration_request" */
export type Registration_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registration_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Registration_Request_Stream_Cursor_Value_Input = {
  ai_business_description?: InputMaybe<Scalars['String']['input']>;
  ai_classes?: InputMaybe<Scalars['jsonb']['input']>;
  ai_pipeline_task_id?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_protection?: InputMaybe<Scalars['Boolean']['input']>;
  client_business_description?: InputMaybe<Scalars['String']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  client_websites?: InputMaybe<Scalars['jsonb']['input']>;
  contact_email?: InputMaybe<Scalars['String']['input']>;
  contact_first_name?: InputMaybe<Scalars['String']['input']>;
  contact_last_name?: InputMaybe<Scalars['String']['input']>;
  contact_phone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  e2e_protection?: InputMaybe<Scalars['Boolean']['input']>;
  euipo_grant_requested?: InputMaybe<Scalars['Boolean']['input']>;
  gdrive_folder_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_ai_analysis_task_id?: InputMaybe<Scalars['String']['input']>;
  invoice_issued_in_US?: InputMaybe<Scalars['Boolean']['input']>;
  is_amazon_seller?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  lawyer_services_help_required?: InputMaybe<Scalars['Boolean']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_force_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  ordered_items?: InputMaybe<Scalars['jsonb']['input']>;
  origin_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  report_violation_url?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  send_drafting_reminders?: InputMaybe<Scalars['Boolean']['input']>;
  service_type?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['jsonb']['input']>;
  special_treatment?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "registration_request_tracking" */
export type Registration_Request_Tracking = {
  __typename?: 'registration_request_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  registration_request: Registration_Request;
  registration_request_id: Scalars['uuid']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: Registration_Request_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "registration_request_tracking" */
export type Registration_Request_Tracking_Aggregate = {
  __typename?: 'registration_request_tracking_aggregate';
  aggregate?: Maybe<Registration_Request_Tracking_Aggregate_Fields>;
  nodes: Array<Registration_Request_Tracking>;
};

export type Registration_Request_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Registration_Request_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Registration_Request_Tracking_Select_Column_Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Registration_Request_Tracking_Select_Column_Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Registration_Request_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "registration_request_tracking" */
export type Registration_Request_Tracking_Aggregate_Fields = {
  __typename?: 'registration_request_tracking_aggregate_fields';
  avg?: Maybe<Registration_Request_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Registration_Request_Tracking_Max_Fields>;
  min?: Maybe<Registration_Request_Tracking_Min_Fields>;
  stddev?: Maybe<Registration_Request_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Registration_Request_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Registration_Request_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Registration_Request_Tracking_Sum_Fields>;
  var_pop?: Maybe<Registration_Request_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Registration_Request_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Registration_Request_Tracking_Variance_Fields>;
};


/** aggregate fields of "registration_request_tracking" */
export type Registration_Request_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "registration_request_tracking" */
export type Registration_Request_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Registration_Request_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Registration_Request_Tracking_Max_Order_By>;
  min?: InputMaybe<Registration_Request_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Registration_Request_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Registration_Request_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Registration_Request_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Registration_Request_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Registration_Request_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Registration_Request_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Registration_Request_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "registration_request_tracking" */
export type Registration_Request_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Registration_Request_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Registration_Request_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Registration_Request_Tracking_Avg_Fields = {
  __typename?: 'registration_request_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "registration_request_tracking". All fields are combined with a logical 'AND'. */
export type Registration_Request_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Request_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Registration_Request_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "registration_request_tracking" */
export enum Registration_Request_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrackingActionsPkey = 'tracking_actions_pkey'
}

/** input type for incrementing numeric columns in table "registration_request_tracking" */
export type Registration_Request_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "registration_request_tracking" */
export type Registration_Request_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Registration_Request_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Registration_Request_Tracking_Max_Fields = {
  __typename?: 'registration_request_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Registration_Request_Tracking_Min_Fields = {
  __typename?: 'registration_request_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "registration_request_tracking" */
export type Registration_Request_Tracking_Mutation_Response = {
  __typename?: 'registration_request_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Registration_Request_Tracking>;
};

/** on_conflict condition type for table "registration_request_tracking" */
export type Registration_Request_Tracking_On_Conflict = {
  constraint: Registration_Request_Tracking_Constraint;
  update_columns?: Array<Registration_Request_Tracking_Update_Column>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "registration_request_tracking". */
export type Registration_Request_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Registration_Request_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: registration_request_tracking */
export type Registration_Request_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "registration_request_tracking" */
export enum Registration_Request_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "registration_request_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "registration_request_tracking" */
export enum Registration_Request_Tracking_Select_Column_Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "registration_request_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "registration_request_tracking" */
export enum Registration_Request_Tracking_Select_Column_Registration_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "registration_request_tracking" */
export type Registration_Request_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status = {
  __typename?: 'registration_request_tracking_status';
  group?: Maybe<Scalars['String']['output']>;
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Aggregate = {
  __typename?: 'registration_request_tracking_status_aggregate';
  aggregate?: Maybe<Registration_Request_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Registration_Request_Tracking_Status>;
};

/** aggregate fields of "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Aggregate_Fields = {
  __typename?: 'registration_request_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Registration_Request_Tracking_Status_Max_Fields>;
  min?: Maybe<Registration_Request_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Registration_Request_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "registration_request_tracking_status". All fields are combined with a logical 'AND'. */
export type Registration_Request_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Registration_Request_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Registration_Request_Tracking_Status_Bool_Exp>>;
  group?: InputMaybe<String_Comparison_Exp>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "registration_request_tracking_status" */
export enum Registration_Request_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  TrackingStatusPkey = 'tracking_status_pkey'
}

/** input type for inserting data into table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Insert_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Registration_Request_Tracking_Status_Max_Fields = {
  __typename?: 'registration_request_tracking_status_max_fields';
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Registration_Request_Tracking_Status_Min_Fields = {
  __typename?: 'registration_request_tracking_status_min_fields';
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Mutation_Response = {
  __typename?: 'registration_request_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Registration_Request_Tracking_Status>;
};

/** input type for inserting object relation for remote table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Registration_Request_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Registration_Request_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_On_Conflict = {
  constraint: Registration_Request_Tracking_Status_Constraint;
  update_columns?: Array<Registration_Request_Tracking_Status_Update_Column>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "registration_request_tracking_status". */
export type Registration_Request_Tracking_Status_Order_By = {
  group?: InputMaybe<Order_By>;
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: registration_request_tracking_status */
export type Registration_Request_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "registration_request_tracking_status" */
export enum Registration_Request_Tracking_Status_Select_Column {
  /** column name */
  Group = 'group',
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Set_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "registration_request_tracking_status" */
export type Registration_Request_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registration_Request_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Registration_Request_Tracking_Status_Stream_Cursor_Value_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "registration_request_tracking_status" */
export enum Registration_Request_Tracking_Status_Update_Column {
  /** column name */
  Group = 'group',
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Registration_Request_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registration_Request_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Registration_Request_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Registration_Request_Tracking_Stddev_Fields = {
  __typename?: 'registration_request_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Registration_Request_Tracking_Stddev_Pop_Fields = {
  __typename?: 'registration_request_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Registration_Request_Tracking_Stddev_Samp_Fields = {
  __typename?: 'registration_request_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "registration_request_tracking" */
export type Registration_Request_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Registration_Request_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Registration_Request_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Registration_Request_Tracking_Sum_Fields = {
  __typename?: 'registration_request_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "registration_request_tracking" */
export enum Registration_Request_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Registration_Request_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Registration_Request_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registration_Request_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Registration_Request_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Registration_Request_Tracking_Var_Pop_Fields = {
  __typename?: 'registration_request_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Registration_Request_Tracking_Var_Samp_Fields = {
  __typename?: 'registration_request_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Registration_Request_Tracking_Variance_Fields = {
  __typename?: 'registration_request_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "registration_request_tracking" */
export type Registration_Request_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "registration_request" */
export enum Registration_Request_Update_Column {
  /** column name */
  AiBusinessDescription = 'ai_business_description',
  /** column name */
  AiClasses = 'ai_classes',
  /** column name */
  AiPipelineTaskId = 'ai_pipeline_task_id',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandProtection = 'brand_protection',
  /** column name */
  ClientBusinessDescription = 'client_business_description',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  ClientWebsites = 'client_websites',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFirstName = 'contact_first_name',
  /** column name */
  ContactLastName = 'contact_last_name',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  E2eProtection = 'e2e_protection',
  /** column name */
  EuipoGrantRequested = 'euipo_grant_requested',
  /** column name */
  GdriveFolderId = 'gdrive_folder_id',
  /** column name */
  Id = 'id',
  /** column name */
  InitialAiAnalysisTaskId = 'initial_ai_analysis_task_id',
  /** column name */
  InvoiceIssuedInUs = 'invoice_issued_in_US',
  /** column name */
  IsAmazonSeller = 'is_amazon_seller',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Language = 'language',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LawyerServicesHelpRequired = 'lawyer_services_help_required',
  /** column name */
  MarkAlias = 'mark_alias',
  /** column name */
  MarketingEmailsForceDisabled = 'marketing_emails_force_disabled',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderedItems = 'ordered_items',
  /** column name */
  OriginTrademarkId = 'origin_trademark_id',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PublicId = 'public_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  Region = 'region',
  /** column name */
  ReportViolationUrl = 'report_violation_url',
  /** column name */
  SendDraftingReminders = 'send_drafting_reminders',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Services = 'services',
  /** column name */
  SpecialTreatment = 'special_treatment',
  /** column name */
  Status = 'status',
  /** column name */
  StatusGroup = 'status_group',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCommerce = 'use_in_commerce',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value',
  /** column name */
  VerificationResult = 'verification_result'
}

export type Registration_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Registration_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Registration_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Registration_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Registration_Request_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Registration_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Registration_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Registration_Request_Bool_Exp;
};

/** columns and relationships of "reminder" */
export type Reminder = {
  __typename?: 'reminder';
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  trigger_at: Scalars['timestamptz']['output'];
  triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "reminder" */
export type Reminder_Aggregate = {
  __typename?: 'reminder_aggregate';
  aggregate?: Maybe<Reminder_Aggregate_Fields>;
  nodes: Array<Reminder>;
};

/** aggregate fields of "reminder" */
export type Reminder_Aggregate_Fields = {
  __typename?: 'reminder_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Reminder_Max_Fields>;
  min?: Maybe<Reminder_Min_Fields>;
};


/** aggregate fields of "reminder" */
export type Reminder_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reminder_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "reminder". All fields are combined with a logical 'AND'. */
export type Reminder_Bool_Exp = {
  _and?: InputMaybe<Array<Reminder_Bool_Exp>>;
  _not?: InputMaybe<Reminder_Bool_Exp>;
  _or?: InputMaybe<Array<Reminder_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  resource_id?: InputMaybe<String_Comparison_Exp>;
  resource_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trigger_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  triggered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reminder" */
export enum Reminder_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReminderPkey = 'reminder_pkey'
}

/** input type for inserting data into table "reminder" */
export type Reminder_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trigger_at?: InputMaybe<Scalars['timestamptz']['input']>;
  triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Reminder_Max_Fields = {
  __typename?: 'reminder_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trigger_at?: Maybe<Scalars['timestamptz']['output']>;
  triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Reminder_Min_Fields = {
  __typename?: 'reminder_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deleted_at?: Maybe<Scalars['timestamptz']['output']>;
  deleted_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trigger_at?: Maybe<Scalars['timestamptz']['output']>;
  triggered_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "reminder" */
export type Reminder_Mutation_Response = {
  __typename?: 'reminder_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reminder>;
};

/** on_conflict condition type for table "reminder" */
export type Reminder_On_Conflict = {
  constraint: Reminder_Constraint;
  update_columns?: Array<Reminder_Update_Column>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};

/** Ordering options when selecting data from "reminder". */
export type Reminder_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigger_at?: InputMaybe<Order_By>;
  triggered_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reminder */
export type Reminder_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reminder" */
export enum Reminder_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUserId = 'deleted_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceName = 'resource_name',
  /** column name */
  Status = 'status',
  /** column name */
  TriggerAt = 'trigger_at',
  /** column name */
  TriggeredAt = 'triggered_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "reminder" */
export type Reminder_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trigger_at?: InputMaybe<Scalars['timestamptz']['input']>;
  triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "reminder" */
export type Reminder_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reminder_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reminder_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deleted_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trigger_at?: InputMaybe<Scalars['timestamptz']['input']>;
  triggered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "reminder" */
export enum Reminder_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUserId = 'deleted_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Notes = 'notes',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceName = 'resource_name',
  /** column name */
  Status = 'status',
  /** column name */
  TriggerAt = 'trigger_at',
  /** column name */
  TriggeredAt = 'triggered_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Reminder_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reminder_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reminder_Bool_Exp;
};

/** columns and relationships of "service" */
export type Service = {
  __typename?: 'service';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  assignee_history: Scalars['jsonb']['output'];
  /** An object relationship */
  case_solution?: Maybe<Case_Solution>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  deadline?: Maybe<Scalars['date']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  note_hub_id: Scalars['uuid']['output'];
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  parameters: Scalars['jsonb']['output'];
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Service_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Service_Tracking_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "service" */
export type ServiceAssignee_HistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service" */
export type ServiceParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service" */
export type ServiceTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


/** columns and relationships of "service" */
export type ServiceTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};

/** aggregated selection of "service" */
export type Service_Aggregate = {
  __typename?: 'service_aggregate';
  aggregate?: Maybe<Service_Aggregate_Fields>;
  nodes: Array<Service>;
};

export type Service_Aggregate_Bool_Exp = {
  count?: InputMaybe<Service_Aggregate_Bool_Exp_Count>;
};

export type Service_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service" */
export type Service_Aggregate_Fields = {
  __typename?: 'service_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Max_Fields>;
  min?: Maybe<Service_Min_Fields>;
};


/** aggregate fields of "service" */
export type Service_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service" */
export type Service_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Max_Order_By>;
  min?: InputMaybe<Service_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Service_Append_Input = {
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "service" */
export type Service_Arr_Rel_Insert_Input = {
  data: Array<Service_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_On_Conflict>;
};

/** Boolean expression to filter rows from the table "service". All fields are combined with a logical 'AND'. */
export type Service_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Bool_Exp>>;
  _not?: InputMaybe<Service_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assignee_history?: InputMaybe<Jsonb_Comparison_Exp>;
  case_solution?: InputMaybe<Case_Solution_Bool_Exp>;
  case_solution_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  deadline?: InputMaybe<Date_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  outcome_note?: InputMaybe<String_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Service_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Service_Tracking_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "service" */
export enum Service_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicePkey = 'service_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Service_Delete_At_Path_Input = {
  assignee_history?: InputMaybe<Array<Scalars['String']['input']>>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Service_Delete_Elem_Input = {
  assignee_history?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Service_Delete_Key_Input = {
  assignee_history?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "service" */
export type Service_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  case_solution?: InputMaybe<Case_Solution_Obj_Rel_Insert_Input>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Service_Tracking_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Service_Max_Fields = {
  __typename?: 'service_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "service" */
export type Service_Max_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Min_Fields = {
  __typename?: 'service_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  case_solution_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_note?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "service" */
export type Service_Min_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service" */
export type Service_Mutation_Response = {
  __typename?: 'service_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service>;
};

/** on_conflict condition type for table "service" */
export type Service_On_Conflict = {
  constraint: Service_Constraint;
  update_columns?: Array<Service_Update_Column>;
  where?: InputMaybe<Service_Bool_Exp>;
};

/** Ordering options when selecting data from "service". */
export type Service_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  assignee_history?: InputMaybe<Order_By>;
  case_solution?: InputMaybe<Case_Solution_Order_By>;
  case_solution_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_note?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Service_Tracking_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service */
export type Service_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Service_Prepend_Input = {
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "service_request" */
export type Service_Request = {
  __typename?: 'service_request';
  asana_task_url?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  billing_entity?: Maybe<Entity>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['uuid']['output'];
  internal_label?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  invoice?: Maybe<Invoice>;
  invoice_content: Scalars['jsonb']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  missive_link_client?: Maybe<Scalars['String']['output']>;
  missive_link_partner?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  parameters: Scalars['jsonb']['output'];
  /** An object relationship */
  product: Product;
  product_id: Scalars['uuid']['output'];
  public_id: Scalars['String']['output'];
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  quote_version: Scalars['Int']['output'];
  region: Scalars['String']['output'];
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tracking_actions: Array<Service_Request_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Service_Request_Tracking_Aggregate;
  /** An array relationship */
  trademark_service_requests: Array<Trademark_Service_Requests>;
  /** An aggregate relationship */
  trademark_service_requests_aggregate: Trademark_Service_Requests_Aggregate;
  /** An array relationship */
  trademark_watch_subscription: Array<Trademark_Watch_Subscription>;
  /** An aggregate relationship */
  trademark_watch_subscription_aggregate: Trademark_Watch_Subscription_Aggregate;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "service_request" */
export type Service_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestInvoice_ContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service_request" */
export type Service_RequestNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestParametersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTrademark_Service_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTrademark_Service_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTrademark_Watch_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


/** columns and relationships of "service_request" */
export type Service_RequestTrademark_Watch_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};

/** aggregated selection of "service_request" */
export type Service_Request_Aggregate = {
  __typename?: 'service_request_aggregate';
  aggregate?: Maybe<Service_Request_Aggregate_Fields>;
  nodes: Array<Service_Request>;
};

export type Service_Request_Aggregate_Bool_Exp = {
  count?: InputMaybe<Service_Request_Aggregate_Bool_Exp_Count>;
};

export type Service_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service_request" */
export type Service_Request_Aggregate_Fields = {
  __typename?: 'service_request_aggregate_fields';
  avg?: Maybe<Service_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Max_Fields>;
  min?: Maybe<Service_Request_Min_Fields>;
  stddev?: Maybe<Service_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Service_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Service_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Service_Request_Sum_Fields>;
  var_pop?: Maybe<Service_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Service_Request_Var_Samp_Fields>;
  variance?: Maybe<Service_Request_Variance_Fields>;
};


/** aggregate fields of "service_request" */
export type Service_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_request" */
export type Service_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Request_Max_Order_By>;
  min?: InputMaybe<Service_Request_Min_Order_By>;
  stddev?: InputMaybe<Service_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Request_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Service_Request_Append_Input = {
  invoice_content?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "service_request" */
export type Service_Request_Arr_Rel_Insert_Input = {
  data: Array<Service_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Service_Request_Avg_Fields = {
  __typename?: 'service_request_avg_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "service_request" */
export type Service_Request_Avg_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_request". All fields are combined with a logical 'AND'. */
export type Service_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Bool_Exp>>;
  asana_task_url?: InputMaybe<String_Comparison_Exp>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  billing_entity?: InputMaybe<Entity_Bool_Exp>;
  billing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_coupon_id?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  internal_label?: InputMaybe<String_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_content?: InputMaybe<Jsonb_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  missive_link_client?: InputMaybe<String_Comparison_Exp>;
  missive_link_partner?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  order_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  parameters?: InputMaybe<Jsonb_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_id?: InputMaybe<Uuid_Comparison_Exp>;
  public_id?: InputMaybe<String_Comparison_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  quote_version?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Service_Request_Tracking_Aggregate_Bool_Exp>;
  trademark_service_requests?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
  trademark_service_requests_aggregate?: InputMaybe<Trademark_Service_Requests_Aggregate_Bool_Exp>;
  trademark_watch_subscription?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
  trademark_watch_subscription_aggregate?: InputMaybe<Trademark_Watch_Subscription_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request" */
export enum Service_Request_Constraint {
  /** unique or primary key constraint on columns "note_hub_id" */
  ServiceRequestNoteHubIdKey = 'service_request_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  ServiceRequestPkey = 'service_request_pkey',
  /** unique or primary key constraint on columns "product_id" */
  ServiceRequestProductIdKey = 'service_request_product_id_key',
  /** unique or primary key constraint on columns "public_id" */
  ServiceRequestPublicIdKey = 'service_request_public_id_key',
  /** unique or primary key constraint on columns "quote_hub_id" */
  ServiceRequestQuoteHubIdKey = 'service_request_quote_hub_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Service_Request_Delete_At_Path_Input = {
  invoice_content?: InputMaybe<Array<Scalars['String']['input']>>;
  parameters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Service_Request_Delete_Elem_Input = {
  invoice_content?: InputMaybe<Scalars['Int']['input']>;
  parameters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Service_Request_Delete_Key_Input = {
  invoice_content?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "service_request" */
export type Service_Request_Inc_Input = {
  quote_version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "service_request" */
export type Service_Request_Insert_Input = {
  asana_task_url?: InputMaybe<Scalars['String']['input']>;
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_label?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<Invoice_Obj_Rel_Insert_Input>;
  invoice_content?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link_client?: InputMaybe<Scalars['String']['input']>;
  missive_link_partner?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  product?: InputMaybe<Product_Obj_Rel_Insert_Input>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_version?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Service_Request_Tracking_Arr_Rel_Insert_Input>;
  trademark_service_requests?: InputMaybe<Trademark_Service_Requests_Arr_Rel_Insert_Input>;
  trademark_watch_subscription?: InputMaybe<Trademark_Watch_Subscription_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Max_Fields = {
  __typename?: 'service_request_max_fields';
  asana_task_url?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link_client?: Maybe<Scalars['String']['output']>;
  missive_link_partner?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  quote_version?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "service_request" */
export type Service_Request_Max_Order_By = {
  asana_task_url?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_label?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link_client?: InputMaybe<Order_By>;
  missive_link_partner?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_version?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  service_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Request_Min_Fields = {
  __typename?: 'service_request_min_fields';
  asana_task_url?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_coupon_id?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  internal_label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  missive_link_client?: Maybe<Scalars['String']['output']>;
  missive_link_partner?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  product_id?: Maybe<Scalars['uuid']['output']>;
  public_id?: Maybe<Scalars['String']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  quote_version?: Maybe<Scalars['Int']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  service_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "service_request" */
export type Service_Request_Min_Order_By = {
  asana_task_url?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  internal_label?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link_client?: InputMaybe<Order_By>;
  missive_link_partner?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_version?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  service_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_request" */
export type Service_Request_Mutation_Response = {
  __typename?: 'service_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request>;
};

/** input type for inserting object relation for remote table "service_request" */
export type Service_Request_Obj_Rel_Insert_Input = {
  data: Service_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_On_Conflict>;
};

/** on_conflict condition type for table "service_request" */
export type Service_Request_On_Conflict = {
  constraint: Service_Request_Constraint;
  update_columns?: Array<Service_Request_Update_Column>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request". */
export type Service_Request_Order_By = {
  asana_task_url?: InputMaybe<Order_By>;
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  billing_entity?: InputMaybe<Entity_Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_coupon_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  internal_label?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_content?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  missive_link_client?: InputMaybe<Order_By>;
  missive_link_partner?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  parameters?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_id?: InputMaybe<Order_By>;
  public_id?: InputMaybe<Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  quote_version?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  service_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Service_Request_Tracking_Aggregate_Order_By>;
  trademark_service_requests_aggregate?: InputMaybe<Trademark_Service_Requests_Aggregate_Order_By>;
  trademark_watch_subscription_aggregate?: InputMaybe<Trademark_Watch_Subscription_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request */
export type Service_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Service_Request_Prepend_Input = {
  invoice_content?: InputMaybe<Scalars['jsonb']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "service_request" */
export enum Service_Request_Select_Column {
  /** column name */
  AsanaTaskUrl = 'asana_task_url',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalLabel = 'internal_label',
  /** column name */
  InvoiceContent = 'invoice_content',
  /** column name */
  Language = 'language',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  MissiveLinkClient = 'missive_link_client',
  /** column name */
  MissiveLinkPartner = 'missive_link_partner',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PublicId = 'public_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  QuoteVersion = 'quote_version',
  /** column name */
  Region = 'region',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  ServiceName = 'service_name',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "service_request" */
export type Service_Request_Set_Input = {
  asana_task_url?: InputMaybe<Scalars['String']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_label?: InputMaybe<Scalars['String']['input']>;
  invoice_content?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link_client?: InputMaybe<Scalars['String']['input']>;
  missive_link_partner?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_version?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Service_Request_Stddev_Fields = {
  __typename?: 'service_request_stddev_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "service_request" */
export type Service_Request_Stddev_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Service_Request_Stddev_Pop_Fields = {
  __typename?: 'service_request_stddev_pop_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "service_request" */
export type Service_Request_Stddev_Pop_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Service_Request_Stddev_Samp_Fields = {
  __typename?: 'service_request_stddev_samp_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "service_request" */
export type Service_Request_Stddev_Samp_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "service_request" */
export type Service_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Stream_Cursor_Value_Input = {
  asana_task_url?: InputMaybe<Scalars['String']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount_coupon_id?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  internal_label?: InputMaybe<Scalars['String']['input']>;
  invoice_content?: InputMaybe<Scalars['jsonb']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  missive_link_client?: InputMaybe<Scalars['String']['input']>;
  missive_link_partner?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  product_id?: InputMaybe<Scalars['uuid']['input']>;
  public_id?: InputMaybe<Scalars['String']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_version?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  service_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Service_Request_Sum_Fields = {
  __typename?: 'service_request_sum_fields';
  quote_version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "service_request" */
export type Service_Request_Sum_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_request_tracking" */
export type Service_Request_Tracking = {
  __typename?: 'service_request_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  service_request_id: Scalars['uuid']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: Service_Request_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "service_request_tracking" */
export type Service_Request_Tracking_Aggregate = {
  __typename?: 'service_request_tracking_aggregate';
  aggregate?: Maybe<Service_Request_Tracking_Aggregate_Fields>;
  nodes: Array<Service_Request_Tracking>;
};

export type Service_Request_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Service_Request_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Service_Request_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Service_Request_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Service_Request_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Service_Request_Tracking_Select_Column_Service_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Request_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Service_Request_Tracking_Select_Column_Service_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Request_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service_request_tracking" */
export type Service_Request_Tracking_Aggregate_Fields = {
  __typename?: 'service_request_tracking_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Tracking_Max_Fields>;
  min?: Maybe<Service_Request_Tracking_Min_Fields>;
};


/** aggregate fields of "service_request_tracking" */
export type Service_Request_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_request_tracking" */
export type Service_Request_Tracking_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Request_Tracking_Max_Order_By>;
  min?: InputMaybe<Service_Request_Tracking_Min_Order_By>;
};

/** input type for inserting array relation for remote table "service_request_tracking" */
export type Service_Request_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Service_Request_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_Tracking_On_Conflict>;
};

/** Boolean expression to filter rows from the table "service_request_tracking". All fields are combined with a logical 'AND'. */
export type Service_Request_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request_tracking" */
export enum Service_Request_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceRequestTrackingPkey = 'service_request_tracking_pkey'
}

/** input type for inserting data into table "service_request_tracking" */
export type Service_Request_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Service_Request_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Tracking_Max_Fields = {
  __typename?: 'service_request_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "service_request_tracking" */
export type Service_Request_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Request_Tracking_Min_Fields = {
  __typename?: 'service_request_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "service_request_tracking" */
export type Service_Request_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_request_tracking" */
export type Service_Request_Tracking_Mutation_Response = {
  __typename?: 'service_request_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request_Tracking>;
};

/** on_conflict condition type for table "service_request_tracking" */
export type Service_Request_Tracking_On_Conflict = {
  constraint: Service_Request_Tracking_Constraint;
  update_columns?: Array<Service_Request_Tracking_Update_Column>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request_tracking". */
export type Service_Request_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Service_Request_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request_tracking */
export type Service_Request_Tracking_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "service_request_tracking" */
export enum Service_Request_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "service_request_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "service_request_tracking" */
export enum Service_Request_Tracking_Select_Column_Service_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "service_request_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "service_request_tracking" */
export enum Service_Request_Tracking_Select_Column_Service_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "service_request_tracking" */
export type Service_Request_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "service_request_tracking_status" */
export type Service_Request_Tracking_Status = {
  __typename?: 'service_request_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Aggregate = {
  __typename?: 'service_request_tracking_status_aggregate';
  aggregate?: Maybe<Service_Request_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Service_Request_Tracking_Status>;
};

/** aggregate fields of "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Aggregate_Fields = {
  __typename?: 'service_request_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Request_Tracking_Status_Max_Fields>;
  min?: Maybe<Service_Request_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Request_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "service_request_tracking_status". All fields are combined with a logical 'AND'. */
export type Service_Request_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Request_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Request_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_request_tracking_status" */
export enum Service_Request_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  ServiceTrackingStatusPkey = 'service_tracking_status_pkey'
}

/** input type for inserting data into table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Service_Request_Tracking_Status_Max_Fields = {
  __typename?: 'service_request_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Service_Request_Tracking_Status_Min_Fields = {
  __typename?: 'service_request_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Mutation_Response = {
  __typename?: 'service_request_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Request_Tracking_Status>;
};

/** input type for inserting object relation for remote table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Service_Request_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Request_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_On_Conflict = {
  constraint: Service_Request_Tracking_Status_Constraint;
  update_columns?: Array<Service_Request_Tracking_Status_Update_Column>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "service_request_tracking_status". */
export type Service_Request_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_request_tracking_status */
export type Service_Request_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "service_request_tracking_status" */
export enum Service_Request_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "service_request_tracking_status" */
export type Service_Request_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "service_request_tracking_status" */
export enum Service_Request_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Service_Request_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Tracking_Status_Bool_Exp;
};

/** Streaming cursor of the table "service_request_tracking" */
export type Service_Request_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Request_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Request_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "service_request_tracking" */
export enum Service_Request_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Service_Request_Tracking_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Tracking_Bool_Exp;
};

/** update columns of table "service_request" */
export enum Service_Request_Update_Column {
  /** column name */
  AsanaTaskUrl = 'asana_task_url',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountCouponId = 'discount_coupon_id',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  InternalLabel = 'internal_label',
  /** column name */
  InvoiceContent = 'invoice_content',
  /** column name */
  Language = 'language',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  MissiveLinkClient = 'missive_link_client',
  /** column name */
  MissiveLinkPartner = 'missive_link_partner',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  PublicId = 'public_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  QuoteVersion = 'quote_version',
  /** column name */
  Region = 'region',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  ServiceName = 'service_name',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

export type Service_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Service_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Service_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Service_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Service_Request_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Request_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Service_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Service_Request_Var_Pop_Fields = {
  __typename?: 'service_request_var_pop_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "service_request" */
export type Service_Request_Var_Pop_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Service_Request_Var_Samp_Fields = {
  __typename?: 'service_request_var_samp_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "service_request" */
export type Service_Request_Var_Samp_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Service_Request_Variance_Fields = {
  __typename?: 'service_request_variance_fields';
  quote_version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "service_request" */
export type Service_Request_Variance_Order_By = {
  quote_version?: InputMaybe<Order_By>;
};

/** select columns of table "service" */
export enum Service_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  CaseSolutionId = 'case_solution_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeNote = 'outcome_note',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** input type for updating data in table "service" */
export type Service_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "service" */
export type Service_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  case_solution_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_note?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['jsonb']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "service_tracking" */
export type Service_Tracking = {
  __typename?: 'service_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  service_id: Scalars['uuid']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: Service_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "service_tracking" */
export type Service_Tracking_Aggregate = {
  __typename?: 'service_tracking_aggregate';
  aggregate?: Maybe<Service_Tracking_Aggregate_Fields>;
  nodes: Array<Service_Tracking>;
};

export type Service_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Service_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Service_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Service_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Service_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Service_Tracking_Select_Column_Service_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Service_Tracking_Select_Column_Service_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Service_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Service_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "service_tracking" */
export type Service_Tracking_Aggregate_Fields = {
  __typename?: 'service_tracking_aggregate_fields';
  avg?: Maybe<Service_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Tracking_Max_Fields>;
  min?: Maybe<Service_Tracking_Min_Fields>;
  stddev?: Maybe<Service_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Service_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Service_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Service_Tracking_Sum_Fields>;
  var_pop?: Maybe<Service_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Service_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Service_Tracking_Variance_Fields>;
};


/** aggregate fields of "service_tracking" */
export type Service_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "service_tracking" */
export type Service_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Tracking_Max_Order_By>;
  min?: InputMaybe<Service_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Service_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "service_tracking" */
export type Service_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Service_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Service_Tracking_Avg_Fields = {
  __typename?: 'service_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "service_tracking" */
export type Service_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_tracking". All fields are combined with a logical 'AND'. */
export type Service_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Service_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  service_id?: InputMaybe<Uuid_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_tracking" */
export enum Service_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceTrackingPkey = 'service_tracking_pkey'
}

/** input type for incrementing numeric columns in table "service_tracking" */
export type Service_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "service_tracking" */
export type Service_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Service_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Service_Tracking_Max_Fields = {
  __typename?: 'service_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  service_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "service_tracking" */
export type Service_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Service_Tracking_Min_Fields = {
  __typename?: 'service_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  service_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "service_tracking" */
export type Service_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "service_tracking" */
export type Service_Tracking_Mutation_Response = {
  __typename?: 'service_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Tracking>;
};

/** on_conflict condition type for table "service_tracking" */
export type Service_Tracking_On_Conflict = {
  constraint: Service_Tracking_Constraint;
  update_columns?: Array<Service_Tracking_Update_Column>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "service_tracking". */
export type Service_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  service_id?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Service_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_tracking */
export type Service_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "service_tracking" */
export enum Service_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'service_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "service_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "service_tracking" */
export enum Service_Tracking_Select_Column_Service_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "service_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "service_tracking" */
export enum Service_Tracking_Select_Column_Service_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "service_tracking" */
export type Service_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "service_tracking_status" */
export type Service_Tracking_Status = {
  __typename?: 'service_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "service_tracking_status" */
export type Service_Tracking_Status_Aggregate = {
  __typename?: 'service_tracking_status_aggregate';
  aggregate?: Maybe<Service_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Service_Tracking_Status>;
};

/** aggregate fields of "service_tracking_status" */
export type Service_Tracking_Status_Aggregate_Fields = {
  __typename?: 'service_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Service_Tracking_Status_Max_Fields>;
  min?: Maybe<Service_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "service_tracking_status" */
export type Service_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "service_tracking_status". All fields are combined with a logical 'AND'. */
export type Service_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "service_tracking_status" */
export enum Service_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  ServiceTrackingStatusPkey1 = 'service_tracking_status_pkey1'
}

/** input type for inserting data into table "service_tracking_status" */
export type Service_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Service_Tracking_Status_Max_Fields = {
  __typename?: 'service_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Service_Tracking_Status_Min_Fields = {
  __typename?: 'service_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "service_tracking_status" */
export type Service_Tracking_Status_Mutation_Response = {
  __typename?: 'service_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Tracking_Status>;
};

/** input type for inserting object relation for remote table "service_tracking_status" */
export type Service_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Service_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Service_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "service_tracking_status" */
export type Service_Tracking_Status_On_Conflict = {
  constraint: Service_Tracking_Status_Constraint;
  update_columns?: Array<Service_Tracking_Status_Update_Column>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "service_tracking_status". */
export type Service_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: service_tracking_status */
export type Service_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "service_tracking_status" */
export enum Service_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "service_tracking_status" */
export type Service_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "service_tracking_status" */
export type Service_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "service_tracking_status" */
export enum Service_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Service_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Service_Tracking_Stddev_Fields = {
  __typename?: 'service_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "service_tracking" */
export type Service_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Service_Tracking_Stddev_Pop_Fields = {
  __typename?: 'service_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "service_tracking" */
export type Service_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Service_Tracking_Stddev_Samp_Fields = {
  __typename?: 'service_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "service_tracking" */
export type Service_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "service_tracking" */
export type Service_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_id?: InputMaybe<Scalars['uuid']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Service_Tracking_Sum_Fields = {
  __typename?: 'service_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "service_tracking" */
export type Service_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "service_tracking" */
export enum Service_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceId = 'service_id',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type Service_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Service_Tracking_Var_Pop_Fields = {
  __typename?: 'service_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "service_tracking" */
export type Service_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Service_Tracking_Var_Samp_Fields = {
  __typename?: 'service_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "service_tracking" */
export type Service_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Service_Tracking_Variance_Fields = {
  __typename?: 'service_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "service_tracking" */
export type Service_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "service" */
export enum Service_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  CaseSolutionId = 'case_solution_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeNote = 'outcome_note',
  /** column name */
  Parameters = 'parameters',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Service_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Service_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Service_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Service_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Service_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Service_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Set_Input>;
  /** filter the rows which have to be updated */
  where: Service_Bool_Exp;
};

/** columns and relationships of "similar_trademark" */
export type Similar_Trademark = {
  __typename?: 'similar_trademark';
  competitor?: Maybe<Scalars['String']['output']>;
  competitor_website?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  jurisdictions?: Maybe<Scalars['jsonb']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  similarity: Scalars['String']['output'];
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  /** An object relationship */
  verification_result: Verification_Result;
  verification_result_id: Scalars['uuid']['output'];
  well_known?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "similar_trademark" */
export type Similar_TrademarkJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "similar_trademark" */
export type Similar_TrademarkMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "similar_trademark" */
export type Similar_Trademark_Aggregate = {
  __typename?: 'similar_trademark_aggregate';
  aggregate?: Maybe<Similar_Trademark_Aggregate_Fields>;
  nodes: Array<Similar_Trademark>;
};

export type Similar_Trademark_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Similar_Trademark_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Similar_Trademark_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Similar_Trademark_Aggregate_Bool_Exp_Count>;
};

export type Similar_Trademark_Aggregate_Bool_Exp_Bool_And = {
  arguments: Similar_Trademark_Select_Column_Similar_Trademark_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Similar_Trademark_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Similar_Trademark_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Similar_Trademark_Select_Column_Similar_Trademark_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Similar_Trademark_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Similar_Trademark_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Similar_Trademark_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "similar_trademark" */
export type Similar_Trademark_Aggregate_Fields = {
  __typename?: 'similar_trademark_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Similar_Trademark_Max_Fields>;
  min?: Maybe<Similar_Trademark_Min_Fields>;
};


/** aggregate fields of "similar_trademark" */
export type Similar_Trademark_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "similar_trademark" */
export type Similar_Trademark_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Similar_Trademark_Max_Order_By>;
  min?: InputMaybe<Similar_Trademark_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Similar_Trademark_Append_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "similar_trademark" */
export type Similar_Trademark_Arr_Rel_Insert_Input = {
  data: Array<Similar_Trademark_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Similar_Trademark_On_Conflict>;
};

/** Boolean expression to filter rows from the table "similar_trademark". All fields are combined with a logical 'AND'. */
export type Similar_Trademark_Bool_Exp = {
  _and?: InputMaybe<Array<Similar_Trademark_Bool_Exp>>;
  _not?: InputMaybe<Similar_Trademark_Bool_Exp>;
  _or?: InputMaybe<Array<Similar_Trademark_Bool_Exp>>;
  competitor?: InputMaybe<String_Comparison_Exp>;
  competitor_website?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  similarity?: InputMaybe<String_Comparison_Exp>;
  similarity_of_gs?: InputMaybe<String_Comparison_Exp>;
  similarity_of_marks?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  verification_result?: InputMaybe<Verification_Result_Bool_Exp>;
  verification_result_id?: InputMaybe<Uuid_Comparison_Exp>;
  well_known?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "similar_trademark" */
export enum Similar_Trademark_Constraint {
  /** unique or primary key constraint on columns "id" */
  SimilarTrademarkPkey = 'similar_trademark_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Similar_Trademark_Delete_At_Path_Input = {
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Similar_Trademark_Delete_Elem_Input = {
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Similar_Trademark_Delete_Key_Input = {
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "similar_trademark" */
export type Similar_Trademark_Insert_Input = {
  competitor?: InputMaybe<Scalars['String']['input']>;
  competitor_website?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Verification_Result_Obj_Rel_Insert_Input>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Similar_Trademark_Max_Fields = {
  __typename?: 'similar_trademark_max_fields';
  competitor?: Maybe<Scalars['String']['output']>;
  competitor_website?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verification_result_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "similar_trademark" */
export type Similar_Trademark_Max_Order_By = {
  competitor?: InputMaybe<Order_By>;
  competitor_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Similar_Trademark_Min_Fields = {
  __typename?: 'similar_trademark_min_fields';
  competitor?: Maybe<Scalars['String']['output']>;
  competitor_website?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  verification_result_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "similar_trademark" */
export type Similar_Trademark_Min_Order_By = {
  competitor?: InputMaybe<Order_By>;
  competitor_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "similar_trademark" */
export type Similar_Trademark_Mutation_Response = {
  __typename?: 'similar_trademark_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Similar_Trademark>;
};

/** on_conflict condition type for table "similar_trademark" */
export type Similar_Trademark_On_Conflict = {
  constraint: Similar_Trademark_Constraint;
  update_columns?: Array<Similar_Trademark_Update_Column>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};

/** Ordering options when selecting data from "similar_trademark". */
export type Similar_Trademark_Order_By = {
  competitor?: InputMaybe<Order_By>;
  competitor_website?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  verification_result?: InputMaybe<Verification_Result_Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
  well_known?: InputMaybe<Order_By>;
};

/** primary key columns input for table: similar_trademark */
export type Similar_Trademark_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Similar_Trademark_Prepend_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "similar_trademark" */
export enum Similar_Trademark_Select_Column {
  /** column name */
  Competitor = 'competitor',
  /** column name */
  CompetitorWebsite = 'competitor_website',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  SimilarityOfGs = 'similarity_of_gs',
  /** column name */
  SimilarityOfMarks = 'similarity_of_marks',
  /** column name */
  Url = 'url',
  /** column name */
  VerificationResultId = 'verification_result_id',
  /** column name */
  WellKnown = 'well_known'
}

/** select "similar_trademark_aggregate_bool_exp_bool_and_arguments_columns" columns of table "similar_trademark" */
export enum Similar_Trademark_Select_Column_Similar_Trademark_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  WellKnown = 'well_known'
}

/** select "similar_trademark_aggregate_bool_exp_bool_or_arguments_columns" columns of table "similar_trademark" */
export enum Similar_Trademark_Select_Column_Similar_Trademark_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  WellKnown = 'well_known'
}

/** input type for updating data in table "similar_trademark" */
export type Similar_Trademark_Set_Input = {
  competitor?: InputMaybe<Scalars['String']['input']>;
  competitor_website?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "similar_trademark" */
export type Similar_Trademark_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Similar_Trademark_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Similar_Trademark_Stream_Cursor_Value_Input = {
  competitor?: InputMaybe<Scalars['String']['input']>;
  competitor_website?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
  well_known?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "similar_trademark" */
export enum Similar_Trademark_Update_Column {
  /** column name */
  Competitor = 'competitor',
  /** column name */
  CompetitorWebsite = 'competitor_website',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Name = 'name',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  SimilarityOfGs = 'similarity_of_gs',
  /** column name */
  SimilarityOfMarks = 'similarity_of_marks',
  /** column name */
  Url = 'url',
  /** column name */
  VerificationResultId = 'verification_result_id',
  /** column name */
  WellKnown = 'well_known'
}

export type Similar_Trademark_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Similar_Trademark_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Similar_Trademark_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Similar_Trademark_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Similar_Trademark_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Similar_Trademark_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Similar_Trademark_Set_Input>;
  /** filter the rows which have to be updated */
  where: Similar_Trademark_Bool_Exp;
};

/** columns and relationships of "specimen" */
export type Specimen = {
  __typename?: 'specimen';
  /** An object relationship */
  application?: Maybe<Application>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  capture_date?: Maybe<Scalars['date']['output']>;
  class_items: Scalars['jsonb']['output'];
  class_number?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  trademark_class?: Maybe<Trademark_Class>;
  trademark_class_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  uspto_requirements?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "specimen" */
export type SpecimenClass_ItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "specimen" */
export type SpecimenUspto_RequirementsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "specimen" */
export type Specimen_Aggregate = {
  __typename?: 'specimen_aggregate';
  aggregate?: Maybe<Specimen_Aggregate_Fields>;
  nodes: Array<Specimen>;
};

export type Specimen_Aggregate_Bool_Exp = {
  count?: InputMaybe<Specimen_Aggregate_Bool_Exp_Count>;
};

export type Specimen_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Specimen_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Specimen_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "specimen" */
export type Specimen_Aggregate_Fields = {
  __typename?: 'specimen_aggregate_fields';
  avg?: Maybe<Specimen_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Specimen_Max_Fields>;
  min?: Maybe<Specimen_Min_Fields>;
  stddev?: Maybe<Specimen_Stddev_Fields>;
  stddev_pop?: Maybe<Specimen_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Specimen_Stddev_Samp_Fields>;
  sum?: Maybe<Specimen_Sum_Fields>;
  var_pop?: Maybe<Specimen_Var_Pop_Fields>;
  var_samp?: Maybe<Specimen_Var_Samp_Fields>;
  variance?: Maybe<Specimen_Variance_Fields>;
};


/** aggregate fields of "specimen" */
export type Specimen_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Specimen_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "specimen" */
export type Specimen_Aggregate_Order_By = {
  avg?: InputMaybe<Specimen_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Specimen_Max_Order_By>;
  min?: InputMaybe<Specimen_Min_Order_By>;
  stddev?: InputMaybe<Specimen_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Specimen_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Specimen_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Specimen_Sum_Order_By>;
  var_pop?: InputMaybe<Specimen_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Specimen_Var_Samp_Order_By>;
  variance?: InputMaybe<Specimen_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Specimen_Append_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_requirements?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "specimen" */
export type Specimen_Arr_Rel_Insert_Input = {
  data: Array<Specimen_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Specimen_On_Conflict>;
};

/** aggregate avg on columns */
export type Specimen_Avg_Fields = {
  __typename?: 'specimen_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "specimen" */
export type Specimen_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "specimen". All fields are combined with a logical 'AND'. */
export type Specimen_Bool_Exp = {
  _and?: InputMaybe<Array<Specimen_Bool_Exp>>;
  _not?: InputMaybe<Specimen_Bool_Exp>;
  _or?: InputMaybe<Array<Specimen_Bool_Exp>>;
  application?: InputMaybe<Application_Bool_Exp>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  capture_date?: InputMaybe<Date_Comparison_Exp>;
  class_items?: InputMaybe<Jsonb_Comparison_Exp>;
  class_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark_class?: InputMaybe<Trademark_Class_Bool_Exp>;
  trademark_class_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  uspto_requirements?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "specimen" */
export enum Specimen_Constraint {
  /** unique or primary key constraint on columns "id" */
  SpecimenPkey = 'specimen_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Specimen_Delete_At_Path_Input = {
  class_items?: InputMaybe<Array<Scalars['String']['input']>>;
  uspto_requirements?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Specimen_Delete_Elem_Input = {
  class_items?: InputMaybe<Scalars['Int']['input']>;
  uspto_requirements?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Specimen_Delete_Key_Input = {
  class_items?: InputMaybe<Scalars['String']['input']>;
  uspto_requirements?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "specimen" */
export type Specimen_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "specimen" */
export type Specimen_Insert_Input = {
  application?: InputMaybe<Application_Obj_Rel_Insert_Input>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  capture_date?: InputMaybe<Scalars['date']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_class?: InputMaybe<Trademark_Class_Obj_Rel_Insert_Input>;
  trademark_class_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uspto_requirements?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Specimen_Max_Fields = {
  __typename?: 'specimen_max_fields';
  application_id?: Maybe<Scalars['uuid']['output']>;
  capture_date?: Maybe<Scalars['date']['output']>;
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  trademark_class_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "specimen" */
export type Specimen_Max_Order_By = {
  application_id?: InputMaybe<Order_By>;
  capture_date?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_class_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Specimen_Min_Fields = {
  __typename?: 'specimen_min_fields';
  application_id?: Maybe<Scalars['uuid']['output']>;
  capture_date?: Maybe<Scalars['date']['output']>;
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  trademark_class_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "specimen" */
export type Specimen_Min_Order_By = {
  application_id?: InputMaybe<Order_By>;
  capture_date?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_class_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "specimen" */
export type Specimen_Mutation_Response = {
  __typename?: 'specimen_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Specimen>;
};

/** on_conflict condition type for table "specimen" */
export type Specimen_On_Conflict = {
  constraint: Specimen_Constraint;
  update_columns?: Array<Specimen_Update_Column>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};

/** Ordering options when selecting data from "specimen". */
export type Specimen_Order_By = {
  application?: InputMaybe<Application_Order_By>;
  application_id?: InputMaybe<Order_By>;
  capture_date?: InputMaybe<Order_By>;
  class_items?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_class?: InputMaybe<Trademark_Class_Order_By>;
  trademark_class_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  uspto_requirements?: InputMaybe<Order_By>;
};

/** primary key columns input for table: specimen */
export type Specimen_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Specimen_Prepend_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  uspto_requirements?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "specimen" */
export enum Specimen_Select_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  CaptureDate = 'capture_date',
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkClassId = 'trademark_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UsptoRequirements = 'uspto_requirements'
}

/** input type for updating data in table "specimen" */
export type Specimen_Set_Input = {
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  capture_date?: InputMaybe<Scalars['date']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_class_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uspto_requirements?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type Specimen_Stddev_Fields = {
  __typename?: 'specimen_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "specimen" */
export type Specimen_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Specimen_Stddev_Pop_Fields = {
  __typename?: 'specimen_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "specimen" */
export type Specimen_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Specimen_Stddev_Samp_Fields = {
  __typename?: 'specimen_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "specimen" */
export type Specimen_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "specimen" */
export type Specimen_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Specimen_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Specimen_Stream_Cursor_Value_Input = {
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  capture_date?: InputMaybe<Scalars['date']['input']>;
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_class_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uspto_requirements?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Specimen_Sum_Fields = {
  __typename?: 'specimen_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "specimen" */
export type Specimen_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** update columns of table "specimen" */
export enum Specimen_Update_Column {
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  CaptureDate = 'capture_date',
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkClassId = 'trademark_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UsptoRequirements = 'uspto_requirements'
}

export type Specimen_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Specimen_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Specimen_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Specimen_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Specimen_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Specimen_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Specimen_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Specimen_Set_Input>;
  /** filter the rows which have to be updated */
  where: Specimen_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Specimen_Var_Pop_Fields = {
  __typename?: 'specimen_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "specimen" */
export type Specimen_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Specimen_Var_Samp_Fields = {
  __typename?: 'specimen_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "specimen" */
export type Specimen_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Specimen_Variance_Fields = {
  __typename?: 'specimen_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "specimen" */
export type Specimen_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "statistic" */
export type Statistic = {
  __typename?: 'statistic';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/** aggregated selection of "statistic" */
export type Statistic_Aggregate = {
  __typename?: 'statistic_aggregate';
  aggregate?: Maybe<Statistic_Aggregate_Fields>;
  nodes: Array<Statistic>;
};

/** aggregate fields of "statistic" */
export type Statistic_Aggregate_Fields = {
  __typename?: 'statistic_aggregate_fields';
  avg?: Maybe<Statistic_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Statistic_Max_Fields>;
  min?: Maybe<Statistic_Min_Fields>;
  stddev?: Maybe<Statistic_Stddev_Fields>;
  stddev_pop?: Maybe<Statistic_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Statistic_Stddev_Samp_Fields>;
  sum?: Maybe<Statistic_Sum_Fields>;
  var_pop?: Maybe<Statistic_Var_Pop_Fields>;
  var_samp?: Maybe<Statistic_Var_Samp_Fields>;
  variance?: Maybe<Statistic_Variance_Fields>;
};


/** aggregate fields of "statistic" */
export type Statistic_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Statistic_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Statistic_Avg_Fields = {
  __typename?: 'statistic_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "statistic". All fields are combined with a logical 'AND'. */
export type Statistic_Bool_Exp = {
  _and?: InputMaybe<Array<Statistic_Bool_Exp>>;
  _not?: InputMaybe<Statistic_Bool_Exp>;
  _or?: InputMaybe<Array<Statistic_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "statistic" */
export enum Statistic_Constraint {
  /** unique or primary key constraint on columns "id" */
  StatisticPkey = 'statistic_pkey'
}

/** input type for incrementing numeric columns in table "statistic" */
export type Statistic_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "statistic" */
export type Statistic_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Statistic_Max_Fields = {
  __typename?: 'statistic_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Statistic_Min_Fields = {
  __typename?: 'statistic_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "statistic" */
export type Statistic_Mutation_Response = {
  __typename?: 'statistic_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Statistic>;
};

/** on_conflict condition type for table "statistic" */
export type Statistic_On_Conflict = {
  constraint: Statistic_Constraint;
  update_columns?: Array<Statistic_Update_Column>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};

/** Ordering options when selecting data from "statistic". */
export type Statistic_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: statistic */
export type Statistic_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "statistic" */
export enum Statistic_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "statistic" */
export type Statistic_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Statistic_Stddev_Fields = {
  __typename?: 'statistic_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Statistic_Stddev_Pop_Fields = {
  __typename?: 'statistic_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Statistic_Stddev_Samp_Fields = {
  __typename?: 'statistic_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "statistic" */
export type Statistic_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Statistic_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Statistic_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Statistic_Sum_Fields = {
  __typename?: 'statistic_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "statistic" */
export enum Statistic_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Value = 'value'
}

export type Statistic_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Statistic_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Statistic_Set_Input>;
  /** filter the rows which have to be updated */
  where: Statistic_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Statistic_Var_Pop_Fields = {
  __typename?: 'statistic_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Statistic_Var_Samp_Fields = {
  __typename?: 'statistic_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Statistic_Variance_Fields = {
  __typename?: 'statistic_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch aggregated fields from the table: "address" */
  address_aggregate: Address_Aggregate;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** An array relationship */
  ai_gs_items_analysis: Array<Ai_Gs_Items_Analysis>;
  /** An aggregate relationship */
  ai_gs_items_analysis_aggregate: Ai_Gs_Items_Analysis_Aggregate;
  /** fetch data from the table: "ai_gs_items_analysis" using primary key columns */
  ai_gs_items_analysis_by_pk?: Maybe<Ai_Gs_Items_Analysis>;
  /** fetch data from the table in a streaming manner: "ai_gs_items_analysis" */
  ai_gs_items_analysis_stream: Array<Ai_Gs_Items_Analysis>;
  /** fetch data from the table: "application" */
  application: Array<Application>;
  /** fetch aggregated fields from the table: "application" */
  application_aggregate: Application_Aggregate;
  /** fetch data from the table: "application" using primary key columns */
  application_by_pk?: Maybe<Application>;
  /** fetch data from the table: "application_jurisdiction" */
  application_jurisdiction: Array<Application_Jurisdiction>;
  /** fetch aggregated fields from the table: "application_jurisdiction" */
  application_jurisdiction_aggregate: Application_Jurisdiction_Aggregate;
  /** fetch data from the table: "application_jurisdiction" using primary key columns */
  application_jurisdiction_by_pk?: Maybe<Application_Jurisdiction>;
  /** fetch data from the table in a streaming manner: "application_jurisdiction" */
  application_jurisdiction_stream: Array<Application_Jurisdiction>;
  /** fetch data from the table in a streaming manner: "application" */
  application_stream: Array<Application>;
  /** fetch data from the table: "audit_log" */
  audit_log: Array<Audit_Log>;
  /** fetch aggregated fields from the table: "audit_log" */
  audit_log_aggregate: Audit_Log_Aggregate;
  /** fetch data from the table in a streaming manner: "audit_log" */
  audit_log_stream: Array<Audit_Log>;
  /** fetch data from the table: "brand" */
  brand: Array<Brand>;
  /** fetch aggregated fields from the table: "brand" */
  brand_aggregate: Brand_Aggregate;
  /** fetch data from the table: "brand" using primary key columns */
  brand_by_pk?: Maybe<Brand>;
  /** fetch data from the table: "brand_monitoring_task" */
  brand_monitoring_task: Array<Brand_Monitoring_Task>;
  /** fetch aggregated fields from the table: "brand_monitoring_task" */
  brand_monitoring_task_aggregate: Brand_Monitoring_Task_Aggregate;
  /** fetch data from the table: "brand_monitoring_task" using primary key columns */
  brand_monitoring_task_by_pk?: Maybe<Brand_Monitoring_Task>;
  /** fetch data from the table in a streaming manner: "brand_monitoring_task" */
  brand_monitoring_task_stream: Array<Brand_Monitoring_Task>;
  /** fetch data from the table: "brand_monitoring_task_tracking" */
  brand_monitoring_task_tracking: Array<Brand_Monitoring_Task_Tracking>;
  /** fetch aggregated fields from the table: "brand_monitoring_task_tracking" */
  brand_monitoring_task_tracking_aggregate: Brand_Monitoring_Task_Tracking_Aggregate;
  /** fetch data from the table: "brand_monitoring_task_tracking" using primary key columns */
  brand_monitoring_task_tracking_by_pk?: Maybe<Brand_Monitoring_Task_Tracking>;
  /** fetch data from the table: "brand_monitoring_task_tracking_status" */
  brand_monitoring_task_tracking_status: Array<Brand_Monitoring_Task_Tracking_Status>;
  /** fetch aggregated fields from the table: "brand_monitoring_task_tracking_status" */
  brand_monitoring_task_tracking_status_aggregate: Brand_Monitoring_Task_Tracking_Status_Aggregate;
  /** fetch data from the table: "brand_monitoring_task_tracking_status" using primary key columns */
  brand_monitoring_task_tracking_status_by_pk?: Maybe<Brand_Monitoring_Task_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "brand_monitoring_task_tracking_status" */
  brand_monitoring_task_tracking_status_stream: Array<Brand_Monitoring_Task_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "brand_monitoring_task_tracking" */
  brand_monitoring_task_tracking_stream: Array<Brand_Monitoring_Task_Tracking>;
  /** fetch data from the table: "brand_snapshot" */
  brand_snapshot: Array<Brand_Snapshot>;
  /** fetch aggregated fields from the table: "brand_snapshot" */
  brand_snapshot_aggregate: Brand_Snapshot_Aggregate;
  /** fetch data from the table: "brand_snapshot" using primary key columns */
  brand_snapshot_by_pk?: Maybe<Brand_Snapshot>;
  /** fetch data from the table in a streaming manner: "brand_snapshot" */
  brand_snapshot_stream: Array<Brand_Snapshot>;
  /** fetch data from the table in a streaming manner: "brand" */
  brand_stream: Array<Brand>;
  /** fetch data from the table: "brand_subscription" */
  brand_subscription: Array<Brand_Subscription>;
  /** fetch aggregated fields from the table: "brand_subscription" */
  brand_subscription_aggregate: Brand_Subscription_Aggregate;
  /** fetch data from the table: "brand_subscription" using primary key columns */
  brand_subscription_by_pk?: Maybe<Brand_Subscription>;
  /** fetch data from the table: "brand_subscription_payment" */
  brand_subscription_payment: Array<Brand_Subscription_Payment>;
  /** fetch aggregated fields from the table: "brand_subscription_payment" */
  brand_subscription_payment_aggregate: Brand_Subscription_Payment_Aggregate;
  /** fetch data from the table: "brand_subscription_payment" using primary key columns */
  brand_subscription_payment_by_pk?: Maybe<Brand_Subscription_Payment>;
  /** fetch data from the table in a streaming manner: "brand_subscription_payment" */
  brand_subscription_payment_stream: Array<Brand_Subscription_Payment>;
  /** fetch data from the table: "brand_subscription_platform" */
  brand_subscription_platform: Array<Brand_Subscription_Platform>;
  /** fetch aggregated fields from the table: "brand_subscription_platform" */
  brand_subscription_platform_aggregate: Brand_Subscription_Platform_Aggregate;
  /** fetch data from the table: "brand_subscription_platform" using primary key columns */
  brand_subscription_platform_by_pk?: Maybe<Brand_Subscription_Platform>;
  /** fetch data from the table in a streaming manner: "brand_subscription_platform" */
  brand_subscription_platform_stream: Array<Brand_Subscription_Platform>;
  /** fetch data from the table in a streaming manner: "brand_subscription" */
  brand_subscription_stream: Array<Brand_Subscription>;
  /** fetch data from the table: "brand_subscription_tracking" */
  brand_subscription_tracking: Array<Brand_Subscription_Tracking>;
  /** fetch aggregated fields from the table: "brand_subscription_tracking" */
  brand_subscription_tracking_aggregate: Brand_Subscription_Tracking_Aggregate;
  /** fetch data from the table: "brand_subscription_tracking" using primary key columns */
  brand_subscription_tracking_by_pk?: Maybe<Brand_Subscription_Tracking>;
  /** fetch data from the table: "brand_subscription_tracking_status" */
  brand_subscription_tracking_status: Array<Brand_Subscription_Tracking_Status>;
  /** fetch aggregated fields from the table: "brand_subscription_tracking_status" */
  brand_subscription_tracking_status_aggregate: Brand_Subscription_Tracking_Status_Aggregate;
  /** fetch data from the table: "brand_subscription_tracking_status" using primary key columns */
  brand_subscription_tracking_status_by_pk?: Maybe<Brand_Subscription_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "brand_subscription_tracking_status" */
  brand_subscription_tracking_status_stream: Array<Brand_Subscription_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "brand_subscription_tracking" */
  brand_subscription_tracking_stream: Array<Brand_Subscription_Tracking>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table: "case_counterparty" */
  case_counterparty: Array<Case_Counterparty>;
  /** fetch aggregated fields from the table: "case_counterparty" */
  case_counterparty_aggregate: Case_Counterparty_Aggregate;
  /** fetch data from the table: "case_counterparty" using primary key columns */
  case_counterparty_by_pk?: Maybe<Case_Counterparty>;
  /** fetch data from the table in a streaming manner: "case_counterparty" */
  case_counterparty_stream: Array<Case_Counterparty>;
  /** fetch data from the table: "case_infringement" */
  case_infringement: Array<Case_Infringement>;
  /** fetch aggregated fields from the table: "case_infringement" */
  case_infringement_aggregate: Case_Infringement_Aggregate;
  /** fetch data from the table: "case_infringement" using primary key columns */
  case_infringement_by_pk?: Maybe<Case_Infringement>;
  /** fetch data from the table: "case_infringement_evidence" */
  case_infringement_evidence: Array<Case_Infringement_Evidence>;
  /** fetch aggregated fields from the table: "case_infringement_evidence" */
  case_infringement_evidence_aggregate: Case_Infringement_Evidence_Aggregate;
  /** fetch data from the table: "case_infringement_evidence" using primary key columns */
  case_infringement_evidence_by_pk?: Maybe<Case_Infringement_Evidence>;
  /** fetch data from the table in a streaming manner: "case_infringement_evidence" */
  case_infringement_evidence_stream: Array<Case_Infringement_Evidence>;
  /** fetch data from the table in a streaming manner: "case_infringement" */
  case_infringement_stream: Array<Case_Infringement>;
  /** fetch data from the table: "case_request" */
  case_request: Array<Case_Request>;
  /** fetch aggregated fields from the table: "case_request" */
  case_request_aggregate: Case_Request_Aggregate;
  /** fetch data from the table: "case_request" using primary key columns */
  case_request_by_pk?: Maybe<Case_Request>;
  /** fetch data from the table in a streaming manner: "case_request" */
  case_request_stream: Array<Case_Request>;
  /** fetch data from the table: "case_request_tracking" */
  case_request_tracking: Array<Case_Request_Tracking>;
  /** fetch aggregated fields from the table: "case_request_tracking" */
  case_request_tracking_aggregate: Case_Request_Tracking_Aggregate;
  /** fetch data from the table: "case_request_tracking" using primary key columns */
  case_request_tracking_by_pk?: Maybe<Case_Request_Tracking>;
  /** fetch data from the table: "case_request_tracking_status" */
  case_request_tracking_status: Array<Case_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "case_request_tracking_status" */
  case_request_tracking_status_aggregate: Case_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "case_request_tracking_status" using primary key columns */
  case_request_tracking_status_by_pk?: Maybe<Case_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "case_request_tracking_status" */
  case_request_tracking_status_stream: Array<Case_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "case_request_tracking" */
  case_request_tracking_stream: Array<Case_Request_Tracking>;
  /** fetch data from the table: "case_solution" */
  case_solution: Array<Case_Solution>;
  /** fetch aggregated fields from the table: "case_solution" */
  case_solution_aggregate: Case_Solution_Aggregate;
  /** fetch data from the table: "case_solution" using primary key columns */
  case_solution_by_pk?: Maybe<Case_Solution>;
  /** fetch data from the table in a streaming manner: "case_solution" */
  case_solution_stream: Array<Case_Solution>;
  /** fetch data from the table in a streaming manner: "case" */
  case_stream: Array<Case>;
  /** fetch data from the table: "case_tracking" */
  case_tracking: Array<Case_Tracking>;
  /** fetch aggregated fields from the table: "case_tracking" */
  case_tracking_aggregate: Case_Tracking_Aggregate;
  /** fetch data from the table: "case_tracking" using primary key columns */
  case_tracking_by_pk?: Maybe<Case_Tracking>;
  /** fetch data from the table: "case_tracking_status" */
  case_tracking_status: Array<Case_Tracking_Status>;
  /** fetch aggregated fields from the table: "case_tracking_status" */
  case_tracking_status_aggregate: Case_Tracking_Status_Aggregate;
  /** fetch data from the table: "case_tracking_status" using primary key columns */
  case_tracking_status_by_pk?: Maybe<Case_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "case_tracking_status" */
  case_tracking_status_stream: Array<Case_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "case_tracking" */
  case_tracking_stream: Array<Case_Tracking>;
  /** fetch data from the table: "consultation" */
  consultation: Array<Consultation>;
  /** fetch aggregated fields from the table: "consultation" */
  consultation_aggregate: Consultation_Aggregate;
  /** fetch data from the table: "consultation" using primary key columns */
  consultation_by_pk?: Maybe<Consultation>;
  /** fetch data from the table in a streaming manner: "consultation" */
  consultation_stream: Array<Consultation>;
  /** fetch data from the table: "contentful" */
  contentful: Array<Contentful>;
  /** fetch aggregated fields from the table: "contentful" */
  contentful_aggregate: Contentful_Aggregate;
  /** fetch data from the table: "contentful" using primary key columns */
  contentful_by_pk?: Maybe<Contentful>;
  /** fetch data from the table in a streaming manner: "contentful" */
  contentful_stream: Array<Contentful>;
  /** fetch data from the table: "credit_note" */
  credit_note: Array<Credit_Note>;
  /** fetch aggregated fields from the table: "credit_note" */
  credit_note_aggregate: Credit_Note_Aggregate;
  /** fetch data from the table: "credit_note" using primary key columns */
  credit_note_by_pk?: Maybe<Credit_Note>;
  /** fetch data from the table in a streaming manner: "credit_note" */
  credit_note_stream: Array<Credit_Note>;
  /** fetch data from the table: "discount_coupon" */
  discount_coupon: Array<Discount_Coupon>;
  /** fetch aggregated fields from the table: "discount_coupon" */
  discount_coupon_aggregate: Discount_Coupon_Aggregate;
  /** fetch data from the table: "discount_coupon" using primary key columns */
  discount_coupon_by_pk?: Maybe<Discount_Coupon>;
  /** fetch data from the table in a streaming manner: "discount_coupon" */
  discount_coupon_stream: Array<Discount_Coupon>;
  /** fetch data from the table: "docketed_message" */
  docketed_message: Array<Docketed_Message>;
  /** fetch aggregated fields from the table: "docketed_message" */
  docketed_message_aggregate: Docketed_Message_Aggregate;
  /** fetch data from the table: "docketed_message" using primary key columns */
  docketed_message_by_pk?: Maybe<Docketed_Message>;
  /** fetch data from the table in a streaming manner: "docketed_message" */
  docketed_message_stream: Array<Docketed_Message>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk?: Maybe<Document>;
  /** fetch data from the table: "document_folder" */
  document_folder: Array<Document_Folder>;
  /** fetch aggregated fields from the table: "document_folder" */
  document_folder_aggregate: Document_Folder_Aggregate;
  /** fetch data from the table: "document_folder" using primary key columns */
  document_folder_by_pk?: Maybe<Document_Folder>;
  /** fetch data from the table in a streaming manner: "document_folder" */
  document_folder_stream: Array<Document_Folder>;
  /** fetch data from the table: "document_hub" */
  document_hub: Array<Document_Hub>;
  /** fetch aggregated fields from the table: "document_hub" */
  document_hub_aggregate: Document_Hub_Aggregate;
  /** fetch data from the table: "document_hub" using primary key columns */
  document_hub_by_pk?: Maybe<Document_Hub>;
  /** fetch data from the table in a streaming manner: "document_hub" */
  document_hub_stream: Array<Document_Hub>;
  /** fetch data from the table in a streaming manner: "document" */
  document_stream: Array<Document>;
  /** An array relationship */
  entity: Array<Entity>;
  /** An aggregate relationship */
  entity_aggregate: Entity_Aggregate;
  /** fetch data from the table: "entity" using primary key columns */
  entity_by_pk?: Maybe<Entity>;
  /** fetch data from the table in a streaming manner: "entity" */
  entity_stream: Array<Entity>;
  /** fetch data from the table: "exchange_rate" */
  exchange_rate: Array<Exchange_Rate>;
  /** fetch aggregated fields from the table: "exchange_rate" */
  exchange_rate_aggregate: Exchange_Rate_Aggregate;
  /** fetch data from the table: "exchange_rate" using primary key columns */
  exchange_rate_by_pk?: Maybe<Exchange_Rate>;
  /** fetch data from the table in a streaming manner: "exchange_rate" */
  exchange_rate_stream: Array<Exchange_Rate>;
  /** fetch data from the table: "external_trademark" */
  external_trademark: Array<External_Trademark>;
  /** fetch aggregated fields from the table: "external_trademark" */
  external_trademark_aggregate: External_Trademark_Aggregate;
  /** fetch data from the table: "external_trademark" using primary key columns */
  external_trademark_by_pk?: Maybe<External_Trademark>;
  /** fetch data from the table in a streaming manner: "external_trademark" */
  external_trademark_stream: Array<External_Trademark>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "note" */
  note: Array<Note>;
  /** fetch aggregated fields from the table: "note" */
  note_aggregate: Note_Aggregate;
  /** fetch data from the table: "note" using primary key columns */
  note_by_pk?: Maybe<Note>;
  /** fetch data from the table: "note_hub" */
  note_hub: Array<Note_Hub>;
  /** fetch aggregated fields from the table: "note_hub" */
  note_hub_aggregate: Note_Hub_Aggregate;
  /** fetch data from the table: "note_hub" using primary key columns */
  note_hub_by_pk?: Maybe<Note_Hub>;
  /** fetch data from the table in a streaming manner: "note_hub" */
  note_hub_stream: Array<Note_Hub>;
  /** fetch data from the table in a streaming manner: "note" */
  note_stream: Array<Note>;
  /** fetch data from the table: "notification" */
  notification: Array<Notification>;
  /** fetch aggregated fields from the table: "notification" */
  notification_aggregate: Notification_Aggregate;
  /** fetch data from the table: "notification" using primary key columns */
  notification_by_pk?: Maybe<Notification>;
  /** fetch data from the table in a streaming manner: "notification" */
  notification_stream: Array<Notification>;
  /** fetch data from the table: "office_action" */
  office_action: Array<Office_Action>;
  /** fetch aggregated fields from the table: "office_action" */
  office_action_aggregate: Office_Action_Aggregate;
  /** fetch data from the table: "office_action" using primary key columns */
  office_action_by_pk?: Maybe<Office_Action>;
  /** fetch data from the table: "office_action_issue" */
  office_action_issue: Array<Office_Action_Issue>;
  /** fetch aggregated fields from the table: "office_action_issue" */
  office_action_issue_aggregate: Office_Action_Issue_Aggregate;
  /** fetch data from the table: "office_action_issue" using primary key columns */
  office_action_issue_by_pk?: Maybe<Office_Action_Issue>;
  /** fetch data from the table in a streaming manner: "office_action_issue" */
  office_action_issue_stream: Array<Office_Action_Issue>;
  /** An array relationship */
  office_action_similar_trademark_map: Array<Office_Action_Similar_Trademark_Map>;
  /** An aggregate relationship */
  office_action_similar_trademark_map_aggregate: Office_Action_Similar_Trademark_Map_Aggregate;
  /** fetch data from the table: "office_action_similar_trademark_map" using primary key columns */
  office_action_similar_trademark_map_by_pk?: Maybe<Office_Action_Similar_Trademark_Map>;
  /** fetch data from the table in a streaming manner: "office_action_similar_trademark_map" */
  office_action_similar_trademark_map_stream: Array<Office_Action_Similar_Trademark_Map>;
  /** fetch data from the table: "office_action_solution" */
  office_action_solution: Array<Office_Action_Solution>;
  /** fetch aggregated fields from the table: "office_action_solution" */
  office_action_solution_aggregate: Office_Action_Solution_Aggregate;
  /** fetch data from the table: "office_action_solution" using primary key columns */
  office_action_solution_by_pk?: Maybe<Office_Action_Solution>;
  /** fetch data from the table in a streaming manner: "office_action_solution" */
  office_action_solution_stream: Array<Office_Action_Solution>;
  /** fetch data from the table in a streaming manner: "office_action" */
  office_action_stream: Array<Office_Action>;
  /** fetch data from the table: "office_action_tracking" */
  office_action_tracking: Array<Office_Action_Tracking>;
  /** fetch aggregated fields from the table: "office_action_tracking" */
  office_action_tracking_aggregate: Office_Action_Tracking_Aggregate;
  /** fetch data from the table: "office_action_tracking" using primary key columns */
  office_action_tracking_by_pk?: Maybe<Office_Action_Tracking>;
  /** fetch data from the table: "office_action_tracking_status" */
  office_action_tracking_status: Array<Office_Action_Tracking_Status>;
  /** fetch aggregated fields from the table: "office_action_tracking_status" */
  office_action_tracking_status_aggregate: Office_Action_Tracking_Status_Aggregate;
  /** fetch data from the table: "office_action_tracking_status" using primary key columns */
  office_action_tracking_status_by_pk?: Maybe<Office_Action_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "office_action_tracking_status" */
  office_action_tracking_status_stream: Array<Office_Action_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "office_action_tracking" */
  office_action_tracking_stream: Array<Office_Action_Tracking>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_hub" */
  order_hub: Array<Order_Hub>;
  /** fetch aggregated fields from the table: "order_hub" */
  order_hub_aggregate: Order_Hub_Aggregate;
  /** fetch data from the table: "order_hub" using primary key columns */
  order_hub_by_pk?: Maybe<Order_Hub>;
  /** fetch data from the table in a streaming manner: "order_hub" */
  order_hub_stream: Array<Order_Hub>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "order_tracking" */
  order_tracking: Array<Order_Tracking>;
  /** fetch aggregated fields from the table: "order_tracking" */
  order_tracking_aggregate: Order_Tracking_Aggregate;
  /** fetch data from the table: "order_tracking" using primary key columns */
  order_tracking_by_pk?: Maybe<Order_Tracking>;
  /** fetch data from the table: "order_tracking_status" */
  order_tracking_status: Array<Order_Tracking_Status>;
  /** fetch aggregated fields from the table: "order_tracking_status" */
  order_tracking_status_aggregate: Order_Tracking_Status_Aggregate;
  /** fetch data from the table: "order_tracking_status" using primary key columns */
  order_tracking_status_by_pk?: Maybe<Order_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "order_tracking_status" */
  order_tracking_status_stream: Array<Order_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "order_tracking" */
  order_tracking_stream: Array<Order_Tracking>;
  paid_orders_summary_last_30_days: Array<Paid_Orders_Summary_Last_30_Days>;
  paid_orders_summary_last_30_days_count: Array<Aggregate_Count>;
  /** fetch data from the table: "poa" */
  poa: Array<Poa>;
  /** fetch aggregated fields from the table: "poa" */
  poa_aggregate: Poa_Aggregate;
  /** fetch data from the table: "poa" using primary key columns */
  poa_by_pk?: Maybe<Poa>;
  /** fetch data from the table in a streaming manner: "poa" */
  poa_stream: Array<Poa>;
  /** fetch data from the table: "price" */
  price: Array<Price>;
  /** fetch aggregated fields from the table: "price" */
  price_aggregate: Price_Aggregate;
  /** fetch data from the table: "price" using primary key columns */
  price_by_pk?: Maybe<Price>;
  /** fetch data from the table: "price_rule" */
  price_rule: Array<Price_Rule>;
  /** fetch aggregated fields from the table: "price_rule" */
  price_rule_aggregate: Price_Rule_Aggregate;
  /** fetch data from the table: "price_rule" using primary key columns */
  price_rule_by_pk?: Maybe<Price_Rule>;
  /** fetch data from the table in a streaming manner: "price_rule" */
  price_rule_stream: Array<Price_Rule>;
  /** fetch data from the table in a streaming manner: "price" */
  price_stream: Array<Price>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product_bundle" */
  product_bundle: Array<Product_Bundle>;
  /** fetch aggregated fields from the table: "product_bundle" */
  product_bundle_aggregate: Product_Bundle_Aggregate;
  /** fetch data from the table: "product_bundle" using primary key columns */
  product_bundle_by_pk?: Maybe<Product_Bundle>;
  /** fetch data from the table in a streaming manner: "product_bundle" */
  product_bundle_stream: Array<Product_Bundle>;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "product_event" */
  product_event: Array<Product_Event>;
  /** fetch aggregated fields from the table: "product_event" */
  product_event_aggregate: Product_Event_Aggregate;
  /** fetch data from the table: "product_event" using primary key columns */
  product_event_by_pk?: Maybe<Product_Event>;
  /** fetch data from the table in a streaming manner: "product_event" */
  product_event_stream: Array<Product_Event>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "product_v2" */
  product_v2: Array<Product_V2>;
  /** fetch aggregated fields from the table: "product_v2" */
  product_v2_aggregate: Product_V2_Aggregate;
  /** fetch data from the table: "product_v2" using primary key columns */
  product_v2_by_pk?: Maybe<Product_V2>;
  /** fetch data from the table in a streaming manner: "product_v2" */
  product_v2_stream: Array<Product_V2>;
  /** fetch data from the table: "quote" */
  quote: Array<Quote>;
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate;
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>;
  /** fetch data from the table: "quote_hub" */
  quote_hub: Array<Quote_Hub>;
  /** fetch aggregated fields from the table: "quote_hub" */
  quote_hub_aggregate: Quote_Hub_Aggregate;
  /** fetch data from the table: "quote_hub" using primary key columns */
  quote_hub_by_pk?: Maybe<Quote_Hub>;
  /** fetch data from the table in a streaming manner: "quote_hub" */
  quote_hub_stream: Array<Quote_Hub>;
  /** fetch data from the table: "quote_item" */
  quote_item: Array<Quote_Item>;
  /** fetch aggregated fields from the table: "quote_item" */
  quote_item_aggregate: Quote_Item_Aggregate;
  /** fetch data from the table: "quote_item" using primary key columns */
  quote_item_by_pk?: Maybe<Quote_Item>;
  /** fetch data from the table in a streaming manner: "quote_item" */
  quote_item_stream: Array<Quote_Item>;
  /** fetch data from the table in a streaming manner: "quote" */
  quote_stream: Array<Quote>;
  recent_applications_sent_to_client: Array<Recent_Applications_Sent_To_Client>;
  /** fetch data from the table: "refund_request" */
  refund_request: Array<Refund_Request>;
  /** fetch aggregated fields from the table: "refund_request" */
  refund_request_aggregate: Refund_Request_Aggregate;
  /** fetch data from the table: "refund_request" using primary key columns */
  refund_request_by_pk?: Maybe<Refund_Request>;
  /** fetch data from the table: "refund_request_invoice" */
  refund_request_invoice: Array<Refund_Request_Invoice>;
  /** fetch aggregated fields from the table: "refund_request_invoice" */
  refund_request_invoice_aggregate: Refund_Request_Invoice_Aggregate;
  /** fetch data from the table: "refund_request_invoice" using primary key columns */
  refund_request_invoice_by_pk?: Maybe<Refund_Request_Invoice>;
  /** fetch data from the table in a streaming manner: "refund_request_invoice" */
  refund_request_invoice_stream: Array<Refund_Request_Invoice>;
  /** fetch data from the table in a streaming manner: "refund_request" */
  refund_request_stream: Array<Refund_Request>;
  /** fetch data from the table: "refund_request_tracking" */
  refund_request_tracking: Array<Refund_Request_Tracking>;
  /** fetch aggregated fields from the table: "refund_request_tracking" */
  refund_request_tracking_aggregate: Refund_Request_Tracking_Aggregate;
  /** fetch data from the table: "refund_request_tracking" using primary key columns */
  refund_request_tracking_by_pk?: Maybe<Refund_Request_Tracking>;
  /** fetch data from the table: "refund_request_tracking_status" */
  refund_request_tracking_status: Array<Refund_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "refund_request_tracking_status" */
  refund_request_tracking_status_aggregate: Refund_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "refund_request_tracking_status" using primary key columns */
  refund_request_tracking_status_by_pk?: Maybe<Refund_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "refund_request_tracking_status" */
  refund_request_tracking_status_stream: Array<Refund_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "refund_request_tracking" */
  refund_request_tracking_stream: Array<Refund_Request_Tracking>;
  /** fetch data from the table: "registration_request" */
  registration_request: Array<Registration_Request>;
  /** fetch aggregated fields from the table: "registration_request" */
  registration_request_aggregate: Registration_Request_Aggregate;
  /** fetch data from the table: "registration_request" using primary key columns */
  registration_request_by_pk?: Maybe<Registration_Request>;
  registration_request_recently_dismissed: Array<Registration_Request_Recently_Dismissed>;
  registration_request_recently_dismissed_count: Array<Aggregate_Count>;
  /** fetch data from the table in a streaming manner: "registration_request" */
  registration_request_stream: Array<Registration_Request>;
  /** fetch data from the table: "registration_request_tracking" */
  registration_request_tracking: Array<Registration_Request_Tracking>;
  /** fetch aggregated fields from the table: "registration_request_tracking" */
  registration_request_tracking_aggregate: Registration_Request_Tracking_Aggregate;
  /** fetch data from the table: "registration_request_tracking" using primary key columns */
  registration_request_tracking_by_pk?: Maybe<Registration_Request_Tracking>;
  /** fetch data from the table: "registration_request_tracking_status" */
  registration_request_tracking_status: Array<Registration_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "registration_request_tracking_status" */
  registration_request_tracking_status_aggregate: Registration_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "registration_request_tracking_status" using primary key columns */
  registration_request_tracking_status_by_pk?: Maybe<Registration_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "registration_request_tracking_status" */
  registration_request_tracking_status_stream: Array<Registration_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "registration_request_tracking" */
  registration_request_tracking_stream: Array<Registration_Request_Tracking>;
  /** fetch data from the table: "reminder" */
  reminder: Array<Reminder>;
  /** fetch aggregated fields from the table: "reminder" */
  reminder_aggregate: Reminder_Aggregate;
  /** fetch data from the table: "reminder" using primary key columns */
  reminder_by_pk?: Maybe<Reminder>;
  /** fetch data from the table in a streaming manner: "reminder" */
  reminder_stream: Array<Reminder>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch aggregated fields from the table: "service" */
  service_aggregate: Service_Aggregate;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk?: Maybe<Service>;
  /** fetch data from the table: "service_request" */
  service_request: Array<Service_Request>;
  /** fetch aggregated fields from the table: "service_request" */
  service_request_aggregate: Service_Request_Aggregate;
  /** fetch data from the table: "service_request" using primary key columns */
  service_request_by_pk?: Maybe<Service_Request>;
  /** fetch data from the table in a streaming manner: "service_request" */
  service_request_stream: Array<Service_Request>;
  /** fetch data from the table: "service_request_tracking" */
  service_request_tracking: Array<Service_Request_Tracking>;
  /** fetch aggregated fields from the table: "service_request_tracking" */
  service_request_tracking_aggregate: Service_Request_Tracking_Aggregate;
  /** fetch data from the table: "service_request_tracking" using primary key columns */
  service_request_tracking_by_pk?: Maybe<Service_Request_Tracking>;
  /** fetch data from the table: "service_request_tracking_status" */
  service_request_tracking_status: Array<Service_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "service_request_tracking_status" */
  service_request_tracking_status_aggregate: Service_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "service_request_tracking_status" using primary key columns */
  service_request_tracking_status_by_pk?: Maybe<Service_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "service_request_tracking_status" */
  service_request_tracking_status_stream: Array<Service_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "service_request_tracking" */
  service_request_tracking_stream: Array<Service_Request_Tracking>;
  /** fetch data from the table in a streaming manner: "service" */
  service_stream: Array<Service>;
  /** fetch data from the table: "service_tracking" */
  service_tracking: Array<Service_Tracking>;
  /** fetch aggregated fields from the table: "service_tracking" */
  service_tracking_aggregate: Service_Tracking_Aggregate;
  /** fetch data from the table: "service_tracking" using primary key columns */
  service_tracking_by_pk?: Maybe<Service_Tracking>;
  /** fetch data from the table: "service_tracking_status" */
  service_tracking_status: Array<Service_Tracking_Status>;
  /** fetch aggregated fields from the table: "service_tracking_status" */
  service_tracking_status_aggregate: Service_Tracking_Status_Aggregate;
  /** fetch data from the table: "service_tracking_status" using primary key columns */
  service_tracking_status_by_pk?: Maybe<Service_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "service_tracking_status" */
  service_tracking_status_stream: Array<Service_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "service_tracking" */
  service_tracking_stream: Array<Service_Tracking>;
  /** fetch data from the table: "similar_trademark" */
  similar_trademark: Array<Similar_Trademark>;
  /** fetch aggregated fields from the table: "similar_trademark" */
  similar_trademark_aggregate: Similar_Trademark_Aggregate;
  /** fetch data from the table: "similar_trademark" using primary key columns */
  similar_trademark_by_pk?: Maybe<Similar_Trademark>;
  /** fetch data from the table in a streaming manner: "similar_trademark" */
  similar_trademark_stream: Array<Similar_Trademark>;
  /** fetch data from the table: "specimen" */
  specimen: Array<Specimen>;
  /** fetch aggregated fields from the table: "specimen" */
  specimen_aggregate: Specimen_Aggregate;
  /** fetch data from the table: "specimen" using primary key columns */
  specimen_by_pk?: Maybe<Specimen>;
  /** fetch data from the table in a streaming manner: "specimen" */
  specimen_stream: Array<Specimen>;
  /** fetch data from the table: "statistic" */
  statistic: Array<Statistic>;
  /** fetch aggregated fields from the table: "statistic" */
  statistic_aggregate: Statistic_Aggregate;
  /** fetch data from the table: "statistic" using primary key columns */
  statistic_by_pk?: Maybe<Statistic>;
  /** fetch data from the table in a streaming manner: "statistic" */
  statistic_stream: Array<Statistic>;
  /** fetch data from the table: "support_ticket" */
  support_ticket: Array<Support_Ticket>;
  /** fetch aggregated fields from the table: "support_ticket" */
  support_ticket_aggregate: Support_Ticket_Aggregate;
  /** fetch data from the table: "support_ticket" using primary key columns */
  support_ticket_by_pk?: Maybe<Support_Ticket>;
  /** fetch data from the table in a streaming manner: "support_ticket" */
  support_ticket_stream: Array<Support_Ticket>;
  /** fetch data from the table: "task" */
  task: Array<Task>;
  /** fetch aggregated fields from the table: "task" */
  task_aggregate: Task_Aggregate;
  /** fetch data from the table: "task" using primary key columns */
  task_by_pk?: Maybe<Task>;
  /** fetch data from the table in a streaming manner: "task" */
  task_stream: Array<Task>;
  /** fetch data from the table: "thread_comment" */
  thread_comment: Array<Thread_Comment>;
  /** fetch aggregated fields from the table: "thread_comment" */
  thread_comment_aggregate: Thread_Comment_Aggregate;
  /** fetch data from the table: "thread_comment" using primary key columns */
  thread_comment_by_pk?: Maybe<Thread_Comment>;
  /** fetch data from the table in a streaming manner: "thread_comment" */
  thread_comment_stream: Array<Thread_Comment>;
  /** fetch data from the table: "trademark" */
  trademark: Array<Trademark>;
  /** fetch aggregated fields from the table: "trademark" */
  trademark_aggregate: Trademark_Aggregate;
  trademark_audit_log: Array<Trademark_Audit_Log>;
  trademark_audit_log_count: Array<Aggregate_Count>;
  /** fetch data from the table: "trademark" using primary key columns */
  trademark_by_pk?: Maybe<Trademark>;
  /** fetch data from the table: "trademark_class" */
  trademark_class: Array<Trademark_Class>;
  /** fetch aggregated fields from the table: "trademark_class" */
  trademark_class_aggregate: Trademark_Class_Aggregate;
  /** fetch data from the table: "trademark_class" using primary key columns */
  trademark_class_by_pk?: Maybe<Trademark_Class>;
  /** fetch data from the table in a streaming manner: "trademark_class" */
  trademark_class_stream: Array<Trademark_Class>;
  /** fetch data from the table: "trademark_ipo_data" */
  trademark_ipo_data: Array<Trademark_Ipo_Data>;
  /** fetch aggregated fields from the table: "trademark_ipo_data" */
  trademark_ipo_data_aggregate: Trademark_Ipo_Data_Aggregate;
  /** fetch data from the table: "trademark_ipo_data" using primary key columns */
  trademark_ipo_data_by_pk?: Maybe<Trademark_Ipo_Data>;
  /** fetch data from the table in a streaming manner: "trademark_ipo_data" */
  trademark_ipo_data_stream: Array<Trademark_Ipo_Data>;
  /** An array relationship */
  trademark_monitoring_result: Array<Trademark_Monitoring_Result>;
  /** An aggregate relationship */
  trademark_monitoring_result_aggregate: Trademark_Monitoring_Result_Aggregate;
  /** fetch data from the table: "trademark_monitoring_result" using primary key columns */
  trademark_monitoring_result_by_pk?: Maybe<Trademark_Monitoring_Result>;
  /** fetch data from the table in a streaming manner: "trademark_monitoring_result" */
  trademark_monitoring_result_stream: Array<Trademark_Monitoring_Result>;
  trademark_portfolio_search: Array<Trademark_Portfolio_Search_Result>;
  trademark_portfolio_search_count: Array<Aggregate_Count>;
  /** fetch data from the table: "trademark_rate_limit_log" */
  trademark_rate_limit_log: Array<Trademark_Rate_Limit_Log>;
  /** fetch aggregated fields from the table: "trademark_rate_limit_log" */
  trademark_rate_limit_log_aggregate: Trademark_Rate_Limit_Log_Aggregate;
  /** fetch data from the table: "trademark_rate_limit_log" using primary key columns */
  trademark_rate_limit_log_by_pk?: Maybe<Trademark_Rate_Limit_Log>;
  /** fetch data from the table in a streaming manner: "trademark_rate_limit_log" */
  trademark_rate_limit_log_stream: Array<Trademark_Rate_Limit_Log>;
  /** fetch data from the table: "trademark_request" */
  trademark_request: Array<Trademark_Request>;
  /** fetch aggregated fields from the table: "trademark_request" */
  trademark_request_aggregate: Trademark_Request_Aggregate;
  /** fetch data from the table: "trademark_request" using primary key columns */
  trademark_request_by_pk?: Maybe<Trademark_Request>;
  /** fetch data from the table in a streaming manner: "trademark_request" */
  trademark_request_stream: Array<Trademark_Request>;
  trademark_search: Array<Trademark_Search_Result>;
  /** An array relationship */
  trademark_service_requests: Array<Trademark_Service_Requests>;
  /** An aggregate relationship */
  trademark_service_requests_aggregate: Trademark_Service_Requests_Aggregate;
  /** fetch data from the table: "trademark_service_requests" using primary key columns */
  trademark_service_requests_by_pk?: Maybe<Trademark_Service_Requests>;
  /** fetch data from the table in a streaming manner: "trademark_service_requests" */
  trademark_service_requests_stream: Array<Trademark_Service_Requests>;
  /** An array relationship */
  trademark_shared_documents: Array<Trademark_Shared_Documents>;
  /** An aggregate relationship */
  trademark_shared_documents_aggregate: Trademark_Shared_Documents_Aggregate;
  /** fetch data from the table: "trademark_shared_documents" using primary key columns */
  trademark_shared_documents_by_pk?: Maybe<Trademark_Shared_Documents>;
  /** fetch data from the table in a streaming manner: "trademark_shared_documents" */
  trademark_shared_documents_stream: Array<Trademark_Shared_Documents>;
  /** fetch data from the table in a streaming manner: "trademark" */
  trademark_stream: Array<Trademark>;
  /** fetch data from the table: "trademark_tracking" */
  trademark_tracking: Array<Trademark_Tracking>;
  /** fetch aggregated fields from the table: "trademark_tracking" */
  trademark_tracking_aggregate: Trademark_Tracking_Aggregate;
  /** fetch data from the table: "trademark_tracking" using primary key columns */
  trademark_tracking_by_pk?: Maybe<Trademark_Tracking>;
  /** fetch data from the table: "trademark_tracking_status" */
  trademark_tracking_status: Array<Trademark_Tracking_Status>;
  /** fetch aggregated fields from the table: "trademark_tracking_status" */
  trademark_tracking_status_aggregate: Trademark_Tracking_Status_Aggregate;
  /** fetch data from the table: "trademark_tracking_status" using primary key columns */
  trademark_tracking_status_by_pk?: Maybe<Trademark_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "trademark_tracking_status" */
  trademark_tracking_status_stream: Array<Trademark_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "trademark_tracking" */
  trademark_tracking_stream: Array<Trademark_Tracking>;
  /** An array relationship */
  trademark_watch_subscription: Array<Trademark_Watch_Subscription>;
  /** An aggregate relationship */
  trademark_watch_subscription_aggregate: Trademark_Watch_Subscription_Aggregate;
  /** fetch data from the table: "trademark_watch_subscription" using primary key columns */
  trademark_watch_subscription_by_pk?: Maybe<Trademark_Watch_Subscription>;
  /** fetch data from the table in a streaming manner: "trademark_watch_subscription" */
  trademark_watch_subscription_stream: Array<Trademark_Watch_Subscription>;
  /** fetch data from the table: "use_in_commerce_request" */
  use_in_commerce_request: Array<Use_In_Commerce_Request>;
  /** fetch aggregated fields from the table: "use_in_commerce_request" */
  use_in_commerce_request_aggregate: Use_In_Commerce_Request_Aggregate;
  /** fetch data from the table: "use_in_commerce_request" using primary key columns */
  use_in_commerce_request_by_pk?: Maybe<Use_In_Commerce_Request>;
  /** fetch data from the table in a streaming manner: "use_in_commerce_request" */
  use_in_commerce_request_stream: Array<Use_In_Commerce_Request>;
  /** fetch data from the table: "use_in_commerce_request_tracking" */
  use_in_commerce_request_tracking: Array<Use_In_Commerce_Request_Tracking>;
  /** fetch aggregated fields from the table: "use_in_commerce_request_tracking" */
  use_in_commerce_request_tracking_aggregate: Use_In_Commerce_Request_Tracking_Aggregate;
  /** fetch data from the table: "use_in_commerce_request_tracking" using primary key columns */
  use_in_commerce_request_tracking_by_pk?: Maybe<Use_In_Commerce_Request_Tracking>;
  /** fetch data from the table: "use_in_commerce_request_tracking_status" */
  use_in_commerce_request_tracking_status: Array<Use_In_Commerce_Request_Tracking_Status>;
  /** fetch aggregated fields from the table: "use_in_commerce_request_tracking_status" */
  use_in_commerce_request_tracking_status_aggregate: Use_In_Commerce_Request_Tracking_Status_Aggregate;
  /** fetch data from the table: "use_in_commerce_request_tracking_status" using primary key columns */
  use_in_commerce_request_tracking_status_by_pk?: Maybe<Use_In_Commerce_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "use_in_commerce_request_tracking_status" */
  use_in_commerce_request_tracking_status_stream: Array<Use_In_Commerce_Request_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "use_in_commerce_request_tracking" */
  use_in_commerce_request_tracking_stream: Array<Use_In_Commerce_Request_Tracking>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user_auth_log" */
  user_auth_log: Array<User_Auth_Log>;
  /** fetch aggregated fields from the table: "user_auth_log" */
  user_auth_log_aggregate: User_Auth_Log_Aggregate;
  /** fetch data from the table: "user_auth_log" using primary key columns */
  user_auth_log_by_pk?: Maybe<User_Auth_Log>;
  /** fetch data from the table in a streaming manner: "user_auth_log" */
  user_auth_log_stream: Array<User_Auth_Log>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_history" */
  user_history: Array<User_History>;
  /** fetch aggregated fields from the table: "user_history" */
  user_history_aggregate: User_History_Aggregate;
  /** fetch data from the table: "user_history" using primary key columns */
  user_history_by_pk?: Maybe<User_History>;
  /** fetch data from the table in a streaming manner: "user_history" */
  user_history_stream: Array<User_History>;
  /** fetch data from the table: "user_payment_method" */
  user_payment_method: Array<User_Payment_Method>;
  /** fetch aggregated fields from the table: "user_payment_method" */
  user_payment_method_aggregate: User_Payment_Method_Aggregate;
  /** fetch data from the table: "user_payment_method" using primary key columns */
  user_payment_method_by_pk?: Maybe<User_Payment_Method>;
  /** fetch data from the table in a streaming manner: "user_payment_method" */
  user_payment_method_stream: Array<User_Payment_Method>;
  /** fetch data from the table: "user_profile" */
  user_profile: Array<User_Profile>;
  /** fetch aggregated fields from the table: "user_profile" */
  user_profile_aggregate: User_Profile_Aggregate;
  /** fetch data from the table: "user_profile" using primary key columns */
  user_profile_by_pk?: Maybe<User_Profile>;
  /** fetch data from the table in a streaming manner: "user_profile" */
  user_profile_stream: Array<User_Profile>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "user_tracking" */
  user_tracking: Array<User_Tracking>;
  /** fetch aggregated fields from the table: "user_tracking" */
  user_tracking_aggregate: User_Tracking_Aggregate;
  /** fetch data from the table: "user_tracking" using primary key columns */
  user_tracking_by_pk?: Maybe<User_Tracking>;
  /** fetch data from the table: "user_tracking_status" */
  user_tracking_status: Array<User_Tracking_Status>;
  /** fetch aggregated fields from the table: "user_tracking_status" */
  user_tracking_status_aggregate: User_Tracking_Status_Aggregate;
  /** fetch data from the table: "user_tracking_status" using primary key columns */
  user_tracking_status_by_pk?: Maybe<User_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "user_tracking_status" */
  user_tracking_status_stream: Array<User_Tracking_Status>;
  /** fetch data from the table in a streaming manner: "user_tracking" */
  user_tracking_stream: Array<User_Tracking>;
  user_unseen_verification_count: Array<Aggregate_Count>;
  /** fetch data from the table: "verification_result" */
  verification_result: Array<Verification_Result>;
  /** fetch aggregated fields from the table: "verification_result" */
  verification_result_aggregate: Verification_Result_Aggregate;
  /** fetch data from the table: "verification_result" using primary key columns */
  verification_result_by_pk?: Maybe<Verification_Result>;
  /** An array relationship */
  verification_result_similar_trademark_map: Array<Verification_Result_Similar_Trademark_Map>;
  /** An aggregate relationship */
  verification_result_similar_trademark_map_aggregate: Verification_Result_Similar_Trademark_Map_Aggregate;
  /** fetch data from the table: "verification_result_similar_trademark_map" using primary key columns */
  verification_result_similar_trademark_map_by_pk?: Maybe<Verification_Result_Similar_Trademark_Map>;
  /** fetch data from the table in a streaming manner: "verification_result_similar_trademark_map" */
  verification_result_similar_trademark_map_stream: Array<Verification_Result_Similar_Trademark_Map>;
  /** fetch data from the table in a streaming manner: "verification_result" */
  verification_result_stream: Array<Verification_Result>;
  verification_search: Array<Verification_Search_Result>;
  /** fetch data from the table: "website" */
  website: Array<Website>;
  /** fetch aggregated fields from the table: "website" */
  website_aggregate: Website_Aggregate;
  /** fetch data from the table: "website" using primary key columns */
  website_by_pk?: Maybe<Website>;
  /** fetch data from the table in a streaming manner: "website" */
  website_stream: Array<Website>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAi_Gs_Items_AnalysisArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


export type Subscription_RootAi_Gs_Items_Analysis_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


export type Subscription_RootAi_Gs_Items_Analysis_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAi_Gs_Items_Analysis_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Ai_Gs_Items_Analysis_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Gs_Items_Analysis_Bool_Exp>;
};


export type Subscription_RootApplicationArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Order_By>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootApplication_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplication_JurisdictionArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


export type Subscription_RootApplication_Jurisdiction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


export type Subscription_RootApplication_Jurisdiction_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApplication_Jurisdiction_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Jurisdiction_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
};


export type Subscription_RootApplication_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Application_Stream_Cursor_Input>>;
  where?: InputMaybe<Application_Bool_Exp>;
};


export type Subscription_RootAudit_LogArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Order_By>>;
  where?: InputMaybe<Audit_Log_Bool_Exp>;
};


export type Subscription_RootAudit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Audit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Audit_Log_Order_By>>;
  where?: InputMaybe<Audit_Log_Bool_Exp>;
};


export type Subscription_RootAudit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Audit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Audit_Log_Bool_Exp>;
};


export type Subscription_RootBrandArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBrand_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBrand_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Monitoring_TaskArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Monitoring_Task_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Monitoring_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Monitoring_Task_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Monitoring_Task_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Monitoring_Task_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Monitoring_Task_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
};


export type Subscription_RootBrand_SnapshotArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


export type Subscription_RootBrand_Snapshot_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Snapshot_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Snapshot_Order_By>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


export type Subscription_RootBrand_Snapshot_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Snapshot_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Snapshot_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Snapshot_Bool_Exp>;
};


export type Subscription_RootBrand_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


export type Subscription_RootBrand_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Subscription_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Payment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Subscription_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Subscription_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Platform_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBrand_Subscription_Platform_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Subscription_Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootBrand_Subscription_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Status_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootBrand_Subscription_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Subscription_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootBrand_Subscription_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Brand_Subscription_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
};


export type Subscription_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_RootCase_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_CounterpartyArgs = {
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By>>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};


export type Subscription_RootCase_Counterparty_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By>>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};


export type Subscription_RootCase_Counterparty_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_Counterparty_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Counterparty_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Counterparty_Bool_Exp>;
};


export type Subscription_RootCase_InfringementArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


export type Subscription_RootCase_Infringement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


export type Subscription_RootCase_Infringement_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_Infringement_EvidenceArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


export type Subscription_RootCase_Infringement_Evidence_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


export type Subscription_RootCase_Infringement_Evidence_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_Infringement_Evidence_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Infringement_Evidence_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Infringement_Evidence_Bool_Exp>;
};


export type Subscription_RootCase_Infringement_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Infringement_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Infringement_Bool_Exp>;
};


export type Subscription_RootCase_RequestArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Order_By>>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};


export type Subscription_RootCase_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Order_By>>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};


export type Subscription_RootCase_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Request_Bool_Exp>;
};


export type Subscription_RootCase_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootCase_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootCase_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCase_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['case_request_status']['input'];
};


export type Subscription_RootCase_Request_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Request_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Request_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Request_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootCase_SolutionArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


export type Subscription_RootCase_Solution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Solution_Order_By>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


export type Subscription_RootCase_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCase_Solution_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Solution_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Solution_Bool_Exp>;
};


export type Subscription_RootCase_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_RootCase_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


export type Subscription_RootCase_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


export type Subscription_RootCase_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCase_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Case_Tracking_Status_Order_By>>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootCase_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootCase_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Case_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
};


export type Subscription_RootConsultationArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootConsultation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consultation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Consultation_Order_By>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootConsultation_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootConsultation_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Consultation_Stream_Cursor_Input>>;
  where?: InputMaybe<Consultation_Bool_Exp>;
};


export type Subscription_RootContentfulArgs = {
  distinct_on?: InputMaybe<Array<Contentful_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contentful_Order_By>>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};


export type Subscription_RootContentful_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contentful_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Contentful_Order_By>>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};


export type Subscription_RootContentful_By_PkArgs = {
  id: Scalars['bpchar']['input'];
};


export type Subscription_RootContentful_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Contentful_Stream_Cursor_Input>>;
  where?: InputMaybe<Contentful_Bool_Exp>;
};


export type Subscription_RootCredit_NoteArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootCredit_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Credit_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootCredit_Note_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCredit_Note_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Credit_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Credit_Note_Bool_Exp>;
};


export type Subscription_RootDiscount_CouponArgs = {
  distinct_on?: InputMaybe<Array<Discount_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Coupon_Order_By>>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};


export type Subscription_RootDiscount_Coupon_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Discount_Coupon_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Discount_Coupon_Order_By>>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};


export type Subscription_RootDiscount_Coupon_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootDiscount_Coupon_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Discount_Coupon_Stream_Cursor_Input>>;
  where?: InputMaybe<Discount_Coupon_Bool_Exp>;
};


export type Subscription_RootDocketed_MessageArgs = {
  distinct_on?: InputMaybe<Array<Docketed_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Docketed_Message_Order_By>>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};


export type Subscription_RootDocketed_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Docketed_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Docketed_Message_Order_By>>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};


export type Subscription_RootDocketed_Message_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDocketed_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Docketed_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Docketed_Message_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootDocument_FolderArgs = {
  distinct_on?: InputMaybe<Array<Document_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Folder_Order_By>>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};


export type Subscription_RootDocument_Folder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Folder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Folder_Order_By>>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};


export type Subscription_RootDocument_Folder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Folder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Folder_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Folder_Bool_Exp>;
};


export type Subscription_RootDocument_HubArgs = {
  distinct_on?: InputMaybe<Array<Document_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Hub_Order_By>>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};


export type Subscription_RootDocument_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Hub_Order_By>>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};


export type Subscription_RootDocument_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocument_Hub_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Hub_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Hub_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootEntityArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootEntity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Entity_Order_By>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootEntity_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEntity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Entity_Bool_Exp>;
};


export type Subscription_RootExchange_RateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rate_Order_By>>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};


export type Subscription_RootExchange_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exchange_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Exchange_Rate_Order_By>>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};


export type Subscription_RootExchange_Rate_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExchange_Rate_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Exchange_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
};


export type Subscription_RootExternal_TrademarkArgs = {
  distinct_on?: InputMaybe<Array<External_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Trademark_Order_By>>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};


export type Subscription_RootExternal_Trademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<External_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<External_Trademark_Order_By>>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};


export type Subscription_RootExternal_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExternal_Trademark_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<External_Trademark_Stream_Cursor_Input>>;
  where?: InputMaybe<External_Trademark_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  variable_symbol: Scalars['String']['input'];
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootNoteArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


export type Subscription_RootNote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


export type Subscription_RootNote_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNote_HubArgs = {
  distinct_on?: InputMaybe<Array<Note_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Hub_Order_By>>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};


export type Subscription_RootNote_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Hub_Order_By>>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};


export type Subscription_RootNote_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNote_Hub_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Note_Hub_Stream_Cursor_Input>>;
  where?: InputMaybe<Note_Hub_Bool_Exp>;
};


export type Subscription_RootNote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


export type Subscription_RootNotificationArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Order_By>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootNotification_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNotification_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Bool_Exp>;
};


export type Subscription_RootOffice_ActionArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


export type Subscription_RootOffice_Action_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


export type Subscription_RootOffice_Action_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOffice_Action_IssueArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Issue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Issue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Issue_Order_By>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Issue_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOffice_Action_Issue_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Issue_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Issue_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOffice_Action_Similar_Trademark_Map_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Similar_Trademark_Map_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootOffice_Action_SolutionArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Solution_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Solution_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Solution_Order_By>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Solution_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOffice_Action_Solution_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Solution_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Solution_Bool_Exp>;
};


export type Subscription_RootOffice_Action_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


export type Subscription_RootOffice_Action_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOffice_Action_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Status_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Status_Order_By>>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootOffice_Action_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOffice_Action_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Office_Action_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_HubArgs = {
  distinct_on?: InputMaybe<Array<Order_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Hub_Order_By>>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};


export type Subscription_RootOrder_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Hub_Order_By>>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};


export type Subscription_RootOrder_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Hub_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Hub_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Hub_Bool_Exp>;
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


export type Subscription_RootOrder_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Order_By>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


export type Subscription_RootOrder_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrder_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Status_Order_By>>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Order_Tracking_Status_Order_By>>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootOrder_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootOrder_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Order_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Tracking_Bool_Exp>;
};


export type Subscription_RootPaid_Orders_Summary_Last_30_DaysArgs = {
  distinct_on?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Order_By>>;
  where?: InputMaybe<Paid_Orders_Summary_Last_30_Days_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootPaid_Orders_Summary_Last_30_Days_CountArgs = {
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootPoaArgs = {
  distinct_on?: InputMaybe<Array<Poa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poa_Order_By>>;
  where?: InputMaybe<Poa_Bool_Exp>;
};


export type Subscription_RootPoa_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Poa_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Poa_Order_By>>;
  where?: InputMaybe<Poa_Bool_Exp>;
};


export type Subscription_RootPoa_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPoa_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Poa_Stream_Cursor_Input>>;
  where?: InputMaybe<Poa_Bool_Exp>;
};


export type Subscription_RootPriceArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


export type Subscription_RootPrice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Order_By>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


export type Subscription_RootPrice_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrice_RuleArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


export type Subscription_RootPrice_Rule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Rule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Price_Rule_Order_By>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


export type Subscription_RootPrice_Rule_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPrice_Rule_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Price_Rule_Stream_Cursor_Input>>;
  where?: InputMaybe<Price_Rule_Bool_Exp>;
};


export type Subscription_RootPrice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Price_Stream_Cursor_Input>>;
  where?: InputMaybe<Price_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_BundleArgs = {
  distinct_on?: InputMaybe<Array<Product_Bundle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Bundle_Order_By>>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};


export type Subscription_RootProduct_Bundle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Bundle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Bundle_Order_By>>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};


export type Subscription_RootProduct_Bundle_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Bundle_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Bundle_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_EventArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


export type Subscription_RootProduct_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_Event_Order_By>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


export type Subscription_RootProduct_Event_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_Event_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Event_Bool_Exp>;
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_V2Args = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


export type Subscription_RootProduct_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Product_V2_Order_By>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


export type Subscription_RootProduct_V2_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProduct_V2_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Product_V2_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_V2_Bool_Exp>;
};


export type Subscription_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootQuote_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuote_HubArgs = {
  distinct_on?: InputMaybe<Array<Quote_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Hub_Order_By>>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};


export type Subscription_RootQuote_Hub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Hub_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Hub_Order_By>>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};


export type Subscription_RootQuote_Hub_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuote_Hub_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Hub_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
};


export type Subscription_RootQuote_ItemArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


export type Subscription_RootQuote_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Quote_Item_Order_By>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


export type Subscription_RootQuote_Item_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuote_Item_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Item_Bool_Exp>;
};


export type Subscription_RootQuote_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Quote_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootRecent_Applications_Sent_To_ClientArgs = {
  args: Recent_Applications_Sent_To_Client_Arguments;
  distinct_on?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Order_By>>;
  where?: InputMaybe<Recent_Applications_Sent_To_Client_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRefund_RequestArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Order_By>>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};


export type Subscription_RootRefund_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Order_By>>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};


export type Subscription_RootRefund_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRefund_Request_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Invoice_Order_By>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Invoice_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRefund_Request_Invoice_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refund_Request_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Refund_Request_Invoice_Bool_Exp>;
};


export type Subscription_RootRefund_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refund_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Refund_Request_Bool_Exp>;
};


export type Subscription_RootRefund_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRefund_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootRefund_Request_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refund_Request_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Refund_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRefund_Request_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Refund_Request_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootRegistration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRegistration_Request_Recently_DismissedArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Order_By>>;
  where?: InputMaybe<Registration_Request_Recently_Dismissed_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Recently_Dismissed_CountArgs = {
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Registration_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootRegistration_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootRegistration_Request_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Registration_Request_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Registration_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootRegistration_Request_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Registration_Request_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootReminderArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reminder_Order_By>>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};


export type Subscription_RootReminder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminder_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reminder_Order_By>>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};


export type Subscription_RootReminder_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReminder_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reminder_Stream_Cursor_Input>>;
  where?: InputMaybe<Reminder_Bool_Exp>;
};


export type Subscription_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootService_RequestArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


export type Subscription_RootService_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


export type Subscription_RootService_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootService_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


export type Subscription_RootService_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootService_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootService_Request_Tracking_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootService_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootService_Request_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Request_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Request_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootService_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


export type Subscription_RootService_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


export type Subscription_RootService_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootService_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Tracking_Status_Order_By>>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootService_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootService_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Service_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
};


export type Subscription_RootSimilar_TrademarkArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


export type Subscription_RootSimilar_Trademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


export type Subscription_RootSimilar_Trademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSimilar_Trademark_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Similar_Trademark_Stream_Cursor_Input>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


export type Subscription_RootSpecimenArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


export type Subscription_RootSpecimen_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


export type Subscription_RootSpecimen_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSpecimen_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Specimen_Stream_Cursor_Input>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


export type Subscription_RootStatisticArgs = {
  distinct_on?: InputMaybe<Array<Statistic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statistic_Order_By>>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};


export type Subscription_RootStatistic_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Statistic_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Statistic_Order_By>>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};


export type Subscription_RootStatistic_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootStatistic_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Statistic_Stream_Cursor_Input>>;
  where?: InputMaybe<Statistic_Bool_Exp>;
};


export type Subscription_RootSupport_TicketArgs = {
  distinct_on?: InputMaybe<Array<Support_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Ticket_Order_By>>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};


export type Subscription_RootSupport_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Support_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Support_Ticket_Order_By>>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};


export type Subscription_RootSupport_Ticket_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootSupport_Ticket_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Support_Ticket_Stream_Cursor_Input>>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};


export type Subscription_RootTaskArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootTask_By_PkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootTask_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Bool_Exp>;
};


export type Subscription_RootThread_CommentArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


export type Subscription_RootThread_Comment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


export type Subscription_RootThread_Comment_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootThread_Comment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Thread_Comment_Stream_Cursor_Input>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


export type Subscription_RootTrademarkArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


export type Subscription_RootTrademark_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


export type Subscription_RootTrademark_Audit_LogArgs = {
  args: Trademark_Audit_Log_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Audit_Log_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Audit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Audit_Log_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTrademark_Audit_Log_CountArgs = {
  args: Trademark_Audit_Log_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTrademark_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_ClassArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


export type Subscription_RootTrademark_Class_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


export type Subscription_RootTrademark_Class_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Class_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Class_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


export type Subscription_RootTrademark_Ipo_DataArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Ipo_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Ipo_Data_Order_By>>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};


export type Subscription_RootTrademark_Ipo_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Ipo_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Ipo_Data_Order_By>>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};


export type Subscription_RootTrademark_Ipo_Data_By_PkArgs = {
  jurisdiction: Scalars['String']['input'];
  number: Scalars['String']['input'];
};


export type Subscription_RootTrademark_Ipo_Data_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Ipo_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};


export type Subscription_RootTrademark_Monitoring_ResultArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


export type Subscription_RootTrademark_Monitoring_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


export type Subscription_RootTrademark_Monitoring_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Monitoring_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Monitoring_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


export type Subscription_RootTrademark_Portfolio_SearchArgs = {
  args: Trademark_Portfolio_Search_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Order_By>>;
  where?: InputMaybe<Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTrademark_Portfolio_Search_CountArgs = {
  args: Trademark_Portfolio_Search_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTrademark_Rate_Limit_LogArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Rate_Limit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Rate_Limit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};


export type Subscription_RootTrademark_Rate_Limit_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Rate_Limit_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Rate_Limit_Log_Order_By>>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};


export type Subscription_RootTrademark_Rate_Limit_Log_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Rate_Limit_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Rate_Limit_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};


export type Subscription_RootTrademark_RequestArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By>>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};


export type Subscription_RootTrademark_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By>>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};


export type Subscription_RootTrademark_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};


export type Subscription_RootTrademark_SearchArgs = {
  args: Trademark_Search_Arguments;
  distinct_on?: InputMaybe<Array<Trademark_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Search_Result_Order_By>>;
  where?: InputMaybe<Trademark_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootTrademark_Service_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


export type Subscription_RootTrademark_Service_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


export type Subscription_RootTrademark_Service_Requests_By_PkArgs = {
  service_request_id: Scalars['uuid']['input'];
  trademark_id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Service_Requests_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Service_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};


export type Subscription_RootTrademark_Shared_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


export type Subscription_RootTrademark_Shared_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


export type Subscription_RootTrademark_Shared_Documents_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTrademark_Shared_Documents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Shared_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


export type Subscription_RootTrademark_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


export type Subscription_RootTrademark_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


export type Subscription_RootTrademark_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


export type Subscription_RootTrademark_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootTrademark_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Status_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootTrademark_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Status_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootTrademark_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootTrademark_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootTrademark_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


export type Subscription_RootTrademark_Watch_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


export type Subscription_RootTrademark_Watch_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


export type Subscription_RootTrademark_Watch_Subscription_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTrademark_Watch_Subscription_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Trademark_Watch_Subscription_Stream_Cursor_Input>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_RequestArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUse_In_Commerce_Request_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Use_In_Commerce_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_TrackingArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Use_In_Commerce_Request_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUse_In_Commerce_Request_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Use_In_Commerce_Request_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_Auth_LogArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Auth_Log_Order_By>>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Auth_Log_Order_By>>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Log_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Auth_Log_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Auth_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_HistoryArgs = {
  distinct_on?: InputMaybe<Array<User_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_History_Order_By>>;
  where?: InputMaybe<User_History_Bool_Exp>;
};


export type Subscription_RootUser_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_History_Order_By>>;
  where?: InputMaybe<User_History_Bool_Exp>;
};


export type Subscription_RootUser_History_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_History_Stream_Cursor_Input>>;
  where?: InputMaybe<User_History_Bool_Exp>;
};


export type Subscription_RootUser_Payment_MethodArgs = {
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By>>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};


export type Subscription_RootUser_Payment_Method_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By>>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};


export type Subscription_RootUser_Payment_Method_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Payment_Method_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Payment_Method_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};


export type Subscription_RootUser_ProfileArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Profile_Order_By>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_Profile_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Profile_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_TrackingArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


export type Subscription_RootUser_Tracking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


export type Subscription_RootUser_Tracking_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUser_Tracking_StatusArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Status_Order_By>>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Tracking_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Status_Order_By>>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Tracking_Status_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootUser_Tracking_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Tracking_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};


export type Subscription_RootUser_Tracking_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Tracking_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


export type Subscription_RootUser_Unseen_Verification_CountArgs = {
  args: User_Unseen_Verification_Count_Arguments;
  distinct_on?: InputMaybe<Array<Aggregate_Count_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Aggregate_Count_Order_By>>;
  where?: InputMaybe<Aggregate_Count_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootVerification_ResultArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


export type Subscription_RootVerification_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Order_By>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


export type Subscription_RootVerification_Result_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVerification_Result_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootVerification_Result_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootVerification_Result_Similar_Trademark_Map_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVerification_Result_Similar_Trademark_Map_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Verification_Result_Similar_Trademark_Map_Stream_Cursor_Input>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


export type Subscription_RootVerification_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Verification_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};


export type Subscription_RootVerification_SearchArgs = {
  args: Verification_Search_Arguments;
  distinct_on?: InputMaybe<Array<Verification_Search_Result_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Search_Result_Order_By>>;
  where?: InputMaybe<Verification_Search_Result_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootWebsiteArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};


export type Subscription_RootWebsite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Website_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Website_Order_By>>;
  where?: InputMaybe<Website_Bool_Exp>;
};


export type Subscription_RootWebsite_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWebsite_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Website_Stream_Cursor_Input>>;
  where?: InputMaybe<Website_Bool_Exp>;
};

/** columns and relationships of "support_ticket" */
export type Support_Ticket = {
  __typename?: 'support_ticket';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description: Scalars['String']['output'];
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  id: Scalars['Int']['output'];
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  resource_id: Scalars['String']['output'];
  resource_name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "support_ticket" */
export type Support_TicketDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "support_ticket" */
export type Support_TicketDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "support_ticket" */
export type Support_TicketNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "support_ticket" */
export type Support_TicketNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};

/** aggregated selection of "support_ticket" */
export type Support_Ticket_Aggregate = {
  __typename?: 'support_ticket_aggregate';
  aggregate?: Maybe<Support_Ticket_Aggregate_Fields>;
  nodes: Array<Support_Ticket>;
};

/** aggregate fields of "support_ticket" */
export type Support_Ticket_Aggregate_Fields = {
  __typename?: 'support_ticket_aggregate_fields';
  avg?: Maybe<Support_Ticket_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Support_Ticket_Max_Fields>;
  min?: Maybe<Support_Ticket_Min_Fields>;
  stddev?: Maybe<Support_Ticket_Stddev_Fields>;
  stddev_pop?: Maybe<Support_Ticket_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Support_Ticket_Stddev_Samp_Fields>;
  sum?: Maybe<Support_Ticket_Sum_Fields>;
  var_pop?: Maybe<Support_Ticket_Var_Pop_Fields>;
  var_samp?: Maybe<Support_Ticket_Var_Samp_Fields>;
  variance?: Maybe<Support_Ticket_Variance_Fields>;
};


/** aggregate fields of "support_ticket" */
export type Support_Ticket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Support_Ticket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Support_Ticket_Avg_Fields = {
  __typename?: 'support_ticket_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "support_ticket". All fields are combined with a logical 'AND'. */
export type Support_Ticket_Bool_Exp = {
  _and?: InputMaybe<Array<Support_Ticket_Bool_Exp>>;
  _not?: InputMaybe<Support_Ticket_Bool_Exp>;
  _or?: InputMaybe<Array<Support_Ticket_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  resolution?: InputMaybe<String_Comparison_Exp>;
  resolved_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  resource_id?: InputMaybe<String_Comparison_Exp>;
  resource_name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "support_ticket" */
export enum Support_Ticket_Constraint {
  /** unique or primary key constraint on columns "document_hub_id" */
  SupportTicketDocumentHubIdKey = 'support_ticket_document_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  SupportTicketPkey = 'support_ticket_pkey'
}

/** input type for incrementing numeric columns in table "support_ticket" */
export type Support_Ticket_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "support_ticket" */
export type Support_Ticket_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Support_Ticket_Max_Fields = {
  __typename?: 'support_ticket_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Support_Ticket_Min_Fields = {
  __typename?: 'support_ticket_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  resolved_at?: Maybe<Scalars['timestamptz']['output']>;
  resource_id?: Maybe<Scalars['String']['output']>;
  resource_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "support_ticket" */
export type Support_Ticket_Mutation_Response = {
  __typename?: 'support_ticket_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Support_Ticket>;
};

/** on_conflict condition type for table "support_ticket" */
export type Support_Ticket_On_Conflict = {
  constraint: Support_Ticket_Constraint;
  update_columns?: Array<Support_Ticket_Update_Column>;
  where?: InputMaybe<Support_Ticket_Bool_Exp>;
};

/** Ordering options when selecting data from "support_ticket". */
export type Support_Ticket_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  resolution?: InputMaybe<Order_By>;
  resolved_at?: InputMaybe<Order_By>;
  resource_id?: InputMaybe<Order_By>;
  resource_name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: support_ticket */
export type Support_Ticket_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "support_ticket" */
export enum Support_Ticket_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceName = 'resource_name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "support_ticket" */
export type Support_Ticket_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Support_Ticket_Stddev_Fields = {
  __typename?: 'support_ticket_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Support_Ticket_Stddev_Pop_Fields = {
  __typename?: 'support_ticket_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Support_Ticket_Stddev_Samp_Fields = {
  __typename?: 'support_ticket_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "support_ticket" */
export type Support_Ticket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Support_Ticket_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Support_Ticket_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  resolved_at?: InputMaybe<Scalars['timestamptz']['input']>;
  resource_id?: InputMaybe<Scalars['String']['input']>;
  resource_name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Support_Ticket_Sum_Fields = {
  __typename?: 'support_ticket_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "support_ticket" */
export enum Support_Ticket_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Description = 'description',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Resolution = 'resolution',
  /** column name */
  ResolvedAt = 'resolved_at',
  /** column name */
  ResourceId = 'resource_id',
  /** column name */
  ResourceName = 'resource_name',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Support_Ticket_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Support_Ticket_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Support_Ticket_Set_Input>;
  /** filter the rows which have to be updated */
  where: Support_Ticket_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Support_Ticket_Var_Pop_Fields = {
  __typename?: 'support_ticket_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Support_Ticket_Var_Samp_Fields = {
  __typename?: 'support_ticket_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Support_Ticket_Variance_Fields = {
  __typename?: 'support_ticket_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "task" */
export type Task = {
  __typename?: 'task';
  created_at: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  execution_time: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lambda_request_id?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['jsonb']['output']>;
  result?: Maybe<Scalars['jsonb']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "task" */
export type TaskDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "task" */
export type TaskOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "task" */
export type TaskResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "task" */
export type Task_Aggregate = {
  __typename?: 'task_aggregate';
  aggregate?: Maybe<Task_Aggregate_Fields>;
  nodes: Array<Task>;
};

/** aggregate fields of "task" */
export type Task_Aggregate_Fields = {
  __typename?: 'task_aggregate_fields';
  avg?: Maybe<Task_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Max_Fields>;
  min?: Maybe<Task_Min_Fields>;
  stddev?: Maybe<Task_Stddev_Fields>;
  stddev_pop?: Maybe<Task_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Task_Stddev_Samp_Fields>;
  sum?: Maybe<Task_Sum_Fields>;
  var_pop?: Maybe<Task_Var_Pop_Fields>;
  var_samp?: Maybe<Task_Var_Samp_Fields>;
  variance?: Maybe<Task_Variance_Fields>;
};


/** aggregate fields of "task" */
export type Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Task_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type Task_Avg_Fields = {
  __typename?: 'task_avg_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "task". All fields are combined with a logical 'AND'. */
export type Task_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Bool_Exp>>;
  _not?: InputMaybe<Task_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  execution_time?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lambda_request_id?: InputMaybe<String_Comparison_Exp>;
  options?: InputMaybe<Jsonb_Comparison_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "task" */
export enum Task_Constraint {
  /** unique or primary key constraint on columns "id" */
  TaskPkey = 'task_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Task_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  result?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Task_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Task_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "task" */
export type Task_Inc_Input = {
  execution_time?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "task" */
export type Task_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lambda_request_id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Task_Max_Fields = {
  __typename?: 'task_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  execution_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lambda_request_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Task_Min_Fields = {
  __typename?: 'task_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  execution_time?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lambda_request_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "task" */
export type Task_Mutation_Response = {
  __typename?: 'task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task>;
};

/** on_conflict condition type for table "task" */
export type Task_On_Conflict = {
  constraint: Task_Constraint;
  update_columns?: Array<Task_Update_Column>;
  where?: InputMaybe<Task_Bool_Exp>;
};

/** Ordering options when selecting data from "task". */
export type Task_Order_By = {
  created_at?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  execution_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lambda_request_id?: InputMaybe<Order_By>;
  options?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: task */
export type Task_Pk_Columns_Input = {
  id: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Task_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "task" */
export enum Task_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  ExecutionTime = 'execution_time',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaRequestId = 'lambda_request_id',
  /** column name */
  Options = 'options',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "task" */
export type Task_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lambda_request_id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Task_Stddev_Fields = {
  __typename?: 'task_stddev_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Task_Stddev_Pop_Fields = {
  __typename?: 'task_stddev_pop_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Task_Stddev_Samp_Fields = {
  __typename?: 'task_stddev_samp_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "task" */
export type Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  execution_time?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lambda_request_id?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
  result?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Task_Sum_Fields = {
  __typename?: 'task_sum_fields';
  execution_time?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "task" */
export enum Task_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Data = 'data',
  /** column name */
  ExecutionTime = 'execution_time',
  /** column name */
  Id = 'id',
  /** column name */
  LambdaRequestId = 'lambda_request_id',
  /** column name */
  Options = 'options',
  /** column name */
  Result = 'result',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Task_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Task_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Task_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Task_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Task_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Task_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Task_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Set_Input>;
  /** filter the rows which have to be updated */
  where: Task_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Task_Var_Pop_Fields = {
  __typename?: 'task_var_pop_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Task_Var_Samp_Fields = {
  __typename?: 'task_var_samp_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Task_Variance_Fields = {
  __typename?: 'task_variance_fields';
  execution_time?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "thread_comment" */
export type Thread_Comment = {
  __typename?: 'thread_comment';
  ai_suggested_action?: Maybe<Scalars['String']['output']>;
  ai_suggested_comment?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document?: Maybe<Document>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  thread_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "thread_comment" */
export type Thread_Comment_Aggregate = {
  __typename?: 'thread_comment_aggregate';
  aggregate?: Maybe<Thread_Comment_Aggregate_Fields>;
  nodes: Array<Thread_Comment>;
};

export type Thread_Comment_Aggregate_Bool_Exp = {
  count?: InputMaybe<Thread_Comment_Aggregate_Bool_Exp_Count>;
};

export type Thread_Comment_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Thread_Comment_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "thread_comment" */
export type Thread_Comment_Aggregate_Fields = {
  __typename?: 'thread_comment_aggregate_fields';
  avg?: Maybe<Thread_Comment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Thread_Comment_Max_Fields>;
  min?: Maybe<Thread_Comment_Min_Fields>;
  stddev?: Maybe<Thread_Comment_Stddev_Fields>;
  stddev_pop?: Maybe<Thread_Comment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Thread_Comment_Stddev_Samp_Fields>;
  sum?: Maybe<Thread_Comment_Sum_Fields>;
  var_pop?: Maybe<Thread_Comment_Var_Pop_Fields>;
  var_samp?: Maybe<Thread_Comment_Var_Samp_Fields>;
  variance?: Maybe<Thread_Comment_Variance_Fields>;
};


/** aggregate fields of "thread_comment" */
export type Thread_Comment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "thread_comment" */
export type Thread_Comment_Aggregate_Order_By = {
  avg?: InputMaybe<Thread_Comment_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Thread_Comment_Max_Order_By>;
  min?: InputMaybe<Thread_Comment_Min_Order_By>;
  stddev?: InputMaybe<Thread_Comment_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Thread_Comment_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Thread_Comment_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Thread_Comment_Sum_Order_By>;
  var_pop?: InputMaybe<Thread_Comment_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Thread_Comment_Var_Samp_Order_By>;
  variance?: InputMaybe<Thread_Comment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "thread_comment" */
export type Thread_Comment_Arr_Rel_Insert_Input = {
  data: Array<Thread_Comment_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Thread_Comment_On_Conflict>;
};

/** aggregate avg on columns */
export type Thread_Comment_Avg_Fields = {
  __typename?: 'thread_comment_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "thread_comment" */
export type Thread_Comment_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "thread_comment". All fields are combined with a logical 'AND'. */
export type Thread_Comment_Bool_Exp = {
  _and?: InputMaybe<Array<Thread_Comment_Bool_Exp>>;
  _not?: InputMaybe<Thread_Comment_Bool_Exp>;
  _or?: InputMaybe<Array<Thread_Comment_Bool_Exp>>;
  ai_suggested_action?: InputMaybe<String_Comparison_Exp>;
  ai_suggested_comment?: InputMaybe<String_Comparison_Exp>;
  application_id?: InputMaybe<Uuid_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_in_commerce_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "thread_comment" */
export enum Thread_Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  ThreadCommentPkey = 'thread_comment_pkey'
}

/** input type for incrementing numeric columns in table "thread_comment" */
export type Thread_Comment_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "thread_comment" */
export type Thread_Comment_Insert_Input = {
  ai_suggested_action?: InputMaybe<Scalars['String']['input']>;
  ai_suggested_comment?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Thread_Comment_Max_Fields = {
  __typename?: 'thread_comment_max_fields';
  ai_suggested_action?: Maybe<Scalars['String']['output']>;
  ai_suggested_comment?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "thread_comment" */
export type Thread_Comment_Max_Order_By = {
  ai_suggested_action?: InputMaybe<Order_By>;
  ai_suggested_comment?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Thread_Comment_Min_Fields = {
  __typename?: 'thread_comment_min_fields';
  ai_suggested_action?: Maybe<Scalars['String']['output']>;
  ai_suggested_comment?: Maybe<Scalars['String']['output']>;
  application_id?: Maybe<Scalars['uuid']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "thread_comment" */
export type Thread_Comment_Min_Order_By = {
  ai_suggested_action?: InputMaybe<Order_By>;
  ai_suggested_comment?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "thread_comment" */
export type Thread_Comment_Mutation_Response = {
  __typename?: 'thread_comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_Comment>;
};

/** on_conflict condition type for table "thread_comment" */
export type Thread_Comment_On_Conflict = {
  constraint: Thread_Comment_Constraint;
  update_columns?: Array<Thread_Comment_Update_Column>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};

/** Ordering options when selecting data from "thread_comment". */
export type Thread_Comment_Order_By = {
  ai_suggested_action?: InputMaybe<Order_By>;
  ai_suggested_comment?: InputMaybe<Order_By>;
  application_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: thread_comment */
export type Thread_Comment_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "thread_comment" */
export enum Thread_Comment_Select_Column {
  /** column name */
  AiSuggestedAction = 'ai_suggested_action',
  /** column name */
  AiSuggestedComment = 'ai_suggested_comment',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "thread_comment" */
export type Thread_Comment_Set_Input = {
  ai_suggested_action?: InputMaybe<Scalars['String']['input']>;
  ai_suggested_comment?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Thread_Comment_Stddev_Fields = {
  __typename?: 'thread_comment_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "thread_comment" */
export type Thread_Comment_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Thread_Comment_Stddev_Pop_Fields = {
  __typename?: 'thread_comment_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "thread_comment" */
export type Thread_Comment_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Thread_Comment_Stddev_Samp_Fields = {
  __typename?: 'thread_comment_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "thread_comment" */
export type Thread_Comment_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "thread_comment" */
export type Thread_Comment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Thread_Comment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Comment_Stream_Cursor_Value_Input = {
  ai_suggested_action?: InputMaybe<Scalars['String']['input']>;
  ai_suggested_comment?: InputMaybe<Scalars['String']['input']>;
  application_id?: InputMaybe<Scalars['uuid']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Thread_Comment_Sum_Fields = {
  __typename?: 'thread_comment_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "thread_comment" */
export type Thread_Comment_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** update columns of table "thread_comment" */
export enum Thread_Comment_Update_Column {
  /** column name */
  AiSuggestedAction = 'ai_suggested_action',
  /** column name */
  AiSuggestedComment = 'ai_suggested_comment',
  /** column name */
  ApplicationId = 'application_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  UserId = 'user_id'
}

export type Thread_Comment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Thread_Comment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Thread_Comment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Thread_Comment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Thread_Comment_Var_Pop_Fields = {
  __typename?: 'thread_comment_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "thread_comment" */
export type Thread_Comment_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Thread_Comment_Var_Samp_Fields = {
  __typename?: 'thread_comment_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "thread_comment" */
export type Thread_Comment_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Thread_Comment_Variance_Fields = {
  __typename?: 'thread_comment_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "thread_comment" */
export type Thread_Comment_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "trademark" */
export type Trademark = {
  __typename?: 'trademark';
  additional_info: Scalars['jsonb']['output'];
  additional_info_legacy: Scalars['jsonb']['output'];
  alias?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  assignee_history: Scalars['jsonb']['output'];
  /** An object relationship */
  brand?: Maybe<Brand>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_registry_code?: Maybe<Scalars['uuid']['output']>;
  color_claim?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_user?: Maybe<User>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  direct_filing?: Maybe<Scalars['Boolean']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** An object relationship */
  domicile_address?: Maybe<Address>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  dou_deadline_date?: Maybe<Scalars['date']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  filing_information?: Maybe<Scalars['jsonb']['output']>;
  filing_postponed_note?: Maybe<Scalars['String']['output']>;
  filing_postponed_reason?: Maybe<Scalars['String']['output']>;
  filing_reference?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  international_number?: Maybe<Scalars['String']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction: Scalars['String']['output'];
  last_ipo_data_sync?: Maybe<Scalars['timestamptz']['output']>;
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  logo_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  mailing_address?: Maybe<Address>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  office_actions: Array<Office_Action>;
  /** An aggregate relationship */
  office_actions_aggregate: Office_Action_Aggregate;
  opposition_period_end?: Maybe<Scalars['timestamptz']['output']>;
  opposition_period_start?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  orders: Array<Service_Request>;
  /** An aggregate relationship */
  orders_aggregate: Service_Request_Aggregate;
  /** An object relationship */
  owner_entity?: Maybe<Entity>;
  owner_entity_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent_use_in_commerce_request?: Maybe<Use_In_Commerce_Request>;
  priority_filing_data: Scalars['jsonb']['output'];
  registration_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  registration_request?: Maybe<Registration_Request>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  representative_entity?: Maybe<Entity>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  status_group: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Trademark_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Trademark_Tracking_Aggregate;
  /** An array relationship */
  trademark_classes: Array<Trademark_Class>;
  /** An aggregate relationship */
  trademark_classes_aggregate: Trademark_Class_Aggregate;
  trademark_registration_id_legacy?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  trademark_request?: Maybe<Trademark_Request>;
  trademark_request_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  trademark_shared_documents: Array<Trademark_Shared_Documents>;
  /** An aggregate relationship */
  trademark_shared_documents_aggregate: Trademark_Shared_Documents_Aggregate;
  /** An array relationship */
  trademark_watch_subscription: Array<Trademark_Watch_Subscription>;
  /** An aggregate relationship */
  trademark_watch_subscription_aggregate: Trademark_Watch_Subscription_Aggregate;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  use_in_commerce_requests: Array<Use_In_Commerce_Request>;
  /** An aggregate relationship */
  use_in_commerce_requests_aggregate: Use_In_Commerce_Request_Aggregate;
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "trademark" */
export type TrademarkAdditional_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark" */
export type TrademarkAdditional_Info_LegacyArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark" */
export type TrademarkAssignee_HistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark" */
export type TrademarkDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkFiling_InformationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark" */
export type TrademarkNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkOffice_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkOffice_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Office_Action_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Office_Action_Order_By>>;
  where?: InputMaybe<Office_Action_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkOrdersArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkPriority_Filing_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark" */
export type TrademarkTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By>>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_Shared_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_Shared_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By>>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_Watch_SubscriptionArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkTrademark_Watch_Subscription_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By>>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkUse_In_Commerce_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};


/** columns and relationships of "trademark" */
export type TrademarkUse_In_Commerce_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};

/** aggregated selection of "trademark" */
export type Trademark_Aggregate = {
  __typename?: 'trademark_aggregate';
  aggregate?: Maybe<Trademark_Aggregate_Fields>;
  nodes: Array<Trademark>;
};

export type Trademark_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Trademark_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Trademark_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Trademark_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Aggregate_Bool_Exp_Bool_And = {
  arguments: Trademark_Select_Column_Trademark_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Trademark_Select_Column_Trademark_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark" */
export type Trademark_Aggregate_Fields = {
  __typename?: 'trademark_aggregate_fields';
  avg?: Maybe<Trademark_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Max_Fields>;
  min?: Maybe<Trademark_Min_Fields>;
  stddev?: Maybe<Trademark_Stddev_Fields>;
  stddev_pop?: Maybe<Trademark_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trademark_Stddev_Samp_Fields>;
  sum?: Maybe<Trademark_Sum_Fields>;
  var_pop?: Maybe<Trademark_Var_Pop_Fields>;
  var_samp?: Maybe<Trademark_Var_Samp_Fields>;
  variance?: Maybe<Trademark_Variance_Fields>;
};


/** aggregate fields of "trademark" */
export type Trademark_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark" */
export type Trademark_Aggregate_Order_By = {
  avg?: InputMaybe<Trademark_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Max_Order_By>;
  min?: InputMaybe<Trademark_Min_Order_By>;
  stddev?: InputMaybe<Trademark_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trademark_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trademark_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trademark_Sum_Order_By>;
  var_pop?: InputMaybe<Trademark_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trademark_Var_Samp_Order_By>;
  variance?: InputMaybe<Trademark_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Append_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  filing_information?: InputMaybe<Scalars['jsonb']['input']>;
  priority_filing_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "trademark" */
export type Trademark_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_On_Conflict>;
};

export type Trademark_Audit_Log = {
  __typename?: 'trademark_audit_log';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  new_values?: Maybe<Scalars['jsonb']['output']>;
  old_values?: Maybe<Scalars['jsonb']['output']>;
  operation: Scalars['String']['output'];
  property?: Maybe<Scalars['String']['output']>;
  record_id_int?: Maybe<Scalars['Int']['output']>;
  record_id_uuid?: Maybe<Scalars['uuid']['output']>;
  table_name: Scalars['String']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


export type Trademark_Audit_LogNew_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


export type Trademark_Audit_LogOld_ValuesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** trademark_audit_logNative Query Arguments */
export type Trademark_Audit_Log_Arguments = {
  trademark_id: Scalars['uuid']['input'];
};

/** Boolean expression to filter rows from the logical model for "trademark_audit_log". All fields are combined with a logical 'AND'. */
export type Trademark_Audit_Log_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Audit_Log_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Audit_Log_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Audit_Log_Bool_Exp_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  new_values?: InputMaybe<Jsonb_Comparison_Exp>;
  old_values?: InputMaybe<Jsonb_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<String_Comparison_Exp>;
  record_id_int?: InputMaybe<Int_Comparison_Exp>;
  record_id_uuid?: InputMaybe<Uuid_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** trademark_audit_log_countNative Query Arguments */
export type Trademark_Audit_Log_Count_Arguments = {
  trademark_id: Scalars['uuid']['input'];
};

export enum Trademark_Audit_Log_Enum_Name {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NewValues = 'new_values',
  /** column name */
  OldValues = 'old_values',
  /** column name */
  Operation = 'operation',
  /** column name */
  Property = 'property',
  /** column name */
  RecordIdInt = 'record_id_int',
  /** column name */
  RecordIdUuid = 'record_id_uuid',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UserId = 'user_id'
}

/** Ordering options when selecting data from "trademark_audit_log". */
export type Trademark_Audit_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  new_values?: InputMaybe<Order_By>;
  old_values?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  property?: InputMaybe<Order_By>;
  record_id_int?: InputMaybe<Order_By>;
  record_id_uuid?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Trademark_Avg_Fields = {
  __typename?: 'trademark_avg_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "trademark" */
export type Trademark_Avg_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trademark". All fields are combined with a logical 'AND'. */
export type Trademark_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Bool_Exp>>;
  additional_info?: InputMaybe<Jsonb_Comparison_Exp>;
  additional_info_legacy?: InputMaybe<Jsonb_Comparison_Exp>;
  alias?: InputMaybe<String_Comparison_Exp>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assignee_history?: InputMaybe<Jsonb_Comparison_Exp>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  brand_registry_code?: InputMaybe<Uuid_Comparison_Exp>;
  color_claim?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  direct_filing?: InputMaybe<Boolean_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  domicile_address?: InputMaybe<Address_Bool_Exp>;
  domicile_address_id?: InputMaybe<Int_Comparison_Exp>;
  dou_deadline_date?: InputMaybe<Date_Comparison_Exp>;
  expiration_date?: InputMaybe<Date_Comparison_Exp>;
  filing_date?: InputMaybe<Date_Comparison_Exp>;
  filing_information?: InputMaybe<Jsonb_Comparison_Exp>;
  filing_postponed_note?: InputMaybe<String_Comparison_Exp>;
  filing_postponed_reason?: InputMaybe<String_Comparison_Exp>;
  filing_reference?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  international_number?: InputMaybe<String_Comparison_Exp>;
  ipo_link?: InputMaybe<String_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  last_ipo_data_sync?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  logo_type?: InputMaybe<String_Comparison_Exp>;
  mailing_address?: InputMaybe<Address_Bool_Exp>;
  mailing_address_id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  office_actions?: InputMaybe<Office_Action_Bool_Exp>;
  office_actions_aggregate?: InputMaybe<Office_Action_Aggregate_Bool_Exp>;
  opposition_period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  opposition_period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  orders?: InputMaybe<Service_Request_Bool_Exp>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Bool_Exp>;
  owner_entity?: InputMaybe<Entity_Bool_Exp>;
  owner_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  priority_filing_data?: InputMaybe<Jsonb_Comparison_Exp>;
  registration_date?: InputMaybe<Date_Comparison_Exp>;
  registration_number?: InputMaybe<String_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  representative_entity?: InputMaybe<Entity_Bool_Exp>;
  representative_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_group?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Trademark_Tracking_Aggregate_Bool_Exp>;
  trademark_classes?: InputMaybe<Trademark_Class_Bool_Exp>;
  trademark_classes_aggregate?: InputMaybe<Trademark_Class_Aggregate_Bool_Exp>;
  trademark_registration_id_legacy?: InputMaybe<Int_Comparison_Exp>;
  trademark_request?: InputMaybe<Trademark_Request_Bool_Exp>;
  trademark_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark_shared_documents?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
  trademark_shared_documents_aggregate?: InputMaybe<Trademark_Shared_Documents_Aggregate_Bool_Exp>;
  trademark_watch_subscription?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
  trademark_watch_subscription_aggregate?: InputMaybe<Trademark_Watch_Subscription_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_in_commerce_requests?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  use_in_commerce_requests_aggregate?: InputMaybe<Use_In_Commerce_Request_Aggregate_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  uspto_logo_subcategory?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "trademark_class" */
export type Trademark_Class = {
  __typename?: 'trademark_class';
  class_items: Scalars['jsonb']['output'];
  class_number: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  decision?: Maybe<Scalars['use_in_commerce_request_class_decision_type']['output']>;
  document_folder_id: Scalars['uuid']['output'];
  filing_basis?: Maybe<Scalars['trademark_filing_basis_type']['output']>;
  filing_description?: Maybe<Scalars['String']['output']>;
  first_use_anywhere?: Maybe<Scalars['timestamptz']['output']>;
  first_use_in_us?: Maybe<Scalars['timestamptz']['output']>;
  foreign_registration_basis?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  specimens: Array<Specimen>;
  /** An aggregate relationship */
  specimens_aggregate: Specimen_Aggregate;
  /** An object relationship */
  trademark?: Maybe<Trademark>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  use_in_commerce_request?: Maybe<Use_In_Commerce_Request>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  websites: Scalars['jsonb']['output'];
};


/** columns and relationships of "trademark_class" */
export type Trademark_ClassClass_ItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark_class" */
export type Trademark_ClassForeign_Registration_BasisArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark_class" */
export type Trademark_ClassSpecimensArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


/** columns and relationships of "trademark_class" */
export type Trademark_ClassSpecimens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Specimen_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Specimen_Order_By>>;
  where?: InputMaybe<Specimen_Bool_Exp>;
};


/** columns and relationships of "trademark_class" */
export type Trademark_ClassWebsitesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "trademark_class" */
export type Trademark_Class_Aggregate = {
  __typename?: 'trademark_class_aggregate';
  aggregate?: Maybe<Trademark_Class_Aggregate_Fields>;
  nodes: Array<Trademark_Class>;
};

export type Trademark_Class_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trademark_Class_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Class_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Class_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_class" */
export type Trademark_Class_Aggregate_Fields = {
  __typename?: 'trademark_class_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Class_Max_Fields>;
  min?: Maybe<Trademark_Class_Min_Fields>;
};


/** aggregate fields of "trademark_class" */
export type Trademark_Class_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_class" */
export type Trademark_Class_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Class_Max_Order_By>;
  min?: InputMaybe<Trademark_Class_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Class_Append_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "trademark_class" */
export type Trademark_Class_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Class_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Class_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trademark_class". All fields are combined with a logical 'AND'. */
export type Trademark_Class_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Class_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Class_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Class_Bool_Exp>>;
  class_items?: InputMaybe<Jsonb_Comparison_Exp>;
  class_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  decision?: InputMaybe<Use_In_Commerce_Request_Class_Decision_Type_Comparison_Exp>;
  document_folder_id?: InputMaybe<Uuid_Comparison_Exp>;
  filing_basis?: InputMaybe<Trademark_Filing_Basis_Type_Comparison_Exp>;
  filing_description?: InputMaybe<String_Comparison_Exp>;
  first_use_anywhere?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_use_in_us?: InputMaybe<Timestamptz_Comparison_Exp>;
  foreign_registration_basis?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  specimens?: InputMaybe<Specimen_Bool_Exp>;
  specimens_aggregate?: InputMaybe<Specimen_Aggregate_Bool_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  use_in_commerce_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  websites?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_class" */
export enum Trademark_Class_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrademarkClassPkey = 'trademark_class_pkey',
  /** unique or primary key constraint on columns "trademark_id", "class_number" */
  TrademarkClassTrademarkUniqueKey = 'trademark_class_trademark_unique_key',
  /** unique or primary key constraint on columns "use_in_commerce_request_id", "class_number" */
  TrademarkClassUseInCommerceRequestUniqueKey = 'trademark_class_use_in_commerce_request_unique_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trademark_Class_Delete_At_Path_Input = {
  class_items?: InputMaybe<Array<Scalars['String']['input']>>;
  foreign_registration_basis?: InputMaybe<Array<Scalars['String']['input']>>;
  websites?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trademark_Class_Delete_Elem_Input = {
  class_items?: InputMaybe<Scalars['Int']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['Int']['input']>;
  websites?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trademark_Class_Delete_Key_Input = {
  class_items?: InputMaybe<Scalars['String']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['String']['input']>;
  websites?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "trademark_class" */
export type Trademark_Class_Insert_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  decision?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_basis?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  filing_description?: InputMaybe<Scalars['String']['input']>;
  first_use_anywhere?: InputMaybe<Scalars['timestamptz']['input']>;
  first_use_in_us?: InputMaybe<Scalars['timestamptz']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  specimens?: InputMaybe<Specimen_Arr_Rel_Insert_Input>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type Trademark_Class_Max_Fields = {
  __typename?: 'trademark_class_max_fields';
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  decision?: Maybe<Scalars['use_in_commerce_request_class_decision_type']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  filing_basis?: Maybe<Scalars['trademark_filing_basis_type']['output']>;
  filing_description?: Maybe<Scalars['String']['output']>;
  first_use_anywhere?: Maybe<Scalars['timestamptz']['output']>;
  first_use_in_us?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trademark_class" */
export type Trademark_Class_Max_Order_By = {
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  decision?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  filing_basis?: InputMaybe<Order_By>;
  filing_description?: InputMaybe<Order_By>;
  first_use_anywhere?: InputMaybe<Order_By>;
  first_use_in_us?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Class_Min_Fields = {
  __typename?: 'trademark_class_min_fields';
  class_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  decision?: Maybe<Scalars['use_in_commerce_request_class_decision_type']['output']>;
  document_folder_id?: Maybe<Scalars['uuid']['output']>;
  filing_basis?: Maybe<Scalars['trademark_filing_basis_type']['output']>;
  filing_description?: Maybe<Scalars['String']['output']>;
  first_use_anywhere?: Maybe<Scalars['timestamptz']['output']>;
  first_use_in_us?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trademark_class" */
export type Trademark_Class_Min_Order_By = {
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  decision?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  filing_basis?: InputMaybe<Order_By>;
  filing_description?: InputMaybe<Order_By>;
  first_use_anywhere?: InputMaybe<Order_By>;
  first_use_in_us?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_class" */
export type Trademark_Class_Mutation_Response = {
  __typename?: 'trademark_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Class>;
};

/** input type for inserting object relation for remote table "trademark_class" */
export type Trademark_Class_Obj_Rel_Insert_Input = {
  data: Trademark_Class_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Class_On_Conflict>;
};

/** on_conflict condition type for table "trademark_class" */
export type Trademark_Class_On_Conflict = {
  constraint: Trademark_Class_Constraint;
  update_columns?: Array<Trademark_Class_Update_Column>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_class". */
export type Trademark_Class_Order_By = {
  class_items?: InputMaybe<Order_By>;
  class_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  decision?: InputMaybe<Order_By>;
  document_folder_id?: InputMaybe<Order_By>;
  filing_basis?: InputMaybe<Order_By>;
  filing_description?: InputMaybe<Order_By>;
  first_use_anywhere?: InputMaybe<Order_By>;
  first_use_in_us?: InputMaybe<Order_By>;
  foreign_registration_basis?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  specimens_aggregate?: InputMaybe<Specimen_Aggregate_Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  websites?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_class */
export type Trademark_Class_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Class_Prepend_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['jsonb']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "trademark_class" */
export enum Trademark_Class_Select_Column {
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Decision = 'decision',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  FilingBasis = 'filing_basis',
  /** column name */
  FilingDescription = 'filing_description',
  /** column name */
  FirstUseAnywhere = 'first_use_anywhere',
  /** column name */
  FirstUseInUs = 'first_use_in_us',
  /** column name */
  ForeignRegistrationBasis = 'foreign_registration_basis',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  Websites = 'websites'
}

/** input type for updating data in table "trademark_class" */
export type Trademark_Class_Set_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  decision?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_basis?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  filing_description?: InputMaybe<Scalars['String']['input']>;
  first_use_anywhere?: InputMaybe<Scalars['timestamptz']['input']>;
  first_use_in_us?: InputMaybe<Scalars['timestamptz']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "trademark_class" */
export type Trademark_Class_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Class_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Class_Stream_Cursor_Value_Input = {
  class_items?: InputMaybe<Scalars['jsonb']['input']>;
  class_number?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  decision?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  document_folder_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_basis?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  filing_description?: InputMaybe<Scalars['String']['input']>;
  first_use_anywhere?: InputMaybe<Scalars['timestamptz']['input']>;
  first_use_in_us?: InputMaybe<Scalars['timestamptz']['input']>;
  foreign_registration_basis?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  websites?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "trademark_class" */
export enum Trademark_Class_Update_Column {
  /** column name */
  ClassItems = 'class_items',
  /** column name */
  ClassNumber = 'class_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Decision = 'decision',
  /** column name */
  DocumentFolderId = 'document_folder_id',
  /** column name */
  FilingBasis = 'filing_basis',
  /** column name */
  FilingDescription = 'filing_description',
  /** column name */
  FirstUseAnywhere = 'first_use_anywhere',
  /** column name */
  FirstUseInUs = 'first_use_in_us',
  /** column name */
  ForeignRegistrationBasis = 'foreign_registration_basis',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  Websites = 'websites'
}

export type Trademark_Class_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trademark_Class_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trademark_Class_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trademark_Class_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trademark_Class_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trademark_Class_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Class_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Class_Bool_Exp;
};

/** unique or primary key constraints on table "trademark" */
export enum Trademark_Constraint {
  /** unique or primary key constraint on columns "document_hub_id" */
  TrademarkDocumentHubIdKey = 'trademark_document_hub_id_key',
  /** unique or primary key constraint on columns "note_hub_id" */
  TrademarkNoteHubIdKey = 'trademark_note_hub_id_key',
  /** unique or primary key constraint on columns "id" */
  TrademarkPkey = 'trademark_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trademark_Delete_At_Path_Input = {
  additional_info?: InputMaybe<Array<Scalars['String']['input']>>;
  additional_info_legacy?: InputMaybe<Array<Scalars['String']['input']>>;
  assignee_history?: InputMaybe<Array<Scalars['String']['input']>>;
  filing_information?: InputMaybe<Array<Scalars['String']['input']>>;
  priority_filing_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trademark_Delete_Elem_Input = {
  additional_info?: InputMaybe<Scalars['Int']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['Int']['input']>;
  assignee_history?: InputMaybe<Scalars['Int']['input']>;
  filing_information?: InputMaybe<Scalars['Int']['input']>;
  priority_filing_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trademark_Delete_Key_Input = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['String']['input']>;
  assignee_history?: InputMaybe<Scalars['String']['input']>;
  filing_information?: InputMaybe<Scalars['String']['input']>;
  priority_filing_data?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "trademark_filing_basis_type". All fields are combined with logical 'AND'. */
export type Trademark_Filing_Basis_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _gt?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _gte?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _in?: InputMaybe<Array<Scalars['trademark_filing_basis_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _lte?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _neq?: InputMaybe<Scalars['trademark_filing_basis_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['trademark_filing_basis_type']['input']>>;
};

/** input type for incrementing numeric columns in table "trademark" */
export type Trademark_Inc_Input = {
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  trademark_registration_id_legacy?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "trademark" */
export type Trademark_Insert_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_registry_code?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  direct_filing?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  domicile_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  dou_deadline_date?: InputMaybe<Scalars['date']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  filing_information?: InputMaybe<Scalars['jsonb']['input']>;
  filing_postponed_note?: InputMaybe<Scalars['String']['input']>;
  filing_postponed_reason?: InputMaybe<Scalars['String']['input']>;
  filing_reference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  international_number?: InputMaybe<Scalars['String']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  last_ipo_data_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  mailing_address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  number?: InputMaybe<Scalars['String']['input']>;
  office_actions?: InputMaybe<Office_Action_Arr_Rel_Insert_Input>;
  opposition_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  opposition_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  orders?: InputMaybe<Service_Request_Arr_Rel_Insert_Input>;
  owner_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
  priority_filing_data?: InputMaybe<Scalars['jsonb']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  representative_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Trademark_Tracking_Arr_Rel_Insert_Input>;
  trademark_classes?: InputMaybe<Trademark_Class_Arr_Rel_Insert_Input>;
  trademark_registration_id_legacy?: InputMaybe<Scalars['Int']['input']>;
  trademark_request?: InputMaybe<Trademark_Request_Obj_Rel_Insert_Input>;
  trademark_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_shared_documents?: InputMaybe<Trademark_Shared_Documents_Arr_Rel_Insert_Input>;
  trademark_watch_subscription?: InputMaybe<Trademark_Watch_Subscription_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_in_commerce_requests?: InputMaybe<Use_In_Commerce_Request_Arr_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
};

/** IPO records to our trademarks downloaded from various external APIs */
export type Trademark_Ipo_Data = {
  __typename?: 'trademark_ipo_data';
  data: Scalars['jsonb']['output'];
  jurisdiction: Scalars['String']['output'];
  next_sync_due_at: Scalars['timestamptz']['output'];
  number: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  status_change_date?: Maybe<Scalars['timestamptz']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** IPO records to our trademarks downloaded from various external APIs */
export type Trademark_Ipo_DataDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "trademark_ipo_data" */
export type Trademark_Ipo_Data_Aggregate = {
  __typename?: 'trademark_ipo_data_aggregate';
  aggregate?: Maybe<Trademark_Ipo_Data_Aggregate_Fields>;
  nodes: Array<Trademark_Ipo_Data>;
};

/** aggregate fields of "trademark_ipo_data" */
export type Trademark_Ipo_Data_Aggregate_Fields = {
  __typename?: 'trademark_ipo_data_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Ipo_Data_Max_Fields>;
  min?: Maybe<Trademark_Ipo_Data_Min_Fields>;
};


/** aggregate fields of "trademark_ipo_data" */
export type Trademark_Ipo_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Ipo_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Ipo_Data_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "trademark_ipo_data". All fields are combined with a logical 'AND'. */
export type Trademark_Ipo_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Ipo_Data_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Ipo_Data_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  next_sync_due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_change_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_ipo_data" */
export enum Trademark_Ipo_Data_Constraint {
  /** unique or primary key constraint on columns "jurisdiction", "number" */
  TrademarkIpoDataPkey = 'trademark_ipo_data_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trademark_Ipo_Data_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trademark_Ipo_Data_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trademark_Ipo_Data_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "trademark_ipo_data" */
export type Trademark_Ipo_Data_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  next_sync_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Trademark_Ipo_Data_Max_Fields = {
  __typename?: 'trademark_ipo_data_max_fields';
  jurisdiction?: Maybe<Scalars['String']['output']>;
  next_sync_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_change_date?: Maybe<Scalars['timestamptz']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Trademark_Ipo_Data_Min_Fields = {
  __typename?: 'trademark_ipo_data_min_fields';
  jurisdiction?: Maybe<Scalars['String']['output']>;
  next_sync_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_change_date?: Maybe<Scalars['timestamptz']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "trademark_ipo_data" */
export type Trademark_Ipo_Data_Mutation_Response = {
  __typename?: 'trademark_ipo_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Ipo_Data>;
};

/** on_conflict condition type for table "trademark_ipo_data" */
export type Trademark_Ipo_Data_On_Conflict = {
  constraint: Trademark_Ipo_Data_Constraint;
  update_columns?: Array<Trademark_Ipo_Data_Update_Column>;
  where?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_ipo_data". */
export type Trademark_Ipo_Data_Order_By = {
  data?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  next_sync_due_at?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_change_date?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_ipo_data */
export type Trademark_Ipo_Data_Pk_Columns_Input = {
  jurisdiction: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Ipo_Data_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "trademark_ipo_data" */
export enum Trademark_Ipo_Data_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  NextSyncDueAt = 'next_sync_due_at',
  /** column name */
  Number = 'number',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangeDate = 'status_change_date',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "trademark_ipo_data" */
export type Trademark_Ipo_Data_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  next_sync_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "trademark_ipo_data" */
export type Trademark_Ipo_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Ipo_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Ipo_Data_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  next_sync_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_change_date?: InputMaybe<Scalars['timestamptz']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "trademark_ipo_data" */
export enum Trademark_Ipo_Data_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  NextSyncDueAt = 'next_sync_due_at',
  /** column name */
  Number = 'number',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  StatusChangeDate = 'status_change_date',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Trademark_Ipo_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trademark_Ipo_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trademark_Ipo_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trademark_Ipo_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trademark_Ipo_Data_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trademark_Ipo_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Ipo_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Ipo_Data_Bool_Exp;
};

/** aggregate max on columns */
export type Trademark_Max_Fields = {
  __typename?: 'trademark_max_fields';
  alias?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_registry_code?: Maybe<Scalars['uuid']['output']>;
  color_claim?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  dou_deadline_date?: Maybe<Scalars['date']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  filing_postponed_note?: Maybe<Scalars['String']['output']>;
  filing_postponed_reason?: Maybe<Scalars['String']['output']>;
  filing_reference?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  international_number?: Maybe<Scalars['String']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  last_ipo_data_sync?: Maybe<Scalars['timestamptz']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  logo_type?: Maybe<Scalars['String']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  opposition_period_end?: Maybe<Scalars['timestamptz']['output']>;
  opposition_period_start?: Maybe<Scalars['timestamptz']['output']>;
  owner_entity_id?: Maybe<Scalars['uuid']['output']>;
  registration_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_group?: Maybe<Scalars['String']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Int']['output']>;
  trademark_request_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "trademark" */
export type Trademark_Max_Order_By = {
  alias?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_registry_code?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  dou_deadline_date?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  filing_postponed_note?: InputMaybe<Order_By>;
  filing_postponed_reason?: InputMaybe<Order_By>;
  filing_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  international_number?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  last_ipo_data_sync?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  opposition_period_end?: InputMaybe<Order_By>;
  opposition_period_start?: InputMaybe<Order_By>;
  owner_entity_id?: InputMaybe<Order_By>;
  registration_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  representative_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
  trademark_request_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Min_Fields = {
  __typename?: 'trademark_min_fields';
  alias?: Maybe<Scalars['String']['output']>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  brand_id?: Maybe<Scalars['uuid']['output']>;
  brand_registry_code?: Maybe<Scalars['uuid']['output']>;
  color_claim?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  dou_deadline_date?: Maybe<Scalars['date']['output']>;
  expiration_date?: Maybe<Scalars['date']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  filing_postponed_note?: Maybe<Scalars['String']['output']>;
  filing_postponed_reason?: Maybe<Scalars['String']['output']>;
  filing_reference?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  international_number?: Maybe<Scalars['String']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  last_ipo_data_sync?: Maybe<Scalars['timestamptz']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  logo_type?: Maybe<Scalars['String']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  opposition_period_end?: Maybe<Scalars['timestamptz']['output']>;
  opposition_period_start?: Maybe<Scalars['timestamptz']['output']>;
  owner_entity_id?: Maybe<Scalars['uuid']['output']>;
  registration_date?: Maybe<Scalars['date']['output']>;
  registration_number?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  representative_entity_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_group?: Maybe<Scalars['String']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Int']['output']>;
  trademark_request_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  uspto_logo_subcategory?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "trademark" */
export type Trademark_Min_Order_By = {
  alias?: InputMaybe<Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_registry_code?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  dou_deadline_date?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  filing_postponed_note?: InputMaybe<Order_By>;
  filing_postponed_reason?: InputMaybe<Order_By>;
  filing_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  international_number?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  last_ipo_data_sync?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  opposition_period_end?: InputMaybe<Order_By>;
  opposition_period_start?: InputMaybe<Order_By>;
  owner_entity_id?: InputMaybe<Order_By>;
  registration_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  representative_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
  trademark_request_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
};

/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_Result = {
  __typename?: 'trademark_monitoring_result';
  application_number?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  filing_date?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction: Scalars['String']['output'];
  mark_name?: Maybe<Scalars['String']['output']>;
  mark_type?: Maybe<Scalars['String']['output']>;
  markify_data?: Maybe<Scalars['jsonb']['output']>;
  markify_logo_url?: Maybe<Scalars['String']['output']>;
  markify_report_id?: Maybe<Scalars['String']['output']>;
  order_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  orders: Array<Service_Request>;
  /** An aggregate relationship */
  orders_aggregate: Service_Request_Aggregate;
  publication_date?: Maybe<Scalars['date']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  relevance_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  seen: Scalars['Boolean']['output'];
  /** An object relationship */
  trademark: Trademark;
  trademark_id: Scalars['uuid']['output'];
  trademark_number?: Maybe<Scalars['String']['output']>;
  trademark_watch_subscription_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultClassesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultMarkify_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultOrdersArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "trademark_monitoring_result" */
export type Trademark_Monitoring_ResultOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};

/** aggregated selection of "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Aggregate = {
  __typename?: 'trademark_monitoring_result_aggregate';
  aggregate?: Maybe<Trademark_Monitoring_Result_Aggregate_Fields>;
  nodes: Array<Trademark_Monitoring_Result>;
};

export type Trademark_Monitoring_Result_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Trademark_Monitoring_Result_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_And = {
  arguments: Trademark_Monitoring_Result_Select_Column_Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Trademark_Monitoring_Result_Select_Column_Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Monitoring_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Aggregate_Fields = {
  __typename?: 'trademark_monitoring_result_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Monitoring_Result_Max_Fields>;
  min?: Maybe<Trademark_Monitoring_Result_Min_Fields>;
};


/** aggregate fields of "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Monitoring_Result_Max_Order_By>;
  min?: InputMaybe<Trademark_Monitoring_Result_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Monitoring_Result_Append_Input = {
  classes?: InputMaybe<Scalars['jsonb']['input']>;
  markify_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Monitoring_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Monitoring_Result_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trademark_monitoring_result". All fields are combined with a logical 'AND'. */
export type Trademark_Monitoring_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Monitoring_Result_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Monitoring_Result_Bool_Exp>>;
  application_number?: InputMaybe<String_Comparison_Exp>;
  classes?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  filing_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ipo_link?: InputMaybe<String_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  mark_name?: InputMaybe<String_Comparison_Exp>;
  mark_type?: InputMaybe<String_Comparison_Exp>;
  markify_data?: InputMaybe<Jsonb_Comparison_Exp>;
  markify_logo_url?: InputMaybe<String_Comparison_Exp>;
  markify_report_id?: InputMaybe<String_Comparison_Exp>;
  order_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  orders?: InputMaybe<Service_Request_Bool_Exp>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Bool_Exp>;
  publication_date?: InputMaybe<Date_Comparison_Exp>;
  relevance?: InputMaybe<String_Comparison_Exp>;
  relevance_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  seen?: InputMaybe<Boolean_Comparison_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark_number?: InputMaybe<String_Comparison_Exp>;
  trademark_watch_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_monitoring_result" */
export enum Trademark_Monitoring_Result_Constraint {
  /** unique or primary key constraint on columns "markify_report_id", "trademark_id", "jurisdiction", "trademark_watch_subscription_id", "trademark_number" */
  TrademarkMonitoringResultMarkifyReportIdCountryTrademark = 'trademark_monitoring_result_markify_report_id_country_trademark',
  /** unique or primary key constraint on columns "id" */
  TrademarkMonitoringResultPkey = 'trademark_monitoring_result_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trademark_Monitoring_Result_Delete_At_Path_Input = {
  classes?: InputMaybe<Array<Scalars['String']['input']>>;
  markify_data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trademark_Monitoring_Result_Delete_Elem_Input = {
  classes?: InputMaybe<Scalars['Int']['input']>;
  markify_data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trademark_Monitoring_Result_Delete_Key_Input = {
  classes?: InputMaybe<Scalars['String']['input']>;
  markify_data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Insert_Input = {
  application_number?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  mark_name?: InputMaybe<Scalars['String']['input']>;
  mark_type?: InputMaybe<Scalars['String']['input']>;
  markify_data?: InputMaybe<Scalars['jsonb']['input']>;
  markify_logo_url?: InputMaybe<Scalars['String']['input']>;
  markify_report_id?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  orders?: InputMaybe<Service_Request_Arr_Rel_Insert_Input>;
  publication_date?: InputMaybe<Scalars['date']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  relevance_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_number?: InputMaybe<Scalars['String']['input']>;
  trademark_watch_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Trademark_Monitoring_Result_Max_Fields = {
  __typename?: 'trademark_monitoring_result_max_fields';
  application_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  mark_name?: Maybe<Scalars['String']['output']>;
  mark_type?: Maybe<Scalars['String']['output']>;
  markify_logo_url?: Maybe<Scalars['String']['output']>;
  markify_report_id?: Maybe<Scalars['String']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  publication_date?: Maybe<Scalars['date']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  relevance_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  trademark_number?: Maybe<Scalars['String']['output']>;
  trademark_watch_subscription_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Max_Order_By = {
  application_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  mark_name?: InputMaybe<Order_By>;
  mark_type?: InputMaybe<Order_By>;
  markify_logo_url?: InputMaybe<Order_By>;
  markify_report_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  publication_date?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  relevance_updated_at?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  trademark_number?: InputMaybe<Order_By>;
  trademark_watch_subscription_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Monitoring_Result_Min_Fields = {
  __typename?: 'trademark_monitoring_result_min_fields';
  application_number?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  filing_date?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ipo_link?: Maybe<Scalars['String']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  mark_name?: Maybe<Scalars['String']['output']>;
  mark_type?: Maybe<Scalars['String']['output']>;
  markify_logo_url?: Maybe<Scalars['String']['output']>;
  markify_report_id?: Maybe<Scalars['String']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  publication_date?: Maybe<Scalars['date']['output']>;
  relevance?: Maybe<Scalars['String']['output']>;
  relevance_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  trademark_number?: Maybe<Scalars['String']['output']>;
  trademark_watch_subscription_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Min_Order_By = {
  application_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  mark_name?: InputMaybe<Order_By>;
  mark_type?: InputMaybe<Order_By>;
  markify_logo_url?: InputMaybe<Order_By>;
  markify_report_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  publication_date?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  relevance_updated_at?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  trademark_number?: InputMaybe<Order_By>;
  trademark_watch_subscription_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Mutation_Response = {
  __typename?: 'trademark_monitoring_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Monitoring_Result>;
};

/** on_conflict condition type for table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_On_Conflict = {
  constraint: Trademark_Monitoring_Result_Constraint;
  update_columns?: Array<Trademark_Monitoring_Result_Update_Column>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_monitoring_result". */
export type Trademark_Monitoring_Result_Order_By = {
  application_number?: InputMaybe<Order_By>;
  classes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  filing_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  mark_name?: InputMaybe<Order_By>;
  mark_type?: InputMaybe<Order_By>;
  markify_data?: InputMaybe<Order_By>;
  markify_logo_url?: InputMaybe<Order_By>;
  markify_report_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Order_By>;
  publication_date?: InputMaybe<Order_By>;
  relevance?: InputMaybe<Order_By>;
  relevance_updated_at?: InputMaybe<Order_By>;
  seen?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  trademark_number?: InputMaybe<Order_By>;
  trademark_watch_subscription_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_monitoring_result */
export type Trademark_Monitoring_Result_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Monitoring_Result_Prepend_Input = {
  classes?: InputMaybe<Scalars['jsonb']['input']>;
  markify_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "trademark_monitoring_result" */
export enum Trademark_Monitoring_Result_Select_Column {
  /** column name */
  ApplicationNumber = 'application_number',
  /** column name */
  Classes = 'classes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  Id = 'id',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  MarkName = 'mark_name',
  /** column name */
  MarkType = 'mark_type',
  /** column name */
  MarkifyData = 'markify_data',
  /** column name */
  MarkifyLogoUrl = 'markify_logo_url',
  /** column name */
  MarkifyReportId = 'markify_report_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  PublicationDate = 'publication_date',
  /** column name */
  Relevance = 'relevance',
  /** column name */
  RelevanceUpdatedAt = 'relevance_updated_at',
  /** column name */
  Seen = 'seen',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  TrademarkNumber = 'trademark_number',
  /** column name */
  TrademarkWatchSubscriptionId = 'trademark_watch_subscription_id',
  /** column name */
  Type = 'type'
}

/** select "trademark_monitoring_result_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trademark_monitoring_result" */
export enum Trademark_Monitoring_Result_Select_Column_Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Seen = 'seen'
}

/** select "trademark_monitoring_result_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trademark_monitoring_result" */
export enum Trademark_Monitoring_Result_Select_Column_Trademark_Monitoring_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Seen = 'seen'
}

/** input type for updating data in table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Set_Input = {
  application_number?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  mark_name?: InputMaybe<Scalars['String']['input']>;
  mark_type?: InputMaybe<Scalars['String']['input']>;
  markify_data?: InputMaybe<Scalars['jsonb']['input']>;
  markify_logo_url?: InputMaybe<Scalars['String']['input']>;
  markify_report_id?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  publication_date?: InputMaybe<Scalars['date']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  relevance_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_number?: InputMaybe<Scalars['String']['input']>;
  trademark_watch_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "trademark_monitoring_result" */
export type Trademark_Monitoring_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Monitoring_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Monitoring_Result_Stream_Cursor_Value_Input = {
  application_number?: InputMaybe<Scalars['String']['input']>;
  classes?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  mark_name?: InputMaybe<Scalars['String']['input']>;
  mark_type?: InputMaybe<Scalars['String']['input']>;
  markify_data?: InputMaybe<Scalars['jsonb']['input']>;
  markify_logo_url?: InputMaybe<Scalars['String']['input']>;
  markify_report_id?: InputMaybe<Scalars['String']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  publication_date?: InputMaybe<Scalars['date']['input']>;
  relevance?: InputMaybe<Scalars['String']['input']>;
  relevance_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_number?: InputMaybe<Scalars['String']['input']>;
  trademark_watch_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trademark_monitoring_result" */
export enum Trademark_Monitoring_Result_Update_Column {
  /** column name */
  ApplicationNumber = 'application_number',
  /** column name */
  Classes = 'classes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  Id = 'id',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  MarkName = 'mark_name',
  /** column name */
  MarkType = 'mark_type',
  /** column name */
  MarkifyData = 'markify_data',
  /** column name */
  MarkifyLogoUrl = 'markify_logo_url',
  /** column name */
  MarkifyReportId = 'markify_report_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  PublicationDate = 'publication_date',
  /** column name */
  Relevance = 'relevance',
  /** column name */
  RelevanceUpdatedAt = 'relevance_updated_at',
  /** column name */
  Seen = 'seen',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  TrademarkNumber = 'trademark_number',
  /** column name */
  TrademarkWatchSubscriptionId = 'trademark_watch_subscription_id',
  /** column name */
  Type = 'type'
}

export type Trademark_Monitoring_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trademark_Monitoring_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trademark_Monitoring_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trademark_Monitoring_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trademark_Monitoring_Result_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trademark_Monitoring_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Monitoring_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Monitoring_Result_Bool_Exp;
};

/** response of any mutation on the table "trademark" */
export type Trademark_Mutation_Response = {
  __typename?: 'trademark_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark>;
};

/** input type for inserting object relation for remote table "trademark" */
export type Trademark_Obj_Rel_Insert_Input = {
  data: Trademark_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_On_Conflict>;
};

/** on_conflict condition type for table "trademark" */
export type Trademark_On_Conflict = {
  constraint: Trademark_Constraint;
  update_columns?: Array<Trademark_Update_Column>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark". */
export type Trademark_Order_By = {
  additional_info?: InputMaybe<Order_By>;
  additional_info_legacy?: InputMaybe<Order_By>;
  alias?: InputMaybe<Order_By>;
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  assignee_history?: InputMaybe<Order_By>;
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  brand_registry_code?: InputMaybe<Order_By>;
  color_claim?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  direct_filing?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  domicile_address?: InputMaybe<Address_Order_By>;
  domicile_address_id?: InputMaybe<Order_By>;
  dou_deadline_date?: InputMaybe<Order_By>;
  expiration_date?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  filing_information?: InputMaybe<Order_By>;
  filing_postponed_note?: InputMaybe<Order_By>;
  filing_postponed_reason?: InputMaybe<Order_By>;
  filing_reference?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  international_number?: InputMaybe<Order_By>;
  ipo_link?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  last_ipo_data_sync?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  logo_type?: InputMaybe<Order_By>;
  mailing_address?: InputMaybe<Address_Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  number?: InputMaybe<Order_By>;
  office_actions_aggregate?: InputMaybe<Office_Action_Aggregate_Order_By>;
  opposition_period_end?: InputMaybe<Order_By>;
  opposition_period_start?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Order_By>;
  owner_entity?: InputMaybe<Entity_Order_By>;
  owner_entity_id?: InputMaybe<Order_By>;
  parent_use_in_commerce_request?: InputMaybe<Use_In_Commerce_Request_Order_By>;
  priority_filing_data?: InputMaybe<Order_By>;
  registration_date?: InputMaybe<Order_By>;
  registration_number?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  representative_entity?: InputMaybe<Entity_Order_By>;
  representative_entity_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_group?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Trademark_Tracking_Aggregate_Order_By>;
  trademark_classes_aggregate?: InputMaybe<Trademark_Class_Aggregate_Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
  trademark_request?: InputMaybe<Trademark_Request_Order_By>;
  trademark_request_id?: InputMaybe<Order_By>;
  trademark_shared_documents_aggregate?: InputMaybe<Trademark_Shared_Documents_Aggregate_Order_By>;
  trademark_watch_subscription_aggregate?: InputMaybe<Trademark_Watch_Subscription_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  use_in_commerce_requests_aggregate?: InputMaybe<Use_In_Commerce_Request_Aggregate_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  uspto_logo_subcategory?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark */
export type Trademark_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** trademark_portfolio_searchNative Query Arguments */
export type Trademark_Portfolio_Search_Arguments = {
  query: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};

/** trademark_portfolio_search_countNative Query Arguments */
export type Trademark_Portfolio_Search_Count_Arguments = {
  query: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};

export type Trademark_Portfolio_Search_Result = {
  __typename?: 'trademark_portfolio_search_result';
  dmetaphone_score: Scalars['Float']['output'];
  filing_date?: Maybe<Scalars['date']['output']>;
  fts_score: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  jurisdiction: Scalars['String']['output'];
  levenshtein_score: Scalars['Float']['output'];
  metaphone_score: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  registration_date?: Maybe<Scalars['date']['output']>;
  score: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  trigram_score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the logical model for "trademark_portfolio_search_result". All fields are combined with a logical 'AND'. */
export type Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Portfolio_Search_Result_Bool_Exp_Bool_Exp>>;
  dmetaphone_score?: InputMaybe<Float_Comparison_Exp>;
  filing_date?: InputMaybe<Date_Comparison_Exp>;
  fts_score?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  levenshtein_score?: InputMaybe<Float_Comparison_Exp>;
  metaphone_score?: InputMaybe<Float_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  registration_date?: InputMaybe<Date_Comparison_Exp>;
  score?: InputMaybe<Float_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trigram_score?: InputMaybe<Float_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export enum Trademark_Portfolio_Search_Result_Enum_Name {
  /** column name */
  DmetaphoneScore = 'dmetaphone_score',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  FtsScore = 'fts_score',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LevenshteinScore = 'levenshtein_score',
  /** column name */
  MetaphoneScore = 'metaphone_score',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  TrigramScore = 'trigram_score',
  /** column name */
  Type = 'type'
}

/** Ordering options when selecting data from "trademark_portfolio_search_result". */
export type Trademark_Portfolio_Search_Result_Order_By = {
  dmetaphone_score?: InputMaybe<Order_By>;
  filing_date?: InputMaybe<Order_By>;
  fts_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  levenshtein_score?: InputMaybe<Order_By>;
  metaphone_score?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  registration_date?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigram_score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Prepend_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['jsonb']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  filing_information?: InputMaybe<Scalars['jsonb']['input']>;
  priority_filing_data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log = {
  __typename?: 'trademark_rate_limit_log';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  request_count: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

/** aggregated selection of "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Aggregate = {
  __typename?: 'trademark_rate_limit_log_aggregate';
  aggregate?: Maybe<Trademark_Rate_Limit_Log_Aggregate_Fields>;
  nodes: Array<Trademark_Rate_Limit_Log>;
};

/** aggregate fields of "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Aggregate_Fields = {
  __typename?: 'trademark_rate_limit_log_aggregate_fields';
  avg?: Maybe<Trademark_Rate_Limit_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Rate_Limit_Log_Max_Fields>;
  min?: Maybe<Trademark_Rate_Limit_Log_Min_Fields>;
  stddev?: Maybe<Trademark_Rate_Limit_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Trademark_Rate_Limit_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trademark_Rate_Limit_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Trademark_Rate_Limit_Log_Sum_Fields>;
  var_pop?: Maybe<Trademark_Rate_Limit_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Trademark_Rate_Limit_Log_Var_Samp_Fields>;
  variance?: Maybe<Trademark_Rate_Limit_Log_Variance_Fields>;
};


/** aggregate fields of "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Rate_Limit_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Trademark_Rate_Limit_Log_Avg_Fields = {
  __typename?: 'trademark_rate_limit_log_avg_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "trademark_rate_limit_log". All fields are combined with a logical 'AND'. */
export type Trademark_Rate_Limit_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Rate_Limit_Log_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Rate_Limit_Log_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  request_count?: InputMaybe<Int_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_rate_limit_log" */
export enum Trademark_Rate_Limit_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrademarkRateLimitLogPkey = 'trademark_rate_limit_log_pkey'
}

/** input type for incrementing numeric columns in table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Inc_Input = {
  request_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_count?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Trademark_Rate_Limit_Log_Max_Fields = {
  __typename?: 'trademark_rate_limit_log_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  request_count?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Trademark_Rate_Limit_Log_Min_Fields = {
  __typename?: 'trademark_rate_limit_log_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  request_count?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Mutation_Response = {
  __typename?: 'trademark_rate_limit_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Rate_Limit_Log>;
};

/** on_conflict condition type for table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_On_Conflict = {
  constraint: Trademark_Rate_Limit_Log_Constraint;
  update_columns?: Array<Trademark_Rate_Limit_Log_Update_Column>;
  where?: InputMaybe<Trademark_Rate_Limit_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_rate_limit_log". */
export type Trademark_Rate_Limit_Log_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_count?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_rate_limit_log */
export type Trademark_Rate_Limit_Log_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trademark_rate_limit_log" */
export enum Trademark_Rate_Limit_Log_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RequestCount = 'request_count',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_count?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Trademark_Rate_Limit_Log_Stddev_Fields = {
  __typename?: 'trademark_rate_limit_log_stddev_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Trademark_Rate_Limit_Log_Stddev_Pop_Fields = {
  __typename?: 'trademark_rate_limit_log_stddev_pop_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Trademark_Rate_Limit_Log_Stddev_Samp_Fields = {
  __typename?: 'trademark_rate_limit_log_stddev_samp_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "trademark_rate_limit_log" */
export type Trademark_Rate_Limit_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Rate_Limit_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Rate_Limit_Log_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  request_count?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Trademark_Rate_Limit_Log_Sum_Fields = {
  __typename?: 'trademark_rate_limit_log_sum_fields';
  request_count?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "trademark_rate_limit_log" */
export enum Trademark_Rate_Limit_Log_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RequestCount = 'request_count',
  /** column name */
  Source = 'source'
}

export type Trademark_Rate_Limit_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trademark_Rate_Limit_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Rate_Limit_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Rate_Limit_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trademark_Rate_Limit_Log_Var_Pop_Fields = {
  __typename?: 'trademark_rate_limit_log_var_pop_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Trademark_Rate_Limit_Log_Var_Samp_Fields = {
  __typename?: 'trademark_rate_limit_log_var_samp_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Trademark_Rate_Limit_Log_Variance_Fields = {
  __typename?: 'trademark_rate_limit_log_variance_fields';
  request_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "trademark_request" */
export type Trademark_Request = {
  __typename?: 'trademark_request';
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  jurisdictions?: Maybe<Scalars['jsonb']['output']>;
  mark_alias: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  trademarks: Array<Trademark>;
  /** An aggregate relationship */
  trademarks_aggregate: Trademark_Aggregate;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "trademark_request" */
export type Trademark_RequestJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "trademark_request" */
export type Trademark_RequestTrademarksArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};


/** columns and relationships of "trademark_request" */
export type Trademark_RequestTrademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Order_By>>;
  where?: InputMaybe<Trademark_Bool_Exp>;
};

/** aggregated selection of "trademark_request" */
export type Trademark_Request_Aggregate = {
  __typename?: 'trademark_request_aggregate';
  aggregate?: Maybe<Trademark_Request_Aggregate_Fields>;
  nodes: Array<Trademark_Request>;
};

/** aggregate fields of "trademark_request" */
export type Trademark_Request_Aggregate_Fields = {
  __typename?: 'trademark_request_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Request_Max_Fields>;
  min?: Maybe<Trademark_Request_Min_Fields>;
};


/** aggregate fields of "trademark_request" */
export type Trademark_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Request_Append_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "trademark_request". All fields are combined with a logical 'AND'. */
export type Trademark_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Request_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Request_Bool_Exp>>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  mark_alias?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trademarks?: InputMaybe<Trademark_Bool_Exp>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_request" */
export enum Trademark_Request_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrademarkRequestPkey = 'trademark_request_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trademark_Request_Delete_At_Path_Input = {
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trademark_Request_Delete_Elem_Input = {
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trademark_Request_Delete_Key_Input = {
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "trademark_request" */
export type Trademark_Request_Insert_Input = {
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trademarks?: InputMaybe<Trademark_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trademark_Request_Max_Fields = {
  __typename?: 'trademark_request_max_fields';
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mark_alias?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Trademark_Request_Min_Fields = {
  __typename?: 'trademark_request_min_fields';
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mark_alias?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "trademark_request" */
export type Trademark_Request_Mutation_Response = {
  __typename?: 'trademark_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Request>;
};

/** input type for inserting object relation for remote table "trademark_request" */
export type Trademark_Request_Obj_Rel_Insert_Input = {
  data: Trademark_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Request_On_Conflict>;
};

/** on_conflict condition type for table "trademark_request" */
export type Trademark_Request_On_Conflict = {
  constraint: Trademark_Request_Constraint;
  update_columns?: Array<Trademark_Request_Update_Column>;
  where?: InputMaybe<Trademark_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_request". */
export type Trademark_Request_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  mark_alias?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademarks_aggregate?: InputMaybe<Trademark_Aggregate_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_request */
export type Trademark_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trademark_Request_Prepend_Input = {
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "trademark_request" */
export enum Trademark_Request_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  MarkAlias = 'mark_alias',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "trademark_request" */
export type Trademark_Request_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "trademark_request" */
export type Trademark_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Request_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  mark_alias?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trademark_request" */
export enum Trademark_Request_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  MarkAlias = 'mark_alias',
  /** column name */
  Status = 'status',
  /** column name */
  UserId = 'user_id'
}

export type Trademark_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trademark_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trademark_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trademark_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trademark_Request_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trademark_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Request_Bool_Exp;
};

/** trademark_searchNative Query Arguments */
export type Trademark_Search_Arguments = {
  /** Comma-separated list of formatted class codes */
  classes?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of jurisdictions */
  jurisdictions: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type Trademark_Search_Result = {
  __typename?: 'trademark_search_result';
  classes?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  dmetaphone_score: Scalars['Float']['output'];
  fts_score: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  jurisdiction: Scalars['String']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  levenshtein_score: Scalars['Float']['output'];
  metaphone_score: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  trigram_score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the logical model for "trademark_search_result". All fields are combined with a logical 'AND'. */
export type Trademark_Search_Result_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Search_Result_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Search_Result_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Search_Result_Bool_Exp_Bool_Exp>>;
  classes?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dmetaphone_score?: InputMaybe<Float_Comparison_Exp>;
  fts_score?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdiction?: InputMaybe<String_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  levenshtein_score?: InputMaybe<Float_Comparison_Exp>;
  metaphone_score?: InputMaybe<Float_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Float_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trigram_score?: InputMaybe<Float_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export enum Trademark_Search_Result_Enum_Name {
  /** column name */
  Classes = 'classes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DmetaphoneScore = 'dmetaphone_score',
  /** column name */
  FtsScore = 'fts_score',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LevenshteinScore = 'levenshtein_score',
  /** column name */
  MetaphoneScore = 'metaphone_score',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  TrigramScore = 'trigram_score',
  /** column name */
  Type = 'type'
}

/** Ordering options when selecting data from "trademark_search_result". */
export type Trademark_Search_Result_Order_By = {
  classes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dmetaphone_score?: InputMaybe<Order_By>;
  fts_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdiction?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  levenshtein_score?: InputMaybe<Order_By>;
  metaphone_score?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigram_score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "trademark" */
export enum Trademark_Select_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  AdditionalInfoLegacy = 'additional_info_legacy',
  /** column name */
  Alias = 'alias',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandRegistryCode = 'brand_registry_code',
  /** column name */
  ColorClaim = 'color_claim',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DirectFiling = 'direct_filing',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DomicileAddressId = 'domicile_address_id',
  /** column name */
  DouDeadlineDate = 'dou_deadline_date',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  FilingInformation = 'filing_information',
  /** column name */
  FilingPostponedNote = 'filing_postponed_note',
  /** column name */
  FilingPostponedReason = 'filing_postponed_reason',
  /** column name */
  FilingReference = 'filing_reference',
  /** column name */
  Id = 'id',
  /** column name */
  InternationalNumber = 'international_number',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LastIpoDataSync = 'last_ipo_data_sync',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LogoType = 'logo_type',
  /** column name */
  MailingAddressId = 'mailing_address_id',
  /** column name */
  Name = 'name',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Number = 'number',
  /** column name */
  OppositionPeriodEnd = 'opposition_period_end',
  /** column name */
  OppositionPeriodStart = 'opposition_period_start',
  /** column name */
  OwnerEntityId = 'owner_entity_id',
  /** column name */
  PriorityFilingData = 'priority_filing_data',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusGroup = 'status_group',
  /** column name */
  TrademarkRegistrationIdLegacy = 'trademark_registration_id_legacy',
  /** column name */
  TrademarkRequestId = 'trademark_request_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UsptoLogoSubcategory = 'uspto_logo_subcategory'
}

/** select "trademark_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trademark" */
export enum Trademark_Select_Column_Trademark_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DirectFiling = 'direct_filing'
}

/** select "trademark_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trademark" */
export enum Trademark_Select_Column_Trademark_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DirectFiling = 'direct_filing'
}

/** columns and relationships of "trademark_service_requests" */
export type Trademark_Service_Requests = {
  __typename?: 'trademark_service_requests';
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
  service_request_id: Scalars['uuid']['output'];
  /** An object relationship */
  trademark?: Maybe<Trademark>;
  trademark_id: Scalars['uuid']['output'];
};

/** aggregated selection of "trademark_service_requests" */
export type Trademark_Service_Requests_Aggregate = {
  __typename?: 'trademark_service_requests_aggregate';
  aggregate?: Maybe<Trademark_Service_Requests_Aggregate_Fields>;
  nodes: Array<Trademark_Service_Requests>;
};

export type Trademark_Service_Requests_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trademark_Service_Requests_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Service_Requests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_service_requests" */
export type Trademark_Service_Requests_Aggregate_Fields = {
  __typename?: 'trademark_service_requests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Service_Requests_Max_Fields>;
  min?: Maybe<Trademark_Service_Requests_Min_Fields>;
};


/** aggregate fields of "trademark_service_requests" */
export type Trademark_Service_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Service_Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_service_requests" */
export type Trademark_Service_Requests_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Service_Requests_Max_Order_By>;
  min?: InputMaybe<Trademark_Service_Requests_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trademark_service_requests" */
export type Trademark_Service_Requests_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Service_Requests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Service_Requests_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trademark_service_requests". All fields are combined with a logical 'AND'. */
export type Trademark_Service_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Service_Requests_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Service_Requests_Bool_Exp>>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_service_requests" */
export enum Trademark_Service_Requests_Constraint {
  /** unique or primary key constraint on columns "service_request_id", "trademark_id" */
  TrademarkServiceRequestsPkey = 'trademark_service_requests_pkey'
}

/** input type for inserting data into table "trademark_service_requests" */
export type Trademark_Service_Requests_Insert_Input = {
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trademark_Service_Requests_Max_Fields = {
  __typename?: 'trademark_service_requests_max_fields';
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trademark_service_requests" */
export type Trademark_Service_Requests_Max_Order_By = {
  service_request_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Service_Requests_Min_Fields = {
  __typename?: 'trademark_service_requests_min_fields';
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trademark_service_requests" */
export type Trademark_Service_Requests_Min_Order_By = {
  service_request_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_service_requests" */
export type Trademark_Service_Requests_Mutation_Response = {
  __typename?: 'trademark_service_requests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Service_Requests>;
};

/** on_conflict condition type for table "trademark_service_requests" */
export type Trademark_Service_Requests_On_Conflict = {
  constraint: Trademark_Service_Requests_Constraint;
  update_columns?: Array<Trademark_Service_Requests_Update_Column>;
  where?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_service_requests". */
export type Trademark_Service_Requests_Order_By = {
  service_request?: InputMaybe<Service_Request_Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_service_requests */
export type Trademark_Service_Requests_Pk_Columns_Input = {
  service_request_id: Scalars['uuid']['input'];
  trademark_id: Scalars['uuid']['input'];
};

/** select columns of table "trademark_service_requests" */
export enum Trademark_Service_Requests_Select_Column {
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  TrademarkId = 'trademark_id'
}

/** input type for updating data in table "trademark_service_requests" */
export type Trademark_Service_Requests_Set_Input = {
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "trademark_service_requests" */
export type Trademark_Service_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Service_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Service_Requests_Stream_Cursor_Value_Input = {
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trademark_service_requests" */
export enum Trademark_Service_Requests_Update_Column {
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  TrademarkId = 'trademark_id'
}

export type Trademark_Service_Requests_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Service_Requests_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Service_Requests_Bool_Exp;
};

/** input type for updating data in table "trademark" */
export type Trademark_Set_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_registry_code?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  direct_filing?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  dou_deadline_date?: InputMaybe<Scalars['date']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  filing_information?: InputMaybe<Scalars['jsonb']['input']>;
  filing_postponed_note?: InputMaybe<Scalars['String']['input']>;
  filing_postponed_reason?: InputMaybe<Scalars['String']['input']>;
  filing_reference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  international_number?: InputMaybe<Scalars['String']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  last_ipo_data_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  opposition_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  opposition_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  priority_filing_data?: InputMaybe<Scalars['jsonb']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  trademark_registration_id_legacy?: InputMaybe<Scalars['Int']['input']>;
  trademark_request_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "trademark_shared_documents" */
export type Trademark_Shared_Documents = {
  __typename?: 'trademark_shared_documents';
  /** An object relationship */
  document: Document;
  document_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  trademark: Trademark;
  trademark_id: Scalars['uuid']['output'];
};

/** aggregated selection of "trademark_shared_documents" */
export type Trademark_Shared_Documents_Aggregate = {
  __typename?: 'trademark_shared_documents_aggregate';
  aggregate?: Maybe<Trademark_Shared_Documents_Aggregate_Fields>;
  nodes: Array<Trademark_Shared_Documents>;
};

export type Trademark_Shared_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trademark_Shared_Documents_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Shared_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_shared_documents" */
export type Trademark_Shared_Documents_Aggregate_Fields = {
  __typename?: 'trademark_shared_documents_aggregate_fields';
  avg?: Maybe<Trademark_Shared_Documents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Shared_Documents_Max_Fields>;
  min?: Maybe<Trademark_Shared_Documents_Min_Fields>;
  stddev?: Maybe<Trademark_Shared_Documents_Stddev_Fields>;
  stddev_pop?: Maybe<Trademark_Shared_Documents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trademark_Shared_Documents_Stddev_Samp_Fields>;
  sum?: Maybe<Trademark_Shared_Documents_Sum_Fields>;
  var_pop?: Maybe<Trademark_Shared_Documents_Var_Pop_Fields>;
  var_samp?: Maybe<Trademark_Shared_Documents_Var_Samp_Fields>;
  variance?: Maybe<Trademark_Shared_Documents_Variance_Fields>;
};


/** aggregate fields of "trademark_shared_documents" */
export type Trademark_Shared_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Shared_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Trademark_Shared_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Shared_Documents_Max_Order_By>;
  min?: InputMaybe<Trademark_Shared_Documents_Min_Order_By>;
  stddev?: InputMaybe<Trademark_Shared_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trademark_Shared_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trademark_Shared_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trademark_Shared_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Trademark_Shared_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trademark_Shared_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Trademark_Shared_Documents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Shared_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Shared_Documents_On_Conflict>;
};

/** aggregate avg on columns */
export type Trademark_Shared_Documents_Avg_Fields = {
  __typename?: 'trademark_shared_documents_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trademark_shared_documents". All fields are combined with a logical 'AND'. */
export type Trademark_Shared_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Shared_Documents_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Shared_Documents_Bool_Exp>>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_shared_documents" */
export enum Trademark_Shared_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  TrademarkSharedDocumentsPkey = 'trademark_shared_documents_pkey',
  /** unique or primary key constraint on columns "trademark_id", "document_id" */
  TrademarkSharedDocumentsTrademarkIdDocumentIdKey = 'trademark_shared_documents_trademark_id_document_id_key'
}

/** input type for incrementing numeric columns in table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Insert_Input = {
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trademark_Shared_Documents_Max_Fields = {
  __typename?: 'trademark_shared_documents_max_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Shared_Documents_Min_Fields = {
  __typename?: 'trademark_shared_documents_min_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Mutation_Response = {
  __typename?: 'trademark_shared_documents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Shared_Documents>;
};

/** on_conflict condition type for table "trademark_shared_documents" */
export type Trademark_Shared_Documents_On_Conflict = {
  constraint: Trademark_Shared_Documents_Constraint;
  update_columns?: Array<Trademark_Shared_Documents_Update_Column>;
  where?: InputMaybe<Trademark_Shared_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_shared_documents". */
export type Trademark_Shared_Documents_Order_By = {
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_shared_documents */
export type Trademark_Shared_Documents_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "trademark_shared_documents" */
export enum Trademark_Shared_Documents_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkId = 'trademark_id'
}

/** input type for updating data in table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Set_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Trademark_Shared_Documents_Stddev_Fields = {
  __typename?: 'trademark_shared_documents_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trademark_Shared_Documents_Stddev_Pop_Fields = {
  __typename?: 'trademark_shared_documents_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trademark_Shared_Documents_Stddev_Samp_Fields = {
  __typename?: 'trademark_shared_documents_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Shared_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Shared_Documents_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Trademark_Shared_Documents_Sum_Fields = {
  __typename?: 'trademark_shared_documents_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "trademark_shared_documents" */
export enum Trademark_Shared_Documents_Update_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  TrademarkId = 'trademark_id'
}

export type Trademark_Shared_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trademark_Shared_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Shared_Documents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Shared_Documents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trademark_Shared_Documents_Var_Pop_Fields = {
  __typename?: 'trademark_shared_documents_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trademark_Shared_Documents_Var_Samp_Fields = {
  __typename?: 'trademark_shared_documents_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trademark_Shared_Documents_Variance_Fields = {
  __typename?: 'trademark_shared_documents_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "trademark_shared_documents" */
export type Trademark_Shared_Documents_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev on columns */
export type Trademark_Stddev_Fields = {
  __typename?: 'trademark_stddev_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "trademark" */
export type Trademark_Stddev_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trademark_Stddev_Pop_Fields = {
  __typename?: 'trademark_stddev_pop_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "trademark" */
export type Trademark_Stddev_Pop_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trademark_Stddev_Samp_Fields = {
  __typename?: 'trademark_stddev_samp_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "trademark" */
export type Trademark_Stddev_Samp_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trademark" */
export type Trademark_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Stream_Cursor_Value_Input = {
  additional_info?: InputMaybe<Scalars['jsonb']['input']>;
  additional_info_legacy?: InputMaybe<Scalars['jsonb']['input']>;
  alias?: InputMaybe<Scalars['String']['input']>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  brand_registry_code?: InputMaybe<Scalars['uuid']['input']>;
  color_claim?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  direct_filing?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  domicile_address_id?: InputMaybe<Scalars['Int']['input']>;
  dou_deadline_date?: InputMaybe<Scalars['date']['input']>;
  expiration_date?: InputMaybe<Scalars['date']['input']>;
  filing_date?: InputMaybe<Scalars['date']['input']>;
  filing_information?: InputMaybe<Scalars['jsonb']['input']>;
  filing_postponed_note?: InputMaybe<Scalars['String']['input']>;
  filing_postponed_reason?: InputMaybe<Scalars['String']['input']>;
  filing_reference?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  international_number?: InputMaybe<Scalars['String']['input']>;
  ipo_link?: InputMaybe<Scalars['String']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  last_ipo_data_sync?: InputMaybe<Scalars['timestamptz']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  logo_type?: InputMaybe<Scalars['String']['input']>;
  mailing_address_id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  opposition_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  opposition_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  priority_filing_data?: InputMaybe<Scalars['jsonb']['input']>;
  registration_date?: InputMaybe<Scalars['date']['input']>;
  registration_number?: InputMaybe<Scalars['String']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  representative_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_group?: InputMaybe<Scalars['String']['input']>;
  trademark_registration_id_legacy?: InputMaybe<Scalars['Int']['input']>;
  trademark_request_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  uspto_logo_subcategory?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Trademark_Sum_Fields = {
  __typename?: 'trademark_sum_fields';
  domicile_address_id?: Maybe<Scalars['Int']['output']>;
  mailing_address_id?: Maybe<Scalars['Int']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "trademark" */
export type Trademark_Sum_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** columns and relationships of "trademark_tracking" */
export type Trademark_Tracking = {
  __typename?: 'trademark_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: Trademark_Tracking_Status;
  /** An object relationship */
  trademark: Trademark;
  trademark_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "trademark_tracking" */
export type Trademark_Tracking_Aggregate = {
  __typename?: 'trademark_tracking_aggregate';
  aggregate?: Maybe<Trademark_Tracking_Aggregate_Fields>;
  nodes: Array<Trademark_Tracking>;
};

export type Trademark_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Trademark_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Trademark_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Trademark_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Trademark_Tracking_Select_Column_Trademark_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Trademark_Tracking_Select_Column_Trademark_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Trademark_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_tracking" */
export type Trademark_Tracking_Aggregate_Fields = {
  __typename?: 'trademark_tracking_aggregate_fields';
  avg?: Maybe<Trademark_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Tracking_Max_Fields>;
  min?: Maybe<Trademark_Tracking_Min_Fields>;
  stddev?: Maybe<Trademark_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Trademark_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trademark_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Trademark_Tracking_Sum_Fields>;
  var_pop?: Maybe<Trademark_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Trademark_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Trademark_Tracking_Variance_Fields>;
};


/** aggregate fields of "trademark_tracking" */
export type Trademark_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_tracking" */
export type Trademark_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Trademark_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Tracking_Max_Order_By>;
  min?: InputMaybe<Trademark_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Trademark_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Trademark_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Trademark_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Trademark_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Trademark_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Trademark_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Trademark_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "trademark_tracking" */
export type Trademark_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Trademark_Tracking_Avg_Fields = {
  __typename?: 'trademark_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "trademark_tracking". All fields are combined with a logical 'AND'. */
export type Trademark_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_tracking" */
export enum Trademark_Tracking_Constraint {
  /** unique or primary key constraint on columns "trademark_id" */
  TrademarkTrackingApiFilingStartedUnique = 'trademark_tracking_api_filing_started_unique',
  /** unique or primary key constraint on columns "id" */
  TrademarkTrackingPkey = 'trademark_tracking_pkey'
}

/** input type for incrementing numeric columns in table "trademark_tracking" */
export type Trademark_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "trademark_tracking" */
export type Trademark_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Trademark_Tracking_Status_Obj_Rel_Insert_Input>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trademark_Tracking_Max_Fields = {
  __typename?: 'trademark_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Tracking_Min_Fields = {
  __typename?: 'trademark_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_tracking" */
export type Trademark_Tracking_Mutation_Response = {
  __typename?: 'trademark_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Tracking>;
};

/** on_conflict condition type for table "trademark_tracking" */
export type Trademark_Tracking_On_Conflict = {
  constraint: Trademark_Tracking_Constraint;
  update_columns?: Array<Trademark_Tracking_Update_Column>;
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_tracking". */
export type Trademark_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Trademark_Tracking_Status_Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_tracking */
export type Trademark_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "trademark_tracking" */
export enum Trademark_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UserId = 'user_id'
}

/** select "trademark_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "trademark_tracking" */
export enum Trademark_Tracking_Select_Column_Trademark_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "trademark_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "trademark_tracking" */
export enum Trademark_Tracking_Select_Column_Trademark_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "trademark_tracking" */
export type Trademark_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "trademark_tracking_status" */
export type Trademark_Tracking_Status = {
  __typename?: 'trademark_tracking_status';
  group?: Maybe<Scalars['String']['output']>;
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "trademark_tracking_status" */
export type Trademark_Tracking_Status_Aggregate = {
  __typename?: 'trademark_tracking_status_aggregate';
  aggregate?: Maybe<Trademark_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Trademark_Tracking_Status>;
};

/** aggregate fields of "trademark_tracking_status" */
export type Trademark_Tracking_Status_Aggregate_Fields = {
  __typename?: 'trademark_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Tracking_Status_Max_Fields>;
  min?: Maybe<Trademark_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "trademark_tracking_status" */
export type Trademark_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "trademark_tracking_status". All fields are combined with a logical 'AND'. */
export type Trademark_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Tracking_Status_Bool_Exp>>;
  group?: InputMaybe<String_Comparison_Exp>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_tracking_status" */
export enum Trademark_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  TrademarkTrackingStatusPkey = 'trademark_tracking_status_pkey'
}

/** input type for inserting data into table "trademark_tracking_status" */
export type Trademark_Tracking_Status_Insert_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Trademark_Tracking_Status_Max_Fields = {
  __typename?: 'trademark_tracking_status_max_fields';
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Trademark_Tracking_Status_Min_Fields = {
  __typename?: 'trademark_tracking_status_min_fields';
  group?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "trademark_tracking_status" */
export type Trademark_Tracking_Status_Mutation_Response = {
  __typename?: 'trademark_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Tracking_Status>;
};

/** input type for inserting object relation for remote table "trademark_tracking_status" */
export type Trademark_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Trademark_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "trademark_tracking_status" */
export type Trademark_Tracking_Status_On_Conflict = {
  constraint: Trademark_Tracking_Status_Constraint;
  update_columns?: Array<Trademark_Tracking_Status_Update_Column>;
  where?: InputMaybe<Trademark_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_tracking_status". */
export type Trademark_Tracking_Status_Order_By = {
  group?: InputMaybe<Order_By>;
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_tracking_status */
export type Trademark_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "trademark_tracking_status" */
export enum Trademark_Tracking_Status_Select_Column {
  /** column name */
  Group = 'group',
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trademark_tracking_status" */
export type Trademark_Tracking_Status_Set_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "trademark_tracking_status" */
export type Trademark_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Tracking_Status_Stream_Cursor_Value_Input = {
  group?: InputMaybe<Scalars['String']['input']>;
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "trademark_tracking_status" */
export enum Trademark_Tracking_Status_Update_Column {
  /** column name */
  Group = 'group',
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Trademark_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Trademark_Tracking_Stddev_Fields = {
  __typename?: 'trademark_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Trademark_Tracking_Stddev_Pop_Fields = {
  __typename?: 'trademark_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Trademark_Tracking_Stddev_Samp_Fields = {
  __typename?: 'trademark_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "trademark_tracking" */
export type Trademark_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Trademark_Tracking_Sum_Fields = {
  __typename?: 'trademark_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "trademark_tracking" */
export enum Trademark_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  UserId = 'user_id'
}

export type Trademark_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trademark_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trademark_Tracking_Var_Pop_Fields = {
  __typename?: 'trademark_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trademark_Tracking_Var_Samp_Fields = {
  __typename?: 'trademark_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trademark_Tracking_Variance_Fields = {
  __typename?: 'trademark_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "trademark_tracking" */
export type Trademark_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "trademark" */
export enum Trademark_Update_Column {
  /** column name */
  AdditionalInfo = 'additional_info',
  /** column name */
  AdditionalInfoLegacy = 'additional_info_legacy',
  /** column name */
  Alias = 'alias',
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  BrandRegistryCode = 'brand_registry_code',
  /** column name */
  ColorClaim = 'color_claim',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  DirectFiling = 'direct_filing',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DomicileAddressId = 'domicile_address_id',
  /** column name */
  DouDeadlineDate = 'dou_deadline_date',
  /** column name */
  ExpirationDate = 'expiration_date',
  /** column name */
  FilingDate = 'filing_date',
  /** column name */
  FilingInformation = 'filing_information',
  /** column name */
  FilingPostponedNote = 'filing_postponed_note',
  /** column name */
  FilingPostponedReason = 'filing_postponed_reason',
  /** column name */
  FilingReference = 'filing_reference',
  /** column name */
  Id = 'id',
  /** column name */
  InternationalNumber = 'international_number',
  /** column name */
  IpoLink = 'ipo_link',
  /** column name */
  Jurisdiction = 'jurisdiction',
  /** column name */
  LastIpoDataSync = 'last_ipo_data_sync',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  LogoType = 'logo_type',
  /** column name */
  MailingAddressId = 'mailing_address_id',
  /** column name */
  Name = 'name',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  Number = 'number',
  /** column name */
  OppositionPeriodEnd = 'opposition_period_end',
  /** column name */
  OppositionPeriodStart = 'opposition_period_start',
  /** column name */
  OwnerEntityId = 'owner_entity_id',
  /** column name */
  PriorityFilingData = 'priority_filing_data',
  /** column name */
  RegistrationDate = 'registration_date',
  /** column name */
  RegistrationNumber = 'registration_number',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  RepresentativeEntityId = 'representative_entity_id',
  /** column name */
  Status = 'status',
  /** column name */
  StatusGroup = 'status_group',
  /** column name */
  TrademarkRegistrationIdLegacy = 'trademark_registration_id_legacy',
  /** column name */
  TrademarkRequestId = 'trademark_request_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UsptoLogoSubcategory = 'uspto_logo_subcategory'
}

export type Trademark_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trademark_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trademark_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trademark_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trademark_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trademark_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trademark_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trademark_Var_Pop_Fields = {
  __typename?: 'trademark_var_pop_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "trademark" */
export type Trademark_Var_Pop_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Trademark_Var_Samp_Fields = {
  __typename?: 'trademark_var_samp_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "trademark" */
export type Trademark_Var_Samp_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Trademark_Variance_Fields = {
  __typename?: 'trademark_variance_fields';
  domicile_address_id?: Maybe<Scalars['Float']['output']>;
  mailing_address_id?: Maybe<Scalars['Float']['output']>;
  trademark_registration_id_legacy?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "trademark" */
export type Trademark_Variance_Order_By = {
  domicile_address_id?: InputMaybe<Order_By>;
  mailing_address_id?: InputMaybe<Order_By>;
  trademark_registration_id_legacy?: InputMaybe<Order_By>;
};

/** columns and relationships of "trademark_watch_subscription" */
export type Trademark_Watch_Subscription = {
  __typename?: 'trademark_watch_subscription';
  date_end: Scalars['date']['output'];
  date_start: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  markify_id: Scalars['String']['output'];
  /** An object relationship */
  service_request?: Maybe<Service_Request>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  trademark?: Maybe<Trademark>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  trademark_monitoring_result: Array<Trademark_Monitoring_Result>;
  /** An aggregate relationship */
  trademark_monitoring_result_aggregate: Trademark_Monitoring_Result_Aggregate;
  type: Scalars['String']['output'];
  /** An object relationship */
  user: User;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "trademark_watch_subscription" */
export type Trademark_Watch_SubscriptionTrademark_Monitoring_ResultArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};


/** columns and relationships of "trademark_watch_subscription" */
export type Trademark_Watch_SubscriptionTrademark_Monitoring_Result_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Monitoring_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By>>;
  where?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
};

/** aggregated selection of "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Aggregate = {
  __typename?: 'trademark_watch_subscription_aggregate';
  aggregate?: Maybe<Trademark_Watch_Subscription_Aggregate_Fields>;
  nodes: Array<Trademark_Watch_Subscription>;
};

export type Trademark_Watch_Subscription_Aggregate_Bool_Exp = {
  count?: InputMaybe<Trademark_Watch_Subscription_Aggregate_Bool_Exp_Count>;
};

export type Trademark_Watch_Subscription_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Aggregate_Fields = {
  __typename?: 'trademark_watch_subscription_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Trademark_Watch_Subscription_Max_Fields>;
  min?: Maybe<Trademark_Watch_Subscription_Min_Fields>;
};


/** aggregate fields of "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trademark_Watch_Subscription_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Trademark_Watch_Subscription_Max_Order_By>;
  min?: InputMaybe<Trademark_Watch_Subscription_Min_Order_By>;
};

/** input type for inserting array relation for remote table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Arr_Rel_Insert_Input = {
  data: Array<Trademark_Watch_Subscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Trademark_Watch_Subscription_On_Conflict>;
};

/** Boolean expression to filter rows from the table "trademark_watch_subscription". All fields are combined with a logical 'AND'. */
export type Trademark_Watch_Subscription_Bool_Exp = {
  _and?: InputMaybe<Array<Trademark_Watch_Subscription_Bool_Exp>>;
  _not?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
  _or?: InputMaybe<Array<Trademark_Watch_Subscription_Bool_Exp>>;
  date_end?: InputMaybe<Date_Comparison_Exp>;
  date_start?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  markify_id?: InputMaybe<String_Comparison_Exp>;
  service_request?: InputMaybe<Service_Request_Bool_Exp>;
  service_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  trademark_monitoring_result?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  trademark_monitoring_result_aggregate?: InputMaybe<Trademark_Monitoring_Result_Aggregate_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "trademark_watch_subscription" */
export enum Trademark_Watch_Subscription_Constraint {
  /** unique or primary key constraint on columns "markify_id" */
  TrademarkWatchSubscriptionMarkifyIdKey = 'trademark_watch_subscription_markify_id_key',
  /** unique or primary key constraint on columns "id" */
  TrademarkWatchSubscriptionPkey = 'trademark_watch_subscription_pkey'
}

/** input type for inserting data into table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Insert_Input = {
  date_end?: InputMaybe<Scalars['date']['input']>;
  date_start?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  markify_id?: InputMaybe<Scalars['String']['input']>;
  service_request?: InputMaybe<Service_Request_Obj_Rel_Insert_Input>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_monitoring_result?: InputMaybe<Trademark_Monitoring_Result_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Trademark_Watch_Subscription_Max_Fields = {
  __typename?: 'trademark_watch_subscription_max_fields';
  date_end?: Maybe<Scalars['date']['output']>;
  date_start?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  markify_id?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Max_Order_By = {
  date_end?: InputMaybe<Order_By>;
  date_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markify_id?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Trademark_Watch_Subscription_Min_Fields = {
  __typename?: 'trademark_watch_subscription_min_fields';
  date_end?: Maybe<Scalars['date']['output']>;
  date_start?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  markify_id?: Maybe<Scalars['String']['output']>;
  service_request_id?: Maybe<Scalars['uuid']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Min_Order_By = {
  date_end?: InputMaybe<Order_By>;
  date_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markify_id?: InputMaybe<Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Mutation_Response = {
  __typename?: 'trademark_watch_subscription_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Trademark_Watch_Subscription>;
};

/** on_conflict condition type for table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_On_Conflict = {
  constraint: Trademark_Watch_Subscription_Constraint;
  update_columns?: Array<Trademark_Watch_Subscription_Update_Column>;
  where?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
};

/** Ordering options when selecting data from "trademark_watch_subscription". */
export type Trademark_Watch_Subscription_Order_By = {
  date_end?: InputMaybe<Order_By>;
  date_start?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  markify_id?: InputMaybe<Order_By>;
  service_request?: InputMaybe<Service_Request_Order_By>;
  service_request_id?: InputMaybe<Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  trademark_monitoring_result_aggregate?: InputMaybe<Trademark_Monitoring_Result_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trademark_watch_subscription */
export type Trademark_Watch_Subscription_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "trademark_watch_subscription" */
export enum Trademark_Watch_Subscription_Select_Column {
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  MarkifyId = 'markify_id',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Set_Input = {
  date_end?: InputMaybe<Scalars['date']['input']>;
  date_start?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  markify_id?: InputMaybe<Scalars['String']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "trademark_watch_subscription" */
export type Trademark_Watch_Subscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trademark_Watch_Subscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trademark_Watch_Subscription_Stream_Cursor_Value_Input = {
  date_end?: InputMaybe<Scalars['date']['input']>;
  date_start?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  markify_id?: InputMaybe<Scalars['String']['input']>;
  service_request_id?: InputMaybe<Scalars['uuid']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "trademark_watch_subscription" */
export enum Trademark_Watch_Subscription_Update_Column {
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  MarkifyId = 'markify_id',
  /** column name */
  ServiceRequestId = 'service_request_id',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type Trademark_Watch_Subscription_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trademark_Watch_Subscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trademark_Watch_Subscription_Bool_Exp;
};

/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_Request = {
  __typename?: 'use_in_commerce_request';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  child?: Maybe<Use_In_Commerce_Request>;
  /** An object relationship */
  child_trademark?: Maybe<Trademark>;
  child_trademark_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<Thread_Comment>;
  /** An aggregate relationship */
  comments_aggregate: Thread_Comment_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  declaration_of_incontestability?: Maybe<Scalars['Boolean']['output']>;
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  due_date: Scalars['timestamptz']['output'];
  grace_period_deadline?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  issue_date: Scalars['timestamptz']['output'];
  kickoff_type?: Maybe<Scalars['String']['output']>;
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  order_hub_id: Scalars['uuid']['output'];
  order_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  orders: Array<Service_Request>;
  /** An aggregate relationship */
  orders_aggregate: Service_Request_Aggregate;
  /** An object relationship */
  parent?: Maybe<Use_In_Commerce_Request>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  quote_hub: Quote_Hub;
  quote_hub_id: Scalars['uuid']['output'];
  remaining_extension_count?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  /** An array relationship */
  tracking_actions: Array<Use_In_Commerce_Request_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: Use_In_Commerce_Request_Tracking_Aggregate;
  /** An object relationship */
  trademark: Trademark;
  /** An array relationship */
  trademark_classes: Array<Trademark_Class>;
  /** An aggregate relationship */
  trademark_classes_aggregate: Trademark_Class_Aggregate;
  trademark_id: Scalars['uuid']['output'];
  type: Scalars['use_in_commerce_request_type']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by_user: User;
  updated_by_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestCommentsArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Thread_Comment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By>>;
  where?: InputMaybe<Thread_Comment_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestOrdersArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By>>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestTrademark_ClassesArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};


/** columns and relationships of "use_in_commerce_request" */
export type Use_In_Commerce_RequestTrademark_Classes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By>>;
  where?: InputMaybe<Trademark_Class_Bool_Exp>;
};

/** aggregated selection of "use_in_commerce_request" */
export type Use_In_Commerce_Request_Aggregate = {
  __typename?: 'use_in_commerce_request_aggregate';
  aggregate?: Maybe<Use_In_Commerce_Request_Aggregate_Fields>;
  nodes: Array<Use_In_Commerce_Request>;
};

export type Use_In_Commerce_Request_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Use_In_Commerce_Request_Aggregate_Bool_Exp_Count>;
};

export type Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_And = {
  arguments: Use_In_Commerce_Request_Select_Column_Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Use_In_Commerce_Request_Select_Column_Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Use_In_Commerce_Request_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "use_in_commerce_request" */
export type Use_In_Commerce_Request_Aggregate_Fields = {
  __typename?: 'use_in_commerce_request_aggregate_fields';
  avg?: Maybe<Use_In_Commerce_Request_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Use_In_Commerce_Request_Max_Fields>;
  min?: Maybe<Use_In_Commerce_Request_Min_Fields>;
  stddev?: Maybe<Use_In_Commerce_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Use_In_Commerce_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Use_In_Commerce_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Use_In_Commerce_Request_Sum_Fields>;
  var_pop?: Maybe<Use_In_Commerce_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Use_In_Commerce_Request_Var_Samp_Fields>;
  variance?: Maybe<Use_In_Commerce_Request_Variance_Fields>;
};


/** aggregate fields of "use_in_commerce_request" */
export type Use_In_Commerce_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Use_In_Commerce_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Use_In_Commerce_Request_Max_Order_By>;
  min?: InputMaybe<Use_In_Commerce_Request_Min_Order_By>;
  stddev?: InputMaybe<Use_In_Commerce_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Use_In_Commerce_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Use_In_Commerce_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Use_In_Commerce_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Use_In_Commerce_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Use_In_Commerce_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Use_In_Commerce_Request_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Arr_Rel_Insert_Input = {
  data: Array<Use_In_Commerce_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Use_In_Commerce_Request_On_Conflict>;
};

/** aggregate avg on columns */
export type Use_In_Commerce_Request_Avg_Fields = {
  __typename?: 'use_in_commerce_request_avg_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Avg_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "use_in_commerce_request". All fields are combined with a logical 'AND'. */
export type Use_In_Commerce_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Use_In_Commerce_Request_Bool_Exp>>;
  _not?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Use_In_Commerce_Request_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  child?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  child_trademark?: InputMaybe<Trademark_Bool_Exp>;
  child_trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<Thread_Comment_Bool_Exp>;
  comments_aggregate?: InputMaybe<Thread_Comment_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  declaration_of_incontestability?: InputMaybe<Boolean_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  grace_period_deadline?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  issue_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  kickoff_type?: InputMaybe<String_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  order_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  orders?: InputMaybe<Service_Request_Bool_Exp>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Bool_Exp>;
  parent?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  quote_hub?: InputMaybe<Quote_Hub_Bool_Exp>;
  quote_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  remaining_extension_count?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tracking_actions?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp>;
  trademark?: InputMaybe<Trademark_Bool_Exp>;
  trademark_classes?: InputMaybe<Trademark_Class_Bool_Exp>;
  trademark_classes_aggregate?: InputMaybe<Trademark_Class_Aggregate_Bool_Exp>;
  trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Use_In_Commerce_Request_Type_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by_user?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "use_in_commerce_request_class_decision_type". All fields are combined with logical 'AND'. */
export type Use_In_Commerce_Request_Class_Decision_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _gt?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _gte?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _in?: InputMaybe<Array<Scalars['use_in_commerce_request_class_decision_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _lte?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _neq?: InputMaybe<Scalars['use_in_commerce_request_class_decision_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['use_in_commerce_request_class_decision_type']['input']>>;
};

/** unique or primary key constraints on table "use_in_commerce_request" */
export enum Use_In_Commerce_Request_Constraint {
  /** unique or primary key constraint on columns "parent_id" */
  UniqueParentId = 'unique_parent_id',
  /** unique or primary key constraint on columns "child_trademark_id" */
  UseInCommerceRequestChildTrademarkIdUnique = 'use_in_commerce_request_child_trademark_id_unique',
  /** unique or primary key constraint on columns "order_id" */
  UseInCommerceRequestOrderIdUnique = 'use_in_commerce_request_order_id_unique',
  /** unique or primary key constraint on columns "id" */
  UseInCommerceRequestPkey = 'use_in_commerce_request_pkey',
  /** unique or primary key constraint on columns "quote_hub_id" */
  UseInCommerceRequestQuoteHubIdKey = 'use_in_commerce_request_quote_hub_id_key'
}

/** input type for incrementing numeric columns in table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Inc_Input = {
  remaining_extension_count?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  child?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
  child_trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  child_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Thread_Comment_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  declaration_of_incontestability?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  grace_period_deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue_date?: InputMaybe<Scalars['timestamptz']['input']>;
  kickoff_type?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  orders?: InputMaybe<Service_Request_Arr_Rel_Insert_Input>;
  parent?: InputMaybe<Use_In_Commerce_Request_Obj_Rel_Insert_Input>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_hub?: InputMaybe<Quote_Hub_Obj_Rel_Insert_Input>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_extension_count?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tracking_actions?: InputMaybe<Use_In_Commerce_Request_Tracking_Arr_Rel_Insert_Input>;
  trademark?: InputMaybe<Trademark_Obj_Rel_Insert_Input>;
  trademark_classes?: InputMaybe<Trademark_Class_Arr_Rel_Insert_Input>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Use_In_Commerce_Request_Max_Fields = {
  __typename?: 'use_in_commerce_request_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  child_trademark_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  grace_period_deadline?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_date?: Maybe<Scalars['timestamptz']['output']>;
  kickoff_type?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  remaining_extension_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['use_in_commerce_request_type']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Max_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  child_trademark_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  grace_period_deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  kickoff_type?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  remaining_extension_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Use_In_Commerce_Request_Min_Fields = {
  __typename?: 'use_in_commerce_request_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  child_trademark_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  grace_period_deadline?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  issue_date?: Maybe<Scalars['timestamptz']['output']>;
  kickoff_type?: Maybe<Scalars['String']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_hub_id?: Maybe<Scalars['uuid']['output']>;
  order_id?: Maybe<Scalars['uuid']['output']>;
  parent_id?: Maybe<Scalars['uuid']['output']>;
  quote_hub_id?: Maybe<Scalars['uuid']['output']>;
  remaining_extension_count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trademark_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['use_in_commerce_request_type']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Min_Order_By = {
  assigned_admin_id?: InputMaybe<Order_By>;
  child_trademark_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  grace_period_deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  kickoff_type?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  remaining_extension_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Mutation_Response = {
  __typename?: 'use_in_commerce_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Use_In_Commerce_Request>;
};

/** input type for inserting object relation for remote table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Obj_Rel_Insert_Input = {
  data: Use_In_Commerce_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Use_In_Commerce_Request_On_Conflict>;
};

/** on_conflict condition type for table "use_in_commerce_request" */
export type Use_In_Commerce_Request_On_Conflict = {
  constraint: Use_In_Commerce_Request_Constraint;
  update_columns?: Array<Use_In_Commerce_Request_Update_Column>;
  where?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "use_in_commerce_request". */
export type Use_In_Commerce_Request_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  child?: InputMaybe<Use_In_Commerce_Request_Order_By>;
  child_trademark?: InputMaybe<Trademark_Order_By>;
  child_trademark_id?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Thread_Comment_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  declaration_of_incontestability?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  due_date?: InputMaybe<Order_By>;
  grace_period_deadline?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  kickoff_type?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  order_hub_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Service_Request_Aggregate_Order_By>;
  parent?: InputMaybe<Use_In_Commerce_Request_Order_By>;
  parent_id?: InputMaybe<Order_By>;
  quote_hub?: InputMaybe<Quote_Hub_Order_By>;
  quote_hub_id?: InputMaybe<Order_By>;
  remaining_extension_count?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<Use_In_Commerce_Request_Tracking_Aggregate_Order_By>;
  trademark?: InputMaybe<Trademark_Order_By>;
  trademark_classes_aggregate?: InputMaybe<Trademark_Class_Aggregate_Order_By>;
  trademark_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: use_in_commerce_request */
export type Use_In_Commerce_Request_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "use_in_commerce_request" */
export enum Use_In_Commerce_Request_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  ChildTrademarkId = 'child_trademark_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclarationOfIncontestability = 'declaration_of_incontestability',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  GracePeriodDeadline = 'grace_period_deadline',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  KickoffType = 'kickoff_type',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  RemainingExtensionCount = 'remaining_extension_count',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

/** select "use_in_commerce_request_aggregate_bool_exp_bool_and_arguments_columns" columns of table "use_in_commerce_request" */
export enum Use_In_Commerce_Request_Select_Column_Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DeclarationOfIncontestability = 'declaration_of_incontestability'
}

/** select "use_in_commerce_request_aggregate_bool_exp_bool_or_arguments_columns" columns of table "use_in_commerce_request" */
export enum Use_In_Commerce_Request_Select_Column_Use_In_Commerce_Request_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DeclarationOfIncontestability = 'declaration_of_incontestability'
}

/** input type for updating data in table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  child_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  declaration_of_incontestability?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  grace_period_deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue_date?: InputMaybe<Scalars['timestamptz']['input']>;
  kickoff_type?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_extension_count?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Use_In_Commerce_Request_Stddev_Fields = {
  __typename?: 'use_in_commerce_request_stddev_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Stddev_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Use_In_Commerce_Request_Stddev_Pop_Fields = {
  __typename?: 'use_in_commerce_request_stddev_pop_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Stddev_Pop_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Use_In_Commerce_Request_Stddev_Samp_Fields = {
  __typename?: 'use_in_commerce_request_stddev_samp_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Stddev_Samp_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Use_In_Commerce_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Use_In_Commerce_Request_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  child_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  declaration_of_incontestability?: InputMaybe<Scalars['Boolean']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  grace_period_deadline?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  issue_date?: InputMaybe<Scalars['timestamptz']['input']>;
  kickoff_type?: InputMaybe<Scalars['String']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  order_id?: InputMaybe<Scalars['uuid']['input']>;
  parent_id?: InputMaybe<Scalars['uuid']['input']>;
  quote_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  remaining_extension_count?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Use_In_Commerce_Request_Sum_Fields = {
  __typename?: 'use_in_commerce_request_sum_fields';
  remaining_extension_count?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Sum_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking = {
  __typename?: 'use_in_commerce_request_tracking';
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  tracking_status: Use_In_Commerce_Request_Tracking_Status;
  use_in_commerce_request_id: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Aggregate = {
  __typename?: 'use_in_commerce_request_tracking_aggregate';
  aggregate?: Maybe<Use_In_Commerce_Request_Tracking_Aggregate_Fields>;
  nodes: Array<Use_In_Commerce_Request_Tracking>;
};

export type Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Count>;
};

export type Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: Use_In_Commerce_Request_Tracking_Select_Column_Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Use_In_Commerce_Request_Tracking_Select_Column_Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Aggregate_Fields = {
  __typename?: 'use_in_commerce_request_tracking_aggregate_fields';
  avg?: Maybe<Use_In_Commerce_Request_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Use_In_Commerce_Request_Tracking_Max_Fields>;
  min?: Maybe<Use_In_Commerce_Request_Tracking_Min_Fields>;
  stddev?: Maybe<Use_In_Commerce_Request_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<Use_In_Commerce_Request_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Use_In_Commerce_Request_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<Use_In_Commerce_Request_Tracking_Sum_Fields>;
  var_pop?: Maybe<Use_In_Commerce_Request_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<Use_In_Commerce_Request_Tracking_Var_Samp_Fields>;
  variance?: Maybe<Use_In_Commerce_Request_Tracking_Variance_Fields>;
};


/** aggregate fields of "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<Use_In_Commerce_Request_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Use_In_Commerce_Request_Tracking_Max_Order_By>;
  min?: InputMaybe<Use_In_Commerce_Request_Tracking_Min_Order_By>;
  stddev?: InputMaybe<Use_In_Commerce_Request_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Use_In_Commerce_Request_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Use_In_Commerce_Request_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Use_In_Commerce_Request_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<Use_In_Commerce_Request_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Use_In_Commerce_Request_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<Use_In_Commerce_Request_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Arr_Rel_Insert_Input = {
  data: Array<Use_In_Commerce_Request_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type Use_In_Commerce_Request_Tracking_Avg_Fields = {
  __typename?: 'use_in_commerce_request_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "use_in_commerce_request_tracking". All fields are combined with a logical 'AND'. */
export type Use_In_Commerce_Request_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Bool_Exp>>;
  _not?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
  use_in_commerce_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "use_in_commerce_request_tracking" */
export enum Use_In_Commerce_Request_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  UseInCommerceRequestTrackingPkey = 'use_in_commerce_request_tracking_pkey'
}

/** input type for incrementing numeric columns in table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Obj_Rel_Insert_Input>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Use_In_Commerce_Request_Tracking_Max_Fields = {
  __typename?: 'use_in_commerce_request_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Use_In_Commerce_Request_Tracking_Min_Fields = {
  __typename?: 'use_in_commerce_request_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  use_in_commerce_request_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Mutation_Response = {
  __typename?: 'use_in_commerce_request_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Use_In_Commerce_Request_Tracking>;
};

/** on_conflict condition type for table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_On_Conflict = {
  constraint: Use_In_Commerce_Request_Tracking_Constraint;
  update_columns?: Array<Use_In_Commerce_Request_Tracking_Update_Column>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "use_in_commerce_request_tracking". */
export type Use_In_Commerce_Request_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Order_By>;
  use_in_commerce_request_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: use_in_commerce_request_tracking */
export type Use_In_Commerce_Request_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "use_in_commerce_request_tracking" */
export enum Use_In_Commerce_Request_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  UserId = 'user_id'
}

/** select "use_in_commerce_request_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "use_in_commerce_request_tracking" */
export enum Use_In_Commerce_Request_Tracking_Select_Column_Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "use_in_commerce_request_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "use_in_commerce_request_tracking" */
export enum Use_In_Commerce_Request_Tracking_Select_Column_Use_In_Commerce_Request_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status = {
  __typename?: 'use_in_commerce_request_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Aggregate = {
  __typename?: 'use_in_commerce_request_tracking_status_aggregate';
  aggregate?: Maybe<Use_In_Commerce_Request_Tracking_Status_Aggregate_Fields>;
  nodes: Array<Use_In_Commerce_Request_Tracking_Status>;
};

/** aggregate fields of "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Aggregate_Fields = {
  __typename?: 'use_in_commerce_request_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Use_In_Commerce_Request_Tracking_Status_Max_Fields>;
  min?: Maybe<Use_In_Commerce_Request_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "use_in_commerce_request_tracking_status". All fields are combined with a logical 'AND'. */
export type Use_In_Commerce_Request_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "use_in_commerce_request_tracking_status" */
export enum Use_In_Commerce_Request_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  UseInCommerceRequestTrackingStatusPkey = 'use_in_commerce_request_tracking_status_pkey'
}

/** input type for inserting data into table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Use_In_Commerce_Request_Tracking_Status_Max_Fields = {
  __typename?: 'use_in_commerce_request_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Use_In_Commerce_Request_Tracking_Status_Min_Fields = {
  __typename?: 'use_in_commerce_request_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Mutation_Response = {
  __typename?: 'use_in_commerce_request_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Use_In_Commerce_Request_Tracking_Status>;
};

/** input type for inserting object relation for remote table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Obj_Rel_Insert_Input = {
  data: Use_In_Commerce_Request_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_On_Conflict = {
  constraint: Use_In_Commerce_Request_Tracking_Status_Constraint;
  update_columns?: Array<Use_In_Commerce_Request_Tracking_Status_Update_Column>;
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "use_in_commerce_request_tracking_status". */
export type Use_In_Commerce_Request_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: use_in_commerce_request_tracking_status */
export type Use_In_Commerce_Request_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "use_in_commerce_request_tracking_status" */
export enum Use_In_Commerce_Request_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "use_in_commerce_request_tracking_status" */
export type Use_In_Commerce_Request_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Use_In_Commerce_Request_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Use_In_Commerce_Request_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "use_in_commerce_request_tracking_status" */
export enum Use_In_Commerce_Request_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type Use_In_Commerce_Request_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Use_In_Commerce_Request_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Use_In_Commerce_Request_Tracking_Stddev_Fields = {
  __typename?: 'use_in_commerce_request_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Use_In_Commerce_Request_Tracking_Stddev_Pop_Fields = {
  __typename?: 'use_in_commerce_request_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Use_In_Commerce_Request_Tracking_Stddev_Samp_Fields = {
  __typename?: 'use_in_commerce_request_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Use_In_Commerce_Request_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Use_In_Commerce_Request_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  use_in_commerce_request_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Use_In_Commerce_Request_Tracking_Sum_Fields = {
  __typename?: 'use_in_commerce_request_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "use_in_commerce_request_tracking" */
export enum Use_In_Commerce_Request_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UseInCommerceRequestId = 'use_in_commerce_request_id',
  /** column name */
  UserId = 'user_id'
}

export type Use_In_Commerce_Request_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Use_In_Commerce_Request_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Use_In_Commerce_Request_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Use_In_Commerce_Request_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Use_In_Commerce_Request_Tracking_Var_Pop_Fields = {
  __typename?: 'use_in_commerce_request_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Use_In_Commerce_Request_Tracking_Var_Samp_Fields = {
  __typename?: 'use_in_commerce_request_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Use_In_Commerce_Request_Tracking_Variance_Fields = {
  __typename?: 'use_in_commerce_request_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "use_in_commerce_request_tracking" */
export type Use_In_Commerce_Request_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "use_in_commerce_request_type". All fields are combined with logical 'AND'. */
export type Use_In_Commerce_Request_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _gt?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _gte?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _in?: InputMaybe<Array<Scalars['use_in_commerce_request_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _lte?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _neq?: InputMaybe<Scalars['use_in_commerce_request_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['use_in_commerce_request_type']['input']>>;
};

/** update columns of table "use_in_commerce_request" */
export enum Use_In_Commerce_Request_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  ChildTrademarkId = 'child_trademark_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclarationOfIncontestability = 'declaration_of_incontestability',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  GracePeriodDeadline = 'grace_period_deadline',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  KickoffType = 'kickoff_type',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  OrderHubId = 'order_hub_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  QuoteHubId = 'quote_hub_id',
  /** column name */
  RemainingExtensionCount = 'remaining_extension_count',
  /** column name */
  Status = 'status',
  /** column name */
  TrademarkId = 'trademark_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id'
}

export type Use_In_Commerce_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Use_In_Commerce_Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Use_In_Commerce_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Use_In_Commerce_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Use_In_Commerce_Request_Var_Pop_Fields = {
  __typename?: 'use_in_commerce_request_var_pop_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Var_Pop_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Use_In_Commerce_Request_Var_Samp_Fields = {
  __typename?: 'use_in_commerce_request_var_samp_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Var_Samp_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Use_In_Commerce_Request_Variance_Fields = {
  __typename?: 'use_in_commerce_request_variance_fields';
  remaining_extension_count?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "use_in_commerce_request" */
export type Use_In_Commerce_Request_Variance_Order_By = {
  remaining_extension_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  /** An object relationship */
  assigned_admin?: Maybe<User>;
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  assignee_history?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  brands: Array<Brand>;
  /** An aggregate relationship */
  brands_aggregate: Brand_Aggregate;
  cp_onboarding_finished: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  document_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  last_tracking_update: Scalars['timestamptz']['output'];
  note_hub_id: Scalars['uuid']['output'];
  /** An array relationship */
  notes: Array<Note>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate;
  password_hash: Scalars['String']['output'];
  /** An object relationship */
  profile?: Maybe<User_Profile>;
  refresh_token?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  registration_requests: Array<Registration_Request>;
  /** An aggregate relationship */
  registration_requests_aggregate: Registration_Request_Aggregate;
  revolut_id?: Maybe<Scalars['uuid']['output']>;
  role: Scalars['String']['output'];
  secret: Scalars['uuid']['output'];
  secret_generated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  service_requests: Array<Service_Request>;
  /** An aggregate relationship */
  service_requests_aggregate: Service_Request_Aggregate;
  status: Scalars['String']['output'];
  tags: Scalars['jsonb']['output'];
  /** An array relationship */
  tracking_actions: Array<User_Tracking>;
  /** An aggregate relationship */
  tracking_actions_aggregate: User_Tracking_Aggregate;
  unsubscribe_token: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "user" */
export type UserAssignee_HistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user" */
export type UserBrandsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserBrands_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Order_By>>;
  where?: InputMaybe<Brand_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserNotesArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By>>;
  where?: InputMaybe<Note_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRegistration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserRegistration_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Registration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Registration_Request_Order_By>>;
  where?: InputMaybe<Registration_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserService_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserService_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Service_Request_Order_By>>;
  where?: InputMaybe<Service_Request_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user" */
export type UserTracking_ActionsArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserTracking_Actions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By>>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Append_Input = {
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "user_auth_log" */
export type User_Auth_Log = {
  __typename?: 'user_auth_log';
  action_type: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  device_info: Scalars['jsonb']['output'];
  id: Scalars['Int']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  location: Scalars['jsonb']['output'];
  metadata: Scalars['jsonb']['output'];
  user_id: Scalars['uuid']['output'];
  vpn_provider?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "user_auth_log" */
export type User_Auth_LogDevice_InfoArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_auth_log" */
export type User_Auth_LogLocationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "user_auth_log" */
export type User_Auth_LogMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "user_auth_log" */
export type User_Auth_Log_Aggregate = {
  __typename?: 'user_auth_log_aggregate';
  aggregate?: Maybe<User_Auth_Log_Aggregate_Fields>;
  nodes: Array<User_Auth_Log>;
};

/** aggregate fields of "user_auth_log" */
export type User_Auth_Log_Aggregate_Fields = {
  __typename?: 'user_auth_log_aggregate_fields';
  avg?: Maybe<User_Auth_Log_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Auth_Log_Max_Fields>;
  min?: Maybe<User_Auth_Log_Min_Fields>;
  stddev?: Maybe<User_Auth_Log_Stddev_Fields>;
  stddev_pop?: Maybe<User_Auth_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Auth_Log_Stddev_Samp_Fields>;
  sum?: Maybe<User_Auth_Log_Sum_Fields>;
  var_pop?: Maybe<User_Auth_Log_Var_Pop_Fields>;
  var_samp?: Maybe<User_Auth_Log_Var_Samp_Fields>;
  variance?: Maybe<User_Auth_Log_Variance_Fields>;
};


/** aggregate fields of "user_auth_log" */
export type User_Auth_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Auth_Log_Append_Input = {
  device_info?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type User_Auth_Log_Avg_Fields = {
  __typename?: 'user_auth_log_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_auth_log". All fields are combined with a logical 'AND'. */
export type User_Auth_Log_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Log_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Log_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Log_Bool_Exp>>;
  action_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_info?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  ip_address?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  vpn_provider?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_log" */
export enum User_Auth_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAuthLogPkey = 'user_auth_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Auth_Log_Delete_At_Path_Input = {
  device_info?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Auth_Log_Delete_Elem_Input = {
  device_info?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Auth_Log_Delete_Key_Input = {
  device_info?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "user_auth_log" */
export type User_Auth_Log_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_auth_log" */
export type User_Auth_Log_Insert_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_info?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vpn_provider?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Auth_Log_Max_Fields = {
  __typename?: 'user_auth_log_max_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vpn_provider?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Auth_Log_Min_Fields = {
  __typename?: 'user_auth_log_min_fields';
  action_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  vpn_provider?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_auth_log" */
export type User_Auth_Log_Mutation_Response = {
  __typename?: 'user_auth_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Log>;
};

/** on_conflict condition type for table "user_auth_log" */
export type User_Auth_Log_On_Conflict = {
  constraint: User_Auth_Log_Constraint;
  update_columns?: Array<User_Auth_Log_Update_Column>;
  where?: InputMaybe<User_Auth_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_log". */
export type User_Auth_Log_Order_By = {
  action_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_info?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  vpn_provider?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_log */
export type User_Auth_Log_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Auth_Log_Prepend_Input = {
  device_info?: InputMaybe<Scalars['jsonb']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "user_auth_log" */
export enum User_Auth_Log_Select_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceInfo = 'device_info',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VpnProvider = 'vpn_provider'
}

/** input type for updating data in table "user_auth_log" */
export type User_Auth_Log_Set_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_info?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vpn_provider?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type User_Auth_Log_Stddev_Fields = {
  __typename?: 'user_auth_log_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type User_Auth_Log_Stddev_Pop_Fields = {
  __typename?: 'user_auth_log_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type User_Auth_Log_Stddev_Samp_Fields = {
  __typename?: 'user_auth_log_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_auth_log" */
export type User_Auth_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Log_Stream_Cursor_Value_Input = {
  action_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_info?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  vpn_provider?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type User_Auth_Log_Sum_Fields = {
  __typename?: 'user_auth_log_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_auth_log" */
export enum User_Auth_Log_Update_Column {
  /** column name */
  ActionType = 'action_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceInfo = 'device_info',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  Location = 'location',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VpnProvider = 'vpn_provider'
}

export type User_Auth_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Auth_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Auth_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Auth_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Auth_Log_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Auth_Log_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Auth_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Auth_Log_Var_Pop_Fields = {
  __typename?: 'user_auth_log_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type User_Auth_Log_Var_Samp_Fields = {
  __typename?: 'user_auth_log_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type User_Auth_Log_Variance_Fields = {
  __typename?: 'user_auth_log_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  assigned_admin?: InputMaybe<User_Bool_Exp>;
  assigned_admin_id?: InputMaybe<Uuid_Comparison_Exp>;
  assignee_history?: InputMaybe<Jsonb_Comparison_Exp>;
  brands?: InputMaybe<Brand_Bool_Exp>;
  brands_aggregate?: InputMaybe<Brand_Aggregate_Bool_Exp>;
  cp_onboarding_finished?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_tracking_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  note_hub_id?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp>;
  password_hash?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<User_Profile_Bool_Exp>;
  refresh_token?: InputMaybe<Uuid_Comparison_Exp>;
  registration_requests?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_requests_aggregate?: InputMaybe<Registration_Request_Aggregate_Bool_Exp>;
  revolut_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  secret?: InputMaybe<Uuid_Comparison_Exp>;
  secret_generated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  service_requests?: InputMaybe<Service_Request_Bool_Exp>;
  service_requests_aggregate?: InputMaybe<Service_Request_Aggregate_Bool_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  tracking_actions?: InputMaybe<User_Tracking_Bool_Exp>;
  tracking_actions_aggregate?: InputMaybe<User_Tracking_Aggregate_Bool_Exp>;
  unsubscribe_token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum User_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserEmailKey = 'user_email_key',
  /** unique or primary key constraint on columns "id" */
  UserNewIdKey = 'user_new_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey',
  /** unique or primary key constraint on columns "refresh_token" */
  UserRefreshTokenKey = 'user_refresh_token_key',
  /** unique or primary key constraint on columns "unsubscribe_token" */
  UserUnsubscribeTokenKey = 'user_unsubscribe_token_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Delete_At_Path_Input = {
  assignee_history?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Delete_Elem_Input = {
  assignee_history?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Delete_Key_Input = {
  assignee_history?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_history" */
export type User_History = {
  __typename?: 'user_history';
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id: Scalars['uuid']['output'];
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_history" */
export type User_History_Aggregate = {
  __typename?: 'user_history_aggregate';
  aggregate?: Maybe<User_History_Aggregate_Fields>;
  nodes: Array<User_History>;
};

/** aggregate fields of "user_history" */
export type User_History_Aggregate_Fields = {
  __typename?: 'user_history_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_History_Max_Fields>;
  min?: Maybe<User_History_Min_Fields>;
};


/** aggregate fields of "user_history" */
export type User_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_history". All fields are combined with a logical 'AND'. */
export type User_History_Bool_Exp = {
  _and?: InputMaybe<Array<User_History_Bool_Exp>>;
  _not?: InputMaybe<User_History_Bool_Exp>;
  _or?: InputMaybe<Array<User_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_history" */
export enum User_History_Constraint {
  /** unique or primary key constraint on columns "email" */
  UserHistoryEmailKey = 'user_history_email_key',
  /** unique or primary key constraint on columns "id" */
  UserHistoryPkey = 'user_history_pkey'
}

/** input type for inserting data into table "user_history" */
export type User_History_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_History_Max_Fields = {
  __typename?: 'user_history_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_History_Min_Fields = {
  __typename?: 'user_history_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_history" */
export type User_History_Mutation_Response = {
  __typename?: 'user_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_History>;
};

/** on_conflict condition type for table "user_history" */
export type User_History_On_Conflict = {
  constraint: User_History_Constraint;
  update_columns?: Array<User_History_Update_Column>;
  where?: InputMaybe<User_History_Bool_Exp>;
};

/** Ordering options when selecting data from "user_history". */
export type User_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_history */
export type User_History_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_history" */
export enum User_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_history" */
export type User_History_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_history" */
export type User_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_history" */
export enum User_History_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  UserId = 'user_id'
}

export type User_History_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_History_Bool_Exp;
};

/** input type for inserting data into table "user" */
export type User_Insert_Input = {
  assigned_admin?: InputMaybe<User_Obj_Rel_Insert_Input>;
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  brands?: InputMaybe<Brand_Arr_Rel_Insert_Input>;
  cp_onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<User_Profile_Obj_Rel_Insert_Input>;
  refresh_token?: InputMaybe<Scalars['uuid']['input']>;
  registration_requests?: InputMaybe<Registration_Request_Arr_Rel_Insert_Input>;
  revolut_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['uuid']['input']>;
  secret_generated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  service_requests?: InputMaybe<Service_Request_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  tracking_actions?: InputMaybe<User_Tracking_Arr_Rel_Insert_Input>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['uuid']['output']>;
  revolut_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['uuid']['output']>;
  secret_generated_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unsubscribe_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  assigned_admin_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_hub_id?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_status_update?: Maybe<Scalars['timestamptz']['output']>;
  last_tracking_update?: Maybe<Scalars['timestamptz']['output']>;
  note_hub_id?: Maybe<Scalars['uuid']['output']>;
  password_hash?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['uuid']['output']>;
  revolut_id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  secret?: Maybe<Scalars['uuid']['output']>;
  secret_generated_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unsubscribe_token?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** input type for inserting object relation for remote table "user" */
export type User_Obj_Rel_Insert_Input = {
  data: User_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type User_On_Conflict = {
  constraint: User_Constraint;
  update_columns?: Array<User_Update_Column>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  assigned_admin?: InputMaybe<User_Order_By>;
  assigned_admin_id?: InputMaybe<Order_By>;
  assignee_history?: InputMaybe<Order_By>;
  brands_aggregate?: InputMaybe<Brand_Aggregate_Order_By>;
  cp_onboarding_finished?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  document_hub_id?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  last_tracking_update?: InputMaybe<Order_By>;
  note_hub_id?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By>;
  password_hash?: InputMaybe<Order_By>;
  profile?: InputMaybe<User_Profile_Order_By>;
  refresh_token?: InputMaybe<Order_By>;
  registration_requests_aggregate?: InputMaybe<Registration_Request_Aggregate_Order_By>;
  revolut_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  secret?: InputMaybe<Order_By>;
  secret_generated_at?: InputMaybe<Order_By>;
  service_requests_aggregate?: InputMaybe<Service_Request_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  tracking_actions_aggregate?: InputMaybe<User_Tracking_Aggregate_Order_By>;
  unsubscribe_token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_payment_method" */
export type User_Payment_Method = {
  __typename?: 'user_payment_method';
  /** An array relationship */
  brand_subscriptions: Array<Brand_Subscription>;
  /** An aggregate relationship */
  brand_subscriptions_aggregate: Brand_Subscription_Aggregate;
  card_brand?: Maybe<Scalars['String']['output']>;
  card_expiration?: Maybe<Scalars['date']['output']>;
  card_last_four?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  revolut_id?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  user_id: Scalars['uuid']['output'];
  validation_order_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "user_payment_method" */
export type User_Payment_MethodBrand_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};


/** columns and relationships of "user_payment_method" */
export type User_Payment_MethodBrand_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By>>;
  where?: InputMaybe<Brand_Subscription_Bool_Exp>;
};

/** aggregated selection of "user_payment_method" */
export type User_Payment_Method_Aggregate = {
  __typename?: 'user_payment_method_aggregate';
  aggregate?: Maybe<User_Payment_Method_Aggregate_Fields>;
  nodes: Array<User_Payment_Method>;
};

/** aggregate fields of "user_payment_method" */
export type User_Payment_Method_Aggregate_Fields = {
  __typename?: 'user_payment_method_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Payment_Method_Max_Fields>;
  min?: Maybe<User_Payment_Method_Min_Fields>;
};


/** aggregate fields of "user_payment_method" */
export type User_Payment_Method_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Payment_Method_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_payment_method". All fields are combined with a logical 'AND'. */
export type User_Payment_Method_Bool_Exp = {
  _and?: InputMaybe<Array<User_Payment_Method_Bool_Exp>>;
  _not?: InputMaybe<User_Payment_Method_Bool_Exp>;
  _or?: InputMaybe<Array<User_Payment_Method_Bool_Exp>>;
  brand_subscriptions?: InputMaybe<Brand_Subscription_Bool_Exp>;
  brand_subscriptions_aggregate?: InputMaybe<Brand_Subscription_Aggregate_Bool_Exp>;
  card_brand?: InputMaybe<String_Comparison_Exp>;
  card_expiration?: InputMaybe<Date_Comparison_Exp>;
  card_last_four?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  revolut_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  validation_order_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_payment_method" */
export enum User_Payment_Method_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPaymentMethodPkey = 'user_payment_method_pkey'
}

/** input type for inserting data into table "user_payment_method" */
export type User_Payment_Method_Insert_Input = {
  brand_subscriptions?: InputMaybe<Brand_Subscription_Arr_Rel_Insert_Input>;
  card_brand?: InputMaybe<Scalars['String']['input']>;
  card_expiration?: InputMaybe<Scalars['date']['input']>;
  card_last_four?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Payment_Method_Max_Fields = {
  __typename?: 'user_payment_method_max_fields';
  card_brand?: Maybe<Scalars['String']['output']>;
  card_expiration?: Maybe<Scalars['date']['output']>;
  card_last_four?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revolut_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  validation_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type User_Payment_Method_Min_Fields = {
  __typename?: 'user_payment_method_min_fields';
  card_brand?: Maybe<Scalars['String']['output']>;
  card_expiration?: Maybe<Scalars['date']['output']>;
  card_last_four?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  revolut_id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  validation_order_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "user_payment_method" */
export type User_Payment_Method_Mutation_Response = {
  __typename?: 'user_payment_method_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Payment_Method>;
};

/** input type for inserting object relation for remote table "user_payment_method" */
export type User_Payment_Method_Obj_Rel_Insert_Input = {
  data: User_Payment_Method_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Payment_Method_On_Conflict>;
};

/** on_conflict condition type for table "user_payment_method" */
export type User_Payment_Method_On_Conflict = {
  constraint: User_Payment_Method_Constraint;
  update_columns?: Array<User_Payment_Method_Update_Column>;
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
};

/** Ordering options when selecting data from "user_payment_method". */
export type User_Payment_Method_Order_By = {
  brand_subscriptions_aggregate?: InputMaybe<Brand_Subscription_Aggregate_Order_By>;
  card_brand?: InputMaybe<Order_By>;
  card_expiration?: InputMaybe<Order_By>;
  card_last_four?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  revolut_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  validation_order_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_payment_method */
export type User_Payment_Method_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_payment_method" */
export enum User_Payment_Method_Select_Column {
  /** column name */
  CardBrand = 'card_brand',
  /** column name */
  CardExpiration = 'card_expiration',
  /** column name */
  CardLastFour = 'card_last_four',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RevolutId = 'revolut_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValidationOrderId = 'validation_order_id'
}

/** input type for updating data in table "user_payment_method" */
export type User_Payment_Method_Set_Input = {
  card_brand?: InputMaybe<Scalars['String']['input']>;
  card_expiration?: InputMaybe<Scalars['date']['input']>;
  card_last_four?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_payment_method" */
export type User_Payment_Method_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Payment_Method_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Payment_Method_Stream_Cursor_Value_Input = {
  card_brand?: InputMaybe<Scalars['String']['input']>;
  card_expiration?: InputMaybe<Scalars['date']['input']>;
  card_last_four?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  revolut_id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  validation_order_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_payment_method" */
export enum User_Payment_Method_Update_Column {
  /** column name */
  CardBrand = 'card_brand',
  /** column name */
  CardExpiration = 'card_expiration',
  /** column name */
  CardLastFour = 'card_last_four',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RevolutId = 'revolut_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  ValidationOrderId = 'validation_order_id'
}

export type User_Payment_Method_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Payment_Method_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Payment_Method_Bool_Exp;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Prepend_Input = {
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "user_profile" */
export type User_Profile = {
  __typename?: 'user_profile';
  /** An object relationship */
  billing_entity?: Maybe<Entity>;
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  billing_entity_prefill_enabled: Scalars['Boolean']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  gdpr_marketing_consent?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  marketing_emails_enabled: Scalars['Boolean']['output'];
  newsletter_emails_enabled: Scalars['Boolean']['output'];
  order_update_emails_enabled: Scalars['Boolean']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  registration_entity?: Maybe<Entity>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
  registration_entity_prefill_enabled: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "user_profile" */
export type User_Profile_Aggregate = {
  __typename?: 'user_profile_aggregate';
  aggregate?: Maybe<User_Profile_Aggregate_Fields>;
  nodes: Array<User_Profile>;
};

export type User_Profile_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Profile_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Profile_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Profile_Aggregate_Bool_Exp_Count>;
};

export type User_Profile_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Profile_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Profile_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Profile_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Profile_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_Fields = {
  __typename?: 'user_profile_aggregate_fields';
  avg?: Maybe<User_Profile_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Profile_Max_Fields>;
  min?: Maybe<User_Profile_Min_Fields>;
  stddev?: Maybe<User_Profile_Stddev_Fields>;
  stddev_pop?: Maybe<User_Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Profile_Stddev_Samp_Fields>;
  sum?: Maybe<User_Profile_Sum_Fields>;
  var_pop?: Maybe<User_Profile_Var_Pop_Fields>;
  var_samp?: Maybe<User_Profile_Var_Samp_Fields>;
  variance?: Maybe<User_Profile_Variance_Fields>;
};


/** aggregate fields of "user_profile" */
export type User_Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_profile" */
export type User_Profile_Aggregate_Order_By = {
  avg?: InputMaybe<User_Profile_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Profile_Max_Order_By>;
  min?: InputMaybe<User_Profile_Min_Order_By>;
  stddev?: InputMaybe<User_Profile_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Profile_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Profile_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Profile_Sum_Order_By>;
  var_pop?: InputMaybe<User_Profile_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Profile_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Profile_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_profile" */
export type User_Profile_Arr_Rel_Insert_Input = {
  data: Array<User_Profile_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Profile_Avg_Fields = {
  __typename?: 'user_profile_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_profile" */
export type User_Profile_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_profile". All fields are combined with a logical 'AND'. */
export type User_Profile_Bool_Exp = {
  _and?: InputMaybe<Array<User_Profile_Bool_Exp>>;
  _not?: InputMaybe<User_Profile_Bool_Exp>;
  _or?: InputMaybe<Array<User_Profile_Bool_Exp>>;
  billing_entity?: InputMaybe<Entity_Bool_Exp>;
  billing_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  billing_entity_prefill_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  gdpr_marketing_consent?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  industry?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  lastname?: InputMaybe<String_Comparison_Exp>;
  marketing_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  newsletter_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  order_update_emails_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  registration_entity?: InputMaybe<Entity_Bool_Exp>;
  registration_entity_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_entity_prefill_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  timezone?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_profile" */
export enum User_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserProfilePkey = 'user_profile_pkey',
  /** unique or primary key constraint on columns "user_id" */
  UserProfileUserIdKey = 'user_profile_user_id_key'
}

/** input type for incrementing numeric columns in table "user_profile" */
export type User_Profile_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_profile" */
export type User_Profile_Insert_Input = {
  billing_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gdpr_marketing_consent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  order_update_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_entity?: InputMaybe<Entity_Obj_Rel_Insert_Input>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Profile_Max_Fields = {
  __typename?: 'user_profile_max_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_profile" */
export type User_Profile_Max_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Profile_Min_Fields = {
  __typename?: 'user_profile_min_fields';
  billing_entity_id?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registration_entity_id?: Maybe<Scalars['uuid']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_profile" */
export type User_Profile_Min_Order_By = {
  billing_entity_id?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_profile" */
export type User_Profile_Mutation_Response = {
  __typename?: 'user_profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Profile>;
};

/** input type for inserting object relation for remote table "user_profile" */
export type User_Profile_Obj_Rel_Insert_Input = {
  data: User_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Profile_On_Conflict>;
};

/** on_conflict condition type for table "user_profile" */
export type User_Profile_On_Conflict = {
  constraint: User_Profile_Constraint;
  update_columns?: Array<User_Profile_Update_Column>;
  where?: InputMaybe<User_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "user_profile". */
export type User_Profile_Order_By = {
  billing_entity?: InputMaybe<Entity_Order_By>;
  billing_entity_id?: InputMaybe<Order_By>;
  billing_entity_prefill_enabled?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  gdpr_marketing_consent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  industry?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  marketing_emails_enabled?: InputMaybe<Order_By>;
  newsletter_emails_enabled?: InputMaybe<Order_By>;
  order_update_emails_enabled?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  registration_entity?: InputMaybe<Entity_Order_By>;
  registration_entity_id?: InputMaybe<Order_By>;
  registration_entity_prefill_enabled?: InputMaybe<Order_By>;
  timezone?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_profile */
export type User_Profile_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_profile" */
export enum User_Profile_Select_Column {
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BillingEntityPrefillEnabled = 'billing_entity_prefill_enabled',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  GdprMarketingConsent = 'gdpr_marketing_consent',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  Language = 'language',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  MarketingEmailsEnabled = 'marketing_emails_enabled',
  /** column name */
  NewsletterEmailsEnabled = 'newsletter_emails_enabled',
  /** column name */
  OrderUpdateEmailsEnabled = 'order_update_emails_enabled',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Region = 'region',
  /** column name */
  RegistrationEntityId = 'registration_entity_id',
  /** column name */
  RegistrationEntityPrefillEnabled = 'registration_entity_prefill_enabled',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "user_profile_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_profile" */
export enum User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BillingEntityPrefillEnabled = 'billing_entity_prefill_enabled',
  /** column name */
  GdprMarketingConsent = 'gdpr_marketing_consent',
  /** column name */
  MarketingEmailsEnabled = 'marketing_emails_enabled',
  /** column name */
  NewsletterEmailsEnabled = 'newsletter_emails_enabled',
  /** column name */
  OrderUpdateEmailsEnabled = 'order_update_emails_enabled',
  /** column name */
  RegistrationEntityPrefillEnabled = 'registration_entity_prefill_enabled'
}

/** select "user_profile_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_profile" */
export enum User_Profile_Select_Column_User_Profile_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BillingEntityPrefillEnabled = 'billing_entity_prefill_enabled',
  /** column name */
  GdprMarketingConsent = 'gdpr_marketing_consent',
  /** column name */
  MarketingEmailsEnabled = 'marketing_emails_enabled',
  /** column name */
  NewsletterEmailsEnabled = 'newsletter_emails_enabled',
  /** column name */
  OrderUpdateEmailsEnabled = 'order_update_emails_enabled',
  /** column name */
  RegistrationEntityPrefillEnabled = 'registration_entity_prefill_enabled'
}

/** input type for updating data in table "user_profile" */
export type User_Profile_Set_Input = {
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gdpr_marketing_consent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  order_update_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type User_Profile_Stddev_Fields = {
  __typename?: 'user_profile_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_profile" */
export type User_Profile_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Profile_Stddev_Pop_Fields = {
  __typename?: 'user_profile_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_profile" */
export type User_Profile_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Profile_Stddev_Samp_Fields = {
  __typename?: 'user_profile_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_profile" */
export type User_Profile_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_profile" */
export type User_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Profile_Stream_Cursor_Value_Input = {
  billing_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  billing_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gdpr_marketing_consent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  marketing_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  order_update_emails_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  registration_entity_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_entity_prefill_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Profile_Sum_Fields = {
  __typename?: 'user_profile_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_profile" */
export type User_Profile_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_profile" */
export enum User_Profile_Update_Column {
  /** column name */
  BillingEntityId = 'billing_entity_id',
  /** column name */
  BillingEntityPrefillEnabled = 'billing_entity_prefill_enabled',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  GdprMarketingConsent = 'gdpr_marketing_consent',
  /** column name */
  Id = 'id',
  /** column name */
  Industry = 'industry',
  /** column name */
  Language = 'language',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  MarketingEmailsEnabled = 'marketing_emails_enabled',
  /** column name */
  NewsletterEmailsEnabled = 'newsletter_emails_enabled',
  /** column name */
  OrderUpdateEmailsEnabled = 'order_update_emails_enabled',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Region = 'region',
  /** column name */
  RegistrationEntityId = 'registration_entity_id',
  /** column name */
  RegistrationEntityPrefillEnabled = 'registration_entity_prefill_enabled',
  /** column name */
  Timezone = 'timezone',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type User_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Profile_Var_Pop_Fields = {
  __typename?: 'user_profile_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_profile" */
export type User_Profile_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Profile_Var_Samp_Fields = {
  __typename?: 'user_profile_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_profile" */
export type User_Profile_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Profile_Variance_Fields = {
  __typename?: 'user_profile_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_profile" */
export type User_Profile_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  CpOnboardingFinished = 'cp_onboarding_finished',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  RevolutId = 'revolut_id',
  /** column name */
  Role = 'role',
  /** column name */
  Secret = 'secret',
  /** column name */
  SecretGeneratedAt = 'secret_generated_at',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UnsubscribeToken = 'unsubscribe_token',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  cp_onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['uuid']['input']>;
  revolut_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['uuid']['input']>;
  secret_generated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  assigned_admin_id?: InputMaybe<Scalars['uuid']['input']>;
  assignee_history?: InputMaybe<Scalars['jsonb']['input']>;
  cp_onboarding_finished?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_status_update?: InputMaybe<Scalars['timestamptz']['input']>;
  last_tracking_update?: InputMaybe<Scalars['timestamptz']['input']>;
  note_hub_id?: InputMaybe<Scalars['uuid']['input']>;
  password_hash?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['uuid']['input']>;
  revolut_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['uuid']['input']>;
  secret_generated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  unsubscribe_token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "user_tracking" */
export type User_Tracking = {
  __typename?: 'user_tracking';
  created_at: Scalars['timestamptz']['output'];
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  /** An object relationship */
  tracking_status: User_Tracking_Status;
  /** An object relationship */
  user?: Maybe<User>;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "user_tracking" */
export type User_Tracking_Aggregate = {
  __typename?: 'user_tracking_aggregate';
  aggregate?: Maybe<User_Tracking_Aggregate_Fields>;
  nodes: Array<User_Tracking>;
};

export type User_Tracking_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<User_Tracking_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<User_Tracking_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<User_Tracking_Aggregate_Bool_Exp_Count>;
};

export type User_Tracking_Aggregate_Bool_Exp_Bool_And = {
  arguments: User_Tracking_Select_Column_User_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Tracking_Aggregate_Bool_Exp_Bool_Or = {
  arguments: User_Tracking_Select_Column_User_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Tracking_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type User_Tracking_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<User_Tracking_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_tracking" */
export type User_Tracking_Aggregate_Fields = {
  __typename?: 'user_tracking_aggregate_fields';
  avg?: Maybe<User_Tracking_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<User_Tracking_Max_Fields>;
  min?: Maybe<User_Tracking_Min_Fields>;
  stddev?: Maybe<User_Tracking_Stddev_Fields>;
  stddev_pop?: Maybe<User_Tracking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Tracking_Stddev_Samp_Fields>;
  sum?: Maybe<User_Tracking_Sum_Fields>;
  var_pop?: Maybe<User_Tracking_Var_Pop_Fields>;
  var_samp?: Maybe<User_Tracking_Var_Samp_Fields>;
  variance?: Maybe<User_Tracking_Variance_Fields>;
};


/** aggregate fields of "user_tracking" */
export type User_Tracking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Tracking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_tracking" */
export type User_Tracking_Aggregate_Order_By = {
  avg?: InputMaybe<User_Tracking_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Tracking_Max_Order_By>;
  min?: InputMaybe<User_Tracking_Min_Order_By>;
  stddev?: InputMaybe<User_Tracking_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Tracking_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Tracking_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Tracking_Sum_Order_By>;
  var_pop?: InputMaybe<User_Tracking_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Tracking_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Tracking_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_tracking" */
export type User_Tracking_Arr_Rel_Insert_Input = {
  data: Array<User_Tracking_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Tracking_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Tracking_Avg_Fields = {
  __typename?: 'user_tracking_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_tracking" */
export type User_Tracking_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_tracking". All fields are combined with a logical 'AND'. */
export type User_Tracking_Bool_Exp = {
  _and?: InputMaybe<Array<User_Tracking_Bool_Exp>>;
  _not?: InputMaybe<User_Tracking_Bool_Exp>;
  _or?: InputMaybe<Array<User_Tracking_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  skipped?: InputMaybe<Boolean_Comparison_Exp>;
  tracking_status?: InputMaybe<User_Tracking_Status_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_tracking" */
export enum User_Tracking_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserTrackingPkey = 'user_tracking_pkey'
}

/** input type for incrementing numeric columns in table "user_tracking" */
export type User_Tracking_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_tracking" */
export type User_Tracking_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  tracking_status?: InputMaybe<User_Tracking_Status_Obj_Rel_Insert_Input>;
  user?: InputMaybe<User_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type User_Tracking_Max_Fields = {
  __typename?: 'user_tracking_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_tracking" */
export type User_Tracking_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Tracking_Min_Fields = {
  __typename?: 'user_tracking_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_tracking" */
export type User_Tracking_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_tracking" */
export type User_Tracking_Mutation_Response = {
  __typename?: 'user_tracking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Tracking>;
};

/** on_conflict condition type for table "user_tracking" */
export type User_Tracking_On_Conflict = {
  constraint: User_Tracking_Constraint;
  update_columns?: Array<User_Tracking_Update_Column>;
  where?: InputMaybe<User_Tracking_Bool_Exp>;
};

/** Ordering options when selecting data from "user_tracking". */
export type User_Tracking_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  skipped?: InputMaybe<Order_By>;
  tracking_status?: InputMaybe<User_Tracking_Status_Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_tracking */
export type User_Tracking_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_tracking" */
export enum User_Tracking_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

/** select "user_tracking_aggregate_bool_exp_bool_and_arguments_columns" columns of table "user_tracking" */
export enum User_Tracking_Select_Column_User_Tracking_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** select "user_tracking_aggregate_bool_exp_bool_or_arguments_columns" columns of table "user_tracking" */
export enum User_Tracking_Select_Column_User_Tracking_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Skipped = 'skipped'
}

/** input type for updating data in table "user_tracking" */
export type User_Tracking_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_tracking_status" */
export type User_Tracking_Status = {
  __typename?: 'user_tracking_status';
  is_status: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** aggregated selection of "user_tracking_status" */
export type User_Tracking_Status_Aggregate = {
  __typename?: 'user_tracking_status_aggregate';
  aggregate?: Maybe<User_Tracking_Status_Aggregate_Fields>;
  nodes: Array<User_Tracking_Status>;
};

/** aggregate fields of "user_tracking_status" */
export type User_Tracking_Status_Aggregate_Fields = {
  __typename?: 'user_tracking_status_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<User_Tracking_Status_Max_Fields>;
  min?: Maybe<User_Tracking_Status_Min_Fields>;
};


/** aggregate fields of "user_tracking_status" */
export type User_Tracking_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Tracking_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_tracking_status". All fields are combined with a logical 'AND'. */
export type User_Tracking_Status_Bool_Exp = {
  _and?: InputMaybe<Array<User_Tracking_Status_Bool_Exp>>;
  _not?: InputMaybe<User_Tracking_Status_Bool_Exp>;
  _or?: InputMaybe<Array<User_Tracking_Status_Bool_Exp>>;
  is_status?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_tracking_status" */
export enum User_Tracking_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  UserTrackingStatusPkey = 'user_tracking_status_pkey'
}

/** input type for inserting data into table "user_tracking_status" */
export type User_Tracking_Status_Insert_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type User_Tracking_Status_Max_Fields = {
  __typename?: 'user_tracking_status_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type User_Tracking_Status_Min_Fields = {
  __typename?: 'user_tracking_status_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "user_tracking_status" */
export type User_Tracking_Status_Mutation_Response = {
  __typename?: 'user_tracking_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Tracking_Status>;
};

/** input type for inserting object relation for remote table "user_tracking_status" */
export type User_Tracking_Status_Obj_Rel_Insert_Input = {
  data: User_Tracking_Status_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Tracking_Status_On_Conflict>;
};

/** on_conflict condition type for table "user_tracking_status" */
export type User_Tracking_Status_On_Conflict = {
  constraint: User_Tracking_Status_Constraint;
  update_columns?: Array<User_Tracking_Status_Update_Column>;
  where?: InputMaybe<User_Tracking_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "user_tracking_status". */
export type User_Tracking_Status_Order_By = {
  is_status?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_tracking_status */
export type User_Tracking_Status_Pk_Columns_Input = {
  name: Scalars['String']['input'];
};

/** select columns of table "user_tracking_status" */
export enum User_Tracking_Status_Select_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "user_tracking_status" */
export type User_Tracking_Status_Set_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_tracking_status" */
export type User_Tracking_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Tracking_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Tracking_Status_Stream_Cursor_Value_Input = {
  is_status?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "user_tracking_status" */
export enum User_Tracking_Status_Update_Column {
  /** column name */
  IsStatus = 'is_status',
  /** column name */
  Name = 'name'
}

export type User_Tracking_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Tracking_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Tracking_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type User_Tracking_Stddev_Fields = {
  __typename?: 'user_tracking_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_tracking" */
export type User_Tracking_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Tracking_Stddev_Pop_Fields = {
  __typename?: 'user_tracking_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "user_tracking" */
export type User_Tracking_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Tracking_Stddev_Samp_Fields = {
  __typename?: 'user_tracking_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "user_tracking" */
export type User_Tracking_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_tracking" */
export type User_Tracking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Tracking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Tracking_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type User_Tracking_Sum_Fields = {
  __typename?: 'user_tracking_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_tracking" */
export type User_Tracking_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_tracking" */
export enum User_Tracking_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Skipped = 'skipped',
  /** column name */
  UserId = 'user_id'
}

export type User_Tracking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Tracking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Tracking_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Tracking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Tracking_Var_Pop_Fields = {
  __typename?: 'user_tracking_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "user_tracking" */
export type User_Tracking_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Tracking_Var_Samp_Fields = {
  __typename?: 'user_tracking_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "user_tracking" */
export type User_Tracking_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Tracking_Variance_Fields = {
  __typename?: 'user_tracking_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_tracking" */
export type User_Tracking_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** user_unseen_verification_countNative Query Arguments */
export type User_Unseen_Verification_Count_Arguments = {
  last_status_update_since?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id: Scalars['uuid']['input'];
};

/** update columns of table "user" */
export enum User_Update_Column {
  /** column name */
  AssignedAdminId = 'assigned_admin_id',
  /** column name */
  AssigneeHistory = 'assignee_history',
  /** column name */
  CpOnboardingFinished = 'cp_onboarding_finished',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentHubId = 'document_hub_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LastTrackingUpdate = 'last_tracking_update',
  /** column name */
  NoteHubId = 'note_hub_id',
  /** column name */
  PasswordHash = 'password_hash',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  RevolutId = 'revolut_id',
  /** column name */
  Role = 'role',
  /** column name */
  Secret = 'secret',
  /** column name */
  SecretGeneratedAt = 'secret_generated_at',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UnsubscribeToken = 'unsubscribe_token',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type User_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "verification_result" */
export type Verification_Result = {
  __typename?: 'verification_result';
  absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  additional_check_required: Scalars['Boolean']['output'];
  ai_absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  ai_confidence?: Maybe<Scalars['String']['output']>;
  ai_distinctive_part?: Maybe<Scalars['String']['output']>;
  ai_distinctiveness?: Maybe<Scalars['String']['output']>;
  ai_not_trademark: Scalars['Boolean']['output'];
  ai_other_refusal_reason?: Maybe<Scalars['String']['output']>;
  ai_reasoning?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  ai_suggested_brand?: Maybe<Brand>;
  ai_suggested_brand_id?: Maybe<Scalars['uuid']['output']>;
  ai_transcription?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  brand_snapshot?: Maybe<Brand_Snapshot>;
  brand_snapshot_id?: Maybe<Scalars['uuid']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  distinctive_part?: Maybe<Scalars['String']['output']>;
  distinctiveness: Scalars['String']['output'];
  /** An object relationship */
  document?: Maybe<Document>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  jurisdictions: Scalars['jsonb']['output'];
  no_text_representation?: Maybe<Scalars['Boolean']['output']>;
  other_refusal_reason?: Maybe<Scalars['String']['output']>;
  overall_risk?: Maybe<Scalars['String']['output']>;
  recommended_classes: Scalars['jsonb']['output'];
  /** An object relationship */
  registration_request: Registration_Request;
  registration_request_id: Scalars['uuid']['output'];
  request_note?: Maybe<Scalars['String']['output']>;
  result_note?: Maybe<Scalars['String']['output']>;
  running_business?: Maybe<Scalars['Boolean']['output']>;
  search_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  similar_trademarks: Array<Similar_Trademark>;
  /** An aggregate relationship */
  similar_trademarks_aggregate: Similar_Trademark_Aggregate;
  similarity?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['Boolean']['output']>;
  support?: Maybe<Scalars['Boolean']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by?: Maybe<User>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  use_narrow_gs_list?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  verification_result_similar_trademark_map: Array<Verification_Result_Similar_Trademark_Map>;
  /** An aggregate relationship */
  verification_result_similar_trademark_map_aggregate: Verification_Result_Similar_Trademark_Map_Aggregate;
  verified_classes: Scalars['jsonb']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "verification_result" */
export type Verification_ResultAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultRecommended_ClassesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultSimilar_TrademarksArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultSimilar_Trademarks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Trademark_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Trademark_Order_By>>;
  where?: InputMaybe<Similar_Trademark_Bool_Exp>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultVerification_Result_Similar_Trademark_MapArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultVerification_Result_Similar_Trademark_Map_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Order_By>>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};


/** columns and relationships of "verification_result" */
export type Verification_ResultVerified_ClassesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "verification_result" */
export type Verification_Result_Aggregate = {
  __typename?: 'verification_result_aggregate';
  aggregate?: Maybe<Verification_Result_Aggregate_Fields>;
  nodes: Array<Verification_Result>;
};

export type Verification_Result_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Verification_Result_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Verification_Result_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Verification_Result_Aggregate_Bool_Exp_Count>;
};

export type Verification_Result_Aggregate_Bool_Exp_Bool_And = {
  arguments: Verification_Result_Select_Column_Verification_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Verification_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Verification_Result_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Verification_Result_Select_Column_Verification_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Verification_Result_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Verification_Result_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Verification_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Verification_Result_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "verification_result" */
export type Verification_Result_Aggregate_Fields = {
  __typename?: 'verification_result_aggregate_fields';
  avg?: Maybe<Verification_Result_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Verification_Result_Max_Fields>;
  min?: Maybe<Verification_Result_Min_Fields>;
  stddev?: Maybe<Verification_Result_Stddev_Fields>;
  stddev_pop?: Maybe<Verification_Result_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Verification_Result_Stddev_Samp_Fields>;
  sum?: Maybe<Verification_Result_Sum_Fields>;
  var_pop?: Maybe<Verification_Result_Var_Pop_Fields>;
  var_samp?: Maybe<Verification_Result_Var_Samp_Fields>;
  variance?: Maybe<Verification_Result_Variance_Fields>;
};


/** aggregate fields of "verification_result" */
export type Verification_Result_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Verification_Result_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "verification_result" */
export type Verification_Result_Aggregate_Order_By = {
  avg?: InputMaybe<Verification_Result_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Verification_Result_Max_Order_By>;
  min?: InputMaybe<Verification_Result_Min_Order_By>;
  stddev?: InputMaybe<Verification_Result_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Verification_Result_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Verification_Result_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Verification_Result_Sum_Order_By>;
  var_pop?: InputMaybe<Verification_Result_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Verification_Result_Var_Samp_Order_By>;
  variance?: InputMaybe<Verification_Result_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Verification_Result_Append_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  recommended_classes?: InputMaybe<Scalars['jsonb']['input']>;
  verified_classes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "verification_result" */
export type Verification_Result_Arr_Rel_Insert_Input = {
  data: Array<Verification_Result_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Verification_Result_On_Conflict>;
};

/** aggregate avg on columns */
export type Verification_Result_Avg_Fields = {
  __typename?: 'verification_result_avg_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "verification_result" */
export type Verification_Result_Avg_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "verification_result". All fields are combined with a logical 'AND'. */
export type Verification_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Verification_Result_Bool_Exp>>;
  _not?: InputMaybe<Verification_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Verification_Result_Bool_Exp>>;
  absolute_ground_for_refusal?: InputMaybe<String_Comparison_Exp>;
  additional_check_required?: InputMaybe<Boolean_Comparison_Exp>;
  ai_absolute_ground_for_refusal?: InputMaybe<String_Comparison_Exp>;
  ai_confidence?: InputMaybe<String_Comparison_Exp>;
  ai_distinctive_part?: InputMaybe<String_Comparison_Exp>;
  ai_distinctiveness?: InputMaybe<String_Comparison_Exp>;
  ai_not_trademark?: InputMaybe<Boolean_Comparison_Exp>;
  ai_other_refusal_reason?: InputMaybe<String_Comparison_Exp>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_suggested_brand?: InputMaybe<Brand_Bool_Exp>;
  ai_suggested_brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  ai_transcription?: InputMaybe<String_Comparison_Exp>;
  brand_snapshot?: InputMaybe<Brand_Snapshot_Bool_Exp>;
  brand_snapshot_id?: InputMaybe<Uuid_Comparison_Exp>;
  client_note?: InputMaybe<String_Comparison_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distinctive_part?: InputMaybe<String_Comparison_Exp>;
  distinctiveness?: InputMaybe<String_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  no_text_representation?: InputMaybe<Boolean_Comparison_Exp>;
  other_refusal_reason?: InputMaybe<String_Comparison_Exp>;
  overall_risk?: InputMaybe<String_Comparison_Exp>;
  recommended_classes?: InputMaybe<Jsonb_Comparison_Exp>;
  registration_request?: InputMaybe<Registration_Request_Bool_Exp>;
  registration_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  request_note?: InputMaybe<String_Comparison_Exp>;
  result_note?: InputMaybe<String_Comparison_Exp>;
  running_business?: InputMaybe<Boolean_Comparison_Exp>;
  search_type?: InputMaybe<String_Comparison_Exp>;
  similar_trademarks?: InputMaybe<Similar_Trademark_Bool_Exp>;
  similar_trademarks_aggregate?: InputMaybe<Similar_Trademark_Aggregate_Bool_Exp>;
  similarity?: InputMaybe<String_Comparison_Exp>;
  strategy?: InputMaybe<Boolean_Comparison_Exp>;
  support?: InputMaybe<Boolean_Comparison_Exp>;
  trama_business_description?: InputMaybe<String_Comparison_Exp>;
  transcription?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<User_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  use_narrow_gs_list?: InputMaybe<Boolean_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  value_type?: InputMaybe<String_Comparison_Exp>;
  verification_result_similar_trademark_map?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
  verification_result_similar_trademark_map_aggregate?: InputMaybe<Verification_Result_Similar_Trademark_Map_Aggregate_Bool_Exp>;
  verified_classes?: InputMaybe<Jsonb_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "verification_result" */
export enum Verification_Result_Constraint {
  /** unique or primary key constraint on columns "id" */
  VerificationResultPkey = 'verification_result_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Verification_Result_Delete_At_Path_Input = {
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
  recommended_classes?: InputMaybe<Array<Scalars['String']['input']>>;
  verified_classes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Verification_Result_Delete_Elem_Input = {
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
  recommended_classes?: InputMaybe<Scalars['Int']['input']>;
  verified_classes?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Verification_Result_Delete_Key_Input = {
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
  recommended_classes?: InputMaybe<Scalars['String']['input']>;
  verified_classes?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "verification_result" */
export type Verification_Result_Inc_Input = {
  document_id?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "verification_result" */
export type Verification_Result_Insert_Input = {
  absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  additional_check_required?: InputMaybe<Scalars['Boolean']['input']>;
  ai_absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  ai_confidence?: InputMaybe<Scalars['String']['input']>;
  ai_distinctive_part?: InputMaybe<Scalars['String']['input']>;
  ai_distinctiveness?: InputMaybe<Scalars['String']['input']>;
  ai_not_trademark?: InputMaybe<Scalars['Boolean']['input']>;
  ai_other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_suggested_brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  ai_suggested_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  ai_transcription?: InputMaybe<Scalars['String']['input']>;
  brand_snapshot?: InputMaybe<Brand_Snapshot_Obj_Rel_Insert_Input>;
  brand_snapshot_id?: InputMaybe<Scalars['uuid']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distinctive_part?: InputMaybe<Scalars['String']['input']>;
  distinctiveness?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  no_text_representation?: InputMaybe<Scalars['Boolean']['input']>;
  other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  overall_risk?: InputMaybe<Scalars['String']['input']>;
  recommended_classes?: InputMaybe<Scalars['jsonb']['input']>;
  registration_request?: InputMaybe<Registration_Request_Obj_Rel_Insert_Input>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  request_note?: InputMaybe<Scalars['String']['input']>;
  result_note?: InputMaybe<Scalars['String']['input']>;
  running_business?: InputMaybe<Scalars['Boolean']['input']>;
  search_type?: InputMaybe<Scalars['String']['input']>;
  similar_trademarks?: InputMaybe<Similar_Trademark_Arr_Rel_Insert_Input>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by?: InputMaybe<User_Obj_Rel_Insert_Input>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_narrow_gs_list?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
  verification_result_similar_trademark_map?: InputMaybe<Verification_Result_Similar_Trademark_Map_Arr_Rel_Insert_Input>;
  verified_classes?: InputMaybe<Scalars['jsonb']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Verification_Result_Max_Fields = {
  __typename?: 'verification_result_max_fields';
  absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  ai_absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  ai_confidence?: Maybe<Scalars['String']['output']>;
  ai_distinctive_part?: Maybe<Scalars['String']['output']>;
  ai_distinctiveness?: Maybe<Scalars['String']['output']>;
  ai_other_refusal_reason?: Maybe<Scalars['String']['output']>;
  ai_suggested_brand_id?: Maybe<Scalars['uuid']['output']>;
  ai_transcription?: Maybe<Scalars['String']['output']>;
  brand_snapshot_id?: Maybe<Scalars['uuid']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  distinctive_part?: Maybe<Scalars['String']['output']>;
  distinctiveness?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  other_refusal_reason?: Maybe<Scalars['String']['output']>;
  overall_risk?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  request_note?: Maybe<Scalars['String']['output']>;
  result_note?: Maybe<Scalars['String']['output']>;
  search_type?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "verification_result" */
export type Verification_Result_Max_Order_By = {
  absolute_ground_for_refusal?: InputMaybe<Order_By>;
  ai_absolute_ground_for_refusal?: InputMaybe<Order_By>;
  ai_confidence?: InputMaybe<Order_By>;
  ai_distinctive_part?: InputMaybe<Order_By>;
  ai_distinctiveness?: InputMaybe<Order_By>;
  ai_other_refusal_reason?: InputMaybe<Order_By>;
  ai_suggested_brand_id?: InputMaybe<Order_By>;
  ai_transcription?: InputMaybe<Order_By>;
  brand_snapshot_id?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distinctive_part?: InputMaybe<Order_By>;
  distinctiveness?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other_refusal_reason?: InputMaybe<Order_By>;
  overall_risk?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  request_note?: InputMaybe<Order_By>;
  result_note?: InputMaybe<Order_By>;
  search_type?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Verification_Result_Min_Fields = {
  __typename?: 'verification_result_min_fields';
  absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  ai_absolute_ground_for_refusal?: Maybe<Scalars['String']['output']>;
  ai_confidence?: Maybe<Scalars['String']['output']>;
  ai_distinctive_part?: Maybe<Scalars['String']['output']>;
  ai_distinctiveness?: Maybe<Scalars['String']['output']>;
  ai_other_refusal_reason?: Maybe<Scalars['String']['output']>;
  ai_suggested_brand_id?: Maybe<Scalars['uuid']['output']>;
  ai_transcription?: Maybe<Scalars['String']['output']>;
  brand_snapshot_id?: Maybe<Scalars['uuid']['output']>;
  client_note?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  distinctive_part?: Maybe<Scalars['String']['output']>;
  distinctiveness?: Maybe<Scalars['String']['output']>;
  document_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  other_refusal_reason?: Maybe<Scalars['String']['output']>;
  overall_risk?: Maybe<Scalars['String']['output']>;
  registration_request_id?: Maybe<Scalars['uuid']['output']>;
  request_note?: Maybe<Scalars['String']['output']>;
  result_note?: Maybe<Scalars['String']['output']>;
  search_type?: Maybe<Scalars['String']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  trama_business_description?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  value_type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "verification_result" */
export type Verification_Result_Min_Order_By = {
  absolute_ground_for_refusal?: InputMaybe<Order_By>;
  ai_absolute_ground_for_refusal?: InputMaybe<Order_By>;
  ai_confidence?: InputMaybe<Order_By>;
  ai_distinctive_part?: InputMaybe<Order_By>;
  ai_distinctiveness?: InputMaybe<Order_By>;
  ai_other_refusal_reason?: InputMaybe<Order_By>;
  ai_suggested_brand_id?: InputMaybe<Order_By>;
  ai_transcription?: InputMaybe<Order_By>;
  brand_snapshot_id?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distinctive_part?: InputMaybe<Order_By>;
  distinctiveness?: InputMaybe<Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  other_refusal_reason?: InputMaybe<Order_By>;
  overall_risk?: InputMaybe<Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  request_note?: InputMaybe<Order_By>;
  result_note?: InputMaybe<Order_By>;
  search_type?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "verification_result" */
export type Verification_Result_Mutation_Response = {
  __typename?: 'verification_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Verification_Result>;
};

/** input type for inserting object relation for remote table "verification_result" */
export type Verification_Result_Obj_Rel_Insert_Input = {
  data: Verification_Result_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Verification_Result_On_Conflict>;
};

/** on_conflict condition type for table "verification_result" */
export type Verification_Result_On_Conflict = {
  constraint: Verification_Result_Constraint;
  update_columns?: Array<Verification_Result_Update_Column>;
  where?: InputMaybe<Verification_Result_Bool_Exp>;
};

/** Ordering options when selecting data from "verification_result". */
export type Verification_Result_Order_By = {
  absolute_ground_for_refusal?: InputMaybe<Order_By>;
  additional_check_required?: InputMaybe<Order_By>;
  ai_absolute_ground_for_refusal?: InputMaybe<Order_By>;
  ai_confidence?: InputMaybe<Order_By>;
  ai_distinctive_part?: InputMaybe<Order_By>;
  ai_distinctiveness?: InputMaybe<Order_By>;
  ai_not_trademark?: InputMaybe<Order_By>;
  ai_other_refusal_reason?: InputMaybe<Order_By>;
  ai_reasoning?: InputMaybe<Order_By>;
  ai_suggested_brand?: InputMaybe<Brand_Order_By>;
  ai_suggested_brand_id?: InputMaybe<Order_By>;
  ai_transcription?: InputMaybe<Order_By>;
  brand_snapshot?: InputMaybe<Brand_Snapshot_Order_By>;
  brand_snapshot_id?: InputMaybe<Order_By>;
  client_note?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distinctive_part?: InputMaybe<Order_By>;
  distinctiveness?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  no_text_representation?: InputMaybe<Order_By>;
  other_refusal_reason?: InputMaybe<Order_By>;
  overall_risk?: InputMaybe<Order_By>;
  recommended_classes?: InputMaybe<Order_By>;
  registration_request?: InputMaybe<Registration_Request_Order_By>;
  registration_request_id?: InputMaybe<Order_By>;
  request_note?: InputMaybe<Order_By>;
  result_note?: InputMaybe<Order_By>;
  running_business?: InputMaybe<Order_By>;
  search_type?: InputMaybe<Order_By>;
  similar_trademarks_aggregate?: InputMaybe<Similar_Trademark_Aggregate_Order_By>;
  similarity?: InputMaybe<Order_By>;
  strategy?: InputMaybe<Order_By>;
  support?: InputMaybe<Order_By>;
  trama_business_description?: InputMaybe<Order_By>;
  transcription?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<User_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  use_narrow_gs_list?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  value_type?: InputMaybe<Order_By>;
  verification_result_similar_trademark_map_aggregate?: InputMaybe<Verification_Result_Similar_Trademark_Map_Aggregate_Order_By>;
  verified_classes?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: verification_result */
export type Verification_Result_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Verification_Result_Prepend_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  recommended_classes?: InputMaybe<Scalars['jsonb']['input']>;
  verified_classes?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "verification_result" */
export enum Verification_Result_Select_Column {
  /** column name */
  AbsoluteGroundForRefusal = 'absolute_ground_for_refusal',
  /** column name */
  AdditionalCheckRequired = 'additional_check_required',
  /** column name */
  AiAbsoluteGroundForRefusal = 'ai_absolute_ground_for_refusal',
  /** column name */
  AiConfidence = 'ai_confidence',
  /** column name */
  AiDistinctivePart = 'ai_distinctive_part',
  /** column name */
  AiDistinctiveness = 'ai_distinctiveness',
  /** column name */
  AiNotTrademark = 'ai_not_trademark',
  /** column name */
  AiOtherRefusalReason = 'ai_other_refusal_reason',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiSuggestedBrandId = 'ai_suggested_brand_id',
  /** column name */
  AiTranscription = 'ai_transcription',
  /** column name */
  BrandSnapshotId = 'brand_snapshot_id',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DistinctivePart = 'distinctive_part',
  /** column name */
  Distinctiveness = 'distinctiveness',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  NoTextRepresentation = 'no_text_representation',
  /** column name */
  OtherRefusalReason = 'other_refusal_reason',
  /** column name */
  OverallRisk = 'overall_risk',
  /** column name */
  RecommendedClasses = 'recommended_classes',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  RequestNote = 'request_note',
  /** column name */
  ResultNote = 'result_note',
  /** column name */
  RunningBusiness = 'running_business',
  /** column name */
  SearchType = 'search_type',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Strategy = 'strategy',
  /** column name */
  Support = 'support',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  Transcription = 'transcription',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UseNarrowGsList = 'use_narrow_gs_list',
  /** column name */
  Value = 'value',
  /** column name */
  ValueType = 'value_type',
  /** column name */
  VerifiedClasses = 'verified_classes',
  /** column name */
  Version = 'version'
}

/** select "verification_result_aggregate_bool_exp_bool_and_arguments_columns" columns of table "verification_result" */
export enum Verification_Result_Select_Column_Verification_Result_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdditionalCheckRequired = 'additional_check_required',
  /** column name */
  AiNotTrademark = 'ai_not_trademark',
  /** column name */
  Completed = 'completed',
  /** column name */
  NoTextRepresentation = 'no_text_representation',
  /** column name */
  RunningBusiness = 'running_business',
  /** column name */
  Strategy = 'strategy',
  /** column name */
  Support = 'support',
  /** column name */
  UseNarrowGsList = 'use_narrow_gs_list'
}

/** select "verification_result_aggregate_bool_exp_bool_or_arguments_columns" columns of table "verification_result" */
export enum Verification_Result_Select_Column_Verification_Result_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdditionalCheckRequired = 'additional_check_required',
  /** column name */
  AiNotTrademark = 'ai_not_trademark',
  /** column name */
  Completed = 'completed',
  /** column name */
  NoTextRepresentation = 'no_text_representation',
  /** column name */
  RunningBusiness = 'running_business',
  /** column name */
  Strategy = 'strategy',
  /** column name */
  Support = 'support',
  /** column name */
  UseNarrowGsList = 'use_narrow_gs_list'
}

/** input type for updating data in table "verification_result" */
export type Verification_Result_Set_Input = {
  absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  additional_check_required?: InputMaybe<Scalars['Boolean']['input']>;
  ai_absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  ai_confidence?: InputMaybe<Scalars['String']['input']>;
  ai_distinctive_part?: InputMaybe<Scalars['String']['input']>;
  ai_distinctiveness?: InputMaybe<Scalars['String']['input']>;
  ai_not_trademark?: InputMaybe<Scalars['Boolean']['input']>;
  ai_other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_suggested_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  ai_transcription?: InputMaybe<Scalars['String']['input']>;
  brand_snapshot_id?: InputMaybe<Scalars['uuid']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distinctive_part?: InputMaybe<Scalars['String']['input']>;
  distinctiveness?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  no_text_representation?: InputMaybe<Scalars['Boolean']['input']>;
  other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  overall_risk?: InputMaybe<Scalars['String']['input']>;
  recommended_classes?: InputMaybe<Scalars['jsonb']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  request_note?: InputMaybe<Scalars['String']['input']>;
  result_note?: InputMaybe<Scalars['String']['input']>;
  running_business?: InputMaybe<Scalars['Boolean']['input']>;
  search_type?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_narrow_gs_list?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
  verified_classes?: InputMaybe<Scalars['jsonb']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map = {
  __typename?: 'verification_result_similar_trademark_map';
  ai_reasoning: Scalars['jsonb']['output'];
  ai_similarity_of_gs?: Maybe<Scalars['String']['output']>;
  ai_similarity_of_marks?: Maybe<Scalars['String']['output']>;
  competitor?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  external_trademark: External_Trademark;
  external_trademark_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  jurisdictions: Scalars['jsonb']['output'];
  metadata: Scalars['jsonb']['output'];
  similarity: Scalars['String']['output'];
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  verification_result: Verification_Result;
  verification_result_id: Scalars['uuid']['output'];
};


/** columns and relationships of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_MapAi_ReasoningArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_MapJurisdictionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_MapMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Aggregate = {
  __typename?: 'verification_result_similar_trademark_map_aggregate';
  aggregate?: Maybe<Verification_Result_Similar_Trademark_Map_Aggregate_Fields>;
  nodes: Array<Verification_Result_Similar_Trademark_Map>;
};

export type Verification_Result_Similar_Trademark_Map_Aggregate_Bool_Exp = {
  count?: InputMaybe<Verification_Result_Similar_Trademark_Map_Aggregate_Bool_Exp_Count>;
};

export type Verification_Result_Similar_Trademark_Map_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Aggregate_Fields = {
  __typename?: 'verification_result_similar_trademark_map_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Verification_Result_Similar_Trademark_Map_Max_Fields>;
  min?: Maybe<Verification_Result_Similar_Trademark_Map_Min_Fields>;
};


/** aggregate fields of "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Verification_Result_Similar_Trademark_Map_Max_Order_By>;
  min?: InputMaybe<Verification_Result_Similar_Trademark_Map_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Verification_Result_Similar_Trademark_Map_Append_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Arr_Rel_Insert_Input = {
  data: Array<Verification_Result_Similar_Trademark_Map_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Verification_Result_Similar_Trademark_Map_On_Conflict>;
};

/** Boolean expression to filter rows from the table "verification_result_similar_trademark_map". All fields are combined with a logical 'AND'. */
export type Verification_Result_Similar_Trademark_Map_Bool_Exp = {
  _and?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Bool_Exp>>;
  _not?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
  _or?: InputMaybe<Array<Verification_Result_Similar_Trademark_Map_Bool_Exp>>;
  ai_reasoning?: InputMaybe<Jsonb_Comparison_Exp>;
  ai_similarity_of_gs?: InputMaybe<String_Comparison_Exp>;
  ai_similarity_of_marks?: InputMaybe<String_Comparison_Exp>;
  competitor?: InputMaybe<String_Comparison_Exp>;
  external_trademark?: InputMaybe<External_Trademark_Bool_Exp>;
  external_trademark_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<Jsonb_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  similarity?: InputMaybe<String_Comparison_Exp>;
  similarity_of_gs?: InputMaybe<String_Comparison_Exp>;
  similarity_of_marks?: InputMaybe<String_Comparison_Exp>;
  verification_result?: InputMaybe<Verification_Result_Bool_Exp>;
  verification_result_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "verification_result_similar_trademark_map" */
export enum Verification_Result_Similar_Trademark_Map_Constraint {
  /** unique or primary key constraint on columns "id" */
  VerificationResultSimilarTrademarkMapPkey = 'verification_result_similar_trademark_map_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Verification_Result_Similar_Trademark_Map_Delete_At_Path_Input = {
  ai_reasoning?: InputMaybe<Array<Scalars['String']['input']>>;
  jurisdictions?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Verification_Result_Similar_Trademark_Map_Delete_Elem_Input = {
  ai_reasoning?: InputMaybe<Scalars['Int']['input']>;
  jurisdictions?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Verification_Result_Similar_Trademark_Map_Delete_Key_Input = {
  ai_reasoning?: InputMaybe<Scalars['String']['input']>;
  jurisdictions?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Insert_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  ai_similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  competitor?: InputMaybe<Scalars['String']['input']>;
  external_trademark?: InputMaybe<External_Trademark_Obj_Rel_Insert_Input>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  verification_result?: InputMaybe<Verification_Result_Obj_Rel_Insert_Input>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Verification_Result_Similar_Trademark_Map_Max_Fields = {
  __typename?: 'verification_result_similar_trademark_map_max_fields';
  ai_similarity_of_gs?: Maybe<Scalars['String']['output']>;
  ai_similarity_of_marks?: Maybe<Scalars['String']['output']>;
  competitor?: Maybe<Scalars['String']['output']>;
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  verification_result_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Max_Order_By = {
  ai_similarity_of_gs?: InputMaybe<Order_By>;
  ai_similarity_of_marks?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Verification_Result_Similar_Trademark_Map_Min_Fields = {
  __typename?: 'verification_result_similar_trademark_map_min_fields';
  ai_similarity_of_gs?: Maybe<Scalars['String']['output']>;
  ai_similarity_of_marks?: Maybe<Scalars['String']['output']>;
  competitor?: Maybe<Scalars['String']['output']>;
  external_trademark_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  similarity?: Maybe<Scalars['String']['output']>;
  similarity_of_gs?: Maybe<Scalars['String']['output']>;
  similarity_of_marks?: Maybe<Scalars['String']['output']>;
  verification_result_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Min_Order_By = {
  ai_similarity_of_gs?: InputMaybe<Order_By>;
  ai_similarity_of_marks?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Mutation_Response = {
  __typename?: 'verification_result_similar_trademark_map_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Verification_Result_Similar_Trademark_Map>;
};

/** on_conflict condition type for table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_On_Conflict = {
  constraint: Verification_Result_Similar_Trademark_Map_Constraint;
  update_columns?: Array<Verification_Result_Similar_Trademark_Map_Update_Column>;
  where?: InputMaybe<Verification_Result_Similar_Trademark_Map_Bool_Exp>;
};

/** Ordering options when selecting data from "verification_result_similar_trademark_map". */
export type Verification_Result_Similar_Trademark_Map_Order_By = {
  ai_reasoning?: InputMaybe<Order_By>;
  ai_similarity_of_gs?: InputMaybe<Order_By>;
  ai_similarity_of_marks?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  external_trademark?: InputMaybe<External_Trademark_Order_By>;
  external_trademark_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  similarity?: InputMaybe<Order_By>;
  similarity_of_gs?: InputMaybe<Order_By>;
  similarity_of_marks?: InputMaybe<Order_By>;
  verification_result?: InputMaybe<Verification_Result_Order_By>;
  verification_result_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: verification_result_similar_trademark_map */
export type Verification_Result_Similar_Trademark_Map_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Verification_Result_Similar_Trademark_Map_Prepend_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "verification_result_similar_trademark_map" */
export enum Verification_Result_Similar_Trademark_Map_Select_Column {
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiSimilarityOfGs = 'ai_similarity_of_gs',
  /** column name */
  AiSimilarityOfMarks = 'ai_similarity_of_marks',
  /** column name */
  Competitor = 'competitor',
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  SimilarityOfGs = 'similarity_of_gs',
  /** column name */
  SimilarityOfMarks = 'similarity_of_marks',
  /** column name */
  VerificationResultId = 'verification_result_id'
}

/** input type for updating data in table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Set_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  ai_similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  competitor?: InputMaybe<Scalars['String']['input']>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "verification_result_similar_trademark_map" */
export type Verification_Result_Similar_Trademark_Map_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Verification_Result_Similar_Trademark_Map_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Verification_Result_Similar_Trademark_Map_Stream_Cursor_Value_Input = {
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  ai_similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  competitor?: InputMaybe<Scalars['String']['input']>;
  external_trademark_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  similarity_of_gs?: InputMaybe<Scalars['String']['input']>;
  similarity_of_marks?: InputMaybe<Scalars['String']['input']>;
  verification_result_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "verification_result_similar_trademark_map" */
export enum Verification_Result_Similar_Trademark_Map_Update_Column {
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiSimilarityOfGs = 'ai_similarity_of_gs',
  /** column name */
  AiSimilarityOfMarks = 'ai_similarity_of_marks',
  /** column name */
  Competitor = 'competitor',
  /** column name */
  ExternalTrademarkId = 'external_trademark_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  SimilarityOfGs = 'similarity_of_gs',
  /** column name */
  SimilarityOfMarks = 'similarity_of_marks',
  /** column name */
  VerificationResultId = 'verification_result_id'
}

export type Verification_Result_Similar_Trademark_Map_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Verification_Result_Similar_Trademark_Map_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Verification_Result_Similar_Trademark_Map_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Verification_Result_Similar_Trademark_Map_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Verification_Result_Similar_Trademark_Map_Set_Input>;
  /** filter the rows which have to be updated */
  where: Verification_Result_Similar_Trademark_Map_Bool_Exp;
};

/** aggregate stddev on columns */
export type Verification_Result_Stddev_Fields = {
  __typename?: 'verification_result_stddev_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "verification_result" */
export type Verification_Result_Stddev_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Verification_Result_Stddev_Pop_Fields = {
  __typename?: 'verification_result_stddev_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "verification_result" */
export type Verification_Result_Stddev_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Verification_Result_Stddev_Samp_Fields = {
  __typename?: 'verification_result_stddev_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "verification_result" */
export type Verification_Result_Stddev_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "verification_result" */
export type Verification_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Verification_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Verification_Result_Stream_Cursor_Value_Input = {
  absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  additional_check_required?: InputMaybe<Scalars['Boolean']['input']>;
  ai_absolute_ground_for_refusal?: InputMaybe<Scalars['String']['input']>;
  ai_confidence?: InputMaybe<Scalars['String']['input']>;
  ai_distinctive_part?: InputMaybe<Scalars['String']['input']>;
  ai_distinctiveness?: InputMaybe<Scalars['String']['input']>;
  ai_not_trademark?: InputMaybe<Scalars['Boolean']['input']>;
  ai_other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  ai_reasoning?: InputMaybe<Scalars['jsonb']['input']>;
  ai_suggested_brand_id?: InputMaybe<Scalars['uuid']['input']>;
  ai_transcription?: InputMaybe<Scalars['String']['input']>;
  brand_snapshot_id?: InputMaybe<Scalars['uuid']['input']>;
  client_note?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distinctive_part?: InputMaybe<Scalars['String']['input']>;
  distinctiveness?: InputMaybe<Scalars['String']['input']>;
  document_id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jurisdictions?: InputMaybe<Scalars['jsonb']['input']>;
  no_text_representation?: InputMaybe<Scalars['Boolean']['input']>;
  other_refusal_reason?: InputMaybe<Scalars['String']['input']>;
  overall_risk?: InputMaybe<Scalars['String']['input']>;
  recommended_classes?: InputMaybe<Scalars['jsonb']['input']>;
  registration_request_id?: InputMaybe<Scalars['uuid']['input']>;
  request_note?: InputMaybe<Scalars['String']['input']>;
  result_note?: InputMaybe<Scalars['String']['input']>;
  running_business?: InputMaybe<Scalars['Boolean']['input']>;
  search_type?: InputMaybe<Scalars['String']['input']>;
  similarity?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['Boolean']['input']>;
  support?: InputMaybe<Scalars['Boolean']['input']>;
  trama_business_description?: InputMaybe<Scalars['String']['input']>;
  transcription?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  use_narrow_gs_list?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_type?: InputMaybe<Scalars['String']['input']>;
  verified_classes?: InputMaybe<Scalars['jsonb']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Verification_Result_Sum_Fields = {
  __typename?: 'verification_result_sum_fields';
  document_id?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "verification_result" */
export type Verification_Result_Sum_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** update columns of table "verification_result" */
export enum Verification_Result_Update_Column {
  /** column name */
  AbsoluteGroundForRefusal = 'absolute_ground_for_refusal',
  /** column name */
  AdditionalCheckRequired = 'additional_check_required',
  /** column name */
  AiAbsoluteGroundForRefusal = 'ai_absolute_ground_for_refusal',
  /** column name */
  AiConfidence = 'ai_confidence',
  /** column name */
  AiDistinctivePart = 'ai_distinctive_part',
  /** column name */
  AiDistinctiveness = 'ai_distinctiveness',
  /** column name */
  AiNotTrademark = 'ai_not_trademark',
  /** column name */
  AiOtherRefusalReason = 'ai_other_refusal_reason',
  /** column name */
  AiReasoning = 'ai_reasoning',
  /** column name */
  AiSuggestedBrandId = 'ai_suggested_brand_id',
  /** column name */
  AiTranscription = 'ai_transcription',
  /** column name */
  BrandSnapshotId = 'brand_snapshot_id',
  /** column name */
  ClientNote = 'client_note',
  /** column name */
  Completed = 'completed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DistinctivePart = 'distinctive_part',
  /** column name */
  Distinctiveness = 'distinctiveness',
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  NoTextRepresentation = 'no_text_representation',
  /** column name */
  OtherRefusalReason = 'other_refusal_reason',
  /** column name */
  OverallRisk = 'overall_risk',
  /** column name */
  RecommendedClasses = 'recommended_classes',
  /** column name */
  RegistrationRequestId = 'registration_request_id',
  /** column name */
  RequestNote = 'request_note',
  /** column name */
  ResultNote = 'result_note',
  /** column name */
  RunningBusiness = 'running_business',
  /** column name */
  SearchType = 'search_type',
  /** column name */
  Similarity = 'similarity',
  /** column name */
  Strategy = 'strategy',
  /** column name */
  Support = 'support',
  /** column name */
  TramaBusinessDescription = 'trama_business_description',
  /** column name */
  Transcription = 'transcription',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UseNarrowGsList = 'use_narrow_gs_list',
  /** column name */
  Value = 'value',
  /** column name */
  ValueType = 'value_type',
  /** column name */
  VerifiedClasses = 'verified_classes',
  /** column name */
  Version = 'version'
}

export type Verification_Result_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Verification_Result_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Verification_Result_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Verification_Result_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Verification_Result_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Verification_Result_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Verification_Result_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Verification_Result_Set_Input>;
  /** filter the rows which have to be updated */
  where: Verification_Result_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Verification_Result_Var_Pop_Fields = {
  __typename?: 'verification_result_var_pop_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "verification_result" */
export type Verification_Result_Var_Pop_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Verification_Result_Var_Samp_Fields = {
  __typename?: 'verification_result_var_samp_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "verification_result" */
export type Verification_Result_Var_Samp_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Verification_Result_Variance_Fields = {
  __typename?: 'verification_result_variance_fields';
  document_id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "verification_result" */
export type Verification_Result_Variance_Order_By = {
  document_id?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** verification_searchNative Query Arguments */
export type Verification_Search_Arguments = {
  /** Comma-separated list of formatted class codes */
  classes?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of jurisdictions */
  jurisdictions: Scalars['String']['input'];
  query: Scalars['String']['input'];
  since: Scalars['date']['input'];
};

export type Verification_Search_Result = {
  __typename?: 'verification_search_result';
  classes?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  dmetaphone_score: Scalars['Float']['output'];
  fts_score: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  jurisdictions: Scalars['String']['output'];
  last_status_update: Scalars['timestamptz']['output'];
  levenshtein_score: Scalars['Float']['output'];
  metaphone_score: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  trigram_score: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the logical model for "verification_search_result". All fields are combined with a logical 'AND'. */
export type Verification_Search_Result_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<Verification_Search_Result_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<Verification_Search_Result_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<Verification_Search_Result_Bool_Exp_Bool_Exp>>;
  classes?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dmetaphone_score?: InputMaybe<Float_Comparison_Exp>;
  fts_score?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jurisdictions?: InputMaybe<String_Comparison_Exp>;
  last_status_update?: InputMaybe<Timestamptz_Comparison_Exp>;
  levenshtein_score?: InputMaybe<Float_Comparison_Exp>;
  metaphone_score?: InputMaybe<Float_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  score?: InputMaybe<Float_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trigram_score?: InputMaybe<Float_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export enum Verification_Search_Result_Enum_Name {
  /** column name */
  Classes = 'classes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DmetaphoneScore = 'dmetaphone_score',
  /** column name */
  FtsScore = 'fts_score',
  /** column name */
  Id = 'id',
  /** column name */
  Jurisdictions = 'jurisdictions',
  /** column name */
  LastStatusUpdate = 'last_status_update',
  /** column name */
  LevenshteinScore = 'levenshtein_score',
  /** column name */
  MetaphoneScore = 'metaphone_score',
  /** column name */
  Name = 'name',
  /** column name */
  Score = 'score',
  /** column name */
  Status = 'status',
  /** column name */
  TrigramScore = 'trigram_score',
  /** column name */
  Type = 'type'
}

/** Ordering options when selecting data from "verification_search_result". */
export type Verification_Search_Result_Order_By = {
  classes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dmetaphone_score?: InputMaybe<Order_By>;
  fts_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jurisdictions?: InputMaybe<Order_By>;
  last_status_update?: InputMaybe<Order_By>;
  levenshtein_score?: InputMaybe<Order_By>;
  metaphone_score?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  score?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trigram_score?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** columns and relationships of "website" */
export type Website = {
  __typename?: 'website';
  /** An object relationship */
  brand: Brand;
  brand_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  link: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "website" */
export type Website_Aggregate = {
  __typename?: 'website_aggregate';
  aggregate?: Maybe<Website_Aggregate_Fields>;
  nodes: Array<Website>;
};

export type Website_Aggregate_Bool_Exp = {
  count?: InputMaybe<Website_Aggregate_Bool_Exp_Count>;
};

export type Website_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Website_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Website_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "website" */
export type Website_Aggregate_Fields = {
  __typename?: 'website_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Website_Max_Fields>;
  min?: Maybe<Website_Min_Fields>;
};


/** aggregate fields of "website" */
export type Website_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Website_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "website" */
export type Website_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Website_Max_Order_By>;
  min?: InputMaybe<Website_Min_Order_By>;
};

/** input type for inserting array relation for remote table "website" */
export type Website_Arr_Rel_Insert_Input = {
  data: Array<Website_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Website_On_Conflict>;
};

/** Boolean expression to filter rows from the table "website". All fields are combined with a logical 'AND'. */
export type Website_Bool_Exp = {
  _and?: InputMaybe<Array<Website_Bool_Exp>>;
  _not?: InputMaybe<Website_Bool_Exp>;
  _or?: InputMaybe<Array<Website_Bool_Exp>>;
  brand?: InputMaybe<Brand_Bool_Exp>;
  brand_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  metadata?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "website" */
export enum Website_Constraint {
  /** unique or primary key constraint on columns "id" */
  WebsitePkey = 'website_pkey'
}

/** input type for inserting data into table "website" */
export type Website_Insert_Input = {
  brand?: InputMaybe<Brand_Obj_Rel_Insert_Input>;
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Website_Max_Fields = {
  __typename?: 'website_max_fields';
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "website" */
export type Website_Max_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Website_Min_Fields = {
  __typename?: 'website_min_fields';
  brand_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "website" */
export type Website_Min_Order_By = {
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "website" */
export type Website_Mutation_Response = {
  __typename?: 'website_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Website>;
};

/** on_conflict condition type for table "website" */
export type Website_On_Conflict = {
  constraint: Website_Constraint;
  update_columns?: Array<Website_Update_Column>;
  where?: InputMaybe<Website_Bool_Exp>;
};

/** Ordering options when selecting data from "website". */
export type Website_Order_By = {
  brand?: InputMaybe<Brand_Order_By>;
  brand_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: website */
export type Website_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "website" */
export enum Website_Select_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "website" */
export type Website_Set_Input = {
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "website" */
export type Website_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Website_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Website_Stream_Cursor_Value_Input = {
  brand_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "website" */
export enum Website_Update_Column {
  /** column name */
  BrandId = 'brand_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Link = 'link',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Website_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Website_Set_Input>;
  /** filter the rows which have to be updated */
  where: Website_Bool_Exp;
};

export type AddressFragment = { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null };

export type AddressDataFragment = { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null };

export type AddressInsertOneMutationVariables = Exact<{
  object: Address_Insert_Input;
}>;


export type AddressInsertOneMutation = { __typename?: 'mutation_root', insert_address_one?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type AddressUpsertOneMutationVariables = Exact<{
  object: Address_Insert_Input;
}>;


export type AddressUpsertOneMutation = { __typename?: 'mutation_root', insert_address_one?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type AddressUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  changes: Address_Set_Input;
}>;


export type AddressUpdateOneMutation = { __typename?: 'mutation_root', update_address_by_pk?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type AddressDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type AddressDeleteOneMutation = { __typename?: 'mutation_root', delete_address_by_pk_audited: Array<{ __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null }> };

export type AddressGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type AddressGetByIdQuery = { __typename?: 'query_root', address_by_pk?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type AiGsItemsAnalysisFragment = { __typename?: 'ai_gs_items_analysis', id: string, registration_request_id: string, jurisdiction: string, class_number: string, business_description: string, class_items: any, analysis: string, created_at: string };

export type AiGsItemsAnalysisInsertOneMutationVariables = Exact<{
  object: Ai_Gs_Items_Analysis_Insert_Input;
}>;


export type AiGsItemsAnalysisInsertOneMutation = { __typename?: 'mutation_root', insert_ai_gs_items_analysis_one?: { __typename?: 'ai_gs_items_analysis', id: string, registration_request_id: string, jurisdiction: string, class_number: string, business_description: string, class_items: any, analysis: string, created_at: string } | null };

export type AiGsItemsAnalysisGetManyQueryVariables = Exact<{
  where: Ai_Gs_Items_Analysis_Bool_Exp;
  order_by?: InputMaybe<Array<Ai_Gs_Items_Analysis_Order_By> | Ai_Gs_Items_Analysis_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Ai_Gs_Items_Analysis_Select_Column> | Ai_Gs_Items_Analysis_Select_Column>;
}>;


export type AiGsItemsAnalysisGetManyQuery = { __typename?: 'query_root', ai_gs_items_analysis: Array<{ __typename?: 'ai_gs_items_analysis', id: string, registration_request_id: string, jurisdiction: string, class_number: string, business_description: string, class_items: any, analysis: string, created_at: string }> };

export type ApplicationFragment = { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type ApplicationDataFragment = { __typename?: 'application', id: string, registration_entity_id?: string | null, mailing_address_id?: number | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_request?: { __typename?: 'registration_request', id: string, type: string, value: string } | null };

export type ApplicationInsertOneMutationVariables = Exact<{
  object: Application_Insert_Input;
}>;


export type ApplicationInsertOneMutation = { __typename?: 'mutation_root', insert_application_one?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type ApplicationUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Application_Set_Input;
}>;


export type ApplicationUpdateMutation = { __typename?: 'mutation_root', update_application_by_pk?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type ApplicationGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Application_Bool_Exp>;
  order_by?: InputMaybe<Array<Application_Order_By> | Application_Order_By>;
}>;


export type ApplicationGetManyQuery = { __typename?: 'query_root', application: Array<{ __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }> };

export type ApplicationGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationGetByIdQuery = { __typename?: 'query_root', application_by_pk?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type ApplicationDataByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationDataByIdQuery = { __typename?: 'query_root', application_by_pk?: { __typename?: 'application', id: string, registration_entity_id?: string | null, mailing_address_id?: number | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_request?: { __typename?: 'registration_request', id: string, type: string, value: string } | null } | null };

export type ApplicationJurisdictionFragment = { __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any };

export type ApplicationJurisdictionUpdateByIdMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  _set: Application_Jurisdiction_Set_Input;
}>;


export type ApplicationJurisdictionUpdateByIdMutation = { __typename?: 'mutation_root', update_application_jurisdiction_by_pk?: { __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any } | null };

export type ApplicationJurisdictionUpdateMultipleMutationVariables = Exact<{
  updates: Array<Application_Jurisdiction_Updates> | Application_Jurisdiction_Updates;
}>;


export type ApplicationJurisdictionUpdateMultipleMutation = { __typename?: 'mutation_root', update_application_jurisdiction_many?: Array<{ __typename?: 'application_jurisdiction_mutation_response', returning: Array<{ __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any }> } | null> | null };

export type ApplicationJurisdictionDeleteManyMutationVariables = Exact<{
  where: Application_Jurisdiction_Bool_Exp;
}>;


export type ApplicationJurisdictionDeleteManyMutation = { __typename?: 'mutation_root', delete_application_jurisdiction?: { __typename?: 'application_jurisdiction_mutation_response', returning: Array<{ __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any }> } | null };

export type ApplicationJurisdictionInsertManyMutationVariables = Exact<{
  objects: Array<Application_Jurisdiction_Insert_Input> | Application_Jurisdiction_Insert_Input;
}>;


export type ApplicationJurisdictionInsertManyMutation = { __typename?: 'mutation_root', insert_application_jurisdiction?: { __typename?: 'application_jurisdiction_mutation_response', returning: Array<{ __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any }> } | null };

export type ApplicationJurisdictionGetManyQueryVariables = Exact<{
  where?: InputMaybe<Application_Jurisdiction_Bool_Exp>;
  order_by?: InputMaybe<Array<Application_Jurisdiction_Order_By> | Application_Jurisdiction_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Application_Jurisdiction_Select_Column> | Application_Jurisdiction_Select_Column>;
}>;


export type ApplicationJurisdictionGetManyQuery = { __typename?: 'query_root', application_jurisdiction: Array<{ __typename?: 'application_jurisdiction', id: string, application_id: string, jurisdiction: string, goods_and_services?: any | null, uspto_filing_basis?: any | null, uspto_specimen_to_class?: any | null, additional_info?: any | null, logo_type?: string | null, text_in_trademark?: string | null, document_folder_id?: string | null, color_claim_enabled: boolean, color_claim?: string | null, uspto_logo_subcategory?: string | null, ai_text_in_trademark?: string | null, ai_logo_type?: string | null, ai_color_claim?: string | null, ai_uspto_logo_subcategory?: string | null, ai_reasoning: any, ai_additional_info: any }> };

export type Audit_LogFragment = { __typename?: 'audit_log', id: number, operation: string, table_name: string, record_id_uuid?: string | null, record_id_int?: number | null, old_values?: any | null, new_values?: any | null, created_at: string, user_id?: string | null, user?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type TrademarkAuditLogQueryVariables = Exact<{
  trademark_id: Scalars['uuid']['input'];
  order_by?: InputMaybe<Array<Trademark_Audit_Log_Order_By> | Trademark_Audit_Log_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkAuditLogQuery = { __typename?: 'query_root', trademark_audit_log: Array<{ __typename?: 'trademark_audit_log', created_at: string, id: number, new_values?: any | null, old_values?: any | null, operation: string, property?: string | null, record_id_int?: number | null, record_id_uuid?: string | null, table_name: string, user_id?: string | null }> };

export type TrademarkAuditLogCountQueryVariables = Exact<{
  trademark_id: Scalars['uuid']['input'];
}>;


export type TrademarkAuditLogCountQuery = { __typename?: 'query_root', trademark_audit_log_count: Array<{ __typename?: 'aggregate_count', count: number }> };

export type BrandFragment = { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> };

export type BrandForUserFragment = { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> };

export type BrandInsertOneMutationVariables = Exact<{
  object: Brand_Insert_Input;
}>;


export type BrandInsertOneMutation = { __typename?: 'mutation_root', insert_brand_one?: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> } | null };

export type BrandInsertManyMutationVariables = Exact<{
  objects: Array<Brand_Insert_Input> | Brand_Insert_Input;
}>;


export type BrandInsertManyMutation = { __typename?: 'mutation_root', insert_brand?: { __typename?: 'brand_mutation_response', returning: Array<{ __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }> } | null };

export type BrandUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Brand_Set_Input;
}>;


export type BrandUpdateOneMutation = { __typename?: 'mutation_root', update_brand_by_pk?: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> } | null };

export type BrandDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandDeleteOneMutation = { __typename?: 'mutation_root', delete_brand_by_pk?: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> } | null };

export type BrandGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  deleted: Scalars['Boolean']['input'];
}>;


export type BrandGetByIdQuery = { __typename?: 'query_root', brand: Array<{ __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }> };

export type BrandGetByIdForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  deleted: Scalars['Boolean']['input'];
}>;


export type BrandGetByIdForUserQuery = { __typename?: 'query_root', brand: Array<{ __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }> };

export type BrandGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Brand_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Order_By> | Brand_Order_By>;
}>;


export type BrandGetManyQuery = { __typename?: 'query_root', brand: Array<{ __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }> };

export type BrandGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Brand_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Order_By> | Brand_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandGetManyForUserQuery = { __typename?: 'query_root', brand: Array<{ __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }>, brand_aggregate: { __typename?: 'brand_aggregate', aggregate?: { __typename?: 'brand_aggregate_fields', count: number } | null } };

export type BrandWithRecentTasksGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Brand_Bool_Exp>;
  task_count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandWithRecentTasksGetManyForUserQuery = { __typename?: 'query_root', brand: Array<{ __typename?: 'brand', id: string, tasks: Array<{ __typename?: 'brand_monitoring_task', status: string, last_status_update: string }> }> };

export type MonitoredBrandsTotalCountQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type MonitoredBrandsTotalCountQuery = { __typename?: 'query_root', brand_aggregate: { __typename?: 'brand_aggregate', aggregate?: { __typename?: 'brand_aggregate_fields', count: number } | null } };

export type BrandMonitoringTaskFragment = { __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string };

export type BrandMonitoringTaskInsertOneMutationVariables = Exact<{
  object: Brand_Monitoring_Task_Insert_Input;
}>;


export type BrandMonitoringTaskInsertOneMutation = { __typename?: 'mutation_root', insert_brand_monitoring_task_one?: { __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string } | null };

export type BrandMonitoringTaskUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Brand_Monitoring_Task_Set_Input>;
}>;


export type BrandMonitoringTaskUpdateOneMutation = { __typename?: 'mutation_root', update_brand_monitoring_task_by_pk?: { __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string } | null };

export type BrandMonitoringTaskGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandMonitoringTaskGetByIdQuery = { __typename?: 'query_root', brand_monitoring_task_by_pk?: { __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string } | null };

export type BrandMonitoringTaskGetManyQueryVariables = Exact<{
  where: Brand_Monitoring_Task_Bool_Exp;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Order_By> | Brand_Monitoring_Task_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Monitoring_Task_Select_Column> | Brand_Monitoring_Task_Select_Column>;
}>;


export type BrandMonitoringTaskGetManyQuery = { __typename?: 'query_root', brand_monitoring_task: Array<{ __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string }> };

export type BrandMonitoringTaskTrackingFragment = { __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string };

export type BrandMonitoringTaskTrackingWithStatusFragment = { __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string, tracking_status: { __typename?: 'brand_monitoring_task_tracking_status', is_status: boolean } };

export type BrandMonitoringTaskTrackingInsertOneMutationVariables = Exact<{
  object: Brand_Monitoring_Task_Tracking_Insert_Input;
}>;


export type BrandMonitoringTaskTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_brand_monitoring_task_tracking_one?: { __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string } | null };

export type BrandMonitoringTaskTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BrandMonitoringTaskTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_brand_monitoring_task_tracking_by_pk?: { __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string } | null };

export type BrandMonitoringTaskTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By> | Brand_Monitoring_Task_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandMonitoringTaskTrackingGetManyQuery = { __typename?: 'query_root', brand_monitoring_task_tracking: Array<{ __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string }> };

export type BrandMonitoringTaskTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Monitoring_Task_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Monitoring_Task_Tracking_Order_By> | Brand_Monitoring_Task_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandMonitoringTaskTrackingWithStatusGetManyQuery = { __typename?: 'query_root', brand_monitoring_task_tracking: Array<{ __typename?: 'brand_monitoring_task_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_monitoring_task_id: string, tracking_status: { __typename?: 'brand_monitoring_task_tracking_status', is_status: boolean } }> };

export type BrandSnapshotFragment = { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string };

export type BrandSnapshotInsertOneMutationVariables = Exact<{
  object: Brand_Snapshot_Insert_Input;
}>;


export type BrandSnapshotInsertOneMutation = { __typename?: 'mutation_root', insert_brand_snapshot_one?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null };

export type BrandSubscriptionFragment = { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null };

export type BrandSubscriptionForUserFragment = { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, discount_coupon_id?: string | null, tracking_actions: Array<{ __typename?: 'brand_subscription_tracking', created_at: string, name: string }> };

export type BrandSubscriptionDetailsFragment = { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null, brand: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }, platforms: Array<{ __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }>, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type BrandSubscriptionWithTasksFragment = { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null, brand_monitoring_tasks: Array<{ __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string }> };

export type BrandSubscriptionInsertOneMutationVariables = Exact<{
  object: Brand_Subscription_Insert_Input;
}>;


export type BrandSubscriptionInsertOneMutation = { __typename?: 'mutation_root', insert_brand_subscription_one?: { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null } | null };

export type BrandSubscriptionUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Brand_Subscription_Set_Input>;
}>;


export type BrandSubscriptionUpdateOneMutation = { __typename?: 'mutation_root', update_brand_subscription_by_pk?: { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null } | null };

export type BrandSubscriptionUpdateManyMutationVariables = Exact<{
  where: Brand_Subscription_Bool_Exp;
  set: Brand_Subscription_Set_Input;
}>;


export type BrandSubscriptionUpdateManyMutation = { __typename?: 'mutation_root', update_brand_subscription?: { __typename?: 'brand_subscription_mutation_response', returning: Array<{ __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null }> } | null };

export type BrandSubscriptionGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandSubscriptionGetByIdQuery = { __typename?: 'query_root', brand_subscription_by_pk?: { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null } | null };

export type BrandSubscriptionGetDetailsByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandSubscriptionGetDetailsByIdQuery = { __typename?: 'query_root', brand_subscription_by_pk?: { __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null, brand: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning?: any | null, trama_business_description_updated_at?: string | null, date_of_first_use_updated_at?: string | null, high_level_usage_updated_at?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }, platforms: Array<{ __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }>, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null } | null };

export type BrandSubscriptionGetManyQueryVariables = Exact<{
  where: Brand_Subscription_Bool_Exp;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By> | Brand_Subscription_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column> | Brand_Subscription_Select_Column>;
}>;


export type BrandSubscriptionGetManyQuery = { __typename?: 'query_root', brand_subscription: Array<{ __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null }> };

export type BrandSubscriptionCountQueryVariables = Exact<{
  filter?: InputMaybe<Brand_Subscription_Bool_Exp>;
}>;


export type BrandSubscriptionCountQuery = { __typename?: 'query_root', brand_subscription_aggregate: { __typename?: 'brand_subscription_aggregate', aggregate?: { __typename?: 'brand_subscription_aggregate_fields', count: number } | null } };

export type BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserQueryVariables = Exact<{
  where: Brand_Subscription_Bool_Exp;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By> | Brand_Subscription_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column> | Brand_Subscription_Select_Column>;
}>;


export type BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserQuery = { __typename?: 'query_root', brand_subscription: Array<{ __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, discount_coupon_id?: string | null, brand: { __typename?: 'brand', id: string, user_id: string, name: string, created_at: string, client_business_description?: string | null, deleted: boolean, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }, brand_subscription_payments: Array<{ __typename?: 'brand_subscription_payment', status: string, end_date: string, created_at: string, decline_reason?: string | null }>, platforms: Array<{ __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string }>, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, user_payment_method?: { __typename?: 'user_payment_method', id: string, user_id: string, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string } | null, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, tracking_actions: Array<{ __typename?: 'brand_subscription_tracking', created_at: string, name: string }> }> };

export type CasesInLastTaskTotalCountQueryVariables = Exact<{
  filterSubscription: Brand_Subscription_Bool_Exp;
  filterCase: Case_Bool_Exp;
}>;


export type CasesInLastTaskTotalCountQuery = { __typename?: 'query_root', brand_subscription: Array<{ __typename?: 'brand_subscription', brand_monitoring_tasks: Array<{ __typename?: 'brand_monitoring_task', cases_aggregate: { __typename?: 'case_aggregate', aggregate?: { __typename?: 'case_aggregate_fields', count: number } | null } }> }> };

export type BrandSubscriptionWithLastTaskGetManyQueryVariables = Exact<{
  where: Brand_Subscription_Bool_Exp;
  order_by?: InputMaybe<Array<Brand_Subscription_Order_By> | Brand_Subscription_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Subscription_Select_Column> | Brand_Subscription_Select_Column>;
}>;


export type BrandSubscriptionWithLastTaskGetManyQuery = { __typename?: 'query_root', brand_subscription: Array<{ __typename: 'brand_subscription', id: string, brand_id: string, billing_entity_id?: string | null, user_payment_method_id?: string | null, note_hub_id: string, tier: string, status: string, payment_frequency: string, start_date: string, end_date?: string | null, currency: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, document_hub_id: string, discount_coupon_id?: string | null, is_proactive: boolean, case_solution_id?: string | null, last_status_update: string, last_tracking_update: string, registration_request_id?: string | null, brand_monitoring_tasks: Array<{ __typename: 'brand_monitoring_task', id: string, brand_id: string, brand_subscription_id?: string | null, brand_subscription_tier: string, status: string, last_status_update: string, last_tracking_update: string, processed_timestamp?: string | null, assigned_admin_id?: string | null, deadline: string, created_at: string }> }> };

export type BrandSubscriptionPaymentFragment = { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number };

export type BrandSubscriptionPaymentDataFragment = { __typename?: 'brand_subscription_payment', brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, billing_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } };

export type BrandSubscriptionPaymentForUserFragment = { __typename?: 'brand_subscription_payment', status: string, end_date: string, created_at: string, decline_reason?: string | null };

export type BrandSubscriptionPaymentInsertOneMutationVariables = Exact<{
  object: Brand_Subscription_Payment_Insert_Input;
}>;


export type BrandSubscriptionPaymentInsertOneMutation = { __typename?: 'mutation_root', insert_brand_subscription_payment_one?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null };

export type BrandSubscriptionPaymentUpsertOneMutationVariables = Exact<{
  object: Brand_Subscription_Payment_Insert_Input;
}>;


export type BrandSubscriptionPaymentUpsertOneMutation = { __typename?: 'mutation_root', insert_brand_subscription_payment_one?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null };

export type BrandSubscriptionPaymentUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Brand_Subscription_Payment_Set_Input>;
}>;


export type BrandSubscriptionPaymentUpdateOneMutation = { __typename?: 'mutation_root', update_brand_subscription_payment_by_pk?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null };

export type BrandSubscriptionPaymentDeleteManyMutationVariables = Exact<{
  where: Brand_Subscription_Payment_Bool_Exp;
}>;


export type BrandSubscriptionPaymentDeleteManyMutation = { __typename?: 'mutation_root', delete_brand_subscription_payment?: { __typename?: 'brand_subscription_payment_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number }> } | null };

export type BrandSubscriptionPaymentGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandSubscriptionPaymentGetByIdQuery = { __typename?: 'query_root', brand_subscription_payment_by_pk?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null };

export type BrandSubscriptionPaymentGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Subscription_Payment_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Subscription_Payment_Order_By> | Brand_Subscription_Payment_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Subscription_Payment_Select_Column> | Brand_Subscription_Payment_Select_Column>;
}>;


export type BrandSubscriptionPaymentGetManyQuery = { __typename?: 'query_root', brand_subscription_payment: Array<{ __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number }> };

export type BrandSubscriptionPlatformFragment = { __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string };

export type BrandSubscriptionPlatformForUserFragment = { __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string };

export type BrandSubscriptionPlatformInsertOneMutationVariables = Exact<{
  object: Brand_Subscription_Platform_Insert_Input;
}>;


export type BrandSubscriptionPlatformInsertOneMutation = { __typename?: 'mutation_root', insert_brand_subscription_platform_one?: { __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type BrandSubscriptionPlatformUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Brand_Subscription_Platform_Set_Input>;
}>;


export type BrandSubscriptionPlatformUpdateOneMutation = { __typename?: 'mutation_root', update_brand_subscription_platform_by_pk?: { __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type BrandSubscriptionPlatformDeleteManyMutationVariables = Exact<{
  where: Brand_Subscription_Platform_Bool_Exp;
}>;


export type BrandSubscriptionPlatformDeleteManyMutation = { __typename?: 'mutation_root', delete_brand_subscription_platform?: { __typename?: 'brand_subscription_platform_mutation_response', returning: Array<{ __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> } | null };

export type BrandSubscriptionPlatformGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Subscription_Platform_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Subscription_Platform_Order_By> | Brand_Subscription_Platform_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Brand_Subscription_Platform_Select_Column> | Brand_Subscription_Platform_Select_Column>;
}>;


export type BrandSubscriptionPlatformGetManyQuery = { __typename?: 'query_root', brand_subscription_platform: Array<{ __typename?: 'brand_subscription_platform', id: string, brand_subscription_id: string, name: string, metadata: any, start_date: string, end_date?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> };

export type BrandSubscriptionTrackingFragment = { __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string };

export type BrandSubscriptionTrackingWithStatusFragment = { __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string, tracking_status: { __typename?: 'brand_subscription_tracking_status', is_status: boolean } };

export type BrandSubscriptionTrackingInsertOneMutationVariables = Exact<{
  object: Brand_Subscription_Tracking_Insert_Input;
}>;


export type BrandSubscriptionTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_brand_subscription_tracking_one?: { __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string } | null };

export type BrandSubscriptionTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BrandSubscriptionTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_brand_subscription_tracking_by_pk?: { __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string } | null };

export type BrandSubscriptionTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By> | Brand_Subscription_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandSubscriptionTrackingGetManyQuery = { __typename?: 'query_root', brand_subscription_tracking: Array<{ __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string }> };

export type BrandSubscriptionTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Brand_Subscription_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Brand_Subscription_Tracking_Order_By> | Brand_Subscription_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandSubscriptionTrackingWithStatusGetManyQuery = { __typename?: 'query_root', brand_subscription_tracking: Array<{ __typename?: 'brand_subscription_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, brand_subscription_id: string, tracking_status: { __typename?: 'brand_subscription_tracking_status', is_status: boolean } }> };

export type CaseFragment = { __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string };

export type CaseWithCounterpartyFragment = { __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, counterparty: { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } };

export type CaseForUserFragment = { __typename?: 'case', id: string, brand_id: string, relevance?: string | null, status: string, last_status_update: string, created_at: string, lawyers_note?: string | null, brand: { __typename?: 'brand', id: string, name: string, deleted: boolean, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }>, user: { __typename?: 'user', status: string } } };

export type CaseInsertOneMutationVariables = Exact<{
  object: Case_Insert_Input;
}>;


export type CaseInsertOneMutation = { __typename?: 'mutation_root', insert_case_one?: { __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Set_Input>;
}>;


export type CaseUpdateOneMutation = { __typename?: 'mutation_root', update_case_by_pk?: { __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseGetByIdQuery = { __typename?: 'query_root', case_by_pk?: { __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseGetManyQueryVariables = Exact<{
  where: Case_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Order_By> | Case_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Select_Column> | Case_Select_Column>;
}>;


export type CaseGetManyQuery = { __typename?: 'query_root', case: Array<{ __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> };

export type CaseWithCounterpartyGetManyQueryVariables = Exact<{
  where: Case_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Order_By> | Case_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Select_Column> | Case_Select_Column>;
}>;


export type CaseWithCounterpartyGetManyQuery = { __typename?: 'query_root', case: Array<{ __typename: 'case', id: string, brand_id: string, brand_monitoring_task_id?: string | null, case_counterparty_id: string, assigned_admin_id?: string | null, trademark_id?: string | null, relevance?: string | null, lawyers_note?: string | null, status: string, last_status_update: string, last_tracking_update: string, outcome?: string | null, outcome_note?: string | null, note_hub_id: string, document_hub_id: string, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string, counterparty: { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } }> };

export type CaseGetManyForUserQueryVariables = Exact<{
  filter: Case_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Order_By> | Case_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CaseGetManyForUserQuery = { __typename?: 'query_root', case: Array<{ __typename?: 'case', id: string, brand_id: string, relevance?: string | null, status: string, last_status_update: string, created_at: string, lawyers_note?: string | null, counterparty: { __typename?: 'case_counterparty', id: string, primary_name: string, websites: any, whitelisted: boolean }, infringements: Array<{ __typename?: 'case_infringement', id: string, platform?: string | null, created_at: string }>, tracking_actions: Array<{ __typename?: 'case_tracking', name: string, created_at: string }>, solutions: Array<{ __typename?: 'case_solution', id: string, items: any, currency: string, case_id: string, status: string, offer_subscription: boolean, offer_watchlist: boolean, order?: { __typename?: 'service_request', product_id: string, status: string } | null, services: Array<{ __typename?: 'service', id: string, type: string, service_request_id?: string | null, status: string, parameters: any, last_status_update: string, created_at: string }> }>, brand: { __typename?: 'brand', id: string, name: string, deleted: boolean, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }>, user: { __typename?: 'user', status: string } } }>, case_aggregate: { __typename?: 'case_aggregate', aggregate?: { __typename?: 'case_aggregate_fields', count: number } | null } };

export type CasesTotalCountQueryVariables = Exact<{
  filter: Case_Bool_Exp;
}>;


export type CasesTotalCountQuery = { __typename?: 'query_root', case_aggregate: { __typename?: 'case_aggregate', aggregate?: { __typename?: 'case_aggregate_fields', count: number } | null } };

export type CaseGetByIdForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseGetByIdForUserQuery = { __typename?: 'query_root', case_by_pk?: { __typename?: 'case', id: string, brand_id: string, relevance?: string | null, status: string, last_status_update: string, created_at: string, lawyers_note?: string | null, brand: { __typename?: 'brand', id: string, name: string, deleted: boolean, user: { __typename?: 'user', status: string }, brand_subscriptions: Array<{ __typename?: 'brand_subscription', id: string, status: string, tier: string, end_date?: string | null }>, websites: Array<{ __typename?: 'website', id: string, brand_id: string, link: string }> }, counterparty: { __typename?: 'case_counterparty', id: string, primary_name: string, websites: any, whitelisted: boolean }, infringements: Array<{ __typename?: 'case_infringement', id: string, platform?: string | null, created_at: string, evidences: Array<{ __typename?: 'case_infringement_evidence', id: string, website?: string | null, document_folder_id: string, external_trademark?: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } | null }> }>, tracking_actions: Array<{ __typename?: 'case_tracking', name: string, created_at: string }>, solutions: Array<{ __typename?: 'case_solution', id: string, items: any, currency: string, case_id: string, status: string, offer_subscription: boolean, offer_watchlist: boolean, order?: { __typename?: 'service_request', product_id: string, status: string } | null, services: Array<{ __typename?: 'service', id: string, type: string, service_request_id?: string | null, status: string, parameters: any, last_status_update: string, created_at: string }> }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> } | null };

export type CaseIdWithCounterpartyGetManyQueryVariables = Exact<{
  where: Case_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Order_By> | Case_Order_By>;
}>;


export type CaseIdWithCounterpartyGetManyQuery = { __typename?: 'query_root', case: Array<{ __typename?: 'case', id: string, created_at: string, counterparty: { __typename?: 'case_counterparty', id: string, primary_name: string } }> };

export type CaseCounterpartyFragment = { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string };

export type CaseCounterpartyForUserFragment = { __typename?: 'case_counterparty', id: string, primary_name: string, websites: any, whitelisted: boolean };

export type CaseCounterpartyInsertOneMutationVariables = Exact<{
  object: Case_Counterparty_Insert_Input;
}>;


export type CaseCounterpartyInsertOneMutation = { __typename?: 'mutation_root', insert_case_counterparty_one?: { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseCounterpartyUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Counterparty_Set_Input>;
}>;


export type CaseCounterpartyUpdateOneMutation = { __typename?: 'mutation_root', update_case_counterparty_by_pk?: { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseCounterpartyGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseCounterpartyGetByIdQuery = { __typename?: 'query_root', case_counterparty_by_pk?: { __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseCounterpartyGetManyQueryVariables = Exact<{
  where: Case_Counterparty_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By> | Case_Counterparty_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column> | Case_Counterparty_Select_Column>;
}>;


export type CaseCounterpartyGetManyQuery = { __typename?: 'query_root', case_counterparty: Array<{ __typename: 'case_counterparty', id: string, primary_name: string, aliases: any, websites: any, note?: string | null, entity_id?: string | null, representative_entity_id?: string | null, user_id?: string | null, whitelisted: boolean, jurisdiction?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> };

export type CaseCounterpartyGetManyForUserQueryVariables = Exact<{
  where: Case_Counterparty_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Counterparty_Order_By> | Case_Counterparty_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Counterparty_Select_Column> | Case_Counterparty_Select_Column>;
}>;


export type CaseCounterpartyGetManyForUserQuery = { __typename?: 'query_root', case_counterparty: Array<{ __typename?: 'case_counterparty', id: string, primary_name: string, websites: any, whitelisted: boolean }> };

export type CaseInfringementFragment = { __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string };

export type CaseInfringementForUserFragment = { __typename?: 'case_infringement', id: string, platform?: string | null, created_at: string };

export type CaseInfringementInsertOneMutationVariables = Exact<{
  object: Case_Infringement_Insert_Input;
}>;


export type CaseInfringementInsertOneMutation = { __typename?: 'mutation_root', insert_case_infringement_one?: { __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseInfringementUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Infringement_Set_Input>;
}>;


export type CaseInfringementUpdateOneMutation = { __typename?: 'mutation_root', update_case_infringement_by_pk?: { __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseInfringementDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseInfringementDeleteOneMutation = { __typename?: 'mutation_root', delete_case_infringement_by_pk?: { __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseInfringementGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseInfringementGetByIdQuery = { __typename?: 'query_root', case_infringement_by_pk?: { __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseInfringementGetManyQueryVariables = Exact<{
  where: Case_Infringement_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Infringement_Order_By> | Case_Infringement_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Infringement_Select_Column> | Case_Infringement_Select_Column>;
}>;


export type CaseInfringementGetManyQuery = { __typename?: 'query_root', case_infringement: Array<{ __typename: 'case_infringement', id: string, case_id: string, platform?: string | null, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> };

export type CaseInfringementEvidenceFragment = { __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string };

export type CaseInfringementEvidenceForUserFragment = { __typename?: 'case_infringement_evidence', id: string, website?: string | null, document_folder_id: string, external_trademark?: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } | null };

export type CaseInfringementEvidenceInsertOneMutationVariables = Exact<{
  object: Case_Infringement_Evidence_Insert_Input;
}>;


export type CaseInfringementEvidenceInsertOneMutation = { __typename?: 'mutation_root', insert_case_infringement_evidence_one?: { __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type CaseInfringementEvidenceUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Infringement_Evidence_Set_Input>;
}>;


export type CaseInfringementEvidenceUpdateOneMutation = { __typename?: 'mutation_root', update_case_infringement_evidence_by_pk?: { __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type CaseInfringementEvidenceDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseInfringementEvidenceDeleteOneMutation = { __typename?: 'mutation_root', delete_case_infringement_evidence_by_pk?: { __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type CaseInfringementEvidenceGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseInfringementEvidenceGetByIdQuery = { __typename?: 'query_root', case_infringement_evidence_by_pk?: { __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type CaseInfringementEvidenceGetManyQueryVariables = Exact<{
  where: Case_Infringement_Evidence_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Infringement_Evidence_Order_By> | Case_Infringement_Evidence_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Infringement_Evidence_Select_Column> | Case_Infringement_Evidence_Select_Column>;
}>;


export type CaseInfringementEvidenceGetManyQuery = { __typename?: 'query_root', case_infringement_evidence: Array<{ __typename: 'case_infringement_evidence', id: string, case_infringement_id: string, document_folder_id: string, website?: string | null, evidence_date: string, description?: string | null, external_trademark_id?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string }> };

export type CaseRequestFragment = { __typename: 'case_request', id: string, type: any, brand_website?: string | null, links: any, message?: string | null, dismiss_reason?: string | null, status: any, last_status_update: string, last_tracking_update: string, case_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, created_at: string, updated_at: string, user_id: string, updated_by_user_id: string };

export type CaseRequestInsertOneMutationVariables = Exact<{
  object: Case_Request_Insert_Input;
}>;


export type CaseRequestInsertOneMutation = { __typename?: 'mutation_root', insert_case_request_one?: { __typename: 'case_request', id: string, type: any, brand_website?: string | null, links: any, message?: string | null, dismiss_reason?: string | null, status: any, last_status_update: string, last_tracking_update: string, case_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, created_at: string, updated_at: string, user_id: string, updated_by_user_id: string } | null };

export type CaseRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Request_Set_Input>;
}>;


export type CaseRequestUpdateOneMutation = { __typename?: 'mutation_root', update_case_request_by_pk?: { __typename: 'case_request', id: string, type: any, brand_website?: string | null, links: any, message?: string | null, dismiss_reason?: string | null, status: any, last_status_update: string, last_tracking_update: string, case_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, created_at: string, updated_at: string, user_id: string, updated_by_user_id: string } | null };

export type CaseRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseRequestGetByIdQuery = { __typename?: 'query_root', case_request_by_pk?: { __typename: 'case_request', id: string, type: any, brand_website?: string | null, links: any, message?: string | null, dismiss_reason?: string | null, status: any, last_status_update: string, last_tracking_update: string, case_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, created_at: string, updated_at: string, user_id: string, updated_by_user_id: string } | null };

export type CaseRequestGetManyQueryVariables = Exact<{
  where: Case_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Request_Order_By> | Case_Request_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Request_Select_Column> | Case_Request_Select_Column>;
}>;


export type CaseRequestGetManyQuery = { __typename?: 'query_root', case_request: Array<{ __typename: 'case_request', id: string, type: any, brand_website?: string | null, links: any, message?: string | null, dismiss_reason?: string | null, status: any, last_status_update: string, last_tracking_update: string, case_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, created_at: string, updated_at: string, user_id: string, updated_by_user_id: string }> };

export type CaseRequestTrackingFragment = { __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string };

export type CaseRequestTrackingWithStatusFragment = { __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string, tracking_status: { __typename?: 'case_request_tracking_status', is_status: boolean } };

export type CaseRequestTrackingInsertOneMutationVariables = Exact<{
  object: Case_Request_Tracking_Insert_Input;
}>;


export type CaseRequestTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_case_request_tracking_one?: { __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string } | null };

export type CaseRequestTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CaseRequestTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_case_request_tracking_by_pk?: { __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string } | null };

export type CaseRequestTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By> | Case_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column> | Case_Request_Tracking_Select_Column>;
}>;


export type CaseRequestTrackingGetManyQuery = { __typename?: 'query_root', case_request_tracking: Array<{ __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string }> };

export type CaseRequestTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Case_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Case_Request_Tracking_Order_By> | Case_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Request_Tracking_Select_Column> | Case_Request_Tracking_Select_Column>;
}>;


export type CaseRequestTrackingWithStatusGetManyQuery = { __typename?: 'query_root', case_request_tracking: Array<{ __typename?: 'case_request_tracking', id: number, name: any, created_at: string, skipped?: boolean | null, user_id: string, case_request_id: string, tracking_status: { __typename?: 'case_request_tracking_status', is_status: boolean } }> };

export type CaseSolutionFragment = { __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string };

export type CaseSolutionForUserFragment = { __typename?: 'case_solution', id: string, items: any, currency: string, case_id: string, status: string, offer_subscription: boolean, offer_watchlist: boolean, order?: { __typename?: 'service_request', product_id: string, status: string } | null, services: Array<{ __typename?: 'service', id: string, type: string, service_request_id?: string | null, status: string, parameters: any, last_status_update: string, created_at: string }> };

export type CaseSolutionInsertOneMutationVariables = Exact<{
  object: Case_Solution_Insert_Input;
}>;


export type CaseSolutionInsertOneMutation = { __typename?: 'mutation_root', insert_case_solution_one?: { __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseSolutionUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Case_Solution_Set_Input>;
}>;


export type CaseSolutionUpdateOneMutation = { __typename?: 'mutation_root', update_case_solution_by_pk?: { __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseSolutionUpdateManyMutationVariables = Exact<{
  where: Case_Solution_Bool_Exp;
  set: Case_Solution_Set_Input;
}>;


export type CaseSolutionUpdateManyMutation = { __typename?: 'mutation_root', update_case_solution?: { __typename?: 'case_solution_mutation_response', returning: Array<{ __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> } | null };

export type CaseSolutionDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseSolutionDeleteOneMutation = { __typename?: 'mutation_root', delete_case_solution_by_pk?: { __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseSolutionGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CaseSolutionGetByIdQuery = { __typename?: 'query_root', case_solution_by_pk?: { __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string } | null };

export type CaseSolutionGetManyQueryVariables = Exact<{
  where: Case_Solution_Bool_Exp;
  order_by?: InputMaybe<Array<Case_Solution_Order_By> | Case_Solution_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Solution_Select_Column> | Case_Solution_Select_Column>;
}>;


export type CaseSolutionGetManyQuery = { __typename?: 'query_root', case_solution: Array<{ __typename: 'case_solution', id: string, case_id: string, status: string, service_request_id?: string | null, items: any, currency: string, offer_subscription: boolean, offer_watchlist: boolean, created_at: string, updated_at: string, created_by_user_id: string, updated_by_user_id: string }> };

export type CaseTrackingFragment = { __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string };

export type CaseTrackingWithStatusFragment = { __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string, tracking_status: { __typename?: 'case_tracking_status', is_status: boolean } };

export type CaseTrackingForUserFragment = { __typename?: 'case_tracking', name: string, created_at: string };

export type CaseTrackingInsertOneMutationVariables = Exact<{
  object: Case_Tracking_Insert_Input;
}>;


export type CaseTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_case_tracking_one?: { __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string } | null };

export type CaseTrackingInsertManyMutationVariables = Exact<{
  objects: Array<Case_Tracking_Insert_Input> | Case_Tracking_Insert_Input;
}>;


export type CaseTrackingInsertManyMutation = { __typename?: 'mutation_root', insert_case_tracking?: { __typename?: 'case_tracking_mutation_response', returning: Array<{ __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string }> } | null };

export type CaseTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CaseTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_case_tracking_by_pk?: { __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string } | null };

export type CaseTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By> | Case_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column> | Case_Tracking_Select_Column>;
}>;


export type CaseTrackingGetManyQuery = { __typename?: 'query_root', case_tracking: Array<{ __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string }> };

export type CaseTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Case_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Case_Tracking_Order_By> | Case_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Case_Tracking_Select_Column> | Case_Tracking_Select_Column>;
}>;


export type CaseTrackingWithStatusGetManyQuery = { __typename?: 'query_root', case_tracking: Array<{ __typename?: 'case_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, case_id: string, tracking_status: { __typename?: 'case_tracking_status', is_status: boolean } }> };

export type ConsultationFragment = { __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null };

export type ConsultationInsertOneMutationVariables = Exact<{
  object: Consultation_Insert_Input;
}>;


export type ConsultationInsertOneMutation = { __typename?: 'mutation_root', insert_consultation_one?: { __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null } | null };

export type ConsultationUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Consultation_Set_Input;
}>;


export type ConsultationUpdateOneMutation = { __typename?: 'mutation_root', update_consultation_by_pk?: { __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null } | null };

export type ConsultationDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ConsultationDeleteOneMutation = { __typename?: 'mutation_root', delete_consultation_by_pk?: { __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null } | null };

export type ConsultationDeleteManyMutationVariables = Exact<{
  calendlyId: Scalars['String']['input'];
}>;


export type ConsultationDeleteManyMutation = { __typename?: 'mutation_root', delete_consultation?: { __typename?: 'consultation_mutation_response', affected_rows: number } | null };

export type ConsultationGetManyQueryVariables = Exact<{
  where?: Consultation_Bool_Exp;
  order_by?: InputMaybe<Array<Consultation_Order_By> | Consultation_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Consultation_Select_Column> | Consultation_Select_Column>;
}>;


export type ConsultationGetManyQuery = { __typename?: 'query_root', consultation: Array<{ __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null }> };

export type ConsultationGetManyUserAggregateQueryVariables = Exact<{
  filter?: Consultation_Bool_Exp;
  order_by?: InputMaybe<Array<Consultation_Order_By> | Consultation_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ConsultationGetManyUserAggregateQuery = { __typename?: 'query_root', consultation: Array<{ __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null }>, consultation_aggregate: { __typename?: 'consultation_aggregate', aggregate?: { __typename?: 'consultation_aggregate_fields', count: number } | null } };

export type ConsultationGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ConsultationGetByIdQuery = { __typename?: 'query_root', consultation_by_pk?: { __typename: 'consultation', id: string, assigned_admin_id?: string | null, user_id?: string | null, event_timestamp: string, description?: string | null, outcome?: string | null, note_hub_id: string, document_hub_id: string, questions_and_answers: any, resolution?: string | null, location?: any | null, calendly_id?: string | null, google_meet_id?: string | null, fathom_recording_url?: string | null, assigned_admin?: { __typename?: 'user', email: string } | null } | null };

export type ContentfulFragment = { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any };

export type ContentfulHeadersFragment = { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null };

export type ContentfulInsertOneMutationVariables = Exact<{
  object: Contentful_Insert_Input;
}>;


export type ContentfulInsertOneMutation = { __typename?: 'mutation_root', insert_contentful_one?: { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any } | null };

export type ContentfulInsertManyMutationVariables = Exact<{
  objects: Array<Contentful_Insert_Input> | Contentful_Insert_Input;
}>;


export type ContentfulInsertManyMutation = { __typename?: 'mutation_root', insert_contentful?: { __typename?: 'contentful_mutation_response', returning: Array<{ __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any }> } | null };

export type ContentfulUpdateOneMutationVariables = Exact<{
  id: Scalars['bpchar']['input'];
  changes: Contentful_Set_Input;
}>;


export type ContentfulUpdateOneMutation = { __typename?: 'mutation_root', update_contentful_by_pk?: { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any } | null };

export type ContentfulUpdateManyMutationVariables = Exact<{
  where: Contentful_Bool_Exp;
  set: Contentful_Set_Input;
}>;


export type ContentfulUpdateManyMutation = { __typename?: 'mutation_root', update_contentful?: { __typename?: 'contentful_mutation_response', returning: Array<{ __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any }> } | null };

export type ContentfulDeleteOneMutationVariables = Exact<{
  id: Scalars['bpchar']['input'];
}>;


export type ContentfulDeleteOneMutation = { __typename?: 'mutation_root', delete_contentful_by_pk?: { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any } | null };

export type ContentfulDeleteManyMutationVariables = Exact<{
  where: Contentful_Bool_Exp;
}>;


export type ContentfulDeleteManyMutation = { __typename?: 'mutation_root', delete_contentful?: { __typename?: 'contentful_mutation_response', affected_rows: number } | null };

export type ContentfulGetByIdQueryVariables = Exact<{
  id: Scalars['bpchar']['input'];
}>;


export type ContentfulGetByIdQuery = { __typename?: 'query_root', contentful_by_pk?: { __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any } | null };

export type ContentfulGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Contentful_Bool_Exp>;
  order_by?: InputMaybe<Array<Contentful_Order_By> | Contentful_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContentfulGetManyQuery = { __typename?: 'query_root', contentful: Array<{ __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null, fields: any }> };

export type ContentfulHeadersGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Contentful_Bool_Exp>;
  order_by?: InputMaybe<Array<Contentful_Order_By> | Contentful_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContentfulHeadersGetManyQuery = { __typename?: 'query_root', contentful: Array<{ __typename: 'contentful', id: any, created_at: string, updated_at: string, deleted: boolean, content_type: string, name?: string | null, title?: string | null, slug?: string | null, date?: string | null, locale?: string | null, author_id?: string | null }> };

export type ContentfulCountQueryVariables = Exact<{
  filter?: InputMaybe<Contentful_Bool_Exp>;
}>;


export type ContentfulCountQuery = { __typename?: 'query_root', contentful_aggregate: { __typename?: 'contentful_aggregate', aggregate?: { __typename?: 'contentful_aggregate_fields', count: number } | null } };

export type CreditNoteFragment = { __typename?: 'credit_note', id: number, variable_symbol: string, document_context: any, invoice_reference?: string | null, year: number, created_at: string, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null };

export type CreditNoteInsertOneMutationVariables = Exact<{
  object: Credit_Note_Insert_Input;
}>;


export type CreditNoteInsertOneMutation = { __typename?: 'mutation_root', insert_credit_note_one?: { __typename?: 'credit_note', id: number, variable_symbol: string, document_context: any, invoice_reference?: string | null, year: number, created_at: string, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type CreditNoteGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CreditNoteGetByIdQuery = { __typename?: 'query_root', credit_note_by_pk?: { __typename?: 'credit_note', id: number, variable_symbol: string, document_context: any, invoice_reference?: string | null, year: number, created_at: string, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type CreditNoteGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Credit_Note_Bool_Exp>;
  order_by?: InputMaybe<Array<Credit_Note_Order_By> | Credit_Note_Order_By>;
}>;


export type CreditNoteGetManyQuery = { __typename?: 'query_root', credit_note: Array<{ __typename?: 'credit_note', id: number, variable_symbol: string, document_context: any, invoice_reference?: string | null, year: number, created_at: string, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null }> };

export type CreditNoteLastVariableSymbolBetweenDatesQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type CreditNoteLastVariableSymbolBetweenDatesQuery = { __typename?: 'query_root', credit_note: Array<{ __typename?: 'credit_note', id: number, variable_symbol: string }> };

export type CreditNoteByInvoiceReferenceQueryVariables = Exact<{
  invoiceReference: Scalars['String']['input'];
}>;


export type CreditNoteByInvoiceReferenceQuery = { __typename?: 'query_root', credit_note: Array<{ __typename?: 'credit_note', id: number, variable_symbol: string, document_context: any, created_at: string, year: number }> };

export type AllUserCreditNotesQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AllUserCreditNotesQuery = { __typename?: 'query_root', credit_note: Array<{ __typename?: 'credit_note', id: number, invoice_reference?: string | null, created_at: string, total: any, currency: any }>, credit_note_aggregate: { __typename?: 'credit_note_aggregate', aggregate?: { __typename?: 'credit_note_aggregate_fields', count: number } | null } };

export type TrademarkNotificationsCountQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  expiration_date_to: Scalars['date']['input'];
}>;


export type TrademarkNotificationsCountQuery = { __typename?: 'query_root', registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null }, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null }, office_action_aggregate: { __typename?: 'office_action_aggregate', aggregate?: { __typename?: 'office_action_aggregate_fields', count: number } | null } };

export type DiscountCouponFragment = { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null };

export type DiscountCouponInsertOneMutationVariables = Exact<{
  object: Discount_Coupon_Insert_Input;
}>;


export type DiscountCouponInsertOneMutation = { __typename?: 'mutation_root', insert_discount_coupon_one?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type DiscountCouponUpdateOneMutationVariables = Exact<{
  id: Scalars['String']['input'];
  changes?: InputMaybe<Discount_Coupon_Set_Input>;
}>;


export type DiscountCouponUpdateOneMutation = { __typename?: 'mutation_root', update_discount_coupon_by_pk?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type DiscountCouponGetByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DiscountCouponGetByIdQuery = { __typename?: 'query_root', discount_coupon_by_pk?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null };

export type Docketed_MessageFragment = { __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null };

export type DocketedMessageInsertOneMutationVariables = Exact<{
  object: Docketed_Message_Insert_Input;
}>;


export type DocketedMessageInsertOneMutation = { __typename?: 'mutation_root', insert_docketed_message_one?: { __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null } | null };

export type DocketedMessageUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  changes: Docketed_Message_Set_Input;
}>;


export type DocketedMessageUpdateOneMutation = { __typename?: 'mutation_root', update_docketed_message_by_pk?: { __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null } | null };

export type DocketedMessageUpdateManyMutationVariables = Exact<{
  where: Docketed_Message_Bool_Exp;
  set: Docketed_Message_Set_Input;
}>;


export type DocketedMessageUpdateManyMutation = { __typename?: 'mutation_root', update_docketed_message?: { __typename?: 'docketed_message_mutation_response', returning: Array<{ __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null }> } | null };

export type DocketedMessageGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DocketedMessageGetByIdQuery = { __typename?: 'query_root', docketed_message_by_pk?: { __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null } | null };

export type DocketedMessageGetManyQueryVariables = Exact<{
  where: Docketed_Message_Bool_Exp;
  order_by?: InputMaybe<Array<Docketed_Message_Order_By> | Docketed_Message_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Docketed_Message_Select_Column> | Docketed_Message_Select_Column>;
}>;


export type DocketedMessageGetManyQuery = { __typename?: 'query_root', docketed_message: Array<{ __typename?: 'docketed_message', id: number, docketer: string, source_email: string, message_id: string, message_link?: string | null, sender_name?: string | null, sender?: string | null, sender_email: string, subject: string, type?: string | null, status: string, jurisdiction?: string | null, trademark_id?: string | null, asana_task_gid?: string | null, asana_task_link?: string | null, office_action_id?: string | null, data: any, received_at: string, created_at: string, updated_at: string, retried_at?: string | null }> };

export type DocumentFolderFragment = { __typename?: 'document_folder', id: string, name?: string | null };

export type DocumentFolderInsertOneMutationVariables = Exact<{
  object: Document_Folder_Insert_Input;
}>;


export type DocumentFolderInsertOneMutation = { __typename?: 'mutation_root', insert_document_folder_one?: { __typename?: 'document_folder', id: string, name?: string | null } | null };

export type DocumentFragment = { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null };

export type DocumentInsertOneMutationVariables = Exact<{
  object: Document_Insert_Input;
}>;


export type DocumentInsertOneMutation = { __typename?: 'mutation_root', insert_document_one?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null };

export type DocumentDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DocumentDeleteOneMutation = { __typename?: 'mutation_root', delete_document_by_pk?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null };

export type DocumentUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  changes: Document_Set_Input;
}>;


export type DocumentUpdateOneMutation = { __typename?: 'mutation_root', update_document_by_pk?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null };

export type DocumentInsertManyMutationVariables = Exact<{
  objects: Array<Document_Insert_Input> | Document_Insert_Input;
}>;


export type DocumentInsertManyMutation = { __typename?: 'mutation_root', insert_document?: { __typename?: 'document_mutation_response', returning: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> } | null };

export type DocumentGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DocumentGetByIdQuery = { __typename?: 'query_root', document_by_pk?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null };

export type DocumentGetManyQueryVariables = Exact<{
  filter: Document_Bool_Exp;
  order_by?: InputMaybe<Array<Document_Order_By> | Document_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Document_Select_Column> | Document_Select_Column>;
}>;


export type DocumentGetManyQuery = { __typename?: 'query_root', document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> };

export type EntityFragment = { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type EntityDataFragment = { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type EntityOwnPropertiesFragment = { __typename?: 'entity', type?: string | null, business_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null };

export type EntityInsertOneMutationVariables = Exact<{
  object: Entity_Insert_Input;
}>;


export type EntityInsertOneMutation = { __typename?: 'mutation_root', insert_entity_one?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type EntityUpsertOneMutationVariables = Exact<{
  object: Entity_Insert_Input;
}>;


export type EntityUpsertOneMutation = { __typename?: 'mutation_root', insert_entity_one?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type EntityUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Entity_Set_Input;
}>;


export type EntityUpdateOneMutation = { __typename?: 'mutation_root', update_entity_by_pk?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type EntityDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EntityDeleteOneMutation = { __typename?: 'mutation_root', delete_entity_by_pk?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type EntityGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EntityGetByIdQuery = { __typename?: 'query_root', entity_by_pk?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type EntityGetManyQueryVariables = Exact<{
  filter?: Entity_Bool_Exp;
  order_by?: InputMaybe<Array<Entity_Order_By> | Entity_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntityGetManyQuery = { __typename?: 'query_root', entity: Array<{ __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }> };

export type ExchangeRateFragment = { __typename?: 'exchange_rate', id: number, base_currency: string, target_currency: string, rate: number, date: string, created_at: string };

export type ExchangeRateInsertManyMutationVariables = Exact<{
  objects: Array<Exchange_Rate_Insert_Input> | Exchange_Rate_Insert_Input;
}>;


export type ExchangeRateInsertManyMutation = { __typename?: 'mutation_root', insert_exchange_rate?: { __typename?: 'exchange_rate_mutation_response', returning: Array<{ __typename?: 'exchange_rate', id: number, base_currency: string, target_currency: string, rate: number, date: string, created_at: string }> } | null };

export type ExchangeRateGetManyQueryVariables = Exact<{
  where?: InputMaybe<Exchange_Rate_Bool_Exp>;
  order_by?: InputMaybe<Array<Exchange_Rate_Order_By> | Exchange_Rate_Order_By>;
}>;


export type ExchangeRateGetManyQuery = { __typename?: 'query_root', exchange_rate: Array<{ __typename?: 'exchange_rate', id: number, base_currency: string, target_currency: string, rate: number, date: string, created_at: string }> };

export type ExternalTrademarkFragment = { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type ExternalTrademarkForUserFragment = { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null };

export type ExternalTrademarkInsertOneMutationVariables = Exact<{
  object: External_Trademark_Insert_Input;
}>;


export type ExternalTrademarkInsertOneMutation = { __typename?: 'mutation_root', insert_external_trademark_one?: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type ExternalTrademarkUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: External_Trademark_Set_Input;
}>;


export type ExternalTrademarkUpdateOneMutation = { __typename?: 'mutation_root', update_external_trademark_by_pk?: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type ExternalTrademarkGetManyQueryVariables = Exact<{
  where: External_Trademark_Bool_Exp;
  order_by?: InputMaybe<Array<External_Trademark_Order_By> | External_Trademark_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<External_Trademark_Select_Column> | External_Trademark_Select_Column>;
}>;


export type ExternalTrademarkGetManyQuery = { __typename?: 'query_root', external_trademark: Array<{ __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }> };

export type InvoiceFragment = { __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null };

export type ProductInvoiceFragment = { __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null, product: { __typename?: 'product', id: string, registration_request?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null, service_request?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null, brand_subscription_payment?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null } };

export type InvoiceForUserFragment = { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null };

export type InvoiceUpdateOneMutationVariables = Exact<{
  variable_symbol: Scalars['String']['input'];
  changes: Invoice_Set_Input;
}>;


export type InvoiceUpdateOneMutation = { __typename?: 'mutation_root', update_invoice_by_pk?: { __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null } | null };

export type InvoiceUpsertMutationVariables = Exact<{
  object: Invoice_Insert_Input;
}>;


export type InvoiceUpsertMutation = { __typename?: 'mutation_root', insert_invoice_one?: { __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null } | null };

export type InvoiceMarkAsPaidMutationVariables = Exact<{
  variableSymbol: Scalars['String']['input'];
  billingEntity: Scalars['String']['input'];
  paymentDate: Scalars['timestamptz']['input'];
  paymentType: Scalars['String']['input'];
}>;


export type InvoiceMarkAsPaidMutation = { __typename?: 'mutation_root', invoice_mark_as_paid: Array<{ __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null }> };

export type InvoiceGetByReferenceQueryVariables = Exact<{
  variable_symbol: Scalars['String']['input'];
}>;


export type InvoiceGetByReferenceQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null } | null };

export type InvoiceGetOneByRegistrationIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InvoiceGetOneByRegistrationIdQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null }> };

export type InvoiceGetOneByProductIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InvoiceGetOneByProductIdQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null }> };

export type InvoiceGetOneByVariableSymbolForUserQueryVariables = Exact<{
  variable_symbol: Scalars['String']['input'];
}>;


export type InvoiceGetOneByVariableSymbolForUserQuery = { __typename?: 'query_root', invoice_by_pk?: { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null } | null };

export type InvoiceGetOneByRegistrationIdForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InvoiceGetOneByRegistrationIdForUserQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null }> };

export type InvoiceGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Invoice_Bool_Exp>;
  order_by?: InputMaybe<Array<Invoice_Order_By> | Invoice_Order_By>;
}>;


export type InvoiceGetManyQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null, product: { __typename?: 'product', id: string, registration_request?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null, service_request?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null, brand_subscription_payment?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null } }> };

export type InvoiceGetManyUnpaidBetweenDatesQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type InvoiceGetManyUnpaidBetweenDatesQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: string, billing_entity: string, serial_number?: number | null, year: number, created_at: string, variable_symbol: string, payment_date?: string | null, payment_type?: string | null, product_id: string, document_context: any, revolut_transaction_id?: string | null, revolut_public_order_id?: string | null, revolut_order_id?: string | null, last_failed_payment_alert_at?: string | null, registration_request?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null }> };

export type InvoicesGetPathsForPaidQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  to: Scalars['timestamptz']['input'];
}>;


export type InvoicesGetPathsForPaidQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', serial_number?: number | null, year: number, billing_entity: string, product: { __typename?: 'product', registration_request?: { __typename?: 'registration_request', documents: Array<{ __typename?: 'document', path: string }> } | null, service_request?: { __typename?: 'service_request', documents: Array<{ __typename?: 'document', path: string }> } | null } }> };

export type AllUserInvoicesQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AllUserInvoicesQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', id: string, payment_date?: string | null, total: any, currency: any, product: { __typename?: 'product', brand_subscription_payment?: { __typename?: 'brand_subscription_payment', brand_subscription: { __typename?: 'brand_subscription', payment_frequency: string, brand: { __typename?: 'brand', name: string } } } | null, service_request?: { __typename?: 'service_request', id: string, service_name?: string | null, internal_label?: string | null } | null, registration_request?: { __typename?: 'registration_request', id: string } | null } }>, invoice_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', count: number } | null } };

export type PaidOrdersSummaryLast30DaysQueryVariables = Exact<{
  order_by?: InputMaybe<Array<Paid_Orders_Summary_Last_30_Days_Order_By> | Paid_Orders_Summary_Last_30_Days_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaidOrdersSummaryLast30DaysQuery = { __typename?: 'query_root', paid_orders_summary_last_30_days: Array<{ __typename?: 'paid_orders_summary_last_30_days', source: string, id: string, service_name?: string | null, registration_request_type?: string | null, registration_request_value?: string | null, total_vat_base: any, service_fees: any, government_fees: any, discount: any, date: string, user_id: string, email: string, assigned_admin?: any | null }> };

export type PaidOrdersSummaryLast30DaysCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PaidOrdersSummaryLast30DaysCountQuery = { __typename?: 'query_root', paid_orders_summary_last_30_days_count: Array<{ __typename?: 'aggregate_count', count: number }> };

export type NoteFragment = { __typename: 'note', id: number, text?: string | null, is_enabled: boolean, created_at: string, created_by?: string | null, note_hub_id: string, document_id?: number | null };

export type NoteInsertOneMutationVariables = Exact<{
  object: Note_Insert_Input;
}>;


export type NoteInsertOneMutation = { __typename?: 'mutation_root', insert_note_one?: { __typename: 'note', id: number, text?: string | null, is_enabled: boolean, created_at: string, created_by?: string | null, note_hub_id: string, document_id?: number | null } | null };

export type NoteUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  set: Note_Set_Input;
}>;


export type NoteUpdateOneMutation = { __typename?: 'mutation_root', update_note_by_pk?: { __typename: 'note', id: number, text?: string | null, is_enabled: boolean, created_at: string, created_by?: string | null, note_hub_id: string, document_id?: number | null } | null };

export type NoteDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type NoteDeleteOneMutation = { __typename?: 'mutation_root', delete_note_by_pk?: { __typename: 'note', id: number, text?: string | null, is_enabled: boolean, created_at: string, created_by?: string | null, note_hub_id: string, document_id?: number | null } | null };

export type NoteGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type NoteGetByIdQuery = { __typename?: 'query_root', note_by_pk?: { __typename: 'note', id: number, text?: string | null, is_enabled: boolean, created_at: string, created_by?: string | null, note_hub_id: string, document_id?: number | null } | null };

export type NotificationFragment = { __typename?: 'notification', id: string, from_user_id: string, to_user_id: string, type: string, message: string, metadata: any, seen_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string };

export type NotificationInsertOneMutationVariables = Exact<{
  object: Notification_Insert_Input;
}>;


export type NotificationInsertOneMutation = { __typename?: 'mutation_root', insert_notification_one?: { __typename?: 'notification', id: string, from_user_id: string, to_user_id: string, type: string, message: string, metadata: any, seen_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string } | null };

export type NotificationInsertManyMutationVariables = Exact<{
  objects: Array<Notification_Insert_Input> | Notification_Insert_Input;
}>;


export type NotificationInsertManyMutation = { __typename?: 'mutation_root', insert_notification?: { __typename?: 'notification_mutation_response', returning: Array<{ __typename?: 'notification', id: string, from_user_id: string, to_user_id: string, type: string, message: string, metadata: any, seen_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string }> } | null };

export type NotificationGetManyQueryVariables = Exact<{
  where: Notification_Bool_Exp;
  order_by?: InputMaybe<Array<Notification_Order_By> | Notification_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Notification_Select_Column> | Notification_Select_Column>;
}>;


export type NotificationGetManyQuery = { __typename?: 'query_root', notification: Array<{ __typename?: 'notification', id: string, from_user_id: string, to_user_id: string, type: string, message: string, metadata: any, seen_at?: string | null, deleted_at?: string | null, created_at: string, updated_at: string }> };

export type OfficeActionFragment = { __typename: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }>, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }>, issues: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }>, office_action_similar_trademark_map: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> };

export type OfficeActionCommonDataFragment = { __typename?: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean };

export type OfficeActionForUserFragment = { __typename?: 'office_action', id: string, due_date?: string | null, issue_date?: string | null, trademark_id: string, status: string, client_input?: string | null, nature_of_issues?: string | null, issues_version: number, trademark: { __typename?: 'trademark', id: string, type: string, jurisdiction: string, name?: string | null }, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, service_request_id?: string | null }>, orders: Array<{ __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }> };

export type OfficeActionForUserDashboardFragment = { __typename?: 'office_action', id: string, due_date?: string | null, status: string, client_input?: string | null, nature_of_issues?: string | null, issues_version: number, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, service_request_id?: string | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }> };

export type OfficeActionInsertOneMutationVariables = Exact<{
  object: Office_Action_Insert_Input;
}>;


export type OfficeActionInsertOneMutation = { __typename?: 'mutation_root', insert_office_action_one?: { __typename: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }>, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }>, issues: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }>, office_action_similar_trademark_map: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> } | null };

export type OfficeActionUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Office_Action_Set_Input;
}>;


export type OfficeActionUpdateOneMutation = { __typename?: 'mutation_root', update_office_action_by_pk?: { __typename: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }>, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }>, issues: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }>, office_action_similar_trademark_map: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> } | null };

export type OfficeActionGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type OfficeActionGetByIdQuery = { __typename?: 'query_root', office_action_by_pk?: { __typename: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }>, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }>, issues: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }>, office_action_similar_trademark_map: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> } | null };

export type OfficeActionGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Office_Action_Bool_Exp>;
  order_by?: InputMaybe<Array<Office_Action_Order_By> | Office_Action_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OfficeActionGetManyQuery = { __typename?: 'query_root', office_action: Array<{ __typename: 'office_action', id: string, assigned_admin_id?: string | null, trademark_id: string, order_hub_id: string, document_hub_id: string, created_at: string, last_status_update: string, last_tracking_update: string, status: string, issue_date?: string | null, due_date?: string | null, tags?: any | null, risk_highlighted?: boolean | null, client_input?: string | null, recommendation_note?: string | null, client_delight?: string | null, order_currency?: string | null, supplemental_register_suggested?: boolean | null, nature_of_issues?: string | null, issue_summary?: string | null, note_hub_id: string, issues_version: number, suggested_issues?: any | null, updated_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, ai_issue_summary?: string | null, consent_denied_roa_service_request_id?: string | null, missive_link?: string | null, outcome?: string | null, is_final: boolean, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }>, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }>, issues: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }>, office_action_similar_trademark_map: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> }> };

export type OfficeActionCountQueryVariables = Exact<{
  filter?: InputMaybe<Office_Action_Bool_Exp>;
}>;


export type OfficeActionCountQuery = { __typename?: 'query_root', office_action_aggregate: { __typename?: 'office_action_aggregate', aggregate?: { __typename?: 'office_action_aggregate_fields', count: number } | null } };

export type OfficeActionGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Office_Action_Bool_Exp>;
  order_by?: InputMaybe<Array<Office_Action_Order_By> | Office_Action_Order_By>;
}>;


export type OfficeActionGetManyForUserQuery = { __typename?: 'query_root', office_action: Array<{ __typename?: 'office_action', id: string, due_date?: string | null, issue_date?: string | null, trademark_id: string, status: string, client_input?: string | null, nature_of_issues?: string | null, issues_version: number, trademark: { __typename?: 'trademark', id: string, type: string, jurisdiction: string, name?: string | null }, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, service_request_id?: string | null }>, orders: Array<{ __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }> }> };

export type OfficeActionIssueFragment = { __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null };

export type OfficeActionIssueUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Office_Action_Issue_Set_Input;
}>;


export type OfficeActionIssueUpdateOneMutation = { __typename?: 'mutation_root', update_office_action_issue_by_pk?: { __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null } | null };

export type OfficeActionIssueDeleteManyMutationVariables = Exact<{
  officeActionId: Scalars['uuid']['input'];
}>;


export type OfficeActionIssueDeleteManyMutation = { __typename?: 'mutation_root', delete_office_action_issue?: { __typename?: 'office_action_issue_mutation_response', affected_rows: number } | null };

export type OfficeActionIssueInsertManyMutationVariables = Exact<{
  objects: Array<Office_Action_Issue_Insert_Input> | Office_Action_Issue_Insert_Input;
}>;


export type OfficeActionIssueInsertManyMutation = { __typename?: 'mutation_root', insert_office_action_issue?: { __typename?: 'office_action_issue_mutation_response', returning: Array<{ __typename?: 'office_action_issue', id: string, name: string, category: string, additional_info_note?: string | null, document_folder_id?: string | null }> } | null };

export type OfficeActionSimilarTrademarkMapFragment = { __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } };

export type OfficeActionSimilarTrademarkMapInsertManyMutationVariables = Exact<{
  objects: Array<Office_Action_Similar_Trademark_Map_Insert_Input> | Office_Action_Similar_Trademark_Map_Insert_Input;
}>;


export type OfficeActionSimilarTrademarkMapInsertManyMutation = { __typename?: 'mutation_root', insert_office_action_similar_trademark_map?: { __typename?: 'office_action_similar_trademark_map_mutation_response', returning: Array<{ __typename: 'office_action_similar_trademark_map', id: number, office_action_id: string, external_trademark_id: string, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> } | null };

export type OfficeActionSimilarTrademarkMapDeleteManyMutationVariables = Exact<{
  where: Office_Action_Similar_Trademark_Map_Bool_Exp;
}>;


export type OfficeActionSimilarTrademarkMapDeleteManyMutation = { __typename?: 'mutation_root', delete_office_action_similar_trademark_map?: { __typename?: 'office_action_similar_trademark_map_mutation_response', affected_rows: number } | null };

export type OfficeActionSolutionFragment = { __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null };

export type OfficeActionSolutionForUserFragment = { __typename?: 'office_action_solution', id: string, solution: string, service_request_id?: string | null };

export type OfficeActionSolutionDeleteManyMutationVariables = Exact<{
  officeActionId: Scalars['uuid']['input'];
}>;


export type OfficeActionSolutionDeleteManyMutation = { __typename?: 'mutation_root', delete_office_action_solution?: { __typename?: 'office_action_solution_mutation_response', affected_rows: number } | null };

export type OfficeActionSolutionInsertManyMutationVariables = Exact<{
  objects: Array<Office_Action_Solution_Insert_Input> | Office_Action_Solution_Insert_Input;
}>;


export type OfficeActionSolutionInsertManyMutation = { __typename?: 'mutation_root', insert_office_action_solution?: { __typename?: 'office_action_solution_mutation_response', returning: Array<{ __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null }> } | null };

export type OfficeActionSolutionUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Office_Action_Solution_Set_Input;
}>;


export type OfficeActionSolutionUpdateOneMutation = { __typename?: 'mutation_root', update_office_action_solution_by_pk?: { __typename?: 'office_action_solution', id: string, solution: string, chance_of_success?: number | null, service_fee?: any | null, government_fee?: any | null, recommended: boolean, service_request_id?: string | null, selected: boolean, order?: { __typename?: 'service_request', status: string, product_id: string, document_hub_id: string } | null } | null };

export type OfficeActionTrackingFragment = { __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string };

export type OfficeActionTrackingWithStatusFragment = { __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string, tracking_status: { __typename?: 'office_action_tracking_status', is_status: boolean } };

export type OfficeActionTrackingInsertOneMutationVariables = Exact<{
  object: Office_Action_Tracking_Insert_Input;
}>;


export type OfficeActionTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_office_action_tracking_one?: { __typename?: 'office_action_tracking', id: number } | null };

export type OfficeActionTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type OfficeActionTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_office_action_tracking_by_pk?: { __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string } | null };

export type OfficeActionTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By> | Office_Action_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column> | Office_Action_Tracking_Select_Column>;
}>;


export type OfficeActionTrackingGetManyQuery = { __typename?: 'query_root', office_action_tracking: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }> };

export type OfficeActionTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Office_Action_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Office_Action_Tracking_Order_By> | Office_Action_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Office_Action_Tracking_Select_Column> | Office_Action_Tracking_Select_Column>;
}>;


export type OfficeActionTrackingWithStatusGetManyQuery = { __typename?: 'query_root', office_action_tracking: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string, tracking_status: { __typename?: 'office_action_tracking_status', is_status: boolean } }> };

export type OrderFragment = { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> };

export type OrderInsertOneMutationVariables = Exact<{
  object: Order_Insert_Input;
}>;


export type OrderInsertOneMutation = { __typename?: 'mutation_root', insert_order_one?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null };

export type OrderUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Order_Set_Input;
}>;


export type OrderUpdateOneMutation = { __typename?: 'mutation_root', update_order_by_pk?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null };

export type OrderGetManyQueryVariables = Exact<{
  where?: InputMaybe<Order_Bool_Exp>;
  order_by?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Order_Select_Column> | Order_Select_Column>;
}>;


export type OrderGetManyQuery = { __typename?: 'query_root', order: Array<{ __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> }> };

export type OrderTrackingFragment = { __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string };

export type OrderTrackingInsertOneMutationVariables = Exact<{
  object: Order_Tracking_Insert_Input;
}>;


export type OrderTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_order_tracking_one?: { __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string } | null };

export type OrderTrackingStatusFragment = { __typename: 'order_tracking_status', name: string, is_status: boolean };

export type OrderTrackingStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Order_Tracking_Status_Bool_Exp>;
  order_by?: InputMaybe<Array<Order_Tracking_Status_Order_By> | Order_Tracking_Status_Order_By>;
}>;


export type OrderTrackingStatusGetManyQuery = { __typename?: 'query_root', order_tracking_status: Array<{ __typename: 'order_tracking_status', name: string, is_status: boolean }> };

export type UnassignedOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type UnassignedOrdersQuery = { __typename?: 'query_root', registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null }, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null }, trademark_request_aggregate: { __typename?: 'trademark_request_aggregate', aggregate?: { __typename?: 'trademark_request_aggregate_fields', count: number } | null }, service_request_aggregate: { __typename?: 'service_request_aggregate', aggregate?: { __typename?: 'service_request_aggregate_fields', count: number } | null } };

export type PoaFragment = { __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> };

export type PoaInsertOneMutationVariables = Exact<{
  object: Poa_Insert_Input;
}>;


export type PoaInsertOneMutation = { __typename?: 'mutation_root', insert_poa_one?: { __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> } | null };

export type PoaUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Poa_Set_Input;
}>;


export type PoaUpdateOneMutation = { __typename?: 'mutation_root', update_poa_by_pk?: { __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> } | null };

export type PoaDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PoaDeleteOneMutation = { __typename?: 'mutation_root', delete_poa_by_pk?: { __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> } | null };

export type PoaGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PoaGetByIdQuery = { __typename?: 'query_root', poa_by_pk?: { __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> } | null };

export type PoaGetManyQueryVariables = Exact<{
  where: Poa_Bool_Exp;
  order_by?: InputMaybe<Array<Poa_Order_By> | Poa_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PoaGetManyQuery = { __typename?: 'query_root', poa: Array<{ __typename?: 'poa', id: string, document_id: number, user_id: string, type: string, template_id: string, status: string, jurisdictions?: any | null, expiration_date?: string | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string, owner_entity: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null }, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }, trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> }> };

export type PriceFragment = { __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string };

export type PriceInsertOneMutationVariables = Exact<{
  object: Price_Insert_Input;
}>;


export type PriceInsertOneMutation = { __typename?: 'mutation_root', insert_price_one?: { __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string } | null };

export type PriceUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Price_Set_Input;
}>;


export type PriceUpdateOneMutation = { __typename?: 'mutation_root', update_price_by_pk?: { __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string } | null };

export type PriceUpdateManyMutationVariables = Exact<{
  where: Price_Bool_Exp;
  set: Price_Set_Input;
}>;


export type PriceUpdateManyMutation = { __typename?: 'mutation_root', update_price?: { __typename?: 'price_mutation_response', returning: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> } | null };

export type PriceRuleFragment = { __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> };

export type PriceRuleInsertOneMutationVariables = Exact<{
  object: Price_Rule_Insert_Input;
}>;


export type PriceRuleInsertOneMutation = { __typename?: 'mutation_root', insert_price_rule_one?: { __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> } | null };

export type PriceRuleInsertManyMutationVariables = Exact<{
  objects: Array<Price_Rule_Insert_Input> | Price_Rule_Insert_Input;
}>;


export type PriceRuleInsertManyMutation = { __typename?: 'mutation_root', insert_price_rule?: { __typename?: 'price_rule_mutation_response', returning: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> } | null };

export type PriceRuleUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Price_Rule_Set_Input;
}>;


export type PriceRuleUpdateOneMutation = { __typename?: 'mutation_root', update_price_rule_by_pk?: { __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> } | null };

export type ProductFragment = { __typename?: 'product', id: string, registration_request?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null, service_request?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null, brand_subscription_payment?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null };

export type ProductUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Product_Set_Input;
}>;


export type ProductUpdateOneMutation = { __typename?: 'mutation_root', update_product_by_pk?: { __typename?: 'product', id: string } | null };

export type ProductGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProductGetByIdQuery = { __typename?: 'query_root', product_by_pk?: { __typename?: 'product', id: string, registration_request?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null, service_request?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null, brand_subscription_payment?: { __typename?: 'brand_subscription_payment', id: string, brand_subscription_id: string, user_payment_method_id?: string | null, product_id: string, start_date: string, end_date: string, status: string, created_at: string, updated_at: string, document_folder_id: string, decline_reason?: string | null, billing_entity_id: string, last_attempt_date?: string | null, number_of_attempts: number } | null } | null };

export type ProductBundleFragment = { __typename: 'product_bundle', id: string, name: string, category: string, jurisdiction?: string | null, created_at: string };

export type ProductBundleInsertOneMutationVariables = Exact<{
  object: Product_Bundle_Insert_Input;
}>;


export type ProductBundleInsertOneMutation = { __typename?: 'mutation_root', insert_product_bundle_one?: { __typename: 'product_bundle', id: string, name: string, category: string, jurisdiction?: string | null, created_at: string } | null };

export type ProductBundleUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Product_Bundle_Set_Input;
}>;


export type ProductBundleUpdateOneMutation = { __typename?: 'mutation_root', update_product_bundle_by_pk?: { __typename: 'product_bundle', id: string, name: string, category: string, jurisdiction?: string | null, created_at: string } | null };

export type ProductBundleDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProductBundleDeleteOneMutation = { __typename?: 'mutation_root', delete_product_bundle_by_pk?: { __typename?: 'product_bundle', id: string } | null };

export type ProductBundleGetManyQueryVariables = Exact<{
  where?: InputMaybe<Product_Bundle_Bool_Exp>;
  order_by?: InputMaybe<Array<Product_Bundle_Order_By> | Product_Bundle_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Product_Bundle_Select_Column> | Product_Bundle_Select_Column>;
}>;


export type ProductBundleGetManyQuery = { __typename?: 'query_root', product_bundle: Array<{ __typename: 'product_bundle', id: string, name: string, category: string, jurisdiction?: string | null, created_at: string }> };

export type ProductBundleGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductBundleGetAllQuery = { __typename?: 'query_root', product_bundle: Array<{ __typename: 'product_bundle', id: string, name: string, category: string, jurisdiction?: string | null, created_at: string, products: Array<{ __typename?: 'product_v2', id: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, price_rules: Array<{ __typename?: 'price_rule', id: string, type: string, name: string, config: any, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> }> }> };

export type ProductEventFragment = { __typename?: 'product_event', id: string, product_id: string, name: string, data: any, created_at: string, updated_at: string };

export type ProductEventInsertOneMutationVariables = Exact<{
  object: Product_Event_Insert_Input;
}>;


export type ProductEventInsertOneMutation = { __typename?: 'mutation_root', insert_product_event_one?: { __typename?: 'product_event', id: string, product_id: string, name: string, data: any, created_at: string, updated_at: string } | null };

export type ProductEventGetManyQueryVariables = Exact<{
  filter: Product_Event_Bool_Exp;
  order_by?: InputMaybe<Array<Product_Event_Order_By> | Product_Event_Order_By>;
}>;


export type ProductEventGetManyQuery = { __typename?: 'query_root', product_event: Array<{ __typename?: 'product_event', id: string, product_id: string, name: string, data: any, created_at: string, updated_at: string }> };

export type ProductV2Fragment = { __typename: 'product_v2', id: string, sku: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, product_bundle_id?: string | null, bundle_sort_order?: number | null, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, price_rules: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> };

export type ProductV2InsertOneMutationVariables = Exact<{
  object: Product_V2_Insert_Input;
}>;


export type ProductV2InsertOneMutation = { __typename?: 'mutation_root', insert_product_v2_one?: { __typename: 'product_v2', id: string, sku: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, product_bundle_id?: string | null, bundle_sort_order?: number | null, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, price_rules: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> } | null };

export type ProductV2InsertManyMutationVariables = Exact<{
  objects: Array<Product_V2_Insert_Input> | Product_V2_Insert_Input;
}>;


export type ProductV2InsertManyMutation = { __typename?: 'mutation_root', insert_product_v2?: { __typename?: 'product_v2_mutation_response', returning: Array<{ __typename: 'product_v2', id: string, sku: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, product_bundle_id?: string | null, bundle_sort_order?: number | null, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, price_rules: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> }> } | null };

export type ProductV2UpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Product_V2_Set_Input;
}>;


export type ProductV2UpdateOneMutation = { __typename?: 'mutation_root', update_product_v2_by_pk?: { __typename: 'product_v2', id: string, sku: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, product_bundle_id?: string | null, bundle_sort_order?: number | null, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, price_rules: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> } | null };

export type ProductV2GetManyQueryVariables = Exact<{
  where?: InputMaybe<Product_V2_Bool_Exp>;
  order_by?: InputMaybe<Array<Product_V2_Order_By> | Product_V2_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Product_V2_Select_Column> | Product_V2_Select_Column>;
}>;


export type ProductV2GetManyQuery = { __typename?: 'query_root', product_v2: Array<{ __typename: 'product_v2', id: string, sku: string, name: string, category: string, jurisdiction?: string | null, is_gov_fee: boolean, invoice_translation_key?: string | null, parameters: any, product_bundle_id?: string | null, bundle_sort_order?: number | null, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, price_rules: Array<{ __typename: 'price_rule', id: string, product_v2_id: string, type: string, name: string, config: any, deleted: boolean, created_at: string, updated_at: string, deleted_at?: string | null, prices: Array<{ __typename: 'price', id: string, price_rule_id: string, active: boolean, price_eur: any, price_czk: any, price_gbp: any, price_usd: any, price_aud: any, price_chf: any, price_cad: any, price_nzd: any, price_mxn: any, price_zar: any, partner_cost_eur?: any | null, created_at: string }> }> }> };

export type QuoteFragment = { __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null };

export type QuoteInsertOneMutationVariables = Exact<{
  object: Quote_Insert_Input;
}>;


export type QuoteInsertOneMutation = { __typename?: 'mutation_root', insert_quote_one?: { __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null } | null };

export type QuoteReplaceActiveInGroupMutationVariables = Exact<{
  group_id: Scalars['uuid']['input'];
  object: Quote_Insert_Input;
}>;


export type QuoteReplaceActiveInGroupMutation = { __typename?: 'mutation_root', update_quote?: { __typename?: 'quote_mutation_response', returning: Array<{ __typename?: 'quote', id: string, order?: { __typename?: 'order', id: string, status: string } | null }> } | null, insert_quote_one?: { __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null } | null };

export type QuoteUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Quote_Set_Input;
}>;


export type QuoteUpdateOneMutation = { __typename?: 'mutation_root', update_quote_by_pk?: { __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null } | null };

export type QuoteUpdateManyMutationVariables = Exact<{
  where: Quote_Bool_Exp;
  set: Quote_Set_Input;
}>;


export type QuoteUpdateManyMutation = { __typename?: 'mutation_root', update_quote?: { __typename?: 'quote_mutation_response', returning: Array<{ __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null }> } | null };

export type QuoteGetManyQueryVariables = Exact<{
  where?: InputMaybe<Quote_Bool_Exp>;
  order_by?: InputMaybe<Array<Quote_Order_By> | Quote_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Quote_Select_Column> | Quote_Select_Column>;
}>;


export type QuoteGetManyQuery = { __typename?: 'query_root', quote: Array<{ __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null }> };

export type QuoteHubFragment = { __typename: 'quote_hub', id: string, type: string, created_at: string, quotes: Array<{ __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null }>, orders: Array<{ __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> }> };

export type QuoteHubGetManyQueryVariables = Exact<{
  where?: InputMaybe<Quote_Hub_Bool_Exp>;
  order_by?: InputMaybe<Array<Quote_Hub_Order_By> | Quote_Hub_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Quote_Hub_Select_Column> | Quote_Hub_Select_Column>;
}>;


export type QuoteHubGetManyQuery = { __typename?: 'query_root', quote_hub: Array<{ __typename: 'quote_hub', id: string, type: string, created_at: string, quotes: Array<{ __typename: 'quote', id: string, group_id: string, quote_hub_id: string, currency: string, active: boolean, parameters?: any | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, quote_items: Array<{ __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string }>, order?: { __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> } | null }>, orders: Array<{ __typename: 'order', id: string, quote_id: string, quote_hub_id: string, user_id: string, status: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, tracking_actions: Array<{ __typename: 'order_tracking', id: string, order_id: string, name: string, user_id?: string | null, created_at: string }> }> }> };

export type QuoteItemFragment = { __typename: 'quote_item', id: string, quote_id: string, product_id?: string | null, name: string, quantity: number, price: number, is_gov_fee: boolean, sort_order: number, parameters?: any | null, created_at: string, updated_at: string };

export type RefundRequestFragment = { __typename: 'refund_request', id: string, title: string, missive_link?: string | null, issue: string, our_fault: boolean, e2e_refund: boolean, reason_for_refund?: string | null, proposed_solution: string, status: string, last_status_update: string, user_id: string, assigned_admin_id?: string | null, note_hub_id: string, document_hub_id: string, refunded_government_fee?: number | null, refunded_service_fee?: number | null, refunded_partner_fee?: number | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string };

export type RefundRequestInsertOneMutationVariables = Exact<{
  object: Refund_Request_Insert_Input;
}>;


export type RefundRequestInsertOneMutation = { __typename?: 'mutation_root', insert_refund_request_one?: { __typename: 'refund_request', id: string, title: string, missive_link?: string | null, issue: string, our_fault: boolean, e2e_refund: boolean, reason_for_refund?: string | null, proposed_solution: string, status: string, last_status_update: string, user_id: string, assigned_admin_id?: string | null, note_hub_id: string, document_hub_id: string, refunded_government_fee?: number | null, refunded_service_fee?: number | null, refunded_partner_fee?: number | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type RefundRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Refund_Request_Set_Input>;
}>;


export type RefundRequestUpdateOneMutation = { __typename?: 'mutation_root', update_refund_request_by_pk?: { __typename: 'refund_request', id: string, title: string, missive_link?: string | null, issue: string, our_fault: boolean, e2e_refund: boolean, reason_for_refund?: string | null, proposed_solution: string, status: string, last_status_update: string, user_id: string, assigned_admin_id?: string | null, note_hub_id: string, document_hub_id: string, refunded_government_fee?: number | null, refunded_service_fee?: number | null, refunded_partner_fee?: number | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type RefundRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RefundRequestGetByIdQuery = { __typename?: 'query_root', refund_request_by_pk?: { __typename: 'refund_request', id: string, title: string, missive_link?: string | null, issue: string, our_fault: boolean, e2e_refund: boolean, reason_for_refund?: string | null, proposed_solution: string, status: string, last_status_update: string, user_id: string, assigned_admin_id?: string | null, note_hub_id: string, document_hub_id: string, refunded_government_fee?: number | null, refunded_service_fee?: number | null, refunded_partner_fee?: number | null, created_at: string, created_by_user_id: string, updated_at: string, updated_by_user_id: string } | null };

export type RefundRequestInvoiceFragment = { __typename: 'refund_request_invoice', id: number, refund_request_id: string, invoice_id: string };

export type RefundRequestInvoiceInsertManyMutationVariables = Exact<{
  objects: Array<Refund_Request_Invoice_Insert_Input> | Refund_Request_Invoice_Insert_Input;
}>;


export type RefundRequestInvoiceInsertManyMutation = { __typename?: 'mutation_root', insert_refund_request_invoice?: { __typename?: 'refund_request_invoice_mutation_response', returning: Array<{ __typename: 'refund_request_invoice', id: number, refund_request_id: string, invoice_id: string }> } | null };

export type RefundRequestInvoiceDeleteManyMutationVariables = Exact<{
  where: Refund_Request_Invoice_Bool_Exp;
}>;


export type RefundRequestInvoiceDeleteManyMutation = { __typename?: 'mutation_root', delete_refund_request_invoice?: { __typename?: 'refund_request_invoice_mutation_response', affected_rows: number } | null };

export type RefundRequestTrackingFragment = { __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string };

export type RefundRequestTrackingWithStatusFragment = { __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string, tracking_status: { __typename?: 'refund_request_tracking_status', is_status: boolean } };

export type RefundRequestTrackingInsertOneMutationVariables = Exact<{
  object: Refund_Request_Tracking_Insert_Input;
}>;


export type RefundRequestTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_refund_request_tracking_one?: { __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string } | null };

export type RefundRequestTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RefundRequestTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_refund_request_tracking_by_pk?: { __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string } | null };

export type RefundRequestTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By> | Refund_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column> | Refund_Request_Tracking_Select_Column>;
}>;


export type RefundRequestTrackingGetManyQuery = { __typename?: 'query_root', refund_request_tracking: Array<{ __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string }> };

export type RefundRequestTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Refund_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Refund_Request_Tracking_Order_By> | Refund_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Refund_Request_Tracking_Select_Column> | Refund_Request_Tracking_Select_Column>;
}>;


export type RefundRequestTrackingWithStatusGetManyQuery = { __typename?: 'query_root', refund_request_tracking: Array<{ __typename?: 'refund_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id: string, refund_request_id: string, tracking_status: { __typename?: 'refund_request_tracking_status', is_status: boolean } }> };

export type CoreRegistrationFieldsFragment = { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> };

export type RegistrationRequestFieldsForUserFragment = { __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, gdrive_folder_id?: string | null, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, brand_protection: boolean, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, application?: { __typename?: 'application', registration_entity_id?: string | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, invoice?: { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null } | null, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> };

export type DraftingRegistrationFieldsFragment = { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademarks: Array<{ __typename?: 'trademark', jurisdiction: string }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> };

export type RegistrationRequestLastStatusUpdateFragment = { __typename?: 'registration_request', id: string, last_status_update: string };

export type ReportViolationRegistrationFieldsFragment = { __typename?: 'registration_request', id: string, type: string, value: string, report_violation_url?: string | null, document_hub_id: string, application_id?: string | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademarks: Array<{ __typename?: 'trademark', jurisdiction: string, id: string, status: string, number?: string | null, filing_date?: string | null }> };

export type RegistrationRequestWithTrackingFieldsForUserFragment = { __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }> };

export type RegistrationRequestFieldsForUserOrdersFragment = { __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> };

export type RegistrationRequestForUserDashboardFragment = { __typename?: 'registration_request', id: string, product_id: string, value: string, type: string, created_at: string, jurisdictions: any, document_hub_id: string, status: string, last_status_update: string, user_id: string, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> };

export type RegistrationRequestInsertOneMutationVariables = Exact<{
  object: Registration_Request_Insert_Input;
}>;


export type RegistrationRequestInsertOneMutation = { __typename?: 'mutation_root', insert_registration_request_one?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null };

export type RegistrationRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Registration_Request_Set_Input;
}>;


export type RegistrationRequestUpdateOneMutation = { __typename?: 'mutation_root', update_registration_request_by_pk?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null };

export type RegistrationRequestUpdateManyMutationVariables = Exact<{
  where?: InputMaybe<Registration_Request_Bool_Exp>;
  set: Registration_Request_Set_Input;
}>;


export type RegistrationRequestUpdateManyMutation = { __typename?: 'mutation_root', update_registration_request?: { __typename?: 'registration_request_mutation_response', returning: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> } | null };

export type RegistrationRequestDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestDeleteOneMutation = { __typename?: 'mutation_root', delete_registration_request_by_pk?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null };

export type RegistrationRequestDeleteManyMutationVariables = Exact<{
  where: Registration_Request_Bool_Exp;
}>;


export type RegistrationRequestDeleteManyMutation = { __typename?: 'mutation_root', delete_registration_request?: { __typename?: 'registration_request_mutation_response', affected_rows: number } | null };

export type RegistrationRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestGetByIdQuery = { __typename?: 'query_root', registration_request_by_pk?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null };

export type RegistrationRequestGetOneUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestGetOneUserQuery = { __typename?: 'query_root', registration_request_by_pk?: { __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, gdrive_folder_id?: string | null, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, brand_protection: boolean, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, application?: { __typename?: 'application', registration_entity_id?: string | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, invoice?: { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null } | null, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> } | null };

export type RegistrationRequestGetOneForDraftingQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestGetOneForDraftingQuery = { __typename?: 'query_root', registration_request_by_pk?: { __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademarks: Array<{ __typename?: 'trademark', jurisdiction: string }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> } | null };

export type RegistrationRequestUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestUserQuery = { __typename?: 'query_root', registration_request_by_pk?: { __typename?: 'registration_request', user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } } | null };

export type RegistrationRequestGetOneForReportViolationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RegistrationRequestGetOneForReportViolationQuery = { __typename?: 'query_root', registration_request_by_pk?: { __typename?: 'registration_request', id: string, type: string, value: string, report_violation_url?: string | null, document_hub_id: string, application_id?: string | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademarks: Array<{ __typename?: 'trademark', jurisdiction: string, id: string, status: string, number?: string | null, filing_date?: string | null }> } | null };

export type RegistrationRequestGetManyQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type RegistrationRequestGetManyUserAggregateQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyUserAggregateQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, gdrive_folder_id?: string | null, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, brand_protection: boolean, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, application?: { __typename?: 'application', registration_entity_id?: string | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, invoice?: { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null } | null, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestGetManyLastStatusUpdateQueryVariables = Exact<{
  filter: Registration_Request_Bool_Exp;
}>;


export type RegistrationRequestGetManyLastStatusUpdateQuery = { __typename?: 'query_root', registration_request: Array<{ __typename?: 'registration_request', id: string, last_status_update: string }> };

export type RegistrationRequestGetManyCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationRequestGetManyCountriesQuery = { __typename?: 'query_root', registration_request: Array<{ __typename?: 'registration_request', jurisdictions: any }> };

export type RegistrationRequestCountQueryVariables = Exact<{
  filter?: InputMaybe<Registration_Request_Bool_Exp>;
}>;


export type RegistrationRequestCountQuery = { __typename?: 'query_root', registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestCountByUserQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type RegistrationRequestCountByUserQuery = { __typename?: 'query_root', unpaid: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null }, paid: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestsVerifiedWithoutResultViewQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type RegistrationRequestsVerifiedWithoutResultViewQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type ApprovedRegistrationRequestsWithResultViewQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type ApprovedRegistrationRequestsWithResultViewQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type DismissedRegistrationRequestsWithResultViewQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type DismissedRegistrationRequestsWithResultViewQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type GetRegistrationRequestsWithOrderCreatedQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type GetRegistrationRequestsWithOrderCreatedQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type GetRegistrationRequestsStartedWithoutOrderCreatedQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
}>;


export type GetRegistrationRequestsStartedWithoutOrderCreatedQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, user_id: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, discount_coupon_id?: string | null, gdrive_folder_id?: string | null, lawyer_services_help_required?: boolean | null, services: any, status: string, updated_at: string, type: string, value: string, client_business_description: string, client_websites?: any | null, jurisdictions: any, language: string, status_group: string, ordered_items?: any | null, euipo_grant_requested: boolean, region: string, country?: string | null, marketing_emails_force_disabled: boolean, send_drafting_reminders: boolean, mark_alias?: string | null, billing_entity_id?: string | null, product_id: string, document_hub_id: string, note_hub_id: string, use_in_commerce?: boolean | null, invoice_issued_in_US?: boolean | null, service_type: string, application_id?: string | null, last_status_update: string, e2e_protection: boolean, client_note?: string | null, assigned_admin_id?: string | null, brand_id?: string | null, origin_trademark_id?: string | null, brand_protection: boolean, ai_business_description?: string | null, ai_classes: any, initial_ai_analysis_task_id?: string | null, ai_pipeline_task_id?: string | null, is_amazon_seller: boolean, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, application?: { __typename?: 'application', id: string, registration_entity_id?: string | null, onboarding_finished: boolean, client_approval: boolean, priority_filing_visible: boolean, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, mailing_address_id?: number | null, domicile_address_id?: number | null, domicile_address_visible: boolean, document_types: any, document_types_modified: boolean, poa_metadata: any, ai_extracted_data: any, ai_analysis_task_id?: string | null, ai_domicile_address_verdict?: string | null, ai_reasoning: any, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }>, mailing_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null, domicile_address?: { __typename?: 'address', id: number, street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> }> };

export type ContactsRegistrationRequestTrackingQueryVariables = Exact<{
  trackingActionName: Scalars['String']['input'];
  trackingCreatedSince: Scalars['timestamptz']['input'];
}>;


export type ContactsRegistrationRequestTrackingQuery = { __typename?: 'query_root', registration_request: Array<{ __typename?: 'registration_request', contact_email: string }> };

export type RegistrationRequestGetManyForUserQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyForUserQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, gdrive_folder_id?: string | null, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, brand_protection: boolean, discount_coupon?: { __typename?: 'discount_coupon', id: string, lawyer_fees_discount: number, fees_discount: number, discount_type: string, recurring: boolean, is_active: boolean, monitoring_upsell: boolean, scope: any, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null } | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, application?: { __typename?: 'application', registration_entity_id?: string | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, logo_document: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, invoice?: { __typename?: 'invoice', serial_number?: number | null, year: number, variable_symbol: string, created_at: string, payment_date?: string | null, payment_type?: string | null, revolut_public_order_id?: string | null } | null, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type UserUnseenVerificationCountQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  last_status_update_since?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type UserUnseenVerificationCountQuery = { __typename?: 'query_root', user_unseen_verification_count: Array<{ __typename?: 'aggregate_count', count: number }> };

export type RegistrationRequestGetManyForUserTrademarksQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyForUserTrademarksQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestGetManyForUserDraftsQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyForUserDraftsQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestGetManyForUserOrdersQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyForUserOrdersQuery = { __typename?: 'query_root', registration_request: Array<{ __typename: 'registration_request', id: string, public_id: string, product_id: string, value: string, type: string, contact_email: string, contact_first_name: string, contact_last_name: string, contact_phone: string, created_at: string, currency: string, jurisdictions: any, lawyer_services_help_required?: boolean | null, services: any, client_business_description: string, client_websites?: any | null, client_note?: string | null, mark_alias?: string | null, document_hub_id: string, status: string, last_status_update: string, ordered_items?: any | null, user_id: string, service_type: string, e2e_protection: boolean, brand_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', created_at: string, name: string }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }> }>, verification_results: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type VerificationSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  jurisdictions: Scalars['String']['input'];
  since: Scalars['date']['input'];
  classes?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerificationSearchQuery = { __typename?: 'query_root', verification_search: Array<{ __typename?: 'verification_search_result', id: string, name: string, type: string, jurisdictions: string, classes?: string | null, status: string, created_at: string, last_status_update: string, fts_score: number, trigram_score: number, metaphone_score: number, dmetaphone_score: number, levenshtein_score: number, score: number }> };

export type RecentApplicationsSentToClientQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  registration_request_id: Scalars['uuid']['input'];
  order_by?: InputMaybe<Array<Recent_Applications_Sent_To_Client_Order_By> | Recent_Applications_Sent_To_Client_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentApplicationsSentToClientQuery = { __typename?: 'query_root', recent_applications_sent_to_client: Array<{ __typename?: 'recent_applications_sent_to_client', id: string, priority_filing_visible?: boolean | null, priority_filing_jurisdiction?: string | null, priority_filing_number?: string | null, priority_filing_date?: string | null, domicile_address_visible: boolean, registration_entity?: any | null, domicile_address?: any | null, registration_request?: any | null, first_sent_to_client_at: string }> };

export type RegistrationRequestRecentlyDismissedQueryVariables = Exact<{
  order_by?: InputMaybe<Array<Registration_Request_Recently_Dismissed_Order_By> | Registration_Request_Recently_Dismissed_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestRecentlyDismissedQuery = { __typename?: 'query_root', registration_request_recently_dismissed: Array<{ __typename?: 'registration_request_recently_dismissed', id: string, type: string, value: string, jurisdictions: any, last_status_update: string, contact_first_name: string, contact_last_name: string, user?: any | null, verification_result: any, notes: any, assigned_admin?: any | null }> };

export type RegistrationRequestRecentlyDismissedCountQueryVariables = Exact<{ [key: string]: never; }>;


export type RegistrationRequestRecentlyDismissedCountQuery = { __typename?: 'query_root', registration_request_recently_dismissed_count: Array<{ __typename?: 'aggregate_count', count: number }> };

export type RegistrationRequestGetManyForUserDashboardQueryVariables = Exact<{
  filter?: Registration_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Registration_Request_Order_By> | Registration_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RegistrationRequestGetManyForUserDashboardQuery = { __typename?: 'query_root', registration_request: Array<{ __typename?: 'registration_request', id: string, product_id: string, value: string, type: string, created_at: string, jurisdictions: any, document_hub_id: string, status: string, last_status_update: string, user_id: string, tracking_actions: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }>, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> }>, registration_request_aggregate: { __typename?: 'registration_request_aggregate', aggregate?: { __typename?: 'registration_request_aggregate_fields', count: number } | null } };

export type RegistrationRequestTrackingFragment = { __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null };

export type RegistrationRequestTrackingWithStatusFragment = { __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null, tracking_status: { __typename?: 'registration_request_tracking_status', is_status: boolean } };

export type RegistrationRequestTrackingInsertOneMutationVariables = Exact<{
  object: Registration_Request_Tracking_Insert_Input;
}>;


export type RegistrationRequestTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_registration_request_tracking_one?: { __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null } | null };

export type RegistrationRequestTrackingInsertManyMutationVariables = Exact<{
  objects: Array<Registration_Request_Tracking_Insert_Input> | Registration_Request_Tracking_Insert_Input;
}>;


export type RegistrationRequestTrackingInsertManyMutation = { __typename?: 'mutation_root', insert_registration_request_tracking?: { __typename?: 'registration_request_tracking_mutation_response', returning: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }> } | null };

export type RegistrationRequestTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RegistrationRequestTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_registration_request_tracking_by_pk?: { __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null } | null };

export type RegistrationRequestTrackingDeleteManyMutationVariables = Exact<{
  registrationRequestId: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
}>;


export type RegistrationRequestTrackingDeleteManyMutation = { __typename?: 'mutation_root', delete_registration_request_tracking?: { __typename?: 'registration_request_tracking_mutation_response', affected_rows: number } | null };

export type RegistrationRequestTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By> | Registration_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column> | Registration_Request_Tracking_Select_Column>;
}>;


export type RegistrationRequestTrackingGetManyQuery = { __typename?: 'query_root', registration_request_tracking: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null }> };

export type RegistrationRequestTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Registration_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Registration_Request_Tracking_Order_By> | Registration_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Registration_Request_Tracking_Select_Column> | Registration_Request_Tracking_Select_Column>;
}>;


export type RegistrationRequestTrackingWithStatusGetManyQuery = { __typename?: 'query_root', registration_request_tracking: Array<{ __typename?: 'registration_request_tracking', id: number, created_at: string, name: string, registration_request_id: string, skipped: boolean, user_id?: string | null, tracking_status: { __typename?: 'registration_request_tracking_status', is_status: boolean } }> };

export type ReminderFragment = { __typename: 'reminder', id: string, user_id: string, trigger_at: string, triggered_at?: string | null, status: string, notes?: string | null, resource_name?: string | null, resource_id?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted_by_user_id?: string | null };

export type ReminderInsertOneMutationVariables = Exact<{
  object: Reminder_Insert_Input;
}>;


export type ReminderInsertOneMutation = { __typename?: 'mutation_root', insert_reminder_one?: { __typename: 'reminder', id: string, user_id: string, trigger_at: string, triggered_at?: string | null, status: string, notes?: string | null, resource_name?: string | null, resource_id?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted_by_user_id?: string | null } | null };

export type ReminderUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Reminder_Set_Input;
}>;


export type ReminderUpdateOneMutation = { __typename?: 'mutation_root', update_reminder_by_pk?: { __typename: 'reminder', id: string, user_id: string, trigger_at: string, triggered_at?: string | null, status: string, notes?: string | null, resource_name?: string | null, resource_id?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted_by_user_id?: string | null } | null };

export type ReminderGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ReminderGetByIdQuery = { __typename?: 'query_root', reminder_by_pk?: { __typename: 'reminder', id: string, user_id: string, trigger_at: string, triggered_at?: string | null, status: string, notes?: string | null, resource_name?: string | null, resource_id?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted_by_user_id?: string | null } | null };

export type ReminderGetManyQueryVariables = Exact<{
  where: Reminder_Bool_Exp;
  order_by?: InputMaybe<Array<Reminder_Order_By> | Reminder_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Reminder_Select_Column> | Reminder_Select_Column>;
}>;


export type ReminderGetManyQuery = { __typename?: 'query_root', reminder: Array<{ __typename: 'reminder', id: string, user_id: string, trigger_at: string, triggered_at?: string | null, status: string, notes?: string | null, resource_name?: string | null, resource_id?: string | null, created_at: string, updated_at: string, deleted_at?: string | null, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted_by_user_id?: string | null }> };

export type ReminderCountQueryVariables = Exact<{
  filter?: InputMaybe<Reminder_Bool_Exp>;
}>;


export type ReminderCountQuery = { __typename?: 'query_root', reminder_aggregate: { __typename?: 'reminder_aggregate', aggregate?: { __typename?: 'reminder_aggregate_fields', count: number } | null } };

export type ServiceFragment = { __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string };

export type ServiceInsertOneMutationVariables = Exact<{
  object: Service_Insert_Input;
}>;


export type ServiceInsertOneMutation = { __typename?: 'mutation_root', insert_service_one?: { __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string } | null };

export type ServiceInsertManyMutationVariables = Exact<{
  objects: Array<Service_Insert_Input> | Service_Insert_Input;
}>;


export type ServiceInsertManyMutation = { __typename?: 'mutation_root', insert_service?: { __typename?: 'service_mutation_response', returning: Array<{ __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string }> } | null };

export type ServiceUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Service_Set_Input;
}>;


export type ServiceUpdateOneMutation = { __typename?: 'mutation_root', update_service_by_pk?: { __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string } | null };

export type ServiceGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ServiceGetByIdQuery = { __typename?: 'query_root', service_by_pk?: { __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string } | null };

export type ServiceGetManyQueryVariables = Exact<{
  where: Service_Bool_Exp;
  order_by?: InputMaybe<Array<Service_Order_By> | Service_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Service_Select_Column> | Service_Select_Column>;
}>;


export type ServiceGetManyQuery = { __typename?: 'query_root', service: Array<{ __typename: 'service', id: string, type: string, service_request_id?: string | null, case_solution_id?: string | null, assigned_admin_id?: string | null, deadline?: string | null, status: string, outcome?: string | null, outcome_note?: string | null, parameters: any, note_hub_id: string, document_hub_id: string, last_status_update: string, last_tracking_update: string, created_by_user_id: string, updated_by_user_id: string, created_at: string, updated_at: string }> };

export type ServiceRequestFragment = { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> };

export type ServiceRequestUserFragment = { __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type ServiceRequestWithTrademarksFragment = { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, trademark_service_requests: Array<{ __typename?: 'trademark_service_requests', trademark_id: string, service_request_id: string, trademark?: { __typename?: 'trademark', id: string, jurisdiction: string, type: string, name?: string | null, number?: string | null, status: string, document_hub_id: string, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }>, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> };

export type ServiceRequestInsertOneMutationVariables = Exact<{
  object: Service_Request_Insert_Input;
}>;


export type ServiceRequestInsertOneMutation = { __typename?: 'mutation_root', insert_service_request_one?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null };

export type ServiceRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Service_Request_Set_Input;
}>;


export type ServiceRequestUpdateOneMutation = { __typename?: 'mutation_root', update_service_request_by_pk?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null };

export type ServiceRequestDeleteManyMutationVariables = Exact<{
  where: Service_Request_Bool_Exp;
}>;


export type ServiceRequestDeleteManyMutation = { __typename?: 'mutation_root', delete_service_request?: { __typename?: 'service_request_mutation_response', affected_rows: number } | null };

export type ServiceRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ServiceRequestGetByIdQuery = { __typename?: 'query_root', service_request_by_pk?: { __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null };

export type ServiceRequestGetManyQueryVariables = Exact<{
  filter?: Service_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Service_Request_Order_By> | Service_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServiceRequestGetManyQuery = { __typename?: 'query_root', service_request: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }> };

export type ServiceRequestGetOneForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ServiceRequestGetOneForUserQuery = { __typename?: 'query_root', service_request_by_pk?: { __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type ServiceRequestGetManyForUserQueryVariables = Exact<{
  filter?: Service_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Service_Request_Order_By> | Service_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServiceRequestGetManyForUserQuery = { __typename?: 'query_root', service_request: Array<{ __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }>, service_request_aggregate: { __typename?: 'service_request_aggregate', aggregate?: { __typename?: 'service_request_aggregate_fields', count: number } | null } };

export type ServiceRequestCountQueryVariables = Exact<{
  filter?: Service_Request_Bool_Exp;
}>;


export type ServiceRequestCountQuery = { __typename?: 'query_root', service_request_aggregate: { __typename?: 'service_request_aggregate', aggregate?: { __typename?: 'service_request_aggregate_fields', count: number } | null } };

export type ServiceRequestGetManyWithTrademarksQueryVariables = Exact<{
  filter?: Service_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Service_Request_Order_By> | Service_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ServiceRequestGetManyWithTrademarksQuery = { __typename?: 'query_root', service_request: Array<{ __typename: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, asana_task_url?: string | null, parameters: any, language?: string | null, region: string, status: string, invoice_content: any, currency: string, billing_entity_id?: string | null, document_hub_id: string, user_id: string, created_at: string, updated_at: string, order_hub_id?: string | null, quote_hub_id: string, quote_version: number, note_hub_id: string, assigned_admin_id?: string | null, brand_id?: string | null, registration_request_id?: string | null, last_status_update: string, last_tracking_update: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, discount_coupon_id?: string | null, trademark_service_requests: Array<{ __typename?: 'trademark_service_requests', trademark_id: string, service_request_id: string, trademark?: { __typename?: 'trademark', id: string, jurisdiction: string, type: string, name?: string | null, number?: string | null, status: string, document_hub_id: string, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }>, user: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> }> };

export type ServiceRequestTrackingFragment = { __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean };

export type ServiceRequestTrackingInsertOneMutationVariables = Exact<{
  object: Service_Request_Tracking_Insert_Input;
}>;


export type ServiceRequestTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_service_request_tracking_one?: { __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean } | null };

export type ServiceRequestTrackingInsertManyMutationVariables = Exact<{
  objects: Array<Service_Request_Tracking_Insert_Input> | Service_Request_Tracking_Insert_Input;
}>;


export type ServiceRequestTrackingInsertManyMutation = { __typename?: 'mutation_root', insert_service_request_tracking?: { __typename?: 'service_request_tracking_mutation_response', returning: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> } | null };

export type ServiceRequestTrackingGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Service_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Service_Request_Tracking_Order_By> | Service_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Service_Request_Tracking_Select_Column> | Service_Request_Tracking_Select_Column>;
}>;


export type ServiceRequestTrackingGetManyQuery = { __typename?: 'query_root', service_request_tracking: Array<{ __typename?: 'service_request_tracking', id: string, created_at: string, name: string, service_request_id: string, skipped: boolean }> };

export type ServiceTrackingFragment = { __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string };

export type ServiceTrackingWithStatusFragment = { __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string, tracking_status: { __typename?: 'service_tracking_status', is_status: boolean } };

export type ServiceTrackingInsertOneMutationVariables = Exact<{
  object: Service_Tracking_Insert_Input;
}>;


export type ServiceTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_service_tracking_one?: { __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string } | null };

export type ServiceTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ServiceTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_service_tracking_by_pk?: { __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string } | null };

export type ServiceTrackingGetManyQueryVariables = Exact<{
  where: Service_Tracking_Bool_Exp;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By> | Service_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column> | Service_Tracking_Select_Column>;
}>;


export type ServiceTrackingGetManyQuery = { __typename?: 'query_root', service_tracking: Array<{ __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string }> };

export type ServiceTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Service_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Service_Tracking_Order_By> | Service_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Service_Tracking_Select_Column> | Service_Tracking_Select_Column>;
}>;


export type ServiceTrackingWithStatusGetManyQuery = { __typename?: 'query_root', service_tracking: Array<{ __typename: 'service_tracking', id: number, service_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string, tracking_status: { __typename?: 'service_tracking_status', is_status: boolean } }> };

export type SimilarTrademarkFragment = { __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null };

export type SpecimenFragment = { __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } };

export type SpecimenInsertOneMutationVariables = Exact<{
  object: Specimen_Insert_Input;
}>;


export type SpecimenInsertOneMutation = { __typename?: 'mutation_root', insert_specimen_one?: { __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } } | null };

export type SpecimenUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Specimen_Set_Input;
}>;


export type SpecimenUpdateOneMutation = { __typename?: 'mutation_root', update_specimen_by_pk?: { __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } } | null };

export type SpecimenDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SpecimenDeleteOneMutation = { __typename?: 'mutation_root', delete_specimen_by_pk?: { __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } } | null };

export type SpecimenGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SpecimenGetByIdQuery = { __typename?: 'query_root', specimen_by_pk?: { __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } } | null };

export type SpecimenGetManyQueryVariables = Exact<{
  where: Specimen_Bool_Exp;
  order_by?: InputMaybe<Array<Specimen_Order_By> | Specimen_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SpecimenGetManyQuery = { __typename?: 'query_root', specimen: Array<{ __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> };

export type StatisticFragment = { __typename?: 'statistic', id: number, name: string, value: number, created_at: string };

export type StatisticInsertOneMutationVariables = Exact<{
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
}>;


export type StatisticInsertOneMutation = { __typename?: 'mutation_root', insert_statistic_one?: { __typename?: 'statistic', id: number, name: string, value: number, created_at: string } | null };

export type StatisticGetManyDistinctQueryVariables = Exact<{ [key: string]: never; }>;


export type StatisticGetManyDistinctQuery = { __typename?: 'query_root', statistic: Array<{ __typename?: 'statistic', id: number, name: string, value: number, created_at: string }> };

export type SupportTicketFragment = { __typename: 'support_ticket', id: number, created_at: string, updated_at: string, resolved_at?: string | null, assigned_admin_id?: string | null, description: string, resolution?: string | null, resource_name: string, resource_id: string, category?: string | null, status: string, note_hub_id: string, document_hub_id: string, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, created_by_user?: { __typename?: 'user', email: string } | null };

export type SupportTicketInsertOneMutationVariables = Exact<{
  object: Support_Ticket_Insert_Input;
}>;


export type SupportTicketInsertOneMutation = { __typename?: 'mutation_root', insert_support_ticket_one?: { __typename: 'support_ticket', id: number, created_at: string, updated_at: string, resolved_at?: string | null, assigned_admin_id?: string | null, description: string, resolution?: string | null, resource_name: string, resource_id: string, category?: string | null, status: string, note_hub_id: string, document_hub_id: string, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, created_by_user?: { __typename?: 'user', email: string } | null } | null };

export type SupportTicketUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  changes: Support_Ticket_Set_Input;
}>;


export type SupportTicketUpdateOneMutation = { __typename?: 'mutation_root', update_support_ticket_by_pk?: { __typename: 'support_ticket', id: number, created_at: string, updated_at: string, resolved_at?: string | null, assigned_admin_id?: string | null, description: string, resolution?: string | null, resource_name: string, resource_id: string, category?: string | null, status: string, note_hub_id: string, document_hub_id: string, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, created_by_user?: { __typename?: 'user', email: string } | null } | null };

export type SupportTicketByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SupportTicketByIdQuery = { __typename?: 'query_root', support_ticket_by_pk?: { __typename: 'support_ticket', id: number, created_at: string, updated_at: string, resolved_at?: string | null, assigned_admin_id?: string | null, description: string, resolution?: string | null, resource_name: string, resource_id: string, category?: string | null, status: string, note_hub_id: string, document_hub_id: string, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, created_by_user?: { __typename?: 'user', email: string } | null } | null };

export type SupportTicketGetManyQueryVariables = Exact<{
  filter?: Support_Ticket_Bool_Exp;
  order_by?: InputMaybe<Array<Support_Ticket_Order_By> | Support_Ticket_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Support_Ticket_Select_Column> | Support_Ticket_Select_Column>;
}>;


export type SupportTicketGetManyQuery = { __typename?: 'query_root', support_ticket: Array<{ __typename: 'support_ticket', id: number, created_at: string, updated_at: string, resolved_at?: string | null, assigned_admin_id?: string | null, description: string, resolution?: string | null, resource_name: string, resource_id: string, category?: string | null, status: string, note_hub_id: string, document_hub_id: string, assigned_admin?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null, created_by_user?: { __typename?: 'user', email: string } | null }>, support_ticket_aggregate: { __typename?: 'support_ticket_aggregate', aggregate?: { __typename?: 'support_ticket_aggregate_fields', count: number } | null } };

export type TaskFragment = { __typename?: 'task', id: string, type: string, data: any, status: string, execution_time: number, created_at: string, updated_at: string, options?: any | null, result?: any | null };

export type TaskInsertOneMutationVariables = Exact<{
  object: Task_Insert_Input;
}>;


export type TaskInsertOneMutation = { __typename?: 'mutation_root', insert_task_one?: { __typename?: 'task', id: string, type: string, data: any, status: string, execution_time: number, created_at: string, updated_at: string, options?: any | null, result?: any | null } | null };

export type TaskUpdateOneMutationVariables = Exact<{
  id: Scalars['String']['input'];
  _set: Task_Set_Input;
}>;


export type TaskUpdateOneMutation = { __typename?: 'mutation_root', update_task_by_pk?: { __typename?: 'task', id: string, type: string, data: any, status: string, execution_time: number, created_at: string, updated_at: string, options?: any | null, result?: any | null } | null };

export type TaskGetByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TaskGetByIdQuery = { __typename?: 'query_root', task_by_pk?: { __typename?: 'task', id: string, type: string, data: any, status: string, execution_time: number, created_at: string, updated_at: string, options?: any | null, result?: any | null } | null };

export type TaskCountQueryVariables = Exact<{
  filter?: InputMaybe<Task_Bool_Exp>;
}>;


export type TaskCountQuery = { __typename?: 'query_root', task_aggregate: { __typename?: 'task_aggregate', aggregate?: { __typename?: 'task_aggregate_fields', count: number } | null } };

export type ThreadCommentFragment = { __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null };

export type ThreadCommentInsertOneMutationVariables = Exact<{
  object: Thread_Comment_Insert_Input;
}>;


export type ThreadCommentInsertOneMutation = { __typename?: 'mutation_root', insert_thread_comment_one?: { __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null } | null };

export type ThreadCommentUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Thread_Comment_Set_Input;
}>;


export type ThreadCommentUpdateOneMutation = { __typename?: 'mutation_root', update_thread_comment_by_pk?: { __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null } | null };

export type ThreadCommentGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Thread_Comment_Bool_Exp>;
  order_by?: InputMaybe<Array<Thread_Comment_Order_By> | Thread_Comment_Order_By>;
}>;


export type ThreadCommentGetManyQuery = { __typename?: 'query_root', thread_comment: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }> };

export type ThreadCommentGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ThreadCommentGetByIdQuery = { __typename?: 'query_root', thread_comment_by_pk?: { __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null } | null };

export type TrademarkFragment = { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> };

export type TrademarkDetailFragment = { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> };

export type TrademarkForUserFragment = { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> };

export type CustomerPortalTrademarkDetailFragment = { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_request?: { __typename?: 'trademark_request', id: string, mark_alias: string, status?: string | null } | null, registration_request?: { __typename?: 'registration_request', id: string, client_websites?: any | null, client_business_description: string } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, type: string, service_request_id?: string | null }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> };

export type TrademarkOwnPropertiesFragment = { __typename?: 'trademark', id: string, jurisdiction: string, number?: string | null, registration_number?: string | null, international_number?: string | null, status: string, name?: string | null, ipo_link?: string | null, filing_date?: string | null, registration_date?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, type: string, additional_info: any, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type TrademarkForUserDashboardFragment = { __typename?: 'trademark', id: string, type: string, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, created_at: string, status: string, dou_deadline_date?: string | null, user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null };

export type TrademarkInsertManyMutationVariables = Exact<{
  objects: Array<Trademark_Insert_Input> | Trademark_Insert_Input;
}>;


export type TrademarkInsertManyMutation = { __typename?: 'mutation_root', insert_trademark?: { __typename?: 'trademark_mutation_response', returning: Array<{ __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }> } | null };

export type TrademarkInsertOneMutationVariables = Exact<{
  object: Trademark_Insert_Input;
}>;


export type TrademarkInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_one?: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> } | null };

export type TrademarkUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Trademark_Set_Input;
}>;


export type TrademarkUpdateOneMutation = { __typename?: 'mutation_root', update_trademark_by_pk?: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> } | null };

export type TrademarkUpdateOneForUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Trademark_Set_Input;
}>;


export type TrademarkUpdateOneForUserMutation = { __typename?: 'mutation_root', update_trademark_by_pk?: { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> } | null };

export type TrademarkUpdateManyMutationVariables = Exact<{
  where: Trademark_Bool_Exp;
  set: Trademark_Set_Input;
}>;


export type TrademarkUpdateManyMutation = { __typename?: 'mutation_root', update_trademark?: { __typename?: 'trademark_mutation_response', returning: Array<{ __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }> } | null };

export type TrademarkDeleteManyMutationVariables = Exact<{
  where: Trademark_Bool_Exp;
}>;


export type TrademarkDeleteManyMutation = { __typename?: 'mutation_root', delete_trademark?: { __typename?: 'trademark_mutation_response', affected_rows: number } | null };

export type TrademarkGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkGetByIdQuery = { __typename?: 'query_root', trademark_by_pk?: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> } | null };

export type TrademarkGetByIdForUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkGetByIdForUserQuery = { __typename?: 'query_root', trademark_by_pk?: { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_request?: { __typename?: 'trademark_request', id: string, mark_alias: string, status?: string | null } | null, registration_request?: { __typename?: 'registration_request', id: string, client_websites?: any | null, client_business_description: string } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, type: string, service_request_id?: string | null }>, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> } | null };

export type TrademarkGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyQuery = { __typename?: 'query_root', trademark: Array<{ __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }> };

export type TrademarkGetManyOwnPropertiesQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyOwnPropertiesQuery = { __typename?: 'query_root', trademark: Array<{ __typename?: 'trademark', id: string, jurisdiction: string, number?: string | null, registration_number?: string | null, international_number?: string | null, status: string, name?: string | null, ipo_link?: string | null, filing_date?: string | null, registration_date?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, type: string, additional_info: any, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, phone?: string | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }> };

export type TrademarkCountQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
}>;


export type TrademarkCountQuery = { __typename?: 'query_root', trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null } };

export type TrademarkGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyForUserQuery = { __typename?: 'query_root', trademark: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }>, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null } };

export type TrademarkSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  jurisdictions: Scalars['String']['input'];
  classes?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrademarkSearchQuery = { __typename?: 'query_root', trademark_search: Array<{ __typename?: 'trademark_search_result', id: string, name: string, number?: string | null, type: string, jurisdiction: string, classes?: string | null, status: string, created_at: string, last_tracking_update: string, fts_score: number, trigram_score: number, metaphone_score: number, dmetaphone_score: number, levenshtein_score: number, score: number }> };

export type TrademarkPortfolioSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type TrademarkPortfolioSearchQuery = { __typename?: 'query_root', trademark_portfolio_search: Array<{ __typename?: 'trademark_portfolio_search_result', id: string, name: string, number?: string | null, type: string, jurisdiction: string, status: string, filing_date?: string | null, registration_date?: string | null, fts_score: number, trigram_score: number, metaphone_score: number, dmetaphone_score: number, levenshtein_score: number, score: number }> };

export type TrademarkPortfolioSearchCountQueryVariables = Exact<{
  query: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type TrademarkPortfolioSearchCountQuery = { __typename?: 'query_root', trademark_portfolio_search_count: Array<{ __typename?: 'aggregate_count', count: number }> };

export type TrademarkGetManyWithRepresentativeQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyWithRepresentativeQuery = { __typename?: 'query_root', trademark: Array<{ __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }> };

export type TrademarkGetPartnersFilingsQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetPartnersFilingsQuery = { __typename?: 'query_root', trademark: Array<{ __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, registration_request?: { __typename?: 'registration_request', public_id: string, invoice?: { __typename?: 'invoice', document_context: any } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }>, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null } };

export type TrademarkGetManyIdsQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyIdsQuery = { __typename?: 'query_root', trademark: Array<{ __typename?: 'trademark', id: string }> };

export type TrademarkGetManyForUserDashboardQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  office_actions_filter?: InputMaybe<Office_Action_Bool_Exp>;
  use_in_commerce_requests_filter?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Order_By> | Trademark_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkGetManyForUserDashboardQuery = { __typename?: 'query_root', trademark: Array<{ __typename?: 'trademark', id: string, type: string, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, created_at: string, status: string, dou_deadline_date?: string | null, user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, office_actions: Array<{ __typename?: 'office_action', id: string, due_date?: string | null, status: string, client_input?: string | null, nature_of_issues?: string | null, issues_version: number, solutions: Array<{ __typename?: 'office_action_solution', id: string, solution: string, service_request_id?: string | null }>, tracking_actions: Array<{ __typename?: 'office_action_tracking', id: number, created_at: string, name: string, office_action_id: string }> }>, use_in_commerce_requests: Array<{ __typename?: 'use_in_commerce_request', id: string, status: string, type: any, kickoff_type?: string | null, due_date: string, grace_period_deadline?: string | null }> }>, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null } };

export type TrademarkClassFragment = { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null };

export type TrademarkClassForUserFragment = { __typename?: 'trademark_class', class_number: string, class_items: any };

export type TrademarkClassWithSpecimensFragment = { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null, specimens: Array<{ __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> };

export type TrademarkClassInsertOneMutationVariables = Exact<{
  object: Trademark_Class_Insert_Input;
}>;


export type TrademarkClassInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_class_one?: { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null } | null };

export type TrademarkClassInsertManyMutationVariables = Exact<{
  objects: Array<Trademark_Class_Insert_Input> | Trademark_Class_Insert_Input;
}>;


export type TrademarkClassInsertManyMutation = { __typename?: 'mutation_root', insert_trademark_class?: { __typename?: 'trademark_class_mutation_response', returning: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> } | null };

export type TrademarkClassUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Trademark_Class_Set_Input>;
}>;


export type TrademarkClassUpdateOneMutation = { __typename?: 'mutation_root', update_trademark_class_by_pk?: { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null } | null };

export type TrademarkClassUpdateManyMutationVariables = Exact<{
  where: Trademark_Class_Bool_Exp;
  changes?: InputMaybe<Trademark_Class_Set_Input>;
}>;


export type TrademarkClassUpdateManyMutation = { __typename?: 'mutation_root', update_trademark_class?: { __typename?: 'trademark_class_mutation_response', affected_rows: number } | null };

export type TrademarkClassDeleteOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkClassDeleteOneMutation = { __typename?: 'mutation_root', delete_trademark_class_by_pk?: { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null } | null };

export type TrademarkClassDeleteManyMutationVariables = Exact<{
  where: Trademark_Class_Bool_Exp;
}>;


export type TrademarkClassDeleteManyMutation = { __typename?: 'mutation_root', delete_trademark_class?: { __typename?: 'trademark_class_mutation_response', affected_rows: number } | null };

export type TrademarkClassGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkClassGetByIdQuery = { __typename?: 'query_root', trademark_class_by_pk?: { __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null } | null };

export type TrademarkClassGetManyQueryVariables = Exact<{
  where: Trademark_Class_Bool_Exp;
  order_by?: InputMaybe<Array<Trademark_Class_Order_By> | Trademark_Class_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Trademark_Class_Select_Column> | Trademark_Class_Select_Column>;
}>;


export type TrademarkClassGetManyQuery = { __typename?: 'query_root', trademark_class: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> };

export type TrademarkIpoDataFragment = { __typename?: 'trademark_ipo_data', number: string, jurisdiction: string, updated_at: string, data: any, source: string, status?: string | null, next_sync_due_at: string, status_change_date?: string | null, trademark_id?: string | null };

export type TrademarkIpoDataUpsertOneMutationVariables = Exact<{
  object: Trademark_Ipo_Data_Insert_Input;
}>;


export type TrademarkIpoDataUpsertOneMutation = { __typename?: 'mutation_root', insert_trademark_ipo_data_one?: { __typename?: 'trademark_ipo_data', number: string, jurisdiction: string, updated_at: string, data: any, source: string, status?: string | null, next_sync_due_at: string, status_change_date?: string | null, trademark_id?: string | null } | null };

export type TrademarkIpoDataGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Ipo_Data_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Ipo_Data_Order_By> | Trademark_Ipo_Data_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkIpoDataGetManyQuery = { __typename?: 'query_root', trademark_ipo_data: Array<{ __typename?: 'trademark_ipo_data', number: string, jurisdiction: string, updated_at: string, data: any, source: string, status?: string | null, next_sync_due_at: string, status_change_date?: string | null, trademark_id?: string | null }> };

export type TrademarkMonitoringResultCommonDataFragment = { __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null };

export type TrademarkMonitoringResultFragment = { __typename?: 'trademark_monitoring_result', document_hub_id: string, id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> };

export type TrademarkMonitoringResultUserFragment = { __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, trademark: { __typename?: 'trademark', user_id?: string | null, user?: { __typename?: 'user', email: string } | null } };

export type TrademarkMonitoringResultForUserFragment = { __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, trademark: { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }> };

export type TrademarkMonitoringResultInsertOneMutationVariables = Exact<{
  object: Trademark_Monitoring_Result_Insert_Input;
}>;


export type TrademarkMonitoringResultInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_monitoring_result_one?: { __typename?: 'trademark_monitoring_result', document_hub_id: string, id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> } | null };

export type TrademarkMonitoringResultUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Trademark_Monitoring_Result_Set_Input;
}>;


export type TrademarkMonitoringResultUpdateOneMutation = { __typename?: 'mutation_root', update_trademark_monitoring_result_by_pk?: { __typename?: 'trademark_monitoring_result', document_hub_id: string, id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> } | null };

export type TrademarkMonitoringResultGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkMonitoringResultGetByIdQuery = { __typename?: 'query_root', trademark_monitoring_result_by_pk?: { __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, trademark: { __typename?: 'trademark', user_id?: string | null, user?: { __typename?: 'user', email: string } | null } } | null };

export type TrademarkMonitoringResultGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By> | Trademark_Monitoring_Result_Order_By>;
}>;


export type TrademarkMonitoringResultGetManyQuery = { __typename?: 'query_root', trademark_monitoring_result: Array<{ __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, trademark: { __typename?: 'trademark', user_id?: string | null, user?: { __typename?: 'user', email: string } | null } }> };

export type TrademarkMonitoringResultGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Monitoring_Result_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Monitoring_Result_Order_By> | Trademark_Monitoring_Result_Order_By>;
}>;


export type TrademarkMonitoringResultGetManyForUserQuery = { __typename?: 'query_root', trademark_monitoring_result: Array<{ __typename?: 'trademark_monitoring_result', id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, trademark: { __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, orders: Array<{ __typename?: 'service_request', id: string, public_id: string, product_id: string, service_name?: string | null, internal_label?: string | null, description?: string | null, parameters: any, language?: string | null, region: string, status: string, currency: string, billing_entity_id?: string | null, document_hub_id: string, created_at: string, updated_at: string, last_status_update: string, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', date_start: string, date_end: string, trademark_id?: string | null }>, billing_entity?: { __typename?: 'entity', id: string, type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }> }> };

export type TrademarkMonitoringResultGetUnseenCountQueryVariables = Exact<{ [key: string]: never; }>;


export type TrademarkMonitoringResultGetUnseenCountQuery = { __typename?: 'query_root', trademark_monitoring_result_aggregate: { __typename?: 'trademark_monitoring_result_aggregate', aggregate?: { __typename?: 'trademark_monitoring_result_aggregate_fields', count: number } | null } };

export type TrademarkMonitoringResultsForTrademarkQueryVariables = Exact<{
  trademarkId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkMonitoringResultsForTrademarkQuery = { __typename?: 'query_root', trademark_monitoring_result: Array<{ __typename?: 'trademark_monitoring_result', document_hub_id: string, id: string, type?: string | null, relevance?: string | null, created_at: string, publication_date?: string | null, filing_date?: string | null, application_number?: string | null, trademark_number?: string | null, mark_name?: string | null, mark_type?: string | null, classes?: any | null, jurisdiction: string, trademark_id: string, ipo_link?: string | null, order_hub_id: string, seen: boolean, markify_logo_url?: string | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }> }>, trademark_monitoring_result_aggregate: { __typename?: 'trademark_monitoring_result_aggregate', aggregate?: { __typename?: 'trademark_monitoring_result_aggregate_fields', count: number } | null } };

export type TrademarkRateLimitLogFragment = { __typename?: 'trademark_rate_limit_log', id: string, source: string, request_count: number, created_at?: string | null };

export type TrademarkRateLimitLogInsertOneMutationVariables = Exact<{
  object: Trademark_Rate_Limit_Log_Insert_Input;
}>;


export type TrademarkRateLimitLogInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_rate_limit_log_one?: { __typename?: 'trademark_rate_limit_log', id: string, source: string, request_count: number, created_at?: string | null } | null };

export type TrademarkRateLimitLogSumRequestCountQueryVariables = Exact<{
  filter?: Trademark_Rate_Limit_Log_Bool_Exp;
}>;


export type TrademarkRateLimitLogSumRequestCountQuery = { __typename?: 'query_root', trademark_rate_limit_log_aggregate: { __typename?: 'trademark_rate_limit_log_aggregate', aggregate?: { __typename?: 'trademark_rate_limit_log_aggregate_fields', sum?: { __typename?: 'trademark_rate_limit_log_sum_fields', request_count?: number | null } | null } | null } };

export type TrademarkRequestFragment = { __typename?: 'trademark_request', id: string, mark_alias: string, jurisdictions?: any | null, created_at: string, user_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }> };

export type TrademarkRequestDataFragment = { __typename?: 'trademark_request', id: string, mark_alias: string, created_at: string, status?: string | null, jurisdictions?: any | null, brand_id?: string | null };

export type TrademarkRequestInsertOneMutationVariables = Exact<{
  object: Trademark_Request_Insert_Input;
}>;


export type TrademarkRequestInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_request_one?: { __typename?: 'trademark_request', id: string, mark_alias: string, jurisdictions?: any | null, created_at: string, user_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }> } | null };

export type TrademarkRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Trademark_Request_Set_Input;
}>;


export type TrademarkRequestUpdateOneMutation = { __typename?: 'mutation_root', update_trademark_request_by_pk?: { __typename?: 'trademark_request', id: string } | null };

export type TrademarkRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkRequestGetByIdQuery = { __typename?: 'query_root', trademark_request_by_pk?: { __typename?: 'trademark_request', id: string, mark_alias: string, jurisdictions?: any | null, created_at: string, user_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }> } | null };

export type TrademarkRequestGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Request_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By> | Trademark_Request_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkRequestGetManyQuery = { __typename?: 'query_root', trademark_request: Array<{ __typename?: 'trademark_request', id: string, mark_alias: string, jurisdictions?: any | null, created_at: string, user_id?: string | null, trademarks: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }> }> };

export type TrademarkRequestGetManyForUserQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Request_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Request_Order_By> | Trademark_Request_Order_By>;
}>;


export type TrademarkRequestGetManyForUserQuery = { __typename?: 'query_root', trademark_request: Array<{ __typename?: 'trademark_request', id: string, mark_alias: string, created_at: string, status?: string | null, jurisdictions?: any | null, brand_id?: string | null }>, trademark_request_aggregate: { __typename?: 'trademark_request_aggregate', aggregate?: { __typename?: 'trademark_request_aggregate_fields', count: number } | null } };

export type TrademarkServiceRequestsFragment = { __typename?: 'trademark_service_requests', trademark_id: string, service_request_id: string, trademark?: { __typename?: 'trademark', id: string, jurisdiction: string, type: string, name?: string | null, number?: string | null, status: string, document_hub_id: string, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type TrademarkServiceRequestsInsertManyMutationVariables = Exact<{
  objects: Array<Trademark_Service_Requests_Insert_Input> | Trademark_Service_Requests_Insert_Input;
}>;


export type TrademarkServiceRequestsInsertManyMutation = { __typename?: 'mutation_root', insert_trademark_service_requests?: { __typename?: 'trademark_service_requests_mutation_response', returning: Array<{ __typename?: 'trademark_service_requests', trademark_id: string, service_request_id: string, trademark?: { __typename?: 'trademark', id: string, jurisdiction: string, type: string, name?: string | null, number?: string | null, status: string, document_hub_id: string, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> } | null };

export type TrademarkServiceRequestsDeleteManyMutationVariables = Exact<{
  where: Trademark_Service_Requests_Bool_Exp;
}>;


export type TrademarkServiceRequestsDeleteManyMutation = { __typename?: 'mutation_root', delete_trademark_service_requests?: { __typename?: 'trademark_service_requests_mutation_response', affected_rows: number } | null };

export type TrademarkServiceRequestsGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Service_Requests_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Service_Requests_Order_By> | Trademark_Service_Requests_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkServiceRequestsGetManyQuery = { __typename?: 'query_root', trademark_service_requests: Array<{ __typename?: 'trademark_service_requests', trademark_id: string, service_request_id: string, trademark?: { __typename?: 'trademark', id: string, jurisdiction: string, type: string, name?: string | null, number?: string | null, status: string, document_hub_id: string, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, documents: Array<{ __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null }>, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type TrademarkSharedDocumentsFragment = { __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number };

export type TrademarkSharedDocumentsWithDocumentFragment = { __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } };

export type TrademarkSharedDocumentsInsertManyMutationVariables = Exact<{
  objects: Array<Trademark_Shared_Documents_Insert_Input> | Trademark_Shared_Documents_Insert_Input;
}>;


export type TrademarkSharedDocumentsInsertManyMutation = { __typename?: 'mutation_root', insert_trademark_shared_documents?: { __typename?: 'trademark_shared_documents_mutation_response', returning: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number }> } | null };

export type TrademarkSharedDocumentsDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TrademarkSharedDocumentsDeleteOneMutation = { __typename?: 'mutation_root', delete_trademark_shared_documents_by_pk?: { __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number } | null };

export type TrademarkSharedDocumentsDeleteManyMutationVariables = Exact<{
  where: Trademark_Shared_Documents_Bool_Exp;
}>;


export type TrademarkSharedDocumentsDeleteManyMutation = { __typename?: 'mutation_root', delete_trademark_shared_documents?: { __typename?: 'trademark_shared_documents_mutation_response', affected_rows: number } | null };

export type TrademarkSharedDocumentsGetManyQueryVariables = Exact<{
  where: Trademark_Shared_Documents_Bool_Exp;
  order_by?: InputMaybe<Array<Trademark_Shared_Documents_Order_By> | Trademark_Shared_Documents_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TrademarkSharedDocumentsGetManyQuery = { __typename?: 'query_root', trademark_shared_documents: Array<{ __typename: 'trademark_shared_documents', id: number, trademark_id: string, document_id: number, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> };

export type TrademarkTrackingFragment = { __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string };

export type TrademarkTrackingWithStatusFragment = { __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string, tracking_status: { __typename?: 'trademark_tracking_status', is_status: boolean } };

export type TrademarkTrackingInsertOneMutationVariables = Exact<{
  object: Trademark_Tracking_Insert_Input;
}>;


export type TrademarkTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_trademark_tracking_one?: { __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string } | null };

export type TrademarkTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TrademarkTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_trademark_tracking_by_pk?: { __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string } | null };

export type TrademarkTrackingDeleteManyMutationVariables = Exact<{
  trademarkId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
}>;


export type TrademarkTrackingDeleteManyMutation = { __typename?: 'mutation_root', delete_trademark_tracking?: { __typename?: 'trademark_tracking_mutation_response', affected_rows: number } | null };

export type TrademarkTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By> | Trademark_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column> | Trademark_Tracking_Select_Column>;
}>;


export type TrademarkTrackingGetManyQuery = { __typename?: 'query_root', trademark_tracking: Array<{ __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string }> };

export type TrademarkTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Trademark_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Tracking_Order_By> | Trademark_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Trademark_Tracking_Select_Column> | Trademark_Tracking_Select_Column>;
}>;


export type TrademarkTrackingWithStatusGetManyQuery = { __typename?: 'query_root', trademark_tracking: Array<{ __typename?: 'trademark_tracking', id: number, trademark_id: string, name: string, skipped: boolean, user_id?: string | null, created_at: string, tracking_status: { __typename?: 'trademark_tracking_status', is_status: boolean } }> };

export type TrademarkWatchSubscriptionFragment = { __typename?: 'trademark_watch_subscription', id: string, markify_id: string, date_start: string, date_end: string, trademark_id?: string | null, user_id: string };

export type TrademarkWatchSubscriptionGetManyQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
  order_by?: InputMaybe<Array<Trademark_Watch_Subscription_Order_By> | Trademark_Watch_Subscription_Order_By>;
}>;


export type TrademarkWatchSubscriptionGetManyQuery = { __typename?: 'query_root', trademark_watch_subscription: Array<{ __typename?: 'trademark_watch_subscription', id: string, markify_id: string, date_start: string, date_end: string, trademark_id?: string | null, user_id: string }> };

export type TrademarkWatchSubscriptionCountQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Watch_Subscription_Bool_Exp>;
}>;


export type TrademarkWatchSubscriptionCountQuery = { __typename?: 'query_root', trademark_watch_subscription_aggregate: { __typename?: 'trademark_watch_subscription_aggregate', aggregate?: { __typename?: 'trademark_watch_subscription_aggregate_fields', count: number } | null } };

export type TrademarkWatchSubscriptionGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TrademarkWatchSubscriptionGetByIdQuery = { __typename?: 'query_root', trademark_watch_subscription_by_pk?: { __typename?: 'trademark_watch_subscription', id: string, markify_id: string, date_start: string, date_end: string, trademark_id?: string | null, user_id: string } | null };

export type TrademarksQueryVariables = Exact<{
  filter?: InputMaybe<Trademark_Bool_Exp>;
  filterRequest?: InputMaybe<Trademark_Request_Bool_Exp>;
}>;


export type TrademarksQuery = { __typename?: 'query_root', trademark_request: Array<{ __typename?: 'trademark_request', id: string, mark_alias: string, created_at: string, status?: string | null, jurisdictions?: any | null, brand_id?: string | null }>, trademark: Array<{ __typename: 'trademark', alias?: string | null, brand_id?: string | null, created_at: string, document_hub_id: string, expiration_date?: string | null, dou_deadline_date?: string | null, filing_date?: string | null, id: string, ipo_link?: string | null, jurisdiction: string, last_tracking_update?: string | null, name?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, owner_entity_id?: string | null, registration_date?: string | null, registration_request_id?: string | null, representative_entity_id?: string | null, status: string, status_group: string, trademark_request_id?: string | null, type: string, user_id?: string | null, additional_info: any, last_ipo_data_sync?: string | null, trademark_classes: Array<{ __typename?: 'trademark_class', class_number: string, class_items: any }>, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }> }>, trademark_request_aggregate: { __typename?: 'trademark_request_aggregate', aggregate?: { __typename?: 'trademark_request_aggregate_fields', count: number } | null }, trademark_aggregate: { __typename?: 'trademark_aggregate', aggregate?: { __typename?: 'trademark_aggregate_fields', count: number } | null } };

export type UseInCommerceRequestFragment = { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null };

export type UseInCommerceRequestForUserFragment = { __typename?: 'use_in_commerce_request', id: string, status: string, type: any, kickoff_type?: string | null, due_date: string, grace_period_deadline?: string | null };

export type UseInCommerceRequestForDraftingFragment = { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null, specimens: Array<{ __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> }>, tracking_actions: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string }>, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }> };

export type UseInCommerceRequestInsertOneMutationVariables = Exact<{
  object: Use_In_Commerce_Request_Insert_Input;
}>;


export type UseInCommerceRequestInsertOneMutation = { __typename?: 'mutation_root', insert_use_in_commerce_request_one?: { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null } | null };

export type UseInCommerceRequestUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<Use_In_Commerce_Request_Set_Input>;
}>;


export type UseInCommerceRequestUpdateOneMutation = { __typename?: 'mutation_root', update_use_in_commerce_request_by_pk?: { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null } | null };

export type UseInCommerceRequestGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UseInCommerceRequestGetByIdQuery = { __typename?: 'query_root', use_in_commerce_request_by_pk?: { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null } | null };

export type UseInCommerceRequestGetByIdForDraftingQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UseInCommerceRequestGetByIdForDraftingQuery = { __typename?: 'query_root', use_in_commerce_request_by_pk?: { __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null, specimens: Array<{ __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> }>, tracking_actions: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string }>, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }> } | null };

export type UseInCommerceRequestGetManyQueryVariables = Exact<{
  where: Use_In_Commerce_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By> | Use_In_Commerce_Request_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column> | Use_In_Commerce_Request_Select_Column>;
}>;


export type UseInCommerceRequestGetManyQuery = { __typename?: 'query_root', use_in_commerce_request: Array<{ __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null }> };

export type UseInCommerceRequestGetManyForDraftingQueryVariables = Exact<{
  where: Use_In_Commerce_Request_Bool_Exp;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Order_By> | Use_In_Commerce_Request_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Select_Column> | Use_In_Commerce_Request_Select_Column>;
}>;


export type UseInCommerceRequestGetManyForDraftingQuery = { __typename?: 'query_root', use_in_commerce_request: Array<{ __typename: 'use_in_commerce_request', id: string, type: any, kickoff_type?: string | null, declaration_of_incontestability?: boolean | null, remaining_extension_count?: number | null, status: string, last_status_update: string, last_tracking_update: string, trademark_id: string, assigned_admin_id?: string | null, document_hub_id: string, order_hub_id: string, issue_date: string, due_date: string, created_at: string, updated_at: string, updated_by_user_id: string, parent_id?: string | null, order_id?: string | null, note_hub_id: string, child_trademark_id?: string | null, grace_period_deadline?: string | null, trademark: { __typename: 'trademark', id: string, name?: string | null, registration_date?: string | null, ipo_link?: string | null, number?: string | null, registration_number?: string | null, international_number?: string | null, filing_reference?: string | null, jurisdiction: string, trademark_request_id?: string | null, filing_date?: string | null, document_hub_id: string, type: string, owner_entity_id?: string | null, representative_entity_id?: string | null, expiration_date?: string | null, dou_deadline_date?: string | null, user_id?: string | null, alias?: string | null, brand_id?: string | null, trademark_registration_id_legacy?: number | null, status: string, status_group: string, filing_postponed_reason?: string | null, filing_postponed_note?: string | null, last_status_update: string, last_tracking_update?: string | null, filing_information?: any | null, brand_registry_code?: string | null, registration_request_id?: string | null, direct_filing?: boolean | null, assigned_admin_id?: string | null, assignee_history: any, note_hub_id: string, logo_type?: string | null, additional_info_legacy: any, additional_info: any, uspto_logo_subcategory?: string | null, color_claim?: string | null, priority_filing_data: any, domicile_address_id?: number | null, mailing_address_id?: number | null, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, opposition_period_start?: string | null, opposition_period_end?: string | null, documents: Array<{ __typename?: 'document', id: number, created_at: string, path: string, type: string, revision: number, document_hub_id: string }>, user?: { __typename?: 'user', email: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null, phone_number?: string | null } | null } | null, tracking_actions: Array<{ __typename?: 'trademark_tracking', name: string, created_at: string }>, owner_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null }> }, trademark_classes: Array<{ __typename: 'trademark_class', id: string, trademark_id?: string | null, use_in_commerce_request_id?: string | null, class_number: string, class_items: any, filing_basis?: any | null, decision?: any | null, first_use_in_us?: string | null, first_use_anywhere?: string | null, websites: any, filing_description?: string | null, document_folder_id: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, foreign_registration_basis?: any | null, specimens: Array<{ __typename?: 'specimen', id: string, application_id?: string | null, trademark_class_id?: string | null, document_id: number, description?: string | null, url?: string | null, class_number?: string | null, class_items: any, capture_date?: string | null, uspto_requirements?: any | null, created_at: string, updated_at: string, document: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } }> }>, tracking_actions: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string }>, comments: Array<{ __typename?: 'thread_comment', id: string, thread_id: string, application_id?: string | null, type: string, content?: string | null, user_id?: string | null, created_at: string, updated_at: string, ai_suggested_comment?: string | null, ai_suggested_action?: string | null, document_id?: number | null, user?: { __typename?: 'user', role: string, profile?: { __typename?: 'user_profile', firstname?: string | null, lastname?: string | null } | null } | null, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null }> }> };

export type UseInCommerceRequestCountQueryVariables = Exact<{
  filter?: InputMaybe<Use_In_Commerce_Request_Bool_Exp>;
}>;


export type UseInCommerceRequestCountQuery = { __typename?: 'query_root', use_in_commerce_request_aggregate: { __typename?: 'use_in_commerce_request_aggregate', aggregate?: { __typename?: 'use_in_commerce_request_aggregate_fields', count: number } | null } };

export type UseInCommerceRequestTrackingFragment = { __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string };

export type UseInCommerceRequestTrackingWithStatusFragment = { __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string, tracking_status: { __typename?: 'use_in_commerce_request_tracking_status', is_status: boolean } };

export type UseInCommerceRequestTrackingForUserFragment = { __typename?: 'use_in_commerce_request_tracking', name: string, created_at: string };

export type UseInCommerceRequestTrackingInsertOneMutationVariables = Exact<{
  object: Use_In_Commerce_Request_Tracking_Insert_Input;
}>;


export type UseInCommerceRequestTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_use_in_commerce_request_tracking_one?: { __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string } | null };

export type UseInCommerceRequestTrackingInsertManyMutationVariables = Exact<{
  objects: Array<Use_In_Commerce_Request_Tracking_Insert_Input> | Use_In_Commerce_Request_Tracking_Insert_Input;
}>;


export type UseInCommerceRequestTrackingInsertManyMutation = { __typename?: 'mutation_root', insert_use_in_commerce_request_tracking?: { __typename?: 'use_in_commerce_request_tracking_mutation_response', returning: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string }> } | null };

export type UseInCommerceRequestTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UseInCommerceRequestTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_use_in_commerce_request_tracking_by_pk?: { __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string } | null };

export type UseInCommerceRequestTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By> | Use_In_Commerce_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column> | Use_In_Commerce_Request_Tracking_Select_Column>;
}>;


export type UseInCommerceRequestTrackingGetManyQuery = { __typename?: 'query_root', use_in_commerce_request_tracking: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string }> };

export type UseInCommerceRequestTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<Use_In_Commerce_Request_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Order_By> | Use_In_Commerce_Request_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<Use_In_Commerce_Request_Tracking_Select_Column> | Use_In_Commerce_Request_Tracking_Select_Column>;
}>;


export type UseInCommerceRequestTrackingWithStatusGetManyQuery = { __typename?: 'query_root', use_in_commerce_request_tracking: Array<{ __typename?: 'use_in_commerce_request_tracking', id: number, name: string, created_at: string, skipped?: boolean | null, user_id?: string | null, use_in_commerce_request_id: string, tracking_status: { __typename?: 'use_in_commerce_request_tracking_status', is_status: boolean } }> };

export type UserFragment = { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type UserWithSecretFieldsFragment = { __typename: 'user', password_hash: string, refresh_token?: string | null, id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type UserForUserFragment = { __typename: 'user', id: string, email: string, role: string, status: string, revolut_id?: string | null, cp_onboarding_finished: boolean, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type UserUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<User_Set_Input>;
}>;


export type UserUpdateOneMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type UserUpdateSecretMutationVariables = Exact<{
  email: Scalars['String']['input'];
  new_secret: Scalars['uuid']['input'];
}>;


export type UserUpdateSecretMutation = { __typename?: 'mutation_root', update_user?: { __typename?: 'user_mutation_response', returning: Array<{ __typename?: 'user', id: string, secret: string }> } | null };

export type UserInsertOneMutationVariables = Exact<{
  object: User_Insert_Input;
}>;


export type UserInsertOneMutation = { __typename?: 'mutation_root', insert_user_one?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type UserGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserGetByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type UserForUserGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserForUserGetByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename: 'user', id: string, email: string, role: string, status: string, revolut_id?: string | null, cp_onboarding_finished: boolean, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type UserByRefreshTokenQueryVariables = Exact<{
  refresh_token: Scalars['uuid']['input'];
}>;


export type UserByRefreshTokenQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: string, email: string, role: string }> };

export type UserWithPasswordHashQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserWithPasswordHashQuery = { __typename?: 'query_root', user_by_pk?: { __typename: 'user', password_hash: string, id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null } | null };

export type UserSecretQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserSecretQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', secret: string, secret_generated_at: string } | null };

export type UserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserByEmailQuery = { __typename?: 'query_root', user: Array<{ __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type UserByEmailWithSecretFieldsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserByEmailWithSecretFieldsQuery = { __typename?: 'query_root', user: Array<{ __typename: 'user', password_hash: string, refresh_token?: string | null, id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type UserBySecretQueryVariables = Exact<{
  secret: Scalars['uuid']['input'];
}>;


export type UserBySecretQuery = { __typename?: 'query_root', user: Array<{ __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type GetUsersQueryVariables = Exact<{
  where?: InputMaybe<User_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'query_root', user: Array<{ __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type UserGetManyQueryVariables = Exact<{
  filter?: InputMaybe<User_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Order_By> | User_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserGetManyQuery = { __typename?: 'query_root', user: Array<{ __typename: 'user', id: string, email: string, role: string, status: string, last_status_update: string, last_tracking_update: string, revolut_id?: string | null, assigned_admin_id?: string | null, document_hub_id: string, note_hub_id: string, tags: any, unsubscribe_token: string, profile?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null }> };

export type UserAuthLogFragment = { __typename: 'user_auth_log', id: number, user_id: string, action_type: string, ip_address?: string | null, vpn_provider?: string | null, device_info: any, location: any, metadata: any, created_at: string };

export type UserAuthLogInsertOneMutationVariables = Exact<{
  object: User_Auth_Log_Insert_Input;
}>;


export type UserAuthLogInsertOneMutation = { __typename?: 'mutation_root', insert_user_auth_log_one?: { __typename: 'user_auth_log', id: number, user_id: string, action_type: string, ip_address?: string | null, vpn_provider?: string | null, device_info: any, location: any, metadata: any, created_at: string } | null };

export type UserHistoryFragment = { __typename: 'user_history', id: string, email: string, user_id: string, created_at: string, created_by_user_id: string };

export type UserHistoryInsertOneMutationVariables = Exact<{
  object: User_History_Insert_Input;
}>;


export type UserHistoryInsertOneMutation = { __typename?: 'mutation_root', insert_user_history_one?: { __typename: 'user_history', id: string, email: string, user_id: string, created_at: string, created_by_user_id: string } | null };

export type UserHistoryGetManyQueryVariables = Exact<{
  where: User_History_Bool_Exp;
  order_by?: InputMaybe<Array<User_History_Order_By> | User_History_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<User_History_Select_Column> | User_History_Select_Column>;
}>;


export type UserHistoryGetManyQuery = { __typename?: 'query_root', user_history: Array<{ __typename: 'user_history', id: string, email: string, user_id: string, created_at: string, created_by_user_id: string }> };

export type UserPaymentMethodFragment = { __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null };

export type UserPaymentMethodForUserFragment = { __typename?: 'user_payment_method', id: string, user_id: string, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string };

export type UserPaymentMethodInsertOneMutationVariables = Exact<{
  object: User_Payment_Method_Insert_Input;
}>;


export type UserPaymentMethodInsertOneMutation = { __typename?: 'mutation_root', insert_user_payment_method_one?: { __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null } | null };

export type UserPaymentMethodUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes?: InputMaybe<User_Payment_Method_Set_Input>;
}>;


export type UserPaymentMethodUpdateOneMutation = { __typename?: 'mutation_root', update_user_payment_method_by_pk?: { __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null } | null };

export type UserPaymentMethodUpdateManyMutationVariables = Exact<{
  where: User_Payment_Method_Bool_Exp;
  set: User_Payment_Method_Set_Input;
}>;


export type UserPaymentMethodUpdateManyMutation = { __typename?: 'mutation_root', update_user_payment_method?: { __typename?: 'user_payment_method_mutation_response', returning: Array<{ __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null }> } | null };

export type UserPaymentMethodGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserPaymentMethodGetByIdQuery = { __typename?: 'query_root', user_payment_method_by_pk?: { __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null } | null };

export type UserPaymentMethodGetManyQueryVariables = Exact<{
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By> | User_Payment_Method_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column> | User_Payment_Method_Select_Column>;
}>;


export type UserPaymentMethodGetManyQuery = { __typename?: 'query_root', user_payment_method: Array<{ __typename?: 'user_payment_method', id: string, user_id: string, revolut_id?: string | null, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string, validation_order_id?: string | null }> };

export type UserPaymentMethodGetManyForUserQueryVariables = Exact<{
  where?: InputMaybe<User_Payment_Method_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Payment_Method_Order_By> | User_Payment_Method_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<User_Payment_Method_Select_Column> | User_Payment_Method_Select_Column>;
}>;


export type UserPaymentMethodGetManyForUserQuery = { __typename?: 'query_root', user_payment_method: Array<{ __typename?: 'user_payment_method', id: string, user_id: string, card_brand?: string | null, card_expiration?: string | null, card_last_four?: string | null, created_at: string, updated_at: string, status: string }> };

export type ProfileFragment = { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null };

export type UserProfileUpdateOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  changes: User_Profile_Set_Input;
}>;


export type UserProfileUpdateOneMutation = { __typename?: 'mutation_root', update_user_profile_by_pk?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type UserProfileInsertOneMutationVariables = Exact<{
  object: User_Profile_Insert_Input;
}>;


export type UserProfileInsertOneMutation = { __typename?: 'mutation_root', insert_user_profile_one?: { __typename?: 'user_profile', id: number } | null };

export type UserProfileGetByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserProfileGetByIdQuery = { __typename?: 'query_root', user_profile_by_pk?: { __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } | null };

export type UserProfileGetManyQueryVariables = Exact<{
  filter?: InputMaybe<User_Profile_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Profile_Order_By> | User_Profile_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserProfileGetManyQuery = { __typename?: 'query_root', user_profile: Array<{ __typename?: 'user_profile', id: number, user_id?: string | null, firstname?: string | null, lastname?: string | null, phone_number?: string | null, billing_entity_id?: string | null, registration_entity_id?: string | null, order_update_emails_enabled: boolean, marketing_emails_enabled: boolean, newsletter_emails_enabled: boolean, registration_entity_prefill_enabled: boolean, billing_entity_prefill_enabled: boolean, updated_at: string, language: string, currency: string, region?: string | null, timezone?: string | null, billing_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null, registration_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null }> };

export type UserTrackingFragment = { __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string };

export type UserTrackingWithStatusFragment = { __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string, tracking_status: { __typename?: 'user_tracking_status', is_status: boolean } };

export type UserTrackingInsertOneMutationVariables = Exact<{
  object: User_Tracking_Insert_Input;
}>;


export type UserTrackingInsertOneMutation = { __typename?: 'mutation_root', insert_user_tracking_one?: { __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string } | null };

export type UserTrackingDeleteOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserTrackingDeleteOneMutation = { __typename?: 'mutation_root', delete_user_tracking_by_pk?: { __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string } | null };

export type UserTrackingGetManyQueryVariables = Exact<{
  where?: InputMaybe<User_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By> | User_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column> | User_Tracking_Select_Column>;
}>;


export type UserTrackingGetManyQuery = { __typename?: 'query_root', user_tracking: Array<{ __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string }> };

export type UserTrackingWithStatusGetManyQueryVariables = Exact<{
  where?: InputMaybe<User_Tracking_Bool_Exp>;
  order_by?: InputMaybe<Array<User_Tracking_Order_By> | User_Tracking_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  distinct_on?: InputMaybe<Array<User_Tracking_Select_Column> | User_Tracking_Select_Column>;
}>;


export type UserTrackingWithStatusGetManyQuery = { __typename?: 'query_root', user_tracking: Array<{ __typename?: 'user_tracking', id: number, user_id: string, name: string, skipped: boolean, created_by_user_id?: string | null, created_at: string, tracking_status: { __typename?: 'user_tracking_status', is_status: boolean } }> };

export type VerificationResultFragment = { __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null };

export type VerificationResultForUserFragment = { __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, transcription?: string | null, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } }> };

export type VerificationResultInsertOneMutationVariables = Exact<{
  object: Verification_Result_Insert_Input;
}>;


export type VerificationResultInsertOneMutation = { __typename?: 'mutation_root', insert_verification_result_one?: { __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null } | null };

export type VerificationResultUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Verification_Result_Set_Input;
}>;


export type VerificationResultUpdateOneMutation = { __typename?: 'mutation_root', update_verification_result_by_pk?: { __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null } | null };

export type VerificationResultGetByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type VerificationResultGetByIdQuery = { __typename?: 'query_root', verification_result_by_pk?: { __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null } | null };

export type VerificationResultGetManyQueryVariables = Exact<{
  where: Verification_Result_Bool_Exp;
  order_by?: InputMaybe<Array<Verification_Result_Order_By> | Verification_Result_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VerificationResultGetManyQuery = { __typename?: 'query_root', verification_result: Array<{ __typename?: 'verification_result', id: string, registration_request_id: string, version: number, created_at: string, updated_at: string, jurisdictions: any, recommended_classes: any, verified_classes: any, additional_check_required: boolean, use_narrow_gs_list?: boolean | null, distinctiveness: string, result_note?: string | null, request_note?: string | null, similarity?: string | null, search_type?: string | null, other_refusal_reason?: string | null, running_business?: boolean | null, strategy?: boolean | null, support?: boolean | null, value_type?: string | null, document_id?: number | null, value?: string | null, completed?: boolean | null, trama_business_description?: string | null, transcription?: string | null, ai_transcription?: string | null, ai_not_trademark: boolean, brand_snapshot_id?: string | null, distinctive_part?: string | null, ai_distinctive_part?: string | null, absolute_ground_for_refusal?: string | null, ai_absolute_ground_for_refusal?: string | null, ai_distinctiveness?: string | null, ai_other_refusal_reason?: string | null, ai_reasoning?: any | null, ai_confidence?: string | null, similar_trademarks: Array<{ __typename?: 'similar_trademark', id: string, name: string, jurisdictions?: any | null, url: string, similarity: string, competitor?: string | null, competitor_website?: string | null, well_known?: boolean | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null }>, document?: { __typename?: 'document', id: number, path: string, type: string, revision: number, created_at: string, document_hub_id: string, document_folder_id?: string | null, parent_document_id?: number | null, created_by_user_id?: string | null, size?: number | null } | null, verification_result_similar_trademark_map: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }>, brand_snapshot?: { __typename?: 'brand_snapshot', id: string, user_id: string, name: string, created_at: string, updated_at: string, created_by_user_id?: string | null, updated_by_user_id?: string | null, deleted: boolean, client_business_description?: string | null, trama_business_description?: string | null, ai_business_description?: string | null, date_of_first_use?: string | null, ai_date_of_first_use?: string | null, high_level_usage?: string | null, ai_high_level_usage?: string | null, ai_reasoning: any, trama_business_description_updated_at: string, date_of_first_use_updated_at: string, high_level_usage_updated_at: string, websites: any, original_brand_id?: string | null, snapshotted_at: string } | null }> };

export type VerificationResultSimilarTrademarkMapForUserFragment = { __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, document_hub_id: string, website?: string | null, well_known?: boolean | null } };

export type VerificationResultSimilarTrademarkMapFragment = { __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } };

export type VerificationResultSimilarTrademarkMapInsertManyMutationVariables = Exact<{
  objects: Array<Verification_Result_Similar_Trademark_Map_Insert_Input> | Verification_Result_Similar_Trademark_Map_Insert_Input;
}>;


export type VerificationResultSimilarTrademarkMapInsertManyMutation = { __typename?: 'mutation_root', insert_verification_result_similar_trademark_map?: { __typename?: 'verification_result_similar_trademark_map_mutation_response', returning: Array<{ __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } }> } | null };

export type VerificationResultSimilarTrademarkMapDeleteManyMutationVariables = Exact<{
  where: Verification_Result_Similar_Trademark_Map_Bool_Exp;
}>;


export type VerificationResultSimilarTrademarkMapDeleteManyMutation = { __typename?: 'mutation_root', delete_verification_result_similar_trademark_map?: { __typename?: 'verification_result_similar_trademark_map_mutation_response', affected_rows: number } | null };

export type VerificationResultSimilarTrademarkMapUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Verification_Result_Similar_Trademark_Map_Set_Input;
}>;


export type VerificationResultSimilarTrademarkMapUpdateOneMutation = { __typename?: 'mutation_root', update_verification_result_similar_trademark_map_by_pk?: { __typename?: 'verification_result_similar_trademark_map', id: string, verification_result_id: string, external_trademark_id: string, jurisdictions: any, similarity: string, metadata: any, competitor?: string | null, similarity_of_marks?: string | null, similarity_of_gs?: string | null, ai_similarity_of_marks?: string | null, ai_similarity_of_gs?: string | null, ai_reasoning: any, external_trademark: { __typename?: 'external_trademark', id: string, name?: string | null, type?: string | null, number: string, jurisdiction: string, ipo_link?: string | null, goods_and_services: any, registration_date?: string | null, filing_date?: string | null, representative_entity_id?: string | null, document_hub_id: string, created_at: string, well_known?: boolean | null, ai_well_known?: boolean | null, ai_well_known_reasoning?: string | null, website?: string | null, representative_entity?: { __typename?: 'entity', type?: string | null, business_name?: string | null, company_id?: string | null, company_type?: string | null, vat?: string | null, vat_payer?: boolean | null, official_first_name?: string | null, official_function?: string | null, official_last_name?: string | null, state_of_incorporation?: string | null, country_of_incorporation?: string | null, first_name?: string | null, last_name?: string | null, personal_id_number?: string | null, nationality?: string | null, birthdate?: string | null, identity_card_id?: string | null, email?: string | null, phone?: string | null, address_id?: number | null, address?: { __typename?: 'address', street?: string | null, city?: string | null, postcode?: string | null, country?: string | null, state?: string | null } | null } | null } } | null };

export type WebsiteForUserFragment = { __typename?: 'website', id: string, brand_id: string, link: string };

export type WebsiteFragment = { __typename?: 'website', metadata?: string | null, type?: string | null, created_at: string, updated_at: string, id: string, brand_id: string, link: string };

export type WebsiteInsertManyMutationVariables = Exact<{
  objects: Array<Website_Insert_Input> | Website_Insert_Input;
}>;


export type WebsiteInsertManyMutation = { __typename?: 'mutation_root', insert_website?: { __typename?: 'website_mutation_response', returning: Array<{ __typename?: 'website', metadata?: string | null, type?: string | null, created_at: string, updated_at: string, id: string, brand_id: string, link: string }> } | null };

export type WebsiteDeleteByIdsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type WebsiteDeleteByIdsMutation = { __typename?: 'mutation_root', delete_website?: { __typename?: 'website_mutation_response', affected_rows: number } | null };

export type WebsiteUpdateOneMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  changes: Website_Set_Input;
}>;


export type WebsiteUpdateOneMutation = { __typename?: 'mutation_root', update_website_by_pk?: { __typename?: 'website', metadata?: string | null, type?: string | null, created_at: string, updated_at: string, id: string, brand_id: string, link: string } | null };

export const AiGsItemsAnalysisFragmentDoc = `
    fragment aiGsItemsAnalysis on ai_gs_items_analysis {
  id
  registration_request_id
  jurisdiction
  class_number
  business_description
  class_items
  analysis
  created_at
}
    `;
export const AddressDataFragmentDoc = `
    fragment addressData on address {
  street
  city
  postcode
  country
  state
}
    `;
export const EntityDataFragmentDoc = `
    fragment entityData on entity {
  type
  business_name
  company_id
  company_type
  vat
  vat_payer
  official_first_name
  official_function
  official_last_name
  state_of_incorporation
  country_of_incorporation
  first_name
  last_name
  personal_id_number
  nationality
  birthdate
  identity_card_id
  email
  phone
  address_id
  address {
    ...addressData
  }
}
    `;
export const ApplicationDataFragmentDoc = `
    fragment applicationData on application {
  id
  registration_entity_id
  registration_entity {
    ...entityData
  }
  registration_request {
    id
    type
    value
  }
  mailing_address_id
}
    `;
export const ApplicationJurisdictionFragmentDoc = `
    fragment applicationJurisdiction on application_jurisdiction {
  id
  application_id
  jurisdiction
  goods_and_services
  uspto_filing_basis
  uspto_specimen_to_class
  additional_info
  logo_type
  text_in_trademark
  document_folder_id
  color_claim_enabled
  color_claim
  uspto_logo_subcategory
  ai_text_in_trademark
  ai_logo_type
  ai_color_claim
  ai_uspto_logo_subcategory
  ai_reasoning
  ai_additional_info
}
    `;
export const ProfileFragmentDoc = `
    fragment profile on user_profile {
  id
  user_id
  firstname
  lastname
  phone_number
  billing_entity_id
  registration_entity_id
  order_update_emails_enabled
  marketing_emails_enabled
  newsletter_emails_enabled
  registration_entity_prefill_enabled
  billing_entity_prefill_enabled
  updated_at
  language
  currency
  region
  timezone
  billing_entity {
    ...entityData
  }
  registration_entity {
    ...entityData
  }
}
    `;
export const UserFragmentDoc = `
    fragment user on user {
  __typename
  id
  email
  role
  status
  last_status_update
  last_tracking_update
  revolut_id
  assigned_admin_id
  document_hub_id
  note_hub_id
  tags
  unsubscribe_token
  profile {
    ...profile
  }
}
    `;
export const Audit_LogFragmentDoc = `
    fragment audit_log on audit_log {
  id
  operation
  table_name
  record_id_uuid
  record_id_int
  old_values
  new_values
  created_at
  user_id
  user {
    ...user
  }
}
    `;
export const WebsiteForUserFragmentDoc = `
    fragment websiteForUser on website {
  id
  brand_id
  link
}
    `;
export const BrandForUserFragmentDoc = `
    fragment brandForUser on brand {
  id
  user_id
  name
  created_at
  client_business_description
  deleted
  updated_at
  created_by_user_id
  updated_by_user_id
  websites {
    ...websiteForUser
  }
}
    `;
export const BrandMonitoringTaskTrackingFragmentDoc = `
    fragment brandMonitoringTaskTracking on brand_monitoring_task_tracking {
  id
  name
  created_at
  skipped
  user_id
  brand_monitoring_task_id
}
    `;
export const BrandMonitoringTaskTrackingWithStatusFragmentDoc = `
    fragment brandMonitoringTaskTrackingWithStatus on brand_monitoring_task_tracking {
  ...brandMonitoringTaskTracking
  tracking_status {
    is_status
  }
}
    `;
export const BrandSubscriptionForUserFragmentDoc = `
    fragment brandSubscriptionForUser on brand_subscription {
  __typename
  id
  brand_id
  billing_entity_id
  user_payment_method_id
  tier
  status
  payment_frequency
  start_date
  end_date
  currency
  created_at
  updated_at
  discount_coupon_id
  tracking_actions {
    created_at
    name
  }
}
    `;
export const BrandSubscriptionFragmentDoc = `
    fragment brandSubscription on brand_subscription {
  __typename
  id
  brand_id
  billing_entity_id
  user_payment_method_id
  note_hub_id
  tier
  status
  payment_frequency
  start_date
  end_date
  currency
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  document_hub_id
  discount_coupon_id
  is_proactive
  case_solution_id
  last_status_update
  last_tracking_update
  registration_request_id
}
    `;
export const BrandFragmentDoc = `
    fragment brand on brand {
  id
  user_id
  name
  created_at
  client_business_description
  deleted
  updated_at
  created_by_user_id
  updated_by_user_id
  trama_business_description
  ai_business_description
  date_of_first_use
  ai_date_of_first_use
  high_level_usage
  ai_high_level_usage
  ai_reasoning
  trama_business_description_updated_at
  date_of_first_use_updated_at
  high_level_usage_updated_at
  websites {
    ...websiteForUser
  }
}
    `;
export const BrandSubscriptionPlatformFragmentDoc = `
    fragment brandSubscriptionPlatform on brand_subscription_platform {
  id
  brand_subscription_id
  name
  metadata
  start_date
  end_date
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const DiscountCouponFragmentDoc = `
    fragment discountCoupon on discount_coupon {
  id
  lawyer_fees_discount
  fees_discount
  discount_type
  recurring
  is_active
  monitoring_upsell
  scope
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const BrandSubscriptionDetailsFragmentDoc = `
    fragment brandSubscriptionDetails on brand_subscription {
  ...brandSubscription
  brand {
    ...brand
  }
  platforms {
    ...brandSubscriptionPlatform
  }
  billing_entity {
    ...entityData
  }
  discount_coupon {
    ...discountCoupon
  }
}
    `;
export const BrandMonitoringTaskFragmentDoc = `
    fragment brandMonitoringTask on brand_monitoring_task {
  __typename
  id
  brand_id
  brand_subscription_id
  brand_subscription_tier
  status
  last_status_update
  last_tracking_update
  processed_timestamp
  assigned_admin_id
  deadline
  created_at
}
    `;
export const BrandSubscriptionWithTasksFragmentDoc = `
    fragment brandSubscriptionWithTasks on brand_subscription {
  __typename
  ...brandSubscription
  brand_monitoring_tasks {
    ...brandMonitoringTask
  }
}
    `;
export const EntityFragmentDoc = `
    fragment entity on entity {
  id
  ...entityData
}
    `;
export const BrandSubscriptionPaymentDataFragmentDoc = `
    fragment brandSubscriptionPaymentData on brand_subscription_payment {
  brand_subscription_id
  user_payment_method_id
  product_id
  start_date
  end_date
  status
  created_at
  updated_at
  document_folder_id
  decline_reason
  billing_entity_id
  billing_entity {
    ...entity
  }
}
    `;
export const BrandSubscriptionPaymentForUserFragmentDoc = `
    fragment brandSubscriptionPaymentForUser on brand_subscription_payment {
  status
  end_date
  created_at
  decline_reason
}
    `;
export const BrandSubscriptionPlatformForUserFragmentDoc = `
    fragment brandSubscriptionPlatformForUser on brand_subscription_platform {
  id
  brand_subscription_id
  name
  metadata
  start_date
  end_date
  created_at
  updated_at
}
    `;
export const BrandSubscriptionTrackingFragmentDoc = `
    fragment brandSubscriptionTracking on brand_subscription_tracking {
  id
  name
  created_at
  skipped
  user_id
  brand_subscription_id
}
    `;
export const BrandSubscriptionTrackingWithStatusFragmentDoc = `
    fragment brandSubscriptionTrackingWithStatus on brand_subscription_tracking {
  ...brandSubscriptionTracking
  tracking_status {
    is_status
  }
}
    `;
export const CaseFragmentDoc = `
    fragment case on case {
  __typename
  id
  brand_id
  brand_monitoring_task_id
  case_counterparty_id
  assigned_admin_id
  trademark_id
  relevance
  lawyers_note
  status
  last_status_update
  last_tracking_update
  outcome
  outcome_note
  note_hub_id
  document_hub_id
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const CaseCounterpartyFragmentDoc = `
    fragment caseCounterparty on case_counterparty {
  __typename
  id
  primary_name
  aliases
  websites
  note
  entity_id
  representative_entity_id
  user_id
  whitelisted
  jurisdiction
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const CaseWithCounterpartyFragmentDoc = `
    fragment caseWithCounterparty on case {
  ...case
  counterparty {
    ...caseCounterparty
  }
}
    `;
export const CaseForUserFragmentDoc = `
    fragment caseForUser on case {
  id
  brand_id
  relevance
  status
  last_status_update
  created_at
  lawyers_note
  brand {
    id
    name
    websites {
      ...websiteForUser
    }
    user {
      status
    }
    deleted
  }
}
    `;
export const CaseCounterpartyForUserFragmentDoc = `
    fragment caseCounterpartyForUser on case_counterparty {
  id
  primary_name
  websites
  whitelisted
}
    `;
export const CaseInfringementFragmentDoc = `
    fragment caseInfringement on case_infringement {
  __typename
  id
  case_id
  platform
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const CaseInfringementForUserFragmentDoc = `
    fragment caseInfringementForUser on case_infringement {
  id
  platform
  created_at
}
    `;
export const CaseInfringementEvidenceFragmentDoc = `
    fragment caseInfringementEvidence on case_infringement_evidence {
  __typename
  id
  case_infringement_id
  document_folder_id
  website
  evidence_date
  description
  external_trademark_id
  created_at
  created_by_user_id
  updated_at
  updated_by_user_id
}
    `;
export const ExternalTrademarkForUserFragmentDoc = `
    fragment externalTrademarkForUser on external_trademark {
  id
  name
  type
  number
  jurisdiction
  ipo_link
  document_hub_id
  website
  well_known
}
    `;
export const CaseInfringementEvidenceForUserFragmentDoc = `
    fragment caseInfringementEvidenceForUser on case_infringement_evidence {
  id
  website
  document_folder_id
  external_trademark {
    ...externalTrademarkForUser
  }
}
    `;
export const CaseRequestFragmentDoc = `
    fragment caseRequest on case_request {
  __typename
  id
  type
  brand_website
  links
  message
  dismiss_reason
  status
  last_status_update
  last_tracking_update
  case_id
  assigned_admin_id
  document_hub_id
  note_hub_id
  created_at
  updated_at
  user_id
  updated_by_user_id
}
    `;
export const CaseRequestTrackingFragmentDoc = `
    fragment caseRequestTracking on case_request_tracking {
  id
  name
  created_at
  skipped
  user_id
  case_request_id
}
    `;
export const CaseRequestTrackingWithStatusFragmentDoc = `
    fragment caseRequestTrackingWithStatus on case_request_tracking {
  ...caseRequestTracking
  tracking_status {
    is_status
  }
}
    `;
export const CaseSolutionFragmentDoc = `
    fragment caseSolution on case_solution {
  __typename
  id
  case_id
  status
  service_request_id
  items
  currency
  offer_subscription
  offer_watchlist
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const CaseSolutionForUserFragmentDoc = `
    fragment caseSolutionForUser on case_solution {
  id
  items
  currency
  case_id
  status
  offer_subscription
  offer_watchlist
  order {
    product_id
    status
  }
  services {
    id
    type
    service_request_id
    status
    parameters
    last_status_update
    created_at
  }
}
    `;
export const CaseTrackingFragmentDoc = `
    fragment caseTracking on case_tracking {
  id
  name
  created_at
  skipped
  user_id
  case_id
}
    `;
export const CaseTrackingWithStatusFragmentDoc = `
    fragment caseTrackingWithStatus on case_tracking {
  ...caseTracking
  tracking_status {
    is_status
  }
}
    `;
export const CaseTrackingForUserFragmentDoc = `
    fragment caseTrackingForUser on case_tracking {
  name
  created_at
}
    `;
export const ConsultationFragmentDoc = `
    fragment consultation on consultation {
  __typename
  id
  assigned_admin_id
  assigned_admin {
    email
  }
  user_id
  event_timestamp
  description
  outcome
  note_hub_id
  document_hub_id
  questions_and_answers
  resolution
  location
  calendly_id
  google_meet_id
  fathom_recording_url
}
    `;
export const ContentfulFragmentDoc = `
    fragment contentful on contentful {
  __typename
  id
  created_at
  updated_at
  deleted
  content_type
  name
  title
  slug
  date
  locale
  author_id
  fields
}
    `;
export const ContentfulHeadersFragmentDoc = `
    fragment contentfulHeaders on contentful {
  __typename
  id
  created_at
  updated_at
  deleted
  content_type
  name
  title
  slug
  date
  locale
  author_id
  date
}
    `;
export const CreditNoteFragmentDoc = `
    fragment creditNote on credit_note {
  id
  variable_symbol
  document_context
  invoice_reference
  year
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
}
    `;
export const Docketed_MessageFragmentDoc = `
    fragment docketed_message on docketed_message {
  id
  docketer
  source_email
  message_id
  message_link
  sender_name
  sender
  sender_email
  subject
  type
  status
  jurisdiction
  trademark_id
  asana_task_gid
  asana_task_link
  office_action_id
  data
  received_at
  created_at
  updated_at
  retried_at
}
    `;
export const DocumentFolderFragmentDoc = `
    fragment documentFolder on document_folder {
  id
  name
}
    `;
export const ExchangeRateFragmentDoc = `
    fragment exchangeRate on exchange_rate {
  id
  base_currency
  target_currency
  rate
  date
  created_at
}
    `;
export const InvoiceFragmentDoc = `
    fragment invoice on invoice {
  id
  billing_entity
  serial_number
  year
  created_at
  variable_symbol
  payment_date
  payment_type
  product_id
  document_context
  revolut_transaction_id
  revolut_public_order_id
  revolut_order_id
  last_failed_payment_alert_at
}
    `;
export const DocumentFragmentDoc = `
    fragment document on document {
  id
  path
  type
  revision
  created_at
  document_hub_id
  document_folder_id
  parent_document_id
  created_by_user_id
  size
}
    `;
export const ThreadCommentFragmentDoc = `
    fragment threadComment on thread_comment {
  id
  thread_id
  application_id
  type
  content
  user_id
  created_at
  updated_at
  ai_suggested_comment
  ai_suggested_action
  document_id
  user {
    role
    profile {
      firstname
      lastname
    }
  }
  document {
    ...document
  }
}
    `;
export const AddressFragmentDoc = `
    fragment address on address {
  id
  ...addressData
}
    `;
export const ApplicationFragmentDoc = `
    fragment application on application {
  id
  registration_entity_id
  registration_entity {
    ...entityData
  }
  onboarding_finished
  client_approval
  comments(where: {thread_id: {_eq: "note"}}, order_by: {created_at: asc}) {
    ...threadComment
  }
  priority_filing_visible
  priority_filing_jurisdiction
  priority_filing_number
  priority_filing_date
  mailing_address_id
  mailing_address {
    ...address
  }
  domicile_address_id
  domicile_address {
    ...address
  }
  domicile_address_visible
  document_types
  document_types_modified
  poa_metadata
  ai_extracted_data
  ai_analysis_task_id
  ai_domicile_address_verdict
  ai_reasoning
}
    `;
export const RegistrationRequestTrackingFragmentDoc = `
    fragment registrationRequestTracking on registration_request_tracking {
  id
  created_at
  name
  registration_request_id
  skipped
  user_id
}
    `;
export const SimilarTrademarkFragmentDoc = `
    fragment similarTrademark on similar_trademark {
  id
  name
  jurisdictions
  url
  similarity
  competitor
  competitor_website
  well_known
  similarity_of_marks
  similarity_of_gs
}
    `;
export const ExternalTrademarkFragmentDoc = `
    fragment externalTrademark on external_trademark {
  id
  name
  type
  number
  jurisdiction
  ipo_link
  goods_and_services
  registration_date
  filing_date
  representative_entity_id
  representative_entity {
    ...entityData
  }
  document_hub_id
  created_at
  well_known
  ai_well_known
  ai_well_known_reasoning
  website
}
    `;
export const VerificationResultSimilarTrademarkMapFragmentDoc = `
    fragment verificationResultSimilarTrademarkMap on verification_result_similar_trademark_map {
  id
  verification_result_id
  external_trademark_id
  jurisdictions
  similarity
  metadata
  competitor
  similarity_of_marks
  similarity_of_gs
  ai_similarity_of_marks
  ai_similarity_of_gs
  ai_reasoning
  external_trademark {
    ...externalTrademark
  }
}
    `;
export const BrandSnapshotFragmentDoc = `
    fragment brandSnapshot on brand_snapshot {
  id
  user_id
  name
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  deleted
  client_business_description
  trama_business_description
  ai_business_description
  date_of_first_use
  ai_date_of_first_use
  high_level_usage
  ai_high_level_usage
  ai_reasoning
  trama_business_description_updated_at
  date_of_first_use_updated_at
  high_level_usage_updated_at
  websites
  original_brand_id
  snapshotted_at
}
    `;
export const VerificationResultFragmentDoc = `
    fragment verificationResult on verification_result {
  id
  registration_request_id
  version
  created_at
  updated_at
  jurisdictions
  recommended_classes
  verified_classes
  additional_check_required
  use_narrow_gs_list
  distinctiveness
  result_note
  request_note
  similarity
  search_type
  other_refusal_reason
  running_business
  strategy
  support
  value_type
  document_id
  value
  completed
  trama_business_description
  similar_trademarks {
    ...similarTrademark
  }
  document {
    ...document
  }
  verification_result_similar_trademark_map {
    ...verificationResultSimilarTrademarkMap
  }
  transcription
  ai_transcription
  ai_not_trademark
  brand_snapshot_id
  brand_snapshot {
    ...brandSnapshot
  }
  distinctive_part
  ai_distinctive_part
  absolute_ground_for_refusal
  ai_absolute_ground_for_refusal
  ai_distinctiveness
  ai_other_refusal_reason
  ai_reasoning
  ai_confidence
}
    `;
export const CoreRegistrationFieldsFragmentDoc = `
    fragment coreRegistrationFields on registration_request {
  __typename
  id
  public_id
  user_id
  contact_email
  contact_first_name
  contact_last_name
  contact_phone
  created_at
  currency
  discount_coupon_id
  gdrive_folder_id
  lawyer_services_help_required
  services
  status
  updated_at
  type
  value
  client_business_description
  client_websites
  jurisdictions
  language
  status_group
  ordered_items
  euipo_grant_requested
  region
  country
  marketing_emails_force_disabled
  send_drafting_reminders
  mark_alias
  billing_entity_id
  billing_entity {
    ...entityData
  }
  product_id
  document_hub_id
  logo_document: documents(
    where: {type: {_eq: "Logo"}}
    limit: 1
    order_by: {created_at: desc}
  ) {
    ...document
  }
  note_hub_id
  discount_coupon {
    ...discountCoupon
  }
  use_in_commerce
  invoice_issued_in_US
  service_type
  application_id
  application {
    ...application
  }
  tracking_actions {
    ...registrationRequestTracking
  }
  last_status_update
  e2e_protection
  verification_results(limit: 1, order_by: {created_at: desc}) {
    ...verificationResult
  }
  client_note
  assigned_admin_id
  brand_id
  origin_trademark_id
  brand_protection
  ai_business_description
  ai_classes
  initial_ai_analysis_task_id
  ai_pipeline_task_id
  is_amazon_seller
}
    `;
export const ServiceRequestTrackingFragmentDoc = `
    fragment serviceRequestTracking on service_request_tracking {
  id
  created_at
  name
  service_request_id
  skipped
}
    `;
export const ServiceRequestFragmentDoc = `
    fragment serviceRequest on service_request {
  __typename
  id
  public_id
  product_id
  service_name
  internal_label
  description
  asana_task_url
  parameters
  language
  region
  status
  invoice_content
  currency
  billing_entity_id
  document_hub_id
  user_id
  created_at
  updated_at
  order_hub_id
  quote_hub_id
  quote_version
  user {
    ...user
  }
  billing_entity {
    ...entity
  }
  tracking_actions {
    ...serviceRequestTracking
  }
  note_hub_id
  assigned_admin_id
  brand_id
  registration_request_id
  last_status_update
  last_tracking_update
  created_by_user_id
  updated_by_user_id
  discount_coupon_id
}
    `;
export const BrandSubscriptionPaymentFragmentDoc = `
    fragment brandSubscriptionPayment on brand_subscription_payment {
  id
  brand_subscription_id
  user_payment_method_id
  product_id
  start_date
  end_date
  status
  created_at
  updated_at
  document_folder_id
  decline_reason
  billing_entity_id
  last_attempt_date
  number_of_attempts
}
    `;
export const ProductFragmentDoc = `
    fragment product on product {
  id
  registration_request {
    ...coreRegistrationFields
  }
  service_request {
    ...serviceRequest
  }
  brand_subscription_payment {
    ...brandSubscriptionPayment
  }
}
    `;
export const ProductInvoiceFragmentDoc = `
    fragment productInvoice on invoice {
  ...invoice
  product {
    ...product
  }
}
    `;
export const NoteFragmentDoc = `
    fragment note on note {
  __typename
  id
  text
  is_enabled
  created_at
  created_by
  note_hub_id
  document_id
}
    `;
export const NotificationFragmentDoc = `
    fragment notification on notification {
  id
  from_user_id
  to_user_id
  type
  message
  metadata
  seen_at
  deleted_at
  created_at
  updated_at
}
    `;
export const OfficeActionCommonDataFragmentDoc = `
    fragment officeActionCommonData on office_action {
  id
  assigned_admin_id
  trademark_id
  order_hub_id
  document_hub_id
  created_at
  last_status_update
  last_tracking_update
  status
  issue_date
  due_date
  tags
  risk_highlighted
  client_input
  recommendation_note
  client_delight
  order_currency
  supplemental_register_suggested
  nature_of_issues
  issue_summary
  note_hub_id
  issues_version
  suggested_issues
  updated_at
  created_by_user_id
  updated_by_user_id
  ai_issue_summary
  consent_denied_roa_service_request_id
  missive_link
  outcome
  is_final
}
    `;
export const TrademarkClassFragmentDoc = `
    fragment trademarkClass on trademark_class {
  __typename
  id
  trademark_id
  use_in_commerce_request_id
  class_number
  class_items
  filing_basis
  decision
  first_use_in_us
  first_use_anywhere
  websites
  filing_description
  document_folder_id
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  foreign_registration_basis
}
    `;
export const TrademarkFragmentDoc = `
    fragment trademark on trademark {
  __typename
  id
  name
  registration_date
  ipo_link
  number
  registration_number
  international_number
  filing_reference
  jurisdiction
  trademark_request_id
  filing_date
  document_hub_id
  type
  owner_entity_id
  representative_entity_id
  expiration_date
  dou_deadline_date
  user_id
  alias
  brand_id
  trademark_registration_id_legacy
  status
  status_group
  filing_postponed_reason
  filing_postponed_note
  last_status_update
  last_tracking_update
  filing_information
  brand_registry_code
  registration_request_id
  direct_filing
  assigned_admin_id
  assignee_history
  note_hub_id
  logo_type
  additional_info_legacy
  additional_info
  uspto_logo_subcategory
  color_claim
  priority_filing_data
  domicile_address_id
  mailing_address_id
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  opposition_period_start
  opposition_period_end
  trademark_classes(order_by: {class_number: asc}) {
    ...trademarkClass
  }
}
    `;
export const TrademarkDetailFragmentDoc = `
    fragment trademarkDetail on trademark {
  ...trademark
  documents(where: {type: {_in: ["Logo", "Registration certificate"]}}) {
    id
    created_at
    path
    type
    revision
    document_hub_id
  }
  user {
    email
    profile {
      firstname
      lastname
      phone_number
    }
  }
  tracking_actions {
    name
    created_at
  }
  owner_entity {
    ...entityData
  }
  representative_entity {
    ...entityData
  }
}
    `;
export const OfficeActionSolutionFragmentDoc = `
    fragment officeActionSolution on office_action_solution {
  id
  solution
  chance_of_success
  service_fee
  government_fee
  recommended
  service_request_id
  selected
  order {
    status
    product_id
    document_hub_id
  }
}
    `;
export const OfficeActionTrackingFragmentDoc = `
    fragment officeActionTracking on office_action_tracking {
  id
  created_at
  name
  office_action_id
}
    `;
export const OfficeActionIssueFragmentDoc = `
    fragment officeActionIssue on office_action_issue {
  id
  name
  category
  additional_info_note
  document_folder_id
}
    `;
export const OfficeActionSimilarTrademarkMapFragmentDoc = `
    fragment officeActionSimilarTrademarkMap on office_action_similar_trademark_map {
  __typename
  id
  office_action_id
  external_trademark_id
  external_trademark {
    ...externalTrademark
  }
}
    `;
export const OfficeActionFragmentDoc = `
    fragment officeAction on office_action {
  __typename
  ...officeActionCommonData
  documents {
    ...document
  }
  orders {
    ...serviceRequest
  }
  trademark {
    ...trademarkDetail
  }
  assigned_admin {
    ...user
  }
  solutions(order_by: {index: asc}) {
    ...officeActionSolution
  }
  tracking_actions {
    ...officeActionTracking
  }
  issues {
    ...officeActionIssue
  }
  office_action_similar_trademark_map {
    ...officeActionSimilarTrademarkMap
  }
}
    `;
export const OfficeActionSolutionForUserFragmentDoc = `
    fragment officeActionSolutionForUser on office_action_solution {
  id
  solution
  service_request_id
}
    `;
export const ServiceRequestUserFragmentDoc = `
    fragment serviceRequestUser on service_request {
  id
  public_id
  product_id
  service_name
  internal_label
  description
  parameters
  language
  region
  status
  currency
  billing_entity_id
  document_hub_id
  created_at
  updated_at
  last_status_update
  documents {
    ...document
  }
  trademark_watch_subscription {
    date_start
    date_end
    trademark_id
  }
  billing_entity {
    ...entity
  }
}
    `;
export const OfficeActionForUserFragmentDoc = `
    fragment officeActionForUser on office_action {
  id
  due_date
  issue_date
  trademark_id
  trademark {
    id
    type
    jurisdiction
    name
  }
  status
  client_input
  nature_of_issues
  issues_version
  documents {
    ...document
  }
  solutions(order_by: {index: asc}) {
    ...officeActionSolutionForUser
  }
  orders {
    ...serviceRequestUser
  }
  tracking_actions {
    ...officeActionTracking
  }
}
    `;
export const OfficeActionForUserDashboardFragmentDoc = `
    fragment officeActionForUserDashboard on office_action {
  id
  due_date
  status
  client_input
  nature_of_issues
  issues_version
  solutions(order_by: {index: asc}) {
    ...officeActionSolutionForUser
  }
  tracking_actions {
    ...officeActionTracking
  }
}
    `;
export const OfficeActionTrackingWithStatusFragmentDoc = `
    fragment officeActionTrackingWithStatus on office_action_tracking {
  ...officeActionTracking
  tracking_status {
    is_status
  }
}
    `;
export const OrderTrackingStatusFragmentDoc = `
    fragment orderTrackingStatus on order_tracking_status {
  __typename
  name
  is_status
}
    `;
export const TrademarkSharedDocumentsFragmentDoc = `
    fragment trademarkSharedDocuments on trademark_shared_documents {
  __typename
  id
  trademark_id
  document_id
}
    `;
export const PoaFragmentDoc = `
    fragment poa on poa {
  id
  document_id
  user_id
  type
  template_id
  status
  jurisdictions
  expiration_date
  created_at
  created_by_user_id
  updated_at
  updated_by_user_id
  owner_entity {
    ...entity
  }
  document {
    ...document
  }
  trademark_shared_documents {
    ...trademarkSharedDocuments
  }
}
    `;
export const ProductBundleFragmentDoc = `
    fragment productBundle on product_bundle {
  __typename
  id
  name
  category
  jurisdiction
  created_at
}
    `;
export const ProductEventFragmentDoc = `
    fragment productEvent on product_event {
  id
  product_id
  name
  data
  created_at
  updated_at
}
    `;
export const PriceFragmentDoc = `
    fragment price on price {
  __typename
  id
  price_rule_id
  active
  price_eur
  price_czk
  price_gbp
  price_usd
  price_aud
  price_chf
  price_cad
  price_nzd
  price_mxn
  price_zar
  partner_cost_eur
  created_at
}
    `;
export const PriceRuleFragmentDoc = `
    fragment priceRule on price_rule {
  __typename
  id
  product_v2_id
  type
  name
  config
  deleted
  created_at
  updated_at
  deleted_at
  prices(where: {active: {_eq: true}}) {
    ...price
  }
}
    `;
export const ProductV2FragmentDoc = `
    fragment productV2 on product_v2 {
  __typename
  id
  sku
  name
  category
  jurisdiction
  is_gov_fee
  invoice_translation_key
  parameters
  product_bundle_id
  bundle_sort_order
  deleted
  created_at
  updated_at
  deleted_at
  price_rules(where: {deleted: {_eq: false}}) {
    ...priceRule
  }
}
    `;
export const QuoteItemFragmentDoc = `
    fragment quoteItem on quote_item {
  __typename
  id
  quote_id
  product_id
  name
  quantity
  price
  is_gov_fee
  sort_order
  parameters
  created_at
  updated_at
}
    `;
export const OrderTrackingFragmentDoc = `
    fragment orderTracking on order_tracking {
  __typename
  id
  order_id
  name
  user_id
  created_at
}
    `;
export const OrderFragmentDoc = `
    fragment order on order {
  __typename
  id
  quote_id
  quote_hub_id
  user_id
  status
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  tracking_actions(order_by: {created_at: asc}) {
    ...orderTracking
  }
}
    `;
export const QuoteFragmentDoc = `
    fragment quote on quote {
  __typename
  id
  group_id
  quote_hub_id
  currency
  active
  parameters
  created_at
  updated_at
  created_by_user_id
  updated_by_user_id
  quote_items(order_by: {sort_order: asc}) {
    ...quoteItem
  }
  order {
    ...order
  }
}
    `;
export const QuoteHubFragmentDoc = `
    fragment quoteHub on quote_hub {
  __typename
  id
  type
  created_at
  quotes(where: {active: {_eq: true}}) {
    ...quote
  }
  orders {
    ...order
  }
}
    `;
export const RefundRequestFragmentDoc = `
    fragment refundRequest on refund_request {
  __typename
  id
  title
  missive_link
  issue
  our_fault
  e2e_refund
  reason_for_refund
  proposed_solution
  status
  last_status_update
  user_id
  assigned_admin_id
  note_hub_id
  document_hub_id
  refunded_government_fee
  refunded_service_fee
  refunded_partner_fee
  created_at
  created_by_user_id
  updated_at
  updated_by_user_id
}
    `;
export const RefundRequestInvoiceFragmentDoc = `
    fragment refundRequestInvoice on refund_request_invoice {
  __typename
  id
  refund_request_id
  invoice_id
}
    `;
export const RefundRequestTrackingFragmentDoc = `
    fragment refundRequestTracking on refund_request_tracking {
  id
  name
  created_at
  skipped
  user_id
  refund_request_id
}
    `;
export const RefundRequestTrackingWithStatusFragmentDoc = `
    fragment refundRequestTrackingWithStatus on refund_request_tracking {
  ...refundRequestTracking
  tracking_status {
    is_status
  }
}
    `;
export const TrademarkClassForUserFragmentDoc = `
    fragment trademarkClassForUser on trademark_class {
  class_number
  class_items
}
    `;
export const TrademarkForUserFragmentDoc = `
    fragment trademarkForUser on trademark {
  __typename
  alias
  brand_id
  created_at
  document_hub_id
  expiration_date
  dou_deadline_date
  filing_date
  id
  ipo_link
  jurisdiction
  last_tracking_update
  name
  number
  registration_number
  international_number
  owner_entity_id
  registration_date
  registration_request_id
  representative_entity_id
  status
  status_group
  trademark_request_id
  type
  user_id
  additional_info
  last_ipo_data_sync
  trademark_classes(order_by: {class_number: asc}) {
    ...trademarkClassForUser
  }
  tracking_actions {
    name
    created_at
  }
}
    `;
export const InvoiceForUserFragmentDoc = `
    fragment invoiceForUser on invoice {
  serial_number
  year
  variable_symbol
  created_at
  payment_date
  payment_type
  revolut_public_order_id
}
    `;
export const VerificationResultSimilarTrademarkMapForUserFragmentDoc = `
    fragment verificationResultSimilarTrademarkMapForUser on verification_result_similar_trademark_map {
  id
  verification_result_id
  external_trademark_id
  jurisdictions
  similarity
  metadata
  competitor
  similarity_of_marks
  similarity_of_gs
  external_trademark {
    ...externalTrademarkForUser
  }
}
    `;
export const VerificationResultForUserFragmentDoc = `
    fragment verificationResultForUser on verification_result {
  id
  registration_request_id
  version
  created_at
  updated_at
  jurisdictions
  transcription
  recommended_classes
  verified_classes
  additional_check_required
  use_narrow_gs_list
  distinctiveness
  result_note
  request_note
  similarity
  search_type
  other_refusal_reason
  running_business
  strategy
  support
  value_type
  document_id
  value
  completed
  trama_business_description
  similar_trademarks {
    ...similarTrademark
  }
  document {
    ...document
  }
  verification_result_similar_trademark_map {
    ...verificationResultSimilarTrademarkMapForUser
  }
}
    `;
export const RegistrationRequestFieldsForUserFragmentDoc = `
    fragment registrationRequestFieldsForUser on registration_request {
  __typename
  id
  public_id
  product_id
  value
  type
  contact_email
  contact_first_name
  contact_last_name
  contact_phone
  created_at
  currency
  discount_coupon {
    ...discountCoupon
  }
  gdrive_folder_id
  jurisdictions
  lawyer_services_help_required
  services
  client_business_description
  client_websites
  client_note
  mark_alias
  document_hub_id
  billing_entity {
    ...entityData
  }
  tracking_actions {
    ...registrationRequestTracking
  }
  application {
    registration_entity_id
    registration_entity {
      ...entityData
    }
  }
  trademarks(order_by: {jurisdiction: asc}) {
    ...trademarkForUser
    tracking_actions {
      created_at
      name
    }
  }
  documents {
    ...document
  }
  logo_document: documents(
    where: {type: {_eq: "Logo"}}
    limit: 1
    order_by: {created_at: desc}
  ) {
    ...document
  }
  invoice {
    ...invoiceForUser
  }
  status
  last_status_update
  ordered_items
  user_id
  service_type
  e2e_protection
  verification_results(order_by: {created_at: desc}) {
    ...verificationResultForUser
  }
  brand_id
  brand_protection
}
    `;
export const DraftingRegistrationFieldsFragmentDoc = `
    fragment draftingRegistrationFields on registration_request {
  ...coreRegistrationFields
  application {
    ...application
    mailing_address {
      ...address
    }
  }
  trademarks {
    jurisdiction
  }
  documents(
    where: {type: {_in: ["Specimen", "Registration PoA - unsigned", "Registration PoA - user signed", "Business certificate", "Logo", "Priority filing document", "Application logo in B&W", "Application logo series", "Application logo", "Passport", "Web domain proof", "Logo from client", "Registration PoA - template", "Foreign registration basis document"]}}
  ) {
    ...document
  }
}
    `;
export const RegistrationRequestLastStatusUpdateFragmentDoc = `
    fragment registrationRequestLastStatusUpdate on registration_request {
  id
  last_status_update
}
    `;
export const ReportViolationRegistrationFieldsFragmentDoc = `
    fragment reportViolationRegistrationFields on registration_request {
  id
  type
  value
  report_violation_url
  document_hub_id
  application_id
  logo_document: documents(
    where: {type: {_eq: "Logo"}}
    limit: 1
    order_by: {created_at: desc}
  ) {
    ...document
  }
  application {
    ...application
  }
  trademarks {
    jurisdiction
    id
    status
    number
    filing_date
  }
}
    `;
export const RegistrationRequestWithTrackingFieldsForUserFragmentDoc = `
    fragment registrationRequestWithTrackingFieldsForUser on registration_request {
  __typename
  id
  public_id
  product_id
  value
  type
  contact_email
  contact_first_name
  contact_last_name
  contact_phone
  created_at
  currency
  jurisdictions
  lawyer_services_help_required
  services
  client_business_description
  client_websites
  client_note
  mark_alias
  document_hub_id
  status
  last_status_update
  ordered_items
  user_id
  service_type
  e2e_protection
  brand_id
  tracking_actions {
    ...registrationRequestTracking
  }
}
    `;
export const RegistrationRequestFieldsForUserOrdersFragmentDoc = `
    fragment registrationRequestFieldsForUserOrders on registration_request {
  __typename
  id
  public_id
  product_id
  value
  type
  contact_email
  contact_first_name
  contact_last_name
  contact_phone
  created_at
  currency
  jurisdictions
  lawyer_services_help_required
  services
  client_business_description
  client_websites
  client_note
  mark_alias
  document_hub_id
  status
  last_status_update
  ordered_items
  user_id
  service_type
  e2e_protection
  brand_id
  trademarks(order_by: {jurisdiction: asc}) {
    ...trademarkForUser
    tracking_actions {
      created_at
      name
    }
  }
  verification_results(order_by: {created_at: desc}, limit: 1) {
    ...verificationResultForUser
  }
}
    `;
export const RegistrationRequestForUserDashboardFragmentDoc = `
    fragment registrationRequestForUserDashboard on registration_request {
  id
  product_id
  value
  type
  created_at
  jurisdictions
  document_hub_id
  tracking_actions {
    ...registrationRequestTracking
  }
  documents(where: {type: {_eq: "Invoice"}}) {
    ...document
  }
  status
  last_status_update
  user_id
}
    `;
export const RegistrationRequestTrackingWithStatusFragmentDoc = `
    fragment registrationRequestTrackingWithStatus on registration_request_tracking {
  ...registrationRequestTracking
  tracking_status {
    is_status
  }
}
    `;
export const ReminderFragmentDoc = `
    fragment reminder on reminder {
  __typename
  id
  user_id
  trigger_at
  triggered_at
  status
  notes
  resource_name
  resource_id
  created_at
  updated_at
  deleted_at
  created_by_user_id
  updated_by_user_id
  deleted_by_user_id
}
    `;
export const ServiceFragmentDoc = `
    fragment service on service {
  __typename
  id
  type
  service_request_id
  case_solution_id
  assigned_admin_id
  deadline
  status
  outcome
  outcome_note
  parameters
  note_hub_id
  document_hub_id
  last_status_update
  last_tracking_update
  created_by_user_id
  updated_by_user_id
  created_at
  updated_at
}
    `;
export const TrademarkServiceRequestsFragmentDoc = `
    fragment trademarkServiceRequests on trademark_service_requests {
  trademark_id
  service_request_id
  trademark {
    id
    jurisdiction
    type
    name
    number
    status
    owner_entity {
      ...entityData
    }
    documents {
      ...document
    }
    document_hub_id
    representative_entity {
      ...entityData
    }
  }
}
    `;
export const ServiceRequestWithTrademarksFragmentDoc = `
    fragment serviceRequestWithTrademarks on service_request {
  ...serviceRequest
  trademark_service_requests {
    ...trademarkServiceRequests
  }
}
    `;
export const ServiceTrackingFragmentDoc = `
    fragment serviceTracking on service_tracking {
  __typename
  id
  service_id
  name
  skipped
  user_id
  created_at
}
    `;
export const ServiceTrackingWithStatusFragmentDoc = `
    fragment serviceTrackingWithStatus on service_tracking {
  ...serviceTracking
  tracking_status {
    is_status
  }
}
    `;
export const StatisticFragmentDoc = `
    fragment statistic on statistic {
  id
  name
  value
  created_at
}
    `;
export const SupportTicketFragmentDoc = `
    fragment supportTicket on support_ticket {
  __typename
  id
  created_at
  updated_at
  resolved_at
  assigned_admin_id
  description
  resolution
  resource_name
  resource_id
  category
  status
  note_hub_id
  document_hub_id
  assigned_admin {
    ...user
  }
  created_by_user {
    email
  }
}
    `;
export const TaskFragmentDoc = `
    fragment task on task {
  id
  type
  data
  status
  execution_time
  created_at
  updated_at
  options
  result
}
    `;
export const CustomerPortalTrademarkDetailFragmentDoc = `
    fragment customerPortalTrademarkDetail on trademark {
  ...trademarkForUser
  trademark_request {
    id
    mark_alias
    status
  }
  registration_request {
    id
    client_websites
    client_business_description
  }
  documents {
    ...document
  }
  owner_entity {
    ...entityData
  }
  representative_entity {
    ...entityData
  }
  trademark_watch_subscription(order_by: {date_start: desc}) {
    date_start
    date_end
    type
    service_request_id
  }
}
    `;
export const EntityOwnPropertiesFragmentDoc = `
    fragment entityOwnProperties on entity {
  type
  business_name
  state_of_incorporation
  country_of_incorporation
  first_name
  last_name
  email
  phone
  address {
    ...addressData
  }
}
    `;
export const TrademarkOwnPropertiesFragmentDoc = `
    fragment trademarkOwnProperties on trademark {
  id
  jurisdiction
  number
  registration_number
  international_number
  status
  name
  trademark_classes(order_by: {class_number: asc}) {
    ...trademarkClass
  }
  ipo_link
  filing_date
  registration_date
  expiration_date
  dou_deadline_date
  type
  owner_entity {
    ...entityOwnProperties
  }
  representative_entity {
    ...entityOwnProperties
  }
  additional_info
}
    `;
export const TrademarkForUserDashboardFragmentDoc = `
    fragment trademarkForUserDashboard on trademark {
  id
  type
  jurisdiction
  last_tracking_update
  name
  number
  created_at
  status
  dou_deadline_date
  user_id
  opposition_period_start
  opposition_period_end
}
    `;
export const TrademarkIpoDataFragmentDoc = `
    fragment trademarkIpoData on trademark_ipo_data {
  number
  jurisdiction
  updated_at
  data
  source
  status
  next_sync_due_at
  status_change_date
  trademark_id
}
    `;
export const TrademarkMonitoringResultCommonDataFragmentDoc = `
    fragment trademarkMonitoringResultCommonData on trademark_monitoring_result {
  id
  type
  relevance
  created_at
  publication_date
  filing_date
  application_number
  trademark_number
  mark_name
  mark_type
  classes
  jurisdiction
  trademark_id
  ipo_link
  order_hub_id
  seen
  markify_logo_url
}
    `;
export const TrademarkMonitoringResultFragmentDoc = `
    fragment trademarkMonitoringResult on trademark_monitoring_result {
  ...trademarkMonitoringResultCommonData
  document_hub_id
  documents {
    ...document
  }
}
    `;
export const TrademarkMonitoringResultUserFragmentDoc = `
    fragment trademarkMonitoringResultUser on trademark_monitoring_result {
  ...trademarkMonitoringResultCommonData
  trademark {
    user_id
    user {
      email
    }
  }
}
    `;
export const TrademarkMonitoringResultForUserFragmentDoc = `
    fragment trademarkMonitoringResultForUser on trademark_monitoring_result {
  ...trademarkMonitoringResultCommonData
  trademark {
    ...trademarkForUser
  }
  documents {
    ...document
  }
  orders {
    ...serviceRequestUser
  }
}
    `;
export const TrademarkRateLimitLogFragmentDoc = `
    fragment trademarkRateLimitLog on trademark_rate_limit_log {
  id
  source
  request_count
  created_at
}
    `;
export const TrademarkRequestFragmentDoc = `
    fragment trademarkRequest on trademark_request {
  id
  mark_alias
  jurisdictions
  created_at
  user_id
  trademarks {
    ...trademarkForUser
  }
}
    `;
export const TrademarkRequestDataFragmentDoc = `
    fragment trademarkRequestData on trademark_request {
  id
  mark_alias
  created_at
  status
  jurisdictions
  brand_id
}
    `;
export const TrademarkSharedDocumentsWithDocumentFragmentDoc = `
    fragment trademarkSharedDocumentsWithDocument on trademark_shared_documents {
  ...trademarkSharedDocuments
  document {
    ...document
  }
}
    `;
export const TrademarkTrackingFragmentDoc = `
    fragment trademarkTracking on trademark_tracking {
  id
  trademark_id
  name
  skipped
  user_id
  created_at
}
    `;
export const TrademarkTrackingWithStatusFragmentDoc = `
    fragment trademarkTrackingWithStatus on trademark_tracking {
  ...trademarkTracking
  tracking_status {
    is_status
  }
}
    `;
export const TrademarkWatchSubscriptionFragmentDoc = `
    fragment trademarkWatchSubscription on trademark_watch_subscription {
  id
  markify_id
  date_start
  date_end
  trademark_id
  user_id
}
    `;
export const UseInCommerceRequestForUserFragmentDoc = `
    fragment useInCommerceRequestForUser on use_in_commerce_request {
  id
  status
  type
  kickoff_type
  due_date
  grace_period_deadline
}
    `;
export const UseInCommerceRequestFragmentDoc = `
    fragment useInCommerceRequest on use_in_commerce_request {
  __typename
  id
  type
  kickoff_type
  declaration_of_incontestability
  remaining_extension_count
  status
  last_status_update
  last_tracking_update
  trademark_id
  assigned_admin_id
  document_hub_id
  order_hub_id
  issue_date
  due_date
  created_at
  updated_at
  updated_by_user_id
  parent_id
  order_id
  note_hub_id
  child_trademark_id
  grace_period_deadline
}
    `;
export const SpecimenFragmentDoc = `
    fragment specimen on specimen {
  id
  application_id
  trademark_class_id
  document_id
  description
  url
  class_number
  class_items
  capture_date
  uspto_requirements
  created_at
  updated_at
  document {
    ...document
  }
}
    `;
export const TrademarkClassWithSpecimensFragmentDoc = `
    fragment trademarkClassWithSpecimens on trademark_class {
  ...trademarkClass
  specimens {
    ...specimen
  }
}
    `;
export const UseInCommerceRequestTrackingFragmentDoc = `
    fragment useInCommerceRequestTracking on use_in_commerce_request_tracking {
  id
  name
  created_at
  skipped
  user_id
  use_in_commerce_request_id
}
    `;
export const UseInCommerceRequestForDraftingFragmentDoc = `
    fragment useInCommerceRequestForDrafting on use_in_commerce_request {
  ...useInCommerceRequest
  trademark {
    ...trademarkDetail
  }
  trademark_classes(order_by: {class_number: asc}) {
    ...trademarkClassWithSpecimens
  }
  tracking_actions {
    ...useInCommerceRequestTracking
  }
  comments(where: {thread_id: {_eq: "note"}}, order_by: {created_at: asc}) {
    ...threadComment
  }
}
    `;
export const UseInCommerceRequestTrackingWithStatusFragmentDoc = `
    fragment useInCommerceRequestTrackingWithStatus on use_in_commerce_request_tracking {
  ...useInCommerceRequestTracking
  tracking_status {
    is_status
  }
}
    `;
export const UseInCommerceRequestTrackingForUserFragmentDoc = `
    fragment useInCommerceRequestTrackingForUser on use_in_commerce_request_tracking {
  name
  created_at
}
    `;
export const UserWithSecretFieldsFragmentDoc = `
    fragment userWithSecretFields on user {
  ...user
  password_hash
  refresh_token
}
    `;
export const UserForUserFragmentDoc = `
    fragment userForUser on user {
  __typename
  id
  email
  role
  status
  revolut_id
  cp_onboarding_finished
  profile {
    ...profile
  }
}
    `;
export const UserAuthLogFragmentDoc = `
    fragment userAuthLog on user_auth_log {
  __typename
  id
  user_id
  action_type
  ip_address
  vpn_provider
  device_info
  location
  metadata
  created_at
}
    `;
export const UserHistoryFragmentDoc = `
    fragment userHistory on user_history {
  __typename
  id
  email
  user_id
  created_at
  created_by_user_id
}
    `;
export const UserPaymentMethodFragmentDoc = `
    fragment userPaymentMethod on user_payment_method {
  id
  user_id
  revolut_id
  card_brand
  card_expiration
  card_last_four
  created_at
  updated_at
  status
  validation_order_id
}
    `;
export const UserPaymentMethodForUserFragmentDoc = `
    fragment userPaymentMethodForUser on user_payment_method {
  id
  user_id
  card_brand
  card_expiration
  card_last_four
  created_at
  updated_at
  status
}
    `;
export const UserTrackingFragmentDoc = `
    fragment userTracking on user_tracking {
  id
  user_id
  name
  skipped
  created_by_user_id
  created_at
}
    `;
export const UserTrackingWithStatusFragmentDoc = `
    fragment userTrackingWithStatus on user_tracking {
  ...userTracking
  tracking_status {
    is_status
  }
}
    `;
export const WebsiteFragmentDoc = `
    fragment website on website {
  ...websiteForUser
  metadata
  type
  created_at
  updated_at
}
    `;
export const AddressInsertOneDocument = `
    mutation addressInsertOne($object: address_insert_input!) {
  insert_address_one(object: $object) {
    ...address
  }
}
    ${AddressFragmentDoc}
${AddressDataFragmentDoc}`;
export const AddressUpsertOneDocument = `
    mutation addressUpsertOne($object: address_insert_input!) {
  insert_address_one(
    object: $object
    on_conflict: {constraint: address_pkey, update_columns: [city, country, postcode, state, street, updated_by_user_id]}
  ) {
    ...address
  }
}
    ${AddressFragmentDoc}
${AddressDataFragmentDoc}`;
export const AddressUpdateOneDocument = `
    mutation addressUpdateOne($id: Int!, $changes: address_set_input!) {
  update_address_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...address
  }
}
    ${AddressFragmentDoc}
${AddressDataFragmentDoc}`;
export const AddressDeleteOneDocument = `
    mutation addressDeleteOne($id: Int!, $userId: uuid) {
  delete_address_by_pk_audited(args: {aid: $id, user_id: $userId}) {
    ...address
  }
}
    ${AddressFragmentDoc}
${AddressDataFragmentDoc}`;
export const AddressGetByIdDocument = `
    query addressGetById($id: Int!) {
  address_by_pk(id: $id) {
    ...address
  }
}
    ${AddressFragmentDoc}
${AddressDataFragmentDoc}`;
export const AiGsItemsAnalysisInsertOneDocument = `
    mutation aiGsItemsAnalysisInsertOne($object: ai_gs_items_analysis_insert_input!) {
  insert_ai_gs_items_analysis_one(object: $object) {
    ...aiGsItemsAnalysis
  }
}
    ${AiGsItemsAnalysisFragmentDoc}`;
export const AiGsItemsAnalysisGetManyDocument = `
    query aiGsItemsAnalysisGetMany($where: ai_gs_items_analysis_bool_exp!, $order_by: [ai_gs_items_analysis_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [ai_gs_items_analysis_select_column!]) {
  ai_gs_items_analysis(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...aiGsItemsAnalysis
  }
}
    ${AiGsItemsAnalysisFragmentDoc}`;
export const ApplicationInsertOneDocument = `
    mutation applicationInsertOne($object: application_insert_input!) {
  insert_application_one(object: $object) {
    ...application
  }
}
    ${ApplicationFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const ApplicationUpdateDocument = `
    mutation applicationUpdate($id: uuid!, $changes: application_set_input!) {
  update_application_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...application
  }
}
    ${ApplicationFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const ApplicationGetManyDocument = `
    query applicationGetMany($filter: application_bool_exp = {}, $order_by: [application_order_by!] = {}) {
  application(where: $filter, order_by: $order_by) {
    ...application
  }
}
    ${ApplicationFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const ApplicationGetByIdDocument = `
    query applicationGetById($id: uuid!) {
  application_by_pk(id: $id) {
    ...application
  }
}
    ${ApplicationFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}
${AddressFragmentDoc}`;
export const ApplicationDataByIdDocument = `
    query applicationDataById($id: uuid!) {
  application_by_pk(id: $id) {
    ...applicationData
  }
}
    ${ApplicationDataFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ApplicationJurisdictionUpdateByIdDocument = `
    mutation applicationJurisdictionUpdateById($id: uuid!, $_set: application_jurisdiction_set_input!) {
  update_application_jurisdiction_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...applicationJurisdiction
  }
}
    ${ApplicationJurisdictionFragmentDoc}`;
export const ApplicationJurisdictionUpdateMultipleDocument = `
    mutation applicationJurisdictionUpdateMultiple($updates: [application_jurisdiction_updates!]!) {
  update_application_jurisdiction_many(updates: $updates) {
    returning {
      ...applicationJurisdiction
    }
  }
}
    ${ApplicationJurisdictionFragmentDoc}`;
export const ApplicationJurisdictionDeleteManyDocument = `
    mutation applicationJurisdictionDeleteMany($where: application_jurisdiction_bool_exp!) {
  delete_application_jurisdiction(where: $where) {
    returning {
      ...applicationJurisdiction
    }
  }
}
    ${ApplicationJurisdictionFragmentDoc}`;
export const ApplicationJurisdictionInsertManyDocument = `
    mutation applicationJurisdictionInsertMany($objects: [application_jurisdiction_insert_input!]!) {
  insert_application_jurisdiction(objects: $objects) {
    returning {
      ...applicationJurisdiction
    }
  }
}
    ${ApplicationJurisdictionFragmentDoc}`;
export const ApplicationJurisdictionGetManyDocument = `
    query applicationJurisdictionGetMany($where: application_jurisdiction_bool_exp = {}, $order_by: [application_jurisdiction_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [application_jurisdiction_select_column!]) {
  application_jurisdiction(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...applicationJurisdiction
  }
}
    ${ApplicationJurisdictionFragmentDoc}`;
export const TrademarkAuditLogDocument = `
    query trademarkAuditLog($trademark_id: uuid!, $order_by: [trademark_audit_log_order_by!], $limit: Int, $offset: Int) {
  trademark_audit_log(
    args: {trademark_id: $trademark_id}
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    created_at
    id
    new_values
    old_values
    operation
    property
    record_id_int
    record_id_uuid
    table_name
    user_id
  }
}
    `;
export const TrademarkAuditLogCountDocument = `
    query trademarkAuditLogCount($trademark_id: uuid!) {
  trademark_audit_log_count(args: {trademark_id: $trademark_id}) {
    count
  }
}
    `;
export const BrandInsertOneDocument = `
    mutation brandInsertOne($object: brand_insert_input!) {
  insert_brand_one(object: $object) {
    ...brand
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandInsertManyDocument = `
    mutation brandInsertMany($objects: [brand_insert_input!]!) {
  insert_brand(objects: $objects) {
    returning {
      ...brand
    }
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandUpdateOneDocument = `
    mutation brandUpdateOne($id: uuid!, $changes: brand_set_input!) {
  update_brand_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...brand
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandDeleteOneDocument = `
    mutation brandDeleteOne($id: uuid!) {
  delete_brand_by_pk(id: $id) {
    ...brand
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandGetByIdDocument = `
    query brandGetById($id: uuid!, $deleted: Boolean!) {
  brand(
    where: {id: {_eq: $id}, _or: [{deleted: {_eq: false}}, {deleted: {_eq: $deleted}}]}
    limit: 1
  ) {
    ...brand
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandGetByIdForUserDocument = `
    query brandGetByIdForUser($id: uuid!, $deleted: Boolean!) {
  brand(
    where: {id: {_eq: $id}, _or: [{deleted: {_eq: false}}, {deleted: {_eq: $deleted}}]}
  ) {
    ...brandForUser
  }
}
    ${BrandForUserFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandGetManyDocument = `
    query brandGetMany($filter: brand_bool_exp = {}, $order_by: [brand_order_by!] = {}) {
  brand(where: $filter, order_by: $order_by) {
    ...brand
  }
}
    ${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandGetManyForUserDocument = `
    query brandGetManyForUser($filter: brand_bool_exp = {}, $order_by: [brand_order_by!] = {}, $limit: Int, $offset: Int) {
  brand(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    ...brandForUser
  }
  brand_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${BrandForUserFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const BrandWithRecentTasksGetManyForUserDocument = `
    query brandWithRecentTasksGetManyForUser($filter: brand_bool_exp = {}, $task_count: Int = 5) {
  brand(where: $filter) {
    id
    tasks(order_by: {last_status_update: desc}, limit: $task_count) {
      status
      last_status_update
    }
  }
}
    `;
export const MonitoredBrandsTotalCountDocument = `
    query monitoredBrandsTotalCount($userId: uuid!) {
  brand_aggregate(
    where: {user_id: {_eq: $userId}, _or: [{brand_subscriptions: {status: {_eq: "Created"}, tracking_actions: {name: {_eq: "Checkout completed"}}}}, {brand_subscriptions: {status: {_in: ["Subscription started", "Trial started"]}}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const BrandMonitoringTaskInsertOneDocument = `
    mutation brandMonitoringTaskInsertOne($object: brand_monitoring_task_insert_input!) {
  insert_brand_monitoring_task_one(object: $object) {
    ...brandMonitoringTask
  }
}
    ${BrandMonitoringTaskFragmentDoc}`;
export const BrandMonitoringTaskUpdateOneDocument = `
    mutation brandMonitoringTaskUpdateOne($id: uuid!, $changes: brand_monitoring_task_set_input) {
  update_brand_monitoring_task_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...brandMonitoringTask
  }
}
    ${BrandMonitoringTaskFragmentDoc}`;
export const BrandMonitoringTaskGetByIdDocument = `
    query brandMonitoringTaskGetById($id: uuid!) {
  brand_monitoring_task_by_pk(id: $id) {
    ...brandMonitoringTask
  }
}
    ${BrandMonitoringTaskFragmentDoc}`;
export const BrandMonitoringTaskGetManyDocument = `
    query brandMonitoringTaskGetMany($where: brand_monitoring_task_bool_exp!, $order_by: [brand_monitoring_task_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [brand_monitoring_task_select_column!]) {
  brand_monitoring_task(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...brandMonitoringTask
  }
}
    ${BrandMonitoringTaskFragmentDoc}`;
export const BrandMonitoringTaskTrackingInsertOneDocument = `
    mutation brandMonitoringTaskTrackingInsertOne($object: brand_monitoring_task_tracking_insert_input!) {
  insert_brand_monitoring_task_tracking_one(object: $object) {
    ...brandMonitoringTaskTracking
  }
}
    ${BrandMonitoringTaskTrackingFragmentDoc}`;
export const BrandMonitoringTaskTrackingDeleteOneDocument = `
    mutation brandMonitoringTaskTrackingDeleteOne($id: Int!) {
  delete_brand_monitoring_task_tracking_by_pk(id: $id) {
    ...brandMonitoringTaskTracking
  }
}
    ${BrandMonitoringTaskTrackingFragmentDoc}`;
export const BrandMonitoringTaskTrackingGetManyDocument = `
    query brandMonitoringTaskTrackingGetMany($where: brand_monitoring_task_tracking_bool_exp = {}, $order_by: [brand_monitoring_task_tracking_order_by!] = {}, $offset: Int, $limit: Int) {
  brand_monitoring_task_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...brandMonitoringTaskTracking
  }
}
    ${BrandMonitoringTaskTrackingFragmentDoc}`;
export const BrandMonitoringTaskTrackingWithStatusGetManyDocument = `
    query brandMonitoringTaskTrackingWithStatusGetMany($where: brand_monitoring_task_tracking_bool_exp = {}, $order_by: [brand_monitoring_task_tracking_order_by!] = {}, $offset: Int, $limit: Int) {
  brand_monitoring_task_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...brandMonitoringTaskTrackingWithStatus
  }
}
    ${BrandMonitoringTaskTrackingWithStatusFragmentDoc}
${BrandMonitoringTaskTrackingFragmentDoc}`;
export const BrandSnapshotInsertOneDocument = `
    mutation brandSnapshotInsertOne($object: brand_snapshot_insert_input!) {
  insert_brand_snapshot_one(object: $object) {
    ...brandSnapshot
  }
}
    ${BrandSnapshotFragmentDoc}`;
export const BrandSubscriptionInsertOneDocument = `
    mutation brandSubscriptionInsertOne($object: brand_subscription_insert_input!) {
  insert_brand_subscription_one(object: $object) {
    ...brandSubscription
  }
}
    ${BrandSubscriptionFragmentDoc}`;
export const BrandSubscriptionUpdateOneDocument = `
    mutation brandSubscriptionUpdateOne($id: uuid!, $changes: brand_subscription_set_input) {
  update_brand_subscription_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...brandSubscription
  }
}
    ${BrandSubscriptionFragmentDoc}`;
export const BrandSubscriptionUpdateManyDocument = `
    mutation brandSubscriptionUpdateMany($where: brand_subscription_bool_exp!, $set: brand_subscription_set_input!) {
  update_brand_subscription(where: $where, _set: $set) {
    returning {
      ...brandSubscription
    }
  }
}
    ${BrandSubscriptionFragmentDoc}`;
export const BrandSubscriptionGetByIdDocument = `
    query brandSubscriptionGetById($id: uuid!) {
  brand_subscription_by_pk(id: $id) {
    ...brandSubscription
  }
}
    ${BrandSubscriptionFragmentDoc}`;
export const BrandSubscriptionGetDetailsByIdDocument = `
    query brandSubscriptionGetDetailsById($id: uuid!) {
  brand_subscription_by_pk(id: $id) {
    ...brandSubscriptionDetails
  }
}
    ${BrandSubscriptionDetailsFragmentDoc}
${BrandSubscriptionFragmentDoc}
${BrandFragmentDoc}
${WebsiteForUserFragmentDoc}
${BrandSubscriptionPlatformFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DiscountCouponFragmentDoc}`;
export const BrandSubscriptionGetManyDocument = `
    query brandSubscriptionGetMany($where: brand_subscription_bool_exp!, $order_by: [brand_subscription_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [brand_subscription_select_column!]) {
  brand_subscription(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...brandSubscription
  }
}
    ${BrandSubscriptionFragmentDoc}`;
export const BrandSubscriptionCountDocument = `
    query brandSubscriptionCount($filter: brand_subscription_bool_exp = {}) {
  brand_subscription_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserDocument = `
    query brandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUser($where: brand_subscription_bool_exp!, $order_by: [brand_subscription_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [brand_subscription_select_column!]) {
  brand_subscription(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...brandSubscriptionForUser
    brand {
      ...brandForUser
    }
    brand_subscription_payments(order_by: {created_at: desc_nulls_last}, limit: 1) {
      ...brandSubscriptionPaymentForUser
    }
    platforms {
      ...brandSubscriptionPlatformForUser
    }
    billing_entity {
      ...entityData
    }
    user_payment_method {
      ...userPaymentMethodForUser
    }
    discount_coupon {
      ...discountCoupon
    }
  }
}
    ${BrandSubscriptionForUserFragmentDoc}
${BrandForUserFragmentDoc}
${WebsiteForUserFragmentDoc}
${BrandSubscriptionPaymentForUserFragmentDoc}
${BrandSubscriptionPlatformForUserFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${UserPaymentMethodForUserFragmentDoc}
${DiscountCouponFragmentDoc}`;
export const CasesInLastTaskTotalCountDocument = `
    query casesInLastTaskTotalCount($filterSubscription: brand_subscription_bool_exp!, $filterCase: case_bool_exp!) {
  brand_subscription(where: $filterSubscription) {
    brand_monitoring_tasks(
      limit: 1
      order_by: {last_status_update: desc_nulls_last}
      where: {status: {_eq: "Processed"}}
    ) {
      cases_aggregate(where: $filterCase) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;
export const BrandSubscriptionWithLastTaskGetManyDocument = `
    query brandSubscriptionWithLastTaskGetMany($where: brand_subscription_bool_exp!, $order_by: [brand_subscription_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [brand_subscription_select_column!]) {
  brand_subscription(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...brandSubscription
    brand_monitoring_tasks(order_by: {deadline: desc_nulls_last}, limit: 1) {
      ...brandMonitoringTask
    }
  }
}
    ${BrandSubscriptionFragmentDoc}
${BrandMonitoringTaskFragmentDoc}`;
export const BrandSubscriptionPaymentInsertOneDocument = `
    mutation brandSubscriptionPaymentInsertOne($object: brand_subscription_payment_insert_input!) {
  insert_brand_subscription_payment_one(object: $object) {
    ...brandSubscriptionPayment
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPaymentUpsertOneDocument = `
    mutation brandSubscriptionPaymentUpsertOne($object: brand_subscription_payment_insert_input!) {
  insert_brand_subscription_payment_one(
    object: $object
    on_conflict: {constraint: brand_subscription_payment_pkey, update_columns: [billing_entity_id, brand_subscription_id, decline_reason, end_date, start_date, status, updated_at, user_payment_method_id]}
  ) {
    ...brandSubscriptionPayment
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPaymentUpdateOneDocument = `
    mutation brandSubscriptionPaymentUpdateOne($id: uuid!, $changes: brand_subscription_payment_set_input) {
  update_brand_subscription_payment_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...brandSubscriptionPayment
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPaymentDeleteManyDocument = `
    mutation brandSubscriptionPaymentDeleteMany($where: brand_subscription_payment_bool_exp!) {
  delete_brand_subscription_payment(where: $where) {
    affected_rows
    returning {
      ...brandSubscriptionPayment
    }
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPaymentGetByIdDocument = `
    query brandSubscriptionPaymentGetById($id: uuid!) {
  brand_subscription_payment_by_pk(id: $id) {
    ...brandSubscriptionPayment
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPaymentGetManyDocument = `
    query brandSubscriptionPaymentGetMany($where: brand_subscription_payment_bool_exp = {}, $order_by: [brand_subscription_payment_order_by!], $offset: Int, $limit: Int, $distinct_on: [brand_subscription_payment_select_column!]) {
  brand_subscription_payment(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...brandSubscriptionPayment
  }
}
    ${BrandSubscriptionPaymentFragmentDoc}`;
export const BrandSubscriptionPlatformInsertOneDocument = `
    mutation brandSubscriptionPlatformInsertOne($object: brand_subscription_platform_insert_input!) {
  insert_brand_subscription_platform_one(object: $object) {
    ...brandSubscriptionPlatform
  }
}
    ${BrandSubscriptionPlatformFragmentDoc}`;
export const BrandSubscriptionPlatformUpdateOneDocument = `
    mutation brandSubscriptionPlatformUpdateOne($id: uuid!, $changes: brand_subscription_platform_set_input) {
  update_brand_subscription_platform_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...brandSubscriptionPlatform
  }
}
    ${BrandSubscriptionPlatformFragmentDoc}`;
export const BrandSubscriptionPlatformDeleteManyDocument = `
    mutation brandSubscriptionPlatformDeleteMany($where: brand_subscription_platform_bool_exp!) {
  delete_brand_subscription_platform(where: $where) {
    returning {
      ...brandSubscriptionPlatform
    }
  }
}
    ${BrandSubscriptionPlatformFragmentDoc}`;
export const BrandSubscriptionPlatformGetManyDocument = `
    query brandSubscriptionPlatformGetMany($where: brand_subscription_platform_bool_exp = {}, $order_by: [brand_subscription_platform_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [brand_subscription_platform_select_column!]) {
  brand_subscription_platform(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...brandSubscriptionPlatform
  }
}
    ${BrandSubscriptionPlatformFragmentDoc}`;
export const BrandSubscriptionTrackingInsertOneDocument = `
    mutation brandSubscriptionTrackingInsertOne($object: brand_subscription_tracking_insert_input!) {
  insert_brand_subscription_tracking_one(object: $object) {
    ...brandSubscriptionTracking
  }
}
    ${BrandSubscriptionTrackingFragmentDoc}`;
export const BrandSubscriptionTrackingDeleteOneDocument = `
    mutation brandSubscriptionTrackingDeleteOne($id: Int!) {
  delete_brand_subscription_tracking_by_pk(id: $id) {
    ...brandSubscriptionTracking
  }
}
    ${BrandSubscriptionTrackingFragmentDoc}`;
export const BrandSubscriptionTrackingGetManyDocument = `
    query brandSubscriptionTrackingGetMany($where: brand_subscription_tracking_bool_exp = {}, $order_by: [brand_subscription_tracking_order_by!] = {}, $offset: Int, $limit: Int) {
  brand_subscription_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...brandSubscriptionTracking
  }
}
    ${BrandSubscriptionTrackingFragmentDoc}`;
export const BrandSubscriptionTrackingWithStatusGetManyDocument = `
    query brandSubscriptionTrackingWithStatusGetMany($where: brand_subscription_tracking_bool_exp = {}, $order_by: [brand_subscription_tracking_order_by!] = {}, $offset: Int, $limit: Int) {
  brand_subscription_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...brandSubscriptionTrackingWithStatus
  }
}
    ${BrandSubscriptionTrackingWithStatusFragmentDoc}
${BrandSubscriptionTrackingFragmentDoc}`;
export const CaseInsertOneDocument = `
    mutation caseInsertOne($object: case_insert_input!) {
  insert_case_one(object: $object) {
    ...case
  }
}
    ${CaseFragmentDoc}`;
export const CaseUpdateOneDocument = `
    mutation caseUpdateOne($id: uuid!, $changes: case_set_input) {
  update_case_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...case
  }
}
    ${CaseFragmentDoc}`;
export const CaseGetByIdDocument = `
    query caseGetById($id: uuid!) {
  case_by_pk(id: $id) {
    ...case
  }
}
    ${CaseFragmentDoc}`;
export const CaseGetManyDocument = `
    query caseGetMany($where: case_bool_exp!, $order_by: [case_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_select_column!]) {
  case(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...case
  }
}
    ${CaseFragmentDoc}`;
export const CaseWithCounterpartyGetManyDocument = `
    query caseWithCounterpartyGetMany($where: case_bool_exp!, $order_by: [case_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_select_column!]) {
  case(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseWithCounterparty
  }
}
    ${CaseWithCounterpartyFragmentDoc}
${CaseFragmentDoc}
${CaseCounterpartyFragmentDoc}`;
export const CaseGetManyForUserDocument = `
    query caseGetManyForUser($filter: case_bool_exp!, $order_by: [case_order_by!] = {}, $offset: Int, $limit: Int) {
  case(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...caseForUser
    counterparty {
      ...caseCounterpartyForUser
    }
    infringements {
      ...caseInfringementForUser
    }
    tracking_actions {
      ...caseTrackingForUser
    }
    solutions(order_by: {created_at: desc}) {
      ...caseSolutionForUser
    }
  }
  case_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${CaseForUserFragmentDoc}
${WebsiteForUserFragmentDoc}
${CaseCounterpartyForUserFragmentDoc}
${CaseInfringementForUserFragmentDoc}
${CaseTrackingForUserFragmentDoc}
${CaseSolutionForUserFragmentDoc}`;
export const CasesTotalCountDocument = `
    query casesTotalCount($filter: case_bool_exp!) {
  case_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const CaseGetByIdForUserDocument = `
    query caseGetByIdForUser($id: uuid!) {
  case_by_pk(id: $id) {
    ...caseForUser
    brand {
      id
      name
      user {
        status
      }
      brand_subscriptions {
        id
        status
        tier
        end_date
      }
    }
    counterparty {
      ...caseCounterpartyForUser
    }
    infringements {
      ...caseInfringementForUser
      evidences {
        ...caseInfringementEvidenceForUser
      }
    }
    tracking_actions {
      ...caseTrackingForUser
    }
    solutions(order_by: {created_at: desc}) {
      ...caseSolutionForUser
    }
    documents(order_by: {created_at: desc}) {
      ...document
    }
  }
}
    ${CaseForUserFragmentDoc}
${WebsiteForUserFragmentDoc}
${CaseCounterpartyForUserFragmentDoc}
${CaseInfringementForUserFragmentDoc}
${CaseInfringementEvidenceForUserFragmentDoc}
${ExternalTrademarkForUserFragmentDoc}
${CaseTrackingForUserFragmentDoc}
${CaseSolutionForUserFragmentDoc}
${DocumentFragmentDoc}`;
export const CaseIdWithCounterpartyGetManyDocument = `
    query caseIdWithCounterpartyGetMany($where: case_bool_exp!, $order_by: [case_order_by!] = {}) {
  case(where: $where, order_by: $order_by) {
    id
    created_at
    counterparty {
      id
      primary_name
    }
  }
}
    `;
export const CaseCounterpartyInsertOneDocument = `
    mutation caseCounterpartyInsertOne($object: case_counterparty_insert_input!) {
  insert_case_counterparty_one(object: $object) {
    ...caseCounterparty
  }
}
    ${CaseCounterpartyFragmentDoc}`;
export const CaseCounterpartyUpdateOneDocument = `
    mutation caseCounterpartyUpdateOne($id: uuid!, $changes: case_counterparty_set_input) {
  update_case_counterparty_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...caseCounterparty
  }
}
    ${CaseCounterpartyFragmentDoc}`;
export const CaseCounterpartyGetByIdDocument = `
    query caseCounterpartyGetById($id: uuid!) {
  case_counterparty_by_pk(id: $id) {
    ...caseCounterparty
  }
}
    ${CaseCounterpartyFragmentDoc}`;
export const CaseCounterpartyGetManyDocument = `
    query caseCounterpartyGetMany($where: case_counterparty_bool_exp!, $order_by: [case_counterparty_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_counterparty_select_column!]) {
  case_counterparty(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseCounterparty
  }
}
    ${CaseCounterpartyFragmentDoc}`;
export const CaseCounterpartyGetManyForUserDocument = `
    query caseCounterpartyGetManyForUser($where: case_counterparty_bool_exp!, $order_by: [case_counterparty_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_counterparty_select_column!]) {
  case_counterparty(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseCounterpartyForUser
  }
}
    ${CaseCounterpartyForUserFragmentDoc}`;
export const CaseInfringementInsertOneDocument = `
    mutation caseInfringementInsertOne($object: case_infringement_insert_input!) {
  insert_case_infringement_one(object: $object) {
    ...caseInfringement
  }
}
    ${CaseInfringementFragmentDoc}`;
export const CaseInfringementUpdateOneDocument = `
    mutation caseInfringementUpdateOne($id: uuid!, $changes: case_infringement_set_input) {
  update_case_infringement_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...caseInfringement
  }
}
    ${CaseInfringementFragmentDoc}`;
export const CaseInfringementDeleteOneDocument = `
    mutation caseInfringementDeleteOne($id: uuid!) {
  delete_case_infringement_by_pk(id: $id) {
    ...caseInfringement
  }
}
    ${CaseInfringementFragmentDoc}`;
export const CaseInfringementGetByIdDocument = `
    query caseInfringementGetById($id: uuid!) {
  case_infringement_by_pk(id: $id) {
    ...caseInfringement
  }
}
    ${CaseInfringementFragmentDoc}`;
export const CaseInfringementGetManyDocument = `
    query caseInfringementGetMany($where: case_infringement_bool_exp!, $order_by: [case_infringement_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_infringement_select_column!]) {
  case_infringement(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseInfringement
  }
}
    ${CaseInfringementFragmentDoc}`;
export const CaseInfringementEvidenceInsertOneDocument = `
    mutation caseInfringementEvidenceInsertOne($object: case_infringement_evidence_insert_input!) {
  insert_case_infringement_evidence_one(object: $object) {
    ...caseInfringementEvidence
  }
}
    ${CaseInfringementEvidenceFragmentDoc}`;
export const CaseInfringementEvidenceUpdateOneDocument = `
    mutation caseInfringementEvidenceUpdateOne($id: uuid!, $changes: case_infringement_evidence_set_input) {
  update_case_infringement_evidence_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...caseInfringementEvidence
  }
}
    ${CaseInfringementEvidenceFragmentDoc}`;
export const CaseInfringementEvidenceDeleteOneDocument = `
    mutation caseInfringementEvidenceDeleteOne($id: uuid!) {
  delete_case_infringement_evidence_by_pk(id: $id) {
    ...caseInfringementEvidence
  }
}
    ${CaseInfringementEvidenceFragmentDoc}`;
export const CaseInfringementEvidenceGetByIdDocument = `
    query caseInfringementEvidenceGetById($id: uuid!) {
  case_infringement_evidence_by_pk(id: $id) {
    ...caseInfringementEvidence
  }
}
    ${CaseInfringementEvidenceFragmentDoc}`;
export const CaseInfringementEvidenceGetManyDocument = `
    query caseInfringementEvidenceGetMany($where: case_infringement_evidence_bool_exp!, $order_by: [case_infringement_evidence_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_infringement_evidence_select_column!]) {
  case_infringement_evidence(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseInfringementEvidence
  }
}
    ${CaseInfringementEvidenceFragmentDoc}`;
export const CaseRequestInsertOneDocument = `
    mutation caseRequestInsertOne($object: case_request_insert_input!) {
  insert_case_request_one(object: $object) {
    ...caseRequest
  }
}
    ${CaseRequestFragmentDoc}`;
export const CaseRequestUpdateOneDocument = `
    mutation caseRequestUpdateOne($id: uuid!, $changes: case_request_set_input) {
  update_case_request_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...caseRequest
  }
}
    ${CaseRequestFragmentDoc}`;
export const CaseRequestGetByIdDocument = `
    query caseRequestGetById($id: uuid!) {
  case_request_by_pk(id: $id) {
    ...caseRequest
  }
}
    ${CaseRequestFragmentDoc}`;
export const CaseRequestGetManyDocument = `
    query caseRequestGetMany($where: case_request_bool_exp!, $order_by: [case_request_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_request_select_column!]) {
  case_request(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseRequest
  }
}
    ${CaseRequestFragmentDoc}`;
export const CaseRequestTrackingInsertOneDocument = `
    mutation caseRequestTrackingInsertOne($object: case_request_tracking_insert_input!) {
  insert_case_request_tracking_one(object: $object) {
    ...caseRequestTracking
  }
}
    ${CaseRequestTrackingFragmentDoc}`;
export const CaseRequestTrackingDeleteOneDocument = `
    mutation caseRequestTrackingDeleteOne($id: Int!) {
  delete_case_request_tracking_by_pk(id: $id) {
    ...caseRequestTracking
  }
}
    ${CaseRequestTrackingFragmentDoc}`;
export const CaseRequestTrackingGetManyDocument = `
    query caseRequestTrackingGetMany($where: case_request_tracking_bool_exp = {}, $order_by: [case_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_request_tracking_select_column!]) {
  case_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseRequestTracking
  }
}
    ${CaseRequestTrackingFragmentDoc}`;
export const CaseRequestTrackingWithStatusGetManyDocument = `
    query caseRequestTrackingWithStatusGetMany($where: case_request_tracking_bool_exp = {}, $order_by: [case_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_request_tracking_select_column!]) {
  case_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseRequestTrackingWithStatus
  }
}
    ${CaseRequestTrackingWithStatusFragmentDoc}
${CaseRequestTrackingFragmentDoc}`;
export const CaseSolutionInsertOneDocument = `
    mutation caseSolutionInsertOne($object: case_solution_insert_input!) {
  insert_case_solution_one(object: $object) {
    ...caseSolution
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseSolutionUpdateOneDocument = `
    mutation caseSolutionUpdateOne($id: uuid!, $changes: case_solution_set_input) {
  update_case_solution_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...caseSolution
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseSolutionUpdateManyDocument = `
    mutation caseSolutionUpdateMany($where: case_solution_bool_exp!, $set: case_solution_set_input!) {
  update_case_solution(where: $where, _set: $set) {
    returning {
      ...caseSolution
    }
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseSolutionDeleteOneDocument = `
    mutation caseSolutionDeleteOne($id: uuid!) {
  delete_case_solution_by_pk(id: $id) {
    ...caseSolution
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseSolutionGetByIdDocument = `
    query caseSolutionGetById($id: uuid!) {
  case_solution_by_pk(id: $id) {
    ...caseSolution
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseSolutionGetManyDocument = `
    query caseSolutionGetMany($where: case_solution_bool_exp!, $order_by: [case_solution_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_solution_select_column!]) {
  case_solution(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseSolution
  }
}
    ${CaseSolutionFragmentDoc}`;
export const CaseTrackingInsertOneDocument = `
    mutation caseTrackingInsertOne($object: case_tracking_insert_input!) {
  insert_case_tracking_one(object: $object) {
    ...caseTracking
  }
}
    ${CaseTrackingFragmentDoc}`;
export const CaseTrackingInsertManyDocument = `
    mutation caseTrackingInsertMany($objects: [case_tracking_insert_input!]!) {
  insert_case_tracking(objects: $objects) {
    returning {
      ...caseTracking
    }
  }
}
    ${CaseTrackingFragmentDoc}`;
export const CaseTrackingDeleteOneDocument = `
    mutation caseTrackingDeleteOne($id: Int!) {
  delete_case_tracking_by_pk(id: $id) {
    ...caseTracking
  }
}
    ${CaseTrackingFragmentDoc}`;
export const CaseTrackingGetManyDocument = `
    query caseTrackingGetMany($where: case_tracking_bool_exp = {}, $order_by: [case_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_tracking_select_column!]) {
  case_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseTracking
  }
}
    ${CaseTrackingFragmentDoc}`;
export const CaseTrackingWithStatusGetManyDocument = `
    query caseTrackingWithStatusGetMany($where: case_tracking_bool_exp = {}, $order_by: [case_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [case_tracking_select_column!]) {
  case_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...caseTrackingWithStatus
  }
}
    ${CaseTrackingWithStatusFragmentDoc}
${CaseTrackingFragmentDoc}`;
export const ConsultationInsertOneDocument = `
    mutation consultationInsertOne($object: consultation_insert_input!) {
  insert_consultation_one(object: $object) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;
export const ConsultationUpdateOneDocument = `
    mutation consultationUpdateOne($id: uuid!, $changes: consultation_set_input!) {
  update_consultation_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;
export const ConsultationDeleteOneDocument = `
    mutation consultationDeleteOne($id: uuid!) {
  delete_consultation_by_pk(id: $id) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;
export const ConsultationDeleteManyDocument = `
    mutation consultationDeleteMany($calendlyId: String!) {
  delete_consultation(where: {calendly_id: {_eq: $calendlyId}}) {
    affected_rows
  }
}
    `;
export const ConsultationGetManyDocument = `
    query consultationGetMany($where: consultation_bool_exp! = {}, $order_by: [consultation_order_by!] = {}, $limit: Int, $offset: Int, $distinct_on: [consultation_select_column!]) {
  consultation(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;
export const ConsultationGetManyUserAggregateDocument = `
    query consultationGetManyUserAggregate($filter: consultation_bool_exp! = {}, $order_by: [consultation_order_by!] = {}, $limit: Int) {
  consultation(where: $filter, order_by: $order_by, limit: $limit) {
    ...consultation
  }
  consultation_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${ConsultationFragmentDoc}`;
export const ConsultationGetByIdDocument = `
    query consultationGetById($id: uuid!) {
  consultation_by_pk(id: $id) {
    ...consultation
  }
}
    ${ConsultationFragmentDoc}`;
export const ContentfulInsertOneDocument = `
    mutation contentfulInsertOne($object: contentful_insert_input!) {
  insert_contentful_one(object: $object) {
    ...contentful
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulInsertManyDocument = `
    mutation contentfulInsertMany($objects: [contentful_insert_input!]!) {
  insert_contentful(objects: $objects) {
    returning {
      ...contentful
    }
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulUpdateOneDocument = `
    mutation contentfulUpdateOne($id: bpchar!, $changes: contentful_set_input!) {
  update_contentful_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...contentful
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulUpdateManyDocument = `
    mutation contentfulUpdateMany($where: contentful_bool_exp!, $set: contentful_set_input!) {
  update_contentful(where: $where, _set: $set) {
    returning {
      ...contentful
    }
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulDeleteOneDocument = `
    mutation contentfulDeleteOne($id: bpchar!) {
  delete_contentful_by_pk(id: $id) {
    ...contentful
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulDeleteManyDocument = `
    mutation contentfulDeleteMany($where: contentful_bool_exp!) {
  delete_contentful(where: $where) {
    affected_rows
  }
}
    `;
export const ContentfulGetByIdDocument = `
    query contentfulGetById($id: bpchar!) {
  contentful_by_pk(id: $id) {
    ...contentful
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulGetManyDocument = `
    query contentfulGetMany($filter: contentful_bool_exp = {}, $order_by: [contentful_order_by!] = {}, $offset: Int, $limit: Int) {
  contentful(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...contentful
  }
}
    ${ContentfulFragmentDoc}`;
export const ContentfulHeadersGetManyDocument = `
    query contentfulHeadersGetMany($filter: contentful_bool_exp = {}, $order_by: [contentful_order_by!] = {}, $offset: Int, $limit: Int) {
  contentful(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...contentfulHeaders
  }
}
    ${ContentfulHeadersFragmentDoc}`;
export const ContentfulCountDocument = `
    query contentfulCount($filter: contentful_bool_exp = {}) {
  contentful_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const CreditNoteInsertOneDocument = `
    mutation creditNoteInsertOne($object: credit_note_insert_input!) {
  insert_credit_note_one(object: $object) {
    ...creditNote
  }
}
    ${CreditNoteFragmentDoc}`;
export const CreditNoteGetByIdDocument = `
    query creditNoteGetById($id: Int!) {
  credit_note_by_pk(id: $id) {
    ...creditNote
  }
}
    ${CreditNoteFragmentDoc}`;
export const CreditNoteGetManyDocument = `
    query creditNoteGetMany($filter: credit_note_bool_exp = {}, $order_by: [credit_note_order_by!] = {}) {
  credit_note(where: $filter, order_by: $order_by) {
    ...creditNote
  }
}
    ${CreditNoteFragmentDoc}`;
export const CreditNoteLastVariableSymbolBetweenDatesDocument = `
    query creditNoteLastVariableSymbolBetweenDates($startDate: timestamptz!, $endDate: timestamptz!) {
  credit_note(
    where: {created_at: {_gte: $startDate, _lt: $endDate}}
    order_by: {variable_symbol: desc}
    limit: 1
  ) {
    id
    variable_symbol
  }
}
    `;
export const CreditNoteByInvoiceReferenceDocument = `
    query creditNoteByInvoiceReference($invoiceReference: String!) {
  credit_note(
    where: {invoice_reference: {_eq: $invoiceReference}}
    order_by: {created_at: asc}
  ) {
    id
    variable_symbol
    document_context
    created_at
    year
  }
}
    `;
export const AllUserCreditNotesDocument = `
    query allUserCreditNotes($user_id: uuid!, $limit: Int!, $offset: Int!) {
  credit_note(
    offset: $offset
    limit: $limit
    order_by: {created_at: desc}
    where: {invoice: {product: {_or: [{brand_subscription_payment: {brand_subscription: {brand: {user_id: {_eq: $user_id}}}}}, {registration_request: {user_id: {_eq: $user_id}}}, {service_request: {user_id: {_eq: $user_id}}}]}}}
  ) {
    id
    invoice_reference
    created_at
    total: document_context(path: "creditNoteContent.total.withVat")
    currency: document_context(path: "creditNoteContent.currency")
  }
  credit_note_aggregate(
    where: {invoice: {product: {_or: [{brand_subscription_payment: {brand_subscription: {brand: {user_id: {_eq: $user_id}}}}}, {registration_request: {user_id: {_eq: $user_id}}}, {service_request: {user_id: {_eq: $user_id}}}]}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const TrademarkNotificationsCountDocument = `
    query trademarkNotificationsCount($user_id: uuid!, $expiration_date_to: date!) {
  registration_request_aggregate(
    where: {user_id: {_eq: $user_id}, _or: [{status: {_eq: "Sent for review"}}, {status: {_in: ["Verification approved", "Verification dismissed"]}, _not: {tracking_actions: {name: {_eq: "Verification result viewed"}}}}]}
  ) {
    aggregate {
      count
    }
  }
  trademark_aggregate(
    where: {expiration_date: {_lt: $expiration_date_to}, user_id: {_eq: $user_id}}
  ) {
    aggregate {
      count
    }
  }
  office_action_aggregate(
    where: {status: {_in: ["Kick-off sent", "Landing page visited"]}, trademark: {user_id: {_eq: $user_id}, status: {_eq: "Office action received"}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const DiscountCouponInsertOneDocument = `
    mutation discountCouponInsertOne($object: discount_coupon_insert_input!) {
  insert_discount_coupon_one(object: $object) {
    ...discountCoupon
  }
}
    ${DiscountCouponFragmentDoc}`;
export const DiscountCouponUpdateOneDocument = `
    mutation discountCouponUpdateOne($id: String!, $changes: discount_coupon_set_input) {
  update_discount_coupon_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...discountCoupon
  }
}
    ${DiscountCouponFragmentDoc}`;
export const DiscountCouponGetByIdDocument = `
    query discountCouponGetById($id: String!) {
  discount_coupon_by_pk(id: $id) {
    ...discountCoupon
  }
}
    ${DiscountCouponFragmentDoc}`;
export const DocketedMessageInsertOneDocument = `
    mutation docketedMessageInsertOne($object: docketed_message_insert_input!) {
  insert_docketed_message_one(object: $object) {
    ...docketed_message
  }
}
    ${Docketed_MessageFragmentDoc}`;
export const DocketedMessageUpdateOneDocument = `
    mutation docketedMessageUpdateOne($id: Int!, $changes: docketed_message_set_input!) {
  update_docketed_message_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...docketed_message
  }
}
    ${Docketed_MessageFragmentDoc}`;
export const DocketedMessageUpdateManyDocument = `
    mutation docketedMessageUpdateMany($where: docketed_message_bool_exp!, $set: docketed_message_set_input!) {
  update_docketed_message(where: $where, _set: $set) {
    returning {
      ...docketed_message
    }
  }
}
    ${Docketed_MessageFragmentDoc}`;
export const DocketedMessageGetByIdDocument = `
    query docketedMessageGetById($id: Int!) {
  docketed_message_by_pk(id: $id) {
    ...docketed_message
  }
}
    ${Docketed_MessageFragmentDoc}`;
export const DocketedMessageGetManyDocument = `
    query docketedMessageGetMany($where: docketed_message_bool_exp!, $order_by: [docketed_message_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [docketed_message_select_column!]) {
  docketed_message(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...docketed_message
  }
}
    ${Docketed_MessageFragmentDoc}`;
export const DocumentFolderInsertOneDocument = `
    mutation documentFolderInsertOne($object: document_folder_insert_input!) {
  insert_document_folder_one(object: $object) {
    ...documentFolder
  }
}
    ${DocumentFolderFragmentDoc}`;
export const DocumentInsertOneDocument = `
    mutation documentInsertOne($object: document_insert_input!) {
  insert_document_one(object: $object) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentDeleteOneDocument = `
    mutation documentDeleteOne($id: Int!) {
  delete_document_by_pk(id: $id) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentUpdateOneDocument = `
    mutation documentUpdateOne($id: Int!, $changes: document_set_input!) {
  update_document_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentInsertManyDocument = `
    mutation documentInsertMany($objects: [document_insert_input!]!) {
  insert_document(objects: $objects) {
    returning {
      ...document
    }
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentGetByIdDocument = `
    query documentGetById($id: Int!) {
  document_by_pk(id: $id) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const DocumentGetManyDocument = `
    query documentGetMany($filter: document_bool_exp!, $order_by: [document_order_by!] = {}, $limit: Int, $offset: Int, $distinct_on: [document_select_column!]) {
  document(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
    distinct_on: $distinct_on
  ) {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const EntityInsertOneDocument = `
    mutation entityInsertOne($object: entity_insert_input!) {
  insert_entity_one(object: $object) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const EntityUpsertOneDocument = `
    mutation entityUpsertOne($object: entity_insert_input!) {
  insert_entity_one(
    object: $object
    on_conflict: {constraint: entity_pkey, update_columns: [address_id, birthdate, business_name, company_id, company_type, country_of_incorporation, email, first_name, identity_card_id, last_name, nationality, official_first_name, official_function, official_last_name, personal_id_number, phone, state_of_incorporation, type, vat, vat_payer, updated_by_user_id]}
  ) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const EntityUpdateOneDocument = `
    mutation entityUpdateOne($id: uuid!, $changes: entity_set_input!) {
  update_entity_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const EntityDeleteOneDocument = `
    mutation entityDeleteOne($id: uuid!) {
  delete_entity_by_pk(id: $id) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const EntityGetByIdDocument = `
    query entityGetById($id: uuid!) {
  entity_by_pk(id: $id) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const EntityGetManyDocument = `
    query entityGetMany($filter: entity_bool_exp! = {}, $order_by: [entity_order_by!] = {}, $limit: Int, $offset: Int) {
  entity(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...entity
  }
}
    ${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ExchangeRateInsertManyDocument = `
    mutation exchangeRateInsertMany($objects: [exchange_rate_insert_input!]!) {
  insert_exchange_rate(objects: $objects) {
    returning {
      ...exchangeRate
    }
  }
}
    ${ExchangeRateFragmentDoc}`;
export const ExchangeRateGetManyDocument = `
    query exchangeRateGetMany($where: exchange_rate_bool_exp = {}, $order_by: [exchange_rate_order_by!] = {}) {
  exchange_rate(where: $where, order_by: $order_by) {
    ...exchangeRate
  }
}
    ${ExchangeRateFragmentDoc}`;
export const ExternalTrademarkInsertOneDocument = `
    mutation externalTrademarkInsertOne($object: external_trademark_insert_input!) {
  insert_external_trademark_one(object: $object) {
    ...externalTrademark
  }
}
    ${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ExternalTrademarkUpdateOneDocument = `
    mutation externalTrademarkUpdateOne($id: uuid!, $changes: external_trademark_set_input!) {
  update_external_trademark_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...externalTrademark
  }
}
    ${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ExternalTrademarkGetManyDocument = `
    query externalTrademarkGetMany($where: external_trademark_bool_exp!, $order_by: [external_trademark_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [external_trademark_select_column!]) {
  external_trademark(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...externalTrademark
  }
}
    ${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const InvoiceUpdateOneDocument = `
    mutation invoiceUpdateOne($variable_symbol: String!, $changes: invoice_set_input!) {
  update_invoice_by_pk(
    pk_columns: {variable_symbol: $variable_symbol}
    _set: $changes
  ) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceUpsertDocument = `
    mutation invoiceUpsert($object: invoice_insert_input!) {
  insert_invoice_one(
    object: $object
    on_conflict: {constraint: invoice_product_id_key, update_columns: [year, document_context, revolut_order_id, revolut_public_order_id]}
  ) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceMarkAsPaidDocument = `
    mutation invoiceMarkAsPaid($variableSymbol: String!, $billingEntity: String!, $paymentDate: timestamptz!, $paymentType: String!) {
  invoice_mark_as_paid(
    args: {variable_symbol: $variableSymbol, billing_entity: $billingEntity, payment_date: $paymentDate, payment_type: $paymentType}
  ) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceGetByReferenceDocument = `
    query invoiceGetByReference($variable_symbol: String!) {
  invoice_by_pk(variable_symbol: $variable_symbol) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceGetOneByRegistrationIdDocument = `
    query invoiceGetOneByRegistrationId($id: uuid!) {
  invoice(where: {registration_request: {id: {_eq: $id}}}, limit: 1) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceGetOneByProductIdDocument = `
    query invoiceGetOneByProductId($id: uuid!) {
  invoice(where: {product: {id: {_eq: $id}}}, limit: 1) {
    ...invoice
  }
}
    ${InvoiceFragmentDoc}`;
export const InvoiceGetOneByVariableSymbolForUserDocument = `
    query invoiceGetOneByVariableSymbolForUser($variable_symbol: String!) {
  invoice_by_pk(variable_symbol: $variable_symbol) {
    ...invoiceForUser
  }
}
    ${InvoiceForUserFragmentDoc}`;
export const InvoiceGetOneByRegistrationIdForUserDocument = `
    query invoiceGetOneByRegistrationIdForUser($id: uuid!) {
  invoice(where: {registration_request: {id: {_eq: $id}}}) {
    ...invoiceForUser
  }
}
    ${InvoiceForUserFragmentDoc}`;
export const InvoiceGetManyDocument = `
    query invoiceGetMany($filter: invoice_bool_exp = {}, $order_by: [invoice_order_by!] = {}) {
  invoice(where: $filter, order_by: $order_by) {
    ...productInvoice
  }
}
    ${ProductInvoiceFragmentDoc}
${InvoiceFragmentDoc}
${ProductFragmentDoc}
${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${BrandSubscriptionPaymentFragmentDoc}`;
export const InvoiceGetManyUnpaidBetweenDatesDocument = `
    query invoiceGetManyUnpaidBetweenDates($from: timestamptz!, $until: timestamptz!) {
  invoice(
    where: {payment_date: {_is_null: true}, created_at: {_gte: $from, _lt: $until}, registration_request: {}}
  ) {
    ...invoice
    registration_request {
      ...coreRegistrationFields
    }
  }
}
    ${InvoiceFragmentDoc}
${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const InvoicesGetPathsForPaidDocument = `
    query invoicesGetPathsForPaid($from: timestamptz!, $to: timestamptz!) {
  invoice(where: {payment_date: {_gte: $from, _lt: $to}}) {
    serial_number
    year
    billing_entity
    product {
      registration_request {
        documents(where: {type: {_eq: "Invoice"}}, order_by: {revision: desc}, limit: 1) {
          path
        }
      }
      service_request {
        documents(where: {type: {_eq: "Invoice"}}, order_by: {revision: desc}, limit: 1) {
          path
        }
      }
    }
  }
}
    `;
export const AllUserInvoicesDocument = `
    query allUserInvoices($user_id: uuid!, $limit: Int!, $offset: Int!) {
  invoice(
    offset: $offset
    limit: $limit
    order_by: {created_at: desc}
    where: {_and: {serial_number: {_is_null: false}, product: {_or: [{brand_subscription_payment: {brand_subscription: {brand: {user_id: {_eq: $user_id}}}}}, {registration_request: {user_id: {_eq: $user_id}}}, {service_request: {user_id: {_eq: $user_id}}}]}}}
  ) {
    id
    payment_date
    total: document_context(path: "invoiceContent.total.withVat")
    currency: document_context(path: "invoiceContent.currency")
    product {
      brand_subscription_payment {
        brand_subscription {
          payment_frequency
          brand {
            name
          }
        }
      }
      service_request {
        id
        service_name
        internal_label
      }
      registration_request {
        id
      }
    }
  }
  invoice_aggregate(
    where: {_and: {serial_number: {_is_null: false}, product: {_or: [{brand_subscription_payment: {brand_subscription: {brand: {user_id: {_eq: $user_id}}}}}, {registration_request: {user_id: {_eq: $user_id}}}, {service_request: {user_id: {_eq: $user_id}}}]}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const PaidOrdersSummaryLast30DaysDocument = `
    query paidOrdersSummaryLast30Days($order_by: [paid_orders_summary_last_30_days_order_by!], $limit: Int, $offset: Int) {
  paid_orders_summary_last_30_days(
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    source
    id
    service_name
    registration_request_type
    registration_request_value
    total_vat_base
    service_fees
    government_fees
    discount
    date
    user_id
    email
    assigned_admin
  }
}
    `;
export const PaidOrdersSummaryLast30DaysCountDocument = `
    query paidOrdersSummaryLast30DaysCount {
  paid_orders_summary_last_30_days_count {
    count
  }
}
    `;
export const NoteInsertOneDocument = `
    mutation noteInsertOne($object: note_insert_input!) {
  insert_note_one(object: $object) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export const NoteUpdateOneDocument = `
    mutation noteUpdateOne($id: Int!, $set: note_set_input!) {
  update_note_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export const NoteDeleteOneDocument = `
    mutation noteDeleteOne($id: Int!) {
  delete_note_by_pk(id: $id) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export const NoteGetByIdDocument = `
    query noteGetById($id: Int!) {
  note_by_pk(id: $id) {
    ...note
  }
}
    ${NoteFragmentDoc}`;
export const NotificationInsertOneDocument = `
    mutation notificationInsertOne($object: notification_insert_input!) {
  insert_notification_one(object: $object) {
    ...notification
  }
}
    ${NotificationFragmentDoc}`;
export const NotificationInsertManyDocument = `
    mutation notificationInsertMany($objects: [notification_insert_input!]!) {
  insert_notification(objects: $objects) {
    returning {
      ...notification
    }
  }
}
    ${NotificationFragmentDoc}`;
export const NotificationGetManyDocument = `
    query notificationGetMany($where: notification_bool_exp!, $order_by: [notification_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [notification_select_column!]) {
  notification(
    where: $where
    order_by: $order_by
    offset: 10
    limit: 10
    distinct_on: created_at
  ) {
    ...notification
  }
}
    ${NotificationFragmentDoc}`;
export const OfficeActionInsertOneDocument = `
    mutation officeActionInsertOne($object: office_action_insert_input!) {
  insert_office_action_one(object: $object) {
    ...officeAction
  }
}
    ${OfficeActionFragmentDoc}
${OfficeActionCommonDataFragmentDoc}
${DocumentFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${OfficeActionSolutionFragmentDoc}
${OfficeActionTrackingFragmentDoc}
${OfficeActionIssueFragmentDoc}
${OfficeActionSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}`;
export const OfficeActionUpdateOneDocument = `
    mutation officeActionUpdateOne($id: uuid!, $changes: office_action_set_input!) {
  update_office_action_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...officeAction
  }
}
    ${OfficeActionFragmentDoc}
${OfficeActionCommonDataFragmentDoc}
${DocumentFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${OfficeActionSolutionFragmentDoc}
${OfficeActionTrackingFragmentDoc}
${OfficeActionIssueFragmentDoc}
${OfficeActionSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}`;
export const OfficeActionGetByIdDocument = `
    query officeActionGetById($id: uuid!) {
  office_action_by_pk(id: $id) {
    ...officeAction
  }
}
    ${OfficeActionFragmentDoc}
${OfficeActionCommonDataFragmentDoc}
${DocumentFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${OfficeActionSolutionFragmentDoc}
${OfficeActionTrackingFragmentDoc}
${OfficeActionIssueFragmentDoc}
${OfficeActionSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}`;
export const OfficeActionGetManyDocument = `
    query officeActionGetMany($filter: office_action_bool_exp = {}, $order_by: [office_action_order_by!] = {}, $limit: Int) {
  office_action(where: $filter, order_by: $order_by, limit: $limit) {
    ...officeAction
  }
}
    ${OfficeActionFragmentDoc}
${OfficeActionCommonDataFragmentDoc}
${DocumentFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${OfficeActionSolutionFragmentDoc}
${OfficeActionTrackingFragmentDoc}
${OfficeActionIssueFragmentDoc}
${OfficeActionSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}`;
export const OfficeActionCountDocument = `
    query officeActionCount($filter: office_action_bool_exp = {}) {
  office_action_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const OfficeActionGetManyForUserDocument = `
    query officeActionGetManyForUser($filter: office_action_bool_exp = {}, $order_by: [office_action_order_by!] = {}) {
  office_action(order_by: $order_by, where: $filter) {
    ...officeActionForUser
  }
}
    ${OfficeActionForUserFragmentDoc}
${DocumentFragmentDoc}
${OfficeActionSolutionForUserFragmentDoc}
${ServiceRequestUserFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${OfficeActionTrackingFragmentDoc}`;
export const OfficeActionIssueUpdateOneDocument = `
    mutation officeActionIssueUpdateOne($id: uuid!, $changes: office_action_issue_set_input!) {
  update_office_action_issue_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...officeActionIssue
  }
}
    ${OfficeActionIssueFragmentDoc}`;
export const OfficeActionIssueDeleteManyDocument = `
    mutation officeActionIssueDeleteMany($officeActionId: uuid!) {
  delete_office_action_issue(
    where: {_and: {office_action_id: {_eq: $officeActionId}}}
  ) {
    affected_rows
  }
}
    `;
export const OfficeActionIssueInsertManyDocument = `
    mutation officeActionIssueInsertMany($objects: [office_action_issue_insert_input!]!) {
  insert_office_action_issue(objects: $objects) {
    returning {
      ...officeActionIssue
    }
  }
}
    ${OfficeActionIssueFragmentDoc}`;
export const OfficeActionSimilarTrademarkMapInsertManyDocument = `
    mutation officeActionSimilarTrademarkMapInsertMany($objects: [office_action_similar_trademark_map_insert_input!]!) {
  insert_office_action_similar_trademark_map(objects: $objects) {
    returning {
      ...officeActionSimilarTrademarkMap
    }
  }
}
    ${OfficeActionSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const OfficeActionSimilarTrademarkMapDeleteManyDocument = `
    mutation officeActionSimilarTrademarkMapDeleteMany($where: office_action_similar_trademark_map_bool_exp!) {
  delete_office_action_similar_trademark_map(where: $where) {
    affected_rows
  }
}
    `;
export const OfficeActionSolutionDeleteManyDocument = `
    mutation officeActionSolutionDeleteMany($officeActionId: uuid!) {
  delete_office_action_solution(
    where: {_and: {office_action_id: {_eq: $officeActionId}}}
  ) {
    affected_rows
  }
}
    `;
export const OfficeActionSolutionInsertManyDocument = `
    mutation officeActionSolutionInsertMany($objects: [office_action_solution_insert_input!]!) {
  insert_office_action_solution(objects: $objects) {
    returning {
      ...officeActionSolution
    }
  }
}
    ${OfficeActionSolutionFragmentDoc}`;
export const OfficeActionSolutionUpdateOneDocument = `
    mutation officeActionSolutionUpdateOne($id: uuid!, $changes: office_action_solution_set_input!) {
  update_office_action_solution_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...officeActionSolution
  }
}
    ${OfficeActionSolutionFragmentDoc}`;
export const OfficeActionTrackingInsertOneDocument = `
    mutation officeActionTrackingInsertOne($object: office_action_tracking_insert_input!) {
  insert_office_action_tracking_one(object: $object) {
    id
  }
}
    `;
export const OfficeActionTrackingDeleteOneDocument = `
    mutation officeActionTrackingDeleteOne($id: Int!) {
  delete_office_action_tracking_by_pk(id: $id) {
    ...officeActionTracking
  }
}
    ${OfficeActionTrackingFragmentDoc}`;
export const OfficeActionTrackingGetManyDocument = `
    query officeActionTrackingGetMany($where: office_action_tracking_bool_exp = {}, $order_by: [office_action_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [office_action_tracking_select_column!]) {
  office_action_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...officeActionTracking
  }
}
    ${OfficeActionTrackingFragmentDoc}`;
export const OfficeActionTrackingWithStatusGetManyDocument = `
    query officeActionTrackingWithStatusGetMany($where: office_action_tracking_bool_exp = {}, $order_by: [office_action_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [office_action_tracking_select_column!]) {
  office_action_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...officeActionTrackingWithStatus
  }
}
    ${OfficeActionTrackingWithStatusFragmentDoc}
${OfficeActionTrackingFragmentDoc}`;
export const OrderInsertOneDocument = `
    mutation orderInsertOne($object: order_insert_input!) {
  insert_order_one(object: $object) {
    ...order
  }
}
    ${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const OrderUpdateOneDocument = `
    mutation orderUpdateOne($id: uuid!, $set: order_set_input!) {
  update_order_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...order
  }
}
    ${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const OrderGetManyDocument = `
    query orderGetMany($where: order_bool_exp = {}, $order_by: [order_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [order_select_column!]) {
  order(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...order
  }
}
    ${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const OrderTrackingInsertOneDocument = `
    mutation orderTrackingInsertOne($object: order_tracking_insert_input!) {
  insert_order_tracking_one(object: $object) {
    ...orderTracking
  }
}
    ${OrderTrackingFragmentDoc}`;
export const OrderTrackingStatusGetManyDocument = `
    query orderTrackingStatusGetMany($where: order_tracking_status_bool_exp = {}, $order_by: [order_tracking_status_order_by!] = {}) {
  order_tracking_status(where: $where, order_by: $order_by) {
    ...orderTrackingStatus
  }
}
    ${OrderTrackingStatusFragmentDoc}`;
export const UnassignedOrdersDocument = `
    query unassignedOrders {
  registration_request_aggregate(where: {brand_id: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  trademark_aggregate(where: {brand_id: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  trademark_request_aggregate(where: {brand_id: {_is_null: true}}) {
    aggregate {
      count
    }
  }
  service_request_aggregate(where: {brand_id: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;
export const PoaInsertOneDocument = `
    mutation poaInsertOne($object: poa_insert_input!) {
  insert_poa_one(object: $object) {
    ...poa
  }
}
    ${PoaFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}`;
export const PoaUpdateOneDocument = `
    mutation poaUpdateOne($id: uuid!, $set: poa_set_input!) {
  update_poa_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...poa
  }
}
    ${PoaFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}`;
export const PoaDeleteOneDocument = `
    mutation poaDeleteOne($id: uuid!) {
  delete_poa_by_pk(id: $id) {
    ...poa
  }
}
    ${PoaFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}`;
export const PoaGetByIdDocument = `
    query poaGetById($id: uuid!) {
  poa_by_pk(id: $id) {
    ...poa
  }
}
    ${PoaFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}`;
export const PoaGetManyDocument = `
    query poaGetMany($where: poa_bool_exp!, $order_by: [poa_order_by!] = {}, $offset: Int, $limit: Int) {
  poa(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    ...poa
  }
}
    ${PoaFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}`;
export const PriceInsertOneDocument = `
    mutation priceInsertOne($object: price_insert_input!) {
  insert_price_one(object: $object) {
    ...price
  }
}
    ${PriceFragmentDoc}`;
export const PriceUpdateOneDocument = `
    mutation priceUpdateOne($id: uuid!, $set: price_set_input!) {
  update_price_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...price
  }
}
    ${PriceFragmentDoc}`;
export const PriceUpdateManyDocument = `
    mutation priceUpdateMany($where: price_bool_exp!, $set: price_set_input!) {
  update_price(where: $where, _set: $set) {
    returning {
      ...price
    }
  }
}
    ${PriceFragmentDoc}`;
export const PriceRuleInsertOneDocument = `
    mutation priceRuleInsertOne($object: price_rule_insert_input!) {
  insert_price_rule_one(object: $object) {
    ...priceRule
  }
}
    ${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const PriceRuleInsertManyDocument = `
    mutation priceRuleInsertMany($objects: [price_rule_insert_input!]!) {
  insert_price_rule(objects: $objects) {
    returning {
      ...priceRule
    }
  }
}
    ${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const PriceRuleUpdateOneDocument = `
    mutation priceRuleUpdateOne($id: uuid!, $set: price_rule_set_input!) {
  update_price_rule_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...priceRule
  }
}
    ${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const ProductUpdateOneDocument = `
    mutation productUpdateOne($id: uuid!, $changes: product_set_input!) {
  update_product_by_pk(pk_columns: {id: $id}, _set: $changes) {
    id
  }
}
    `;
export const ProductGetByIdDocument = `
    query productGetById($id: uuid!) {
  product_by_pk(id: $id) {
    ...product
  }
}
    ${ProductFragmentDoc}
${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${BrandSubscriptionPaymentFragmentDoc}`;
export const ProductBundleInsertOneDocument = `
    mutation productBundleInsertOne($object: product_bundle_insert_input!) {
  insert_product_bundle_one(object: $object) {
    ...productBundle
  }
}
    ${ProductBundleFragmentDoc}`;
export const ProductBundleUpdateOneDocument = `
    mutation productBundleUpdateOne($id: uuid!, $set: product_bundle_set_input!) {
  update_product_bundle_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...productBundle
  }
}
    ${ProductBundleFragmentDoc}`;
export const ProductBundleDeleteOneDocument = `
    mutation productBundleDeleteOne($id: uuid!) {
  delete_product_bundle_by_pk(id: $id) {
    id
  }
}
    `;
export const ProductBundleGetManyDocument = `
    query productBundleGetMany($where: product_bundle_bool_exp = {}, $order_by: [product_bundle_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [product_bundle_select_column!]) {
  product_bundle(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...productBundle
  }
}
    ${ProductBundleFragmentDoc}`;
export const ProductBundleGetAllDocument = `
    query productBundleGetAll {
  product_bundle {
    ...productBundle
    products(where: {deleted: {_eq: false}}, order_by: {bundle_sort_order: asc}) {
      id
      name
      category
      jurisdiction
      is_gov_fee
      invoice_translation_key
      parameters
      price_rules(where: {deleted: {_eq: false}}) {
        id
        type
        name
        config
        prices(where: {active: {_eq: true}}) {
          ...price
        }
      }
    }
  }
}
    ${ProductBundleFragmentDoc}
${PriceFragmentDoc}`;
export const ProductEventInsertOneDocument = `
    mutation productEventInsertOne($object: product_event_insert_input!) {
  insert_product_event_one(object: $object) {
    ...productEvent
  }
}
    ${ProductEventFragmentDoc}`;
export const ProductEventGetManyDocument = `
    query productEventGetMany($filter: product_event_bool_exp!, $order_by: [product_event_order_by!] = {}) {
  product_event(where: $filter, order_by: $order_by) {
    ...productEvent
  }
}
    ${ProductEventFragmentDoc}`;
export const ProductV2InsertOneDocument = `
    mutation productV2InsertOne($object: product_v2_insert_input!) {
  insert_product_v2_one(object: $object) {
    ...productV2
  }
}
    ${ProductV2FragmentDoc}
${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const ProductV2InsertManyDocument = `
    mutation productV2InsertMany($objects: [product_v2_insert_input!]!) {
  insert_product_v2(objects: $objects) {
    returning {
      ...productV2
    }
  }
}
    ${ProductV2FragmentDoc}
${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const ProductV2UpdateOneDocument = `
    mutation productV2UpdateOne($id: uuid!, $set: product_v2_set_input!) {
  update_product_v2_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...productV2
  }
}
    ${ProductV2FragmentDoc}
${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const ProductV2GetManyDocument = `
    query productV2GetMany($where: product_v2_bool_exp = {}, $order_by: [product_v2_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [product_v2_select_column!]) {
  product_v2(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...productV2
  }
}
    ${ProductV2FragmentDoc}
${PriceRuleFragmentDoc}
${PriceFragmentDoc}`;
export const QuoteInsertOneDocument = `
    mutation quoteInsertOne($object: quote_insert_input!) {
  insert_quote_one(object: $object) {
    ...quote
  }
}
    ${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const QuoteReplaceActiveInGroupDocument = `
    mutation quoteReplaceActiveInGroup($group_id: uuid!, $object: quote_insert_input!) {
  update_quote(
    where: {group_id: {_eq: $group_id}, active: {_eq: true}}
    _set: {active: false}
  ) {
    returning {
      id
      order {
        id
        status
      }
    }
  }
  insert_quote_one(object: $object) {
    ...quote
  }
}
    ${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const QuoteUpdateOneDocument = `
    mutation quoteUpdateOne($id: uuid!, $set: quote_set_input!) {
  update_quote_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...quote
  }
}
    ${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const QuoteUpdateManyDocument = `
    mutation quoteUpdateMany($where: quote_bool_exp!, $set: quote_set_input!) {
  update_quote(where: $where, _set: $set) {
    returning {
      ...quote
    }
  }
}
    ${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const QuoteGetManyDocument = `
    query quoteGetMany($where: quote_bool_exp = {}, $order_by: [quote_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [quote_select_column!]) {
  quote(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...quote
  }
}
    ${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const QuoteHubGetManyDocument = `
    query quoteHubGetMany($where: quote_hub_bool_exp = {}, $order_by: [quote_hub_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [quote_hub_select_column!]) {
  quote_hub(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...quoteHub
  }
}
    ${QuoteHubFragmentDoc}
${QuoteFragmentDoc}
${QuoteItemFragmentDoc}
${OrderFragmentDoc}
${OrderTrackingFragmentDoc}`;
export const RefundRequestInsertOneDocument = `
    mutation refundRequestInsertOne($object: refund_request_insert_input!) {
  insert_refund_request_one(object: $object) {
    ...refundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export const RefundRequestUpdateOneDocument = `
    mutation refundRequestUpdateOne($id: uuid!, $changes: refund_request_set_input) {
  update_refund_request_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...refundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export const RefundRequestGetByIdDocument = `
    query refundRequestGetById($id: uuid!) {
  refund_request_by_pk(id: $id) {
    ...refundRequest
  }
}
    ${RefundRequestFragmentDoc}`;
export const RefundRequestInvoiceInsertManyDocument = `
    mutation refundRequestInvoiceInsertMany($objects: [refund_request_invoice_insert_input!]!) {
  insert_refund_request_invoice(objects: $objects) {
    returning {
      ...refundRequestInvoice
    }
  }
}
    ${RefundRequestInvoiceFragmentDoc}`;
export const RefundRequestInvoiceDeleteManyDocument = `
    mutation refundRequestInvoiceDeleteMany($where: refund_request_invoice_bool_exp!) {
  delete_refund_request_invoice(where: $where) {
    affected_rows
  }
}
    `;
export const RefundRequestTrackingInsertOneDocument = `
    mutation refundRequestTrackingInsertOne($object: refund_request_tracking_insert_input!) {
  insert_refund_request_tracking_one(object: $object) {
    ...refundRequestTracking
  }
}
    ${RefundRequestTrackingFragmentDoc}`;
export const RefundRequestTrackingDeleteOneDocument = `
    mutation refundRequestTrackingDeleteOne($id: Int!) {
  delete_refund_request_tracking_by_pk(id: $id) {
    ...refundRequestTracking
  }
}
    ${RefundRequestTrackingFragmentDoc}`;
export const RefundRequestTrackingGetManyDocument = `
    query refundRequestTrackingGetMany($where: refund_request_tracking_bool_exp = {}, $order_by: [refund_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [refund_request_tracking_select_column!]) {
  refund_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...refundRequestTracking
  }
}
    ${RefundRequestTrackingFragmentDoc}`;
export const RefundRequestTrackingWithStatusGetManyDocument = `
    query refundRequestTrackingWithStatusGetMany($where: refund_request_tracking_bool_exp = {}, $order_by: [refund_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [refund_request_tracking_select_column!]) {
  refund_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...refundRequestTrackingWithStatus
  }
}
    ${RefundRequestTrackingWithStatusFragmentDoc}
${RefundRequestTrackingFragmentDoc}`;
export const RegistrationRequestInsertOneDocument = `
    mutation registrationRequestInsertOne($object: registration_request_insert_input!) {
  insert_registration_request_one(object: $object) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestUpdateOneDocument = `
    mutation registrationRequestUpdateOne($id: uuid!, $changes: registration_request_set_input!) {
  update_registration_request_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestUpdateManyDocument = `
    mutation registrationRequestUpdateMany($where: registration_request_bool_exp = {}, $set: registration_request_set_input!) {
  update_registration_request(_set: $set, where: $where) {
    returning {
      ...coreRegistrationFields
    }
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestDeleteOneDocument = `
    mutation registrationRequestDeleteOne($id: uuid!) {
  delete_registration_request_by_pk(id: $id) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestDeleteManyDocument = `
    mutation registrationRequestDeleteMany($where: registration_request_bool_exp!) {
  delete_registration_request(where: $where) {
    affected_rows
  }
}
    `;
export const RegistrationRequestGetByIdDocument = `
    query registrationRequestGetById($id: uuid!) {
  registration_request_by_pk(id: $id) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestGetOneUserDocument = `
    query registrationRequestGetOneUser($id: uuid!) {
  registration_request_by_pk(id: $id) {
    ...registrationRequestFieldsForUser
  }
}
    ${RegistrationRequestFieldsForUserFragmentDoc}
${DiscountCouponFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${DocumentFragmentDoc}
${InvoiceForUserFragmentDoc}
${VerificationResultForUserFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapForUserFragmentDoc}
${ExternalTrademarkForUserFragmentDoc}`;
export const RegistrationRequestGetOneForDraftingDocument = `
    query registrationRequestGetOneForDrafting($id: uuid!) {
  registration_request_by_pk(id: $id) {
    ...draftingRegistrationFields
  }
}
    ${DraftingRegistrationFieldsFragmentDoc}
${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestUserDocument = `
    query registrationRequestUser($id: uuid!) {
  registration_request_by_pk(id: $id) {
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const RegistrationRequestGetOneForReportViolationDocument = `
    query registrationRequestGetOneForReportViolation($id: uuid!) {
  registration_request_by_pk(id: $id) {
    ...reportViolationRegistrationFields
  }
}
    ${ReportViolationRegistrationFieldsFragmentDoc}
${DocumentFragmentDoc}
${ApplicationFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}`;
export const RegistrationRequestGetManyDocument = `
    query registrationRequestGetMany($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const RegistrationRequestGetManyUserAggregateDocument = `
    query registrationRequestGetManyUserAggregate($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int) {
  registration_request(where: $filter, order_by: $order_by, limit: $limit) {
    ...registrationRequestFieldsForUser
  }
  registration_request_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestFieldsForUserFragmentDoc}
${DiscountCouponFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${DocumentFragmentDoc}
${InvoiceForUserFragmentDoc}
${VerificationResultForUserFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapForUserFragmentDoc}
${ExternalTrademarkForUserFragmentDoc}`;
export const RegistrationRequestGetManyLastStatusUpdateDocument = `
    query registrationRequestGetManyLastStatusUpdate($filter: registration_request_bool_exp!) {
  registration_request(where: $filter) {
    ...registrationRequestLastStatusUpdate
  }
}
    ${RegistrationRequestLastStatusUpdateFragmentDoc}`;
export const RegistrationRequestGetManyCountriesDocument = `
    query registrationRequestGetManyCountries {
  registration_request(where: {tracking_actions: {name: {_eq: "Order created"}}}) {
    jurisdictions
  }
}
    `;
export const RegistrationRequestCountDocument = `
    query registrationRequestCount($filter: registration_request_bool_exp = {}) {
  registration_request_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const RegistrationRequestCountByUserDocument = `
    query registrationRequestCountByUser($userId: uuid) {
  unpaid: registration_request_aggregate(
    where: {user_id: {_eq: $userId}, _not: {tracking_actions: {name: {_eq: "Invoice paid"}}}}
  ) {
    aggregate {
      count
    }
  }
  paid: registration_request_aggregate(
    where: {user_id: {_eq: $userId}, tracking_actions: {name: {_eq: "Invoice paid"}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const RegistrationRequestsVerifiedWithoutResultViewDocument = `
    query registrationRequestsVerifiedWithoutResultView($from: timestamptz!, $until: timestamptz!) {
  registration_request(
    where: {_and: {status: {_in: ["Verification approved", "Verification dismissed"]}, verification_results: {}, _not: {tracking_actions: {name: {_eq: "Verification result viewed"}}}, tracking_actions: {_and: {name: {_in: ["Verification approved", "Verification dismissed"]}, created_at: {_gte: $from, _lt: $until}}}}}
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const ApprovedRegistrationRequestsWithResultViewDocument = `
    query approvedRegistrationRequestsWithResultView($from: timestamptz!, $until: timestamptz!) {
  registration_request(
    where: {_and: {_and: {status: {_eq: "Verification approved"}, verification_results: {}, _and: {tracking_actions: {_and: {name: {_eq: "Verification approved"}, created_at: {_gte: $from, _lt: $until}}}, _not: {tracking_actions: {name: {_eq: "Registration order started"}}}}}, tracking_actions: {name: {_eq: "Verification result viewed"}}}}
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const DismissedRegistrationRequestsWithResultViewDocument = `
    query dismissedRegistrationRequestsWithResultView($from: timestamptz!, $until: timestamptz!) {
  registration_request(
    where: {_and: {_and: {status: {_eq: "Verification dismissed"}, verification_results: {}, tracking_actions: {_and: {name: {_eq: "Verification dismissed"}, created_at: {_gte: $from, _lt: $until}}}}, tracking_actions: {name: {_eq: "Verification result viewed"}}}}
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const GetRegistrationRequestsWithOrderCreatedDocument = `
    query getRegistrationRequestsWithOrderCreated($from: timestamptz!, $until: timestamptz!) {
  registration_request(
    where: {_and: {status: {_eq: "Order created"}, _and: {tracking_actions: {_and: {name: {_eq: "Order created"}, created_at: {_gte: $from, _lt: $until}}}, _not: {tracking_actions: {name: {_eq: "Checkout completed"}}}}}}
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const GetRegistrationRequestsStartedWithoutOrderCreatedDocument = `
    query getRegistrationRequestsStartedWithoutOrderCreated($from: timestamptz!, $until: timestamptz!) {
  registration_request(
    where: {_and: {status: {_eq: "Verification approved"}, _and: {tracking_actions: {_and: {name: {_eq: "Registration order started"}, created_at: {_gte: $from, _lt: $until}}}, _not: {tracking_actions: {name: {_eq: "Registration started first reminder"}}}}}}
  ) {
    ...coreRegistrationFields
  }
}
    ${CoreRegistrationFieldsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}
${DiscountCouponFragmentDoc}
${ApplicationFragmentDoc}
${ThreadCommentFragmentDoc}
${AddressFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const ContactsRegistrationRequestTrackingDocument = `
    query contactsRegistrationRequestTracking($trackingActionName: String!, $trackingCreatedSince: timestamptz!) {
  registration_request(
    distinct_on: contact_email
    where: {tracking_actions: {created_at: {_gte: $trackingCreatedSince}, name: {_eq: $trackingActionName}}}
  ) {
    contact_email
  }
}
    `;
export const RegistrationRequestGetManyForUserDocument = `
    query registrationRequestGetManyForUser($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...registrationRequestFieldsForUser
  }
  registration_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestFieldsForUserFragmentDoc}
${DiscountCouponFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${DocumentFragmentDoc}
${InvoiceForUserFragmentDoc}
${VerificationResultForUserFragmentDoc}
${SimilarTrademarkFragmentDoc}
${VerificationResultSimilarTrademarkMapForUserFragmentDoc}
${ExternalTrademarkForUserFragmentDoc}`;
export const UserUnseenVerificationCountDocument = `
    query userUnseenVerificationCount($user_id: uuid!, $last_status_update_since: timestamptz) {
  user_unseen_verification_count(
    args: {user_id: $user_id, last_status_update_since: $last_status_update_since}
  ) {
    count
  }
}
    `;
export const RegistrationRequestGetManyForUserTrademarksDocument = `
    query registrationRequestGetManyForUserTrademarks($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...registrationRequestWithTrackingFieldsForUser
  }
  registration_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestWithTrackingFieldsForUserFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestGetManyForUserDraftsDocument = `
    query registrationRequestGetManyForUserDrafts($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...registrationRequestWithTrackingFieldsForUser
  }
  registration_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestWithTrackingFieldsForUserFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestGetManyForUserOrdersDocument = `
    query registrationRequestGetManyForUserOrders($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...registrationRequestFieldsForUserOrders
  }
  registration_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestFieldsForUserOrdersFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${VerificationResultForUserFragmentDoc}
${SimilarTrademarkFragmentDoc}
${DocumentFragmentDoc}
${VerificationResultSimilarTrademarkMapForUserFragmentDoc}
${ExternalTrademarkForUserFragmentDoc}`;
export const VerificationSearchDocument = `
    query verificationSearch($query: String!, $jurisdictions: String!, $since: date!, $classes: String) {
  verification_search(
    args: {query: $query, jurisdictions: $jurisdictions, since: $since, classes: $classes}
  ) {
    id
    name
    type
    jurisdictions
    classes
    status
    created_at
    last_status_update
    fts_score
    trigram_score
    metaphone_score
    dmetaphone_score
    levenshtein_score
    score
  }
}
    `;
export const RecentApplicationsSentToClientDocument = `
    query recentApplicationsSentToClient($user_id: uuid!, $registration_request_id: uuid!, $order_by: [recent_applications_sent_to_client_order_by!], $limit: Int, $offset: Int) {
  recent_applications_sent_to_client(
    args: {user_id: $user_id, registration_request_id: $registration_request_id}
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    priority_filing_visible
    priority_filing_jurisdiction
    priority_filing_number
    priority_filing_date
    domicile_address_visible
    registration_entity
    domicile_address
    registration_request
    first_sent_to_client_at
  }
}
    `;
export const RegistrationRequestRecentlyDismissedDocument = `
    query registrationRequestRecentlyDismissed($order_by: [registration_request_recently_dismissed_order_by!], $limit: Int, $offset: Int) {
  registration_request_recently_dismissed(
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    id
    type
    value
    jurisdictions
    last_status_update
    contact_first_name
    contact_last_name
    user
    verification_result
    notes
    assigned_admin
  }
}
    `;
export const RegistrationRequestRecentlyDismissedCountDocument = `
    query registrationRequestRecentlyDismissedCount {
  registration_request_recently_dismissed_count {
    count
  }
}
    `;
export const RegistrationRequestGetManyForUserDashboardDocument = `
    query registrationRequestGetManyForUserDashboard($filter: registration_request_bool_exp! = {}, $order_by: [registration_request_order_by!] = {}, $limit: Int, $offset: Int) {
  registration_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...registrationRequestForUserDashboard
  }
  registration_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${RegistrationRequestForUserDashboardFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}
${DocumentFragmentDoc}`;
export const RegistrationRequestTrackingInsertOneDocument = `
    mutation registrationRequestTrackingInsertOne($object: registration_request_tracking_insert_input!) {
  insert_registration_request_tracking_one(object: $object) {
    ...registrationRequestTracking
  }
}
    ${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestTrackingInsertManyDocument = `
    mutation registrationRequestTrackingInsertMany($objects: [registration_request_tracking_insert_input!]!) {
  insert_registration_request_tracking(objects: $objects) {
    returning {
      ...registrationRequestTracking
    }
  }
}
    ${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestTrackingDeleteOneDocument = `
    mutation registrationRequestTrackingDeleteOne($id: Int!) {
  delete_registration_request_tracking_by_pk(id: $id) {
    ...registrationRequestTracking
  }
}
    ${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestTrackingDeleteManyDocument = `
    mutation registrationRequestTrackingDeleteMany($registrationRequestId: uuid!, $name: String!) {
  delete_registration_request_tracking(
    where: {_and: {registration_request_id: {_eq: $registrationRequestId}, name: {_eq: $name}}}
  ) {
    affected_rows
  }
}
    `;
export const RegistrationRequestTrackingGetManyDocument = `
    query registrationRequestTrackingGetMany($where: registration_request_tracking_bool_exp = {}, $order_by: [registration_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [registration_request_tracking_select_column!]) {
  registration_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...registrationRequestTracking
  }
}
    ${RegistrationRequestTrackingFragmentDoc}`;
export const RegistrationRequestTrackingWithStatusGetManyDocument = `
    query registrationRequestTrackingWithStatusGetMany($where: registration_request_tracking_bool_exp = {}, $order_by: [registration_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [registration_request_tracking_select_column!]) {
  registration_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...registrationRequestTrackingWithStatus
  }
}
    ${RegistrationRequestTrackingWithStatusFragmentDoc}
${RegistrationRequestTrackingFragmentDoc}`;
export const ReminderInsertOneDocument = `
    mutation reminderInsertOne($object: reminder_insert_input!) {
  insert_reminder_one(object: $object) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export const ReminderUpdateOneDocument = `
    mutation reminderUpdateOne($id: uuid!, $set: reminder_set_input!) {
  update_reminder_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export const ReminderGetByIdDocument = `
    query reminderGetById($id: uuid!) {
  reminder_by_pk(id: $id) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export const ReminderGetManyDocument = `
    query reminderGetMany($where: reminder_bool_exp!, $order_by: [reminder_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [reminder_select_column!]) {
  reminder(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...reminder
  }
}
    ${ReminderFragmentDoc}`;
export const ReminderCountDocument = `
    query reminderCount($filter: reminder_bool_exp = {}) {
  reminder_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const ServiceInsertOneDocument = `
    mutation serviceInsertOne($object: service_insert_input!) {
  insert_service_one(object: $object) {
    ...service
  }
}
    ${ServiceFragmentDoc}`;
export const ServiceInsertManyDocument = `
    mutation serviceInsertMany($objects: [service_insert_input!]!) {
  insert_service(objects: $objects) {
    returning {
      ...service
    }
  }
}
    ${ServiceFragmentDoc}`;
export const ServiceUpdateOneDocument = `
    mutation serviceUpdateOne($id: uuid!, $set: service_set_input!) {
  update_service_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...service
  }
}
    ${ServiceFragmentDoc}`;
export const ServiceGetByIdDocument = `
    query serviceGetById($id: uuid!) {
  service_by_pk(id: $id) {
    ...service
  }
}
    ${ServiceFragmentDoc}`;
export const ServiceGetManyDocument = `
    query serviceGetMany($where: service_bool_exp!, $order_by: [service_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [service_select_column!]) {
  service(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...service
  }
}
    ${ServiceFragmentDoc}`;
export const ServiceRequestInsertOneDocument = `
    mutation serviceRequestInsertOne($object: service_request_insert_input!) {
  insert_service_request_one(object: $object) {
    ...serviceRequest
  }
}
    ${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestUpdateOneDocument = `
    mutation serviceRequestUpdateOne($id: uuid!, $set: service_request_set_input!) {
  update_service_request_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...serviceRequest
  }
}
    ${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestDeleteManyDocument = `
    mutation serviceRequestDeleteMany($where: service_request_bool_exp!) {
  delete_service_request(where: $where) {
    affected_rows
  }
}
    `;
export const ServiceRequestGetByIdDocument = `
    query serviceRequestGetById($id: uuid!) {
  service_request_by_pk(id: $id) {
    ...serviceRequest
  }
}
    ${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestGetManyDocument = `
    query serviceRequestGetMany($filter: service_request_bool_exp! = {}, $order_by: [service_request_order_by!] = {}, $limit: Int, $offset: Int) {
  service_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...serviceRequest
  }
}
    ${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestGetOneForUserDocument = `
    query serviceRequestGetOneForUser($id: uuid!) {
  service_request_by_pk(id: $id) {
    ...serviceRequestUser
  }
}
    ${ServiceRequestUserFragmentDoc}
${DocumentFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ServiceRequestGetManyForUserDocument = `
    query serviceRequestGetManyForUser($filter: service_request_bool_exp! = {}, $order_by: [service_request_order_by!] = {}, $limit: Int, $offset: Int) {
  service_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...serviceRequestUser
  }
  service_request_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${ServiceRequestUserFragmentDoc}
${DocumentFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const ServiceRequestCountDocument = `
    query serviceRequestCount($filter: service_request_bool_exp! = {}) {
  service_request_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const ServiceRequestGetManyWithTrademarksDocument = `
    query serviceRequestGetManyWithTrademarks($filter: service_request_bool_exp! = {}, $order_by: [service_request_order_by!] = {}, $limit: Int, $offset: Int) {
  service_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...serviceRequestWithTrademarks
  }
}
    ${ServiceRequestWithTrademarksFragmentDoc}
${ServiceRequestFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${EntityFragmentDoc}
${ServiceRequestTrackingFragmentDoc}
${TrademarkServiceRequestsFragmentDoc}
${DocumentFragmentDoc}`;
export const ServiceRequestTrackingInsertOneDocument = `
    mutation serviceRequestTrackingInsertOne($object: service_request_tracking_insert_input!) {
  insert_service_request_tracking_one(object: $object) {
    ...serviceRequestTracking
  }
}
    ${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestTrackingInsertManyDocument = `
    mutation serviceRequestTrackingInsertMany($objects: [service_request_tracking_insert_input!]!) {
  insert_service_request_tracking(objects: $objects) {
    returning {
      ...serviceRequestTracking
    }
  }
}
    ${ServiceRequestTrackingFragmentDoc}`;
export const ServiceRequestTrackingGetManyDocument = `
    query serviceRequestTrackingGetMany($filter: service_request_tracking_bool_exp = {}, $order_by: [service_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [service_request_tracking_select_column!]) {
  service_request_tracking(
    where: $filter
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...serviceRequestTracking
  }
}
    ${ServiceRequestTrackingFragmentDoc}`;
export const ServiceTrackingInsertOneDocument = `
    mutation serviceTrackingInsertOne($object: service_tracking_insert_input!) {
  insert_service_tracking_one(object: $object) {
    ...serviceTracking
  }
}
    ${ServiceTrackingFragmentDoc}`;
export const ServiceTrackingDeleteOneDocument = `
    mutation serviceTrackingDeleteOne($id: Int!) {
  delete_service_tracking_by_pk(id: $id) {
    ...serviceTracking
  }
}
    ${ServiceTrackingFragmentDoc}`;
export const ServiceTrackingGetManyDocument = `
    query serviceTrackingGetMany($where: service_tracking_bool_exp!, $order_by: [service_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [service_tracking_select_column!]) {
  service_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...serviceTracking
  }
}
    ${ServiceTrackingFragmentDoc}`;
export const ServiceTrackingWithStatusGetManyDocument = `
    query serviceTrackingWithStatusGetMany($where: service_tracking_bool_exp = {}, $order_by: [service_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [service_tracking_select_column!]) {
  service_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...serviceTrackingWithStatus
  }
}
    ${ServiceTrackingWithStatusFragmentDoc}
${ServiceTrackingFragmentDoc}`;
export const SpecimenInsertOneDocument = `
    mutation specimenInsertOne($object: specimen_insert_input!) {
  insert_specimen_one(object: $object) {
    ...specimen
  }
}
    ${SpecimenFragmentDoc}
${DocumentFragmentDoc}`;
export const SpecimenUpdateOneDocument = `
    mutation specimenUpdateOne($id: uuid!, $set: specimen_set_input!) {
  update_specimen_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...specimen
  }
}
    ${SpecimenFragmentDoc}
${DocumentFragmentDoc}`;
export const SpecimenDeleteOneDocument = `
    mutation specimenDeleteOne($id: uuid!) {
  delete_specimen_by_pk(id: $id) {
    ...specimen
  }
}
    ${SpecimenFragmentDoc}
${DocumentFragmentDoc}`;
export const SpecimenGetByIdDocument = `
    query specimenGetById($id: uuid!) {
  specimen_by_pk(id: $id) {
    ...specimen
  }
}
    ${SpecimenFragmentDoc}
${DocumentFragmentDoc}`;
export const SpecimenGetManyDocument = `
    query specimenGetMany($where: specimen_bool_exp!, $order_by: [specimen_order_by!] = {}, $limit: Int, $offset: Int) {
  specimen(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
    ...specimen
  }
}
    ${SpecimenFragmentDoc}
${DocumentFragmentDoc}`;
export const StatisticInsertOneDocument = `
    mutation statisticInsertOne($name: String!, $value: Int!) {
  insert_statistic_one(object: {name: $name, value: $value}) {
    ...statistic
  }
}
    ${StatisticFragmentDoc}`;
export const StatisticGetManyDistinctDocument = `
    query statisticGetManyDistinct {
  statistic(distinct_on: name, order_by: [{name: asc}, {created_at: desc}]) {
    ...statistic
  }
}
    ${StatisticFragmentDoc}`;
export const SupportTicketInsertOneDocument = `
    mutation supportTicketInsertOne($object: support_ticket_insert_input!) {
  insert_support_ticket_one(object: $object) {
    ...supportTicket
  }
}
    ${SupportTicketFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const SupportTicketUpdateOneDocument = `
    mutation supportTicketUpdateOne($id: Int!, $changes: support_ticket_set_input!) {
  update_support_ticket_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...supportTicket
  }
}
    ${SupportTicketFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const SupportTicketByIdDocument = `
    query supportTicketById($id: Int!) {
  support_ticket_by_pk(id: $id) {
    ...supportTicket
  }
}
    ${SupportTicketFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const SupportTicketGetManyDocument = `
    query supportTicketGetMany($filter: support_ticket_bool_exp! = {}, $order_by: [support_ticket_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [support_ticket_select_column!]) {
  support_ticket(
    where: $filter
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...supportTicket
  }
  support_ticket_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${SupportTicketFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const TaskInsertOneDocument = `
    mutation taskInsertOne($object: task_insert_input!) {
  insert_task_one(object: $object) {
    ...task
  }
}
    ${TaskFragmentDoc}`;
export const TaskUpdateOneDocument = `
    mutation taskUpdateOne($id: String!, $_set: task_set_input!) {
  update_task_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...task
  }
}
    ${TaskFragmentDoc}`;
export const TaskGetByIdDocument = `
    query taskGetById($id: String!) {
  task_by_pk(id: $id) {
    ...task
  }
}
    ${TaskFragmentDoc}`;
export const TaskCountDocument = `
    query taskCount($filter: task_bool_exp = {}) {
  task_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const ThreadCommentInsertOneDocument = `
    mutation threadCommentInsertOne($object: thread_comment_insert_input!) {
  insert_thread_comment_one(object: $object) {
    ...threadComment
  }
}
    ${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}`;
export const ThreadCommentUpdateOneDocument = `
    mutation threadCommentUpdateOne($id: uuid!, $set: thread_comment_set_input!) {
  update_thread_comment_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...threadComment
  }
}
    ${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}`;
export const ThreadCommentGetManyDocument = `
    query threadCommentGetMany($filter: thread_comment_bool_exp = {}, $order_by: [thread_comment_order_by!] = {}) {
  thread_comment(where: $filter, order_by: $order_by) {
    ...threadComment
  }
}
    ${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}`;
export const ThreadCommentGetByIdDocument = `
    query threadCommentGetById($id: uuid!) {
  thread_comment_by_pk(id: $id) {
    ...threadComment
  }
}
    ${ThreadCommentFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkInsertManyDocument = `
    mutation trademarkInsertMany($objects: [trademark_insert_input!]!) {
  insert_trademark(objects: $objects) {
    returning {
      ...trademark
    }
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkInsertOneDocument = `
    mutation trademarkInsertOne($object: trademark_insert_input!) {
  insert_trademark_one(object: $object) {
    ...trademark
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkUpdateOneDocument = `
    mutation trademarkUpdateOne($id: uuid!, $changes: trademark_set_input!) {
  update_trademark_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...trademark
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkUpdateOneForUserDocument = `
    mutation trademarkUpdateOneForUser($id: uuid!, $changes: trademark_set_input!) {
  update_trademark_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...trademarkForUser
  }
}
    ${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const TrademarkUpdateManyDocument = `
    mutation trademarkUpdateMany($where: trademark_bool_exp!, $set: trademark_set_input!) {
  update_trademark(where: $where, _set: $set) {
    returning {
      ...trademark
    }
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkDeleteManyDocument = `
    mutation trademarkDeleteMany($where: trademark_bool_exp!) {
  delete_trademark(where: $where) {
    affected_rows
  }
}
    `;
export const TrademarkGetByIdDocument = `
    query trademarkGetById($id: uuid!) {
  trademark_by_pk(id: $id) {
    ...trademark
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkGetByIdForUserDocument = `
    query trademarkGetByIdForUser($id: uuid!) {
  trademark_by_pk(id: $id) {
    ...customerPortalTrademarkDetail
  }
}
    ${CustomerPortalTrademarkDetailFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${DocumentFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const TrademarkGetManyDocument = `
    query trademarkGetMany($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $offset: Int, $limit: Int) {
  trademark(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...trademark
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkGetManyOwnPropertiesDocument = `
    query trademarkGetManyOwnProperties($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, offset: $offset) {
    ...trademarkOwnProperties
  }
}
    ${TrademarkOwnPropertiesFragmentDoc}
${TrademarkClassFragmentDoc}
${EntityOwnPropertiesFragmentDoc}
${AddressDataFragmentDoc}`;
export const TrademarkCountDocument = `
    query trademarkCount($filter: trademark_bool_exp = {}) {
  trademark_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const TrademarkGetManyForUserDocument = `
    query trademarkGetManyForUser($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    ...trademarkForUser
  }
  trademark_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const TrademarkSearchDocument = `
    query trademarkSearch($query: String!, $jurisdictions: String!, $classes: String) {
  trademark_search(
    args: {query: $query, jurisdictions: $jurisdictions, classes: $classes}
  ) {
    id
    name
    number
    type
    jurisdiction
    classes
    status
    created_at
    last_tracking_update
    fts_score
    trigram_score
    metaphone_score
    dmetaphone_score
    levenshtein_score
    score
  }
}
    `;
export const TrademarkPortfolioSearchDocument = `
    query trademarkPortfolioSearch($query: String!, $userId: uuid!) {
  trademark_portfolio_search(args: {query: $query, user_id: $userId}) {
    id
    name
    number
    type
    jurisdiction
    status
    filing_date
    registration_date
    fts_score
    trigram_score
    metaphone_score
    dmetaphone_score
    levenshtein_score
    score
  }
}
    `;
export const TrademarkPortfolioSearchCountDocument = `
    query trademarkPortfolioSearchCount($query: String!, $userId: uuid!) {
  trademark_portfolio_search_count(args: {query: $query, user_id: $userId}) {
    count
  }
}
    `;
export const TrademarkGetManyWithRepresentativeDocument = `
    query trademarkGetManyWithRepresentative($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    ...trademark
    representative_entity {
      ...entityData
    }
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const TrademarkGetPartnersFilingsDocument = `
    query trademarkGetPartnersFilings($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    ...trademark
    registration_request {
      public_id
      invoice {
        document_context
      }
    }
  }
  trademark_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}`;
export const TrademarkGetManyIdsDocument = `
    query trademarkGetManyIds($filter: trademark_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    id
  }
}
    `;
export const TrademarkGetManyForUserDashboardDocument = `
    query trademarkGetManyForUserDashboard($filter: trademark_bool_exp = {}, $office_actions_filter: office_action_bool_exp = {}, $use_in_commerce_requests_filter: use_in_commerce_request_bool_exp = {}, $order_by: [trademark_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
    ...trademarkForUserDashboard
    office_actions(
      where: $office_actions_filter
      order_by: {due_date: asc_nulls_last}
      limit: 1
    ) {
      ...officeActionForUserDashboard
    }
    use_in_commerce_requests(
      where: $use_in_commerce_requests_filter
      order_by: {due_date: asc_nulls_last}
      limit: 1
    ) {
      ...useInCommerceRequestForUser
    }
  }
  trademark_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${TrademarkForUserDashboardFragmentDoc}
${OfficeActionForUserDashboardFragmentDoc}
${OfficeActionSolutionForUserFragmentDoc}
${OfficeActionTrackingFragmentDoc}
${UseInCommerceRequestForUserFragmentDoc}`;
export const TrademarkClassInsertOneDocument = `
    mutation trademarkClassInsertOne($object: trademark_class_insert_input!) {
  insert_trademark_class_one(object: $object) {
    ...trademarkClass
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkClassInsertManyDocument = `
    mutation trademarkClassInsertMany($objects: [trademark_class_insert_input!]!) {
  insert_trademark_class(objects: $objects) {
    returning {
      ...trademarkClass
    }
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkClassUpdateOneDocument = `
    mutation trademarkClassUpdateOne($id: uuid!, $changes: trademark_class_set_input) {
  update_trademark_class_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...trademarkClass
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkClassUpdateManyDocument = `
    mutation trademarkClassUpdateMany($where: trademark_class_bool_exp!, $changes: trademark_class_set_input) {
  update_trademark_class(where: $where, _set: $changes) {
    affected_rows
  }
}
    `;
export const TrademarkClassDeleteOneDocument = `
    mutation trademarkClassDeleteOne($id: uuid!) {
  delete_trademark_class_by_pk(id: $id) {
    ...trademarkClass
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkClassDeleteManyDocument = `
    mutation trademarkClassDeleteMany($where: trademark_class_bool_exp!) {
  delete_trademark_class(where: $where) {
    affected_rows
  }
}
    `;
export const TrademarkClassGetByIdDocument = `
    query trademarkClassGetById($id: uuid!) {
  trademark_class_by_pk(id: $id) {
    ...trademarkClass
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkClassGetManyDocument = `
    query trademarkClassGetMany($where: trademark_class_bool_exp!, $order_by: [trademark_class_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [trademark_class_select_column!]) {
  trademark_class(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...trademarkClass
  }
}
    ${TrademarkClassFragmentDoc}`;
export const TrademarkIpoDataUpsertOneDocument = `
    mutation trademarkIpoDataUpsertOne($object: trademark_ipo_data_insert_input!) {
  insert_trademark_ipo_data_one(
    object: $object
    on_conflict: {constraint: trademark_ipo_data_pkey, update_columns: [updated_at, data, source, status, status_change_date, next_sync_due_at]}
  ) {
    ...trademarkIpoData
  }
}
    ${TrademarkIpoDataFragmentDoc}`;
export const TrademarkIpoDataGetManyDocument = `
    query trademarkIpoDataGetMany($filter: trademark_ipo_data_bool_exp = {}, $order_by: [trademark_ipo_data_order_by!] = {}, $offset: Int, $limit: Int) {
  trademark_ipo_data(
    where: $filter
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...trademarkIpoData
  }
}
    ${TrademarkIpoDataFragmentDoc}`;
export const TrademarkMonitoringResultInsertOneDocument = `
    mutation trademarkMonitoringResultInsertOne($object: trademark_monitoring_result_insert_input!) {
  insert_trademark_monitoring_result_one(object: $object) {
    ...trademarkMonitoringResult
  }
}
    ${TrademarkMonitoringResultFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkMonitoringResultUpdateOneDocument = `
    mutation trademarkMonitoringResultUpdateOne($id: uuid!, $changes: trademark_monitoring_result_set_input!) {
  update_trademark_monitoring_result_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...trademarkMonitoringResult
  }
}
    ${TrademarkMonitoringResultFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkMonitoringResultGetByIdDocument = `
    query trademarkMonitoringResultGetById($id: uuid!) {
  trademark_monitoring_result_by_pk(id: $id) {
    ...trademarkMonitoringResultUser
  }
}
    ${TrademarkMonitoringResultUserFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}`;
export const TrademarkMonitoringResultGetManyDocument = `
    query trademarkMonitoringResultGetMany($filter: trademark_monitoring_result_bool_exp = {}, $order_by: [trademark_monitoring_result_order_by!] = {}) {
  trademark_monitoring_result(where: $filter, order_by: $order_by) {
    ...trademarkMonitoringResultUser
  }
}
    ${TrademarkMonitoringResultUserFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}`;
export const TrademarkMonitoringResultGetManyForUserDocument = `
    query trademarkMonitoringResultGetManyForUser($filter: trademark_monitoring_result_bool_exp = {}, $order_by: [trademark_monitoring_result_order_by!] = {}) {
  trademark_monitoring_result(where: $filter, order_by: $order_by) {
    ...trademarkMonitoringResultForUser
  }
}
    ${TrademarkMonitoringResultForUserFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}
${DocumentFragmentDoc}
${ServiceRequestUserFragmentDoc}
${EntityFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const TrademarkMonitoringResultGetUnseenCountDocument = `
    query trademarkMonitoringResultGetUnseenCount {
  trademark_monitoring_result_aggregate(
    where: {seen: {_eq: false}, relevance: {_is_null: false}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const TrademarkMonitoringResultsForTrademarkDocument = `
    query trademarkMonitoringResultsForTrademark($trademarkId: uuid!, $limit: Int) {
  trademark_monitoring_result(
    where: {trademark_id: {_eq: $trademarkId}}
    order_by: {created_at: desc}
    limit: $limit
  ) {
    ...trademarkMonitoringResult
  }
  trademark_monitoring_result_aggregate(
    where: {trademark_id: {_eq: $trademarkId}}
  ) {
    aggregate {
      count
    }
  }
}
    ${TrademarkMonitoringResultFragmentDoc}
${TrademarkMonitoringResultCommonDataFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkRateLimitLogInsertOneDocument = `
    mutation trademarkRateLimitLogInsertOne($object: trademark_rate_limit_log_insert_input!) {
  insert_trademark_rate_limit_log_one(object: $object) {
    ...trademarkRateLimitLog
  }
}
    ${TrademarkRateLimitLogFragmentDoc}`;
export const TrademarkRateLimitLogSumRequestCountDocument = `
    query trademarkRateLimitLogSumRequestCount($filter: trademark_rate_limit_log_bool_exp! = {}) {
  trademark_rate_limit_log_aggregate(where: $filter) {
    aggregate {
      sum {
        request_count
      }
    }
  }
}
    `;
export const TrademarkRequestInsertOneDocument = `
    mutation trademarkRequestInsertOne($object: trademark_request_insert_input!) {
  insert_trademark_request_one(object: $object) {
    ...trademarkRequest
  }
}
    ${TrademarkRequestFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const TrademarkRequestUpdateOneDocument = `
    mutation trademarkRequestUpdateOne($id: uuid!, $changes: trademark_request_set_input!) {
  update_trademark_request_by_pk(pk_columns: {id: $id}, _set: $changes) {
    id
  }
}
    `;
export const TrademarkRequestGetByIdDocument = `
    query trademarkRequestGetById($id: uuid!) {
  trademark_request_by_pk(id: $id) {
    ...trademarkRequest
  }
}
    ${TrademarkRequestFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const TrademarkRequestGetManyDocument = `
    query trademarkRequestGetMany($filter: trademark_request_bool_exp = {}, $order_by: [trademark_request_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark_request(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...trademarkRequest
  }
}
    ${TrademarkRequestFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const TrademarkRequestGetManyForUserDocument = `
    query trademarkRequestGetManyForUser($filter: trademark_request_bool_exp = {}, $order_by: [trademark_request_order_by!] = {}) {
  trademark_request(where: $filter, order_by: $order_by) {
    ...trademarkRequestData
  }
  trademark_request_aggregate(where: $filter, order_by: $order_by) {
    aggregate {
      count
    }
  }
}
    ${TrademarkRequestDataFragmentDoc}`;
export const TrademarkServiceRequestsInsertManyDocument = `
    mutation trademarkServiceRequestsInsertMany($objects: [trademark_service_requests_insert_input!]!) {
  insert_trademark_service_requests(objects: $objects) {
    returning {
      ...trademarkServiceRequests
    }
  }
}
    ${TrademarkServiceRequestsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkServiceRequestsDeleteManyDocument = `
    mutation trademarkServiceRequestsDeleteMany($where: trademark_service_requests_bool_exp!) {
  delete_trademark_service_requests(where: $where) {
    affected_rows
  }
}
    `;
export const TrademarkServiceRequestsGetManyDocument = `
    query trademarkServiceRequestsGetMany($filter: trademark_service_requests_bool_exp = {}, $order_by: [trademark_service_requests_order_by!] = {}, $limit: Int, $offset: Int) {
  trademark_service_requests(
    where: $filter
    order_by: $order_by
    limit: $limit
    offset: $offset
  ) {
    ...trademarkServiceRequests
  }
}
    ${TrademarkServiceRequestsFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkSharedDocumentsInsertManyDocument = `
    mutation trademarkSharedDocumentsInsertMany($objects: [trademark_shared_documents_insert_input!]!) {
  insert_trademark_shared_documents(objects: $objects) {
    returning {
      ...trademarkSharedDocuments
    }
  }
}
    ${TrademarkSharedDocumentsFragmentDoc}`;
export const TrademarkSharedDocumentsDeleteOneDocument = `
    mutation trademarkSharedDocumentsDeleteOne($id: Int!) {
  delete_trademark_shared_documents_by_pk(id: $id) {
    ...trademarkSharedDocuments
  }
}
    ${TrademarkSharedDocumentsFragmentDoc}`;
export const TrademarkSharedDocumentsDeleteManyDocument = `
    mutation trademarkSharedDocumentsDeleteMany($where: trademark_shared_documents_bool_exp!) {
  delete_trademark_shared_documents(where: $where) {
    affected_rows
  }
}
    `;
export const TrademarkSharedDocumentsGetManyDocument = `
    query trademarkSharedDocumentsGetMany($where: trademark_shared_documents_bool_exp!, $order_by: [trademark_shared_documents_order_by!] = {}, $offset: Int, $limit: Int) {
  trademark_shared_documents(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...trademarkSharedDocumentsWithDocument
  }
}
    ${TrademarkSharedDocumentsWithDocumentFragmentDoc}
${TrademarkSharedDocumentsFragmentDoc}
${DocumentFragmentDoc}`;
export const TrademarkTrackingInsertOneDocument = `
    mutation trademarkTrackingInsertOne($object: trademark_tracking_insert_input!) {
  insert_trademark_tracking_one(object: $object) {
    ...trademarkTracking
  }
}
    ${TrademarkTrackingFragmentDoc}`;
export const TrademarkTrackingDeleteOneDocument = `
    mutation trademarkTrackingDeleteOne($id: Int!) {
  delete_trademark_tracking_by_pk(id: $id) {
    ...trademarkTracking
  }
}
    ${TrademarkTrackingFragmentDoc}`;
export const TrademarkTrackingDeleteManyDocument = `
    mutation trademarkTrackingDeleteMany($trademarkId: uuid!, $status: String!) {
  delete_trademark_tracking(
    where: {_and: {trademark_id: {_eq: $trademarkId}, name: {_eq: $status}}}
  ) {
    affected_rows
  }
}
    `;
export const TrademarkTrackingGetManyDocument = `
    query trademarkTrackingGetMany($where: trademark_tracking_bool_exp = {}, $order_by: [trademark_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [trademark_tracking_select_column!]) {
  trademark_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...trademarkTracking
  }
}
    ${TrademarkTrackingFragmentDoc}`;
export const TrademarkTrackingWithStatusGetManyDocument = `
    query trademarkTrackingWithStatusGetMany($where: trademark_tracking_bool_exp = {}, $order_by: [trademark_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [trademark_tracking_select_column!]) {
  trademark_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...trademarkTrackingWithStatus
  }
}
    ${TrademarkTrackingWithStatusFragmentDoc}
${TrademarkTrackingFragmentDoc}`;
export const TrademarkWatchSubscriptionGetManyDocument = `
    query trademarkWatchSubscriptionGetMany($filter: trademark_watch_subscription_bool_exp = {}, $order_by: [trademark_watch_subscription_order_by!] = {}) {
  trademark_watch_subscription(where: $filter, order_by: $order_by) {
    ...trademarkWatchSubscription
  }
}
    ${TrademarkWatchSubscriptionFragmentDoc}`;
export const TrademarkWatchSubscriptionCountDocument = `
    query trademarkWatchSubscriptionCount($filter: trademark_watch_subscription_bool_exp = {}) {
  trademark_watch_subscription_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const TrademarkWatchSubscriptionGetByIdDocument = `
    query trademarkWatchSubscriptionGetById($id: uuid!) {
  trademark_watch_subscription_by_pk(id: $id) {
    ...trademarkWatchSubscription
  }
}
    ${TrademarkWatchSubscriptionFragmentDoc}`;
export const TrademarksDocument = `
    query trademarks($filter: trademark_bool_exp, $filterRequest: trademark_request_bool_exp) {
  trademark_request(where: $filterRequest) {
    ...trademarkRequestData
  }
  trademark(where: $filter) {
    ...trademarkForUser
  }
  trademark_request_aggregate(where: $filterRequest) {
    aggregate {
      count
    }
  }
  trademark_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    ${TrademarkRequestDataFragmentDoc}
${TrademarkForUserFragmentDoc}
${TrademarkClassForUserFragmentDoc}`;
export const UseInCommerceRequestInsertOneDocument = `
    mutation useInCommerceRequestInsertOne($object: use_in_commerce_request_insert_input!) {
  insert_use_in_commerce_request_one(object: $object) {
    ...useInCommerceRequest
  }
}
    ${UseInCommerceRequestFragmentDoc}`;
export const UseInCommerceRequestUpdateOneDocument = `
    mutation useInCommerceRequestUpdateOne($id: uuid!, $changes: use_in_commerce_request_set_input) {
  update_use_in_commerce_request_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...useInCommerceRequest
  }
}
    ${UseInCommerceRequestFragmentDoc}`;
export const UseInCommerceRequestGetByIdDocument = `
    query useInCommerceRequestGetById($id: uuid!) {
  use_in_commerce_request_by_pk(id: $id) {
    ...useInCommerceRequest
  }
}
    ${UseInCommerceRequestFragmentDoc}`;
export const UseInCommerceRequestGetByIdForDraftingDocument = `
    query useInCommerceRequestGetByIdForDrafting($id: uuid!) {
  use_in_commerce_request_by_pk(id: $id) {
    ...useInCommerceRequestForDrafting
  }
}
    ${UseInCommerceRequestForDraftingFragmentDoc}
${UseInCommerceRequestFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${TrademarkClassWithSpecimensFragmentDoc}
${SpecimenFragmentDoc}
${DocumentFragmentDoc}
${UseInCommerceRequestTrackingFragmentDoc}
${ThreadCommentFragmentDoc}`;
export const UseInCommerceRequestGetManyDocument = `
    query useInCommerceRequestGetMany($where: use_in_commerce_request_bool_exp!, $order_by: [use_in_commerce_request_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [use_in_commerce_request_select_column!]) {
  use_in_commerce_request(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...useInCommerceRequest
  }
}
    ${UseInCommerceRequestFragmentDoc}`;
export const UseInCommerceRequestGetManyForDraftingDocument = `
    query useInCommerceRequestGetManyForDrafting($where: use_in_commerce_request_bool_exp!, $order_by: [use_in_commerce_request_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [use_in_commerce_request_select_column!]) {
  use_in_commerce_request(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...useInCommerceRequestForDrafting
  }
}
    ${UseInCommerceRequestForDraftingFragmentDoc}
${UseInCommerceRequestFragmentDoc}
${TrademarkDetailFragmentDoc}
${TrademarkFragmentDoc}
${TrademarkClassFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${TrademarkClassWithSpecimensFragmentDoc}
${SpecimenFragmentDoc}
${DocumentFragmentDoc}
${UseInCommerceRequestTrackingFragmentDoc}
${ThreadCommentFragmentDoc}`;
export const UseInCommerceRequestCountDocument = `
    query useInCommerceRequestCount($filter: use_in_commerce_request_bool_exp = {}) {
  use_in_commerce_request_aggregate(where: $filter) {
    aggregate {
      count
    }
  }
}
    `;
export const UseInCommerceRequestTrackingInsertOneDocument = `
    mutation useInCommerceRequestTrackingInsertOne($object: use_in_commerce_request_tracking_insert_input!) {
  insert_use_in_commerce_request_tracking_one(object: $object) {
    ...useInCommerceRequestTracking
  }
}
    ${UseInCommerceRequestTrackingFragmentDoc}`;
export const UseInCommerceRequestTrackingInsertManyDocument = `
    mutation useInCommerceRequestTrackingInsertMany($objects: [use_in_commerce_request_tracking_insert_input!]!) {
  insert_use_in_commerce_request_tracking(objects: $objects) {
    returning {
      ...useInCommerceRequestTracking
    }
  }
}
    ${UseInCommerceRequestTrackingFragmentDoc}`;
export const UseInCommerceRequestTrackingDeleteOneDocument = `
    mutation useInCommerceRequestTrackingDeleteOne($id: Int!) {
  delete_use_in_commerce_request_tracking_by_pk(id: $id) {
    ...useInCommerceRequestTracking
  }
}
    ${UseInCommerceRequestTrackingFragmentDoc}`;
export const UseInCommerceRequestTrackingGetManyDocument = `
    query useInCommerceRequestTrackingGetMany($where: use_in_commerce_request_tracking_bool_exp = {}, $order_by: [use_in_commerce_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [use_in_commerce_request_tracking_select_column!]) {
  use_in_commerce_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...useInCommerceRequestTracking
  }
}
    ${UseInCommerceRequestTrackingFragmentDoc}`;
export const UseInCommerceRequestTrackingWithStatusGetManyDocument = `
    query useInCommerceRequestTrackingWithStatusGetMany($where: use_in_commerce_request_tracking_bool_exp = {}, $order_by: [use_in_commerce_request_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [use_in_commerce_request_tracking_select_column!]) {
  use_in_commerce_request_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...useInCommerceRequestTrackingWithStatus
  }
}
    ${UseInCommerceRequestTrackingWithStatusFragmentDoc}
${UseInCommerceRequestTrackingFragmentDoc}`;
export const UserUpdateOneDocument = `
    mutation userUpdateOne($id: uuid!, $changes: user_set_input) {
  update_user_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserUpdateSecretDocument = `
    mutation userUpdateSecret($email: String!, $new_secret: uuid!) {
  update_user(_set: {secret: $new_secret}, where: {email: {_eq: $email}}) {
    returning {
      id
      secret
    }
  }
}
    `;
export const UserInsertOneDocument = `
    mutation userInsertOne($object: user_insert_input!) {
  insert_user_one(object: $object) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserGetByIdDocument = `
    query userGetById($id: uuid!) {
  user_by_pk(id: $id) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserForUserGetByIdDocument = `
    query userForUserGetById($id: uuid!) {
  user_by_pk(id: $id) {
    ...userForUser
  }
}
    ${UserForUserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserByRefreshTokenDocument = `
    query userByRefreshToken($refresh_token: uuid!) {
  user(
    where: {_and: {refresh_token: {_eq: $refresh_token}, status: {_eq: "Active"}}}
  ) {
    id
    email
    role
  }
}
    `;
export const UserWithPasswordHashDocument = `
    query userWithPasswordHash($id: uuid!) {
  user_by_pk(id: $id) {
    ...user
    password_hash
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserSecretDocument = `
    query userSecret($id: uuid!) {
  user_by_pk(id: $id) {
    secret
    secret_generated_at
  }
}
    `;
export const UserByEmailDocument = `
    query userByEmail($email: String!) {
  user(where: {email: {_eq: $email}}) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserByEmailWithSecretFieldsDocument = `
    query userByEmailWithSecretFields($email: String!) {
  user(where: {email: {_eq: $email}}) {
    ...userWithSecretFields
  }
}
    ${UserWithSecretFieldsFragmentDoc}
${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserBySecretDocument = `
    query userBySecret($secret: uuid!) {
  user(where: {secret: {_eq: $secret}}) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const GetUsersDocument = `
    query getUsers($where: user_bool_exp = {}, $limit: Int) {
  user(where: $where, limit: $limit) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserGetManyDocument = `
    query userGetMany($filter: user_bool_exp = {}, $order_by: [user_order_by!] = {}, $limit: Int) {
  user(where: $filter, order_by: $order_by, limit: $limit) {
    ...user
  }
}
    ${UserFragmentDoc}
${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserAuthLogInsertOneDocument = `
    mutation userAuthLogInsertOne($object: user_auth_log_insert_input!) {
  insert_user_auth_log_one(object: $object) {
    ...userAuthLog
  }
}
    ${UserAuthLogFragmentDoc}`;
export const UserHistoryInsertOneDocument = `
    mutation userHistoryInsertOne($object: user_history_insert_input!) {
  insert_user_history_one(object: $object) {
    ...userHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export const UserHistoryGetManyDocument = `
    query userHistoryGetMany($where: user_history_bool_exp!, $order_by: [user_history_order_by!], $offset: Int, $limit: Int, $distinct_on: [user_history_select_column!]) {
  user_history(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...userHistory
  }
}
    ${UserHistoryFragmentDoc}`;
export const UserPaymentMethodInsertOneDocument = `
    mutation userPaymentMethodInsertOne($object: user_payment_method_insert_input!) {
  insert_user_payment_method_one(object: $object) {
    ...userPaymentMethod
  }
}
    ${UserPaymentMethodFragmentDoc}`;
export const UserPaymentMethodUpdateOneDocument = `
    mutation userPaymentMethodUpdateOne($id: uuid!, $changes: user_payment_method_set_input) {
  update_user_payment_method_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...userPaymentMethod
  }
}
    ${UserPaymentMethodFragmentDoc}`;
export const UserPaymentMethodUpdateManyDocument = `
    mutation userPaymentMethodUpdateMany($where: user_payment_method_bool_exp!, $set: user_payment_method_set_input!) {
  update_user_payment_method(where: $where, _set: $set) {
    returning {
      ...userPaymentMethod
    }
  }
}
    ${UserPaymentMethodFragmentDoc}`;
export const UserPaymentMethodGetByIdDocument = `
    query userPaymentMethodGetById($id: uuid!) {
  user_payment_method_by_pk(id: $id) {
    ...userPaymentMethod
  }
}
    ${UserPaymentMethodFragmentDoc}`;
export const UserPaymentMethodGetManyDocument = `
    query userPaymentMethodGetMany($where: user_payment_method_bool_exp = {}, $order_by: [user_payment_method_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [user_payment_method_select_column!]) {
  user_payment_method(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...userPaymentMethod
  }
}
    ${UserPaymentMethodFragmentDoc}`;
export const UserPaymentMethodGetManyForUserDocument = `
    query userPaymentMethodGetManyForUser($where: user_payment_method_bool_exp = {}, $order_by: [user_payment_method_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [user_payment_method_select_column!]) {
  user_payment_method(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...userPaymentMethodForUser
  }
}
    ${UserPaymentMethodForUserFragmentDoc}`;
export const UserProfileUpdateOneDocument = `
    mutation userProfileUpdateOne($id: Int!, $changes: user_profile_set_input!) {
  update_user_profile_by_pk(_set: $changes, pk_columns: {id: $id}) {
    ...profile
  }
}
    ${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserProfileInsertOneDocument = `
    mutation userProfileInsertOne($object: user_profile_insert_input!) {
  insert_user_profile_one(object: $object) {
    id
  }
}
    `;
export const UserProfileGetByIdDocument = `
    query userProfileGetById($id: Int!) {
  user_profile_by_pk(id: $id) {
    ...profile
  }
}
    ${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserProfileGetManyDocument = `
    query userProfileGetMany($filter: user_profile_bool_exp = {}, $order_by: [user_profile_order_by!] = {}, $limit: Int) {
  user_profile(where: $filter, order_by: $order_by, limit: $limit) {
    ...profile
  }
}
    ${ProfileFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const UserTrackingInsertOneDocument = `
    mutation userTrackingInsertOne($object: user_tracking_insert_input!) {
  insert_user_tracking_one(object: $object) {
    ...userTracking
  }
}
    ${UserTrackingFragmentDoc}`;
export const UserTrackingDeleteOneDocument = `
    mutation userTrackingDeleteOne($id: Int!) {
  delete_user_tracking_by_pk(id: $id) {
    ...userTracking
  }
}
    ${UserTrackingFragmentDoc}`;
export const UserTrackingGetManyDocument = `
    query userTrackingGetMany($where: user_tracking_bool_exp = {}, $order_by: [user_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [user_tracking_select_column!]) {
  user_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...userTracking
  }
}
    ${UserTrackingFragmentDoc}`;
export const UserTrackingWithStatusGetManyDocument = `
    query userTrackingWithStatusGetMany($where: user_tracking_bool_exp = {}, $order_by: [user_tracking_order_by!] = {}, $offset: Int, $limit: Int, $distinct_on: [user_tracking_select_column!]) {
  user_tracking(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...userTrackingWithStatus
  }
}
    ${UserTrackingWithStatusFragmentDoc}
${UserTrackingFragmentDoc}`;
export const VerificationResultInsertOneDocument = `
    mutation verificationResultInsertOne($object: verification_result_insert_input!) {
  insert_verification_result_one(object: $object) {
    ...verificationResult
  }
}
    ${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${DocumentFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const VerificationResultUpdateOneDocument = `
    mutation verificationResultUpdateOne($id: uuid!, $changes: verification_result_set_input!) {
  update_verification_result_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...verificationResult
  }
}
    ${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${DocumentFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const VerificationResultGetByIdDocument = `
    query verificationResultGetById($id: uuid!) {
  verification_result_by_pk(id: $id) {
    ...verificationResult
  }
}
    ${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${DocumentFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const VerificationResultGetManyDocument = `
    query verificationResultGetMany($where: verification_result_bool_exp!, $order_by: [verification_result_order_by!] = {}, $offset: Int, $limit: Int) {
  verification_result(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...verificationResult
  }
}
    ${VerificationResultFragmentDoc}
${SimilarTrademarkFragmentDoc}
${DocumentFragmentDoc}
${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}
${BrandSnapshotFragmentDoc}`;
export const VerificationResultSimilarTrademarkMapInsertManyDocument = `
    mutation verificationResultSimilarTrademarkMapInsertMany($objects: [verification_result_similar_trademark_map_insert_input!]!) {
  insert_verification_result_similar_trademark_map(objects: $objects) {
    returning {
      ...verificationResultSimilarTrademarkMap
    }
  }
}
    ${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const VerificationResultSimilarTrademarkMapDeleteManyDocument = `
    mutation verificationResultSimilarTrademarkMapDeleteMany($where: verification_result_similar_trademark_map_bool_exp!) {
  delete_verification_result_similar_trademark_map(where: $where) {
    affected_rows
  }
}
    `;
export const VerificationResultSimilarTrademarkMapUpdateOneDocument = `
    mutation verificationResultSimilarTrademarkMapUpdateOne($id: uuid!, $changes: verification_result_similar_trademark_map_set_input!) {
  update_verification_result_similar_trademark_map_by_pk(
    pk_columns: {id: $id}
    _set: $changes
  ) {
    ...verificationResultSimilarTrademarkMap
  }
}
    ${VerificationResultSimilarTrademarkMapFragmentDoc}
${ExternalTrademarkFragmentDoc}
${EntityDataFragmentDoc}
${AddressDataFragmentDoc}`;
export const WebsiteInsertManyDocument = `
    mutation websiteInsertMany($objects: [website_insert_input!]!) {
  insert_website(objects: $objects) {
    returning {
      ...website
    }
  }
}
    ${WebsiteFragmentDoc}
${WebsiteForUserFragmentDoc}`;
export const WebsiteDeleteByIdsDocument = `
    mutation websiteDeleteByIds($ids: [uuid!]!) {
  delete_website(where: {id: {_in: $ids}}) {
    affected_rows
  }
}
    `;
export const WebsiteUpdateOneDocument = `
    mutation websiteUpdateOne($id: uuid!, $changes: website_set_input!) {
  update_website_by_pk(pk_columns: {id: $id}, _set: $changes) {
    ...website
  }
}
    ${WebsiteFragmentDoc}
${WebsiteForUserFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addressInsertOne(variables: AddressInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddressInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressInsertOneMutation>(AddressInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addressInsertOne', 'mutation', variables);
    },
    addressUpsertOne(variables: AddressUpsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddressUpsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressUpsertOneMutation>(AddressUpsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addressUpsertOne', 'mutation', variables);
    },
    addressUpdateOne(variables: AddressUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddressUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressUpdateOneMutation>(AddressUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addressUpdateOne', 'mutation', variables);
    },
    addressDeleteOne(variables: AddressDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddressDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressDeleteOneMutation>(AddressDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addressDeleteOne', 'mutation', variables);
    },
    addressGetById(variables: AddressGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddressGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddressGetByIdQuery>(AddressGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addressGetById', 'query', variables);
    },
    aiGsItemsAnalysisInsertOne(variables: AiGsItemsAnalysisInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiGsItemsAnalysisInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiGsItemsAnalysisInsertOneMutation>(AiGsItemsAnalysisInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aiGsItemsAnalysisInsertOne', 'mutation', variables);
    },
    aiGsItemsAnalysisGetMany(variables: AiGsItemsAnalysisGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AiGsItemsAnalysisGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AiGsItemsAnalysisGetManyQuery>(AiGsItemsAnalysisGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aiGsItemsAnalysisGetMany', 'query', variables);
    },
    applicationInsertOne(variables: ApplicationInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationInsertOneMutation>(ApplicationInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationInsertOne', 'mutation', variables);
    },
    applicationUpdate(variables: ApplicationUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationUpdateMutation>(ApplicationUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationUpdate', 'mutation', variables);
    },
    applicationGetMany(variables?: ApplicationGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationGetManyQuery>(ApplicationGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationGetMany', 'query', variables);
    },
    applicationGetById(variables: ApplicationGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationGetByIdQuery>(ApplicationGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationGetById', 'query', variables);
    },
    applicationDataById(variables: ApplicationDataByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationDataByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationDataByIdQuery>(ApplicationDataByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationDataById', 'query', variables);
    },
    applicationJurisdictionUpdateById(variables: ApplicationJurisdictionUpdateByIdMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationJurisdictionUpdateByIdMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationJurisdictionUpdateByIdMutation>(ApplicationJurisdictionUpdateByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationJurisdictionUpdateById', 'mutation', variables);
    },
    applicationJurisdictionUpdateMultiple(variables: ApplicationJurisdictionUpdateMultipleMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationJurisdictionUpdateMultipleMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationJurisdictionUpdateMultipleMutation>(ApplicationJurisdictionUpdateMultipleDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationJurisdictionUpdateMultiple', 'mutation', variables);
    },
    applicationJurisdictionDeleteMany(variables: ApplicationJurisdictionDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationJurisdictionDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationJurisdictionDeleteManyMutation>(ApplicationJurisdictionDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationJurisdictionDeleteMany', 'mutation', variables);
    },
    applicationJurisdictionInsertMany(variables: ApplicationJurisdictionInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationJurisdictionInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationJurisdictionInsertManyMutation>(ApplicationJurisdictionInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationJurisdictionInsertMany', 'mutation', variables);
    },
    applicationJurisdictionGetMany(variables?: ApplicationJurisdictionGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApplicationJurisdictionGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApplicationJurisdictionGetManyQuery>(ApplicationJurisdictionGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'applicationJurisdictionGetMany', 'query', variables);
    },
    trademarkAuditLog(variables: TrademarkAuditLogQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkAuditLogQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkAuditLogQuery>(TrademarkAuditLogDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkAuditLog', 'query', variables);
    },
    trademarkAuditLogCount(variables: TrademarkAuditLogCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkAuditLogCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkAuditLogCountQuery>(TrademarkAuditLogCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkAuditLogCount', 'query', variables);
    },
    brandInsertOne(variables: BrandInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandInsertOneMutation>(BrandInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandInsertOne', 'mutation', variables);
    },
    brandInsertMany(variables: BrandInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandInsertManyMutation>(BrandInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandInsertMany', 'mutation', variables);
    },
    brandUpdateOne(variables: BrandUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandUpdateOneMutation>(BrandUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandUpdateOne', 'mutation', variables);
    },
    brandDeleteOne(variables: BrandDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandDeleteOneMutation>(BrandDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandDeleteOne', 'mutation', variables);
    },
    brandGetById(variables: BrandGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandGetByIdQuery>(BrandGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandGetById', 'query', variables);
    },
    brandGetByIdForUser(variables: BrandGetByIdForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandGetByIdForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandGetByIdForUserQuery>(BrandGetByIdForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandGetByIdForUser', 'query', variables);
    },
    brandGetMany(variables?: BrandGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandGetManyQuery>(BrandGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandGetMany', 'query', variables);
    },
    brandGetManyForUser(variables?: BrandGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandGetManyForUserQuery>(BrandGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandGetManyForUser', 'query', variables);
    },
    brandWithRecentTasksGetManyForUser(variables?: BrandWithRecentTasksGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandWithRecentTasksGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandWithRecentTasksGetManyForUserQuery>(BrandWithRecentTasksGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandWithRecentTasksGetManyForUser', 'query', variables);
    },
    monitoredBrandsTotalCount(variables: MonitoredBrandsTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MonitoredBrandsTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MonitoredBrandsTotalCountQuery>(MonitoredBrandsTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'monitoredBrandsTotalCount', 'query', variables);
    },
    brandMonitoringTaskInsertOne(variables: BrandMonitoringTaskInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskInsertOneMutation>(BrandMonitoringTaskInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskInsertOne', 'mutation', variables);
    },
    brandMonitoringTaskUpdateOne(variables: BrandMonitoringTaskUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskUpdateOneMutation>(BrandMonitoringTaskUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskUpdateOne', 'mutation', variables);
    },
    brandMonitoringTaskGetById(variables: BrandMonitoringTaskGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskGetByIdQuery>(BrandMonitoringTaskGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskGetById', 'query', variables);
    },
    brandMonitoringTaskGetMany(variables: BrandMonitoringTaskGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskGetManyQuery>(BrandMonitoringTaskGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskGetMany', 'query', variables);
    },
    brandMonitoringTaskTrackingInsertOne(variables: BrandMonitoringTaskTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskTrackingInsertOneMutation>(BrandMonitoringTaskTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskTrackingInsertOne', 'mutation', variables);
    },
    brandMonitoringTaskTrackingDeleteOne(variables: BrandMonitoringTaskTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskTrackingDeleteOneMutation>(BrandMonitoringTaskTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskTrackingDeleteOne', 'mutation', variables);
    },
    brandMonitoringTaskTrackingGetMany(variables?: BrandMonitoringTaskTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskTrackingGetManyQuery>(BrandMonitoringTaskTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskTrackingGetMany', 'query', variables);
    },
    brandMonitoringTaskTrackingWithStatusGetMany(variables?: BrandMonitoringTaskTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandMonitoringTaskTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandMonitoringTaskTrackingWithStatusGetManyQuery>(BrandMonitoringTaskTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandMonitoringTaskTrackingWithStatusGetMany', 'query', variables);
    },
    brandSnapshotInsertOne(variables: BrandSnapshotInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSnapshotInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSnapshotInsertOneMutation>(BrandSnapshotInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSnapshotInsertOne', 'mutation', variables);
    },
    brandSubscriptionInsertOne(variables: BrandSubscriptionInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionInsertOneMutation>(BrandSubscriptionInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionInsertOne', 'mutation', variables);
    },
    brandSubscriptionUpdateOne(variables: BrandSubscriptionUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionUpdateOneMutation>(BrandSubscriptionUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionUpdateOne', 'mutation', variables);
    },
    brandSubscriptionUpdateMany(variables: BrandSubscriptionUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionUpdateManyMutation>(BrandSubscriptionUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionUpdateMany', 'mutation', variables);
    },
    brandSubscriptionGetById(variables: BrandSubscriptionGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionGetByIdQuery>(BrandSubscriptionGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionGetById', 'query', variables);
    },
    brandSubscriptionGetDetailsById(variables: BrandSubscriptionGetDetailsByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionGetDetailsByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionGetDetailsByIdQuery>(BrandSubscriptionGetDetailsByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionGetDetailsById', 'query', variables);
    },
    brandSubscriptionGetMany(variables: BrandSubscriptionGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionGetManyQuery>(BrandSubscriptionGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionGetMany', 'query', variables);
    },
    brandSubscriptionCount(variables?: BrandSubscriptionCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionCountQuery>(BrandSubscriptionCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionCount', 'query', variables);
    },
    brandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUser(variables: BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserQuery>(BrandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionWithBrandEntityPlatformsAndPaymentsGetManyForUser', 'query', variables);
    },
    casesInLastTaskTotalCount(variables: CasesInLastTaskTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CasesInLastTaskTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CasesInLastTaskTotalCountQuery>(CasesInLastTaskTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'casesInLastTaskTotalCount', 'query', variables);
    },
    brandSubscriptionWithLastTaskGetMany(variables: BrandSubscriptionWithLastTaskGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionWithLastTaskGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionWithLastTaskGetManyQuery>(BrandSubscriptionWithLastTaskGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionWithLastTaskGetMany', 'query', variables);
    },
    brandSubscriptionPaymentInsertOne(variables: BrandSubscriptionPaymentInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentInsertOneMutation>(BrandSubscriptionPaymentInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentInsertOne', 'mutation', variables);
    },
    brandSubscriptionPaymentUpsertOne(variables: BrandSubscriptionPaymentUpsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentUpsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentUpsertOneMutation>(BrandSubscriptionPaymentUpsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentUpsertOne', 'mutation', variables);
    },
    brandSubscriptionPaymentUpdateOne(variables: BrandSubscriptionPaymentUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentUpdateOneMutation>(BrandSubscriptionPaymentUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentUpdateOne', 'mutation', variables);
    },
    brandSubscriptionPaymentDeleteMany(variables: BrandSubscriptionPaymentDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentDeleteManyMutation>(BrandSubscriptionPaymentDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentDeleteMany', 'mutation', variables);
    },
    brandSubscriptionPaymentGetById(variables: BrandSubscriptionPaymentGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentGetByIdQuery>(BrandSubscriptionPaymentGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentGetById', 'query', variables);
    },
    brandSubscriptionPaymentGetMany(variables?: BrandSubscriptionPaymentGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPaymentGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPaymentGetManyQuery>(BrandSubscriptionPaymentGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPaymentGetMany', 'query', variables);
    },
    brandSubscriptionPlatformInsertOne(variables: BrandSubscriptionPlatformInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPlatformInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPlatformInsertOneMutation>(BrandSubscriptionPlatformInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPlatformInsertOne', 'mutation', variables);
    },
    brandSubscriptionPlatformUpdateOne(variables: BrandSubscriptionPlatformUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPlatformUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPlatformUpdateOneMutation>(BrandSubscriptionPlatformUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPlatformUpdateOne', 'mutation', variables);
    },
    brandSubscriptionPlatformDeleteMany(variables: BrandSubscriptionPlatformDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPlatformDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPlatformDeleteManyMutation>(BrandSubscriptionPlatformDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPlatformDeleteMany', 'mutation', variables);
    },
    brandSubscriptionPlatformGetMany(variables?: BrandSubscriptionPlatformGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionPlatformGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionPlatformGetManyQuery>(BrandSubscriptionPlatformGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionPlatformGetMany', 'query', variables);
    },
    brandSubscriptionTrackingInsertOne(variables: BrandSubscriptionTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionTrackingInsertOneMutation>(BrandSubscriptionTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionTrackingInsertOne', 'mutation', variables);
    },
    brandSubscriptionTrackingDeleteOne(variables: BrandSubscriptionTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionTrackingDeleteOneMutation>(BrandSubscriptionTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionTrackingDeleteOne', 'mutation', variables);
    },
    brandSubscriptionTrackingGetMany(variables?: BrandSubscriptionTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionTrackingGetManyQuery>(BrandSubscriptionTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionTrackingGetMany', 'query', variables);
    },
    brandSubscriptionTrackingWithStatusGetMany(variables?: BrandSubscriptionTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BrandSubscriptionTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<BrandSubscriptionTrackingWithStatusGetManyQuery>(BrandSubscriptionTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'brandSubscriptionTrackingWithStatusGetMany', 'query', variables);
    },
    caseInsertOne(variables: CaseInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInsertOneMutation>(CaseInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInsertOne', 'mutation', variables);
    },
    caseUpdateOne(variables: CaseUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseUpdateOneMutation>(CaseUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseUpdateOne', 'mutation', variables);
    },
    caseGetById(variables: CaseGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseGetByIdQuery>(CaseGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseGetById', 'query', variables);
    },
    caseGetMany(variables: CaseGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseGetManyQuery>(CaseGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseGetMany', 'query', variables);
    },
    caseWithCounterpartyGetMany(variables: CaseWithCounterpartyGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseWithCounterpartyGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseWithCounterpartyGetManyQuery>(CaseWithCounterpartyGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseWithCounterpartyGetMany', 'query', variables);
    },
    caseGetManyForUser(variables: CaseGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseGetManyForUserQuery>(CaseGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseGetManyForUser', 'query', variables);
    },
    casesTotalCount(variables: CasesTotalCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CasesTotalCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CasesTotalCountQuery>(CasesTotalCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'casesTotalCount', 'query', variables);
    },
    caseGetByIdForUser(variables: CaseGetByIdForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseGetByIdForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseGetByIdForUserQuery>(CaseGetByIdForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseGetByIdForUser', 'query', variables);
    },
    caseIdWithCounterpartyGetMany(variables: CaseIdWithCounterpartyGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseIdWithCounterpartyGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseIdWithCounterpartyGetManyQuery>(CaseIdWithCounterpartyGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseIdWithCounterpartyGetMany', 'query', variables);
    },
    caseCounterpartyInsertOne(variables: CaseCounterpartyInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseCounterpartyInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseCounterpartyInsertOneMutation>(CaseCounterpartyInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseCounterpartyInsertOne', 'mutation', variables);
    },
    caseCounterpartyUpdateOne(variables: CaseCounterpartyUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseCounterpartyUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseCounterpartyUpdateOneMutation>(CaseCounterpartyUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseCounterpartyUpdateOne', 'mutation', variables);
    },
    caseCounterpartyGetById(variables: CaseCounterpartyGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseCounterpartyGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseCounterpartyGetByIdQuery>(CaseCounterpartyGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseCounterpartyGetById', 'query', variables);
    },
    caseCounterpartyGetMany(variables: CaseCounterpartyGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseCounterpartyGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseCounterpartyGetManyQuery>(CaseCounterpartyGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseCounterpartyGetMany', 'query', variables);
    },
    caseCounterpartyGetManyForUser(variables: CaseCounterpartyGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseCounterpartyGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseCounterpartyGetManyForUserQuery>(CaseCounterpartyGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseCounterpartyGetManyForUser', 'query', variables);
    },
    caseInfringementInsertOne(variables: CaseInfringementInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementInsertOneMutation>(CaseInfringementInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementInsertOne', 'mutation', variables);
    },
    caseInfringementUpdateOne(variables: CaseInfringementUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementUpdateOneMutation>(CaseInfringementUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementUpdateOne', 'mutation', variables);
    },
    caseInfringementDeleteOne(variables: CaseInfringementDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementDeleteOneMutation>(CaseInfringementDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementDeleteOne', 'mutation', variables);
    },
    caseInfringementGetById(variables: CaseInfringementGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementGetByIdQuery>(CaseInfringementGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementGetById', 'query', variables);
    },
    caseInfringementGetMany(variables: CaseInfringementGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementGetManyQuery>(CaseInfringementGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementGetMany', 'query', variables);
    },
    caseInfringementEvidenceInsertOne(variables: CaseInfringementEvidenceInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementEvidenceInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementEvidenceInsertOneMutation>(CaseInfringementEvidenceInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementEvidenceInsertOne', 'mutation', variables);
    },
    caseInfringementEvidenceUpdateOne(variables: CaseInfringementEvidenceUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementEvidenceUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementEvidenceUpdateOneMutation>(CaseInfringementEvidenceUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementEvidenceUpdateOne', 'mutation', variables);
    },
    caseInfringementEvidenceDeleteOne(variables: CaseInfringementEvidenceDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementEvidenceDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementEvidenceDeleteOneMutation>(CaseInfringementEvidenceDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementEvidenceDeleteOne', 'mutation', variables);
    },
    caseInfringementEvidenceGetById(variables: CaseInfringementEvidenceGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementEvidenceGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementEvidenceGetByIdQuery>(CaseInfringementEvidenceGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementEvidenceGetById', 'query', variables);
    },
    caseInfringementEvidenceGetMany(variables: CaseInfringementEvidenceGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseInfringementEvidenceGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseInfringementEvidenceGetManyQuery>(CaseInfringementEvidenceGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseInfringementEvidenceGetMany', 'query', variables);
    },
    caseRequestInsertOne(variables: CaseRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestInsertOneMutation>(CaseRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestInsertOne', 'mutation', variables);
    },
    caseRequestUpdateOne(variables: CaseRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestUpdateOneMutation>(CaseRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestUpdateOne', 'mutation', variables);
    },
    caseRequestGetById(variables: CaseRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestGetByIdQuery>(CaseRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestGetById', 'query', variables);
    },
    caseRequestGetMany(variables: CaseRequestGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestGetManyQuery>(CaseRequestGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestGetMany', 'query', variables);
    },
    caseRequestTrackingInsertOne(variables: CaseRequestTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestTrackingInsertOneMutation>(CaseRequestTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestTrackingInsertOne', 'mutation', variables);
    },
    caseRequestTrackingDeleteOne(variables: CaseRequestTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestTrackingDeleteOneMutation>(CaseRequestTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestTrackingDeleteOne', 'mutation', variables);
    },
    caseRequestTrackingGetMany(variables?: CaseRequestTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestTrackingGetManyQuery>(CaseRequestTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestTrackingGetMany', 'query', variables);
    },
    caseRequestTrackingWithStatusGetMany(variables?: CaseRequestTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseRequestTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseRequestTrackingWithStatusGetManyQuery>(CaseRequestTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseRequestTrackingWithStatusGetMany', 'query', variables);
    },
    caseSolutionInsertOne(variables: CaseSolutionInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionInsertOneMutation>(CaseSolutionInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionInsertOne', 'mutation', variables);
    },
    caseSolutionUpdateOne(variables: CaseSolutionUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionUpdateOneMutation>(CaseSolutionUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionUpdateOne', 'mutation', variables);
    },
    caseSolutionUpdateMany(variables: CaseSolutionUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionUpdateManyMutation>(CaseSolutionUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionUpdateMany', 'mutation', variables);
    },
    caseSolutionDeleteOne(variables: CaseSolutionDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionDeleteOneMutation>(CaseSolutionDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionDeleteOne', 'mutation', variables);
    },
    caseSolutionGetById(variables: CaseSolutionGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionGetByIdQuery>(CaseSolutionGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionGetById', 'query', variables);
    },
    caseSolutionGetMany(variables: CaseSolutionGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseSolutionGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseSolutionGetManyQuery>(CaseSolutionGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseSolutionGetMany', 'query', variables);
    },
    caseTrackingInsertOne(variables: CaseTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseTrackingInsertOneMutation>(CaseTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseTrackingInsertOne', 'mutation', variables);
    },
    caseTrackingInsertMany(variables: CaseTrackingInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseTrackingInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseTrackingInsertManyMutation>(CaseTrackingInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseTrackingInsertMany', 'mutation', variables);
    },
    caseTrackingDeleteOne(variables: CaseTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseTrackingDeleteOneMutation>(CaseTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseTrackingDeleteOne', 'mutation', variables);
    },
    caseTrackingGetMany(variables?: CaseTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseTrackingGetManyQuery>(CaseTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseTrackingGetMany', 'query', variables);
    },
    caseTrackingWithStatusGetMany(variables?: CaseTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CaseTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaseTrackingWithStatusGetManyQuery>(CaseTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'caseTrackingWithStatusGetMany', 'query', variables);
    },
    consultationInsertOne(variables: ConsultationInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationInsertOneMutation>(ConsultationInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationInsertOne', 'mutation', variables);
    },
    consultationUpdateOne(variables: ConsultationUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationUpdateOneMutation>(ConsultationUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationUpdateOne', 'mutation', variables);
    },
    consultationDeleteOne(variables: ConsultationDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationDeleteOneMutation>(ConsultationDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationDeleteOne', 'mutation', variables);
    },
    consultationDeleteMany(variables: ConsultationDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationDeleteManyMutation>(ConsultationDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationDeleteMany', 'mutation', variables);
    },
    consultationGetMany(variables?: ConsultationGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationGetManyQuery>(ConsultationGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationGetMany', 'query', variables);
    },
    consultationGetManyUserAggregate(variables?: ConsultationGetManyUserAggregateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationGetManyUserAggregateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationGetManyUserAggregateQuery>(ConsultationGetManyUserAggregateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationGetManyUserAggregate', 'query', variables);
    },
    consultationGetById(variables: ConsultationGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConsultationGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConsultationGetByIdQuery>(ConsultationGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'consultationGetById', 'query', variables);
    },
    contentfulInsertOne(variables: ContentfulInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulInsertOneMutation>(ContentfulInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulInsertOne', 'mutation', variables);
    },
    contentfulInsertMany(variables: ContentfulInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulInsertManyMutation>(ContentfulInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulInsertMany', 'mutation', variables);
    },
    contentfulUpdateOne(variables: ContentfulUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulUpdateOneMutation>(ContentfulUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulUpdateOne', 'mutation', variables);
    },
    contentfulUpdateMany(variables: ContentfulUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulUpdateManyMutation>(ContentfulUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulUpdateMany', 'mutation', variables);
    },
    contentfulDeleteOne(variables: ContentfulDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulDeleteOneMutation>(ContentfulDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulDeleteOne', 'mutation', variables);
    },
    contentfulDeleteMany(variables: ContentfulDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulDeleteManyMutation>(ContentfulDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulDeleteMany', 'mutation', variables);
    },
    contentfulGetById(variables: ContentfulGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulGetByIdQuery>(ContentfulGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulGetById', 'query', variables);
    },
    contentfulGetMany(variables?: ContentfulGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulGetManyQuery>(ContentfulGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulGetMany', 'query', variables);
    },
    contentfulHeadersGetMany(variables?: ContentfulHeadersGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulHeadersGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulHeadersGetManyQuery>(ContentfulHeadersGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulHeadersGetMany', 'query', variables);
    },
    contentfulCount(variables?: ContentfulCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContentfulCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContentfulCountQuery>(ContentfulCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contentfulCount', 'query', variables);
    },
    creditNoteInsertOne(variables: CreditNoteInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditNoteInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditNoteInsertOneMutation>(CreditNoteInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditNoteInsertOne', 'mutation', variables);
    },
    creditNoteGetById(variables: CreditNoteGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditNoteGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditNoteGetByIdQuery>(CreditNoteGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditNoteGetById', 'query', variables);
    },
    creditNoteGetMany(variables?: CreditNoteGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditNoteGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditNoteGetManyQuery>(CreditNoteGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditNoteGetMany', 'query', variables);
    },
    creditNoteLastVariableSymbolBetweenDates(variables: CreditNoteLastVariableSymbolBetweenDatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditNoteLastVariableSymbolBetweenDatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditNoteLastVariableSymbolBetweenDatesQuery>(CreditNoteLastVariableSymbolBetweenDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditNoteLastVariableSymbolBetweenDates', 'query', variables);
    },
    creditNoteByInvoiceReference(variables: CreditNoteByInvoiceReferenceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreditNoteByInvoiceReferenceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreditNoteByInvoiceReferenceQuery>(CreditNoteByInvoiceReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'creditNoteByInvoiceReference', 'query', variables);
    },
    allUserCreditNotes(variables: AllUserCreditNotesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllUserCreditNotesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllUserCreditNotesQuery>(AllUserCreditNotesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allUserCreditNotes', 'query', variables);
    },
    trademarkNotificationsCount(variables: TrademarkNotificationsCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkNotificationsCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkNotificationsCountQuery>(TrademarkNotificationsCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkNotificationsCount', 'query', variables);
    },
    discountCouponInsertOne(variables: DiscountCouponInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DiscountCouponInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DiscountCouponInsertOneMutation>(DiscountCouponInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'discountCouponInsertOne', 'mutation', variables);
    },
    discountCouponUpdateOne(variables: DiscountCouponUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DiscountCouponUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DiscountCouponUpdateOneMutation>(DiscountCouponUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'discountCouponUpdateOne', 'mutation', variables);
    },
    discountCouponGetById(variables: DiscountCouponGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DiscountCouponGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DiscountCouponGetByIdQuery>(DiscountCouponGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'discountCouponGetById', 'query', variables);
    },
    docketedMessageInsertOne(variables: DocketedMessageInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocketedMessageInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocketedMessageInsertOneMutation>(DocketedMessageInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'docketedMessageInsertOne', 'mutation', variables);
    },
    docketedMessageUpdateOne(variables: DocketedMessageUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocketedMessageUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocketedMessageUpdateOneMutation>(DocketedMessageUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'docketedMessageUpdateOne', 'mutation', variables);
    },
    docketedMessageUpdateMany(variables: DocketedMessageUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocketedMessageUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocketedMessageUpdateManyMutation>(DocketedMessageUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'docketedMessageUpdateMany', 'mutation', variables);
    },
    docketedMessageGetById(variables: DocketedMessageGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocketedMessageGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocketedMessageGetByIdQuery>(DocketedMessageGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'docketedMessageGetById', 'query', variables);
    },
    docketedMessageGetMany(variables: DocketedMessageGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocketedMessageGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocketedMessageGetManyQuery>(DocketedMessageGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'docketedMessageGetMany', 'query', variables);
    },
    documentFolderInsertOne(variables: DocumentFolderInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentFolderInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentFolderInsertOneMutation>(DocumentFolderInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentFolderInsertOne', 'mutation', variables);
    },
    documentInsertOne(variables: DocumentInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentInsertOneMutation>(DocumentInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentInsertOne', 'mutation', variables);
    },
    documentDeleteOne(variables: DocumentDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentDeleteOneMutation>(DocumentDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentDeleteOne', 'mutation', variables);
    },
    documentUpdateOne(variables: DocumentUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentUpdateOneMutation>(DocumentUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentUpdateOne', 'mutation', variables);
    },
    documentInsertMany(variables: DocumentInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentInsertManyMutation>(DocumentInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentInsertMany', 'mutation', variables);
    },
    documentGetById(variables: DocumentGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGetByIdQuery>(DocumentGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentGetById', 'query', variables);
    },
    documentGetMany(variables: DocumentGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DocumentGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DocumentGetManyQuery>(DocumentGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'documentGetMany', 'query', variables);
    },
    entityInsertOne(variables: EntityInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityInsertOneMutation>(EntityInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityInsertOne', 'mutation', variables);
    },
    entityUpsertOne(variables: EntityUpsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityUpsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityUpsertOneMutation>(EntityUpsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityUpsertOne', 'mutation', variables);
    },
    entityUpdateOne(variables: EntityUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityUpdateOneMutation>(EntityUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityUpdateOne', 'mutation', variables);
    },
    entityDeleteOne(variables: EntityDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityDeleteOneMutation>(EntityDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityDeleteOne', 'mutation', variables);
    },
    entityGetById(variables: EntityGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityGetByIdQuery>(EntityGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityGetById', 'query', variables);
    },
    entityGetMany(variables?: EntityGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntityGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntityGetManyQuery>(EntityGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'entityGetMany', 'query', variables);
    },
    exchangeRateInsertMany(variables: ExchangeRateInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExchangeRateInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExchangeRateInsertManyMutation>(ExchangeRateInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exchangeRateInsertMany', 'mutation', variables);
    },
    exchangeRateGetMany(variables?: ExchangeRateGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExchangeRateGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExchangeRateGetManyQuery>(ExchangeRateGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exchangeRateGetMany', 'query', variables);
    },
    externalTrademarkInsertOne(variables: ExternalTrademarkInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExternalTrademarkInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExternalTrademarkInsertOneMutation>(ExternalTrademarkInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'externalTrademarkInsertOne', 'mutation', variables);
    },
    externalTrademarkUpdateOne(variables: ExternalTrademarkUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExternalTrademarkUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExternalTrademarkUpdateOneMutation>(ExternalTrademarkUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'externalTrademarkUpdateOne', 'mutation', variables);
    },
    externalTrademarkGetMany(variables: ExternalTrademarkGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ExternalTrademarkGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ExternalTrademarkGetManyQuery>(ExternalTrademarkGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'externalTrademarkGetMany', 'query', variables);
    },
    invoiceUpdateOne(variables: InvoiceUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUpdateOneMutation>(InvoiceUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUpdateOne', 'mutation', variables);
    },
    invoiceUpsert(variables: InvoiceUpsertMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceUpsertMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceUpsertMutation>(InvoiceUpsertDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceUpsert', 'mutation', variables);
    },
    invoiceMarkAsPaid(variables: InvoiceMarkAsPaidMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceMarkAsPaidMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceMarkAsPaidMutation>(InvoiceMarkAsPaidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceMarkAsPaid', 'mutation', variables);
    },
    invoiceGetByReference(variables: InvoiceGetByReferenceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetByReferenceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetByReferenceQuery>(InvoiceGetByReferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetByReference', 'query', variables);
    },
    invoiceGetOneByRegistrationId(variables: InvoiceGetOneByRegistrationIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetOneByRegistrationIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetOneByRegistrationIdQuery>(InvoiceGetOneByRegistrationIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetOneByRegistrationId', 'query', variables);
    },
    invoiceGetOneByProductId(variables: InvoiceGetOneByProductIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetOneByProductIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetOneByProductIdQuery>(InvoiceGetOneByProductIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetOneByProductId', 'query', variables);
    },
    invoiceGetOneByVariableSymbolForUser(variables: InvoiceGetOneByVariableSymbolForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetOneByVariableSymbolForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetOneByVariableSymbolForUserQuery>(InvoiceGetOneByVariableSymbolForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetOneByVariableSymbolForUser', 'query', variables);
    },
    invoiceGetOneByRegistrationIdForUser(variables: InvoiceGetOneByRegistrationIdForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetOneByRegistrationIdForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetOneByRegistrationIdForUserQuery>(InvoiceGetOneByRegistrationIdForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetOneByRegistrationIdForUser', 'query', variables);
    },
    invoiceGetMany(variables?: InvoiceGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetManyQuery>(InvoiceGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetMany', 'query', variables);
    },
    invoiceGetManyUnpaidBetweenDates(variables: InvoiceGetManyUnpaidBetweenDatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoiceGetManyUnpaidBetweenDatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoiceGetManyUnpaidBetweenDatesQuery>(InvoiceGetManyUnpaidBetweenDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoiceGetManyUnpaidBetweenDates', 'query', variables);
    },
    invoicesGetPathsForPaid(variables: InvoicesGetPathsForPaidQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InvoicesGetPathsForPaidQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InvoicesGetPathsForPaidQuery>(InvoicesGetPathsForPaidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'invoicesGetPathsForPaid', 'query', variables);
    },
    allUserInvoices(variables: AllUserInvoicesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AllUserInvoicesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AllUserInvoicesQuery>(AllUserInvoicesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'allUserInvoices', 'query', variables);
    },
    paidOrdersSummaryLast30Days(variables?: PaidOrdersSummaryLast30DaysQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaidOrdersSummaryLast30DaysQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaidOrdersSummaryLast30DaysQuery>(PaidOrdersSummaryLast30DaysDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paidOrdersSummaryLast30Days', 'query', variables);
    },
    paidOrdersSummaryLast30DaysCount(variables?: PaidOrdersSummaryLast30DaysCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaidOrdersSummaryLast30DaysCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaidOrdersSummaryLast30DaysCountQuery>(PaidOrdersSummaryLast30DaysCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paidOrdersSummaryLast30DaysCount', 'query', variables);
    },
    noteInsertOne(variables: NoteInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NoteInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NoteInsertOneMutation>(NoteInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'noteInsertOne', 'mutation', variables);
    },
    noteUpdateOne(variables: NoteUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NoteUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NoteUpdateOneMutation>(NoteUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'noteUpdateOne', 'mutation', variables);
    },
    noteDeleteOne(variables: NoteDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NoteDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NoteDeleteOneMutation>(NoteDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'noteDeleteOne', 'mutation', variables);
    },
    noteGetById(variables: NoteGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NoteGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NoteGetByIdQuery>(NoteGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'noteGetById', 'query', variables);
    },
    notificationInsertOne(variables: NotificationInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationInsertOneMutation>(NotificationInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notificationInsertOne', 'mutation', variables);
    },
    notificationInsertMany(variables: NotificationInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationInsertManyMutation>(NotificationInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notificationInsertMany', 'mutation', variables);
    },
    notificationGetMany(variables: NotificationGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NotificationGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NotificationGetManyQuery>(NotificationGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'notificationGetMany', 'query', variables);
    },
    officeActionInsertOne(variables: OfficeActionInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionInsertOneMutation>(OfficeActionInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionInsertOne', 'mutation', variables);
    },
    officeActionUpdateOne(variables: OfficeActionUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionUpdateOneMutation>(OfficeActionUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionUpdateOne', 'mutation', variables);
    },
    officeActionGetById(variables: OfficeActionGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionGetByIdQuery>(OfficeActionGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionGetById', 'query', variables);
    },
    officeActionGetMany(variables?: OfficeActionGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionGetManyQuery>(OfficeActionGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionGetMany', 'query', variables);
    },
    officeActionCount(variables?: OfficeActionCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionCountQuery>(OfficeActionCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionCount', 'query', variables);
    },
    officeActionGetManyForUser(variables?: OfficeActionGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionGetManyForUserQuery>(OfficeActionGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionGetManyForUser', 'query', variables);
    },
    officeActionIssueUpdateOne(variables: OfficeActionIssueUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionIssueUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionIssueUpdateOneMutation>(OfficeActionIssueUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionIssueUpdateOne', 'mutation', variables);
    },
    officeActionIssueDeleteMany(variables: OfficeActionIssueDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionIssueDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionIssueDeleteManyMutation>(OfficeActionIssueDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionIssueDeleteMany', 'mutation', variables);
    },
    officeActionIssueInsertMany(variables: OfficeActionIssueInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionIssueInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionIssueInsertManyMutation>(OfficeActionIssueInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionIssueInsertMany', 'mutation', variables);
    },
    officeActionSimilarTrademarkMapInsertMany(variables: OfficeActionSimilarTrademarkMapInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionSimilarTrademarkMapInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionSimilarTrademarkMapInsertManyMutation>(OfficeActionSimilarTrademarkMapInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionSimilarTrademarkMapInsertMany', 'mutation', variables);
    },
    officeActionSimilarTrademarkMapDeleteMany(variables: OfficeActionSimilarTrademarkMapDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionSimilarTrademarkMapDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionSimilarTrademarkMapDeleteManyMutation>(OfficeActionSimilarTrademarkMapDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionSimilarTrademarkMapDeleteMany', 'mutation', variables);
    },
    officeActionSolutionDeleteMany(variables: OfficeActionSolutionDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionSolutionDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionSolutionDeleteManyMutation>(OfficeActionSolutionDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionSolutionDeleteMany', 'mutation', variables);
    },
    officeActionSolutionInsertMany(variables: OfficeActionSolutionInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionSolutionInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionSolutionInsertManyMutation>(OfficeActionSolutionInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionSolutionInsertMany', 'mutation', variables);
    },
    officeActionSolutionUpdateOne(variables: OfficeActionSolutionUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionSolutionUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionSolutionUpdateOneMutation>(OfficeActionSolutionUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionSolutionUpdateOne', 'mutation', variables);
    },
    officeActionTrackingInsertOne(variables: OfficeActionTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionTrackingInsertOneMutation>(OfficeActionTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionTrackingInsertOne', 'mutation', variables);
    },
    officeActionTrackingDeleteOne(variables: OfficeActionTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionTrackingDeleteOneMutation>(OfficeActionTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionTrackingDeleteOne', 'mutation', variables);
    },
    officeActionTrackingGetMany(variables?: OfficeActionTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionTrackingGetManyQuery>(OfficeActionTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionTrackingGetMany', 'query', variables);
    },
    officeActionTrackingWithStatusGetMany(variables?: OfficeActionTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OfficeActionTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OfficeActionTrackingWithStatusGetManyQuery>(OfficeActionTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'officeActionTrackingWithStatusGetMany', 'query', variables);
    },
    orderInsertOne(variables: OrderInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderInsertOneMutation>(OrderInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderInsertOne', 'mutation', variables);
    },
    orderUpdateOne(variables: OrderUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderUpdateOneMutation>(OrderUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderUpdateOne', 'mutation', variables);
    },
    orderGetMany(variables?: OrderGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderGetManyQuery>(OrderGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderGetMany', 'query', variables);
    },
    orderTrackingInsertOne(variables: OrderTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderTrackingInsertOneMutation>(OrderTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderTrackingInsertOne', 'mutation', variables);
    },
    orderTrackingStatusGetMany(variables?: OrderTrackingStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderTrackingStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderTrackingStatusGetManyQuery>(OrderTrackingStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderTrackingStatusGetMany', 'query', variables);
    },
    unassignedOrders(variables?: UnassignedOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnassignedOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnassignedOrdersQuery>(UnassignedOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unassignedOrders', 'query', variables);
    },
    poaInsertOne(variables: PoaInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PoaInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoaInsertOneMutation>(PoaInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'poaInsertOne', 'mutation', variables);
    },
    poaUpdateOne(variables: PoaUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PoaUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoaUpdateOneMutation>(PoaUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'poaUpdateOne', 'mutation', variables);
    },
    poaDeleteOne(variables: PoaDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PoaDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoaDeleteOneMutation>(PoaDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'poaDeleteOne', 'mutation', variables);
    },
    poaGetById(variables: PoaGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PoaGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoaGetByIdQuery>(PoaGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'poaGetById', 'query', variables);
    },
    poaGetMany(variables: PoaGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PoaGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PoaGetManyQuery>(PoaGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'poaGetMany', 'query', variables);
    },
    priceInsertOne(variables: PriceInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceInsertOneMutation>(PriceInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceInsertOne', 'mutation', variables);
    },
    priceUpdateOne(variables: PriceUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceUpdateOneMutation>(PriceUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceUpdateOne', 'mutation', variables);
    },
    priceUpdateMany(variables: PriceUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceUpdateManyMutation>(PriceUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceUpdateMany', 'mutation', variables);
    },
    priceRuleInsertOne(variables: PriceRuleInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceRuleInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceRuleInsertOneMutation>(PriceRuleInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceRuleInsertOne', 'mutation', variables);
    },
    priceRuleInsertMany(variables: PriceRuleInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceRuleInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceRuleInsertManyMutation>(PriceRuleInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceRuleInsertMany', 'mutation', variables);
    },
    priceRuleUpdateOne(variables: PriceRuleUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PriceRuleUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PriceRuleUpdateOneMutation>(PriceRuleUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'priceRuleUpdateOne', 'mutation', variables);
    },
    productUpdateOne(variables: ProductUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductUpdateOneMutation>(ProductUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productUpdateOne', 'mutation', variables);
    },
    productGetById(variables: ProductGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductGetByIdQuery>(ProductGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productGetById', 'query', variables);
    },
    productBundleInsertOne(variables: ProductBundleInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductBundleInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBundleInsertOneMutation>(ProductBundleInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productBundleInsertOne', 'mutation', variables);
    },
    productBundleUpdateOne(variables: ProductBundleUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductBundleUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBundleUpdateOneMutation>(ProductBundleUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productBundleUpdateOne', 'mutation', variables);
    },
    productBundleDeleteOne(variables: ProductBundleDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductBundleDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBundleDeleteOneMutation>(ProductBundleDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productBundleDeleteOne', 'mutation', variables);
    },
    productBundleGetMany(variables?: ProductBundleGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductBundleGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBundleGetManyQuery>(ProductBundleGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productBundleGetMany', 'query', variables);
    },
    productBundleGetAll(variables?: ProductBundleGetAllQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductBundleGetAllQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductBundleGetAllQuery>(ProductBundleGetAllDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productBundleGetAll', 'query', variables);
    },
    productEventInsertOne(variables: ProductEventInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductEventInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductEventInsertOneMutation>(ProductEventInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productEventInsertOne', 'mutation', variables);
    },
    productEventGetMany(variables: ProductEventGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductEventGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductEventGetManyQuery>(ProductEventGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productEventGetMany', 'query', variables);
    },
    productV2InsertOne(variables: ProductV2InsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductV2InsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductV2InsertOneMutation>(ProductV2InsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productV2InsertOne', 'mutation', variables);
    },
    productV2InsertMany(variables: ProductV2InsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductV2InsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductV2InsertManyMutation>(ProductV2InsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productV2InsertMany', 'mutation', variables);
    },
    productV2UpdateOne(variables: ProductV2UpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductV2UpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductV2UpdateOneMutation>(ProductV2UpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productV2UpdateOne', 'mutation', variables);
    },
    productV2GetMany(variables?: ProductV2GetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductV2GetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductV2GetManyQuery>(ProductV2GetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productV2GetMany', 'query', variables);
    },
    quoteInsertOne(variables: QuoteInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteInsertOneMutation>(QuoteInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteInsertOne', 'mutation', variables);
    },
    quoteReplaceActiveInGroup(variables: QuoteReplaceActiveInGroupMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteReplaceActiveInGroupMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteReplaceActiveInGroupMutation>(QuoteReplaceActiveInGroupDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteReplaceActiveInGroup', 'mutation', variables);
    },
    quoteUpdateOne(variables: QuoteUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteUpdateOneMutation>(QuoteUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteUpdateOne', 'mutation', variables);
    },
    quoteUpdateMany(variables: QuoteUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteUpdateManyMutation>(QuoteUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteUpdateMany', 'mutation', variables);
    },
    quoteGetMany(variables?: QuoteGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteGetManyQuery>(QuoteGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteGetMany', 'query', variables);
    },
    quoteHubGetMany(variables?: QuoteHubGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<QuoteHubGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<QuoteHubGetManyQuery>(QuoteHubGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'quoteHubGetMany', 'query', variables);
    },
    refundRequestInsertOne(variables: RefundRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestInsertOneMutation>(RefundRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestInsertOne', 'mutation', variables);
    },
    refundRequestUpdateOne(variables: RefundRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestUpdateOneMutation>(RefundRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestUpdateOne', 'mutation', variables);
    },
    refundRequestGetById(variables: RefundRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestGetByIdQuery>(RefundRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestGetById', 'query', variables);
    },
    refundRequestInvoiceInsertMany(variables: RefundRequestInvoiceInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestInvoiceInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestInvoiceInsertManyMutation>(RefundRequestInvoiceInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestInvoiceInsertMany', 'mutation', variables);
    },
    refundRequestInvoiceDeleteMany(variables: RefundRequestInvoiceDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestInvoiceDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestInvoiceDeleteManyMutation>(RefundRequestInvoiceDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestInvoiceDeleteMany', 'mutation', variables);
    },
    refundRequestTrackingInsertOne(variables: RefundRequestTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestTrackingInsertOneMutation>(RefundRequestTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestTrackingInsertOne', 'mutation', variables);
    },
    refundRequestTrackingDeleteOne(variables: RefundRequestTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestTrackingDeleteOneMutation>(RefundRequestTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestTrackingDeleteOne', 'mutation', variables);
    },
    refundRequestTrackingGetMany(variables?: RefundRequestTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestTrackingGetManyQuery>(RefundRequestTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestTrackingGetMany', 'query', variables);
    },
    refundRequestTrackingWithStatusGetMany(variables?: RefundRequestTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefundRequestTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefundRequestTrackingWithStatusGetManyQuery>(RefundRequestTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refundRequestTrackingWithStatusGetMany', 'query', variables);
    },
    registrationRequestInsertOne(variables: RegistrationRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestInsertOneMutation>(RegistrationRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestInsertOne', 'mutation', variables);
    },
    registrationRequestUpdateOne(variables: RegistrationRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestUpdateOneMutation>(RegistrationRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestUpdateOne', 'mutation', variables);
    },
    registrationRequestUpdateMany(variables: RegistrationRequestUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestUpdateManyMutation>(RegistrationRequestUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestUpdateMany', 'mutation', variables);
    },
    registrationRequestDeleteOne(variables: RegistrationRequestDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestDeleteOneMutation>(RegistrationRequestDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestDeleteOne', 'mutation', variables);
    },
    registrationRequestDeleteMany(variables: RegistrationRequestDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestDeleteManyMutation>(RegistrationRequestDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestDeleteMany', 'mutation', variables);
    },
    registrationRequestGetById(variables: RegistrationRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetByIdQuery>(RegistrationRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetById', 'query', variables);
    },
    registrationRequestGetOneUser(variables: RegistrationRequestGetOneUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetOneUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetOneUserQuery>(RegistrationRequestGetOneUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetOneUser', 'query', variables);
    },
    registrationRequestGetOneForDrafting(variables: RegistrationRequestGetOneForDraftingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetOneForDraftingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetOneForDraftingQuery>(RegistrationRequestGetOneForDraftingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetOneForDrafting', 'query', variables);
    },
    registrationRequestUser(variables: RegistrationRequestUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestUserQuery>(RegistrationRequestUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestUser', 'query', variables);
    },
    registrationRequestGetOneForReportViolation(variables: RegistrationRequestGetOneForReportViolationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetOneForReportViolationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetOneForReportViolationQuery>(RegistrationRequestGetOneForReportViolationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetOneForReportViolation', 'query', variables);
    },
    registrationRequestGetMany(variables?: RegistrationRequestGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyQuery>(RegistrationRequestGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetMany', 'query', variables);
    },
    registrationRequestGetManyUserAggregate(variables?: RegistrationRequestGetManyUserAggregateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyUserAggregateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyUserAggregateQuery>(RegistrationRequestGetManyUserAggregateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyUserAggregate', 'query', variables);
    },
    registrationRequestGetManyLastStatusUpdate(variables: RegistrationRequestGetManyLastStatusUpdateQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyLastStatusUpdateQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyLastStatusUpdateQuery>(RegistrationRequestGetManyLastStatusUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyLastStatusUpdate', 'query', variables);
    },
    registrationRequestGetManyCountries(variables?: RegistrationRequestGetManyCountriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyCountriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyCountriesQuery>(RegistrationRequestGetManyCountriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyCountries', 'query', variables);
    },
    registrationRequestCount(variables?: RegistrationRequestCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestCountQuery>(RegistrationRequestCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestCount', 'query', variables);
    },
    registrationRequestCountByUser(variables?: RegistrationRequestCountByUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestCountByUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestCountByUserQuery>(RegistrationRequestCountByUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestCountByUser', 'query', variables);
    },
    registrationRequestsVerifiedWithoutResultView(variables: RegistrationRequestsVerifiedWithoutResultViewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestsVerifiedWithoutResultViewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestsVerifiedWithoutResultViewQuery>(RegistrationRequestsVerifiedWithoutResultViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestsVerifiedWithoutResultView', 'query', variables);
    },
    approvedRegistrationRequestsWithResultView(variables: ApprovedRegistrationRequestsWithResultViewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ApprovedRegistrationRequestsWithResultViewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ApprovedRegistrationRequestsWithResultViewQuery>(ApprovedRegistrationRequestsWithResultViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'approvedRegistrationRequestsWithResultView', 'query', variables);
    },
    dismissedRegistrationRequestsWithResultView(variables: DismissedRegistrationRequestsWithResultViewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DismissedRegistrationRequestsWithResultViewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DismissedRegistrationRequestsWithResultViewQuery>(DismissedRegistrationRequestsWithResultViewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'dismissedRegistrationRequestsWithResultView', 'query', variables);
    },
    getRegistrationRequestsWithOrderCreated(variables: GetRegistrationRequestsWithOrderCreatedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRegistrationRequestsWithOrderCreatedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRegistrationRequestsWithOrderCreatedQuery>(GetRegistrationRequestsWithOrderCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRegistrationRequestsWithOrderCreated', 'query', variables);
    },
    getRegistrationRequestsStartedWithoutOrderCreated(variables: GetRegistrationRequestsStartedWithoutOrderCreatedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRegistrationRequestsStartedWithoutOrderCreatedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRegistrationRequestsStartedWithoutOrderCreatedQuery>(GetRegistrationRequestsStartedWithoutOrderCreatedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getRegistrationRequestsStartedWithoutOrderCreated', 'query', variables);
    },
    contactsRegistrationRequestTracking(variables: ContactsRegistrationRequestTrackingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactsRegistrationRequestTrackingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactsRegistrationRequestTrackingQuery>(ContactsRegistrationRequestTrackingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactsRegistrationRequestTracking', 'query', variables);
    },
    registrationRequestGetManyForUser(variables?: RegistrationRequestGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyForUserQuery>(RegistrationRequestGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyForUser', 'query', variables);
    },
    userUnseenVerificationCount(variables: UserUnseenVerificationCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserUnseenVerificationCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserUnseenVerificationCountQuery>(UserUnseenVerificationCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userUnseenVerificationCount', 'query', variables);
    },
    registrationRequestGetManyForUserTrademarks(variables?: RegistrationRequestGetManyForUserTrademarksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyForUserTrademarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyForUserTrademarksQuery>(RegistrationRequestGetManyForUserTrademarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyForUserTrademarks', 'query', variables);
    },
    registrationRequestGetManyForUserDrafts(variables?: RegistrationRequestGetManyForUserDraftsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyForUserDraftsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyForUserDraftsQuery>(RegistrationRequestGetManyForUserDraftsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyForUserDrafts', 'query', variables);
    },
    registrationRequestGetManyForUserOrders(variables?: RegistrationRequestGetManyForUserOrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyForUserOrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyForUserOrdersQuery>(RegistrationRequestGetManyForUserOrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyForUserOrders', 'query', variables);
    },
    verificationSearch(variables: VerificationSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationSearchQuery>(VerificationSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationSearch', 'query', variables);
    },
    recentApplicationsSentToClient(variables: RecentApplicationsSentToClientQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecentApplicationsSentToClientQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecentApplicationsSentToClientQuery>(RecentApplicationsSentToClientDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'recentApplicationsSentToClient', 'query', variables);
    },
    registrationRequestRecentlyDismissed(variables?: RegistrationRequestRecentlyDismissedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestRecentlyDismissedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestRecentlyDismissedQuery>(RegistrationRequestRecentlyDismissedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestRecentlyDismissed', 'query', variables);
    },
    registrationRequestRecentlyDismissedCount(variables?: RegistrationRequestRecentlyDismissedCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestRecentlyDismissedCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestRecentlyDismissedCountQuery>(RegistrationRequestRecentlyDismissedCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestRecentlyDismissedCount', 'query', variables);
    },
    registrationRequestGetManyForUserDashboard(variables?: RegistrationRequestGetManyForUserDashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestGetManyForUserDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestGetManyForUserDashboardQuery>(RegistrationRequestGetManyForUserDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestGetManyForUserDashboard', 'query', variables);
    },
    registrationRequestTrackingInsertOne(variables: RegistrationRequestTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingInsertOneMutation>(RegistrationRequestTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingInsertOne', 'mutation', variables);
    },
    registrationRequestTrackingInsertMany(variables: RegistrationRequestTrackingInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingInsertManyMutation>(RegistrationRequestTrackingInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingInsertMany', 'mutation', variables);
    },
    registrationRequestTrackingDeleteOne(variables: RegistrationRequestTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingDeleteOneMutation>(RegistrationRequestTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingDeleteOne', 'mutation', variables);
    },
    registrationRequestTrackingDeleteMany(variables: RegistrationRequestTrackingDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingDeleteManyMutation>(RegistrationRequestTrackingDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingDeleteMany', 'mutation', variables);
    },
    registrationRequestTrackingGetMany(variables?: RegistrationRequestTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingGetManyQuery>(RegistrationRequestTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingGetMany', 'query', variables);
    },
    registrationRequestTrackingWithStatusGetMany(variables?: RegistrationRequestTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationRequestTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationRequestTrackingWithStatusGetManyQuery>(RegistrationRequestTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'registrationRequestTrackingWithStatusGetMany', 'query', variables);
    },
    reminderInsertOne(variables: ReminderInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReminderInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReminderInsertOneMutation>(ReminderInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reminderInsertOne', 'mutation', variables);
    },
    reminderUpdateOne(variables: ReminderUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReminderUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReminderUpdateOneMutation>(ReminderUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reminderUpdateOne', 'mutation', variables);
    },
    reminderGetById(variables: ReminderGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReminderGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReminderGetByIdQuery>(ReminderGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reminderGetById', 'query', variables);
    },
    reminderGetMany(variables: ReminderGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReminderGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReminderGetManyQuery>(ReminderGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reminderGetMany', 'query', variables);
    },
    reminderCount(variables?: ReminderCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ReminderCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ReminderCountQuery>(ReminderCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'reminderCount', 'query', variables);
    },
    serviceInsertOne(variables: ServiceInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceInsertOneMutation>(ServiceInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceInsertOne', 'mutation', variables);
    },
    serviceInsertMany(variables: ServiceInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceInsertManyMutation>(ServiceInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceInsertMany', 'mutation', variables);
    },
    serviceUpdateOne(variables: ServiceUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceUpdateOneMutation>(ServiceUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceUpdateOne', 'mutation', variables);
    },
    serviceGetById(variables: ServiceGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceGetByIdQuery>(ServiceGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceGetById', 'query', variables);
    },
    serviceGetMany(variables: ServiceGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceGetManyQuery>(ServiceGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceGetMany', 'query', variables);
    },
    serviceRequestInsertOne(variables: ServiceRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestInsertOneMutation>(ServiceRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestInsertOne', 'mutation', variables);
    },
    serviceRequestUpdateOne(variables: ServiceRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestUpdateOneMutation>(ServiceRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestUpdateOne', 'mutation', variables);
    },
    serviceRequestDeleteMany(variables: ServiceRequestDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestDeleteManyMutation>(ServiceRequestDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestDeleteMany', 'mutation', variables);
    },
    serviceRequestGetById(variables: ServiceRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestGetByIdQuery>(ServiceRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestGetById', 'query', variables);
    },
    serviceRequestGetMany(variables?: ServiceRequestGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestGetManyQuery>(ServiceRequestGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestGetMany', 'query', variables);
    },
    serviceRequestGetOneForUser(variables: ServiceRequestGetOneForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestGetOneForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestGetOneForUserQuery>(ServiceRequestGetOneForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestGetOneForUser', 'query', variables);
    },
    serviceRequestGetManyForUser(variables?: ServiceRequestGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestGetManyForUserQuery>(ServiceRequestGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestGetManyForUser', 'query', variables);
    },
    serviceRequestCount(variables?: ServiceRequestCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestCountQuery>(ServiceRequestCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestCount', 'query', variables);
    },
    serviceRequestGetManyWithTrademarks(variables?: ServiceRequestGetManyWithTrademarksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestGetManyWithTrademarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestGetManyWithTrademarksQuery>(ServiceRequestGetManyWithTrademarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestGetManyWithTrademarks', 'query', variables);
    },
    serviceRequestTrackingInsertOne(variables: ServiceRequestTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestTrackingInsertOneMutation>(ServiceRequestTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestTrackingInsertOne', 'mutation', variables);
    },
    serviceRequestTrackingInsertMany(variables: ServiceRequestTrackingInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestTrackingInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestTrackingInsertManyMutation>(ServiceRequestTrackingInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestTrackingInsertMany', 'mutation', variables);
    },
    serviceRequestTrackingGetMany(variables?: ServiceRequestTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceRequestTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceRequestTrackingGetManyQuery>(ServiceRequestTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceRequestTrackingGetMany', 'query', variables);
    },
    serviceTrackingInsertOne(variables: ServiceTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceTrackingInsertOneMutation>(ServiceTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceTrackingInsertOne', 'mutation', variables);
    },
    serviceTrackingDeleteOne(variables: ServiceTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceTrackingDeleteOneMutation>(ServiceTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceTrackingDeleteOne', 'mutation', variables);
    },
    serviceTrackingGetMany(variables: ServiceTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceTrackingGetManyQuery>(ServiceTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceTrackingGetMany', 'query', variables);
    },
    serviceTrackingWithStatusGetMany(variables?: ServiceTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ServiceTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ServiceTrackingWithStatusGetManyQuery>(ServiceTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'serviceTrackingWithStatusGetMany', 'query', variables);
    },
    specimenInsertOne(variables: SpecimenInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecimenInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecimenInsertOneMutation>(SpecimenInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specimenInsertOne', 'mutation', variables);
    },
    specimenUpdateOne(variables: SpecimenUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecimenUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecimenUpdateOneMutation>(SpecimenUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specimenUpdateOne', 'mutation', variables);
    },
    specimenDeleteOne(variables: SpecimenDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecimenDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecimenDeleteOneMutation>(SpecimenDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specimenDeleteOne', 'mutation', variables);
    },
    specimenGetById(variables: SpecimenGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecimenGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecimenGetByIdQuery>(SpecimenGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specimenGetById', 'query', variables);
    },
    specimenGetMany(variables: SpecimenGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SpecimenGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SpecimenGetManyQuery>(SpecimenGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'specimenGetMany', 'query', variables);
    },
    statisticInsertOne(variables: StatisticInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StatisticInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatisticInsertOneMutation>(StatisticInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'statisticInsertOne', 'mutation', variables);
    },
    statisticGetManyDistinct(variables?: StatisticGetManyDistinctQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StatisticGetManyDistinctQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatisticGetManyDistinctQuery>(StatisticGetManyDistinctDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'statisticGetManyDistinct', 'query', variables);
    },
    supportTicketInsertOne(variables: SupportTicketInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SupportTicketInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupportTicketInsertOneMutation>(SupportTicketInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'supportTicketInsertOne', 'mutation', variables);
    },
    supportTicketUpdateOne(variables: SupportTicketUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SupportTicketUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupportTicketUpdateOneMutation>(SupportTicketUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'supportTicketUpdateOne', 'mutation', variables);
    },
    supportTicketById(variables: SupportTicketByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SupportTicketByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupportTicketByIdQuery>(SupportTicketByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'supportTicketById', 'query', variables);
    },
    supportTicketGetMany(variables?: SupportTicketGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SupportTicketGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SupportTicketGetManyQuery>(SupportTicketGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'supportTicketGetMany', 'query', variables);
    },
    taskInsertOne(variables: TaskInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TaskInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TaskInsertOneMutation>(TaskInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taskInsertOne', 'mutation', variables);
    },
    taskUpdateOne(variables: TaskUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TaskUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TaskUpdateOneMutation>(TaskUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taskUpdateOne', 'mutation', variables);
    },
    taskGetById(variables: TaskGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TaskGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TaskGetByIdQuery>(TaskGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taskGetById', 'query', variables);
    },
    taskCount(variables?: TaskCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TaskCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TaskCountQuery>(TaskCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'taskCount', 'query', variables);
    },
    threadCommentInsertOne(variables: ThreadCommentInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThreadCommentInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThreadCommentInsertOneMutation>(ThreadCommentInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'threadCommentInsertOne', 'mutation', variables);
    },
    threadCommentUpdateOne(variables: ThreadCommentUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThreadCommentUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThreadCommentUpdateOneMutation>(ThreadCommentUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'threadCommentUpdateOne', 'mutation', variables);
    },
    threadCommentGetMany(variables?: ThreadCommentGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThreadCommentGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThreadCommentGetManyQuery>(ThreadCommentGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'threadCommentGetMany', 'query', variables);
    },
    threadCommentGetById(variables: ThreadCommentGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ThreadCommentGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ThreadCommentGetByIdQuery>(ThreadCommentGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'threadCommentGetById', 'query', variables);
    },
    trademarkInsertMany(variables: TrademarkInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkInsertManyMutation>(TrademarkInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkInsertMany', 'mutation', variables);
    },
    trademarkInsertOne(variables: TrademarkInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkInsertOneMutation>(TrademarkInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkInsertOne', 'mutation', variables);
    },
    trademarkUpdateOne(variables: TrademarkUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkUpdateOneMutation>(TrademarkUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkUpdateOne', 'mutation', variables);
    },
    trademarkUpdateOneForUser(variables: TrademarkUpdateOneForUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkUpdateOneForUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkUpdateOneForUserMutation>(TrademarkUpdateOneForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkUpdateOneForUser', 'mutation', variables);
    },
    trademarkUpdateMany(variables: TrademarkUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkUpdateManyMutation>(TrademarkUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkUpdateMany', 'mutation', variables);
    },
    trademarkDeleteMany(variables: TrademarkDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkDeleteManyMutation>(TrademarkDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkDeleteMany', 'mutation', variables);
    },
    trademarkGetById(variables: TrademarkGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetByIdQuery>(TrademarkGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetById', 'query', variables);
    },
    trademarkGetByIdForUser(variables: TrademarkGetByIdForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetByIdForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetByIdForUserQuery>(TrademarkGetByIdForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetByIdForUser', 'query', variables);
    },
    trademarkGetMany(variables?: TrademarkGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyQuery>(TrademarkGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetMany', 'query', variables);
    },
    trademarkGetManyOwnProperties(variables?: TrademarkGetManyOwnPropertiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyOwnPropertiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyOwnPropertiesQuery>(TrademarkGetManyOwnPropertiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetManyOwnProperties', 'query', variables);
    },
    trademarkCount(variables?: TrademarkCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkCountQuery>(TrademarkCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkCount', 'query', variables);
    },
    trademarkGetManyForUser(variables?: TrademarkGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyForUserQuery>(TrademarkGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetManyForUser', 'query', variables);
    },
    trademarkSearch(variables: TrademarkSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkSearchQuery>(TrademarkSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkSearch', 'query', variables);
    },
    trademarkPortfolioSearch(variables: TrademarkPortfolioSearchQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkPortfolioSearchQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkPortfolioSearchQuery>(TrademarkPortfolioSearchDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkPortfolioSearch', 'query', variables);
    },
    trademarkPortfolioSearchCount(variables: TrademarkPortfolioSearchCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkPortfolioSearchCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkPortfolioSearchCountQuery>(TrademarkPortfolioSearchCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkPortfolioSearchCount', 'query', variables);
    },
    trademarkGetManyWithRepresentative(variables?: TrademarkGetManyWithRepresentativeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyWithRepresentativeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyWithRepresentativeQuery>(TrademarkGetManyWithRepresentativeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetManyWithRepresentative', 'query', variables);
    },
    trademarkGetPartnersFilings(variables?: TrademarkGetPartnersFilingsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetPartnersFilingsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetPartnersFilingsQuery>(TrademarkGetPartnersFilingsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetPartnersFilings', 'query', variables);
    },
    trademarkGetManyIds(variables?: TrademarkGetManyIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyIdsQuery>(TrademarkGetManyIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetManyIds', 'query', variables);
    },
    trademarkGetManyForUserDashboard(variables?: TrademarkGetManyForUserDashboardQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkGetManyForUserDashboardQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkGetManyForUserDashboardQuery>(TrademarkGetManyForUserDashboardDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkGetManyForUserDashboard', 'query', variables);
    },
    trademarkClassInsertOne(variables: TrademarkClassInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassInsertOneMutation>(TrademarkClassInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassInsertOne', 'mutation', variables);
    },
    trademarkClassInsertMany(variables: TrademarkClassInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassInsertManyMutation>(TrademarkClassInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassInsertMany', 'mutation', variables);
    },
    trademarkClassUpdateOne(variables: TrademarkClassUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassUpdateOneMutation>(TrademarkClassUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassUpdateOne', 'mutation', variables);
    },
    trademarkClassUpdateMany(variables: TrademarkClassUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassUpdateManyMutation>(TrademarkClassUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassUpdateMany', 'mutation', variables);
    },
    trademarkClassDeleteOne(variables: TrademarkClassDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassDeleteOneMutation>(TrademarkClassDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassDeleteOne', 'mutation', variables);
    },
    trademarkClassDeleteMany(variables: TrademarkClassDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassDeleteManyMutation>(TrademarkClassDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassDeleteMany', 'mutation', variables);
    },
    trademarkClassGetById(variables: TrademarkClassGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassGetByIdQuery>(TrademarkClassGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassGetById', 'query', variables);
    },
    trademarkClassGetMany(variables: TrademarkClassGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkClassGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkClassGetManyQuery>(TrademarkClassGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkClassGetMany', 'query', variables);
    },
    trademarkIpoDataUpsertOne(variables: TrademarkIpoDataUpsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkIpoDataUpsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkIpoDataUpsertOneMutation>(TrademarkIpoDataUpsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkIpoDataUpsertOne', 'mutation', variables);
    },
    trademarkIpoDataGetMany(variables?: TrademarkIpoDataGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkIpoDataGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkIpoDataGetManyQuery>(TrademarkIpoDataGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkIpoDataGetMany', 'query', variables);
    },
    trademarkMonitoringResultInsertOne(variables: TrademarkMonitoringResultInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultInsertOneMutation>(TrademarkMonitoringResultInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultInsertOne', 'mutation', variables);
    },
    trademarkMonitoringResultUpdateOne(variables: TrademarkMonitoringResultUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultUpdateOneMutation>(TrademarkMonitoringResultUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultUpdateOne', 'mutation', variables);
    },
    trademarkMonitoringResultGetById(variables: TrademarkMonitoringResultGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultGetByIdQuery>(TrademarkMonitoringResultGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultGetById', 'query', variables);
    },
    trademarkMonitoringResultGetMany(variables?: TrademarkMonitoringResultGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultGetManyQuery>(TrademarkMonitoringResultGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultGetMany', 'query', variables);
    },
    trademarkMonitoringResultGetManyForUser(variables?: TrademarkMonitoringResultGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultGetManyForUserQuery>(TrademarkMonitoringResultGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultGetManyForUser', 'query', variables);
    },
    trademarkMonitoringResultGetUnseenCount(variables?: TrademarkMonitoringResultGetUnseenCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultGetUnseenCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultGetUnseenCountQuery>(TrademarkMonitoringResultGetUnseenCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultGetUnseenCount', 'query', variables);
    },
    trademarkMonitoringResultsForTrademark(variables: TrademarkMonitoringResultsForTrademarkQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkMonitoringResultsForTrademarkQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkMonitoringResultsForTrademarkQuery>(TrademarkMonitoringResultsForTrademarkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkMonitoringResultsForTrademark', 'query', variables);
    },
    trademarkRateLimitLogInsertOne(variables: TrademarkRateLimitLogInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRateLimitLogInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRateLimitLogInsertOneMutation>(TrademarkRateLimitLogInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRateLimitLogInsertOne', 'mutation', variables);
    },
    trademarkRateLimitLogSumRequestCount(variables?: TrademarkRateLimitLogSumRequestCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRateLimitLogSumRequestCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRateLimitLogSumRequestCountQuery>(TrademarkRateLimitLogSumRequestCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRateLimitLogSumRequestCount', 'query', variables);
    },
    trademarkRequestInsertOne(variables: TrademarkRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRequestInsertOneMutation>(TrademarkRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRequestInsertOne', 'mutation', variables);
    },
    trademarkRequestUpdateOne(variables: TrademarkRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRequestUpdateOneMutation>(TrademarkRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRequestUpdateOne', 'mutation', variables);
    },
    trademarkRequestGetById(variables: TrademarkRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRequestGetByIdQuery>(TrademarkRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRequestGetById', 'query', variables);
    },
    trademarkRequestGetMany(variables?: TrademarkRequestGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRequestGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRequestGetManyQuery>(TrademarkRequestGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRequestGetMany', 'query', variables);
    },
    trademarkRequestGetManyForUser(variables?: TrademarkRequestGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkRequestGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkRequestGetManyForUserQuery>(TrademarkRequestGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkRequestGetManyForUser', 'query', variables);
    },
    trademarkServiceRequestsInsertMany(variables: TrademarkServiceRequestsInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkServiceRequestsInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkServiceRequestsInsertManyMutation>(TrademarkServiceRequestsInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkServiceRequestsInsertMany', 'mutation', variables);
    },
    trademarkServiceRequestsDeleteMany(variables: TrademarkServiceRequestsDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkServiceRequestsDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkServiceRequestsDeleteManyMutation>(TrademarkServiceRequestsDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkServiceRequestsDeleteMany', 'mutation', variables);
    },
    trademarkServiceRequestsGetMany(variables?: TrademarkServiceRequestsGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkServiceRequestsGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkServiceRequestsGetManyQuery>(TrademarkServiceRequestsGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkServiceRequestsGetMany', 'query', variables);
    },
    trademarkSharedDocumentsInsertMany(variables: TrademarkSharedDocumentsInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkSharedDocumentsInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkSharedDocumentsInsertManyMutation>(TrademarkSharedDocumentsInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkSharedDocumentsInsertMany', 'mutation', variables);
    },
    trademarkSharedDocumentsDeleteOne(variables: TrademarkSharedDocumentsDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkSharedDocumentsDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkSharedDocumentsDeleteOneMutation>(TrademarkSharedDocumentsDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkSharedDocumentsDeleteOne', 'mutation', variables);
    },
    trademarkSharedDocumentsDeleteMany(variables: TrademarkSharedDocumentsDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkSharedDocumentsDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkSharedDocumentsDeleteManyMutation>(TrademarkSharedDocumentsDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkSharedDocumentsDeleteMany', 'mutation', variables);
    },
    trademarkSharedDocumentsGetMany(variables: TrademarkSharedDocumentsGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkSharedDocumentsGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkSharedDocumentsGetManyQuery>(TrademarkSharedDocumentsGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkSharedDocumentsGetMany', 'query', variables);
    },
    trademarkTrackingInsertOne(variables: TrademarkTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkTrackingInsertOneMutation>(TrademarkTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkTrackingInsertOne', 'mutation', variables);
    },
    trademarkTrackingDeleteOne(variables: TrademarkTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkTrackingDeleteOneMutation>(TrademarkTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkTrackingDeleteOne', 'mutation', variables);
    },
    trademarkTrackingDeleteMany(variables: TrademarkTrackingDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkTrackingDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkTrackingDeleteManyMutation>(TrademarkTrackingDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkTrackingDeleteMany', 'mutation', variables);
    },
    trademarkTrackingGetMany(variables?: TrademarkTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkTrackingGetManyQuery>(TrademarkTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkTrackingGetMany', 'query', variables);
    },
    trademarkTrackingWithStatusGetMany(variables?: TrademarkTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkTrackingWithStatusGetManyQuery>(TrademarkTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkTrackingWithStatusGetMany', 'query', variables);
    },
    trademarkWatchSubscriptionGetMany(variables?: TrademarkWatchSubscriptionGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkWatchSubscriptionGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkWatchSubscriptionGetManyQuery>(TrademarkWatchSubscriptionGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkWatchSubscriptionGetMany', 'query', variables);
    },
    trademarkWatchSubscriptionCount(variables?: TrademarkWatchSubscriptionCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkWatchSubscriptionCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkWatchSubscriptionCountQuery>(TrademarkWatchSubscriptionCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkWatchSubscriptionCount', 'query', variables);
    },
    trademarkWatchSubscriptionGetById(variables: TrademarkWatchSubscriptionGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarkWatchSubscriptionGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarkWatchSubscriptionGetByIdQuery>(TrademarkWatchSubscriptionGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarkWatchSubscriptionGetById', 'query', variables);
    },
    trademarks(variables?: TrademarksQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrademarksQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrademarksQuery>(TrademarksDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'trademarks', 'query', variables);
    },
    useInCommerceRequestInsertOne(variables: UseInCommerceRequestInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestInsertOneMutation>(UseInCommerceRequestInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestInsertOne', 'mutation', variables);
    },
    useInCommerceRequestUpdateOne(variables: UseInCommerceRequestUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestUpdateOneMutation>(UseInCommerceRequestUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestUpdateOne', 'mutation', variables);
    },
    useInCommerceRequestGetById(variables: UseInCommerceRequestGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestGetByIdQuery>(UseInCommerceRequestGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestGetById', 'query', variables);
    },
    useInCommerceRequestGetByIdForDrafting(variables: UseInCommerceRequestGetByIdForDraftingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestGetByIdForDraftingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestGetByIdForDraftingQuery>(UseInCommerceRequestGetByIdForDraftingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestGetByIdForDrafting', 'query', variables);
    },
    useInCommerceRequestGetMany(variables: UseInCommerceRequestGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestGetManyQuery>(UseInCommerceRequestGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestGetMany', 'query', variables);
    },
    useInCommerceRequestGetManyForDrafting(variables: UseInCommerceRequestGetManyForDraftingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestGetManyForDraftingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestGetManyForDraftingQuery>(UseInCommerceRequestGetManyForDraftingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestGetManyForDrafting', 'query', variables);
    },
    useInCommerceRequestCount(variables?: UseInCommerceRequestCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestCountQuery>(UseInCommerceRequestCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestCount', 'query', variables);
    },
    useInCommerceRequestTrackingInsertOne(variables: UseInCommerceRequestTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestTrackingInsertOneMutation>(UseInCommerceRequestTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestTrackingInsertOne', 'mutation', variables);
    },
    useInCommerceRequestTrackingInsertMany(variables: UseInCommerceRequestTrackingInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestTrackingInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestTrackingInsertManyMutation>(UseInCommerceRequestTrackingInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestTrackingInsertMany', 'mutation', variables);
    },
    useInCommerceRequestTrackingDeleteOne(variables: UseInCommerceRequestTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestTrackingDeleteOneMutation>(UseInCommerceRequestTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestTrackingDeleteOne', 'mutation', variables);
    },
    useInCommerceRequestTrackingGetMany(variables?: UseInCommerceRequestTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestTrackingGetManyQuery>(UseInCommerceRequestTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestTrackingGetMany', 'query', variables);
    },
    useInCommerceRequestTrackingWithStatusGetMany(variables?: UseInCommerceRequestTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UseInCommerceRequestTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UseInCommerceRequestTrackingWithStatusGetManyQuery>(UseInCommerceRequestTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'useInCommerceRequestTrackingWithStatusGetMany', 'query', variables);
    },
    userUpdateOne(variables: UserUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserUpdateOneMutation>(UserUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userUpdateOne', 'mutation', variables);
    },
    userUpdateSecret(variables: UserUpdateSecretMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserUpdateSecretMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserUpdateSecretMutation>(UserUpdateSecretDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userUpdateSecret', 'mutation', variables);
    },
    userInsertOne(variables: UserInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserInsertOneMutation>(UserInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userInsertOne', 'mutation', variables);
    },
    userGetById(variables: UserGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserGetByIdQuery>(UserGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userGetById', 'query', variables);
    },
    userForUserGetById(variables: UserForUserGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserForUserGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserForUserGetByIdQuery>(UserForUserGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userForUserGetById', 'query', variables);
    },
    userByRefreshToken(variables: UserByRefreshTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserByRefreshTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserByRefreshTokenQuery>(UserByRefreshTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userByRefreshToken', 'query', variables);
    },
    userWithPasswordHash(variables: UserWithPasswordHashQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserWithPasswordHashQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserWithPasswordHashQuery>(UserWithPasswordHashDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userWithPasswordHash', 'query', variables);
    },
    userSecret(variables: UserSecretQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserSecretQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserSecretQuery>(UserSecretDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userSecret', 'query', variables);
    },
    userByEmail(variables: UserByEmailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserByEmailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserByEmailQuery>(UserByEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userByEmail', 'query', variables);
    },
    userByEmailWithSecretFields(variables: UserByEmailWithSecretFieldsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserByEmailWithSecretFieldsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserByEmailWithSecretFieldsQuery>(UserByEmailWithSecretFieldsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userByEmailWithSecretFields', 'query', variables);
    },
    userBySecret(variables: UserBySecretQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserBySecretQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserBySecretQuery>(UserBySecretDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userBySecret', 'query', variables);
    },
    getUsers(variables?: GetUsersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUsersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUsersQuery>(GetUsersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getUsers', 'query', variables);
    },
    userGetMany(variables?: UserGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserGetManyQuery>(UserGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userGetMany', 'query', variables);
    },
    userAuthLogInsertOne(variables: UserAuthLogInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserAuthLogInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserAuthLogInsertOneMutation>(UserAuthLogInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userAuthLogInsertOne', 'mutation', variables);
    },
    userHistoryInsertOne(variables: UserHistoryInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserHistoryInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserHistoryInsertOneMutation>(UserHistoryInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userHistoryInsertOne', 'mutation', variables);
    },
    userHistoryGetMany(variables: UserHistoryGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserHistoryGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserHistoryGetManyQuery>(UserHistoryGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userHistoryGetMany', 'query', variables);
    },
    userPaymentMethodInsertOne(variables: UserPaymentMethodInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodInsertOneMutation>(UserPaymentMethodInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodInsertOne', 'mutation', variables);
    },
    userPaymentMethodUpdateOne(variables: UserPaymentMethodUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodUpdateOneMutation>(UserPaymentMethodUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodUpdateOne', 'mutation', variables);
    },
    userPaymentMethodUpdateMany(variables: UserPaymentMethodUpdateManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodUpdateManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodUpdateManyMutation>(UserPaymentMethodUpdateManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodUpdateMany', 'mutation', variables);
    },
    userPaymentMethodGetById(variables: UserPaymentMethodGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodGetByIdQuery>(UserPaymentMethodGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodGetById', 'query', variables);
    },
    userPaymentMethodGetMany(variables?: UserPaymentMethodGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodGetManyQuery>(UserPaymentMethodGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodGetMany', 'query', variables);
    },
    userPaymentMethodGetManyForUser(variables?: UserPaymentMethodGetManyForUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserPaymentMethodGetManyForUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserPaymentMethodGetManyForUserQuery>(UserPaymentMethodGetManyForUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userPaymentMethodGetManyForUser', 'query', variables);
    },
    userProfileUpdateOne(variables: UserProfileUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProfileUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileUpdateOneMutation>(UserProfileUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProfileUpdateOne', 'mutation', variables);
    },
    userProfileInsertOne(variables: UserProfileInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProfileInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileInsertOneMutation>(UserProfileInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProfileInsertOne', 'mutation', variables);
    },
    userProfileGetById(variables: UserProfileGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProfileGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileGetByIdQuery>(UserProfileGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProfileGetById', 'query', variables);
    },
    userProfileGetMany(variables?: UserProfileGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserProfileGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserProfileGetManyQuery>(UserProfileGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProfileGetMany', 'query', variables);
    },
    userTrackingInsertOne(variables: UserTrackingInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserTrackingInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserTrackingInsertOneMutation>(UserTrackingInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userTrackingInsertOne', 'mutation', variables);
    },
    userTrackingDeleteOne(variables: UserTrackingDeleteOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserTrackingDeleteOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserTrackingDeleteOneMutation>(UserTrackingDeleteOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userTrackingDeleteOne', 'mutation', variables);
    },
    userTrackingGetMany(variables?: UserTrackingGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserTrackingGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserTrackingGetManyQuery>(UserTrackingGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userTrackingGetMany', 'query', variables);
    },
    userTrackingWithStatusGetMany(variables?: UserTrackingWithStatusGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserTrackingWithStatusGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserTrackingWithStatusGetManyQuery>(UserTrackingWithStatusGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userTrackingWithStatusGetMany', 'query', variables);
    },
    verificationResultInsertOne(variables: VerificationResultInsertOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultInsertOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultInsertOneMutation>(VerificationResultInsertOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultInsertOne', 'mutation', variables);
    },
    verificationResultUpdateOne(variables: VerificationResultUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultUpdateOneMutation>(VerificationResultUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultUpdateOne', 'mutation', variables);
    },
    verificationResultGetById(variables: VerificationResultGetByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultGetByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultGetByIdQuery>(VerificationResultGetByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultGetById', 'query', variables);
    },
    verificationResultGetMany(variables: VerificationResultGetManyQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultGetManyQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultGetManyQuery>(VerificationResultGetManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultGetMany', 'query', variables);
    },
    verificationResultSimilarTrademarkMapInsertMany(variables: VerificationResultSimilarTrademarkMapInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultSimilarTrademarkMapInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultSimilarTrademarkMapInsertManyMutation>(VerificationResultSimilarTrademarkMapInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultSimilarTrademarkMapInsertMany', 'mutation', variables);
    },
    verificationResultSimilarTrademarkMapDeleteMany(variables: VerificationResultSimilarTrademarkMapDeleteManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultSimilarTrademarkMapDeleteManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultSimilarTrademarkMapDeleteManyMutation>(VerificationResultSimilarTrademarkMapDeleteManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultSimilarTrademarkMapDeleteMany', 'mutation', variables);
    },
    verificationResultSimilarTrademarkMapUpdateOne(variables: VerificationResultSimilarTrademarkMapUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerificationResultSimilarTrademarkMapUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerificationResultSimilarTrademarkMapUpdateOneMutation>(VerificationResultSimilarTrademarkMapUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'verificationResultSimilarTrademarkMapUpdateOne', 'mutation', variables);
    },
    websiteInsertMany(variables: WebsiteInsertManyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebsiteInsertManyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebsiteInsertManyMutation>(WebsiteInsertManyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'websiteInsertMany', 'mutation', variables);
    },
    websiteDeleteByIds(variables: WebsiteDeleteByIdsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebsiteDeleteByIdsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebsiteDeleteByIdsMutation>(WebsiteDeleteByIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'websiteDeleteByIds', 'mutation', variables);
    },
    websiteUpdateOne(variables: WebsiteUpdateOneMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WebsiteUpdateOneMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<WebsiteUpdateOneMutation>(WebsiteUpdateOneDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'websiteUpdateOne', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;